// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
import { frModuleTips } from './fr-extras.js';
export const fr = {
    login: {
        title: '[[TOK_0]] ConformitéOne',
        subtitle: 'Connectez-vous à votre compte',
        email: 'E-mail',
        password: 'Mot de passe',
        sign_in: 'Se connecter',
        signing_in: 'Connexion en cours...',
        mfa_code: 'Code MFA',
        mfa_placeholder: 'Entrez le code à 6 chiffres',
        mfa_instruction: "Entrez le code à 6 chiffres de votre application d'authentification.",
        verify: 'Vérifier',
        verifying: 'Vérification en cours...',
        forgot_password: 'Mot de passe oublié ?',
        account_locked: 'Le compte est verrouillé. Veuillez réessayer plus tard.',
        account_deactivated: 'Le compte a été désactivé. Contactez votre administrateur.',
        invalid_mfa: 'Code MFA invalide. Veuillez réessayer.',
        invalid_credentials: 'E-mail ou mot de passe invalide.',
        login_failed: 'Échec de la connexion',
        session_expired: 'Votre session a expiré. Veuillez recharger la page et réessayer.',
    },
    auth: {
        forgot_password: {
            title: 'Mot de passe oublié',
            subtitle: 'Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
            send: 'Envoyer le lien de réinitialisation',
            sending: 'Envoi en cours...',
            success: 'Si cette adresse e-mail existe, un lien de réinitialisation du mot de passe a été envoyé.',
            back_to_login: 'Retour à la connexion',
        },
        reset_password: {
            title: 'Réinitialiser le mot de passe',
            subtitle: 'Saisissez votre nouveau mot de passe ci-dessous.',
            new_password: 'Nouveau mot de passe',
            confirm_password: 'Confirmer le mot de passe',
            reset: 'Réinitialiser le mot de passe',
            resetting: 'Réinitialisation en cours...',
            success: 'Votre mot de passe a été réinitialisé avec succès.',
            go_to_login: 'Aller à la connexion',
            password_mismatch: 'Les mots de passe ne correspondent pas.',
            invalid_token: 'Jeton de réinitialisation invalide ou manquant. Veuillez demander un nouveau lien de réinitialisation du mot de passe.',
            requirements_title: 'Exigences relatives au mot de passe :',
            password_requirements: 'Le mot de passe doit répondre aux exigences suivantes :',
            rules: {
                min_length: 'Au moins 12 caractères',
                uppercase: 'Au moins une lettre majuscule',
                lowercase: 'Au moins une lettre minuscule',
                digit: 'Au moins un chiffre',
                special: 'Au moins un caractère spécial',
            },
        },
        verify_email: {
            title: "Vérification de l'adresse e-mail",
            verifying: 'Vérification de votre adresse e-mail en cours...',
            success: 'Votre adresse e-mail a été vérifiée avec succès.',
            invalid_token: 'Jeton de vérification invalide ou manquant.',
            failed: "La vérification de l'adresse e-mail a échoué. Le jeton est peut-être invalide ou expiré.",
            go_to_login: 'Aller à la connexion',
        },
        offline: {
            title: 'Vous êtes hors ligne',
            message: 'Il semble que vous ayez perdu votre connexion Internet. Veuillez vérifier votre réseau et réessayer.',
        },
    },
    intake: {
        title: "Demande d'exercice des droits",
        subtitle: "Soumettre une demande d'exercice des droits à notre organisation",
        fields: {
            full_name: 'Nom complet',
            email: 'Adresse e-mail',
            phone: 'Numéro de téléphone (facultatif)',
            request_type: 'Type de demande',
            description: 'Décrivez votre demande',
            preferred_language: 'Langue préférée',
            consent: 'Je consens au traitement de cette demande',
        },
        submit: 'Soumettre la demande',
        validation: {
            name_required: 'Le nom complet est requis',
            email_required: 'Une adresse e-mail valide est requise',
            type_required: 'Veuillez sélectionner un type de demande',
            description_required: 'Veuillez décrire votre demande',
            consent_required: 'Vous devez consentir au traitement pour continuer',
        },
        error_title: 'Erreur',
        config_load_error: "Impossible de charger la configuration. Veuillez vérifier l'URL.",
        organization_label: 'Organisation',
        customer_reference: 'Numéro de référence client',
        country: 'Pays / Juridiction',
        preferred_channel: 'Canal de réponse préféré',
        channels: {
            email: 'E-mail',
            postal: 'Courrier',
            phone: 'Téléphone',
            portal: 'Portail',
        },
        confirmation: {
            title: 'Demande reçue',
            message: 'Votre demande a été enregistrée avec succès. Votre numéro de référence est :',
            next_steps: 'Nous traiterons votre demande dans les meilleurs délais conformément à la législation applicable. Le délai de traitement prévu est de 30 jours ouvrés.',
        },
    },
    request_types: {
        access: "Droit d'accès (DSAR)",
        deletion: "Droit à l'effacement",
        correction: 'Rectification / Mise à jour',
        objection: 'Opposition',
        portability: 'Portabilité des données',
        restriction: 'Limitation du traitement',
        consent_withdrawal: 'Retrait du consentement',
    },
    statuses: {
        new: 'Nouveau',
        in_review: "En cours d'examen",
        waiting_on_requester: 'En attente du demandeur',
        waiting_on_internal_data: 'En attente de données internes',
        approved: 'Approuvé',
        closed: 'Clôturé',
        rejected: 'Rejeté',
    },
    admin: {
        nav: {
            rights_requests: "Demandes d'exercice des droits",
            templates: 'Modèles',
            response_templates: 'Modèles de Réponse',
            data_mapping: 'Cartographie des données',
            governance: 'Gouvernance',
            consent: 'Consentement',
            assessments: 'Évaluations',
            classification: 'Classement',
            monitoring: 'Surveillance',
            incidents: 'Incidents',
            onboarding: 'Intégration',
            connectors: 'Connecteurs',
            vendor_risk: 'Risque prestataire',
            deletion_orchestration: 'Orchestration de suppression',
            discovery: 'Découverte de données',
            incident_ops: 'Opérations incidents',
            program_governance: 'Gouvernance de programme',
            access_accountability: 'Responsabilité des accès',
            consent_properties: 'Propriétés de consentement',
            localization: 'Localisation',
            partner_workspace: 'Espace partenaire',
            audit_trail: "Piste d'audit",
            forseti: 'Forseti',
            settings: 'Paramètres',
            help_center: "Centre d'aide",
            dashboard: 'Tableau de bord',
            platform: 'Plateforme',
            integrations: 'Intégrations',
            cmp_dsar_sync: 'Synchronisation CMP DSAR',
            cmp_integration: 'Intégration CMP',
            purpose_mapping: 'Correspondance des finalités',
            webhook_config: 'Configuration des webhooks',
            bulk_sync: 'Synchronisation en masse',
            privacy_scanner: 'Analyseur de confidentialité',
            privacy_monitoring: 'Surveillance de la confidentialité',
            real_time_scanner: 'Analyseur en temps réel',
            compliance_forms: 'Formulaires de conformité',
            forms_dashboard: 'Tableau de bord des formulaires',
            form_templates: 'Modèles',
            form_catalog: 'Catalogue de formulaires',
            pack_catalog: 'Catalogue de packs',
            org_groups: 'Groupes organisationnels',
            consolidation: 'Consolidation',
            organizations: 'Organisations',
            org_list: 'Toutes les organisations',
            intake_configs: "Configurations d'admission",
            task_management: 'Gestion des tâches',
            unified_audit: 'Audit Unifié',
            evidence_packs: 'Paquets de Preuves',
            audit_periods: "Périodes d'Audit",
            regulatory_updates: 'Mises à Jour Réglementaires',
            departments: 'Départements',
        },
        sidebar_category_data_privacy_rights: 'Confidentialité des Données & Droits',
        sidebar_category_vendor_third_party: 'Gestion des Fournisseurs & Tiers',
        sidebar_category_risk_assessment: 'Risque & Évaluation',
        sidebar_category_operations_automation: 'Opérations & Automatisation',
        sidebar_category_task_workflow: 'Gestion des Tâches & Flux de Travail',
        sidebar_groups: {
            consent_cmp_webhooks: '[[TOK_0]] et webhooks',
            data_mapping_ropa: 'Registre des traitements',
            data_mapping_classification: 'Classement',
            data_mapping_governance: 'Gouvernance',
            access_live_monitoring: 'Surveillance en temps réel',
            access_reviews_investigations: 'Revues & Investigations',
            access_evidence_policies: 'Preuves & Politiques',
            classification_taxonomies: 'Taxonomies & Étiquettes',
            classification_workflow: 'Flux de travail',
            classification_insights: 'Analyses',
            connectors_runtime: 'Exécution',
            connectors_due_diligence: 'Diligence raisonnable',
            connectors_coverage: 'Couverture',
            cp_definitions: 'Définitions',
            cp_lifecycle: 'Cycle de vie',
            cp_quality: 'Qualité & Preuves',
            deletion_execution: 'Exécution',
            deletion_vendors: 'Fournisseurs',
            deletion_evidence: 'Preuves & Intégration',
            discovery_rules: 'Règles & Modèles',
            discovery_scanning: 'Analyse',
            discovery_review: 'Flux de revue',
            discovery_insights: 'Analyses',
            governance_oversight: 'Supervision',
            governance_reporting: 'Rapports',
            governance_vendors: 'Fournisseurs & Transferts hors UE',
            governance_lifecycle: 'Cycle de vie',
            incident_ops_dashboards: 'Tableaux de bord',
            incident_ops_sla: 'Configuration SLA',
            incident_ops_playbooks: 'Manuels de jeu',
            incident_ops_vendor_regulator: 'Fournisseur & Régulateur',
            incident_ops_evidence: 'Preuves & Revue',
            incidents_workload: 'Charge de travail',
            incidents_regulatory: 'Réglementaire',
            incidents_reporting: 'Rapports',
            localization_content: 'Contenu',
            localization_regulatory: 'Réglementaire',
            localization_observability: 'Observabilité',
            monitoring_metrics: 'Métriques',
            monitoring_programs: 'Programmes',
            monitoring_tasks: 'Tâches',
            monitoring_controls: 'Contrôles',
            org_entities: 'Entités',
            org_config: 'Configuration',
            org_frameworks: 'Référentiels & Consolidation',
            partner_overview: 'Vue d’ensemble',
            partner_partners: 'Partenaires',
            partner_delivery: 'Livraison',
            partner_support: 'Assistance',
            platform_identity: 'Identité & Rôles',
            platform_access_control: 'Contrôle d’accès',
            platform_auth_session: 'Authentification & Session',
            platform_access_reviews: 'Revues d’accès',
            platform_files: 'Fichiers',
            platform_notifications: 'Notifications',
            platform_module_config: 'Configuration des modules',
            platform_ops: 'Opérations & Journaux',
            pg_health: 'État du programme',
            pg_maturity: 'Maturité',
            pg_audit: 'Audit & Preuves',
            pg_obligations: 'Obligations',
            pg_documents: 'Documents',
            vr_overview: 'Vue d’ensemble',
            vr_onboarding: 'Intégration',
            vr_assessment: 'Évaluation',
            vr_oversight: 'Supervision',
        },
        tickets: {
            title: "Demandes d'exercice des droits",
            create: 'Créer une demande',
            filters: 'Filtres',
            search_placeholder: 'Search tickets...',
            export_csv: 'Exporter [[TOK_0]]',
            exporting: 'Exportation...',
            bulk_export_failed: "Échec de l'exportation groupée",
            bulk_export: {
                label: 'Exporter',
                format: {
                    pdf: '[[TOK_0]] Résumé',
                    zip: 'ZIP (packs de preuves par cas)',
                    csv: '[[TOK_0]]',
                },
                warning_over_50: 'Cela générera environ [[TOK_1]] dossiers - cela peut prendre plusieurs minutes. Continuer?',
                blocked_over_500: "Filtrez à 500 cas ou moins avant d'exporter le fichier ZIP (actuel : [[TOK_1]]).",
                success: 'Exportation groupée enregistrée dans le navigateur de fichiers (cas [[TOK_1]])',
                failed: "Échec de l'exportation groupée",
                continue: 'Continuer',
                cancel: 'Annuler',
            },
            no_results: 'Aucune demande trouvée',
            ticket_id: 'ID du ticket',
            request_type: 'Type de demande',
            requester: 'Demandeur',
            source: 'Origine',
            all_sources: 'Toutes les sources',
            assigned_to: 'Assigné à',
            created: 'Créé',
            load_error: 'Échec du chargement des dossiers. Veuillez réessayer.',
            case_creation_failed: 'Échec de la création du cas',
            business_unit: 'Unité commerciale',
            reference: 'Référence',
            sla: {
                title: 'Statut SLA',
                on_track: '{days} jours restants',
                approaching: 'Échéance proche',
                overdue: '{days} jours de retard',
                ack_overdue: "{hours}h au-delà du délai d'accusé de réception",
                ack_warning: 'Accusé de réception bientôt dû',
                closed: 'Fermé',
                completed_in: 'Terminé en {days} jours',
            },
        },
        templates: {
            title: 'Modèles de réponse',
            new: 'Nouveau modèle',
            edit: 'Modifier le modèle',
            all_types: 'Tous les types',
            all_locales: 'Toutes les langues',
            type_access: 'Accès/DSAR',
            type_deletion: 'Suppression',
            type_correction: 'Rectificatif',
            type_objection: 'Opposition',
            type_portability: 'Portabilité',
            type_other: 'Autre',
            type_restriction: 'Restriction',
            type_all: 'Tous',
            locale_en: 'Anglais',
            locale_vi: 'Vietnamien',
            locale_all: 'Les deux',
            name: 'Nom',
            request_type: 'Type de demande',
            locale: 'Langue',
            subject: 'Objet',
            body: 'Corps du message',
            name_placeholder: 'Nom du modèle...',
            subject_placeholder: "Objet de l'e-mail/courrier...",
            body_placeholder: 'Corps du modèle. Utilisez {{requester_name}}, {{ticket_id}}, {{request_type}}, {{org_name}}, {{response_date}} comme espaces réservés.',
            available_placeholders: 'Espaces réservés disponibles :',
            create_template: 'Créer un modèle',
            preview: 'Aperçu',
            close_preview: "Fermer l'aperçu",
            default_badge: 'Par défaut',
            no_templates: 'Aucun modèle trouvé',
            confirm_delete: 'Supprimer ce modèle ?',
            load_error: 'Échec du chargement des modèles. Veuillez réessayer.',
            create_error: 'Échec de la création du modèle',
            update_error: 'Échec de la mise à jour du modèle',
            delete_error: 'Échec de la suppression du modèle',
            preview_error: "Échec de l'aperçu du modèle",
            response_templates_badge: 'Modèles de Réponse',
            browse_form_templates: 'Parcourir les Modèles de Formulaires de Conformité',
            templates_loaded: 'Modèles chargés',
            sample_organization: 'Organisation modèle',
        },
        detail: {
            requester_info: 'Informations du demandeur',
            status: 'Statut',
            assignment: 'Attribution',
            notes: 'Remarques',
            audit_trail: "Piste d'audit",
            add_note: 'Ajouter une note',
            case_not_found: 'Dossier introuvable',
            load_error: 'Échec du chargement du dossier. Veuillez réessayer.',
            note_error: "Échec de l'ajout de la note. Veuillez réessayer.",
            submitted_from: 'Soumis depuis',
            via_cmp: 'via [[TOK_1]] [[TOK_0]]',
            cmp_ticket: 'Ticket CMP :',
            select_template: 'Sélectionner un modèle',
            direction_inbound: '[[TOK_0]] → GRC',
            direction_outbound: 'GRC → [[TOK_0]]',
            tabs: {
                details: 'Détails',
                evidence: 'Preuves',
                communications: 'Échanges',
                escalations: 'Escalades',
                audit_trail: "Piste d'audit",
                fulfillment: 'Exécution',
                response: 'Réponse',
                extension: 'Prolongation',
            },
            requester: {
                name: 'Nom',
                email: 'E-mail',
                phone: 'Téléphone',
                language: 'Langue',
                source: 'Provenance',
                customer_ref: 'Réf. client',
                country: 'Pays',
                preferred_channel: 'Canal préféré',
            },
            sla: {
                title: 'SLA',
                on_track: 'Dans les délais',
                due_soon: 'Échéance proche',
                overdue: 'En retard',
                days_remaining: 'j restants',
                due_date: "Date d'échéance",
                breached: 'Dépassé',
                paused: 'En pause',
                total_paused_days: 'Total jours en pause',
                days_elapsed: 'Jours écoulés',
                progress: 'Progression',
            },
            identity: {
                title: "Vérification d'identité",
                verified: 'Vérifié',
                not_verified: 'Non vérifié',
                method: 'Méthode',
                notes: 'Remarques',
                verified_by: 'Vérifié par',
                verified_at: 'Vérifié le',
                warning: "L'identité n'a pas encore été vérifiée.",
                verify_button: "Vérifier l'identité",
                select_method: '-- Sélectionner --',
                methods: {
                    email_confirmation: 'Confirmation par e-mail',
                    id_document: "Pièce d'identité",
                    phone_call: 'Appel téléphonique',
                    in_person: 'En personne',
                    other: 'Autre',
                },
            },
            closure: {
                reason: 'Motif de clôture',
                summary: 'Résumé de clôture',
                summary_placeholder: 'Résumé de la résolution de la demande...',
                reason_required: 'Le résumé et le motif de clôture sont requis',
                response_not_sent: 'Une réponse formelle doit être envoyée au sujet des données avant de clôturer ce dossier',
                reasons: {
                    fulfilled: 'Satisfait',
                    partially_fulfilled: 'Partiellement satisfait',
                    unfounded: 'Non fondé',
                    excessive: 'Excessif',
                    withdrawn: 'Retiré',
                    duplicate: 'Doublon',
                    identity_unverified: 'Identité non vérifiée',
                },
            },
            export_title: 'Exporter',
            export_pdf: 'Exporter en PDF',
            export_zip: 'Exporter en ZIP',
            case_file_pdf: 'Exporter [[TOK_0]] (dossier)',
            evidence_pack_zip: 'Exporter ZIP (Pack de preuves)',
            cross_border_warning: 'Virement transfrontalier détecté - dossier transfrontalier requis',
            breach: {
                flag_btn: 'Signaler comme étant à l’origine d’une violation',
                modal: {
                    title: 'Signaler le cas comme étant à l’origine d’une violation',
                    type_label: 'Type de violation',
                    type: {
                        misdirected_response: 'Réponse mal adressée',
                        unauthorised_disclosure: 'Divulgation non autorisée',
                        identity_mismatch: "Inadéquation d'identité",
                        other: 'Autre',
                    },
                    description: 'Description (facultatif)',
                    description_placeholder: "Ce qui s'est passé? (maximum 1 000 caractères)",
                    confirm: 'Signaler et démarrer le chronomètre de dépôt de 72h',
                    cancel: 'Annuler',
                    flagging: 'Signalement...',
                },
                banner: {
                    title: 'Violation signalée : [[TOK_1]]',
                    detected_at: 'Détecté à [[TOK_1]]',
                    filing_deadline: '72h Délai de dépôt [[TOK_2]] : en [[TOK_1]] heures',
                    overdue: '72h délai de dépôt [[TOK_0]] : OVERDUE',
                },
                toasts: {
                    flagged: "Affaire signalée comme étant à l'origine d'une violation - le chronomètre de 72 h a démarré",
                    flag_failed: "Échec de la signalisation du cas comme étant à l'origine d'une violation",
                },
            },
            export: {
                generating: 'Génération... veuillez patienter',
                success: 'Exportation enregistrée dans le navigateur de fichiers',
                failed: "Échec de l'exportation : vérifiez le journal d'audit",
            },
            no_notes: 'Aucune note pour le moment',
            assign_placeholder: 'ID utilisateur à assigner...',
            reassign: 'Réassigner',
            evidence: {
                checklist_title: 'Liste de contrôle des preuves',
                complete_pct: '% terminé',
                no_checklist: 'Aucun élément dans la liste de contrôle',
                attachments: 'Pièces jointes',
                upload_attachment: 'Télécharger une pièce jointe',
                upload_button: 'Télécharger',
                uploading: 'Téléchargement...',
                attachment_uploaded: 'Pièce jointe téléchargée avec succès',
                upload_error: 'Échec du téléchargement',
                category: 'Catégorie',
                categories: {
                    identity_proof: "Preuve d'identité",
                    correspondence: 'Correspondance',
                    internal_data: 'Données internes',
                    legal: 'Légal',
                    other: 'Autre',
                },
                no_attachments: 'Aucune pièce jointe',
                references_title: 'Références de preuves',
                no_references: 'Aucune référence',
                add_reference: 'Ajouter une référence',
                ref_type: 'Catégorie',
                ref_value: 'Valeur',
                ref_desc: 'Descriptif',
                ref_value_placeholder: 'URL, ID e-mail ou référence...',
                ref_desc_placeholder: 'Descriptif...',
                ref_types: {
                    url: 'URL',
                    email_id: 'ID e-mail',
                    crm_record: 'Enregistrement CRM',
                    ticket_ref: 'Référence du ticket',
                    other: 'Autre',
                },
            },
            communications: {
                title: 'Communications',
                add: 'Ajouter un message',
                no_records: 'Aucune communication enregistrée',
                direction: 'Sens',
                channel: 'Canal',
                visibility: 'Visibilité',
                subject: 'Objet',
                body: 'Corps',
                send: 'Envoyer',
                inbound: 'Entrant',
                outbound: 'Sortant',
                internal: 'Interne',
                external: 'Externe',
                tab_all: 'All',
                tab_internal: 'Interne',
                tab_external: 'Externe',
                subject_placeholder: 'Objet (facultatif)',
                body_placeholder: 'Corps du message...',
                channels: {
                    email: 'E-mail',
                    portal: 'Portail',
                    phone: 'Téléphone',
                    postal: 'Courrier postal',
                    in_person: 'En personne',
                },
                apply_template: 'Appliquer le Modèle',
                select_template: 'Sélectionner un modèle...',
                no_templates: 'Aucun modèle disponible',
                template_applied: 'Modèle appliqué à la réponse.',
                template_apply_error: "Impossible d'appliquer le modèle.",
            },
            escalations: {
                title: "Historique d'escalade",
                no_events: "Aucun événement d'escalade",
                tier: 'Niveau',
                threshold: 'Seuil',
                action: 'Mesure',
                target: 'Cible',
                triggered_at: 'Déclenché le',
            },
            cmp_sync: {
                title: 'Synchronisation AesirX CMP',
                sync_status: 'Statut de synchronisation',
                last_synced: 'Dernière synchronisation',
                not_synced: 'Non synchronisé',
                resync: 'Resynchroniser maintenant',
                syncing: 'Synchronisation en cours...',
                sync_history: 'Historique de synchronisation (10 dernières)',
                direction: 'Sens',
                time: 'Heure',
                retries: 'Tentatives',
                error_col: 'Erreur',
            },
            audit: {
                filter_event_placeholder: "Filtrer par type d'événement...",
                filter_actor_placeholder: 'Filtrer par acteur...',
            },
            fulfillment: {
                title: 'Exécution par département',
                assign_departments: 'Attribuer les départements',
                department: 'Département',
                assignee: 'Responsable',
                deadline: 'Échéance',
                evidence_count: 'Preuves',
                signoff: 'Validation',
                signed_off: 'Validé',
                pending_signoff: 'En attente',
                start_button: 'Démarrer',
                complete_button: 'Marquer comme terminé',
                signoff_button: 'Se déconnecter',
                no_tasks: "Aucune tâche d'exécution attribuée.",
                tasks_table: "Tâches d'exécution",
                progress_label: "Progression de l'exécution",
                overdue: 'en retard',
                assigned_success: "Tâche d'exécution départementale attribuée avec succès.",
                assign_error: "Échec de l'attribution de la tâche d'exécution.",
                signoff_success: 'Validation départementale enregistrée.',
                signoff_error: "Échec de l'enregistrement de la validation.",
                identity_required: 'Identity verification required before fulfillment actions.',
                remove_task: 'Remove Task',
                remove_success: 'Fulfillment task removed successfully.',
                add_evidence_btn: 'Ajouter des preuves',
                evidence_uploaded: 'Preuve téléchargée et liée',
                evidence_upload_error: 'Échec du téléchargement',
                suggest_data_stores: 'Suggérer des entrepôts de données',
                suggest_error: 'Échec du chargement des suggestions de stockage.',
                suggest_stores_title: 'Magasins de données suggérés',
                suggest_stores_none: 'Aucun magasin de données ne correspond à ce cas. Configurez les systèmes dans Data Mapping pour améliorer les suggestions.',
                suggest_stores_add: 'Ajouter au cas',
                suggest_stores_added: 'Magasin de données ajouté au dossier',
                no_departments_title: 'Aucun département configuré',
                no_departments_body: "Les départements vous permettent d'acheminer les tâches d'exécution DSR vers une fonction (Confidentialité, Juridique, RH, Opérations informatiques). Installez des exemples de départements ou demandez à votre administrateur de configurer les départements dans les paramètres de l'organisation.",
                no_departments_cta: 'Installer des exemples de données',
                department_placeholder: 'Nom du département...',
                assignee_placeholder: 'ID utilisateur à attribuer...',
                assign_button: 'Attribuer',
                status_pending: 'En attente',
                status_in_progress: 'En cours',
                status_completed: 'Terminé',
                status_verified: 'Vérifié',
                confirm_approve: 'Êtes-vous sûr de vouloir approuver cette prolongation ?',
                confirm_deny: 'Êtes-vous sûr de vouloir refuser cette prolongation ?',
            },
            response: {
                title: 'Génération de réponse',
                select_template: 'Modèle de réponse',
                choose_template: 'Sélectionner un modèle...',
                generate: 'Générer la réponse',
                preview: 'Aperçu de la réponse',
                send: 'Envoyer la réponse',
                delivery_method: {
                    label: 'Méthode de livraison',
                    email: 'Courriel',
                    portal: 'Portail',
                    postal: 'Courrier postal',
                    in_person: 'En personne',
                },
                recipient: {
                    email: 'E-mail du destinataire',
                    portal: 'ID utilisateur du portail',
                    address: 'Adresse postale',
                },
                auto_generate_btn: 'Générer et envoyer une réponse',
                auto_generate_success: 'Réponse générée et délivrée',
                auto_generate_missing_recipient: "Veuillez indiquer un destinataire avant l'envoi.",
                auto_fields: 'Champs remplis automatiquement',
                case_id: 'ID du dossier',
                requester_name: 'Nom du demandeur',
                rights_type: 'Type de droit',
                history: 'Réponses envoyées',
                generated_at: 'Généré',
                confirmation: 'Confirmation',
                sent_label: 'Envoyé',
                draft_label: 'Brouillon',
                generated_success: 'Réponse générée avec succès.',
                generate_error: 'Échec de la génération de la réponse.',
                sent_success: 'Réponse envoyée avec succès.',
                send_error: "Échec de l'envoi de la réponse.",
                load_error: 'Échec du chargement des modèles de réponse.',
                pdf_title: 'Lettre de réponse à la personne concernée',
                download_pdf: 'Télécharger le PDF',
                download_all: 'Tout télécharger',
                download_error: 'Échec du téléchargement de la réponse',
            },
            extension: {
                title: 'Prolongations de délai',
                acknowledgment_deadline: "Délai d'accusé de réception",
                fulfillment_deadline: "Délai d'exécution",
                request_extension: 'Demander une prolongation',
                reason: 'Motif',
                reason_placeholder: 'Motif de la demande de temps supplémentaire...',
                additional_days: 'Jours supplémentaires',
                submit_request: 'Soumettre la demande de prolongation',
                history: 'Historique des prolongations',
                requested_at: 'Demandé',
                approve: 'Approuver',
                deny: 'Refuser',
                request_success: 'Demande de prolongation soumise.',
                request_error: 'Échec de la soumission de la demande de prolongation.',
                approved_success: 'Prolongation approuvée.',
                denied_success: 'Prolongation refusée.',
                decision_error: 'Échec du traitement de la décision de prolongation.',
                status_pending: 'En attente',
                status_approved: 'Approuvé',
                status_denied: 'Refusé',
                confirm_approve: 'Êtes-vous sûr de vouloir approuver cette demande de prolongation ?',
                confirm_deny: 'Êtes-vous sûr de vouloir refuser cette demande de prolongation ?',
                decided_by: 'Décidé par',
            },
        },
        audit: {
            export_csv: 'Exporter en CSV',
            exporting: 'Export en cours...',
            search_placeholder: "Rechercher dans les détails d'audit...",
            filter_by_actor: 'Filtrer par acteur...',
            all_event_types: "Tous les types d'événements",
            seq: '#',
            timestamp: 'Horodatage',
            event: 'Événement',
            case_col: 'Dossier',
            actor: 'Acteur',
            summary: 'Résumé',
            no_events: "Aucun événement d'audit trouvé",
            export_success: "Piste d'audit exportée avec succès.",
            export_error: "Échec de l'export CSV d'audit",
            load_error: "Échec du chargement de la piste d'audit. Veuillez réessayer.",
            announce_loaded: "Piste d'audit chargée",
            start_date: 'Date de début',
            end_date: 'Date de fin',
            per_page: '[[TOK_1]] / page',
            unknown: 'Inconnu',
            source_filter: {
                label: 'Origine',
                all: 'Tout',
                module: 'Module',
                forseti: 'Forseti',
                aria_label: "Filtrer les événements d'audit par source",
            },
            event_types: {
                case_created: 'Dossier créé',
                status_changed: 'Statut modifié',
                case_assigned: 'Dossier assigné',
                note_added: 'Note ajoutée',
                attachment_added: 'Pièce jointe ajoutée',
                attachment_deleted: 'Pièce jointe supprimée',
                reference_added: 'Référence ajoutée',
                checklist_updated: 'Liste de contrôle mise à jour',
                identity_verified: 'Identité vérifiée',
                closure_summary_added: 'Résumé de clôture',
                approval_granted: 'Approbation accordée',
                template_applied: 'Modèle appliqué',
                export_generated: 'Export généré',
                sla_warning: 'Avertissement SLA',
                sla_overdue: 'SLA dépassé',
            },
            unified_audit: {
                title: "Piste d'Audit Unifiée",
                module_filter: 'Module',
                framework_filter: 'Référentiel',
                select_framework: 'Sélectionner un référentiel...',
                entity_type_filter: "Type d'entité",
                action_filter: 'Action',
                actor_filter: 'Acteur',
                select_actor: 'Sélectionner un acteur...',
                search_filter: 'Recherche',
                search_placeholder: "Rechercher des événements d'audit...",
                filters_heading: 'Filtres',
                date_range: 'Plage de dates',
                no_events_found: "Aucun événement d'audit trouvé.",
                event_count: "Nombre d'événements",
                action: 'Action',
                actor: 'Acteur',
                date_range_start: 'Début de la plage de dates',
                date_range_end: 'Fin de la plage de dates',
                filtering_events: "Filtrage des événements d'audit",
                framework_codes: 'Codes de cadre',
                entity_type_col: "Type d'entité",
                aria_table: "Événements d'audit unifiés",
                page_of: 'Page {page} sur {total}',
                entity_types: {
                    user: 'Utilisateur',
                    case: 'Cas',
                    incident: 'Incident',
                    assessment: 'Évaluation',
                    vendor: 'Vendeur',
                    consent: 'Consentement',
                    policy: 'Politique',
                    data_map: 'Carte des données',
                },
                actions: {
                    create: 'Créer',
                    update: 'Mise à jour',
                    delete: 'Supprimer',
                    view: 'Voir',
                    export: 'Exporter',
                    status_change: 'Changement de statut',
                },
            },
            evidence_packs: {
                title: "Paquets de Preuves d'Audit",
                assemble_pack: 'Assembler un Paquet de Preuves',
                framework: 'Référentiel',
                select_framework: 'Sélectionner un référentiel...',
                framework_code_label: 'Code du cadre',
                entity_types: "Types d'entités",
                select_entity_types: "Sélectionner les types d'entités...",
                period: 'Période',
                period_start: 'Début de la période',
                period_end: 'Fin de la période',
                completeness: 'Complétude',
                no_packs_found: 'Aucun paquet de preuves trouvé.',
                verify: 'Vérifier',
                export_pack: 'Exporter',
                exporting: 'Exportation en cours...',
                pack_assembled: 'Pack de preuves assemblé',
                pack_exported: 'Pack de preuves exporté',
                aria_table: "Packs de preuves d'audit",
                aria_export_pack: 'Exporter le pack',
                export_format: "Format d'exportation",
                export_in_progress: 'Exportation en cours...',
                status_draft: 'Brouillon',
                status_assembled: 'Assemblé',
                status_verified: 'Vérifié',
                status_submitted: 'Soumis',
                entity_type_labels: {
                    user: 'Utilisateur',
                    case: 'Cas',
                    incident: 'Incident',
                    assessment: 'Évaluation',
                    vendor: 'Vendeur',
                    consent: 'Consentement',
                    policy: 'Politique',
                    data_map: 'Carte des données',
                },
                template_id: 'ID de modèle',
                csv_headers: {
                    module: 'Module',
                    action: 'Action',
                    actor_id: 'Acteur',
                    entity_type: "Type d'entité",
                    entity_id: "ID d'entité",
                    summary: 'Résumé',
                    timestamp: 'Horodatage',
                    framework_code: 'Cadre',
                },
                export_header_framework: 'Pack de preuves — Cadre : {framework}',
                export_header_period: 'Période : {start} à {end}',
                export_header_completeness: 'Complétude : {score}%',
                export_header_status: 'Statut : {status}',
            },
            audit_periods: {
                title: "Périodes d'Audit",
                create_period: "Créer une Période d'Audit",
                framework_code_label: 'Code du cadre',
                select_framework: 'Sélectionner un référentiel...',
                period_label: 'Libellé de période',
                period_start: 'Début de la période',
                period_end: 'Fin de la période',
                start: 'Commencer',
                end: 'Fin',
                framework: 'Cadre',
                retention_days: 'Jours de rétention',
                no_periods_found: "Aucune période d'audit trouvée.",
                period_created: "Période d'audit créée",
                aria_table: "Périodes d'audit",
                suggested_boundaries: 'Limites suggérées',
                suggested_boundaries_info: 'Les limites de période suggérées sont dérivées du cycle de reporting réglementaire de chaque cadre. Ajustez selon les besoins de votre organisation.',
                reporting_cycle: 'Cycle de reporting',
                suggested_start: 'Début suggéré',
                suggested_end: 'Fin suggérée',
                suggested_next: 'Période suivante suggérée',
                cycle_monthly: 'Mensuel',
                cycle_quarterly: 'Trimestriel',
                cycle_semi_annual: 'Semestriel',
                cycle_annual: 'Annuel',
                cycle_custom: 'Personnalisé',
                period_deleted: "Période d'audit supprimée",
            },
        },
        create_case: {
            customer_ref: 'Référence client',
            country: 'Pays / Juridiction',
            preferred_channel: 'Canal préféré',
            channels: {
                email: 'E-mail',
                postal: 'Courrier postal',
                phone: 'Téléphone',
                portal: 'Portail',
            },
            source: 'Origine',
            sources: {
                admin_manual: "Manuel d'administration",
                public_form: 'Formulaire public',
                cmp_gateway: '[[TOK_0]] Passerelle',
                aesirx_cmp: '[[TOK_1]] [[TOK_0]]',
                phone_received: 'Téléphone reçu',
                postal_received: 'Poste reçu',
                email_received: 'E-mail reçu',
                in_person: 'En personne',
                legacy_import: 'Importation héritée',
            },
            required_fields: "Le type de demande, le nom et l'e-mail sont requis",
            create_error: 'Échec de la création du dossier',
        },
        settings: {
            title: 'Paramètres',
            request_types: 'Types de demande',
            request_types_desc: 'Configurez les types de demande activés pour le formulaire public.',
            notifications: 'Avis',
            ticket_numbering: 'Numérotation des tickets',
            ticket_format: 'Format actuel',
            ticket_prefix: 'Préfixe',
            ticket_prefix_note: 'non configurable dans le Sprint 1.0.0',
            sla_deadlines: 'Délais SLA',
            sla_desc: 'Définissez le délai de réponse maximal (en jours calendaires) pour chaque type de demande. Les dossiers approchant du seuil afficheront des avertissements.',
            days: 'jours',
            warning_threshold: "Seuil d'avertissement",
            escalation_label: "Activer l'escalade automatique en cas de dépassement du SLA",
            save_sla: 'Enregistrer la configuration SLA',
            saving: 'Enregistrement...',
            saved: 'Enregistré avec succès',
            announce_loaded: 'Paramètres chargés',
            email_on_creation: 'Notification par e-mail à la création du ticket',
            send_confirmation: 'Envoyer un e-mail de confirmation au demandeur',
            users: 'Utilisateurs',
            roles: 'Rôles',
            api_keys: '[[TOK_0]] Clés',
            mfa: 'MFA',
            sessions: 'Séances',
            webhooks: 'Webhooks',
            modules: 'Modules',
            deadline_labels: {
                access: "Droit d'accès (DSAR)",
                deletion: 'Effacement',
                correction: 'Droit de rectification',
                portability: 'Portabilité',
                objection: 'Opposition',
                restriction: 'Limitation',
                consent_withdrawal: 'Retrait du consentement',
            },
        },
        section_assignments: {
            title: 'Attributions de sections',
            assign_section: 'Attribuer une section',
            section_ref: 'Référence de section',
            section_label: 'Libellé de section',
            department_id: 'Département',
            assignee_id: 'Responsable',
            mandatory: 'Obligatoire',
            assign: 'Attribuer',
            no_assignments: 'Aucune attribution de section',
            status: 'Statut',
            completion: 'Achèvement',
            mark_complete: 'Terminer',
        },
        consolidation: {
            title: 'Avancement de la consolidation',
            add_child: 'Ajouter une sous-tâche',
            child_task_id: 'Identifiant de sous-tâche',
            department_id: 'Département',
            link: 'Lien',
            overall_completion: 'Achèvement global',
            departments_complete: 'Départements terminés',
            overdue: 'En retard',
            ready: 'Prêt',
            not_ready: 'Pas prêt',
            master_status: 'Statut global',
            department_breakdown: 'Détail par département',
            department: 'Département',
            status: 'Statut',
            completion: 'Achèvement',
            due_date: "Date d'échéance",
            overdue_flag: 'En retard',
            child_tasks: 'Sous-tâches',
            task: 'Tâche',
        },
        conflict_detection: {
            title: 'Détection de conflits',
            unresolved: 'non résolu',
            no_conflicts: 'Aucun conflit détecté',
            section: 'Section',
            field: 'Champ',
            dept_a: 'Département A',
            value_a: 'Valeur A',
            dept_b: 'Département B',
            value_b: 'Valeur B',
            severity: 'Gravité',
            status: 'Statut',
            resolved: 'Résolu',
            open: 'Ouvert',
            resolve: 'Résoudre',
        },
        org_maturity: {
            title: "Maturité de l'Organisation",
            departments: 'Départements',
            department_hierarchy: 'Hiérarchie des Départements',
            create_department: 'Créer un Département',
            department_name: 'Nom du Département',
            department_code: 'Coder',
            level: 'Niveau',
            division: 'Division',
            department: 'Département',
            team: 'Équipe',
            parent_department: 'Département Parent',
            head_user: 'Chef de Département',
            no_departments: 'Aucun département configuré.',
            user_mappings: "Affectations d'Utilisateurs",
            map_user: 'Affecter un Utilisateur',
            user_id: 'ID Utilisateur',
            role: 'Rôle',
            no_users: 'Aucun utilisateur affecté à ce département.',
            remove: 'Supprimer',
            framework_assignments: 'Affectations de Référentiels',
            assign_framework: 'Affecter un Référentiel',
            entity_id: "ID de l'Entité",
            entity_type: "Type d'Entité",
            framework_id: 'ID du Référentiel',
            framework_code: 'Code du Référentiel',
            no_assignments: 'Aucune affectation de référentiel.',
            compliance_rollup: 'Synthèse de Conformité',
            entity_name: 'Entité',
            total_assessments: 'Évaluations Totales',
            completed: 'Terminé',
            completion_pct: 'Achèvement %',
            open_gaps: 'Écarts Ouverts',
            critical_gaps: 'Critiques',
            compliance_score: 'Score',
            no_rollup: 'Aucune donnée de synthèse de conformité disponible.',
            entity_summary: "Résumé de Conformité de l'Entité",
            frameworks_assigned: 'Référentiels',
            overall_score: 'Score Global',
            load_departments_error: 'Échec du chargement des départements',
            load_users_error: 'Échec du chargement des utilisateurs',
            department_created: 'Département créé',
            department_created_announce: 'Département créé',
            create_department_error: 'Échec de la création du département',
            user_mapped: 'Utilisateur associé',
            user_mapped_announce: 'Utilisateur associé au département',
            map_user_error: "Échec de l'association de l'utilisateur",
            user_removed: 'Utilisateur supprimé',
            load_rollup_error: 'Échec du chargement du résumé',
            load_assignments_error: 'Échec du chargement des attributions',
            framework_assigned: 'Cadre affecté',
            framework_assigned_announce: "Cadre affecté à l'entité",
            assign_framework_error: "Échec de l'attribution du cadre",
            assignment_removed: 'Affectation supprimée',
            enter_entity_id_placeholder: "Entrez l'ID de l'entité pour voir les affectations",
            entity_type_organization: 'Organisation',
            entity_type_department: 'Département',
        },
        onboarding_maturity: {
            title: "Maturité d'intégration",
            quick_starts: 'Démarrages rapides',
            progress: "Progression de l'intégration",
            personas: 'Chemins de personnalité',
            persona_onboarding: 'Intégration des personnages',
            quick_start_scenarios: 'Scénarios de démarrage rapide',
            start: 'Démarrer',
            restart: 'Redémarrer',
            estimated_minutes: 'Minutes estimées',
            steps: 'Étapes',
            scenario: 'Scénario',
            no_scenarios: 'Aucun scénario de démarrage rapide disponible.',
            persona_id: 'Identifiant personnel',
            persona_label: 'Personnalité',
            role_description: 'Description du rôle',
            primary_modules: 'Modules principaux',
            recommended_tours: 'Visites recommandées',
            sample_data_modules: 'Exemples de modules de données',
            quick_start_scenario: 'Scénario de démarrage rapide',
            no_personas: 'Aucun chemin personnel disponible.',
            framework_setup: 'Cadres réglementaires',
            framework_code: 'Code-cadre',
            framework_name: 'Nom du cadre',
            related_modules: 'Modules associés',
            persona_relevance: 'Personnalités pertinentes',
            no_frameworks: 'Aucune option de configuration du framework disponible.',
            tier_config: 'Configuration du module de niveau',
            tier: 'Niveau',
            available_modules: 'Modules disponibles',
            module_count: 'Nombre de modules',
            overall_completion: 'Achèvement global',
            wizard_completed: 'Assistant terminé',
            tours_completed: 'Visites terminées',
            quick_starts_completed: 'Démarrages rapides terminés',
            selected_frameworks: 'Cadres sélectionnés',
            no_progress: 'Aucune donnée de progression de l’intégration disponible.',
            detected_persona: 'Personnalité détectée',
            current_tier: 'Niveau actuel',
            completion_pct: 'Achèvement',
            progress_page: {
                loaded: 'Progression chargée',
                no_progress: "Aucune donnée de progression d'intégration disponible.",
                overall: 'Progression globale',
                detected_persona: 'Persona détecté',
                tier: 'Niveau',
                modules: 'modules',
                wizard: 'Assistant',
                completed: 'Terminé',
                pending: 'En attente',
                tours: 'Visites guidées',
                quick_starts: 'Démarrages rapides',
                frameworks: 'Cadres sélectionnés',
                no_frameworks: 'Aucun cadre sélectionné.',
                go_to_wizard: "Terminer l'assistant de configuration",
                framework_selection: 'Sélection du cadre',
                framework_toggle: 'Activer ou désactiver les cadres pour votre programme de conformité.',
                framework_updated: 'Sélection du cadre mise à jour.',
                view_tours: 'Voir les visites guidées',
                view_quick_starts: 'Voir les démarrages rapides',
            },
            persona_page: {
                description: 'Sélectionnez un persona pour voir les modules, visites guidées et scénarios de démarrage rapide recommandés.',
                no_personas: 'Aucun parcours de persona disponible.',
                modules: 'Modules',
                tours: 'Visites guidées',
                quick_start: 'Démarrage rapide',
                details: 'Détails',
                primary_modules: 'Modules principaux',
                recommended_tours: 'Visites guidées recommandées',
                framework_options: 'Cadres réglementaires',
                no_frameworks: 'Aucune option de configuration du cadre disponible.',
                framework_code: 'Code du cadre',
                framework_label: 'Libellé',
                region: 'Région',
                category: 'Catégorie',
                enabled: 'Activé',
                disabled: 'Désactivé',
                tier_modules: 'Configuration des modules par niveau',
                tiers_loaded: 'Configurations de niveaux chargées',
                no_tier_config: 'Aucune configuration de niveau disponible.',
                view_tours: 'Voir les visites de modules',
                view_quick_start: 'Lancer le démarrage rapide',
                toggle_framework: 'Basculer le cadre',
                framework_updated: 'Sélection du cadre mise à jour.',
                tier_desc_light: 'Essentiels de confidentialité — bases de conformité PDPL',
                tier_desc_standard: 'Suite de conformité complète — tous les modules avec workflows',
                tier_desc_enterprise: 'Gouvernance avancée et automatisation — multi-entité, rapports de groupe',
                persona_highlight: 'Vos modules',
                aria_go_to_module: '[[TOK_1]] — aller au module',
                aria_start_tour: 'Démarrer [[TOK_1]]',
                aria_quick_start: 'Démarrage rapide : [[TOK_1]]',
                aria_help_article: "Article d'aide : [[TOK_1]]",
                aria_view_framework: '[[TOK_2]][[TOK_3]] — afficher les détails du framework',
                aria_primary_for_persona: '[[TOK_1]] (principal pour ce personnage)',
                primary_for_persona_suffix: ' (primaire pour ce personnage)',
                aria_view_in_persona_paths: '[[TOK_1]] — affichage dans les chemins personnels',
                progress_of_total: '[[TOK_2]] sur [[TOK_3]] terminés',
            },
            quick_starts_page: {
                description: 'Pratiquez les flux de travail courants avec des scénarios de démarrage rapide guidés.',
                no_scenarios: 'Aucun scénario de démarrage rapide disponible.',
                started: 'Démarrage rapide lancé',
                status_completed: 'Terminé',
                status_in_progress: 'En cours',
                status_not_started: 'Non commencé',
                minutes: 'min',
                steps: 'étapes',
                step: 'Étape',
                restart: 'Redémarrer',
                start: 'Démarrer',
                go_to_module: 'Aller au module',
                next_step: 'Étape suivante',
                complete: 'Terminer',
                reset: 'Réinitialiser',
                step_of: 'sur',
                action_navigate: 'Naviguer',
                action_form_fill: 'Remplir le formulaire',
                action_review: 'Vérifier',
                action_confirm: 'Confirmer',
                step_changed: 'Étape {current} sur {total} : {title}',
                completed_message: 'Démarrage rapide terminé avec succès !',
                reset_message: 'Le démarrage rapide a été réinitialisé.',
            },
            persona_p_vn_01_label: 'Entreprise DPO',
            persona_p_vn_01_description: "Délégué à la protection des données gérant les programmes de conformité à l'échelle de l'entreprise",
            persona_p_vn_02_label: 'Propriétaire du département',
            persona_p_vn_02_description: 'Chef de service responsable des rapports de conformité sectoriels',
            persona_p_vn_03_label: 'Conformité du commerce électronique',
            persona_p_vn_03_description: 'Responsable de la conformité axé sur la protection des données et le consentement du commerce électronique',
            persona_p_vn_04_label: 'Télécom DPO',
            persona_p_vn_04_description: "Secteur des télécommunications DPO gérant les données des abonnés et les rapports d'incidents",
            persona_p_vn_05_label: 'Responsable de la gouvernance des données',
            persona_p_vn_05_description: 'Responsable de la cartographie, de la classification et de la gouvernance des données',
            persona_p_vn_06_label: 'Cybersécurité et opérations juridiques',
            persona_p_vn_06_description: 'Responsable de la cybersécurité gérant la réponse aux incidents et les risques liés aux fournisseurs',
            persona_p_vn_07_label: 'AI Responsable de la gouvernance',
            persona_p_vn_07_description: 'Responsable de la supervision de la gouvernance du système, des évaluations des risques et de la classification de AI',
            persona_p_vn_08_label: 'Gouvernement transfrontalier et fournisseur',
            persona_p_vn_08_description: 'Agent gérant les transferts transfrontaliers et la gouvernance des fournisseurs',
            persona_p_vn_09_label: 'Responsable de la réponse aux violations',
            persona_p_vn_09_description: 'Responsable de la coordination des notifications de violations et de la réponse aux incidents',
            persona_p_vn_10_label: "Responsable de l'audit interne",
            persona_p_vn_10_description: "Responsable de l'audit de conformité et de l'examen de la gouvernance des programmes",
            persona_p_vn_11_label: 'Responsable des données RH et employés',
            persona_p_vn_11_description: 'Responsable RH gérant les registres de consentement des employés et les DSAR internes',
            persona_p_vn_12_label: 'Responsable conformité filiale multinationale',
            persona_p_vn_12_description: "DPO dans une filiale vietnamienne d'une entreprise étrangère nécessitant une couche de conformité locale",
            persona_p_vn_13_label: 'Responsable conformité éducation',
            persona_p_vn_13_description: 'Responsable conformité dans un établissement scolaire étranger gérant la protection des données des élèves et des parents',
            qs_hr_consent_title: 'Enregistrer les consentements des employés',
            qs_hr_consent_description: "Parcourir l'enregistrement du consentement des employés et générer un rapport de couverture.",
            qs_subsidiary_dpia_title: 'Créer une évaluation AIPD de filiale',
            qs_subsidiary_dpia_description: "Parcourir la création d'une AIPD pour une activité de traitement de filiale.",
            qs_student_consent_title: 'Configurer la collecte de consentement étudiant',
            qs_student_consent_description: 'Parcourir la création de politiques de consentement parental pour les données des élèves.',
            persona_p_vn_14_label: 'Conseiller juridique externe',
            persona_p_vn_14_description: "Associé principal d'un cabinet d'avocats, conseillant plusieurs organisations clientes sur la conformité de PDPL",
            persona_p_vn_15_label: "Responsable des opérations du cabinet d'avocats",
            persona_p_vn_15_description: "Coordonnateur de l'engagement client gérant le suivi des livrables et la coordination des délais",
            persona_p_vn_16_label: "Propriétaire d'entreprise / CEO",
            persona_p_vn_16_description: "CEO ou GM qui est légalement le responsable du traitement des données sous PDPL, responsable de l'investissement en matière de conformité",
            qs_dpia_filing_title: 'Complétez votre premier dépôt DPIA',
            qs_dept_compliance_title: 'Soumettez votre première section de conformité du service',
            qs_ecommerce_consent_title: 'Configurer la collecte de consentement pour le commerce électronique',
            qs_telecom_data_title: 'Configurer la gestion des données des abonnés télécoms',
            qs_data_flow_title: 'Cartographiez votre premier flux de données',
            qs_incident_response_title: 'Configurer le workflow de réponse aux incidents',
            qs_ai_risk_title: 'Exécuter une évaluation des risques système AI',
            qs_cross_border_title: 'Évaluer un transfert de données transfrontalier',
            qs_breach_notification_title: 'Simuler un workflow de notification de violation',
            qs_audit_trail_title: 'Examiner une piste d’audit de conformité',
            qs_legal_advisor_portfolio_title: 'Examiner le portefeuille de conformité multi-clients',
            qs_legal_advisor_portfolio_description: 'Examinez l’état de conformité de plusieurs organisations clientes.',
            qs_law_firm_ops_title: 'Suivre l’état des livrables du client',
            qs_law_firm_ops_description: 'Surveiller les progrès des livrables de conseil et l’engagement des clients.',
            qs_ceo_dashboard_title: 'Afficher le tableau de bord de conformité des dirigeants',
            qs_ceo_dashboard_description: 'Examinez l’état de conformité de haut niveau et les mesures d’investissement.',
        },
        rights_requests: {
            response_templates: {
                title: 'Modèles de réponse',
                subtitle: 'Gérez les modèles de lettre de réponse DSR que ResponseGenerator utilise pour rédiger les réponses aux personnes concernées.',
                create_btn: 'Nouveau modèle',
                edit_btn: 'Modifier le modèle',
                filter_right_type: 'Filtrer par type approprié',
                filter_locale: 'Filtrer par paramètres régionaux',
                filter_status: 'Filtrer par statut',
                all_right_types: 'Tous les bons types',
                any_right_type: "Tout (s'applique à tous les types)",
                all_locales: 'Tous les paramètres régionaux',
                all_statuses: 'Tout',
                status_active: 'Actif',
                status_inactive: 'Inactif',
                empty_state: 'Aucun modèle ne correspond aux filtres actuels.',
                columns: {
                    template_id: 'ID du modèle',
                    outcome: 'Résultat',
                    locale: 'Paramètres régionaux',
                    right_type: 'Type correct',
                    is_active: 'Statut',
                    last_updated: 'Dernière mise à jour',
                    actions: 'Actions',
                },
                actions: {
                    edit: 'Modifier',
                    clone: 'Cloner',
                    deactivate: 'Désactiver',
                    reactivate: 'Réactiver',
                    preview: 'Aperçu',
                },
                form: {
                    template_id: 'ID du modèle',
                    template_id_help: 'Identifiant minuscule, par ex. dsr_access_fulfilled_vi',
                    outcome: 'Résultat',
                    locale: 'Paramètres régionaux',
                    right_type: 'Type correct',
                    subject: 'Sujet',
                    body: 'Modèle de corps',
                    body_help: 'Utilisez des espaces réservés tels que [[TOK_3]], [[TOK_4]], [[TOK_5]]. Minimum 15 lignes pour les lettres à plusieurs sections.',
                    is_active: 'Actif',
                    official_form_id: 'ID du formulaire officiel (facultatif)',
                },
                outcomes: {
                    fulfilled: 'Réalisé',
                    partially_fulfilled: 'Partiellement réalisé',
                    denied: 'Refusé',
                },
                clone_modal_title: 'Modèle de clonage',
                clone_target_locale: 'Paramètres régionaux cibles',
                clone_help: 'Un nouveau modèle sera créé dans les paramètres régionaux cible en utilisant ce modèle comme point de départ.',
                preview_modal_title: 'Aperçu du modèle',
                preview_note: "L'aperçu utilise des espaces réservés DSR-DEMO-0020 du cas de démonstration. La livraison réelle remplace les données de cas réelles.",
                preview_unavailable: "L'aperçu nécessite un cas existant. Joignez ce modèle à un dossier et utilisez l'action Brouillon de réponse sur la page de détail du dossier.",
                deactivate_confirm: 'Désactiver ce modèle ? Il continuera de s’appliquer aux affaires existantes qui y font référence.',
                toasts: {
                    created: 'Modèle créé',
                    updated: 'Modèle mis à jour',
                    deactivated: 'Modèle désactivé',
                    reactivated: 'Modèle réactivé',
                    cloned: 'Modèle cloné',
                    load_error: 'Échec du chargement des modèles',
                    save_error: "Échec de l'enregistrement du modèle",
                    clone_error: 'Échec du clonage du modèle',
                },
            },
        },
        organizations: {
            departments: {
                title: 'Départements',
                subtitle: 'Gérez les services qui acheminent les cas DSR, les tâches [[TOK_0]] et les workflows de conformité.',
                create_btn: 'Nouveau département',
                edit_btn: 'Modifier le département',
                columns: {
                    name: 'Nom',
                    description: 'Descriptif',
                    active_cases: 'Cas actifs',
                    members: 'Membres',
                    status: 'Statut',
                    actions: 'Actions',
                },
                status_active: 'Actif',
                status_inactive: 'Inactif',
                form: {
                    name: 'Nom',
                    description: 'Descriptif',
                },
                actions: {
                    edit: 'Modifier',
                    deactivate: 'Désactiver',
                    reactivate: 'Réactiver',
                    delete: 'Supprimer',
                    manage_members: 'Gérer les membres',
                },
                delete_modal_title: 'Supprimer un département',
                delete_warning: 'Ce département a encore des dossiers actifs. Choisissez un département auquel les réaffecter avant la suppression.',
                delete_no_cases: "Ce service n'a aucun cas actif et peut être supprimé en toute sécurité.",
                reassign_prompt: 'Réaffecter les dossiers actifs à :',
                reassign_none_available: "Aucun autre département actif disponible. Créez d'abord un autre département.",
                member_section_title: 'Membres',
                add_member: 'Ajouter un membre',
                remove_member: 'Supprimer',
                member_role: 'Rôle',
                no_members: 'Aucun membre mappé à ce département.',
                toasts: {
                    created: 'Département créé',
                    updated: 'Département mis à jour',
                    deactivated: 'Département désactivé',
                    reactivated: 'Département réactivé',
                    deleted: 'Département supprimé',
                    reassigned_count: '[[TOK_1]] dossier(s) réaffecté(s)',
                    member_added: 'Membre ajouté',
                    member_removed: 'Membre supprimé',
                    load_error: 'Échec du chargement des départements',
                    save_error: "Échec de l'enregistrement du département",
                    delete_error: 'Échec de la suppression du département',
                },
            },
            retention_policies: {
                title: 'Politiques de rétention',
                subtitle: "Configurez les fenêtres de rétention par type de cible. Les documents de vérification d'identité l'utilisent pour tamponner retention_expires_at sur les futurs téléchargements.",
                create_btn: 'Nouvelle politique',
                edit_btn: 'Modifier la politique',
                columns: {
                    target_type: 'Type de cible',
                    retention_days: 'Rétention (jours)',
                    owner: 'Propriétaire de la police',
                    effective_from: 'En vigueur à partir de',
                    last_reviewed: 'Dernière révision',
                    status: 'Statut',
                    actions: 'Actions',
                },
                status_active: 'Actif',
                status_inactive: 'Inactif',
                form: {
                    target_type: 'Type de cible',
                    target_type_help: "À quelle catégorie de données la fenêtre de conservation s'applique. Actuellement, seuls les documents de vérification d'identité DSR sont pris en charge.",
                    retention_days: 'Fenêtre de rétention (jours)',
                    retention_days_help: 'Entre 1 et 3650 jours (10 ans max).',
                    owner: 'Propriétaire de la police',
                    owner_help: 'Généralement le [[TOK_0]]. Responsable de la décision de conservation sous DG-2.',
                    effective_from: 'En vigueur à partir de',
                },
                target_types: {
                    dsr_identity_verification_document: "Documents de vérification d'identité DSR",
                },
                deactivate_notice: "La désactivation n'affecte pas les pièces jointes déjà tamponnées : seuls les futurs téléchargements ne recevront plus de fenêtre de conservation.",
                deactivate_confirm: 'Désactiver cette politique de rétention ?',
                toasts: {
                    created: 'Politique de rétention créée',
                    updated: 'Politique de rétention mise à jour',
                    deactivated: 'Politique de rétention désactivée',
                    load_error: 'Échec du chargement des stratégies de rétention',
                    save_error: "Échec de l'enregistrement de la stratégie de rétention",
                },
            },
        },
    },
    data_mapping: {
        nav: {
            systems: 'Systèmes',
            categories: 'Catégories de données',
            registry: 'Registre de données',
            purposes: 'Finalités du traitement',
            retention: 'Conservation',
            flows: 'Flux de données',
            activities: 'Activités de traitement',
            evidence: 'Preuves',
            exports: 'Exportations',
            attestation: "Cycles d'attestation",
            governance: 'Gouvernance',
            review: 'Tâches de révision',
            inventory: 'Inventaire',
            exceptions: 'Exceptions',
            history: 'Historique',
            ropa_completeness: 'Complétude ROPA',
        },
        ropa_completeness_autofix: {
            ask_button: 'Demandez à Forseti',
            drafting: 'Rédaction…',
            accept: 'Accepter',
            reject: 'Rejeter',
            accepted: "Accepté — postulez via l'éditeur d'activité.",
            rejected: 'Rejeté.',
            needs_human_input: "Forseti a besoin de plus de contexte d'activité (par exemple un objectif documenté) avant de rédiger ce champ.",
        },
        ropa_completeness: {
            title: "Rapport d'exhaustivité ROPA",
            subtitle: "Audit d'hygiène par domaine de vos enregistrements d'activités de traitement, limité par le cadre réglementaire.",
            framework_label: 'Cadre',
            kpi_total: 'Activités notées',
            kpi_critical: 'Critique',
            kpi_high: 'Élevé',
            kpi_conditional: 'Conditionnel',
            field_chart_heading: 'Champs manquants par fréquence',
            drilldown_heading: 'Activités avec des lacunes',
            col_activity: 'Activité',
            col_field: 'Champ',
            col_severity: 'Gravité',
            col_condition: 'État',
            col_action: 'Fix',
            action_fix: 'Fix',
            severity_critical: 'Critique',
            severity_high: 'Élevé',
            severity_conditional: 'Conditionnel',
            severity_informational: 'Informatif',
            include_informational: 'Inclure des informations (ISO 27701)',
            export_csv: 'Télécharger [[TOK_0]]',
            exporting: 'Exportation...',
            loading: 'Chargement…',
            empty_state: 'Toutes les activités actives ont des enregistrements ROPA complets pour ce cadre.',
            error_fetch: "Échec du chargement du rapport d'exhaustivité.",
            error_unsupported_framework: "Ce cadre n'est pas pris en charge.",
            error_framework_not_installed: "Ce framework n'est pas installé pour votre organisation.",
            no_misses_for_field: 'Aucune activité ne manque ce champ.',
            framework_PDPL: '[[TOK_0]] (Loi 91/2025 + Décret 356)',
            framework_GDPR: '[[TOK_0]] Article 30',
            framework_DECREE_165: 'Décret 165 (loi vietnamienne sur les données)',
            framework_ISO_27701: 'ISO 27701 (informatif)',
        },
        registry: {
            page: {
                title: 'Registre de données',
                subtitle: 'Éléments de données personnelles détenus par votre organisation, organisés en catégories de données.',
                empty_state: "Aucun élément de registre pour l'instant. Ajoutez un élément manuellement ou importez depuis un registre réglementaire.",
                empty_filter_state: 'Aucun article ne correspond à vos filtres.',
            },
            filter: {
                category: 'Catégorie',
                sensitivity: 'Sensibilité',
                data_subject: 'Personne concernée',
                status: 'Statut',
                data_tier: 'Niveau de données',
                cross_border: 'Transfrontalier',
                has_owner: 'A le propriétaire',
                has_form_source: 'Importé depuis le formulaire',
                search_placeholder: 'Rechercher un nom, une description ou un identifiant de champ…',
                clear: 'Effacer les filtres',
                option_all: 'Tout',
            },
            col: {
                name: 'Nom',
                category: 'Catégorie',
                sensitivity: 'Sensibilité',
                data_subjects: 'Personnes concernées',
                systems: 'Systèmes',
                activities: 'Activités',
                owner: 'Propriétaire',
                retention: 'Rétention',
                data_tier: 'Niveau de données',
                status: 'Statut',
                last_reviewed: 'Dernière révision',
                actions: 'Actions',
            },
            action: {
                add_manual: 'Ajouter un article',
                add_from_form: 'Ajouter à partir du registre réglementaire',
                import_history: 'Importer des soumissions antérieures',
                export: 'Exporter',
                archive: 'Archiver',
                restore: 'Restaurer',
                edit: 'Modifier',
                assign_owner: 'Attribuer un propriétaire',
                attach_evidence: 'Joindre des preuves',
                open_lineage: 'Lignée ouverte',
            },
            modal_editor: {
                section_identity: 'Identité',
                section_classification: 'Classement',
                section_subjects: 'Sujets et volumes',
                section_location: 'Localisation et transfert',
                section_systems: 'Systèmes et activités',
                section_retention: 'Rétention et mentions légales',
                section_governance: 'Gouvernance',
                section_notes: 'Remarques',
                hint_inherited: '(hérité de la catégorie)',
                hint_overridden: '(remplacé)',
                placeholder_field_identifiers: 'par exemple, clients.primary_email, hris.employee_id',
                validation_name_required: 'Le nom est requis',
                validation_category_required: 'La catégorie est obligatoire',
                validation_data_subjects_required: 'Au moins un type de personne concernée est requis',
                label_data_type: 'Type de données',
                label_field_identifiers: 'Identifiants de champ (séparés par des virgules)',
                label_data_subject_types: 'Types de personnes concernées',
                label_volume_band: 'Bande de volume',
                label_storage_locations: 'Emplacements de stockage (séparés par des virgules)',
                placeholder_storage_locations: 'Codes ISO-3166 ou texte libre (par exemple, VN, Hetzner EU)',
                label_cross_border: 'Virement transfrontalier',
                label_source_systems: 'Systèmes sources',
                label_processing_activities: 'Activités de traitement',
                label_collection_method: 'Méthode de collecte',
                label_legal_basis: 'Base juridique',
                label_purposes: 'Objectifs',
                hint_multi_select: 'Maintenez Cmd/Ctrl pour en sélectionner plusieurs.',
                option_inherit_category: '— (hériter de la catégorie)',
                option_dash: '—',
            },
            modal_import: {
                dry_run_heading: "Aperçu de l'importation",
                label_to_create: 'Pour créer',
                label_to_update: 'Pour mettre à jour',
                label_skipped_archived: 'Sauté (archivé)',
                label_conflicts: 'Conflits',
                commit: 'Importer',
                cancel: 'Annuler',
                conflict_row: '[[TOK_3]] — conserver votre modification ([[TOK_4]]) ; mappeur recherché [[TOK_5]].',
            },
            drawer: {
                section_category: 'Catégorie',
                section_systems: 'Systèmes sources',
                section_activities: 'Activités de traitement',
                section_flows: 'Flux de données',
                section_retention: 'Rétention efficace',
                section_governance: 'Gouvernance',
                section_evidence: 'Preuve',
                section_audit: 'Piste d’audit récente',
                section_source_form: 'Soumission du formulaire source',
                badge_inherited: 'Hérité',
                badge_overridden: 'Remplacé',
            },
            toast: {
                created: 'Élément de registre créé.',
                updated: 'Élément de registre mis à jour.',
                archived: 'Élément de registre archivé.',
                imported: '[[TOK_1]] éléments importés.',
                conflict_warning: 'Les [[TOK_1]] champ(s) ont conservé vos modifications — voir la liste des conflits.',
            },
        },
        systems: {
            title: 'Inventaire des systèmes',
            new: 'Nouveau système',
            edit: 'Modifier le système',
            name: 'Nom',
            owner: 'Responsable',
            criticality: 'Criticité',
            dpa_status: 'Statut DPA',
            location: 'Localisation',
            system_type: 'Type de système',
            metadata: 'Métadonnées (JSON)',
            department: 'Département',
            hosting_location: "Lieu d'hébergement",
            hosting_provider: "Fournisseur d'hébergement",
            data_residency_country: 'Pays de résidence des données',
            hosting: 'Hébergement',
            no_systems: 'Aucun système trouvé',
            confirm_archive: 'Archiver le système « {name} » ?',
            count: 'systèmes',
            count_one: 'système',
            type_internal: 'Interne',
            type_external: 'Externe',
            type_cloud_service: 'Service cloud',
            type_on_premise: 'Sur site',
            type_hybrid: 'Hybride',
            status_active: 'Actif',
            status_decommissioning: 'En cours de retrait',
            status_decommissioned: 'Retiré',
            status_planned: 'Planifié',
            dpa_not_required: 'Non requis',
            dpa_required_missing: 'Requis manquant',
            dpa_in_progress: 'En cours',
            dpa_signed: 'Signé',
            all_criticalities: 'Toutes les criticités',
        },
        categories: {
            title: 'Catégories de données',
            new: 'Nouvelle catégorie',
            edit: 'Modifier la catégorie',
            name: 'Nom',
            sensitivity: 'Sensibilité',
            tags: 'Étiquettes',
            used_in: 'Utilisée dans',
            examples: 'Exemples',
            examples_hint: 'Exemples (séparés par des virgules)',
            default: 'Par défaut',
            all_sensitivities: 'Toutes les sensibilités',
            all_statuses: 'Tous les statuts',
            no_categories: 'Aucune catégorie trouvée',
            confirm_delete: 'Supprimer la catégorie « {name} » ?',
            count: 'catégories',
            count_one: 'catégorie',
            status_draft: 'Brouillon',
            status_proposed: 'Proposé',
            status_under_review: 'En révision',
            status_approved: 'Approuvé',
            status_deprecated: 'Obsolète',
            status_updated: 'Statut de catégorie mis à jour',
            propose: 'Proposer',
            approve: 'Approuver',
            deprecate: 'Rendre obsolète',
        },
        purposes: {
            title: 'Finalités de traitement',
            new: 'Nouvelle finalité',
            edit: 'Modifier la finalité',
            name: 'Nom',
            legal_basis: 'Base juridique',
            retention_period: 'Durée de conservation (jours)',
            justification: "Justification de l'intérêt légitime",
            legal_basis_detail: 'Détail de la base juridique',
            all_legal_bases: 'Toutes les bases juridiques',
            no_purposes: 'Aucune finalité trouvée',
            confirm_delete: 'Supprimer « {name} » ?',
            default: 'Par défaut',
            count: '{count} finalités',
            count_one: '{count} finalité',
            basis_consent: 'Consentement',
            basis_contract: 'Contrat',
            basis_legal_obligation: 'Obligation Légale',
            basis_vital_interest: 'Intérêt Vital',
            basis_public_interest: 'Intérêt Public',
            basis_legitimate_interest: 'Intérêt Légitime',
        },
        retention: {
            title: 'Politiques de conservation',
            new: 'Nouvelle politique',
            edit: 'Modifier la politique',
            name: 'Nom',
            retention_days: 'Jours de conservation',
            disposal_method: "Méthode d'élimination",
            data_categories: 'Catégories de données',
            activities: 'Activités',
            review_frequency: 'Fréquence de révision',
            review_frequency_days: 'Fréquence de révision (jours)',
            no_policies: 'Aucune politique de conservation trouvée',
            confirm_delete: 'Supprimer « {name} » ?',
            count: '{count} politiques',
            count_one: '{count} politique',
            days: 'jours',
            disposal_deletion: 'Suppression',
            disposal_anonymization: 'Anonymisation',
            disposal_archival: 'Archivage',
            review_overdue: 'Révision en retard',
            review_status: 'Statut de révision',
            review_ok: 'En bonne voie',
            department: 'Département',
            all_departments: 'Tous les départements',
        },
        flows: {
            view_tabs_aria: 'Vue des flux',
            view_list: 'Liste',
            view_map: 'Carte',
            title: 'Flux de données',
            new: 'Nouveau flux',
            edit: 'Modifier le flux',
            name: 'Nom',
            from_system: 'Système source',
            to_system: 'Système destinataire',
            flow_type: 'Type de flux',
            cross_border: 'Transfrontalier',
            risk_level: 'Niveau de risque',
            mechanism: 'Mécanisme',
            transfer_mechanism: 'Mécanisme de transfert',
            frequency: 'Fréquence',
            source_country: "Pays d'origine",
            destination_country: 'Pays de destination',
            transfer_safeguard: 'Garantie de transfert',
            all_risk_levels: 'Tous les niveaux de risque',
            no_flows: 'Aucun flux de données trouvé',
            confirm_archive: 'Archiver « {name} » ?',
            count: '{count} flux',
            count_one: '{count} flux',
            status_active: 'Actif',
            status_inactive: 'Inactif',
            status_under_review: 'En cours de révision',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Transfert de fichiers',
            mechanism_database_replication: 'Réplication de base de données',
            mechanism_manual: 'Manuel',
            mechanism_email: 'E-mail',
            mechanism_other: 'Autre',
            frequency_real_time: 'Temps réel',
            frequency_hourly: 'Horaire',
            frequency_daily: 'Quotidien',
            frequency_weekly: 'Hebdomadaire',
            frequency_monthly: 'Mensuel',
            frequency_on_demand: 'À la demande',
            frequency_one_time: 'Ponctuel',
            safeguard_adequacy_decision: "Décision d'adéquation",
            safeguard_standard_contractual_clauses: 'Clauses contractuelles types',
            safeguard_binding_corporate_rules: "Règles d'entreprise contraignantes",
            safeguard_explicit_consent: 'Consentement explicite',
            safeguard_legal_obligation: 'Obligation légale',
            safeguard_none: 'Aucune',
            safeguard_other: 'Autre',
        },
        activities: {
            title: 'Activités de traitement',
            new: 'Nouvelle activité',
            edit: "Modifier l'activité",
            activity_title: 'Titre',
            category: 'Catégorie',
            legal_basis: 'Base juridique',
            dpa_required: 'DPA requis',
            ropa_generated: 'Registre généré',
            version: 'Révision',
            generate_ropa: 'Générer le registre',
            controller: 'Responsable du traitement',
            controller_name: 'Nom du responsable du traitement',
            controller_contact: 'Contact du responsable du traitement',
            legal_basis_detail: 'Détail de la base juridique',
            organization_info: "Informations sur l'organisation (Annexe I)",
            org_address: "Adresse de l'organisation",
            tax_code: 'Code fiscal',
            contact_person: 'Personne de contact',
            contact_email: 'Email de contact',
            contact_phone: 'Téléphone de contact',
            select_entity: 'Sélectionnez…',
            no_entities: 'Aucun article trouvé',
            dpo_name: 'Nom du DPO',
            dpo_contact: 'Contact du DPO',
            processor_name: 'Nom du sous-traitant',
            processor_contact: 'Contact du sous-traitant',
            data_subjects: 'Personnes concernées',
            data_subjects_hint: 'Personnes concernées (séparées par des virgules)',
            recipients: 'Destinataires',
            recipients_hint: 'Destinataires (séparés par des virgules)',
            security_measures: 'Mesures de sécurité',
            dpia_reference: 'Référence AIPD',
            no_activities: 'Aucune activité de traitement trouvée',
            confirm_archive: 'Archiver « {name} » ?',
            count: '{count} activités',
            count_one: '{count} activité',
            ropa_success: 'Enregistrement RoPA généré. Accédez aux Exports pour le télécharger.',
            ropa_error: 'Échec de la génération du registre',
            required_label: 'Requis',
            status_draft: 'Brouillon',
            status_active: 'Actif',
            status_under_review: 'En cours de révision',
            status_archived: 'Archivé',
            decree_165_heading: 'Niveau de données du décret 165 (loi vietnamienne sur les données)',
            decree_165_helper: 'Classifier les données traitées par cette activité en vertu du décret vietnamien 165. Les données régulières correspondent au régime transfrontalier de référence ; les données importantes et essentielles entraînent des obligations supplémentaires.',
            data_tier_label: 'Niveau de données',
            data_tier_help: "Le décret 165 classe les données comme régulières, importantes ou essentielles. Consultez l'article d'aide pour obtenir des conseils.",
            data_tier_column_header: 'Niveau de données',
            data_tier_regular: 'Régulier',
            data_tier_important: 'Important',
            data_tier_core: 'Noyau',
            transfer_mechanism_label: 'Mécanisme de transfert transfrontalier',
            transfer_mechanism_placeholder: "par ex. Clauses contractuelles types, décision d'adéquation",
            security_assessment_reference_label: "Référence d'évaluation de sécurité",
            security_assessment_reference_placeholder: 'par ex. [[TOK_0]]-SA-2026-001',
        },
        evidence: {
            title: 'Coffre-fort de preuves',
            new: 'Nouvelle preuve',
            edit: 'Modifier la preuve',
            name: 'Nom',
            evidence_type: 'Type de preuve',
            linked_entities: 'Entités liées',
            uploaded: 'Téléversé',
            expiry: 'Expiration',
            file_url: 'URL du fichier',
            source_mode_label: 'Source de la preuve',
            source_mode_file: 'Téléverser un fichier',
            source_mode_url: 'Lier une URL externe',
            attachment_label: 'Pièce jointe',
            link_to: 'Lier la preuve à',
            entity_type: "Type d'entité",
            entity_id: "Identifiant de l'entité",
            no_evidence: 'Aucun élément de preuve trouvé',
            manage_links: 'Gérer les liens',
            unlink: 'Dissocier',
            confirm_delete: 'Supprimer la preuve « {name} » ?',
            count: '{count} éléments',
            count_one: '{count} élément',
            type_document: 'Pièce jointe',
            type_screenshot: "Capture d'écran",
            type_policy: 'Politique',
            type_contract: 'Contrat',
            type_assessment: 'Évaluation',
            type_correspondence: 'Correspondance',
            type_other: 'Autre',
            linked_type_system: 'Système',
            linked_type_data_flow: 'Flux de données',
            linked_type_processing_activity: 'Activité de traitement',
            linked_type_data_category: 'Catégorie de données',
            linked_type_purpose: 'Objectif',
            linked_type_retention_policy: 'Politique de conservation',
            link_entity: "Lien vers l'entité",
            link_success: 'Entité liée avec succès',
            confirm_unlink: 'Êtes-vous sûr de vouloir dissocier cette entité ?',
            unlink_success: 'Entité dissociée avec succès',
            no_linked_entities: 'Aucune entité liée',
            select_entity: 'Sélectionnez…',
            no_entities: 'Aucun article',
        },
        exports: {
            title: 'Exports de données',
            recent: 'Exports récents',
            export_type: "Type d'export",
            format: 'Formater',
            requested_by: 'Demandé par',
            requested_at: 'Demandé le',
            download: 'Télécharger',
            csv_export: 'Exporter CSV',
            csv_description: 'Télécharger les données au format CSV pour analyse dans un tableur.',
            pdf_reports: 'Rapports PDF',
            pdf_description: 'Générer des rapports formatés pour la documentation de conformité.',
            csv_systems: 'Inventaire des systèmes',
            csv_categories: 'Catégories de données',
            csv_flows: 'Flux de données',
            csv_activities: 'Activités de traitement',
            csv_cross_border: 'Flux transfrontaliers',
            csv_retention_policies: 'Politiques de rétention',
            csv_evidence: 'Éléments de preuve',
            csv_governance_assignments: 'Missions de gouvernance',
            pdf_ropa: 'Registre des activités de traitement',
            pdf_systems: 'Rapport des systèmes',
            pdf_cross_border: 'Rapport transfrontalier',
            pdf_flow_map: 'Cartographie des flux',
            export_failed: "Échec de l'export",
            pdf_generated: 'PDF généré avec succès.',
            ropa: 'Registre RoPA',
            retention_policies: 'Politiques de rétention',
            governance_assignments: 'Missions de gouvernance',
            col_entity: "Entité d'exportation",
            col_description: 'Descriptif',
            desc_ropa: 'Registre ROPA complet de toutes les activités de traitement avec base juridique, statut [[TOK_0]] et contrôles.',
            desc_systems: 'Inventaire des systèmes avec propriétaire, balises de catégorie de données et état de conformité.',
            desc_activities: 'Activités de traitement individuelles avec responsable du traitement, base juridique et classification [[TOK_0]]',
            desc_categories: 'Catégories de données et niveaux de sensibilité utilisés dans la classification et les audits.',
            desc_purposes: 'Finalités du traitement avec citations de base légale conformément au décret 13/2023 et à la loi sur les télécommunications 2023.',
            desc_flows: 'Flux de données entre les systèmes, y compris les itinéraires internes et transfrontaliers.',
            desc_cross_border: 'Flux transfrontaliers uniquement, avec mécanisme de transfert et évaluation des risques.',
            desc_retention_policies: 'Politiques de conservation, méthodes d’élimination et cadence de révision.',
            desc_evidence: 'Preuves attachées aux activités de traitement : certificats, contrats DPA, rapports [[TOK_0]]',
            desc_governance_assignments: 'Missions de gouvernance : propriétaires, approbateurs et références ISO 27001.',
            unified_heading: 'Exporter des entités',
            unified_description: "Exportez n'importe quelle entité de mappage de données au format [[TOK_0]], [[TOK_3]], [[TOK_2]] ou [[TOK_1]]. Toutes les exportations sont enregistrées dans le navigateur de fichiers.",
            export_button_label: 'Exporter',
            csv_download_success: 'CSV téléchargé avec succès.',
        },
        attestation: {
            title: "Cycles d'Attestation",
            create: 'Nouveau Cycle',
            name: 'Nom du Cycle',
            year: 'Année',
            deadline: 'Date Limite',
            scope: 'Portée',
            status: 'Statut',
            tasks: 'Tâches du Département',
            assign_tasks: 'Attribuer des Tâches',
            department: 'Département',
            assignee: 'Assigné',
            progress: 'Progression',
            stale_entries: 'Entrées Obsolètes',
            detect_stale: 'Détecter Obsolètes',
            export_bundle: 'Exporter le Paquet',
            no_cycles: "Pas encore de cycles d'attestation.",
            create_success: "Cycle d'attestation créé.",
            assign_success: 'Tâches attribuées avec succès.',
            complete_success: 'Tâche terminée.',
            stale_detected: 'Entrées obsolètes détectées.',
            stale_systems: 'Systèmes obsolètes',
            stale_flows: 'Flux obsolètes',
            no_stale: 'Aucune entrée obsolète détectée.',
            stale_name: 'Nom',
            stale_announcement: '{0} systèmes obsolètes et {1} flux obsolètes trouvés',
            last_updated: 'Dernière mise à jour',
            status_draft: 'Brouillon',
            status_active: 'Actif',
            status_completed: 'Terminé',
            task_status_pending: 'En attente',
            task_status_in_progress: 'En cours',
            task_status_completed: 'Terminé',
            scope_systems: 'Systèmes',
            scope_flows: 'Flux de données',
            scope_activities: 'Activités',
            scope_categories: 'Catégories',
            scope_purposes: 'Finalités',
            scope_retention: 'Conservation',
        },
        governance: {
            title: 'Attributions de Gouvernance',
            assign: 'Attribuer la Propriété',
            entity_type: "Type d'Entité",
            entity: 'Entité',
            role: 'Rôle',
            assigned_by: 'Attribué par',
            assigned_at: 'Attribué le',
            remove: 'Supprimer',
            no_assignments: 'Aucune attribution de gouvernance.',
            assign_success: 'Propriété attribuée.',
            remove_success: 'Attribution supprimée.',
            assignee: 'Attributaire',
            department: 'Département',
            all_departments: 'Tous les départements',
            roles: {
                data_owner: 'Propriétaire des Données',
                data_steward: 'Gestionnaire des Données',
                data_custodian: 'Gardien des Données',
                informed: 'Informé',
            },
            entity_types: {
                system: 'Système',
                flow: 'Flux de données',
                activity: 'Activité',
                category: 'Catégorie',
                purpose: 'Finalité',
                retention_policy: 'Politique de conservation',
            },
        },
        risk_assessment: {
            title: 'Évaluation des Risques',
            create: 'Nouvelle Évaluation',
            safeguard_type: 'Type de Garantie',
            adequacy_status: "Statut d'Adéquation",
            risk_factors: 'Facteurs de Risque',
            mitigations: "Mesures d'Atténuation",
            reviewer: 'Réviseur',
            decision: 'Décision',
            approve: 'Approuver',
            reject: 'Rejeter',
            no_assessments: 'Aucune évaluation des risques.',
            create_success: 'Évaluation des risques créée.',
            approve_success: 'Évaluation approuvée.',
            reject_success: 'Évaluation rejetée.',
            one_per_line: 'Un par ligne',
            safeguard_adequacy_decision: "Décision d'adéquation",
            safeguard_standard_contractual_clauses: 'Clauses contractuelles types',
            safeguard_binding_corporate_rules: "Règles d'entreprise contraignantes",
            safeguard_explicit_consent: 'Consentement explicite',
            safeguard_legal_obligation: 'Obligation légale',
            safeguard_none: 'Aucune',
            safeguard_other: 'Autre',
            adequacy_adequate: 'Adéquat',
            adequacy_inadequate: 'Inadéquat',
            adequacy_under_review: 'En cours de révision',
            adequacy_not_assessed: 'Non évalué',
            decision_approved: 'Approuvé',
            decision_rejected: 'Rejeté',
        },
        review: {
            title: 'Tâches de révision',
            description: "Les tâches de révision sont créées automatiquement lorsqu'une catégorie de données est proposée. Pour créer une nouvelle tâche, accédez aux Catégories de données et cliquez sur Proposer sur une catégorie brouillon.",
            count: 'tâches de révision',
            summary: 'Résumé des révisions',
            pending: 'En attente',
            resolved_today: "Résolues aujourd'hui",
            escalated: 'Escaladées',
            overdue: 'En retard (>5 jours)',
            all_statuses: 'Tous les statuts',
            status_pending: 'En attente',
            status_resolved: 'Résolu',
            status_escalated: 'Escaladé',
            category_name: 'Catégorie',
            system_name: 'Système',
            owner: 'Responsable',
            resolve: 'Résoudre',
            resolve_task: 'Résoudre la tâche de révision',
            resolution: 'Résolution',
            resolution_approve: 'Approuver',
            resolution_modify: 'Modifier et approuver',
            resolution_reject: 'Rejeter',
            resolution_escalate: 'Escalader',
            notes: 'Notes de résolution',
            notes_required: 'Notes obligatoires (minimum 10 caractères) pour Modifier, Rejeter ou Escalader',
            resolved_success: 'Tâche de révision résolue',
            bulk_approve: 'Approbation groupée',
            bulk_reject: 'Rejet groupé',
            bulk_success: '{count} tâches traitées',
            no_tasks: 'Aucune tâche de révision trouvée',
        },
        inventory: {
            title: 'Inventaire de classification',
            count: 'systèmes',
            summary: "Résumé de l'inventaire",
            total_systems: 'Total des systèmes',
            total_labels: 'Total des étiquettes',
            system_name: 'Système',
            label_count: 'Étiquettes',
            approved_count: 'Approuvés',
            pending_count: 'En attente',
            no_items: "Aucun élément d'inventaire trouvé",
        },
        exceptions: {
            title: 'Exceptions de classification',
            count: 'exceptions',
            all_severities: 'Toutes les sévérités',
            all_statuses: 'Tous les statuts',
            system_name: 'Système',
            severity_label: 'Sévérité',
            status_open: 'Ouverte',
            status_resolved: 'Résolue',
            status_accepted_risk: 'Risque accepté',
            resolve: 'Résoudre',
            resolve_exception: "Résoudre l'exception",
            resolution_type: 'Type de résolution',
            notes: 'Remarques',
            justification_required: 'Justification obligatoire (minimum 10 caractères) pour risque accepté',
            resolved_success: 'Exception résolue',
            no_exceptions: 'Aucune exception trouvée',
        },
        history: {
            title: 'Historique de classification',
            count: 'événements',
            actor: 'Acteur',
            action: 'Action',
            entity_type: "Type d'entité",
            changes: 'Modifications',
            view_lineage: 'Voir la lignée',
            lineage_title: 'Lignée de classification',
            no_events: "Aucun événement d'historique trouvé",
            no_lineage: 'Aucune donnée de lignée disponible',
            modified: 'Modifié',
            created: 'Créé',
            removed: 'Supprimé',
            action_created: 'Créé',
            action_updated: 'Mis à jour',
            action_archived: 'Archivé',
            action_approved: 'Approuvé',
            action_deprecated: 'Obsolète',
            entity_label: 'Étiquette',
            entity_taxonomy: 'Taxonomie',
            entity_review_task: 'Tâche de révision',
            entity_exception: 'Exception',
            before: 'Avant',
            after: 'Après',
        },
    },
    governance: {
        audit_trail_title: "Piste d'audit de la gouvernance",
        audit_trail_subtitle: "Flux d'audit inter-entités pour les actions de gouvernance : approbations, exécutions de playbook, liaisons de preuves, etc.",
        audit_trail_item_count: "événements d'audit",
        audit_trail_fetch_error: "Impossible de récupérer les événements d'audit.",
        audit_trail_no_events: "Aucun événement d'audit trouvé avec les filtres actuels.",
        audit_trail_entity_type: "Type d'entité",
        audit_trail_entity_id: "ID d'entité",
        audit_trail_action: 'Action',
        audit_trail_actor: 'Acteur',
        audit_trail_timestamp: 'Horodatage',
        audit_trail_date_from: 'Du',
        audit_trail_date_to: 'Au',
        audit_trail_no_rows_to_export: 'Aucune ligne à exporter.',
        nav: {
            vendors: 'Prestataires',
            subprocessors: 'Sous-traitants',
            cross_border: 'Transfrontalier',
            drift: 'Surveillance des écarts',
            scores: 'Score de conformité',
            playbooks: 'Guides opérationnels',
            approvals: 'Approbations',
            audit_trail: "Piste d'audit",
            board_report: "Rapport d'administration",
            evidence: 'Preuves',
            onboarding: "Pipeline d'intégration",
            dpa_reviews: 'Revues DPA',
            periodic_reviews: 'Revues périodiques',
            offboarding: 'Désinscription',
        },
        vendors: {
            title: 'Registre des prestataires',
            new: 'Nouveau prestataire',
            edit: 'Modifier le prestataire',
            name: 'Nom',
            jurisdiction: 'Juridiction',
            dpa_status: 'Statut DPA',
            risk_level: 'Niveau de risque',
            onboarding_status: "Statut d'intégration",
            contact_email: 'E-mail de contact',
            contact_name: 'Nom du contact',
            contact_phone: 'Téléphone de contact',
            website: 'Site web',
            services_csv: 'Services (séparés par des virgules)',
            country: 'Pays',
            country_placeholder: 'ex. VN',
            last_reviewed: 'Dernière révision',
            offboard: 'Résilier',
            offboard_vendor: 'Résilier le prestataire',
            offboard_reason: 'Motif de résiliation',
            no_vendors: 'Aucun prestataire trouvé',
            vendor_count: '{count} prestataire(s)',
            all_dpa_status: 'Tous les statuts DPA',
            all_risk_levels: 'Tous les niveaux de risque',
            all_onboarding: "Tous les statuts d'intégration",
            fetch_error: 'Échec. Veuillez réessayer.',
            save_error: 'Échec de la sauvegarde du prestataire',
            offboard_error: 'Échec de la résiliation',
        },
        vendor_types: {
            processor: 'Sous-traitant',
            sub_processor: 'Sous-traitant Ultérieur',
            controller: 'Responsable du Traitement',
            joint_controller: 'Responsables Conjoints',
        },
        onboarding_statuses: {
            pending_review: 'En Attente de Révision',
            approved: 'Approuvé',
            active: 'Actif',
            suspended: 'Suspendu',
            offboarded: 'Résilié',
        },
        dpa_statuses: {
            not_required: 'Non Requis',
            required_missing: 'Requis Manquant',
            draft: 'Brouillon',
            under_review: 'En Cours de Révision',
            signed: 'Signé',
            expired: 'Expiré',
        },
        risk_levels: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
        },
        approval_statuses: {
            pending: 'En Attente',
            approved: 'Approuvé',
            rejected: 'Rejeté',
            expired: 'Expiré',
        },
        approval_action_types: {
            vendor_onboarding: 'Intégration Fournisseur',
            vendor_offboarding: 'Résiliation Fournisseur',
            cross_border_acceptance: 'Approbation Transfrontalière',
            playbook_activation: 'Activation du Playbook',
            drift_accept_risk: 'Dérive Risque Accepté',
            activity_activation: "Activation d'Activité",
        },
        drift_check_types: {
            dpa_expiry: 'Expiration du DPA',
            dpa_missing: 'DPA Manquant',
            review_overdue: 'Révision en Retard',
            cross_border_gap: 'Écart Transfrontalier',
            sub_processor_chain: 'Chaîne de Sous-traitants',
            risk_assessment_overdue: 'Évaluation des Risques en Retard',
            retention_policy_missing: 'Politique de Conservation Manquante',
            evidence_expiring: 'Preuve Expirant',
        },
        drift_statuses: {
            open: 'Ouvert',
            acknowledged: 'Confirmé',
            in_progress: 'En Cours',
            resolved: 'Résolu',
            accepted_risk: 'Risque Accepté',
        },
        drift_entity_types: {
            vendor: 'Fournisseur',
            system: 'Système',
            data_flow: 'Flux de Données',
            processing_activity: 'Activité de Traitement',
            evidence_item: 'Élément de Preuve',
        },
        playbook_statuses: {
            draft: 'Brouillon',
            active: 'Actif',
            archived: 'Archivé',
        },
        playbook_action_types: {
            delete_data: 'Supprimer les Données',
            verify_deletion: 'Vérifier la Suppression',
            notify_vendor: 'Notifier le Fournisseur',
            confirm_receipt: 'Confirmer la Réception',
            document_evidence: 'Documenter',
            other: 'Autre',
        },
        playbook_target_types: {
            system: 'Système',
            vendor: 'Fournisseur',
        },
        dpa_chain_statuses: {
            complete: 'Complet',
            incomplete: 'Incomplet',
            unknown: 'Inconnu',
        },
        sub_processor_statuses: {
            active: 'Actif',
            terminated: 'Résilié',
        },
        evidence_types: {
            dpa_agreement: 'Accord DPA',
            risk_assessment: 'Évaluation des Risques',
            audit_report: "Rapport d'Audit",
            certification: 'Accréditation',
            deletion_confirmation: 'Confirmation de Suppression',
            training_record: 'Registre de Formation',
            incident_report: "Rapport d'Incident",
            document: 'Pièce jointe',
            screenshot: "Capture d'Écran",
            policy: 'Politique',
            contract: 'Contrat',
            assessment: 'Évaluation',
            correspondence: 'Correspondance',
            other: 'Autre',
        },
        linkable_entity_types: {
            vendor: 'Fournisseur',
            transfer_mechanism: 'Mécanisme de Transfert',
            playbook: 'Livre de procédures',
            execution: 'Exécution',
            system: 'Système',
            activity: 'Activité',
        },
        subprocessors: {
            title: 'Relations avec les sous-traitants',
            new: 'Nouveau lien',
            vendor: 'Prestataire',
            subprocessor: 'Sous-traitant',
            relationship_type: 'Type de relation',
            countries: 'Pays',
            countries_csv: 'Pays (séparés par des virgules)',
            dpa_chain: 'Chaîne DPA',
            dpa_chain_status: 'Statut de la chaîne DPA',
            no_processors: 'Aucun sous-traitant trouvé.',
            no_subprocessors: 'Aucun sous-traitant ultérieur trouvé.',
            processor_vendor: 'Prestataire sous-traitant',
            select_processor: 'Sélectionner le sous-traitant',
            select_vendor: 'Sélectionner le prestataire',
            services: 'Prestations',
            sub_processor_vendor_id: 'ID du sous-traitant ultérieur',
            terminate: 'Résilier',
            confirm_terminate: 'Êtes-vous sûr de vouloir résilier cette relation ?',
            create_error: 'Échec de la création du lien.',
            fetch_error: 'Échec de la récupération des sous-traitants.',
            processor: 'Sous-traitant',
            services_csv: 'Services (séparés par des virgules)',
            terminate_error: 'Échec de la résiliation.',
            version_history_heading: 'Gestion des versions modifiées par le sous-traitant',
            change_tracking_note: "Toutes les modifications apportées à la relation entre les sous-traitants sont versionnées. Chaque modification enregistre l'état avant/après pour la piste d'audit.",
            history_retention_note: "L'historique des modifications est conservé pendant toute la période de conservation des données. Consultez les journaux de modifications via la vue détaillée du fournisseur.",
            vendor_risk_cross_view_heading: 'Registre des sous-traitants (Vendor Risk)',
            vendor_risk_cross_view_source: 'Source : Vendor Risk Register',
            vendor_risk_cross_view_empty: 'Aucune entrée dans le registre Vendor Risk.',
        },
        cross_border: {
            title: 'Rapport de gouvernance transfrontalière',
            flows: 'Flux transfrontaliers',
            transfers: 'Transferts transfrontaliers',
            detected_gaps: 'Écarts détectés',
            safeguards: 'Garanties',
            cross_border_vendors: 'Prestataires transfrontaliers',
            destination: 'Lieu de destination',
            no_cross_border_vendors: 'Aucun prestataire transfrontalier trouvé.',
            no_safeguard: 'Aucune garantie',
            processing_locations: 'Lieux de traitement',
            export_error: "Échec de l'export du rapport.",
            export_pdf: 'Exporter en PDF',
            export_success: 'Rapport exporté avec succès.',
            exporting: 'Export en cours...',
            fetch_error: 'Échec de la récupération des données transfrontalières.',
            source: 'Provenance',
            pdpl_p2_heading: '[[TOK_0]]-P2 Conformité aux transferts transfrontaliers',
            dossier_prep_note: "Préparation du dossier : rassemblez l'analyse d'impact, la base juridique et la documentation de sauvegarde avant le dépôt.",
            filing_tracking_note: "Suivi du dépôt : surveillez l'état de la soumission auprès de l'Autorité (PDPC) depuis la demande initiale jusqu'à l'approbation.",
            supplement_loop_note: "Boucle de complément : répondre aux demandes d'informations de l'Autorité et soumettre à nouveau les dossiers modifiés si nécessaire.",
            official_forms_note: "Formulaires officiels : utilisez Mau so 01a (Application), Mau so 01b (Informations supplémentaires) et Mau so 09 (Évaluation de l'impact du transfert) conformément aux règlements [[TOK_0]]-P2.",
            vendor_search_label: 'Recherche de fournisseur',
            vendor_search_placeholder: 'Rechercher par nom de fournisseur…',
            jurisdiction_filter_label: 'Juridiction',
            filings_section_heading: 'Dépôts transfrontaliers',
            filings_empty: "Aucun dépôt pour l'instant. Créez-en un pour démarrer un dossier.",
            filings_create_button: 'Nouveau dépôt',
            filings_table_id: 'Identifiant de dépôt',
            filings_table_jurisdiction: 'Juridiction',
            filings_table_type: 'Type de formulaire',
            filings_table_status: 'Statut',
            filings_table_updated: 'Mis à jour',
            filings_table_open: 'Ouvert',
            filings_detail_title: 'Dépôt transfrontalier',
            filings_back_to_list: 'Retour à Transfrontalier',
            filings_status_heading: 'Cycle de vie',
            filings_evidence_heading: 'Preuve',
            filings_history_heading: "Piste d'audit",
            filings_field_filing_id: 'Identifiant de dépôt',
            filings_field_jurisdiction: 'Juridiction',
            filings_field_type: 'Type de formulaire',
            filings_field_status: 'Statut',
            filings_field_reference: "Référence d'autorité",
            filings_field_mps_receipt: '[[TOK_0]] reçu',
            filings_field_submitted_at: 'Soumis à',
            filings_field_acknowledged_at: 'Reconnu à',
            filings_field_archived_at: 'Archivé à',
            filings_field_version: 'Version',
            filings_field_notes: 'Remarques',
            filings_action_advance: 'Statut avancé',
            filings_action_reject: 'Rejeter',
            filings_action_archive: 'Archiver',
            filings_action_submit: 'Marquer soumis',
            filings_action_acknowledge: 'Mark a reconnu',
            filings_action_resume_draft: 'Reprendre comme brouillon',
            filings_status_draft: 'Brouillon',
            filings_status_assessed: 'Évalué',
            filings_status_pending_review: "En attente d'examen",
            filings_status_ready_to_file: 'Prêt à déposer',
            filings_status_submitted: 'Soumis',
            filings_status_acknowledged: 'Reconnu',
            filings_status_rejected: 'Rejeté',
            filings_status_archived: 'Archivé',
            filings_type_mau_01a: 'Mẫu 01a — Demande de transfert',
            filings_type_mau_03a: 'Mẫu 03a — Supplément dossier',
            filings_type_mau_09: "Mẫu 09 — Évaluation de l'impact du transfert",
            filings_new_dialog_title: 'Nouveau dépôt transfrontalier',
            filings_new_form_jurisdiction: 'Juridiction (par exemple, VN-[[TOK_0]])',
            filings_new_form_type: 'Type de formulaire',
            filings_new_form_notes: 'Remarques (facultatif)',
            filings_new_submit: 'Créer',
            filings_new_cancel: 'Annuler',
            filings_reason_label: 'Raison',
            filings_reference_label: "Numéro de référence de l'autorité",
            filings_mps_receipt_label: '[[TOK_0]] référence du reçu',
            filings_create_error: 'Échec de la création du dossier.',
            filings_create_success: 'Dossier créé.',
            filings_update_error: 'Échec de la mise à jour du dossier.',
            filings_update_success: 'Dossier mis à jour.',
            filings_fetch_error: 'Échec de la récupération des dossiers.',
            filings_archive_confirm: 'Archiver ce dossier ? Cela ne peut pas être annulé.',
            filings_status_rejected_detour: 'Le dépôt a été rejeté après examen. Reprendre en tant que brouillon pour redémarrer le flux.',
            recent_exports_heading: 'Exportations récentes',
            recent_exports_empty: 'Aucune exportation pour l\'instant. Cliquez sur "Exporter [[TOK_0]]" pour en générer un.',
        },
        drift: {
            title: 'Surveillance des écarts de configuration',
            drift_type: "Type d'écart",
            severity: 'Gravité',
            detected_at: 'Détecté le',
            resolve: 'Résoudre',
            all_check_types: 'Tous les types de vérification',
            all_entity_types: "Tous les types d'entité",
            event_count: "Nombre d'événements",
            accept_risk: 'Accepter le risque',
            acknowledge: 'Confirmer',
            assign_error: "Échec de l'attribution.",
            assign_event: 'Attribuer',
            assigned: 'Attribué',
            enter_resolution_notes: 'Saisir les notes de résolution...',
            enter_user_id: "Saisir l'identifiant utilisateur...",
            entity: 'Entité',
            fetch_error: 'Échec de la récupération des événements de dérive.',
            no_events: 'Aucun événement de dérive trouvé.',
            resolution_notes: 'Notes de résolution',
            update_status_error: 'Échec de la mise à jour du statut.',
        },
        scores: {
            title: 'Tableau de bord du score de conformité',
            overall: 'Score de conformité global',
            breakdown: 'Détail du score par module',
            trend: 'Tendance historique',
            module: 'Composant',
            score: 'Score',
            grade: 'Note',
            calculated_at: 'Calculé le',
            generate_board_report: 'Générer le rapport du conseil',
            lang_english: 'Anglais',
            lang_vietnamese: 'Vietnamien',
            fetch_error: 'Échec de la récupération des scores de conformité.',
            generate_report: 'Générer le rapport',
            generating: 'Génération en cours...',
            recommendations: 'Recommandations',
            report_error: 'Échec de la génération du rapport.',
            factor_owner_assigned: 'Propriétaire assigné',
            factor_data_categories_linked: 'Catégories de données liées',
            factor_purposes_linked: 'Finalités liées',
            factor_data_flows_documented: 'Flux de données documentés',
            factor_processing_activity_linked: 'Activité de traitement liée',
            factor_dpa_status: 'Statut DPA',
            factor_retention_policy_linked: 'Politique de conservation liée',
            factor_last_reviewed: 'Dernière révision dans le seuil',
            factor_risk_assessment_current: 'Évaluation des risques à jour',
            factor_sub_processors_documented: 'Sous-traitants documentés',
            factor_cross_border_safeguards: 'Garanties transfrontalières',
            factor_contact_info_complete: 'Coordonnées complètes',
            factor_onboarding_approved: 'Intégration approuvée',
            factor_avg_system_score: 'Score système moyen',
            factor_avg_vendor_score: 'Score fournisseur moyen',
            factor_processing_activity_coverage: 'Couverture des activités de traitement',
            factor_ropa_completeness: 'Complétude du RoPA',
            factor_open_drift_events: 'Événements de dérive ouverts',
        },
        playbooks: {
            title: 'Guides opérationnels de suppression',
            new: 'Nouveau guide',
            edit: 'Modifier le guide',
            steps: 'Étapes',
            add_step: 'Ajouter une étape',
            remove_step: 'Supprimer une étape',
            data_categories_csv: 'Catégories de données (séparées par des virgules)',
            estimated_duration: 'Durée estimée',
            estimated_duration_label: 'Durée estimée',
            evidence_description: 'Description de la preuve',
            no_playbooks: 'Aucun guide opérationnel trouvé.',
            playbook_count: 'Nombre de guides',
            requires_evidence: 'Preuve requise',
            step_label: "Libellé de l'étape",
            target_name: 'Nom de la cible',
            target_type: 'Type de cible',
            action_type: "Type d'action",
            archive_error: "Échec de l'archivage.",
            confirm_archive: 'Êtes-vous sûr de vouloir archiver ce guide opérationnel ?',
            data_categories: 'Catégories de données',
            days: 'jours',
            fetch_error: 'Échec de la récupération des guides opérationnels.',
            sla_days: 'SLA (jours)',
            target_id: 'ID de la cible',
            template_class_heading: 'Classification des modèles',
            official: 'Officiel',
            internal: 'Interne',
            classification: 'Classement',
            official_note: 'Officiel : modèles mandatés par la réglementation alignés sur [[TOK_1]], [[TOK_0]] ou sur des exigences spécifiques au secteur.',
            internal_note: "Interne : procédures spécifiques à l'organisation non dérivées de modèles réglementaires.",
            active_executions_heading: 'Exécutions actives',
            no_active_executions: 'Aucune exécution active.',
            playbook_label: 'Manuel de jeu',
            ticket_id_label: 'Billet',
            progress_label: 'Progression',
            actions_label: 'Actions',
            view_steps_label: 'Voir les étapes',
            execution_detail_title: "Détail de l'exécution",
            playbook_missing: 'Playbook introuvable.',
            evidence_required_label: 'Preuve requise',
            upload_evidence_label: 'Téléverser la preuve',
            mark_complete_label: 'Marquer comme terminé',
            evidence_required_toast: 'Preuve requise avant de terminer cette étape.',
            evidence_blocking_message: 'Joignez un fichier de preuve pour continuer.',
            step_completed_toast: 'Étape terminée.',
            executions_fetch_error: 'Échec du chargement des exécutions.',
            step_evidence_default_name: "Preuve de l'étape d'exécution",
            attached_evidence_label: 'Preuves jointes',
        },
        approvals: {
            title: "Flux d'approbation",
            new: 'Nouvelle approbation',
            edit: "Modifier l'approbation",
            request_type: 'Type de demande',
            requester: 'Demandeur',
            approve: 'Approuver',
            reject: 'Rejeter',
            justification: 'Motif',
            all_action_types: "Tous les types d'action",
            decided_by: 'Décidé par',
            no_approvals: 'Aucune approbation trouvée.',
            approval_count: "Nombre d'approbations",
            approval_notes_optional: 'Notes (facultatif)',
            approve_error: "Échec de l'approbation.",
            approve_request: 'Approuver la demande',
            decision: 'Décision',
            entity: 'Entité',
            fetch_error: 'Échec de la récupération des approbations.',
            reject_error: 'Échec du rejet.',
            reject_request: 'Rejeter la demande',
            rejection_notes_required: 'Notes de rejet requises',
            rejection_notes_required_msg: 'Veuillez fournir un motif de rejet.',
            requested_at: 'Demandé le',
            multi_step_heading: "Flux de travail d'approbation en plusieurs étapes",
            legal_review_note: 'Étape 1 — Examen juridique : le conseiller juridique examine la demande de conformité réglementaire.',
            dpo_review_note: 'Étape 2 — [[TOK_0]] Examen : le délégué à la protection des données valide les implications en matière de protection des données.',
            management_review_note: "Étape 3 — Approbation de la direction : la haute direction fournit l'autorisation finale.",
            supporting_evidence_label: "Preuve à l'appui (optionnelle)",
            decision_evidence_name: 'Preuve de décision',
        },
        evidence: {
            title: 'Preuves de gouvernance',
            new: 'Nouvelle preuve',
            link_to: 'Lier à',
            entity_id_placeholder: "Identifiant de l'entité",
            file_path_placeholder: '/chemin/vers/fichier',
            evidence_label: 'Libellé de la preuve',
            file_path: 'Chemin du fichier',
            source_mode_label: 'Source de la preuve',
            source_mode_file: 'Téléverser un fichier',
            source_mode_url: 'Lier une URL externe',
            attachment_label: 'Pièce jointe',
            item_count: "Nombre d'éléments",
            link_button: 'Lier la preuve',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette preuve ?',
            enter_entity_id: "Saisir l'identifiant de l'entité...",
            entity_id: "Identifiant de l'entité",
            entity_type: "Type d'entité",
            expires: 'Expirer',
            expires_at: 'Expire le',
            fetch_error: 'Échec de la récupération des preuves.',
            link_error: 'Échec de la liaison de la preuve.',
            no_evidence: 'Aucune preuve trouvée.',
            tags_csv: 'Étiquettes (séparées par des virgules)',
            uploaded: 'Téléversé',
            url: 'URL',
            framework_tag_heading: 'Preuves marquées par le cadre',
            framework_tag_note: "Chaque enregistrement de preuve capture le code-cadre, l'acteur et l'horodatage. Filtrez par framework pour isoler les enregistrements pertinents pour l’audit.",
            framework_code: 'Code-cadre',
            filter_by_framework: 'Filtrer par code-cadre...',
            actor: 'Acteur',
        },
        certification: {
            not_applicable: 'Sans objet',
            not_certified: 'Non certifié',
            pending: 'En attente',
            certified: 'Certifié',
            revoked: 'Révoqué',
        },
        onboarding_pipeline: {
            title: "Pipeline d'intégration",
            new_workflow: "Nouveau workflow d'intégration",
            vendor_id: 'ID fournisseur',
            stages: 'Étapes',
            current_stage: 'Étape actuelle',
            advance: "Avancer l'étape",
            advance_success: 'Étape avancée avec succès',
            workflow_status: 'Statut du workflow',
            initiated: 'Initié',
            in_progress: 'En cours',
            completed: 'Terminé',
            cancelled: 'Annulé',
            no_workflows: "Aucun workflow d'intégration trouvé",
            stages_placeholder: 'Étape 1, Étape 2, Étape 3',
            assigned_to: 'Assigné à',
            notes: 'Remarques',
            pdpl_lifecycle_heading: '[[TOK_0]] Cycle de vie du fournisseur – Intégration',
            due_diligence_note: "L'étape de diligence raisonnable est obligatoire avant d'intégrer un processeur sous [[TOK_0]]. Vérifiez l’étendue du traitement des données, la base juridique et les mesures de sécurité.",
            contract_review_note: "L'examen du contrat doit confirmer les clauses DPA, les limites de conservation des données et les restrictions des sous-traitants ultérieurs.",
            create_dpa_review_cta: 'Créer un examen DPA',
            dpa_review_linked: 'Examen DPA lié',
        },
        dpa_review: {
            title: 'Revues DPA',
            new_review: 'Nouvelle revue DPA',
            review_type: 'Type de revue',
            findings: 'Constatations',
            outcome: 'Résultat',
            complete_review: 'Terminer la revue',
            complete_success: 'Revue terminée avec succès',
            link_assessment: 'Lier une évaluation de sécurité',
            link_success: 'Évaluation liée avec succès',
            assessment_id: "ID d'évaluation",
            combined_title: 'Évaluation combinée',
            no_reviews: 'Aucune revue DPA trouvée',
            telecom_disclosure_heading: 'Gouvernance de la divulgation des télécommunications',
            disclosure_trigger_note: 'Les examens déclenchés par la divulgation capturent les événements de partage de données des abonnés des télécommunications conformément à la loi VN Telecom.',
            telecom_t2_note: "L'approbation du niveau TELECOM-T2 est requise avant de divulguer les données des abonnés aux autorités.",
            quarterly_log_note: "Utilisez le journal trimestriel pour documenter tous les événements de divulgation et maintenir une piste d'audit continue.",
        },
        periodic_review: {
            title: 'Revues périodiques',
            new_review: 'Nouvelle revue périodique',
            review_type: 'Type de revue',
            due_date: "Date d'échéance",
            next_review: 'Prochaine date de revue',
            trigger_reassessment: 'Déclencher une réévaluation',
            reassessment_reason: 'Raison de la réévaluation',
            reassessment_success: 'Réévaluation déclenchée avec succès',
            complete_success: 'Revue terminée avec succès',
            scheduled: 'Planifiée',
            in_progress: 'En cours',
            completed: 'Terminée',
            overdue: 'En retard',
            material_change: 'Changement significatif',
            no_reviews: 'Aucune revue périodique trouvée',
            mark_complete: 'Marquer comme terminé',
            pdpl_periodic_heading: '[[TOK_0]] Cycle de vie du fournisseur – Examens périodiques',
            scheduled_review_note: 'Des examens périodiques doivent être programmés au moins une fois par an pour tous les processeurs actifs. Les examens en retard déclenchent des alertes de conformité.',
            material_change_note: 'Les changements importants dans le traitement des données nécessitent une réévaluation immédiate, quel que soit le calendrier.',
            overdue_badge: 'En retard',
            overdue_aria: 'Examen en retard',
            only_overdue_filter: 'Seulement en retard',
        },
        offboarding: {
            title: 'Désinscription fournisseur',
            initiate: 'Initier la désinscription',
            initiate_success: 'Désinscription initiée avec succès',
            reason: 'Raison de la désinscription',
            data_return_required: 'Retour des données requis',
            verify_data: 'Vérifier le retour des données',
            verify_success: 'Retour des données vérifié avec succès',
            sign_off: 'Approuver',
            sign_off_success: 'Désinscription approuvée avec succès',
            status_initiated: 'Initiée',
            status_data_pending: 'Retour des données en attente',
            status_data_verified: 'Retour des données vérifié',
            status_completed: 'Terminée',
            status_cancelled: 'Annulée',
            task_id: 'ID de tâche',
            no_tasks: 'Aucune tâche de désinscription trouvée',
            evidence_id: 'ID de preuve',
            pdpl_offboarding_heading: '[[TOK_0]] Cycle de vie du fournisseur – Délocalisation et suppression',
            deletion_capture_note: "L'offboarding doit capturer la confirmation de suppression des données du fournisseur. Vérifiez le retour des données avant la signature.",
            evidence_attachment_note: "Joignez des preuves de suppression (certificats, captures d'écran, confirmations du fournisseur) pour compléter le dossier de délocalisation.",
            verify_mode_label: 'Méthode de vérification',
            verify_mode_upload: 'Téléverser un nouveau fichier',
            verify_mode_link: 'Lier une preuve existante',
            verify_mode_none: 'Aucune donnée à restituer',
            upload_data_return_evidence: 'Téléverser la preuve de restitution des données',
            no_data_justification_label: 'Justification',
            no_data_justification_placeholder: "Expliquez pourquoi aucune donnée n'est à restituer",
            no_data_justification_hint: 'Minimum 20 caractères',
            upload_required_toast: 'Joindre un fichier pour continuer',
            evidence_link_required_toast: 'Sélectionner une preuve pour continuer',
            no_data_justification_required_toast: "Fournir une justification d'au moins 20 caractères",
            data_return_evidence_name: 'Preuve de restitution des données',
        },
        dpa_review_types: {
            initial: 'Initiale',
            annual: 'Annuel',
            renewal: 'Renouvellement',
            incident_triggered: 'Suite à un incident',
        },
        periodic_review_types: {
            initial: 'Initiale',
            annual: 'Annuelle',
            renewal: 'Renouvellement',
            incident_triggered: 'Déclenché par incident',
            material_change: 'Changement significatif',
            disclosure_triggered: 'Déclenché par divulgation',
            quarterly_log: 'Journal trimestriel',
        },
        dpa_review_statuses: {
            pending: 'En attente',
            in_progress: 'En cours',
            completed: 'Terminé',
            cancelled: 'Annulé',
        },
        onboarding_stage_names: {
            due_diligence: 'Due diligence',
            contract_review: 'Revue de contrat',
            security_assessment: 'Évaluation de sécurité',
            data_mapping: 'Cartographie des données',
            approval: 'Approbation',
            integration: 'Intégration',
        },
        access_denied_title: 'Accès refusé',
        access_denied: "Vous n'avez pas la permission de consulter cette page. Veuillez contacter votre administrateur.",
    },
    consent: {
        nav: {
            policies: 'Politiques',
            purposes: 'Catalogue des finalités',
            workflows: 'Flux de travail',
            snapshots: 'Instantanés CMP',
            change_awareness: 'Détection des modifications',
            audit: 'Audit du consentement',
        },
        gap_analysis: {
            nav_label: 'Analyse des écarts',
            page_title: 'Analyse des écarts de consentement',
            page_subtitle: 'Forseti vérifie les objectifs de votre consentement actif par rapport aux exigences du framework installé ([[TOK_0]] Art.7 + Art.6 + Art.9, [[TOK_1]] Art.13 + Art.20, PIPL Art.13 + Art.29) et fait apparaître les lacunes avec citation + correction suggérée.',
            framework_picker_label: 'Cadres',
            org_flags_label: "Contexte de l'organisation",
            flag_withdrawal: 'Le mécanisme de retrait mondial est-il documenté',
            flag_parental: "Dispose d'un flux de consentement parental pour les sujets de moins de 16 ans",
            flag_cross_border: 'A un dépôt transfrontalier enregistré',
            run_label: "Analyse des écarts d'exécution",
            running_label: 'Courir…',
            requires_advisor_label: "Nécessite l'autorisation ai_advisor : chat.",
            results_heading: 'Lacunes apparues ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            empty_label: 'Aucune lacune détectée pour les frameworks sélectionnés.',
            remediation_label: 'Correction suggérée :',
            dismiss_label: 'Rejeter comme sans objet',
            resolve_label: 'Résoudre',
            dismissed_label: 'Rejeté car sans objet',
            resolved_label: 'Résolu',
        },
        import: {
            title: 'Importer les flux de consentement',
            nav_title: 'Import en masse',
            description: 'Téléversez un fichier CSV pour importer en masse les flux de consentement.',
            select_file: 'Sélectionner le fichier CSV',
            file_help: 'CSV avec des en-têtes correspondant aux champs de flux.',
            required_columns_help: 'Colonnes requises : Type de flux, Personne concernée, Canal.',
            file_too_large: 'Fichier trop volumineux. La taille maximale est de 2 Mo.',
            preview: 'Aperçu',
            columns_detected: 'Colonnes détectées : {count}',
            column_mapping: 'Correspondance des colonnes',
            import_button: 'Importer',
            import_complete: 'Import terminé',
            import_error: "L'import a échoué",
            result: "Résultat de l'import",
            total: 'Total',
            imported: 'Importé',
            skipped: 'Ignoré',
            failed: 'Échoué',
            errors: 'Erreurs',
            error_row: 'Ligne',
            error_field: 'Champ',
            error_message: 'Message',
            history: "Historique d'import",
            no_history: "Aucun historique d'import.",
            history_file: 'Nom de fichier',
            history_date: 'Date',
            create_profiles_label: 'Créer des profils de Personne concernée pour les nouveaux sujets',
            create_profiles_help: "Les imports sans profil correspondant en créent un automatiquement. Décochez pour n'importer que les flux.",
            profiles_created: 'Profils créés',
            profiles_matched: 'Profils correspondants',
            subject_kind_help: 'Colonnes facultatives : subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Adresse e-mail non valide dans la colonne subject_email.',
            error_subject_unknown_kind: 'Valeur subject_kind inconnue. Attendu : email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'external_ref_key est requis lorsque subject_kind=external_ref',
        },
        policies: {
            title: 'Politiques de consentement',
            new: 'Nouvelle politique',
            edit: 'Modifier la politique',
            name: 'Nom',
            version: 'Révision',
            policy_text: 'Texte de la politique',
            publish: 'Publier',
            versions: 'Révisions',
            hide_versions: 'Masquer les versions',
            submit_for_review: 'Soumettre pour révision',
            suspend: 'Suspendre',
            retire: 'Retirer',
            jurisdictions: 'Juridictions',
            jurisdictions_csv: 'Juridictions (séparées par des virgules)',
            approval_mode: "Mode d'approbation",
            reviewer_ids: 'ID des réviseurs (séparés par des virgules)',
            tags_csv: 'Étiquettes (séparées par des virgules)',
            effective_date: "Date d'entrée en vigueur",
            review_date: 'Date de révision',
            consent_model_statement: 'Déclaration du modèle de consentement',
            consent_model_placeholder: 'Déclaration facultative du modèle de consentement...',
            default_settings: 'Paramètres par défaut (JSON)',
            changes: 'Modifications',
            fetch_error: 'Échec de la récupération des politiques de consentement. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement de la politique de consentement. Veuillez réessayer.",
            submit_review_error: 'Échec de la soumission de la politique pour révision. Veuillez réessayer.',
            activate_error: "Échec de l'activation de la politique. Veuillez réessayer.",
            suspend_error: 'Échec de la suspension de la politique. Veuillez réessayer.',
            retire_error: 'Échec du retrait de la politique. Veuillez réessayer.',
            submit_review_success: 'Politique soumise pour examen.',
            activate_success: 'Politique activée.',
            suspend_success: 'Politique suspendue.',
            retire_success: 'Politique retirée.',
            versions_error: 'Échec de la récupération des versions de la politique. Veuillez réessayer.',
            invalid_json: 'JSON invalide dans le champ Paramètres par défaut. Veuillez réessayer.',
            page_title: 'Politiques de consentement',
            version_updated: 'Mis à jour',
            version_initial: 'Version initiale',
            json_format: 'Format [[TOK_0]]',
            sensitive: 'Sensible',
            flag_sensitive: 'Sensible au drapeau',
            flag_sensitive_title: 'Signaler la politique comme sensible',
            require_enhanced_review: 'Exiger un examen approfondi',
            enhanced_review_success: 'Exigence de révision améliorée activée.',
            select_categories: 'Sélectionnez les catégories de données sensibles [[TOK_0]] Article 2 applicables :',
            no_policies: 'Aucune politique de consentement trouvée. Créez votre première politique pour commencer.',
            approval_success: 'Politique approuvée.',
            reviewers_label: 'Réviseurs',
            enhanced_review_title: 'Révision approfondie requise',
            enhanced_review_badge: 'Révision approfondie requise',
            enhanced_review_status_pending: 'Révision en attente',
            enhanced_review_status_approved: 'Révision approuvée',
            enhanced_review_status_rejected: 'Révision rejetée',
            enhanced_review_reviewed_by: 'Révisé par',
            enhanced_review_notes: 'Notes de révision',
            enhanced_review_approve: 'Approuver la révision',
            enhanced_review_reject: 'Rejeter la révision',
            enhanced_review_notes_required: 'Les notes de révision sont obligatoires',
            enhanced_review_approved: 'Révision approfondie approuvée',
            enhanced_review_rejected: 'Révision approfondie rejetée — politique réinitialisée en brouillon',
            enhanced_review_reset_to_draft: 'Révision approfondie rejetée — politique réinitialisée en brouillon',
            enhanced_review_reject_warning: 'Le rejet réinitialisera cette politique au statut Brouillon. Le DPO doit la soumettre à nouveau après avoir résolu les problèmes.',
            submitted_modal_title: 'Soumis pour révision approfondie',
            submitted_modal_body: "Cette politique a été soumise. Un réviseur Juridique/Confidentialité doit l'approuver avant qu'elle puisse être activée.",
        },
        sensitive_categories: {
            health: 'Donnees de sante',
            biometric: 'Donnees biometriques',
            political: 'Opinions politiques',
            ethnic: 'Origine ethnique',
            genetic: 'Donnees genetiques',
            criminal: 'Casier judiciaire',
        },
        purposes: {
            title: 'Catalogue des finalités',
            new: 'Nouvelle finalité',
            edit: 'Modifier la finalité',
            name: 'Nom',
            legal_basis: 'Base juridique',
            retention_days: 'Durée de conservation (jours)',
            is_active: 'Actif',
            filter_by_category: 'Filtrer par catégorie',
            policy_ids: 'ID des politiques (séparés par des virgules)',
            ropa_activity_ids: 'ID des activités ROPA (séparés par des virgules)',
            policies: 'Politiques',
            deprecate: 'Déprécier',
            fetch_error: 'Échec de la récupération des finalités de consentement. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement de la finalité de consentement. Veuillez réessayer.",
            deprecate_error: 'Échec de la dépréciation de la finalité de consentement. Veuillez réessayer.',
            page_title: 'Objectif Catalogue',
            no_purposes: 'Aucune finalité de consentement trouvée. Créez votre première finalité pour commencer.',
            category_personal_data: 'Données personnelles',
            category_sensitive_data: 'Données sensibles',
            category_health_data: 'Données de santé',
            category_financial_data: 'Données financières',
            category_biometric_data: 'Données biométriques',
            category_children_data: 'Données sur les enfants',
            category_location_data: 'Données de localisation',
            category_communications_data: 'Données de communication',
            category_other: 'Autre',
        },
        workflows: {
            title: 'Flux de travail du consentement',
            new: 'Nouveau flux de travail',
            edit: 'Modifier le flux de travail',
            workflow_type: 'Type de flux de travail',
            user_id: 'Identifiant utilisateur',
            purpose_id: 'Identifiant de finalité',
            purpose_ids_csv: 'ID de finalité (séparés par des virgules)',
            reason: 'Motif',
            process: 'Traiter',
            data_subject_ref: 'Référence de la personne concernée',
            data_subject: 'Personne concernée',
            channel: 'Canal',
            policy_id: 'ID de la politique',
            scope: 'Périmètre',
            legal_grounds: 'Fondements juridiques',
            assessment: 'Évaluation',
            select_outcome: 'Sélectionner le résultat',
            partially_approved: 'Partiellement approuvé',
            denied: 'Refusé',
            outcome_upheld: 'Confirmé',
            outcome_pending: 'En attente',
            outcome_denied: 'Refusé',
            status_count: 'Nombre par statut',
            channel_filter: 'Filtrer par canal',
            add_action: '+ Mesure',
            by_type: 'Par type',
            by_status: 'Par statut',
            downstream_actions: 'Actions en aval',
            downstream_actions_for: 'Actions en aval pour {subject} ({type})',
            add_downstream_action: 'Ajouter une action en aval',
            assigned_to: 'Assigné à',
            fetch_error: 'Échec de la récupération des flux de travail de consentement. Veuillez réessayer.',
            dashboard_error: 'Échec de la récupération du tableau de bord des flux de travail. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement du flux de travail de consentement. Veuillez réessayer.",
            status_update_error: 'Échec de la mise à jour du statut du flux de travail. Veuillez réessayer.',
            assessment_error: "Échec de la mise à jour de l'évaluation du flux de travail. Veuillez réessayer.",
            add_action_error: "Échec de l'ajout de l'action du flux de travail. Veuillez réessayer.",
            update_action_error: "Échec de la mise à jour de l'action du flux de travail. Veuillez réessayer.",
            type_refusal: 'Refus',
            type_withdrawal: 'Retrait',
            type_restriction: 'Limitation',
            type_objection: 'Opposition',
            status_received: 'Reçu',
            status_processing: 'En cours de traitement',
            status_under_assessment: "En cours d'évaluation",
            status_implemented: 'Mis en œuvre',
            evidence_button: 'Preuve',
            evidence_modal_title: 'Preuve du flux de travail',
            no_evidence: 'Aucune preuve attachée à ce flux de travail.',
            upload_evidence_label: 'Télécharger des preuves de flux de travail',
            completed_at: 'Terminé à',
            effective_date: "Date d'entrée en vigueur",
            page_title: 'Flux de travail de consentement',
            no_workflows: 'Aucun flux de consentement trouvé. Les flux sont créés lorsque les personnes concernées exercent leurs droits.',
            type_grant: 'Octroi',
            propagation_none: 'Aucun',
            propagation_pending: 'En attente',
            propagation_pending_warning: 'Impossible de terminer — la propagation du retrait est toujours en attente',
            propagation_completed: 'Terminé',
            propagation_partial: 'Partiel',
            propagation_incomplete_error: 'Impossible de terminer le flux tant que la propagation du retrait est en attente',
            propagation_status: 'Statut de propagation',
        },
        snapshots: {
            title: 'Instantanés CMP',
            new: 'Nouvel instantané',
            label: 'Libellé',
            snapshot_date: "Date de l'instantané",
            purposes_count: 'Nombre de finalités',
            compare: 'Comparer',
            snapshot_data: "Données de l'instantané (JSON)",
            select_left: "Sélectionner l'instantané de gauche",
            select_right: "Sélectionner l'instantané de droite",
            comparison_results: 'Résultats de la comparaison',
            field: 'Champ',
            left: 'Gauche',
            right: 'Droite',
            close_comparison: 'Fermer la comparaison',
            trigger: 'Déclencheur',
            trigger_manual: 'Manuel',
            trigger_policy_approval: 'Approbation de politique',
            cmp_version: 'Version CMP',
            policy_version_id: 'ID de la version de politique',
            banner_config: 'Configuration de la bannière (JSON)',
            active_purposes: 'Finalités actives (JSON)',
            active_legal_bases: 'Bases juridiques actives (JSON)',
            domain_scope: 'Périmètre de domaine',
            domain_scope_csv: 'Périmètre de domaine (séparé par des virgules)',
            raw_config: 'Configuration brute (JSON)',
            checksum: 'Somme de contrôle',
            created: 'Créé',
            fetch_error: 'Échec de la récupération des instantanés CMP. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement de l'instantané CMP. Veuillez réessayer.",
            compare_error: 'Échec de la comparaison des instantanés. Veuillez réessayer.',
            page_title: 'Instantanés de consentement',
            json_format: 'Format [[TOK_0]]',
            json_array_format: 'format de tableau [[TOK_0]]',
            manual_snapshot_note: "Pour administrateurs/développeurs uniquement. En fonctionnement normal, les instantanés sont créés automatiquement via le webhook CMP ou lors de l'approbation des politiques. Collez le JSON exporté depuis votre fournisseur CMP (ex. OneTrust, Cookiebot).",
            banner_config_hint: "Collez l'objet de configuration de bannière depuis votre export CMP.",
            active_purposes_hint: 'Tableau JSON des objets de finalités actives copiés depuis votre export CMP.',
            active_legal_bases_hint: 'Tableau JSON des objets de bases légales actives copiés depuis votre export CMP.',
            raw_config_hint: 'JSON de configuration brut complet depuis votre CMP. Les autres champs JSON en sont extraits. Une somme de contrôle SHA-256 est calculée automatiquement.',
            changed_field: 'Champ modifié : ',
            no_snapshots: 'Aucun instantané CMP trouvé. Les instantanés sont créés lorsque les politiques sont approuvées ou déclenchés manuellement.',
            detail_title: "Détail de l'instantané",
            view_snapshot_detail: "Voir le détail de l'instantané",
            policy_version: 'Version de la politique',
            removed: 'Avant',
            added: 'Après',
        },
        change_awareness: {
            title: 'Détection des modifications de consentement',
            change_type: 'Type de modification',
            entity_type: "Type d'entité",
            entity_id: "Identifiant de l'entité",
            detected_at: 'Détecté le',
            acknowledge: 'Prendre en compte',
            new_alert: 'Nouvelle alerte',
            new_alert_form: 'Nouvelle alerte de détection de modification',
            total_open: 'Total ouvert',
            by_severity: 'Par sévérité',
            snapshot_id: "ID de l'instantané",
            update_status: 'Mettre à jour le statut',
            resolution_notes: 'Notes de résolution',
            resolution_required: 'Notes de résolution (obligatoire)',
            resolution_required_msg: "Les notes de résolution sont requises lors de la résolution d'un élément.",
            status_open: 'Ouvert',
            status_under_review: 'En cours de révision',
            status_resolved: 'Résolu',
            status_accepted: 'Accepté',
            severity_informational: 'Informatif',
            severity_requires_review: 'Nécessite une révision',
            severity_policy_violation: 'Violation de politique',
            create_reconciliation: 'Créer une tâche de rapprochement',
            reconciliation_created: 'Tâche de réconciliation créée avec succès.',
            reconciliation_error: 'Échec de la création de la tâche de rapprochement. Veuillez réessayer.',
            fetch_error: 'Échec de la récupération des éléments de détection de modification. Veuillez réessayer.',
            dashboard_error: 'Échec de la récupération du tableau de bord de détection de modification. Veuillez réessayer.',
            create_error: "Échec de la création de l'élément de détection de modification. Veuillez réessayer.",
            status_update_error: 'Échec de la mise à jour du statut de détection de modification. Veuillez réessayer.',
            page_title: 'Sensibilisation au changement',
            no_items: 'Aucun élément de sensibilisation aux changements trouvé. Les éléments sont créés lorsque des changements de configuration du consentement sont détectés.',
        },
        audit: {
            title: "Piste d'audit du consentement",
            event_type: "Type d'événement",
            user_id: 'Identifiant utilisateur',
            timestamp: 'Horodatage',
            details: 'Détails',
            actor: 'Acteur',
            filter_by_entity_type: "Filtrer par type d'entité",
            filter_by_action: 'Filtrer par action',
            fetch_error: "Échec de la récupération de la piste d'audit du consentement. Veuillez réessayer.",
            page_title: 'Vérification du consentement',
            export_csv: 'Exporter [[TOK_0]]',
            exporting: 'Exporter…',
            export_success: "Piste d'audit exportée avec succès.",
            export_error: "Échec de l'exportation de la piste d'audit du consentement. Veuillez réessayer.",
            no_entries: 'Aucune entrée d’audit trouvée. Les événements d’audit sont enregistrés automatiquement lorsque les données de consentement changent.',
            entity_policy: 'Politique',
            entity_purpose: 'Finalité',
            entity_workflow: 'Flux de travail',
            entity_consent_record: 'Enregistrement de consentement',
            entity_change_awareness: 'Sensibilisation aux changements',
            entity_cmp_snapshot: 'Instantané CMP',
            action_created: 'Créé',
            action_updated: 'Mis à jour',
            action_status_changed: 'Statut modifié',
            action_drift_detected: 'Dérive détectée',
            action_snapshot_created: 'Instantané créé',
            action_approval_submitted: 'Approbation soumise',
            action_archived: 'Archivé',
            action_purpose_auto_mapped: 'Finalité attribuée automatiquement',
            action_purpose_mapping_updated: 'Attribution de finalité mise à jour',
            action_webhook_configured: 'Webhook configuré',
            entity_propagation: 'Propagation',
            entity_reconciliation: 'Réconciliation',
            action_propagation_confirmed: 'Propagation confirmée',
            action_propagation_failed: 'Échec de la propagation',
            action_consent_captured: 'Consentement capturé',
            action_reconciliation_created: 'Réconciliation créée',
            action_reconciliation_resolved: 'Réconciliation résolue',
            action_submitted_for_review: 'Soumis pour examen',
            action_activated: 'Activé',
            action_suspended: 'Suspendu',
            action_retired: 'Retiré',
            action_enhanced_review_required: 'Examen approfondi requis',
            action_enhanced_review_approved: 'Révision approfondie approuvée',
            action_enhanced_review_rejected: 'Révision approfondie rejetée — politique réinitialisée en brouillon',
            action_consented: 'Consentement',
            action_consented_customize: 'Consentement personnalisé',
            action_revoked: 'Révoqué',
            action_rejected: 'Rejeté',
        },
        web_records: {
            title: 'Enregistrements de consentement Web',
            page_title: 'Enregistrements de consentement Web',
            domain: 'Domaine',
            visitor_id: 'ID visiteur',
            consent_action: 'Action de consentement',
            received_at: 'Reçu à',
            admin_status: "Statut d'administrateur",
            revoke: 'Révoquer',
            reject: 'Rejeter',
            reason: 'Raison',
            reason_placeholder: 'Raison de cette action (facultatif)',
            revoke_confirm: 'Révoquer cet enregistrement de consentement ?',
            reject_confirm: 'Rejeter cet enregistrement de consentement ?',
            override_success: "Le statut de l'enregistrement a été mis à jour avec succès.",
            override_error: "Échec de la mise à jour du statut de l'enregistrement.",
            no_records: 'Aucun enregistrement de consentement Web trouvé.',
            fetch_error: 'Échec du chargement des enregistrements de consentement Web.',
            filter_by_domain: 'Filtrer par domaine',
            filter_by_action: 'Filtrer par action',
            active: 'Actif',
        },
        legal_bases: {
            all: 'Toutes les bases juridiques',
            consent: 'Consentement',
            legitimate_interest: 'Intérêt légitime',
            contract: 'Contrat',
            legal_obligation: 'Obligation légale',
            vital_interest: 'Intérêt vital',
            public_interest: 'Intérêt public',
        },
        common_statuses: {
            suspended: 'Suspendu',
            retired: 'Retiré',
            deprecated: 'Déprécié',
        },
        approval_modes: {
            all: 'Tous',
            any: "N'importe lequel",
        },
        cmp_integration: {
            title: 'Intégration AesirX CMP',
            back_to_consent: 'Retour au consentement',
            back_to_integration: "Retour à l'intégration",
            webhook_status: 'Statut du webhook',
            events_received: 'Événements reçus',
            web_consent_records: 'Enregistrements de consentement web',
            unmapped_purposes: 'Finalités non mappées',
            integration_management: "Gestion de l'intégration",
            webhook_configuration: 'Configuration du webhook',
            webhook_config_desc: "Configurez le point d'accès du webhook CMP et gérez le secret HMAC.",
            purpose_mapping: 'Correspondance des finalités',
            purpose_mapping_desc: 'Associez les identifiants de finalité CMP aux finalités du catalogue de consentement GRC.',
            bulk_sync: 'Synchronisation en masse',
            bulk_sync_desc: "Importez les données de consentement historiques et consultez l'historique de synchronisation.",
            consent_analytics: 'Analytique du consentement web (30 derniers jours)',
            consent_grant_rate: "Taux d'octroi du consentement",
            top_domain: 'Domaine principal',
            records: 'enregistrements',
            banner_interactions: 'Interactions avec la bannière',
            consent_actions: 'Actions de consentement',
            opt_in_trend: "Tendance d'opt-in/opt-out",
            records_by_domain: 'Enregistrements par domaine',
            date: 'Date du',
            grants: 'Consentements',
            denials: 'Refus',
            not_configured: 'Non configuré',
            load_error: "Échec du chargement des données d'intégration",
            webhook_not_configured: 'Webhook non configuré.',
            webhook_not_configured_msg: 'Veuillez {link} au préalable.',
            configure_webhook_link: 'configurer le webhook',
            setup_wizard: "Assistant d'installation",
            step_configure_webhook: 'Configurer le webhook',
            step_map_purposes: 'Associer les finalités',
            step_run_sync: 'Lancer la synchronisation initiale en masse',
            step_verify_data: 'Vérifier les données dans le tableau de bord',
            configure: 'Configurer',
            view_dashboard: 'Voir le tableau de bord',
            syncing: 'Synchronisation en cours...',
            sync_now: 'Synchroniser maintenant',
            sync_completed: 'Synchronisation terminée : {imported} importé(s), {skipped} ignoré(s), {failed} échoué(s).',
            sync_failed: 'Échec de la synchronisation',
            last_sync_result: 'Dernier résultat de synchronisation',
            imported: 'Importé(s)',
            skipped: 'Ignoré(s)',
            errors: 'Erreurs',
            index: 'Répertoire',
            error: 'Erreur',
            sync_history: 'Historique de synchronisation',
            no_sync_jobs: 'Aucune tâche de synchronisation enregistrée.',
            load_sync_error: 'Échec du chargement des données de synchronisation',
            purpose_mapping_title: 'Correspondance des finalités CMP',
            auto_mapping: 'Association automatique en cours...',
            auto_map_purposes: 'Associer automatiquement les finalités',
            unmapped_warning: '{count} finalité(s) non associée(s) -- ces finalités CMP doivent être associées aux finalités GRC.',
            mapping_saved: 'Association enregistrée.',
            mapping_deleted: 'Association supprimée.',
            auto_map_complete: 'Association automatique terminée : {mapped} associée(s), {unmatched} non associée(s).',
            auto_map_failed: "Échec de l'association automatique",
            save_mapping_error: "Échec de l'enregistrement de l'association",
            delete_mapping_error: "Échec de la suppression de l'association",
            load_data_error: 'Échec du chargement des données',
            cmp_purpose: 'Finalité CMP',
            grc_purpose: 'Finalité GRC',
            select_grc_purpose: '-- Sélectionner une finalité GRC --',
            auto_mapped: 'Associé automatiquement',
            mapped: 'Associé',
            unmapped: 'Non associé',
            no_mappings: "Aucune correspondance de finalité trouvée. Les correspondances sont créées automatiquement à la réception d'événements de consentement.",
            total_mappings: 'Total : {count} correspondance(s)',
            webhook_config_title: 'Configuration du webhook',
            current_configuration: 'Configuration actuelle',
            setup_webhook: 'Configurer le webhook',
            setup_webhook_desc: 'Configurez le webhook AesirX CMP pour recevoir les événements de consentement.',
            allowed_domains: 'Domaines autorisés (un par ligne)',
            webhook_secret_warning: 'Secret du webhook (enregistrez-le maintenant -- il ne sera plus affiché) :',
            last_event: 'Dernier événement',
            none_received: 'Aucun',
            update_domains: 'Mettre à jour les domaines',
            pause_webhook: 'Suspendre le webhook',
            resume_webhook: 'Reprendre le webhook',
            regenerate_secret: 'Régénérer le secret',
            configuring: 'Configuration en cours...',
            create_webhook_config: 'Créer la configuration du webhook',
            webhook_endpoint: "Point d'accès du webhook",
            webhook_endpoint_desc: 'Configurez votre AesirX CMP pour envoyer les événements de consentement à :',
            webhook_signature_note: "Incluez la signature HMAC-SHA256 dans l'en-tête {header}.",
            configured_success: 'Webhook configuré avec succès.',
            config_updated: 'Configuration mise à jour.',
            config_error: 'Échec de la configuration du webhook',
            update_error: 'Échec de la mise à jour de la configuration',
            toggle_error: "Échec de l'activation/désactivation du webhook",
            deactivated: 'Webhook désactivé.',
            deactivate_error: 'Échec de la désactivation du webhook',
            page_title: '[[TOK_0]] Intégration',
            webhook_config_page_title: '[[TOK_0]] Configuration du webhook',
            bulk_sync_page_title: 'Remapper les enregistrements',
            purpose_mapping_page_title: 'Cartographie des objectifs',
            data_loaded: "[[TOK_0]] données d'intégration chargées",
            sync_all: 'Tout synchroniser',
            sync_selected: 'Synchroniser la sélection',
            sync_status: 'État de synchronisation',
            last_sync: 'Dernière synchronisation',
            no_records: 'Aucun enregistrement trouvé.',
            sync_in_progress: 'Synchronisation en cours...',
            sync_complete: 'Synchronisation terminée.',
            sync_error: 'La synchronisation a échoué. Veuillez réessayer.',
            map_purpose: 'Associer la finalité',
            unmap: 'Dissocier',
            mapping_status: 'État de l’association',
            save_mapping: 'Enregistrer l’association',
            remap_unmapped_records: 'Remapper les enregistrements non mappés',
            remap_records: 'Remapper les enregistrements',
            add_mappings_first: "Ajoutez d'abord des mappages d'objectifs (étape 2)",
            remap_result: 'Résultat du remappage',
            remap_result_desc: 'Nous avons traité tous les enregistrements de consentement avec des finalités non mappées ou partiellement mappées.',
            total_processed: 'Total traité',
            newly_mapped: 'Nouvellement cartographié',
            still_unmapped_label: 'Toujours non cartographié',
            still_unmapped_msg: '[[TOK_2]] les enregistrements ont toujours des objectifs non mappés. [[TOK_3]] puis cliquez à nouveau sur Re-mapper.',
            add_more_mappings: 'Ajouter plus de mappages',
            remap_complete: 'Remappage terminé : [[TOK_2]] nouvellement mappés, [[TOK_3]] toujours non mappés.',
            add_mapping: 'Ajouter un mappage',
            cmp_purpose_id_label: "[[TOK_0]] ID de l'objectif *",
            cmp_purpose_id_required: "[[TOK_0]] L'ID de l'objectif est requis",
            cmp_purpose_name_label: "[[TOK_0]] Nom de l'objectif",
            grc_purpose_label: 'Objectif GRC',
        },
        propagation: {
            title: 'Propagation du retrait',
            systems: 'Systèmes liés',
            status: 'Statut',
            confirmed: 'Confirmé',
            pending: 'En attente',
            failed: 'Échoué',
            confirm: 'Confirmer le retrait',
            fail: 'Marquer comme échoué',
            failure_reason: "Raison de l'échec",
            can_close: 'Tous les systèmes confirmés — le flux peut être clôturé',
            cannot_close: 'En attente des confirmations système',
            no_tasks: 'Aucune tâche de propagation.',
            confirm_success: 'Retrait système confirmé.',
            fail_success: 'Système marqué comme échoué.',
            propagate_success: 'Retrait propagé aux systèmes liés.',
            propagate: 'Propager aux systèmes',
            add_system: 'Ajouter un système',
            remove_system: 'Supprimer',
            system_id: 'ID système',
            system_name: 'Nom du système',
            owner_id: 'ID du propriétaire',
            propagate_error: 'Échec de la propagation du retrait. Veuillez réessayer.',
            no_systems: 'Ajoutez au moins un système.',
            page_title: 'Propagation du retrait',
            workflow_id: 'Sélectionnez le flux de travail de retrait',
            system_id_hint: 'ex. crm-001, erp-prod',
            owner_id_hint: 'Propriétaire du système',
            elapsed: 'Écoulé',
        },
        sensitive: {
            title: 'Politiques de données sensibles',
            flag: 'Marquer comme sensible',
            categories: 'Catégories sensibles',
            enhanced_review: 'Exiger un examen approfondi',
            enhanced_review_success: 'Examen approfondi requis.',
            flag_success: 'Politique marquée comme sensible.',
            no_sensitive: 'Aucune politique de données sensibles.',
        },
        reconciliation: {
            title: 'Réconciliation des écarts',
            create: 'Nouvelle tâche de réconciliation',
            system: 'Système',
            owner: 'Propriétaire',
            description: 'Descriptif',
            resolution: 'Résolution',
            resolve: 'Résoudre',
            update_grc: 'Mettre à jour GRC',
            update_cmp: 'Mettre à jour CMP',
            accept_difference: 'Accepter la différence',
            escalate: 'Escalader',
            resolution_notes: 'Notes de résolution',
            no_tasks: 'Aucune tâche de réconciliation.',
            resolve_success: 'Tâche de réconciliation résolue.',
            create_success: 'Tâche de réconciliation créée.',
            open: 'Ouvert',
            resolved: 'Résolu',
            escalated: 'Escaladé',
            dashboard_open: 'Tâches ouvertes',
            dashboard_resolved: 'Tâches résolues',
            dashboard_escalated: 'Tâches escaladées',
            page_title: 'Rapprochement des discordances',
            my_tasks: 'Mes tâches',
            all_tasks: 'Toutes les tâches',
            severity: 'Gravité',
        },
        sync: {
            title: 'Synchronisation CMP',
            direction: 'Direction',
            cmp_to_grc: '[[TOK_0]] → GRC',
            grc_to_cmp: 'GRC → [[TOK_0]]',
            conflict: 'Conflit',
            resolve_conflict: 'Résoudre le conflit',
            no_events: 'Aucun événement de synchronisation.',
            resolve_success: 'Conflit de synchronisation résolu.',
            create_success: 'Événement de synchronisation enregistré.',
            page_title: '[[TOK_0]] Synchronisation',
            detect_drift: 'Détecter les conflits',
            detecting: 'Détection...',
            drift_result: '[[TOK_2]] conflit(s) détecté(s) parmi les [[TOK_3]] objectif(s) comparé(s).',
            no_drift: 'Aucun nouveau conflit détecté.',
            drift_error: "Échec de l'exécution de la détection des conflits.",
            resolve_modal_title: 'Résoudre le conflit',
            resolve_field: 'Champ',
            resolve_grc_value: 'Valeur GRC',
            resolve_cmp_value: '[[TOK_0]] Valeur',
            accept_cmp: 'Accepter la valeur [[TOK_0]]',
            accept_cmp_desc: "Mettez à jour GRC pour qu'il corresponde à [[TOK_0]] — la valeur [[TOK_1]] devient la nouvelle valeur GRC.",
            keep_grc: 'Conserver la valeur GRC',
            keep_grc_desc: "Fermez ce conflit sans modifier GRC — informez le propriétaire [[TOK_0]] de l'aligner.",
            resolve_applied: 'Conflit résolu. Objectif GRC mis à jour pour correspondre à [[TOK_0]].',
        },
    },
    assessments: {
        dossier_preflight: {
            advisory_notice: 'Ce rapport de préparation est consultatif. Il n’approuve, n’assemble, ne matérialise, ne dépose ni n’envoie le dossier.',
            run_label: 'Exécuter le pré-vol',
            running: 'Exécution du pré-vol…',
            assemble_label: 'Forfait à assembler automatiquement',
            assembling: 'Assemblage…',
            verdict_label: 'Verdict avant le vol',
            tokens_label: '≈ [[TOK_1]] jetons',
            remediation_label: 'Assainissement',
            no_gaps: 'Aucun écart avant vol détecté. Le dossier est prêt à monter.',
            override_label: "Annuler le verdict de blocage : l'assemblage sera estampillé par un audit.",
            accept_label: 'Accepter le rapport',
            reject_label: 'Rejeter le rapport',
            assembled_label: 'Dossier de soumission assemblé',
            package_id_label: 'Identifiant du paquet',
            package_filename_label: 'Nom du fichier',
            package_hash_label: 'Hachage du paquet',
            evidence_count_label: '[[TOK_1]] éléments de preuve regroupés',
            error_generic: "Impossible d'exécuter le pré-vol ou d'assembler le package. Réessayez ou vérifiez l'état du dépôt.",
        },
        errors: {
            fetch: 'Échec du chargement des évaluations.',
            save: "Échec de l'enregistrement de l'évaluation.",
            fetch_gap_report_failed: "Échec de la récupération du rapport d'écarts.",
            fetch_transfers_failed: 'Échec de la récupération des transferts.',
            save_transfer_failed: "Échec de l'enregistrement du transfert.",
            submit_review_failed: 'Échec de la soumission pour révision.',
            process_decision_failed: 'Échec du traitement de la décision.',
            deprecate_failed: 'Échec de la dépréciation.',
            evaluate_risk_failed: "Échec de l'évaluation du risque.",
            fetch_safeguards_failed: 'Échec de la récupération des garanties.',
            save_safeguard_failed: "Échec de l'enregistrement de la garantie.",
            update_safeguard_status_failed: 'Échec de la mise à jour du statut de la garantie.',
        },
        nav: {
            dpias: 'AIPD',
            transfers: 'Évaluations des transferts',
            dashboard: 'Tableau de bord',
            gap_report: "Rapport d'écarts",
        },
        risk_level_critical: 'Risque critique',
        risk_level_high: 'Risque élevé',
        risk_level_medium: 'Risque moyen',
        risk_level_low: 'Risque faible',
        severity_critical: 'Gravité critique',
        severity_high: 'Gravité élevée',
        severity_medium: 'Gravité moyenne',
        severity_low: 'Gravité faible',
        overdue: 'En retard',
        framework_filter_label: 'Cadre',
        aria_filter_by_framework: 'Filtrer par framework',
        dashboard: {
            title: 'Tableau de bord des évaluations',
            page_title: 'Tableau de bord des évaluations',
            announce_loaded: 'Tableau de bord des évaluations chargé',
            announce_chart_view: 'Affichage en graphique',
            announce_table_view: 'Affichage en tableau de données',
            aria_metrics_table: 'Métriques du tableau de bord',
            metric_col: 'Métrique',
            value_col: 'Valeur',
            dpia_prefix: 'AIPD',
            transfer_prefix: 'Transfert',
            risk_prefix: 'Risque',
            aria_dpias_by_status: 'AIPD par statut',
            aria_transfers_by_status: 'Transferts par statut',
            aria_top_risks: 'Principaux risques',
            aria_top_risks_table: 'Principaux risques des AIPD',
            overdue_dpias_attention: '{count} évaluations AIPD en retard nécessitent une attention',
            no_overdue_dpias: 'Aucune évaluation AIPD en retard',
            overdue_transfers_attention: '{count} évaluations de transfert en retard nécessitent une attention',
            no_overdue_transfers: 'Aucune évaluation de transfert en retard',
            dpias_overview: "Vue d'ensemble des AIPD",
            transfers_overview: "Vue d'ensemble des évaluations de transferts",
            overdue_items: 'Éléments en retard',
            overdue_dpias: 'AIPD en retard',
            overdue_transfers: 'Transferts en retard',
            count: 'Nombre',
            no_data: 'Aucune donnée disponible.',
            no_risks: 'Aucun risque trouvé.',
            no_dashboard_data: 'Aucune donnée de tableau de bord disponible.',
            fetch_error: 'Échec de la récupération des données du tableau de bord. Veuillez réessayer.',
        },
        dpias: {
            page_title: 'AIPD',
            announce_submitted_for_review: 'AIPD soumise pour examen',
            announce_deprecated: 'AIPD obsolète',
            announce_risks_loaded: '{count} risque(s) chargé(s)',
            announce_mitigations_loaded: "{count} mesure(s) d'atténuation chargée(s)",
            announce_risk_deleted: 'Risque supprimé',
            announce_mitigation_status_updated: "Statut de la mesure d'atténuation mis à jour",
            aria_filter: 'Filtrer les AIPD',
            aria_filter_by_status: 'Filtrer par statut',
            aria_filter_by_lead: "Filtrer par responsable d'évaluation",
            aria_table: "Analyses d'impact sur la protection des données",
            announce_found: '{count} AIPD trouvée(s)',
            announce_decision: 'AIPD {decision}',
            mitigation_start: 'Démarrer',
            mitigation_mark_implemented: 'Marquer comme implémenté',
            mitigation_verify: 'Vérifier',
            title: "Analyses d'impact relatives à la protection des données",
            new: 'Nouvelle AIPD',
            edit: "Modifier l'AIPD",
            dpia_title: 'Titre',
            activity: 'Activité',
            risk_score: 'Score de risque',
            risks: 'Risques',
            mitigations: "Mesures d'atténuation",
            add_risk: 'Ajouter un risque',
            add_mitigation: "Ajouter une mesure d'atténuation",
            necessity: 'Nécessité / Proportionnalité',
            likelihood: 'Probabilité',
            impact: 'Impact',
            severity_label: 'Gravité',
            purpose: 'Finalité',
            consultation_notes: 'Notes de consultation',
            dpo_opinion: 'Avis du DPO',
            processing_activity_ids: 'ID des activités de traitement (séparés par des virgules)',
            system_ids: 'ID des systèmes (séparés par des virgules)',
            vendor_ids: 'ID des prestataires (séparés par des virgules)',
            data_types: 'Types de données (séparés par des virgules)',
            data_types_short: 'Types de données',
            data_subjects: 'Personnes concernées (séparées par des virgules)',
            assessment_lead_id: "ID du responsable de l'évaluation",
            assessment_lead: "Responsable de l'évaluation",
            dpo_id: 'ID du DPO',
            reviewer_ids: 'ID des réviseurs (séparés par des virgules)',
            approval_mode: "Mode d'approbation",
            approval_all: 'Tous',
            approval_any: "N'importe lequel",
            require_dpo_signoff: 'Signature du DPO requise',
            review_date: 'Date de révision',
            submit_for_review: 'Soumettre pour révision',
            approve_reject: 'Approuver/Rejeter',
            deprecate: 'Déprécier',
            deprecated: 'Déprécié',
            hide_risks: 'Masquer les risques',
            hide_mitigations: "Masquer les mesures d'atténuation",
            comments: 'Commentaires',
            submit_decision: 'Soumettre la décision',
            category_label: 'Catégorie',
            category_data_breach: 'Violation de données',
            category_unauthorized_access: 'Accès non autorisé',
            category_function_creep: 'Détournement de finalité',
            category_re_identification: 'Ré-identification',
            category_discrimination: 'Traitement discriminatoire',
            category_surveillance: 'Mise sous surveillance',
            category_other: 'Autre',
            affected_rights: 'Droits affectés (séparés par des virgules)',
            no_risks: 'Aucun risque trouvé.',
            no_mitigations: "Aucune mesure d'atténuation trouvée.",
            no_dpias: 'Aucune AIPD trouvée.',
            mitigation_type: 'Catégorie',
            mitigation_technical: 'Technique',
            mitigation_organizational: 'Organisationnel',
            mitigation_contractual: 'Contractuel',
            risk_ids: 'ID des risques (séparés par des virgules)',
            responsible_party: 'Partie responsable',
            responsible_party_placeholder: 'Ou saisir le nom manuellement',
            affected_rights_placeholder: 'Les droits sélectionnés apparaissent ici',
            affected_rights_freetext_placeholder: 'Saisir les droits affectés (séparés par des virgules)',
            responsible: 'Responsable',
            target_date: 'Date cible',
            created: 'Créé',
            fetch_error: 'Échec de la récupération des AIPD. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement de l'AIPD. Veuillez réessayer.",
            submit_review_error: "Échec de la soumission de l'AIPD pour révision. Veuillez réessayer.",
            decision_error: 'Échec du traitement de la décision. Veuillez réessayer.',
            deprecate_error: "Échec de la dépréciation de l'AIPD. Veuillez réessayer.",
            fetch_risks_error: 'Échec de la récupération des risques. Veuillez réessayer.',
            save_risk_error: "Échec de l'enregistrement du risque. Veuillez réessayer.",
            delete_risk_error: 'Échec de la suppression du risque. Veuillez réessayer.',
            fetch_mitigations_error: "Échec de la récupération des mesures d'atténuation. Veuillez réessayer.",
            save_mitigation_error: "Échec de l'enregistrement de la mesure d'atténuation. Veuillez réessayer.",
            update_mitigation_status_error: "Échec de la mise à jour du statut de la mesure d'atténuation. Veuillez réessayer.",
            link_form_template: 'Modèle de formulaire réglementaire de lien',
            link_form_template_placeholder: 'Sélectionnez un modèle de formulaire [[TOK_0]] (facultatif)',
            link_form_template_none: 'Aucun',
            linked_form: 'Formulaire lié',
            linked_form_creating: "Création d'un formulaire lié...",
            linked_form_error: "Échec de la création de l'instance de formulaire liée. Le [[TOK_0]] a été créé sans formulaire lié.",
            view_linked_form: 'Voir le formulaire',
            announce_created_with_form: '[[TOK_0]] créé avec une instance de formulaire liée',
            creation_mode: '[[TOK_0]] Mode de création',
            mode_standard: 'Norme [[TOK_0]]',
            mode_template: 'Utiliser le modèle de formulaire réglementaire',
            select_form_template: 'Sélectionnez un modèle de formulaire',
            create_and_fill_form: 'Créer et remplir un formulaire',
            template_sections_title: 'Sections du modèle',
            field_singular: 'champ',
            field_plural: 'champs',
            no_sections: 'Aucune section trouvée dans ce modèle.',
            template_mode_hint: 'Après création, vous serez redirigé pour remplir le formulaire réglementaire complet.',
            linked_dossier_filings: 'Dépôts de dossier liés',
            no_linked_dossier_filings: 'Aucun dépôt de dossier lié à cette AIPD.',
            view_dossier_filing: 'Voir le dépôt',
            hide_dossier_filings: 'Masquer les dépôts de dossier',
            supporting_evidence: 'Preuve à l’appui',
            hide_supporting_evidence: 'Masquer les preuves',
            no_supporting_evidence: 'Aucune preuve à l’appui n’est jointe.',
            upload_supporting_evidence: "Télécharger des preuves à l'appui",
            view_form_responses: 'Voir les réponses du formulaire',
            regulatory_framework: 'Cadre réglementaire',
            all_frameworks: 'Tous les cadres',
            no_templates_for_market: 'Aucun modèle disponible pour le marché sélectionné. Veuillez sélectionner un autre marché ou créer un modèle.',
        },
        transfers: {
            page_title: 'Transferts de données',
            announce_found: '{count} évaluation(s) de transfert trouvée(s)',
            announce_submitted_for_review: 'Transfert soumis pour examen',
            announce_deprecated: 'Transfert obsolète',
            announce_decision: 'Transfert {decision}',
            announce_risk_eval_completed: 'Évaluation des risques terminée',
            announce_safeguard_status_updated: 'Statut de la mesure de protection mis à jour',
            announce_safeguards_loaded: '{count} mesure(s) de protection chargée(s)',
            aria_filter: 'Filtrer les évaluations de transfert',
            aria_filter_by_status: 'Filtrer par statut',
            aria_filter_by_mechanism: 'Filtrer par mécanisme de transfert',
            aria_table: 'Évaluations des transferts de données',
            title: 'Évaluations des transferts transfrontaliers',
            new: 'Nouveau transfert',
            edit: 'Modifier le transfert',
            name: 'Nom',
            from_country: "Pays d'origine",
            to_country: 'Pays de destination',
            safeguards: 'Garanties',
            risk_level: 'Niveau de risque',
            assessment_notes: "Notes d'évaluation",
            mechanism: 'Mécanisme',
            transfer_mechanism: 'Mécanisme de transfert',
            transfer_mechanism_detail: 'Détail du mécanisme de transfert',
            all_mechanisms: 'Tous les mécanismes',
            mechanism_adequacy_decision: "Décision d'adéquation",
            mechanism_sccs: 'CCS',
            mechanism_bcrs: 'BCR',
            mechanism_consent: 'Consentement',
            mechanism_derogation: 'Dérogation',
            mechanism_other: 'Autre',
            data_types: 'Types de données (séparés par des virgules)',
            data_subjects: 'Personnes concernées (séparées par des virgules)',
            purpose: 'Finalité',
            recipient_name: 'Nom du destinataire',
            create_success: 'Évaluation de transfert créée.',
            update_success: 'Évaluation de transfert mise à jour.',
            recipient_details: 'Détails du destinataire',
            recipient_details_placeholder: 'Rôle, emplacement et systèmes du destinataire, et détails du transfert ultérieur',
            vendor_id: 'ID du prestataire',
            processing_activity_ids: 'ID des activités de traitement (séparés par des virgules)',
            reviewer_ids: 'ID des réviseurs (séparés par des virgules)',
            approval_mode: "Mode d'approbation",
            approval_all: 'Tous',
            approval_any: "N'importe lequel",
            require_dpo_signoff: 'Signature du DPO requise',
            review_date: 'Date de révision',
            created: 'Créé',
            deprecated: 'Déprécié',
            submit_for_review: 'Soumettre pour révision',
            approve_reject: 'Approuver/Rejeter',
            deprecate: 'Déprécier',
            risk_eval: 'Évaluation du risque',
            hide_safeguards: 'Masquer les garanties',
            mechanism_proof: 'Preuve de mécanisme',
            hide_mechanism_proof: 'Masquer la preuve du mécanisme',
            mechanism_proof_hint: "Télécharger le mécanisme de transfert signé (SCC, BCR, décision d'adéquation, etc.) prouvant cette appréciation du transfert.",
            no_mechanism_proof: 'Aucune preuve de mécanisme jointe.',
            upload_mechanism_proof: 'Télécharger la preuve du mécanisme',
            comments: 'Commentaires',
            submit_decision: 'Soumettre la décision',
            data_sensitivity: 'Sensibilité des données (1-5)',
            country_risk: 'Risque pays (1-5)',
            safeguard_adequacy: 'Adéquation des garanties (1-5)',
            volume_factor: 'Facteur de volume (1-5)',
            evaluate: 'Évaluer',
            add_safeguard: 'Ajouter une garantie',
            responsible_party: 'Partie responsable',
            responsible_party_placeholder: 'Ou saisir le nom manuellement',
            responsible: 'Responsable',
            implementation_date: 'Date de mise en œuvre',
            implementation: 'Mise en œuvre',
            expiry_date: "Date d'expiration",
            expiry: 'Expiration',
            expire: 'Expirer',
            no_safeguards: 'Aucune garantie trouvée.',
            no_transfers: 'Aucune évaluation de transfert trouvée.',
            fetch_error: 'Échec de la récupération des évaluations de transfert. Veuillez réessayer.',
            save_error: "Échec de l'enregistrement de l'évaluation de transfert. Veuillez réessayer.",
            submit_review_error: 'Échec de la soumission pour révision. Veuillez réessayer.',
            decision_error: 'Échec du traitement de la décision. Veuillez réessayer.',
            deprecate_error: 'Échec de la dépréciation du transfert. Veuillez réessayer.',
            risk_eval_error: "Échec de l'évaluation du risque. Veuillez réessayer.",
            fetch_safeguards_error: 'Échec de la récupération des garanties. Veuillez réessayer.',
            save_safeguard_error: "Échec de l'enregistrement de la garantie. Veuillez réessayer.",
            update_safeguard_status_error: 'Échec de la mise à jour du statut de la garantie. Veuillez réessayer.',
            safeguard_type_encryption_in_transit: 'Chiffrement en transit',
            safeguard_type_encryption_at_rest: 'Chiffrement au repos',
            safeguard_type_access_controls: "Contrôles d'accès",
            safeguard_type_contractual_clauses: 'Clauses contractuelles',
            safeguard_type_data_minimization: 'Minimisation des données',
            safeguard_type_pseudonymization: 'Pseudonymisation',
            safeguard_type_audit_rights: "Droits d'audit",
            safeguard_type_breach_notification: 'Notification de violation',
            safeguard_type_data_localization: 'Localisation des données',
            safeguard_type_other: 'Autre',
            activate: 'Activer',
            all_statuses: 'Tous les statuts',
            any: "N'importe lequel",
            mechanism_detail: 'Détail du mécanisme',
            mechanisms: {
                adequacy_decision: "Décision d'adéquation",
                sccs: 'CCS',
                bcr: 'BCR',
                bcrs: 'BCR',
                derogation: 'Dérogation',
                consent: 'Consentement',
                other: 'Autre',
            },
            safeguard_types: {
                encryption_in_transit: 'Chiffrement en transit',
                encryption_at_rest: 'Chiffrement au repos',
                access_controls: "Contrôles d'accès",
                contractual_clauses: 'Clauses contractuelles',
                data_minimization: 'Minimisation des données',
                pseudonymization: 'Pseudonymisation',
                audit_rights: "Droits d'audit",
                breach_notification: 'Notification de violation',
                data_localization: 'Localisation des données',
                other: 'Autre',
            },
        },
        gap_report: {
            page_title: "Rapport d'écarts des évaluations",
            announce_loaded: "Rapport d'écarts chargé. {count} écart(s) identifié(s)",
            aria_activities_without_dpia: 'Activités sans évaluation AIPD',
            aria_activities_unclassified: "Activités dont l'exigence d'AIPD n'est pas classifiée",
            activities_unclassified_section_title: "Activités dont l'exigence d'AIPD n'est pas classifiée",
            activities_unclassified_description: "Ces activités n'ont pas été examinées pour déterminer si une AIPD est légalement requise. Classifiez chacune pour lever le signalement.",
            activities_unclassified_empty: 'Toutes les activités actives ont été classifiées.',
            aria_unmitigated_risks: 'Risques élevés et critiques non atténués',
            aria_transfers_without_safeguards: 'Transferts sans mesures de protection adéquates',
            aria_expired_assessments: 'Évaluations expirées nécessitant un renouvellement',
            title: "Rapport d'écarts des évaluations",
            no_dpia: 'Activités sans AIPD',
            no_assessment: 'Transferts sans évaluation',
            unmitigated: 'AIPD avec risques non atténués',
            activity_id: "ID de l'activité",
            dpia_id: "ID de l'AIPD",
            assessment_id: "ID de l'évaluation",
            expired_assessments: 'Évaluations expirées',
            no_gaps_activities: 'Aucun écart trouvé. Toutes les activités ont des AIPD.',
            no_unmitigated_risks: 'Aucun risque élevé/critique non atténué trouvé.',
            no_gaps_safeguards: 'Aucun écart trouvé. Tous les transferts ont des garanties adéquates.',
            no_expired: 'Aucune évaluation expirée trouvée.',
            no_report_data: "Aucune donnée de rapport d'écarts disponible.",
            fetch_error: "Échec de la récupération du rapport d'écarts. Veuillez réessayer.",
            no_expired_assessments: 'Aucune évaluation expirée.',
            no_gaps_dpia: "Aucun écart d'AIPD trouvé.",
            no_data: 'Aucune donnée disponible.',
        },
        dossier_filings: {
            page_title_detail: 'Détail du dossier déposé',
            page_title_list: 'Dossiers déposés',
            announce_filings_found: '{count} dépôt(s) trouvé(s)',
            announce_results: '{count} résultats',
            aria_filter_by_status: 'Filtrer par statut',
            title: 'Dossiers de dépôt de dossiers',
            nav_label: 'Dépôts de dossiers',
            create: 'Créer un dépôt de dossier',
            form_type: 'Type de formulaire',
            phu_luc_i_label: 'Mẫu số 02a (Norme [[TOK_0]], Décret 356)',
            phu_luc_ii_label: 'Mẫu số 02b (Transfrontalier / À haut risque [[TOK_0]], Décret 356)',
            dpia_reference: '[[TOK_0]] Référence',
            submitted_date: 'Date de soumission',
            outcome: 'Résultat',
            parent_filing: 'Parent',
            no_filings: 'Aucun dépôt de dossier trouvé.',
            fetch_error: 'Échec de la récupération des dossiers. Veuillez réessayer.',
            save_error: 'Échec de la création du dossier de dossier. Veuillez réessayer.',
            created: 'Dépôt de dossier créé.',
            loaded: 'Dépôt de dossier chargé.',
            not_found: 'Dossier de dépôt introuvable.',
            back_to_list: 'Retour à la liste',
            section_assignments: 'Affectations des sections',
            assign_sections: 'Attribuer des sections',
            section_id: 'Section',
            department: 'Département',
            assignee: 'Cessionnaire',
            deadline: 'Échéance',
            no_assignments: "Aucune affectation de section pour l'instant.",
            sections_assigned_msg: 'Sections attribuées.',
            assign_error: "Échec de l'attribution des sections. Veuillez réessayer.",
            lifecycle: 'Cycle de vie du dépôt',
            submission: 'Détails de la soumission',
            submission_channel: 'Canal de soumission',
            mps_portal: '[[TOK_0]] Portail',
            in_person: 'En personne',
            postal: 'Poste',
            confirmation_number: 'Numéro de confirmation',
            submit_for_review: 'Soumettre pour révision',
            submitted_for_review: 'Soumis pour examen interne.',
            submit_review_error: 'Échec de la soumission pour examen. Veuillez réessayer.',
            legal_signoff: 'Approbation légale',
            legal_signoff_done: 'Approbation légale terminée.',
            legal_signoff_error: "Échec de l'approbation légale. Veuillez réessayer.",
            approve: 'Approuver',
            approved_msg: 'Dépôt approuvé.',
            approve_error: "Échec de l'approbation du dépôt. Veuillez réessayer.",
            materialisation_status_column: 'Artefact de soumission',
            materialisation_na: 'Sans objet',
            materialisation_pending: 'En attente',
            materialisation_success: 'Matérialisé',
            materialisation_failed: 'Échec',
            materialisation_banner_title: "L'artefact de soumission n'a pas pu être créé",
            materialisation_banner_body: "Le dépôt a été approuvé, mais le dossier sous-jacent n'a pas pu être créé. Les exportations de lettres de motivation et de soumissions ne sont pas disponibles jusqu'à ce que vous réessayiez.",
            materialisation_retry_button: 'Réessayer',
            materialisation_retry_count: 'Nouvelles tentatives précédentes :',
            materialisation_retry_success: "L'artefact de soumission s'est matérialisé avec succès.",
            materialisation_retry_announce: 'Nouvelle tentative réussie',
            filter_materialisation_failed: 'Afficher uniquement les échecs de matérialisation',
            column_title: 'Titre',
            column_form_type: 'Formulaire',
            submit_to_mps: 'Envoyer à [[TOK_0]]',
            submitted_to_mps_msg: 'Soumis à [[TOK_0]].',
            submit_mps_error: 'Échec de la soumission à [[TOK_0]]. Veuillez réessayer.',
            supplement_request: 'Demande de supplément',
            supplement_requests: 'Demandes de supplément',
            supplement_response: 'Réponse complémentaire',
            record_supplement: 'Demande de supplément au dossier',
            supplement_recorded: 'Demande de supplément enregistrée.',
            supplement_error: "Échec de l'enregistrement de la demande de supplément. Veuillez réessayer.",
            submit_supplement: 'Soumettre une réponse supplémentaire',
            supplement_submitted_msg: 'Réponse supplémentaire soumise.',
            supplement_submit_error: "Échec de l'envoi de la réponse supplémentaire. Veuillez réessayer.",
            response_status: 'Statut de la réponse',
            response_notes: 'Notes de réponse',
            resubmit: 'Soumettre à nouveau',
            resubmitted_msg: 'Dossier soumis à nouveau.',
            resubmit_error: 'Échec de la soumission à nouveau du dossier. Veuillez réessayer.',
            record_outcome: 'Enregistrer le résultat',
            outcome_recorded: 'Résultat enregistré.',
            outcome_error: "Échec de l'enregistrement du résultat. Veuillez réessayer.",
            accepted: 'Accepté',
            rejected: 'Rejeté',
            close: 'Fermer',
            closed_msg: 'Dossier clos.',
            close_error: 'Échec de la clôture du dossier. Veuillez réessayer.',
            change_filing: 'Créer un dépôt de modification',
            change_filing_created: 'Modification du dossier créé.',
            change_filing_error: 'Échec de la création du dossier de modification. Veuillez réessayer.',
            change_reason: 'Raison du changement',
            filing_lineage: 'Lignée de dépôt',
            timers: 'Minuteries actives',
            timer_mps_review: '[[TOK_0]] Révision',
            timer_supplement: 'Date limite du supplément',
            timer_resubmission: 'Date limite de nouvelle soumission',
            timer_department: 'Date limite du département',
            days_remaining: 'jours restants',
            days_overdue: 'jours de retard',
            cover_letter: 'Lettre de motivation',
            checklist: 'Liste de contrôle',
            evidence_index: 'Index des preuves',
            status_draft: 'Brouillon',
            status_sections_assigned: 'Sections attribuées',
            status_internal_review: 'Revue interne',
            status_legal_signoff: 'Approbation légale',
            status_approved: 'Approuvé',
            status_submitted_to_mps: 'Envoyé à [[TOK_0]]',
            status_supplement_requested: 'Complément demandé',
            status_supplement_submitted: 'Supplément soumis',
            status_resubmitted: 'Resoumis',
            status_accepted: 'Accepté',
            status_rejected: 'Rejeté',
            status_closed: 'Clôturé',
            linked_dpia: 'AIPD liée',
            linked_dpia_none: 'Aucune AIPD liée à ce dépôt.',
            view_linked_dpia: "Voir l'AIPD",
            linked_dpia_label: "Ce dépôt de dossier est lié à l'AIPD suivante :",
        },
        materialisation_health: {
            nav_label: 'Santé des artefacts de soumission',
            page_title: 'Santé des artefacts de soumission',
            page_description: 'Détecter et résoudre les problèmes de matérialisation des dossiers. Les listes sont limitées à votre organisation.',
            failed_title: 'Échec des matérialisations',
            failed_empty: 'Aucune matérialisation ratée – bien.',
            pending_title: 'Approuvé mais non matérialisé',
            pending_empty: "Tous les dépôts approuvés sont accompagnés d'un dossier.",
            orphan_title: 'Dossiers orphelins',
            orphan_description: "Des dossiers créés par matérialisation qui ne sont plus référencés par aucun dossier – généralement le perdant d'une course concurrente. Répertorié pour enquête ; le nettoyage est manuel.",
            orphan_empty: 'Aucun dossier orphelin détecté.',
            materialise_button: 'Matérialisez-vous maintenant',
            column_failure_reason: "Raison de l'échec",
            column_failed_at: 'Échec à',
            column_retries: 'Nouvelles tentatives',
            column_approved_at: 'Approuvé à',
            column_dossier_id: 'ID du dossier',
            column_source_filing_id: 'Dépôt source',
            column_dossier_type: 'Tapez',
            column_created_at: 'Créé à',
        },
    },
    classification: {
        access_denied_title: 'Accès refusé',
        access_denied: 'Vous ne disposez pas des autorisations requises pour accéder au module Classification. Contactez votre administrateur.',
        nav: {
            taxonomies: 'Classifications',
            labeling: 'Étiquetage',
            lifecycle: 'Cycle de vie',
            gaps: "Rapport d'écarts",
            exports: 'Exportations',
        },
        exports: {
            title: 'Exportations de classification',
            csv_section: 'Exportations CSV',
            pdf_section: 'Rapports PDF',
            inventory: 'Inventaire',
            classification_register: 'Registre de classification',
            raci: 'Matrice RACI',
            exceptions: 'Exceptions',
            evidence_pack: 'Dossier de preuves',
            delta_report: 'Rapport delta',
            executive_summary: 'Synthèse exécutive',
            exporting: 'Exportation en cours…',
            export_success: 'Exportation terminée avec succès.',
            export_error: "L'exportation a échoué. Veuillez réessayer.",
            csv_download: 'Téléchargement CSV prêt.',
            pdf_download: 'Génération du PDF démarrée.',
            no_data: "Aucune donnée disponible pour l'exportation.",
        },
        delta: {
            title: 'Détail des modifications',
            added: 'Ajoutés',
            removed: 'Supprimés',
            changed: 'Modifiés',
            added_count: 'Ajoutés ({count})',
            removed_count: 'Supprimés ({count})',
            changed_count: 'Modifiés ({count})',
            object_id: 'ID objet',
            object_type: "Type d'objet",
            taxonomy: 'Taxonomie',
            level: 'Niveau',
            previous: 'Précédent',
            current: 'Actuel',
            no_records: 'Aucun enregistrement dans cette section.',
            empty_section: 'Cette section est vide.',
        },
        schedule: {
            title: 'Planifier le cycle de découverte',
            enabled: 'Activé',
            interval_days: 'Intervalle (jours)',
            interval_label: 'Exécuter tous les N jours',
            manual_only: 'Manuel uniquement',
            every_n_days: 'Tous les {n} jours',
            save: 'Enregistrer le planning',
            cancel: 'Annuler',
            schedule_updated: 'Planning mis à jour avec succès.',
        },
        taxonomies: {
            title: 'Taxonomies de classification',
            new: 'Nouvelle taxonomie',
            edit: 'Modifier la taxonomie',
            name: 'Nom',
            levels: 'Niveaux de classification',
            seed_defaults: 'Initialiser les valeurs par défaut',
            scope: 'Périmètre',
            scope_organization: 'Organisation',
            scope_module_specific: 'Spécifique au module',
            deprecate: 'Déprécier',
            hide_levels: 'Masquer les niveaux',
            versions: 'Révisions',
            hide_versions: 'Masquer les versions',
            add_level: 'Ajouter un niveau',
            new_level: 'Nouveau niveau',
            edit_level: 'Modifier le niveau',
            code: 'Identifiant',
            label: 'Libellé',
            color: 'Couleur',
            ordinal: "Numéro d'ordre",
            handling_requirements: 'Exigences de traitement',
            version_history: 'Historique des versions',
            changes: 'Modifications',
            failed_fetch: 'Échec de la récupération des taxonomies. Veuillez réessayer.',
            failed_save: "Échec de l'enregistrement de la taxonomie. Veuillez réessayer.",
            failed_activate: "Échec de l'activation de la taxonomie. Veuillez réessayer.",
            failed_deprecate: 'Échec de la dépréciation de la taxonomie. Veuillez réessayer.',
            failed_seed: "Échec de l'initialisation des taxonomies par défaut. Veuillez réessayer.",
            failed_fetch_levels: 'Échec de la récupération des niveaux de taxonomie. Veuillez réessayer.',
            failed_save_level: "Échec de l'enregistrement du niveau de taxonomie. Veuillez réessayer.",
            failed_delete_level: 'Échec de la suppression du niveau de taxonomie. Veuillez réessayer.',
            failed_fetch_versions: 'Échec de la récupération des versions de taxonomie. Veuillez réessayer.',
            loaded_count: '{count} taxonomies chargées',
            defaults_seeded: 'Taxonomies par défaut initialisées.',
            no_levels: 'Aucun niveau de classification défini — ajoutez des niveaux pour définir votre hiérarchie de classification.',
            no_versions: "Pas encore d'historique de versions — les versions sont créées lorsqu'une taxonomie active est mise à jour.",
        },
        labeling: {
            title: 'Étiquetage des données',
            new: 'Nouvelle étiquette',
            edit: "Modifier l'étiquette",
            entity_type: "Type d'entité",
            entity_id: "Identifiant de l'entité",
            taxonomy: 'Taxonomie',
            classification_level: 'Niveau de classification',
            applied_by: 'Appliqué par',
            applied_at: 'Appliqué le',
            bulk_apply: 'Application en masse',
            bulk_remove: 'Suppression en masse',
            all_taxonomies: 'Toutes les taxonomies',
            system: 'Système',
            dataset: 'Jeu de données',
            level_code_placeholder: 'Code du niveau...',
            select_taxonomy: 'Sélectionner une taxonomie...',
            select_level: 'Sélectionner un niveau...',
            rationale: 'Justification',
            review_date: 'Date de révision',
            review: 'Réviser',
            selected: 'sélectionné(s)',
            select_all_labels: 'Sélectionner tous les libellés',
            loaded_count: '{count} libellés chargés',
            hide_stale_labels: 'Masquer les étiquettes obsolètes',
            show_conflicts: 'Afficher les conflits',
            hide_conflicts: 'Masquer les conflits',
            label_conflicts: "Conflits d'étiquettes",
            conflict_reason: 'Raison du conflit',
            labels: 'Étiquettes',
            failed_fetch: 'Échec de la récupération des étiquettes. Veuillez réessayer.',
            failed_fetch_taxonomies: 'Échec de la récupération des taxonomies. Veuillez réessayer.',
            failed_fetch_levels: 'Échec de la récupération des niveaux de taxonomie. Veuillez réessayer.',
            failed_save: "Échec de l'enregistrement de l'étiquette. Veuillez réessayer.",
            failed_review: "Échec de la révision de l'étiquette. Veuillez réessayer.",
            failed_bulk: "Échec de l'étiquetage en masse. Veuillez réessayer.",
            failed_stale: 'Échec de la récupération des étiquettes obsolètes. Veuillez réessayer.',
            failed_conflicts: "Échec de la récupération des conflits d'étiquettes. Veuillez réessayer.",
            review_permission_denied: "Vous n'avez pas la permission de réviser cette étiquette.",
            review_not_found: 'Étiquette introuvable — elle a peut-être été supprimée.',
            approve_selected: 'Approuver la sélection',
            reject_selected: 'Rejeter la sélection',
            approved: 'Approuvée',
            rejected: 'Rejetée',
            labels_count: 'étiquettes',
            failed_count: 'échouées',
            confirm_approve: "Confirmer l'approbation",
            confirm_reject: 'Confirmer le rejet',
            approve_n_labels: 'Approuver {count} étiquettes ?',
            reject_n_labels: 'Rejeter {count} étiquettes ?',
            submit_for_review: 'Soumettre pour révision',
            approve: 'Approuver',
            reject: 'Rejeter',
            parent_system: 'Systeme parent',
            parent_system_placeholder: 'Selectionner le systeme parent...',
            parent_system_help: 'Utilise pour la detection des conflits.',
            dataset_level: 'Niveau du jeu de donnees',
            parent_level: 'Niveau parent',
            bulk_created: '{created} etiquette(s) creee(s)',
            bulk_skipped: '{skipped} ignoree(s)',
            bulk_all_skipped: 'Toutes les {skipped} ignorees',
            ids_hint: 'Saisissez des identifiants separes par des virgules',
            delete_confirm: 'Supprimer etiquette pour "{id}" ?',
        },
        lifecycle: {
            title: 'Suivi du cycle de vie des données',
            new: 'Nouvelle entrée',
            current_stage: 'Étape actuelle',
            last_transition: 'Dernière transition',
            transition: "Changement d'état",
            view_history: "Voir l'historique",
            stages: {
                creation: 'Création',
                collection: 'Collecte',
                processing: 'Traitement',
                storage: 'Stockage',
                retention: 'Conservation',
                disposal: 'Élimination',
                archived: 'Archivé',
                active: 'Actif',
                pending_deletion: 'Suppression en attente',
                deleted: 'Supprimé',
                on_hold: 'En attente',
            },
            all_stages: 'Toutes les étapes',
            object_id: "ID de l'objet",
            object_type: "Type d'objet",
            policy_reference: 'Référence de politique',
            retention_period_days: 'Période de conservation (jours)',
            retention_basis: 'Base de conservation',
            deletion_method: 'Méthode de suppression',
            deletion_secure_erase: 'Effacement sécurisé',
            deletion_anonymization: 'Anonymisation',
            deletion_physical_destruction: 'Destruction physique',
            deletion_other: 'Autre',
            responsible_party: 'Partie responsable',
            responsible_user_id: "ID de l'utilisateur responsable",
            retention_expiry: 'Expiration de la conservation',
            hold_reason: 'Motif de la mise en attente',
            hold: 'Mettre en attente',
            release: 'Libérer',
            hide_events: 'Masquer les événements',
            events_timeline: 'Chronologie des événements',
            add_event: 'Ajouter un événement',
            event_type: "Type d'événement",
            create_event: 'Créer un événement',
            from_stage: "Étape d'origine",
            to_stage: 'Étape de destination',
            actor: 'Acteur',
            reason_placeholder: 'Motif...',
            go: 'Exécuter',
            show_expired_retentions: 'Afficher les conservations expirées',
            hide_expired_retentions: 'Masquer les conservations expirées',
            expired_retentions_alert: 'Alerte de conservations expirées',
            failed_fetch: 'Échec de la récupération des enregistrements du cycle de vie. Veuillez réessayer.',
            failed_save: "Échec de l'enregistrement du cycle de vie. Veuillez réessayer.",
            failed_transition: "Échec de la transition de l'étape du cycle de vie. Veuillez réessayer.",
            failed_hold: 'Échec de la mise en attente. Veuillez réessayer.',
            failed_release: 'Échec de la libération. Veuillez réessayer.',
            failed_fetch_events: 'Échec de la récupération des événements du cycle de vie. Veuillez réessayer.',
            failed_create_event: "Échec de la création de l'événement du cycle de vie. Veuillez réessayer.",
            failed_expired: 'Échec de la récupération des conservations expirées. Veuillez réessayer.',
            hold_reason_prompt: 'Saisissez le motif de la mise en attente :',
            loaded_count: '{count} enregistrements de cycle de vie chargés',
            stage_transition_for: "Transition d'étape pour {id}",
            event_created: 'Créé',
            event_updated: 'Mis à jour',
            event_approved: 'Approuvé',
            event_deprecated: 'Obsolète',
            event_proposed: 'Proposé',
            event_reviewed: 'Révisé',
            event_archived: 'Archivé',
            event_restored: 'Restauré',
        },
        gap_report: {
            title: "Rapport d'écarts de classification",
            unlabeled: 'Données non étiquetées',
            missing_lifecycle: 'Cycle de vie manquant',
            stale_labels: 'Étiquettes obsolètes',
            run_detection: "Lancer la détection d'écarts",
            detecting: 'Détection en cours...',
            detection_complete: "Détection d'écarts terminée. {count} écart(s) détecté(s).",
            detection_failed: "Échec de la détection d'écarts.",
            by_severity: 'Par gravité',
            by_gap_type: "Par type d'écart",
            all_gap_types: "Tous les types d'écarts",
            conflicting_labels: 'Étiquettes en conflit',
            expired_retention: 'Conservation expirée',
            missing_handling: 'Traitement manquant',
            info: 'Informations',
            gap_type: "Type d'écart",
            object_id: "ID de l'objet",
            object_type: "Type d'objet",
            detected_at: 'Détecté le',
            open: 'Ouvert',
            acknowledged: 'Accusé de réception',
            remediated: 'Remédié',
            accepted: 'Accepté',
            acknowledge: 'Accuser réception',
            remediate: 'Remédier',
            accept_risk: 'Accepter le risque',
            accept_risk_prompt: "Saisissez la justification de l'acceptation du risque :",
            failed_fetch: 'Échec de la récupération des écarts. Veuillez réessayer.',
            failed_acknowledge: "Échec de l'accusé de réception de l'écart. Veuillez réessayer.",
            failed_remediate: "Échec de la remédiation de l'écart. Veuillez réessayer.",
            failed_accept_risk: "Échec de l'acceptation du risque de l'écart. Veuillez réessayer.",
            failed_detect: "Échec de l'exécution de la détection d'écarts. Veuillez réessayer.",
            loaded_count: '{count} lacunes de classification chargées',
            related_object_id: "ID de l'objet associé",
            related_object_type: "Type de l'objet associé",
            gap_types: {
                unlabeled_asset: 'Actif sans étiquette',
                missing_lifecycle: 'Cycle de vie manquant',
                expired_retention: 'Rétention expirée',
                extended_pending_deletion: 'Suppression en attente étendue',
            },
        },
        label_workflow: {
            title: "Flux d'étiquettes",
            proposed: 'Proposé',
            under_review: 'En cours de révision',
            approved: 'Approuvé',
            deprecated: 'Obsolète',
            submit_review: 'Soumettre pour révision',
            approve: "Approuver l'étiquette",
            deprecate: 'Rendre obsolète',
            bulk_approve: 'Approbation en masse',
            bulk_approve_success: 'Étiquettes approuvées avec succès.',
            submit_success: 'Étiquette soumise pour révision.',
            approve_success: 'Étiquette approuvée.',
            deprecate_success: 'Étiquette rendue obsolète.',
        },
        review_tasks: {
            title: 'Tâches de révision',
            create: 'Nouvelle tâche de révision',
            system: 'Système',
            owner: 'Propriétaire',
            description: 'Descriptif',
            resolution: 'Résolution',
            resolve: 'Résoudre',
            approve: 'Approuver',
            modify: 'Modifier',
            reject: 'Rejeter',
            escalate: 'Escalader',
            escalated: 'Tâches escaladées',
            no_tasks: 'Aucune tâche de révision.',
            resolve_success: 'Tâche de révision résolue.',
            status_pending: 'En attente',
            status_resolved: 'Résolue',
            status_escalated: 'Escaladée',
            notes: 'Remarques',
            create_success: 'Tâche de révision créée.',
            no_tasks_detail: "Pas encore de tâches de révision — créez une tâche pour assigner des révisions d'étiquettes aux propriétaires de systèmes.",
            label_id: "ID d'étiquette",
            system_id: 'ID système',
            system_name: 'Nom du système',
            owner_id: 'ID du propriétaire',
            resolution_col: 'Résolution',
            notes_col: 'Remarques',
        },
        exceptions: {
            title: "File d'attente des exceptions",
            create: 'Nouvelle exception',
            severity: 'Sévérité',
            system: 'Système',
            owner: 'Propriétaire',
            resolve: 'Résoudre',
            no_exceptions: 'Aucune exception trouvée.',
            resolve_success: 'Exception résolue.',
            dashboard_open: 'Exceptions ouvertes',
            dashboard_resolved: 'Exceptions résolues',
            dashboard_total: 'Total',
            dashboard_by_severity: 'Par sévérité',
            status_open: 'Ouverte',
            status_resolved: 'Résolue',
            status_accepted_risk: 'Risque accepté',
            create_success: 'Exception créée.',
            no_exceptions_detail: "Pas encore d'exceptions — les exceptions sont créées à partir de lacunes de haute sévérité nécessitant un traitement spécial.",
            gap_id: 'ID de lacune',
            system_id: 'ID système',
            system_name: 'Nom du système',
            owner_id: 'ID du propriétaire',
            resolution_notes: 'Notes de résolution',
            resolution_notes_placeholder: 'Décrivez comment cette exception a été résolue...',
        },
        enterprise_map: {
            title: 'Carte des données entreprise',
            inventory: 'Inventaire des données',
            total_systems: 'Total des systèmes',
            total_labels: 'Total des étiquettes',
            approved_count: 'Étiquettes approuvées',
            proposed_count: 'Étiquettes proposées',
            no_data: 'Aucune donnée de classification disponible.',
            no_approved_labels: "Pas encore d'étiquettes approuvées — les étiquettes doivent être révisées et approuvées avant d'apparaître sur la carte des données.",
            loaded_count: "Carte de données d'entreprise chargée",
        },
        discovery: {
            title: 'Cycles de découverte',
            create: 'Nouveau cycle',
            cycle_name: 'Nom du cycle',
            run_delta: 'Lancer la détection delta',
            delta_success: 'Détection delta terminée.',
            create_success: 'Cycle de découverte créé.',
            no_cycles: 'Aucun cycle de découverte.',
            status_created: 'Créé',
            status_scanning: 'Numérisation',
            status_review: 'Examen',
            status_approved: 'Approuvé',
            status_published: 'Publié',
            status_draft: 'Brouillon',
            running: 'En cours',
            completed: 'Terminé',
            cancelled: 'Annulé',
            delta_result_summary: '{added} ajoutées, {removed} supprimées, {changed} étiquettes modifiées trouvées.',
            delta_results: 'Résultats delta',
            view_results: 'Voir les résultats',
            scope_type: 'Type de portée',
            scope_type_all: 'Tout',
            scope_type_systems: 'Systèmes',
            scope_type_datasets: 'Ensembles de données',
            scope_ids: 'ID de portée',
            scope_ids_placeholder: 'Saisissez les identifiants séparés par des virgules',
            cycle_explanation: 'Un cycle de découverte analyse votre infrastructure de données pour identifier, classer et suivre les actifs de données. Configurez la portée pour cibler des systèmes ou des ensembles de données spécifiques.',
            empty_state_title: "Aucun cycle de découverte pour l'instant",
            empty_state_description: 'Créez votre premier cycle de découverte pour commencer à analyser et classer vos actifs de données.',
            empty_state_cta: 'Créer le premier cycle',
            validation_name_required: 'Le nom du cycle est obligatoire',
            validation_scope_type_required: 'Le type de portée est requis',
            validation_scope_ids_required: 'Au moins un ID de portée est requis',
        },
        regulatory: {
            sensitivity_importance_info: 'La loi sur les données (loi [[TOK_0]], req. 18e4bfd1) nécessite une classification par sensibilité et par importance en tant que dimensions distinctes. Créez une taxonomie pour chaque dimension pour satisfaire à cette exigence.',
            handling_rules_info: 'Chaque niveau de classification doit définir des règles de traitement par demande. b89981ac ("Définir les règles de traitement par niveau de classification").',
            template_internal_ids_info: "Tous les modèles de classification utilisent des identifiants internes (par exemple vn_data_law_data_classification_record). Aucun modèle n'est présenté comme un formulaire officiel du ministère.",
            ai_risk_tiers_info: 'La loi [[TOK_0]] (loi [[TOK_3]], req. 3a87ad63) définit quatre niveaux de risque système [[TOK_1]] : minimal, limité, élevé et inacceptable. Créez une taxonomie de risque [[TOK_2]] avec ces niveaux.',
            ai_risk_tier_minimal: 'Minime',
            ai_risk_tier_limited: 'Limite',
            ai_risk_tier_high: 'Eleve',
            ai_risk_tier_unacceptable: 'Inacceptable',
            ai_register_info: "Les enregistrements de classification [[TOK_0]] doivent être liés à une entrée du registre système [[TOK_1]] (requête 0f4475d3) capturant : le nom du système, le propriétaire, l'objectif, le contexte de déploiement, le niveau de risque, l'implication du fournisseur.",
            ai_template_internal_info: "Les modèles de classification [[TOK_0]] utilisent des identifiants internes (par exemple, [[TOK_1]]-RISK-01). Aucun identifiant d'espace réservé officiel [[TOK_2]] ([[TOK_3]]-HC-01 à [[TOK_4]]-HC-08) n'est utilisé.",
            ai_audit_trail_info: "Les modifications de classification [[TOK_0]] produisent une piste d'audit versionnée par UC-VN-06 : acteur, horodatage, valeur précédente, nouvelle valeur et justification.",
            lifecycle_data_d1_info: 'Les transitions du cycle de vie correspondent aux étapes de la procédure Data Law DATA-D1 : cataloguer, classer, définir des règles de traitement, capturer des preuves, planifier des révisions.',
            lifecycle_deletion_link_info: 'Un actif de données classifiées arrivant en fin de vie doit déclencher un enregistrement de planification de suppression via le module Deletion Orchestration.',
            lifecycle_evidence_info: "Chaque changement d'état du cycle de vie (ébauche, actif, en cours de révision, archivé, supprimé) capture l'acteur, l'horodatage et la justification sous forme d'entrée de piste d'audit.",
            escalation_timers_info: "UC-VN-10 délais de remontée : 5 jours ouvrés pour l'examen par le propriétaire, 48 heures pour la remontée d'une exception, 72 heures pour les éléments à haut risque/sensibles.",
            escalation_owner_review: '5 jours ouvres',
            escalation_exception: '48 heures',
            escalation_high_risk: '72 heures',
            gap_risk_areas_info: "Loi sur les données requise. f6c3060a (« Évaluation des risques liés aux données ») nécessite une analyse des écarts dans 4 domaines de risque : confidentialité, cybersécurité, contrôle d'accès et risque opérationnel.",
            gap_risk_area_privacy: 'Vie privee',
            gap_risk_area_cybersecurity: 'Cybersecurite',
            gap_risk_area_access: "Controle d'acces",
            gap_risk_area_operational: 'Operationnel',
            gap_framework_filter_info: "Filtrez les lacunes par cadre réglementaire (VN_DATA_LAW ou VN_AI_LAW_2026) pour afficher les lacunes pertinentes pour chaque champ d'application réglementaire.",
            framework_vn_data_law: 'Loi sur les donnees VN',
            framework_vn_ai_law: "Loi sur l'IA VN 2026",
            enterprise_map_approved_info: "Cette carte de données affiche uniquement les enregistrements de classification approuvés selon l'étape 10 du flux de travail UC-VN-10 (« Les étiquettes approuvées deviennent la vérité actuelle de l'entreprise »). Les brouillons et les dossiers proposés sont exclus.",
            exports_bundle_info: "Les ensembles d'exportation comprennent : le registre de classification, les règles de traitement, la propriété/RACI et le pack de preuves – correspondant aux exigences d'exportation de UC-VN-10 et au format de feuille de preuves DATA-EVD-01.",
        },
    },
    monitoring: {
        no_permission_title: 'Autorisations insuffisantes',
        no_permission_message: 'Vous navez pas la permission dacceder a ce module de surveillance.',
        errors: {
            fetch: 'Échec du chargement.',
            save: "Échec de l'enregistrement.",
            fetch_programs_failed: 'Échec de la récupération des programmes.',
            fetch_kpi_failed: 'Échec de la récupération des données KPI.',
            create_snapshot_failed: "Échec de la création de l'instantané.",
            fetch_periods_failed: 'Échec de la récupération des périodes.',
            create_period_failed: 'Échec de la création de la période.',
            auto_generate_failed: 'Échec de la génération automatique des périodes.',
            start_period_failed: 'Échec du démarrage de la période.',
            close_period_failed: 'Échec de la clôture de la période.',
            save_program_failed: "Échec de l'enregistrement du programme.",
            activate_program_failed: "Échec de l'activation du programme.",
            pause_program_failed: 'Échec de la suspension du programme.',
            complete_program_failed: 'Échec de la finalisation du programme.',
            archive_program_failed: "Échec de l'archivage du programme.",
            fetch_ric_templates_failed: 'Échec de la récupération des modèles RIC.',
            fetch_ric_cases_failed: 'Échec de la récupération des dossiers RIC.',
            create_ric_case_failed: 'Échec de la création du dossier RIC.',
            transition_ric_failed: 'Échec de la transition du dossier RIC.',
            add_follow_up_failed: "Échec de l'ajout du suivi.",
            respond_follow_up_failed: 'Échec de la réponse au suivi.',
            link_evidence_failed: 'Échec de la liaison de la preuve.',
            fetch_task_templates_failed: 'Échec de la récupération des modèles de tâches.',
            save_task_template_failed: "Échec de l'enregistrement du modèle de tâche.",
            delete_task_template_failed: 'Échec de la suppression du modèle de tâche.',
            delete_framework_link_failed: 'Échec de la suppression du lien vers le cadre réglementaire.',
            seed_defaults_failed: "Échec de l'initialisation des valeurs par défaut.",
            fetch_tasks_failed: 'Échec de la récupération des tâches.',
            create_task_failed: 'Échec de la création de la tâche.',
            instantiate_tasks_failed: "Échec de l'instanciation des tâches.",
            start_task_failed: 'Échec du démarrage de la tâche.',
            complete_task_failed: 'Échec de la finalisation de la tâche.',
            defer_task_failed: 'Échec du report de la tâche.',
            block_task_failed: 'Échec du blocage de la tâche.',
            override_complete_failed: 'Échec du forçage de la clôture.',
            assign_task_failed: "Échec de l'attribution de la tâche.",
            update_checklist_failed: 'Échec de la mise à jour de la liste de contrôle.',
        },
        nav: {
            programs: 'Programmes',
            periods: 'Périodes',
            task_templates: 'Modèles de tâches',
            tasks: 'Tâches',
            kpi: 'Tableau de bord KPI',
            ric: 'Demandes des autorités',
            framework_link: 'Surveillance du cadre',
            authority_readiness: 'Préparation autorités',
            change_review: 'Revue des modifications',
            raci: 'Matrice RACI',
        },
        programs: {
            page_title: 'Programmes de surveillance',
            title: 'Programmes de surveillance',
            new: 'Nouveau programme',
            edit: 'Modifier le programme',
            name: 'Nom',
            scope: 'Périmètre',
            frequency: 'Fréquence',
            owner: 'Responsable',
            activate: 'Activer',
            pause: 'Suspendre',
            resume: 'Reprendre',
            complete: 'Terminer',
            archive: 'Archiver',
            custom_frequency_days: 'Fréquence personnalisée (jours)',
            select_user: 'Sélectionner un utilisateur…',
            assign_training: 'Attribuer une formation',
            linked_forms: 'Formulaires liés',
            linked_forms_none: 'Aucun formulaire lié pour le moment',
            loaded_count: '{0} programmes chargés',
            scope_labels: {
                full: 'Complet',
                partial: 'Partiel',
                targeted: 'Ciblé',
                consent: 'Consentement',
                dpia: 'DPIA',
                vendors: 'Fournisseurs',
                classification: 'Classement',
                rights_requests: 'Demandes de droits',
                data_mapping: 'Cartographie des données',
                transfers: 'Transferts',
                security_monitoring: 'Surveillance de la sécurité',
                authority_response: "Réponse de l'autorité",
                evidence_preservation: 'Préservation des preuves',
                localization_review: 'Examen de la localisation',
                ai_system_registration: '[[TOK_0]] Enregistrement du système',
                ai_pre_deployment: '[[TOK_0]] Évaluation préalable au déploiement',
                ai_transparency: '[[TOK_0]] Contrôle de transparence',
                ai_incident_review: '[[TOK_0]] Examen des incidents',
            },
            framework_cadence_info: 'Cybersecurity Law programs typically use continuous/monthly/quarterly cadences. AI Law programs typically use annual review cadences.',
        },
        periods: {
            page_title: 'Périodes de surveillance',
            title: 'Périodes de revue',
            new: 'Nouvelle période',
            label: 'Libellé de la période',
            start_date: 'Date de début',
            end_date: 'Date de fin',
            reviewers: 'Réviseurs',
            auto_generate: 'Générer automatiquement les périodes',
            start: 'Démarrer',
            close: 'Clôturer',
            change_digest: 'Synthèse des modifications',
            no_digest: 'Aucun résumé disponible.',
            reviewers_count: 'Nombre de réviseurs',
            select_program: 'Sélectionnez programme',
            select_program_prompt: 'Sélectionnez program to view periods.',
            hide_digest: 'Masquer Résumer',
            loaded_count: '[[TOK_1]] périodes chargées',
            periods_auto_generated: 'Périodes générées automatiquement',
            label_placeholder: 'ex. 2026-Q1',
        },
        task_templates: {
            page_title: 'Modèles de tâches',
            title: 'Modèles de tâches',
            new: 'Nouveau modèle',
            edit: 'Modifier le modèle',
            category: 'Catégorie',
            priority: 'Priorité',
            checklist_items: 'Éléments de la liste de contrôle',
            effort: 'Effort estimé (heures)',
            pre_seeded: 'Pré-initialisé',
            seed_defaults: 'Initialiser les valeurs par défaut',
            add_checklist: 'Ajouter un élément à la liste de contrôle',
            guidance: "Notes d'orientation",
            all_categories: 'Toutes les catégories',
            loaded_count: 'Modèles de tâches [[TOK_1]] chargés',
            defaults_seeded: 'Modèles de tâches par défaut prédéfinis',
            checklist_item_label: 'Élément de la liste de contrôle [[TOK_1]]',
            remove_checklist_item: "Supprimer l'élément de la liste de contrôle [[TOK_1]]",
            category_info: 'Categories cover PDPL compliance, Cybersecurity Law tasks, and AI Law tasks.',
        },
        tasks: {
            page_title: 'Tâches de revue',
            title: 'Tâches de revue',
            new: 'Nouvelle tâche',
            assigned_to: 'Attribué à',
            due_date: "Date d'échéance",
            checklist: 'Liste de contrôle',
            start: 'Démarrer',
            complete: 'Terminer',
            defer: 'Reporter',
            block: 'Bloquer',
            override_complete: 'Forcer la clôture',
            link_evidence: 'Lier une preuve',
            direct_upload_label: 'Téléverser un fichier de preuve',
            instantiate: 'Instancier à partir des modèles',
            defer_reason: 'Motif du report',
            override_justification: 'Justification du forçage',
            filter_assignee: 'Filtrer par assigné',
            select_period: 'Sélectionnez période',
            select_program: 'Sélectionnez programme',
            select_program_period_prompt: 'Sélectionnez program and period to view tasks.',
            assign_placeholder: 'Assigner à...',
            loaded_count: '{0} tâches chargées',
            tasks_instantiated: 'Tâches créées à partir des modèles',
            overdue: 'En retard',
            checklist_for: 'liste de contrôle pour',
            manage_checklist: 'Gérer la liste de contrôle',
            add_checklist_item: 'Ajouter un élément',
            checklist_item_label: 'Élément',
            checklist_item_description: 'Description',
            remove_checklist_item: 'Supprimer l’élément',
            save_checklist: 'Enregistrer la liste de contrôle',
            no_checklist_items: 'Aucun élément pour le moment.',
            confirm_delete_attachment: 'Voulez-vous vraiment supprimer ce fichier de preuve ? Cette action est irréversible.',
        },
        kpi: {
            page_title: 'Tableau de bord KPI',
            title: 'Tableau de bord KPI',
            kpi_name: 'Nom du KPI',
            current_value: 'Valeur actuelle',
            target: 'Objectif',
            trends: 'Tendances',
            capture_snapshot: 'Capturer un instantané',
            select_program: 'Sélectionnez programme',
            select_program_prompt: 'Sélectionnez program to view KPIs.',
            snapshot: 'Instantané',
            kpi_labels: {
                on_track: 'Sur Suivre',
                at_risk: 'À Risque',
                behind: 'En retard',
                rights_request_sla_rate: 'Demande de droits [[TOK_0]] Taux',
                vendor_review_currency: "Devise d'évaluation du fournisseur",
                dpia_completion_rate: "[[TOK_0]] Taux d'achèvement",
                classification_coverage: 'Couverture de la classification',
                consent_policy_currency: 'Devise de la politique de consentement',
                security_event_detection_rate: 'Taux de détection des événements de sécurité',
                evidence_preservation_compliance_rate: 'Taux de conformité en matière de préservation des preuves',
                authority_response_timeliness: 'Rapidité de réponse des autorités',
                localization_readiness_score: 'Score de préparation à la localisation',
                ai_register_completeness: '[[TOK_0]] Complétude du registre système',
                pre_deployment_gate_pass_rate: 'Taux de réussite au portail de pré-déploiement',
                transparency_disclosure_coverage: 'Couverture de la divulgation de transparence',
                ai_incident_readiness_score: '[[TOK_0]] Score de préparation aux incidents',
            },
            pdpl_kpi_info: 'The predefined KPI codes are PDPL-specific metrics. For Cybersecurity Law or AI Law monitoring, use framework-specific KPI codes.',
            cybersec_kpi_info: 'KPI de la loi sur la cybersécurité : taux de détection des événements de sécurité, taux de conformité à la préservation des preuves, rapidité de réponse des autorités, score de préparation à la localisation.',
            ai_law_kpi_info: '[[TOK_0]] KPI juridiques : [[TOK_1]] exhaustivité du registre du système, taux de réussite de la porte de pré-déploiement, couverture de la divulgation de transparence, [[TOK_2]] score de préparation aux incidents.',
            no_data: 'Aucune donnée disponible.',
            snapshot_date: "Date d'instantané",
            loaded_count: '{0} instantanés KPI chargés',
            snapshot_captured: 'Instantané KPI capturé',
            showing_chart: 'Affichage en graphique',
            showing_table: 'Affichage en tableau',
            aria_current_values: 'Valeurs actuelles KPI',
            kpi_label: 'KPI',
            actual: 'Réel',
            trend: 'Tendance',
            notes: 'Remarques',
            trend_up: 'En hausse',
            trend_down: 'En baisse',
            trend_stable: 'Stable',
        },
        ric: {
            page_title: 'Dossiers RIC',
            title: 'Dossiers de demandes des autorités de contrôle',
            new: 'Nouveau dossier',
            reference: 'Référence',
            regulator: 'Autorité de contrôle',
            inquiry_type: 'Type de demande',
            deadline: 'Date limite de réponse',
            lead: 'Responsable',
            follow_ups: 'Suivis',
            add_follow_up: 'Ajouter un suivi',
            respond: 'Répondre',
            question: 'Interrogation',
            response: 'Réponse',
            asked_at: 'Demandé le',
            no_follow_ups: 'Non follow-ups encore.',
            received_date: 'Reçu Date',
            responded_at: 'Répondu le',
            hide_follow_ups: 'Masquer Follow-ups',
            inquiry_types: {
                general: 'Général',
                investigation: 'Enquête',
                audit: 'Vérification',
                complaint: 'Plainte',
                general_audit: 'Audit général',
                rights_requests_review: 'Revue des demandes de droits',
                cross_border_transfer_review: 'Revue des transferts transfrontaliers',
                vendor_governance_review: 'Revue de la gouvernance fournisseurs',
                consent_management_review: 'Revue de la gestion du consentement',
                data_mapping_ropa_review: 'Revue de la cartographie des données / ROPA',
                incident_readiness_review: 'Revue de la préparation aux incidents',
                security_access_control_review: "Revue de la sécurité et du contrôle d'accès",
                targeted_processing_review: 'Revue du traitement ciblé',
                bank_readiness_pack: 'Dossier de préparation bancaire',
            },
            link_evidence: 'Lier Preuve',
            loaded_count: 'Cas RIC [[TOK_1]] chargés',
            to_follow_up: 'à la question complémentaire',
            overdue: 'En retard',
            overdue_indicator: 'Délai de réponse dépassé',
            template_info: 'RIC templates are internal platform templates. They are not official government-mandated forms.',
            status_labels: {
                received: 'Reçu',
                in_triage: 'En triage',
                evidence_gathering: 'Collecte de preuves',
                response_drafting: 'Rédaction de la réponse',
                internal_review: 'Revue interne',
                submitted: 'Soumis',
                follow_up: 'Suivi',
                closed: 'Clôturé',
            },
        },
        framework_link: {
            title: 'Surveillance liée au cadre',
            link_program: 'Lier le programme au cadre',
            framework_code: 'Code du cadre',
            select_framework: 'Sélectionner un cadre...',
            select_program: 'Sélectionner un programme...',
            readiness_score: 'Score de préparation',
            no_links: 'Aucun programme lié au cadre trouvé',
            seed_defaults: 'Créer les modèles par défaut',
            program_id: 'ID du programme',
            program: 'Programme',
        },
        authority_readiness: {
            title: 'Préparation aux demandes des autorités',
            create_entry: 'Nouvelle entrée de préparation',
            select_framework: 'Sélectionner un cadre...',
            framework_code: 'Cadre',
            readiness_status: 'Statut de préparation',
            readiness_package: 'Dossier de préparation',
            run_drill: 'Lancer un exercice de préparation',
            drill_success: 'Exercice de préparation enregistré',
            last_drill: 'Dernier exercice',
            never_drilled: 'Jamais',
            no_readiness: 'Aucune donnée de préparation des autorités trouvée',
            entry_created: 'Entrée de préparation créée',
            ready: 'Prêt',
            partial: 'Partiel',
            not_ready: 'Non prêt',
            items: 'items',
        },
        change_review: {
            title: 'Revue des modifications réglementaires',
            new_review: 'Nouvelle revue de modification',
            change_id: 'ID de modification',
            select_change: 'Sélectionner une modification...',
            select_framework: 'Sélectionner un cadre...',
            impact_assessment: "Évaluation d'impact",
            decision: 'Décision',
            no_action: 'Aucune action',
            internal_update: 'Mise à jour interne',
            authority_filing: 'Dépôt auprès des autorités',
            no_reviews: 'Aucune revue de modification trouvée',
            auto_cycle: 'Cycle de revue automatique',
            cadence: 'Fréquence de revue',
            framework: 'Cadre',
        },
        export_csv: 'Exporter [[TOK_0]]',
        exporting: 'Exporter…',
        export_success: '[[TOK_0]] exporté avec succès.',
        export_failed: "L'exportation de [[TOK_0]] a échoué.",
        export_attestation_pack: "Pack d'attestations d'exportation",
        staleness: {
            badge_label: '[[TOK_1]] éléments obsolètes',
            days_since: '[[TOK_1]] jours depuis la dernière mise à jour',
            detail_title: 'Articles périmés',
            accept_justification: 'Accepter avec justification',
            justification_label: 'Justification',
            no_stale: 'Aucun élément périmé trouvé.',
            threshold_label: "Seuil d'obsolescence (jours)",
            threshold_min: 'Minimum 30 jours',
            threshold_max: 'Maximum 730 jours',
            threshold_saved: "Seuil d'obsolescence mis à jour.",
        },
        csv_columns: {
            name: 'Nom',
            status: 'Statut',
            owner: 'Propriétaire',
            created_at: 'Créé à',
            updated_at: 'Mis à jour à',
            scope: 'Portée',
            frameworks: 'Cadres',
            period_label: 'Étiquette de période',
            start_date: 'Date de début',
            end_date: 'Date de fin',
            task_count: 'Nombre de tâches',
            completion_rate: "Taux d'achèvement",
            title: 'Titre',
            assigned_to: 'Attribué à',
            due_date: "Date d'échéance",
            priority: 'Priorité',
            completed_at: 'Terminé à',
            kpi_code: '[[TOK_0]] Code',
            kpi_label: '[[TOK_0]] Libellé',
            target: 'Cible',
            actual: 'Réel',
            trend: 'Tendance',
            reference: 'Référence',
            regulator: 'Régulateur',
            inquiry_type: 'Type de demande',
            lead: 'Diriger',
            received_date: 'Date de réception',
            deadline: 'Date limite',
            framework_code: 'Code-cadre',
            readiness_status: 'État de préparation',
            package_count: 'Nombre de colis',
            change_id: "Changer l'identifiant",
            impact_assessment: "Évaluation d'impact",
            decision: 'Décision',
            program: 'Programme',
            readiness_score: 'Score de préparation',
            category: 'Catégorie',
            checklist_count: 'Nombre de listes de contrôle',
            effort_hours: 'Effort (heures)',
            version: 'Version',
            department: 'Département',
            function_area: 'Zone de fonction',
            role: 'Rôle',
            assignee: 'Cessionnaire',
            frequency: 'Fréquence',
        },
        raci: {
            page_title: 'Matrice RACI de gouvernance',
            title: 'Matrice RACI de gouvernance',
            department: 'Département',
            function_area: 'Zone de fonction',
            responsible: 'Responsable',
            accountable: 'Responsable',
            consulted: 'Consulté',
            informed: 'Informé',
            assign_role: 'Attribuer un rôle RACI',
            select_program: 'Sélectionnez le programme',
            select_program_prompt: 'Sélectionnez un programme pour afficher la matrice RACI.',
            no_assignments: 'Aucune affectation RACI trouvée.',
            role_updated: 'Affectation RACI mise à jour.',
            role_labels: {
                R: 'Responsable',
                A: 'Responsable',
                C: 'Consulté',
                I: 'Informé',
            },
            loaded_count: '[[TOK_1]] affectations RACI chargées',
            single_accountability_warning: 'Un seul rôle de responsable (A) est autorisé par domaine de fonction. L’attribution d’un nouveau rôle de responsable remplacera celui existant.',
            cybersec_function_areas: 'Domaines de fonction du droit de la cybersécurité : réponse aux incidents, préservation des preuves, coopération entre autorités, examen de la localisation.',
            ai_law_function_areas: '[[TOK_0]] Domaines de fonctions juridiques : enregistrement du système, évaluation avant déploiement, transparence, gestion des incidents.',
            suggested_function_areas: 'Domaines de fonction suggérés',
        },
        prior_cycle: {
            link_label: 'Lien vers le cycle précédent',
            select_prior: 'Sélectionnez le cycle précédent…',
            linked: 'Année après année',
            no_prior: 'Aucun cycle antérieur disponible.',
            linked_success: 'Cycle antérieur lié.',
        },
        digest_table: {
            module: 'Module',
            entity_type: "Type d'entité",
            change_type: 'Changer le type',
            description: 'Descriptif',
            changed_at: 'Changé à',
        },
        view_related_ric: 'Voir les cas RIC connexes',
        linked_program: 'Programme lié',
        nav_raci: 'Matrice RACI',
    },
    incidents: {
        authority_response_draft: {
            draft_label: 'Projet de réponse',
            drafting: 'Rédaction…',
            results_heading: 'Réponses rédigées ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            counsel_label: 'Examen par un avocat requis :',
            counsel_default: "Au moins une réponse nécessite un examen par un avocat avant l'envoi.",
            requires_counsel_label: 'Nécessite un examen par un avocat.',
            accept_label: 'Accepter le brouillon',
            reject_label: 'Rejeter le brouillon',
            error_generic: 'Impossible de rédiger la réponse. Réessayez ou affinez le texte de la demande.',
        },
        breach_timeline: {
            compute_label: 'Chronologie des notifications de violation de calcul',
            computing: 'Informatique…',
            results_heading: 'Délais de notification des violations ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            handoff_label: 'Forseti suggère :',
            empty_label: 'Aucun cadre applicable pour les juridictions concernées.',
            mandatory_label: 'Champs obligatoires :',
            draft_label: 'Projet de notification',
            remaining_label: '[[TOK_1]]h restantes',
            overdue_label: 'EN RETARD par',
            acknowledge_label: 'Reconnaître – tâches créées en externe',
            acknowledging: 'Reconnaissant…',
            error_generic: 'Impossible de calculer la chronologie de la violation. Essayer à nouveau.',
        },
        breach_determination: {
            confirmed_breach: 'Confirmé Violation',
            suspected_breach: 'Violation suspectée',
            not_a_breach: 'Non un Violation',
            pending: 'En attente',
        },
        errors: {
            fetch: 'Échec de charge incidents. Veuillez réessayer.',
            save: 'Échec de save incident. Veuillez réessayer.',
            fetch_failed: 'Échec de fetch incidents. Veuillez réessayer.',
            save_failed: 'Échec de save incident. Veuillez réessayer.',
            transition_failed: 'Échec de transition incident. Veuillez réessayer.',
            close_failed: 'Échec de fermer incident. Veuillez réessayer.',
            fetch_timeline_failed: 'Échec de fetch timeline. Veuillez réessayer.',
            fetch_decisions_failed: 'Échec de fetch decisions. Veuillez réessayer.',
            triage_failed: 'Échec de update triage. Veuillez réessayer.',
            impact_update_failed: 'Échec de mise à jour impact évaluation. Veuillez réessayer.',
            breach_update_failed: 'Échec de mise à jour violation évaluation. Veuillez réessayer.',
            create_timeline_failed: 'Échec de create timeline entry. Veuillez réessayer.',
            create_decision_failed: 'Échec de create decision. Veuillez réessayer.',
            notification_update_failed: 'Échec de mise à jour notification. Veuillez réessayer.',
            fetch_tasks_failed: 'Échec de fetch tasks. Veuillez réessayer.',
            create_task_failed: 'Échec de create task. Veuillez réessayer.',
            update_task_status_failed: 'Échec de la mise à jour du statut de la tâche. Veuillez réessayer.',
            update_checklist_failed: 'Échec de update checklist. Veuillez réessayer.',
            assign_task_failed: 'Échec de assign task. Veuillez réessayer.',
            escalate_task_failed: 'Échec de escalate task. Veuillez réessayer.',
            fetch_templates_failed: 'Échec de fetch templates. Veuillez réessayer.',
            permission_denied: 'Vous ne disposez pas des autorisations necessaires pour acceder a cette section. Contactez votre administrateur.',
        },
        harm_likelihood: {
            unlikely: 'Improbable',
            possible: 'Envisageable',
            likely: 'Probable',
            very_likely: 'Très probable',
        },
        reported_via: {
            email: 'E-mail',
            phone: 'Téléphone',
            internal_system: 'Interne Système',
            third_party: 'Tiers',
            automated_detection: 'Détection automatisée',
        },
        task_transition_labels: {
            start: 'Début',
            complete: 'Complet',
            block: 'Bloquer',
            defer: 'Reporter',
        },
        transition_labels: {
            start: 'Début',
            complete: 'Complet',
            block: 'Bloquer',
            defer: 'Reporter',
        },
        nav: {
            all: 'Tous les incidents',
            tasks: 'Tâches de réponse',
            reports: 'Rapports',
            breach_notifications: 'Notifications de violation',
            supplements: 'Suppléments',
            remediation: 'Remédiation',
            authority_requests: 'Demandes des autorités',
            disclosure_register: 'Registre de divulgation',
        },
        list: {
            page_title: 'Incidents',
            title: 'Incidents',
            new: 'Nouvel incident',
            edit: "Modifier l'incident",
            incident_title: 'Titre',
            severity: 'Gravité',
            reported_at: 'Signalé le',
            reported_by: 'Signalé par',
            assigned_to: 'Attribué à',
            view_detail: 'Voir le détail',
            reference: 'Référence',
            lead: 'Responsable',
            reported_via: 'Signalé via',
            discovery_date: 'Date de découverte',
            hide_details: 'Masquer Détails',
            close_incident: 'Fermer Incident',
            close_justification_prompt: 'Veuillez fournir une justification pour clôturer cet incident.',
            justification: 'Motif',
            lead_id: 'ID du responsable',
            contact: 'Personne-ressource',
            category: 'Catégorie',
            not_assessed: 'Non évalué',
        },
        detail: {
            page_title: "Détails de l'incident",
            title: "Détail de l'incident",
            tabs: {
                overview: "Vue d'ensemble",
                triage: 'Évaluation initiale',
                impact: "Évaluation de l'impact",
                breach: 'Évaluation de la violation',
                timeline: 'Chronologie',
                decisions: 'Décisions',
                evidence: 'Preuves',
                audit_trail: "Piste d'audit",
            },
            evidence_upload_label: 'Joindre un fichier de preuve',
            evidence_uploaded: 'Preuve téléversée',
            evidence_deleted: 'Preuve supprimée',
            evidence_delete_error: 'Échec de la suppression de la preuve',
            evidence_uploaded_at: 'Téléversé',
            evidence_empty: 'Aucun fichier de preuve joint à cet incident.',
            evidence_size: 'Taille',
            triage_notes: 'Notes de triage',
            initial_classification: 'Classification initiale',
            individuals_affected: 'Nombre de personnes concernées',
            data_categories: 'Catégories de données impliquées',
            systems_compromised: 'Systèmes compromis',
            geographic_scope: 'Portée géographique',
            breach_determination: 'Détermination de la violation',
            notification_required: 'Notification requise',
            notification_deadline: 'Date limite de notification',
            pdpc_reportable: 'Signalement PDPC requis',
            add_timeline: 'Ajouter une entrée chronologique',
            add_decision: 'Ajouter une décision',
            not_found: 'Incident non found.',
            team_members: "Membres de l'équipe",
            checklist: 'Liste de contrôle',
            completed: 'Terminé',
            impact_severity_score: 'Calculated Impact Gravité Score',
            records_affected: 'Enregistrements affectés',
            potential_consequences: 'Conséquences potentielles',
            harm_likelihood: 'Probabilité de préjudice',
            legal_basis: 'Base juridique',
            jurisdictions: 'Juridictions',
            jurisdictions_comma: 'Juridictions (séparées par des virgules)',
            jurisdiction: 'Juridiction',
            authority_status: "Statut de l'autorité",
            subject_status: 'Sujet Statut',
            authority_deadline: "Délai de l'autorité",
            subject_deadline: 'Sujet Échéance',
            mark_authority_done: "Marquer l'autorité comme terminée",
            mark_subject_done: 'Marquer Sujet Done',
            not_assessed: 'Non évalué',
            event_type: 'Événement Type',
            timestamp: 'Horodatage',
            actor: 'Acteur',
            no_timeline_events: 'Aucun événement de chronologie.',
            decision_type: 'Décision Type',
            decision: 'Décision',
            rationale: 'Justification',
            decision_made: 'Décision prise',
            no_decisions: 'Non décisions recorded encore.',
            jurisdictions_comma_separated: 'VN, SG, UE',
            no_audit_events: "Aucun événement d'audit enregistré pour l'instant.",
            export_pdf: 'Exporter PDF',
            pdf_title: "Rapport de Synthèse d'Incident",
            description: 'Descriptif',
            linked_records: 'Enregistrements Liés',
        },
        tasks: {
            page_title: 'Tâches de réponse aux incidents',
            title: 'Tâches de réponse aux incidents',
            new: 'Nouvelle tâche',
            edit: 'Modifier la tâche',
            task_type: 'Type de tâche',
            assignee: 'Assigné à',
            due_date: "Date d'échéance",
            dependencies: 'Dépendances',
            mark_complete: 'Marquer comme terminé',
            templates: 'Modèles de tâches',
            select_incident: 'Sélectionner un incident',
            all_statuses: 'Tous les statuts',
            all_categories: 'Toutes les catégories',
            new_response_task: 'Nouvelle tâche de réponse',
            category: 'Catégorie',
            priority: 'Priorité',
            depends_on: 'Dépend de (identifiants de tâches séparés par des virgules)',
            checklist_items: 'Éléments de la liste de contrôle',
            remove: 'Supprimer',
            add: 'Ajouter',
            new_checklist_item: 'Nouvel élément de la liste de contrôle',
            no_templates: 'Aucun modèle disponible.',
            assign_task: 'Attribuer la tâche',
            assign_to: 'Attribuer à',
            assign: 'Attribuer',
            select_incident_prompt: 'Veuillez sélectionner un incident pour voir ses tâches de réponse.',
            checklist: 'Liste de contrôle',
            hide_checklist: 'Masquer la liste de contrôle',
            escalate: 'Escalader',
            escalations: 'Escalades',
            no_checklist_items: 'Aucun élément dans la liste de contrôle.',
        },
        reports: {
            page_title: "Rapports d'incidents",
            title: "Rapports d'incidents",
            summary: 'Statistiques récapitulatives',
            by_severity: 'Par gravité',
            by_status: 'Par statut',
            recent: 'Incidents récents',
            total_incidents: 'Total des incidents',
            open: 'Ouverts',
            closed: 'Clôturés',
            export_csv: 'Exporter CSV',
            export_pdf: 'Exporter PDF',
            export_success: 'Rapport exporté avec succès.',
            export_error: "Échec de l'exportation du rapport.",
            reference: 'Référence',
            view_report: 'Voir le rapport',
        },
        statuses: {
            reported: 'Signalé',
            triage: 'Évaluation initiale',
            contained: 'Contenu',
            investigation: 'Enquête',
            remediation: 'Remédiation',
            closed: 'Clôturé',
            false_positive: 'Faux positif',
        },
        task_statuses: {
            pending: 'En attente',
            in_progress: 'En cours',
            completed: 'Terminé',
            blocked: 'Bloqué',
            cancelled: 'Annulé',
        },
        severity: {
            low: 'Faible',
            medium: 'Moyen',
            high: 'Élevé',
            critical: 'Critique',
        },
        task_types: {
            containment: 'Confinement',
            investigation: 'Enquête',
            remediation: 'Remédiation',
            communication: 'Échange',
            documentation: 'Pièces justificatives',
            notification: 'Avertissement',
        },
        categories: {
            data_breach: 'Données Violation',
            unauthorized_access: 'Accès non autorisé',
            data_loss: 'Perte de données',
            system_compromise: 'Compromission du système',
            malware: 'Logiciel malveillant',
            phishing: 'Hameçonnage',
            insider_threat: 'Menace interne',
            other: 'Autre',
        },
        reported_via_options: {
            email: 'E-mail',
            phone: 'Téléphone',
            internal_system: 'Interne Système',
            third_party: 'Tiers',
            automated_detection: 'Détection automatisée',
        },
        harm_likelihood_options: {
            unlikely: 'Improbable',
            possible: 'Envisageable',
            likely: 'Probable',
            very_likely: 'Très probable',
        },
        breach_determination_options: {
            confirmed_breach: 'Confirmé Violation',
            suspected_breach: 'Violation suspectée',
            not_a_breach: 'Non un Violation',
            pending: 'En attente',
        },
        timeline_event_types: {
            detection: 'Détection',
            escalation: 'Escalade',
            containment: 'Confinement',
            investigation_start: 'Enquête Début',
            evidence_collected: 'Preuves collectées',
            notification_sent: 'Notification Envoyé',
            remediation_action: 'Remédiation Action',
            status_change: 'Statut Changement',
            communication: 'Échange',
            other: 'Autre',
        },
        decision_types: {
            containment: 'Confinement',
            notification: 'Avertissement',
            remediation: 'Remédiation',
            escalation: 'Escalade',
            closure: 'Clôture',
            other: 'Autre',
        },
        task_transitions: {
            start: 'Début',
            complete: 'Complet',
            block: 'Bloquer',
            cancel: 'Annuler',
            unblock: 'Débloquer',
        },
        announce: {
            loaded: '[[TOK_1]] incidents chargés',
            reports_loaded: "[[TOK_1]] rapports d'incident chargés",
            tasks_loaded: '[[TOK_1]] tâches chargées',
            created: 'Incident créé avec succès',
            updated: 'Incident mis à jour avec succès',
            closed: 'Incident clôturé avec succès',
            status_changed: "Statut de l'incident modifié",
            triage_completed: 'Triage terminé avec succès',
            impact_updated: "Analyse d'impact mise à jour",
            breach_updated: 'Évaluation des violations mise à jour',
            timeline_added: 'Événement de chronologie ajouté',
            decision_recorded: 'Décision enregistrée',
            notification_updated: 'Statut de notification mis à jour',
            task_created: 'Tâche créée avec succès',
            task_status_changed: 'Statut de la tâche modifié',
            checklist_completed: 'Élément de la liste de contrôle terminé',
            checklist_unchecked: 'Élément de la liste de contrôle non coché',
            task_assigned: 'Tâche assignée avec succès',
            task_escalated: 'Tâche transférée',
            export_initiated: 'Exportation lancée',
        },
        breach_notifications: {
            page_title: 'Notifications de violation',
            title: 'Notifications de violation',
            new_notification: 'Nouvelle notification',
            no_notifications: 'Aucune notification de violation trouvée',
            status: 'Statut',
            submit_to_mps: 'Envoyer à [[TOK_0]]',
            decision: 'Décision',
            decision_maker: 'Décideur',
            notify: 'Notifier',
            do_not_notify: 'Ne pas avertir',
            rationale: 'Justification',
            filing_deadline: 'Date limite de dépôt',
            overdue: 'En retard',
            due_soon: 'Bientôt dû',
            on_track: 'Dans les temps',
            legal_review: 'Examen juridique',
            incident_id: "Identifiant de l'incident",
            notification_statuses: {
                assessment: 'Évaluation',
                decision_to_notify: 'Décision de notifier',
                notification_drafted: 'Notification rédigée',
                legal_review: 'Examen juridique',
                submitted_to_mps: 'Envoyé à [[TOK_0]]',
                supplement_requested: 'Supplément demandé',
                supplement_submitted: 'Supplément soumis',
                acknowledged: 'Reconnu',
                closed: 'Fermé',
            },
        },
        supplements: {
            page_title: 'Demandes de supplément',
            title: 'Demandes de supplément',
            new_supplement: 'Nouveau supplément',
            no_supplements: 'Aucune demande de supplément trouvée',
            request_details: 'Détails de la demande',
            response_package: 'Dossier de réponse',
            submit_response: 'Soumettre la réponse',
            deadline: 'Date limite',
            notification_id: 'ID de notification',
            enter_notification_id: 'Entrez un ID de notification pour afficher les suppléments.',
            supplement_statuses: {
                requested: 'Demandé',
                drafting: 'Rédaction',
                submitted: 'Soumis',
                accepted: 'Accepté',
                rejected: 'Rejeté',
            },
        },
        remediation: {
            page_title: 'Actions correctives',
            title: 'Actions correctives',
            new_action: 'Nouvelle action',
            no_actions: 'Aucune action corrective trouvée',
            description: 'Descriptif',
            owner: 'Propriétaire',
            department: 'Département',
            deadline: 'Date limite',
            statuses: {
                planned: 'Prévu',
                in_progress: 'En cours',
                completed: 'Terminé',
                verified: 'Vérifié',
            },
            verify: 'Vérifier',
            incident_id: "Identifiant de l'incident",
            enter_incident_id: "Saisissez un ID d'incident pour afficher les actions correctives.",
            start: 'Commencer',
            complete_action: 'Terminer',
        },
        authority_requests: {
            page_title: "Demandes d'autorisation",
            title: "Demandes d'autorisation",
            new_request: 'Nouvelle demande',
            no_requests: "Aucune demande d'autorité trouvée",
            authority_name: "Nom de l'autorité",
            request_details: 'Détails de la demande',
            response_package: 'Dossier de réponse',
            submission_channel: 'Canal de soumission',
            submit_response: 'Soumettre la réponse',
            deadline: 'Date limite',
            confirmation: 'Confirmation',
            incident_id_optional: "ID de l'incident (facultatif)",
            response_context_label: 'Contexte de réponse (pour la matérialisation du document de soumission)',
            response_context_none: '(ignorer la matérialisation)',
            response_context_supplement: 'Réponse complémentaire',
            response_context_information: "Réponse à demande d'information",
            response_context_inspection: "Réponse à l'inspection",
            materialisation_status_column: 'Document de soumission',
            materialisation_pending: 'En attente',
            materialisation_success: 'Matérialisé',
            materialisation_failed: 'Échoué',
            materialisation_retry_button: 'Réessayer',
            ar_statuses: {
                received: 'Reçu',
                verified: 'Vérifié',
                assembling: 'Assemblage',
                submitted: 'Soumis',
                closed: 'Fermé',
            },
        },
        disclosure_register: {
            page_title: 'Registre de divulgation',
            title: 'Registre de divulgation',
            new_entry: 'Nouvelle entrée',
            no_entries: 'Aucune entrée de registre de divulgation trouvée',
            disclosure_type: 'Type de divulgation',
            disclosure_date: 'Date de divulgation',
            recipient: 'Destinataire',
            authority_name: "Nom de l'autorité",
            channel: 'Chaîne',
            content_summary: 'Résumé du contenu',
            incident_id_optional: "ID de l'incident (facultatif)",
        },
    },
    onboarding: {
        nav: {
            wizard: 'Assistant de configuration',
            tours: 'Visites guidées',
            sample_data: "Données d'exemple",
        },
        wizard: {
            title: 'Assistant de configuration',
            welcome: 'Bienvenue sur AesirX ComplianceOne',
            welcome_message: 'Configurons votre organisation. Cet assistant vous guidera dans la configuration initiale.',
            setup_complete: 'Configuration terminée',
            skipped_message: "L'assistant de configuration a été ignoré. Vous pouvez le relancer à tout moment pour configurer votre organisation.",
            start_setup: 'Démarrer la configuration',
            skip_wizard: "Ignorer l'assistant",
            go_to_admin: 'Allez dans Administrateur',
            skip_for_now: 'Ignorer pour le moment',
            next_step: 'Étape suivante',
            previous_step: 'Étape précédente',
            finish_setup: 'Terminer la configuration',
            rerun: "Relancer l'assistant de configuration",
            step_label: 'Étape {number}',
            validation_org_name_required: "Le nom de l'organisation est requis.",
            validation_admin_email_required: "L'e-mail de l'administrateur est requis.",
            validation_admin_email_invalid: 'Veuillez saisir une adresse e-mail valide.',
            validation_cmp_endpoint_required: "Le point d'accès CMP est requis lorsque le CMP est activé.",
            steps: {
                license_activation: 'Activation de la licence',
                org_profile: "Profil de l'organisation",
                module_selection: 'Sélection des modules',
                cmp_integration: 'Intégration CMP',
                notification_preferences: 'Notifications',
                review: 'Vérification et confirmation',
            },
            step_descriptions: {
                license_activation: 'Entrez votre clé de licence pour activer votre package et déterminer quels modules sont disponibles.',
                org_profile: "Configurez le nom de l'organisation, la juridiction, le secteur, la taille et la langue préférée.",
                module_selection: 'Choisissez les modules de conformité à activer pour votre organisation.',
                cmp_integration: "Configurez l'intégration de la Consent Management Platform (optionnel).",
                notification_preferences: 'Configurez la réception des notifications pour les événements de conformité.',
                review: 'Vérifiez votre configuration et finalisez la mise en place.',
            },
            license_step: {
                validate_button: 'Valider la licence',
                skip_warning: "L'accès au module sera limité au niveau de package par défaut. Vous pouvez activer une licence ultérieurement dans Plateforme > Paramètres de licence.",
            },
            module_descriptions: {
                rights_requests: "Traitez les demandes d'accès et de suppression des données personnelles.",
                data_mapping: 'Cartographiez les systèmes, les flux de données et les activités de traitement.',
                governance: 'Gérez la conformité des fournisseurs et les procédures de suppression.',
                consent: 'Gérez les politiques de consentement et les catalogues de finalités.',
                consent_properties: 'Gérez le consentement sur plusieurs propriétés numériques.',
                assessments: "Réalisez des analyses d'impact et des transferts de données transfrontaliers.",
                classification: 'Classifiez et étiquetez les actifs de données avec suivi du cycle de vie.',
                monitoring: 'Revues de conformité programmées et suivi des KPI.',
                incidents: 'Signalez et gérez les incidents de sécurité et de confidentialité.',
                connectors: "Connectez-vous à des systèmes externes pour l'échange automatisé de données.",
                vendor_risk: 'Évaluez les fournisseurs, suivez les contrats et gérez la due diligence.',
                deletion_orchestration: 'Coordonnez la suppression des données entre les systèmes et les fournisseurs.',
                discovery: 'Découvrez et classifiez les données dans votre infrastructure.',
                incident_ops: "Playbooks d'incidents avancés, suivi SLA et escalades.",
                program_governance: "Évaluations de maturité, rapports de direction et préparation à l'audit.",
                access_accountability: "Surveillez l'accès utilisateur, les sessions et les flux de justification.",
                localization: 'Packs de conformité spécifiques au marché et cadres réglementaires.',
                partner_workspace: 'Espace de travail partenaires et revendeurs.',
                privacy_scanner: 'Surveillance en temps réel de la confidentialité des propriétés numériques.',
                onboarding: "Assistant de configuration, visites guidées et gestion des données d'exemple.",
                compliance_forms: 'Modèles de conformité interactifs et génération de documents.',
                audit_trail: "Journalisation d'audit immuable complète et conservation.",
                organizations: 'Gestion multi-organisations et de groupes.',
                task_management: 'Planification unifiée des tâches, moteur de workflow et vues calendrier.',
            },
            module_categories: {
                data_privacy_rights: 'Confidentialité des données et droits',
                vendor_third_party: 'Gestion des fournisseurs et des tiers',
                risk_assessment: 'Risque et évaluation',
                operations_automation: 'Opérations et automatisation',
                platform_admin: 'Plateforme et administration',
            },
            package_tier_label: 'Votre Forfait',
            package_module_unavailable: 'Non inclus dans votre forfait',
            select_all: 'Tout Sélectionner',
            deselect_all: 'Tout Désélectionner',
            load_sample_data: "Charger les données d'exemple après la configuration",
            load_sample_data_description: "Installez des données de démonstration réalistes (Lotus Financial Services) pour explorer la plateforme. Peut être supprimé ultérieurement depuis Onboarding > Données d'exemple.",
            language_label: 'Langue Préférée',
            language_description: 'Choisissez la langue par défaut pour votre organisation.',
            admin_account_title: 'Compte Administrateur',
            admin_account_created: 'Compte administrateur créé',
            admin_full_name: 'Nom complet',
            admin_email: 'Adresse e-mail',
            admin_password: 'Mot de passe',
            admin_confirm_password: 'Confirmer le mot de passe',
            admin_show_password: 'Afficher le mot de passe',
            admin_hide_password: 'Masquer le mot de passe',
            admin_name_placeholder: 'par ex. Jeanne Smith',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Minimum 8 caractères',
            admin_password_confirm_placeholder: 'Ressaisir le mot de passe',
            validation_admin_name_required: "Le nom de l'administrateur est requis",
            validation_admin_password_required: 'Le mot de passe est requis',
            validation_admin_password_min_length: 'Le mot de passe doit contenir au moins 8 caractères',
            validation_passwords_mismatch: 'Les mots de passe ne correspondent pas',
            notification_email_enabled: 'Activer les Notifications par E-mail',
            notification_email_description: 'Recevez des notifications par e-mail pour les affectations de tâches, les violations de SLA et les événements de conformité.',
            notification_digest_frequency: 'Fréquence du Résumé',
            notification_digest_daily: 'Quotidien',
            notification_digest_weekly: 'Hebdomadaire',
            notification_digest_none: 'Pas de résumé',
            notification_in_app_enabled: 'Activer les Notifications Plateforme',
            notification_in_app_description: 'Afficher le badge et le tiroir de notifications pour les alertes en temps réel.',
            jurisdictions: {
                vietnam: 'Viêt Nam',
                asean: 'ASEAN',
                eu_eea: 'UE/EEE',
                global: 'Mondial',
            },
            languages: {
                en: 'Anglais',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Suède',
                nb: 'Norsk bokmål',
                nn: 'Norsk-Nynorsk',
                de: 'Allemand',
                fi: 'Suomi',
                nl: 'Pays-Bas',
                fr: 'Français',
                lb: 'Letzebuergesch',
                ga: 'Gaeilge',
                es: 'espagnol',
                ca: 'Catalogne',
                eu: 'euskara',
                pt: 'Portugais',
            },
            industries: {
                financial_services: 'Services financiers',
                healthcare: 'Santé',
                technology: 'Technologie',
                telecommunications: 'Télécommunications',
                government: 'Secteur public',
                education: 'Éducation',
                manufacturing: 'Industrie manufacturière',
                retail: 'Commerce de détail',
                other: 'Autre',
            },
            placeholders: {
                org_name: 'par exemple, Lotus Financial Services',
                admin_email: 'admin@company.vn',
                team_emails: 'utilisateur1@entreprise.vn, utilisateur2@entreprise.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: "Nom de l'organisation",
                jurisdiction: 'Juridiction',
                industry: "Secteur d'activité",
                org_size: "Taille de l'organisation",
                language: 'Langue Préférée',
                admin_email: "E-mail de l'administrateur",
                team_emails: "Adresses e-mail des membres de l'équipe (séparées par des virgules)",
                enable_cmp: "Activer l'intégration CMP",
                cmp_endpoint: "Point d'accès API CMP",
                email_notifications: 'Notifications par E-mail',
                in_app_notifications: 'Notifications Plateforme',
                digest_frequency: 'Fréquence du Résumé',
            },
        },
        tours: {
            title: 'Visites guidées des modules',
            start: 'Démarrer la visite',
            continue_tour: 'Continuer la visite',
            replay: 'Rejouer la visite',
            exit: 'Quitter la visite',
            skip: 'Ignorer la visite',
            next: 'Suivant',
            previous: 'Précédent',
            finish: 'Terminer la visite',
            step_of: 'Étape {current} sur {total}',
            info: 'Suivez des visites guidées de chaque module pour découvrir les fonctionnalités et flux de travail clés. Les visites peuvent être rejouées à tout moment.',
            autoplay: 'Lecture automatique',
            interactive: 'Interactif',
            play_all: 'Tout jouer',
            search_tours: 'Rechercher des circuits...',
            duration: 'Durée',
            steps_label: '[[TOK_1]] étapes',
            mode: 'Mode',
            pause: 'Pause',
            resume: 'CV',
            speed: 'Vitesse',
            restart: 'Redémarrer',
            reset: 'Réinitialiser',
            reset_success: 'La progression de la tournée a été réinitialisée.',
            category_core_privacy: 'Confidentialité de base',
            category_governance: 'Gouvernance',
            category_operations: 'Opérations',
            category_platform: 'Plateforme',
            category_advanced: 'Avancé',
            category_data_privacy_rights: 'Confidentialité des données et droits',
            category_vendor_third_party: 'Gestion des fournisseurs et des tiers',
            category_risk_assessment: 'Risque et évaluation',
            category_operations_automation: 'Opérations et automatisation',
            category_platform_admin: 'Plateforme et administration',
            steps_count: '[[TOK_1]] étapes',
        },
        sample_data: {
            title: "Gestion des données d'exemple",
            select_modules: 'Sélectionner les modules',
            current_status: 'Statut actuel',
            operation_history: 'Historique des opérations',
            load: "Charger les données d'exemple",
            clear: "Supprimer les données d'exemple",
            processing: 'Traitement en cours...',
            loaded: 'Chargé',
            not_loaded: 'Non chargé',
            records: "Enregistrements d'exemple",
            confirm_clear: "Êtes-vous sûr de vouloir supprimer toutes les données d'exemple des modules sélectionnés ?",
            confirm_clear_title: 'Supprimer les données exemples',
            confirm_load_title: "Charger les données d'exemple",
            confirm_load: "Êtes-vous sûr de vouloir charger les données d'exemple pour les modules sélectionnés ?",
            action_load: 'Charger',
            action_clear: 'Supprimer',
            info: "Chargez des données de démonstration réalistes pour la formation et les démonstrations en utilisant l'entreprise fictive « Lotus Financial Services ». Les données d'exemple sont étiquetées et peuvent être supprimées en toute sécurité sans affecter les données réelles.",
        },
        help: {
            title: "Centre d'aide",
            search: 'Rechercher',
            search_placeholder: "Rechercher des articles d'aide...",
            clear: 'Effacer',
            all_categories: 'Toutes les catégories',
            all_modules: 'Tous les Modules',
            back: "Retour au Centre d'aide",
            callout_important: 'Important',
            callout_tip: 'Astuce',
            no_results: 'Aucun article trouvé correspondant à votre recherche.',
            no_articles: "Aucun article d'aide disponible pour le moment. Les articles apparaîtront ici au fur et à mesure de leur ajout.",
            results_for: '{count} résultat(s) pour « {query} »',
            quick_links: {
                getting_started: 'Premiers pas',
                getting_started_desc: 'Installation, configuration et guide de démarrage rapide.',
                user_guide: "Guide de l'utilisateur",
                user_guide_desc: "Documentation d'utilisation module par module.",
                admin_guide: "Guide de l'administrateur",
                admin_guide_desc: 'Configuration, maintenance et dépannage.',
                faq: 'FAQ',
                faq_desc: 'Questions fréquemment posées et réponses.',
            },
            search_articles_aria: "Rechercher des articles d'aide",
            article_metadata_aria: "Métadonnées de l'article",
            articles_list_aria: "Articles d'aide",
            category_nav_aria: 'Navigation par catégorie',
            quick_links_aria: "Liens rapides vers les catégories d'aide",
            returned_to_list: 'Retour à la liste des articles',
            opening_article: "Ouverture de l'article : {title}",
            read_article_aria: "Lire l'article : {title}",
            pagination_nav_aria: 'Pagination des articles',
            error_unavailable: "Le centre d'aide est actuellement indisponible. Veuillez réessayer plus tard.",
            retry: 'Réessayer',
        },
    },
    common: {
        save: 'Enregistrer',
        cancel: 'Annuler',
        system_actor: 'Système',
        delete: 'Supprimer',
        edit: 'Modifier',
        create: 'Créer',
        update: 'Mettre à jour',
        loading: 'Chargement...',
        error: 'Une erreur est survenue',
        success: 'Succès',
        logout: 'Déconnexion',
        actions: 'Mesures',
        retrying: 'Nouvelle tentative…',
        permission_denied: "Vous n'avez pas accès à cette page.",
        status: 'Statut',
        description: 'Descriptif',
        name: 'Nom',
        created_at: 'Créé le',
        updated_at: 'Mis à jour le',
        yes: 'Oui',
        no: 'Non',
        confirm: 'Confirmer',
        back: 'Retour',
        next: 'Suivant',
        previous: 'Précédent',
        search: 'Rechercher',
        filter: 'Filtrer',
        page_x_of_y: 'Page [[TOK_2]] sur [[TOK_3]]',
        pagination_label: 'Pagination',
        view_mode_label: 'Mode d’affichage',
        export: 'Exporter',
        exporting: 'Exportation…',
        sidebar_navigation: 'Navigation latérale administration',
        items_count: '{count} éléments',
        items_count_one: '{count} élément',
        export_success: 'Document généré avec succès.',
        generate_pdf: 'Générer PDF',
        import: 'Importer',
        download: 'Télécharger',
        upload: 'Téléverser',
        view: 'Voir',
        close: 'Fermer',
        submit: 'Soumettre',
        saved: 'Enregistré avec succès',
        saving: 'Enregistrement...',
        submitting: 'Soumission...',
        created: 'Créé avec succès',
        all: 'Tous',
        none: 'Aucun',
        select: 'Sélectionner',
        select_user: 'Sélectionnez un utilisateur...',
        custom_input: 'Saisir manuellement',
        required: 'Requis',
        optional: 'Facultatif',
        notes: 'Remarques',
        tags: 'Étiquettes',
        archive: 'Archiver',
        clone: 'Cloner',
        refresh: 'Actualiser',
        retry: 'Réessayer',
        reset: 'Réinitialiser',
        add: 'Ajouter',
        remove: 'Supprimer',
        removing: 'Suppression…',
        attachment: 'Pièce jointe',
        upload_file: 'Téléverser un fichier',
        upload_file_required: 'Téléverser un fichier (requis)',
        select_entity_type_first: 'Sélectionnez d’abord un type d’entité',
        failed_to_remove_file: 'Impossible de supprimer le fichier.',
        entity_type_label: 'Type d’entité',
        entity_label: 'Entité',
        entity_reference: 'Référence d’entité',
        failed_to_load_entities: 'Impossible de charger les entités',
        enable: 'Activer',
        disable: 'Désactiver',
        no_data: 'Aucune donnée trouvée',
        confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        confirm_action: 'Êtes-vous sûr de vouloir continuer ?',
        save_success: 'Enregistré avec succès',
        save_error: "Échec de l'enregistrement",
        delete_success: 'Supprimé avec succès',
        delete_error: 'Échec de la suppression',
        hour: 'heure',
        hours: 'heures',
        load_error: 'Échec du chargement des données',
        operation_error: "Échec de l'opération",
        something_went_wrong: 'Une erreur est survenue',
        go_home: 'Aller au tableau de bord',
        access_denied: 'Accès refusé',
        no_permission: "Vous n'avez pas la permission d'accéder à cette page.",
        no_permission_title: 'Permissions insuffisantes',
        no_permission_message: "Vous n'avez pas la permission d'accéder à cette page.",
        unknown: 'Inconnu',
        back_to_dashboard: 'Retour à Tableau de bord',
        id: 'ID',
        type: 'Catégorie',
        date: 'Date du',
        created_by: 'Créé Par',
        updated_by: 'Mis à jour Par',
        page_of: 'Page {page} de {total}',
        showing_items: 'Affichage de {count} éléments',
        items_per_page: 'Éléments par page',
        no_results: 'Aucun enregistrement ne correspond à vos filtres',
        no_items: 'Aucun items trouvé',
        sort_by: 'Trier par',
        ascending: 'Croissant',
        descending: 'Décroissant',
        all_statuses: 'Tous les statuts',
        all_types: 'Tous les types',
        all_categories: 'Toutes les catégories',
        all_severities: 'Toutes les gravités',
        date_range: 'Plage de dates',
        from_date: 'De',
        to_date: 'To',
        clear_filters: 'Effacer les filtres',
        apply_filters: 'Appliquer les filtres',
        save_changes: 'Enregistrer Changements',
        discard_changes: 'Rejeter Changements',
        confirm_discard: 'Vous avez des modifications non enregistrées. Les abandonner ?',
        copy: 'Copier',
        duplicate: 'Dupliquer',
        move: 'Déplacer',
        assign: 'Assigner',
        unassign: 'Désassigner',
        approve: 'Approuver',
        reject: 'Rejeter',
        deleting: 'Suppression...',
        processing: 'Traitement...',
        loading_page: 'Chargement de page...',
        operation_success: 'Opération terminé avec succès',
        operation_failed: "L'opération a échoué. Veuillez réessayer.",
        empty_dash: '—',
        network_error: 'Réseau erreur. Vérifier votre connection.',
        session_expired: 'Session expiré. Please journaliser dans again.',
        test: 'Tester',
        pause: 'Mettre en pause',
        resume: 'Reprendre',
        activate: 'Activer',
        last_sync: 'Dernier Synchroniser',
        health: 'Santé',
        email: 'E-mail',
        role: 'Rôle',
        title: 'Titre',
        owner: 'Propriétaire',
        priority: 'Priorité',
        category: 'Catégorie',
        details: 'Détails',
        overview: 'Aperçu',
        configuration: 'Paramétrage',
        history: 'Historique',
        new_item: 'New',
        edit_item: 'Modifier',
        select_option: 'Sélectionner...',
        total: 'Somme totale',
        active: 'Actif',
        inactive: 'Inactif',
        enabled: 'Activé',
        disabled: 'Désactivé',
        last_login: 'Dernière connexion',
        never: 'Jamais',
        password_changed: 'Mot de passe modifié. Vous allez être déconnecté.',
        password_change_failed: 'Échec de change password. Veuillez réessayer.',
        passwords_mismatch: 'Les mots de passe ne correspondent pas',
        install: 'Installer',
        uninstall: 'Désinstaller',
        installed: 'Installé',
        available: 'Disponible',
        catalog: 'Catalogue',
        published: 'Publié',
        version: 'Révision',
        market: 'Marché',
        language: 'Langue',
        framework: 'Cadre',
        template: 'Modèle',
        connector_type: 'Connecteur Type',
        polling_interval: "Intervalle d'interrogation (minutes)",
        new_instance: 'Nouveau Instance',
        change_password: 'Changement Mot de passe',
        current_password: 'Actuel Mot de passe',
        new_password: 'Nouveau mot de passe',
        confirm_password: 'Confirmer Mot de passe',
        comments: 'Commentaires',
        completed: 'Terminé',
        contact: 'Personne-ressource',
        hide: 'Masquer',
        hide_details: 'Masquer Détails',
        label: 'Libellé',
        max: 'Max',
        min: 'Min',
        na: 'N/A',
        of: 'of',
        showing: 'Affichage',
        page: 'Feuillet',
        preview: 'Aperçu',
        print: 'Imprimer',
        show: 'Afficher',
        status_active: 'Actif',
        status_completed: 'Terminé',
        status_draft: 'Brouillon',
        status_in_progress: 'En cours',
        status_pending: 'En attente',
        view_details: 'Voir détails',
        all_priorities: 'Toutes les priorités',
        pipeline: 'Chaîne de traitement',
        all_requests: 'Tous Demandes',
        schedule: 'Planification',
        deploy: 'Déployer',
        rollback: 'Retour arrière',
        advance_stage: "Avancer l'étape",
        submit_for_approval: 'Soumettre pour Approbation',
        approval_log: 'Approbation Journal',
        approver: 'Approbateur',
        decision: 'Décision',
        decided_at: 'Décidé le',
        rollout_stages: 'Étapes de déploiement',
        approval_comment: 'Approbation Commentaire',
        optional_comment: 'Facultatif commentaire...',
        impact_summary: 'Impact Résumé',
        target_property_ids: 'Cible Propriété IDs (comma-separated)',
        policy_id: 'Politique ID',
        target_version: 'Cible Version',
        target_version_placeholder: 'ex. 2.0.0',
        scheduled_label: 'Planifié',
        scheduled_start: 'Planifié Début',
        scheduled_end: 'Planifié Fin',
        properties_count: '{count} propriétés',
        results: 'Résultats',
        comparison_results: 'Résultats de comparaison',
        past_comparison_reports: 'Rapports de comparaison passés',
        scanning: 'Analyse...',
        run_inconsistency_scan: 'Exécuter Inconsistency Scanner',
        property_ids_label: 'IDs de propriétés (séparés par des virgules, min 2)',
        comparison_type: 'Type de comparaison',
        golden_template_id: 'ID du modèle de référence (facultatif)',
        leave_blank_compare: 'Laissez vide pour comparer les propriétés entre elles',
        add_notes_placeholder: 'Ajouter votre analysis notes ici...',
        covered_of_active: '{covered} sur {active} propriétés actives couvertes',
        fetch_error: 'Échec de fetch data. Veuillez réessayer.',
        run_comparison_error: 'Échec de run comparison. Veuillez réessayer.',
        save_notes_error: 'Échec de save notes. Veuillez réessayer.',
        scan_complete: 'Inconsistency scan terminé avec succès',
        scan_error: 'Échec de run inconsistency scan. Veuillez réessayer.',
        min_two_properties: 'Veuillez fournir au moins 2 ID de propriétés pour la comparaison.',
        comma_separated: 'séparées par des virgules',
        language_english: 'Anglais',
        language_vietnamese: 'Vietnamien',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Auteur',
        dependencies: 'Dépendances',
        checksum: 'Somme de contrôle',
        changelog: 'Journal des modifications',
        tier: 'Niveau',
        phone: 'Téléphone',
        launch: 'Lancer',
        complete: 'Complet',
        back_to_list: 'Retour à Liste',
        clear_selection: 'Effacer la sélection',
        deactivate: 'Désactiver',
        scope: 'Portée',
        deadline: 'Échéance',
        progress: 'Progression',
        frequency: 'Fréquence',
        reviewer: 'Réviseur',
        user: 'Utilisateur',
        campaign: 'Campagne',
        items: 'Éléments',
        next_run: 'Suivant Exécuter',
        last_run: 'Dernier Exécuter',
        overdue: 'EN RETARD',
        creating: 'Création...',
        launching: 'Lancement...',
        loaded: 'loaded',
        page_size: 'Taille des pages',
        per_page: '/page',
        urgent: 'Urgent',
        pagination: 'Pagination',
        metric: 'Métrique',
        value: 'Valeur',
        country: 'Pays',
        showing_chart_view: 'Affichage de la vue graphique',
        showing_table_view: 'Affichage de la vue tableau de données',
        policies: 'Politiques',
        select_content_type: 'Veuillez sélectionner au moins un type de contenu.',
        compliant: 'Conforme',
        non_compliant_status: 'Non conforme',
        all_data: 'Toutes les données',
        sr_urgent: 'Urgent',
        n_per_page: '[[TOK_1]] / page',
        select_user_placeholder: "-- Sélectionnez l'utilisateur --",
        field_required: 'Ce champ est obligatoire',
        results_found: 'résultats trouvés',
        select_placeholder: '-- Sélectionner --',
        unknown_user: 'Utilisateur inconnu',
        export_csv: 'Exporter CSV',
        not_applicable: 'S/O',
        aria_overdue_since: 'En retard depuis {date}',
        placeholders: {
            enter_justification: 'Saisissez justification',
            justification: 'Motif',
            campaign_name_example: 'Q1 2026 Accès Examiner',
            optional_description: 'Description facultative',
            enter_user_id: 'Saisissez user ID of the reviewer',
            enter_user_id_short: 'Saisissez user ID',
            schedule_name_example: 'Trimestriel Accès Attestation',
            enter_property_id: 'Saisissez propriété id',
            enter_policy_id: 'Saisissez politique id',
            property_or_group_id: 'ID de propriété ou de groupe',
            describe_template_purpose: "Décrivez l'objectif du modèle...",
            step_title: 'Étape titre...',
            detailed_instructions: 'Instructions détaillées...',
            filter_by_taxonomy_id: 'Filtrer par Taxonomie ID...',
            describe_classification_rule: 'Décrivez la règle de classification...',
            describe_dedup_rule: 'Décrivez la règle de dédoublonnage...',
            describe_import_template: "Décrivez le modèle d'importation...",
            reason_for_rejection: 'Reason pour rejet...',
            jurisdiction_codes_example: 'VN, SG, UE',
            filter_by_locale: 'Filtrer par langue...',
            filter_by_event_type: "Filtrer par type d'événement",
            filter_by_actor_id: "Filtrer par ID d'acteur",
            filter_by_market_code: 'Filtrer par code marché...',
            filter_by_framework_id: 'Filtrer par cadre ID...',
            add_comment: 'Ajouter commentaire...',
            provide_rejection_reason: 'Fournissez un motif de rejet de cette soumission...',
            filter_by_jurisdiction: 'Filtrer par code juridiction...',
            enter_report_title: 'Saisissez signaler titre',
            enter_name: 'Saisissez name',
            enter_description: 'Saisissez description',
            enter_org_id: 'Saisissez Org ID to add',
            describe_evidence_gap: 'Décrivez le manque de preuves...',
            expected_evidence: 'Quoi preuve est expected',
            entity_identifier: "Identifiant de l'entité",
            remediation_steps: 'Étapes pour remédier à cet écart',
            user_id_or_name: 'ID utilisateur ou nom',
            reporting_period_id: 'ID de la période de rapport',
            maturity_model_id: 'Maturité modéliser ID',
            describe_maturity_model: 'Describe ce maturité modéliser...',
            describe_role_purpose: "Describe this role's purpose...",
            provide_deny_reason: 'Fournissez un motif de refus de cette demande',
            describe_emergency: "Décrivez la situation d'urgence nécessitant un accès élevé (minimum 20 caractères)",
            enter_delegate_id: 'Saisissez user id de le déléguer',
            provide_delegation_reason: 'Fournissez un motif pour cette délégation',
            client_identifier: 'Identifiant client',
            client_secret: 'Secret client',
            time_format: 'HH:MM',
            describe_sod_rule: "Décrivez l'objectif de cette règle SoD...",
            enter_role_id: 'Saisissez role ID',
            explain_exception: 'Explain pourquoi ce exception est needed...',
            describe_compensating_controls: 'Décrivez les contrôles compensatoires en place...',
            full_name: 'Nom complet',
            min_chars: 'Min 12 caractères',
            enter_override_justification: 'Saisissez justification for overriding this gate evaluation',
            enter_evidence_id: "Saisissez l'ID de la preuve à lier :",
            date_format: 'JJ/MM/AAAA',
            describe_pack_contents: 'Décrivez le contenu et le but du paquet',
            select_reviewers: 'Sélectionner des réviseurs...',
        },
        aria_previous_page: 'Page précédente',
        aria_next_page: 'Page suivante',
        aria_results_per_page: 'Résultats par page',
        per_page_25: '25/page',
        per_page_50: '50/page',
        per_page_100: '100/page',
        select_language: 'Choisir la langue',
        today: "Aujourd'hui",
        tomorrow: 'Demain',
        dashboard_load_error: 'Impossible de charger le tableau de bord. Veuillez réessayer.',
        enum_grade: {
            red: 'Rouge',
            amber: 'Orange',
            yellow: 'Jaune',
            green: 'Vert',
        },
        enum_severity: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
        },
        enum_priority: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
        },
        enum_status: {
            pending: 'En attente',
            in_progress: 'En cours',
            completed: 'Terminé',
            blocked: 'Bloqué',
            escalated: 'Escaladé',
            cancelled: 'Annulé',
            overdue: 'En retard',
            not_started: 'Non démarré',
            new: 'Nouveau',
            open: 'Ouvert',
            closed: 'Fermé',
            acknowledged: 'Pris en compte',
            resolved: 'Résolu',
        },
        enum_department: {
            unassigned: 'Non attribué',
        },
        enum_form_category: {
            assessment: 'Évaluation',
            assessment_report: "Rapport d'évaluation",
            dpia: '[[TOK_0]]',
            authority_submission: "Soumission à l'autorité",
            cross_border_transfer: 'Transfert transfrontalier',
            vendor: 'Vendeur',
            breach: 'Violation',
            consent: 'Consentement',
            governance: 'Gouvernance',
            register: "S'inscrire",
            monitoring: 'Surveillance',
            dpa: 'DPA',
            dsr: 'DSR',
            privacy: 'Confidentialité',
            incident: 'Incident',
            org: 'Organisation',
            sector: 'Secteur',
            classification: 'Classement',
            discovery: 'Découverte',
        },
        enum_module: {
            rights_requests: 'Demandes de droits',
            assessments: 'Évaluations',
            incidents: 'Incidents',
            incident_ops: 'Opérations sur les incidents',
            monitoring: 'Surveillance',
            vendor_risk: 'Risque du fournisseur',
            governance: 'Gouvernance',
            deletion_orchestration: 'Suppression',
            access_review: "Examen de l'accès",
            consent: 'Consentement',
            consent_properties: 'Propriétés du consentement',
            forms: 'Formulaires',
            localization: 'Localisation',
            program_governance: 'Gouvernance du programme',
            privacy_scanner: 'Scanner de confidentialité',
            classification: 'Classement',
            discovery: 'Découverte',
            manual: 'Manuel',
            data_mapping: 'Cartographie des données',
        },
        enum_risk_level: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
        },
        enum_request_type: {
            all: 'All',
            access: 'Accès ([[TOK_0]])',
            deletion: 'Suppression',
            correction: 'Correction',
            objection: 'Objection',
            portability: 'Portabilité',
            restriction: 'Restriction',
            consent_withdrawal: 'Retrait du consentement',
        },
        enum_locale: {
            en: 'Anglais',
            vi: 'Vietnamien',
            all: 'Les deux',
        },
        enum_event_type: {
            case_created: 'Cas créé',
            status_changed: 'Statut modifié',
            case_assigned: 'Cas attribué',
            note_added: 'Remarque ajoutée',
            attachment_added: 'Pièce jointe ajoutée',
            attachment_deleted: 'Pièce jointe supprimée',
            reference_added: 'Référence ajoutée',
            checklist_updated: 'Liste de contrôle mise à jour',
            identity_verified: 'Identité vérifiée',
            closure_summary_added: 'Résumé de la clôture',
            approval_granted: 'Approbation accordée',
            template_applied: 'Modèle appliqué',
            export_generated: 'Exportation générée',
            sla_warning: '[[TOK_0]] Avertissement',
            sla_overdue: '[[TOK_0]] En retard',
        },
        more: 'more',
        use: 'Use',
        ok: 'OK',
    },
    common_statuses: {
        removed: 'Supprimé',
        draft: 'Brouillon',
        active: 'Actif',
        inactive: 'Inactif',
        pending: 'En attente',
        in_progress: 'En cours',
        completed: 'Terminé',
        archived: 'Archivé',
        published: 'Publié',
        approved: 'Approuvé',
        rejected: 'Rejeté',
        cancelled: 'Annulé',
        blocked: 'Bloqué',
        deferred: 'Reporté',
        not_started: 'Non démarré',
        dismissed: 'Rejeté',
        failed: 'Échoué',
        in_review: 'Dans Examiner',
        deprecated: 'Obsolète',
        scheduled: 'Planifié',
        deploying: 'Déploiement',
        deployed: 'Déployé',
        paused: 'En pause',
        rolled_back: 'Annulé',
        received: 'Reçu',
        processing: 'Traitement',
        under_assessment: 'Sous Évaluation',
        implemented: 'Implémenté',
        pending_approval: 'En attente Approbation',
        pending_deletion: 'En attente Suppression',
        on_hold: 'En attente',
        deleted: 'Supprimé',
        expired: 'Expiré',
        outdated: 'Obsolète',
        drifted: 'Dévié',
        decommissioned: 'Décommissionné',
        match: 'Correspondance',
        different: 'Différent',
        missing: 'Manquant',
        confirmed: 'Confirmé',
        revoked: 'Révoqué',
        escalated: 'Escaladé',
        system: 'Système',
        custom: 'Personnalisé',
        warning: 'Avertissement',
        blocking: 'Bloquant',
        analyst: 'Analyste',
        viewer: 'Visualiseur',
        daily: 'Quotidien',
        weekly: 'Hebdomadaire',
        policies: 'Politiques',
        denied: 'Refusé',
        verified: 'Vérifié',
        detected: 'Détecté',
        ignored: 'Ignoré',
        open: 'Ouvert',
        resolved: 'Résolu',
        suspended: 'Suspendu',
        retired: 'Retraité',
        review: 'Examen',
        generated: 'Généré',
        exported: 'Exporté',
    },
    severity: {
        low: 'Faible',
        medium: 'Moyen',
        high: 'Élevé',
        critical: 'Critique',
    },
    sensitivity: {
        standard: 'Norme',
        sensitive: 'Sensible',
        special_category: 'Catégorie spéciale',
        badge_sensitive: 'Sensible',
    },
    change_types: {
        policy_update: 'Politique Mettre à jour',
        new_binding: 'Nouveau Binding',
        remove_binding: 'Supprimer la liaison',
        configuration_change: 'Configuration Changement',
        banner_update: 'Bannière Mettre à jour',
    },
    comparison_types: {
        full: 'Complet',
        banner_only: 'Bannière Seulement',
        purposes_only: 'Finalités Seulement',
        legal_bases_only: 'Bases juridiques uniquement',
        consent_settings: 'Consentement Paramètres',
    },
    lifecycle_stages: {
        active: 'Actif',
        archived: 'Archivé',
        pending_deletion: 'En attente Suppression',
        deleted: 'Supprimé',
        on_hold: 'En attente',
    },
    object_types: {
        personal_data: 'Données personnelles',
        consent_record: 'Consentement Enregistrement',
        user_account: 'Utilisateur Compte',
        audit_log: 'Audit Journal',
        document: 'Pièce jointe',
        backup: 'Sauvegarde',
    },
    transfer_mechanisms: {
        adequacy_decision: 'Adéquation Décision',
        standard_contractual_clauses: 'Clauses contractuelles types',
        binding_corporate_rules: "Règles d'entreprise contraignantes",
        explicit_consent: 'Consentement explicite',
        public_interest: 'Intérêt public',
        legal_claims: 'Réclamations juridiques',
        vital_interests: 'Intérêts vitaux',
    },
    risk_categories: {
        data_breach: 'Données Violation',
        unauthorized_access: 'Accès non autorisé',
        data_loss: 'Perte de données',
        regulatory_non_compliance: 'Non-conformité réglementaire',
        third_party_risk: 'Third-Party Risque',
        operational: 'Opérationnel',
        technical: 'Technique',
        legal: 'Juridique',
    },
    mitigation_types: {
        technical: 'Technique',
        organizational: 'Organisationnel',
        contractual: 'Contractuel',
        procedural: 'Procédural',
    },
    safeguard_types: {
        encryption_in_transit: 'Chiffrement en transit',
        encryption_at_rest: 'Chiffrement au repos',
        access_controls: "Contrôles d'accès",
        contractual_clauses: 'Clauses contractuelles',
        data_minimization: 'Minimisation des données',
        pseudonymization: 'Pseudonymisation',
        audit_rights: 'Droits de vérification',
        breach_notification: 'Notification de violation',
        data_localization: 'Localisation des données',
        other: 'Autre',
    },
    scoring_methods: {
        weighted_average: 'Moyenne pondérée',
        simple_average: 'Moyenne simple',
        maximum: 'Valeur maximale',
        manual: 'Manuel',
    },
    dpa_status: {
        not_required: 'Non requis',
        required: 'Requis',
        in_progress: 'En cours',
        completed: 'Terminé',
        signed: 'Signé',
    },
    disposal_methods: {
        anonymize: 'Anonymiser',
        pseudonymize: 'Pseudonymiser',
        aggregate: 'Agréger',
        delete: 'Supprimer',
    },
    dashboard: {
        title: 'Tableau de bord',
        no_data: 'Aucune donnée de tableau de bord disponible.',
        no_data_heading: 'Aucune donnée en temps réel pour le moment',
        no_data_detail: "Les widgets du tableau de bord ci-dessous montrent la mise en page. Les données s'afficheront une fois la connexion à la base de données établie.",
        consent_coverage: 'Couverture du consentement',
        ctia_filings: 'Déclarations CTIA',
        next_dpia_review: 'Prochain examen DPIA',
        next_review_none: 'Aucun prévu',
        incident_mps_filings: 'Déclarations MPS des incidents',
        compliance_score: 'Score de conformité',
        grade: 'Note',
        no_score: 'Aucun score de conformité calculé pour le moment.',
        rights_requests: "Demandes d'exercice des droits",
        open: 'Ouvertes',
        sla_breached: 'SLA dépassé',
        sla_approaching: 'SLA bientôt échu',
        closed_month: 'Clôturées (mois)',
        incidents: 'Incidents et violations',
        active: 'Actifs',
        breaches: 'Violations',
        overdue_tasks: 'Tâches en retard',
        breach_72h_notice: 'Un délai de notification réglementaire de 72 heures s’applique aux violations actives',
        recommendations: 'Recommandations',
        take_action: "Passez à l'action",
        drift_events: 'Écarts et approbations',
        open_events: 'Événements ouverts',
        pending_approvals: 'Approbations en attente',
        monitoring: 'Tâches de surveillance',
        programs: 'Programmes',
        overdue: 'En retard',
        pending: 'En attente',
        ric_cases: 'Dossiers des autorités de contrôle',
        coverage: 'Couverture des données',
        systems: 'Systèmes',
        activities: 'Activités',
        vendors: 'Prestataires',
        dpias: 'AIPD',
        open_gaps: 'écarts ouverts',
        view_as_table: 'Afficher en tableau',
        view_as_chart: 'Afficher en graphique',
        table_metric_header: 'Indicateur',
        table_value_header: 'Valeur',
        announce_chart_view: 'Affichage en graphique',
        announce_table_view: 'Affichage en tableau',
        section_core_metrics: 'Indicateurs cles',
        section_task_management: 'Gestion des taches',
        section_compliance_insights: 'Perspectives de conformite',
        configure_dashboard: 'Configurer le tableau de bord',
        config_col_active: 'Actif',
        config_col_widget: 'Widget',
        collapse_section: 'Reduire',
        expand_section: 'Developper',
        reset_to_defaults: 'Réinitialiser par défaut',
        preferences_saved: 'Préférences du tableau de bord enregistrées',
        preferences_reset: 'Tableau de bord réinitialisé aux paramètres du rôle',
        preferences_load_error: 'Échec du chargement des préférences du tableau de bord',
        factor_avg_system_score: 'Score système moyen',
        factor_avg_vendor_score: 'Note moyenne du fournisseur',
        factor_processing_coverage: 'Couverture des activités de traitement',
        factor_ropa_completeness: 'Complétude du RoPA',
        factor_drift_penalty: 'Pénalité pour les événements de dérive',
        rec_improve_system_gov: 'Améliorer la documentation sur la gouvernance du système',
        rec_improve_vendor_gov: 'Améliorer la documentation sur la gouvernance des fournisseurs',
        rec_document_processing: 'Activités de traitement de documents pour les systèmes non couverts',
        rec_generate_ropa: 'Générer des enregistrements RoPA pour les activités de traitement actives',
        rec_resolve_drift: 'Résoudre les événements de dérive ouverts critiques et de haute gravité',
        score_good: 'Bon',
        score_fair: 'Acceptable',
        score_poor: 'Mauvais',
        score_critical: 'Critique',
        drag_to_reorder: 'Glisser pour réorganiser',
        widget_moved: 'Widget déplacé',
        press_space_to_grab: 'Appuyez sur Espace pour saisir, touches fléchées pour déplacer, Espace pour déposer',
        reorder_instructions: 'Utilisez le glisser-déposer ou les raccourcis clavier pour réorganiser les widgets',
        task_widgets: {
            tasks_overview: 'Aperçu des tâches',
            pending: 'En attente',
            in_progress: 'En cours',
            overdue: 'En retard',
            done_7d: 'Terminé (7j)',
            by_priority: 'Par priorité',
            view_all_tasks: 'Afficher toutes les tâches',
            upcoming_tasks: 'Tâches à venir (7 prochains jours)',
            no_upcoming: 'Aucune tâche à accomplir dans les 7 prochains jours.',
            view_calendar: 'Voir le calendrier',
            overdue_alerts: 'En retard',
            no_overdue: 'Aucune tâche en retard. Tout est sur la bonne voie.',
            assigned_to: 'Attribué à',
            view_all_overdue: 'Afficher tous les retards',
            notifications: 'Notifications récentes',
            unread: 'unread',
            no_notifications: 'Aucune notification. Vous êtes tous rattrapés !',
            view_all_notifications: 'Afficher toutes les notifications',
            load_error: 'Échec du chargement des données.',
            day_late: 'jour de retard',
            days_late_plural: 'jours de retard',
            due_today: "À rendre aujourd'hui",
            just_now: 'juste maintenant',
            minutes_short: 'm',
            hours_short: 'h',
            days_short: 'ré',
            cross_org_stats: 'Statistiques inter-organisations',
            by_organization: 'Par organisation',
            overdue_across_orgs: 'tâches en retard dans les organisations',
            total: 'Total',
            tasks: 'tasks',
            organization: 'Organisation',
            current_org: 'Organisation actuelle',
            all_orgs: 'Toutes les organisations',
            all_organizations: 'Toutes les organisations',
            filter_by_org: 'Filtrer par organisation',
            cross_org: 'Inter-organisation',
            empty_calendar: 'Aucune tâche pour cette période. Créez votre première tâche ou vérifiez vos filtres.',
            empty_my_tasks: 'Aucune tâche ne vous est assignée. Excellent travail !',
            empty_overdue: 'Aucune tâche en retard. Tout est sur la bonne voie.',
            empty_notifications: 'Aucune notification. Vous êtes tous rattrapés !',
            empty_workflows: 'Aucun flux de travail configuré. Parcourez les modèles pour commencer.',
        },
        my_tasks_widget: {
            title: 'Mes Tâches',
            no_tasks: 'Aucune tâche ne vous est attribuée.',
            load_error: 'Impossible de charger les tâches.',
            overdue: 'en retard',
            remaining: 'restant',
            view_all: 'Voir Toutes les Tâches',
        },
        my_section_status_widget: {
            title: 'Statut de Mes Sections',
            overall_completion: 'Global',
            sections_count: 'Sections',
            no_sections: 'Aucune section attribuée à votre département.',
            load_error: 'Impossible de charger le statut des sections.',
        },
        revision_requests_widget: {
            title: 'Demandes de Révision',
            no_revisions: 'Aucune demande de révision. Toutes les sections sont en bonne voie.',
            load_error: 'Impossible de charger les demandes de révision.',
        },
        consent_summary: {
            title: 'Consentement',
            active: 'Actif',
            withdrawn_30d: 'Retiré (30j)',
            expiring_7d: 'Expirant (7j)',
        },
        transfer_assessments: {
            title: 'Évaluations de transfert',
            open: 'Ouvert',
            approved: 'Approuvé',
            gaps_flagged: 'Lacunes signalées',
        },
        breach_notifications: {
            title: 'Notifications de violation',
            deadline_72h: 'délai de 72h',
            submitted: 'Soumis',
            pending: 'En attente',
        },
        authority_requests: {
            title: "Demandes d'autorisation",
            pending: 'En attente',
            overdue: 'En retard',
            responded_30d: 'A répondu (30j)',
        },
        data_subjects_widget: {
            title: 'Personnes concernées',
            total: 'Total',
            high_risk: 'Risque élevé',
            active_30d: 'Actif (30j)',
        },
        audit_activity_summary: {
            title: 'Activité de vérification',
            events_today: "Événements aujourd'hui",
            events_7d: 'Événements (7j)',
            unique_actors_30d: 'Acteurs uniques (30j)',
        },
        onboarding_progress: {
            title: "Progression de l'intégration",
            completion_pct: 'Terminé',
            status_label: 'Statut',
            current_step: 'Étape actuelle',
            status: {
                in_progress: 'En cours',
                completed: 'Terminé',
                skipped: 'Sauté',
                not_started: 'Pas démarré',
            },
        },
        sector_overlay_reports_due: {
            title: 'Sector Overlay Reports Due [FR]',
        },
        persona_widgets: {
            framework_filter: 'Filtrer par référentiel',
            all_frameworks: 'Tous les référentiels',
            filing_lifecycle: 'Cycle de vie des déclarations',
            filing_pipeline: 'Pipeline de déclarations',
            draft: 'Brouillon',
            internal_review: 'Revue interne',
            approved: 'Approuvé',
            submitted: 'Soumis',
            supplement_requested: 'Supplément demandé',
            resubmitted: 'Soumis à nouveau',
            accepted: 'Accepté',
            rejected: 'Rejeté',
            closed: 'Fermé',
            deadline: 'Date limite',
            days_remaining: 'jours restants',
            days_overdue: 'jours de retard',
            no_filings: 'Aucune déclaration active.',
            department_consolidation: 'Consolidation des départements',
            departments_completed: 'Départements terminés',
            departments_pending: 'Départements en attente',
            departments_overdue: 'Départements en retard',
            no_consolidation_cases: 'Aucun cas multi-départements en cours.',
            vendor_risk: 'Risque fournisseurs et tiers',
            pending_assessment: 'Évaluation en attente',
            overdue_questionnaires: 'Questionnaires en retard',
            dpa_review_queue: 'File de revue DPA',
            risk_distribution: 'Répartition des risques',
            total_vendors: 'Total fournisseurs',
            by_risk_level: 'Par niveau de risque',
            no_vendor_data: 'Aucune donnée de risque fournisseur disponible.',
            discovery_summary: 'Découverte de données',
            discovery_classification: 'Découverte et classification des données',
            active_scans: 'Analyses actives',
            labels_pending: "Étiquettes en attente d'examen",
            exceptions_unresolved: 'Exceptions non résolues',
            pending_review: 'Revue en attente',
            exceptions: 'Exceptions',
            approved_labels: 'Étiquettes approuvées',
            total_classified: 'Total classifié',
            no_discovery_data: 'Aucune donnée de découverte disponible.',
            ai_governance: "Gouvernance des systèmes d'IA",
            systems_inventory: 'Systèmes en inventaire',
            systems_in_inventory: "Systèmes dans l'inventaire",
            classification_breakdown: 'Répartition des classifications',
            dossier_completion: 'Achèvement du dossier',
            by_classification: 'Par classification',
            labeling_status: "Statut d'étiquetage",
            not_started: 'Non démarré',
            no_ai_data: 'Aucune donnée de gouvernance IA disponible.',
            breach_response: 'Réponse aux violations et incidents',
            active_breaches: 'Violations actives',
            notification_status: 'Statut de notification',
            remediation_progress: 'Progression de la remédiation',
            supplement_loops: 'Boucles de complément',
            no_breach_data: 'Aucun cas de violation actif.',
            audit_readiness: "Préparation à l'audit et aux évaluations",
            assessments: 'Évaluations',
            gap_findings: 'Constats de lacunes',
            evidence_completion: 'Achèvement des preuves',
            export_ready: 'Prêt à exporter',
            not_ready: 'Non prêt',
            no_audit_data: "Aucune donnée de préparation d'audit disponible.",
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN Cybersecurite 2018',
            framework_label_vn_ecommerce: 'VN E-commerce 2023',
            framework_label_vn_telecom: 'VN Telecommunications 2023',
            framework_label_vn_ai: 'VN Loi IA 2025',
            framework_label_gdpr: 'RGPD',
            framework_label_unspecified: 'Non spécifié',
            my_department: 'Mon département',
            my_tasks: 'Mes tâches',
            section_status: 'Statut de la section',
            revision_requests: 'Demandes de révision',
            completion: 'Achèvement',
            reason: 'Motif',
            requested_at: 'Demandé le',
            no_tasks_assigned: 'Aucune tâche assignée.',
            no_sections: 'Aucune section assignée à votre département.',
            no_revisions: 'Aucune demande de révision.',
            load_error: 'Échec du chargement des données.',
        },
    },
    connectors: {
        nav: {
            instances: 'Occurrences',
            credentials: "Coffre-fort d'identifiants",
            event_bus: "Bus d'événements",
            definitions: 'Définitions',
            brds: 'Capture BRD',
            security_reviews: 'Revues de sécurité',
            poc_scorecards: 'Fiches POC',
            automation_planning: 'Planification automatisation',
            system_inventory: 'Inventaire systèmes',
            traceability_matrix: 'Matrice traçabilité',
            gap_register: 'Registre des écarts',
        },
        instances: {
            title: 'Instances de connecteurs',
            page_title: 'Connecteurs',
            add: 'Ajouter une instance',
            test: 'Tester la connexion',
            sync_now: 'Synchroniser maintenant',
            new_instance: 'Nouveau connecteur instance',
            no_instances: 'Aucun connector instances trouvé',
            instance_count: '{count} occurrence(s)',
            confirm_delete: 'Supprimer connector instance "{name}"?',
            all_connector_types: 'Tous Connecteur Types',
            select_connector: 'Sélectionnez connector...',
            fetch_error: 'Échec de fetch connector instances. Veuillez réessayer.',
            fetch_definitions_error: 'Échec de fetch connector definitions. Veuillez réessayer.',
            create_error: 'Échec de create connector instance. Veuillez réessayer.',
            test_error: 'Échec de test connector. Veuillez réessayer.',
            status_error: 'Échec de la mise à jour du statut du connecteur. Veuillez réessayer.',
            delete_error: 'Échec de supprimer connector instance. Veuillez réessayer.',
        },
        credentials: {
            title: "Coffre-fort d'identifiants",
            page_title: 'Identifiants du connecteur',
            add: 'Ajouter un identifiant',
            rotate: 'Renouveler',
            expired: 'Expiré',
            expiring: 'Expiration prochaine',
            orphaned: 'Orphelin',
            new_credential: 'Nouveau identifiant',
            no_credentials: 'Aucun identifiants trouvé',
            no_expiry: "Pas d'expiration",
            linked_connectors: 'Connecteurs liés',
            expires_at: 'Expire À',
            value_label: 'Valeur * (write-only)',
            confirm_delete_title: 'Confirmer Supprimer',
            confirm_delete_message: "Supprimer cette accréditation ? Les connecteurs liés perdront l'accès.",
            rotate_title: 'Rotation des accréditations',
            new_credential_value: "Nouvelle valeur d'accréditation",
            fetch_error: 'Échec de charge identifiants. Veuillez réessayer.',
            health_error: 'Échec de load health. Veuillez réessayer.',
            create_error: 'Échec de create credential. Veuillez réessayer.',
            rotate_error: 'Échec de rotate credential. Veuillez réessayer.',
            delete_error: 'Échec de supprimer identifiant. Veuillez réessayer.',
        },
        event_bus: {
            title: "Bus d'événements",
            page_title: "Bus d'événements",
            events: 'Événements',
            subscriptions: 'Abonnements',
            dlq: 'File des messages en erreur',
            publish: 'Publier un événement',
            retry: 'Réessayer',
            dismiss: 'Ignorer',
            search_events: 'Rechercher des événements...',
            filter_event_type: "Filtrer par type d'événement...",
            event_type: 'Événement Type',
            source_module: 'Module source',
            timestamp: 'Horodatage',
            delivery_status: 'Statut de livraison',
            correlation_id: 'ID de corrélation',
            tracking_id: 'ID de suivi',
            delivery_status_hint: 'Le statut de livraison est mis à jour automatiquement au fur et à mesure que les événements sont traités.',
            no_events: 'Aucun events trouvé',
            total_with_count: '{count} au total',
            prev: 'Préc.',
            new_subscription: '+ Nouveau Abonnement',
            subscriber_type: 'Abonné Type',
            subscriber_id: 'Abonné ID',
            event_type_pattern: 'Événement Type Pattern',
            event_type_pattern_placeholder: 'p.ex. incident.*',
            filter_expression: 'Expression de filtre',
            filter_expression_placeholder: 'Facultatif filtrer',
            subscriber_type_hint: "Choisissez comment les événements seront livrés : webhook envoie des requêtes HTTP, e-mail envoie des notifications, file d'attente route vers une file de messages.",
            subscriber_id_hint: "Entrez la destination des événements. Pour les webhooks, utilisez une URL. Pour l'e-mail, utilisez une adresse. Pour les files, utilisez le nom de la file.",
            event_type_pattern_hint: "Faites correspondre les événements par type avec des caractères génériques. Utilisez * pour correspondre à n'importe quel segment (ex. incident.* correspond à incident.created, incident.resolved).",
            filter_expression_hint: 'Optionnel. Filtrez davantage les événements par contenu (ex. severity=high).',
            subscriber_id_placeholder_webhook: 'ex. https://votre-app.com/webhook',
            subscriber_id_placeholder_email: 'ex. alertes@votre-entreprise.com',
            subscriber_id_placeholder_queue: 'ex. file-evenements',
            event_pattern: "Modèle d'événement",
            filter: 'Filtrer',
            enabled: 'Activé',
            delivery_stats: 'Stats de livraison',
            no_subscriptions: 'Aucun abonnements trouvé',
            on: 'ON',
            off: 'OFF',
            delivered_failed: '{delivered} livrés / {failed} échoués',
            confirm_delete_subscription: 'Supprimer ce abonnement?',
            unresolved: 'Non résolu',
            resolved: 'Résolu',
            event_id: 'Événement ID',
            subscription_id: 'Abonnement ID',
            error_code: "Code d'erreur",
            error_message: "Message d'erreur",
            attempts: 'Tentatives',
            last_failed: 'Dernier Échoué',
            no_dlq_entries: 'Aucun dead letter entries trouvé',
            dlq_count: '{count} entrée(s) au total',
            fetch_events_error: 'Échec de fetch events. Veuillez réessayer.',
            fetch_subscriptions_error: 'Échec de fetch subscriptions. Veuillez réessayer.',
            fetch_dlq_error: 'Échec de fetch dlq entries. Veuillez réessayer.',
            create_subscription_error: 'Échec de create subscription. Veuillez réessayer.',
            toggle_subscription_error: 'Échec de basculer abonnement. Veuillez réessayer.',
            delete_subscription_error: 'Échec de supprimer abonnement. Veuillez réessayer.',
            retry_error: 'Nouvelle tentative échoué',
            dismiss_error: 'Rejet échoué',
            event_published: 'Événement publié',
            publish_event_error: "Échec de la publication de l'événement. Veuillez réessayer.",
            priority_label: 'Priorité',
            priority_low: 'Basse',
            priority_normal: 'Normale',
            priority_high: 'Haute',
            payload_helper_text: 'Saisissez les données de l\'événement au format JSON. Exemple : {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Abonnement créé',
            subscription_toggled: 'Abonnement basculé',
            subscription_deleted: 'Abonnement supprimé',
            dlq_retried: 'Message DLQ réessayé',
            dlq_dismissed: 'Message DLQ rejeté',
        },
        definitions: {
            title: 'Définitions des connecteurs',
            page_title: 'Définitions de connecteurs',
            add: 'Ajouter une définition',
            new_definition: 'Nouvelle définition de connecteur',
            edit_definition: 'Modifier la définition du connecteur',
            no_definitions: 'Aucune définition de connecteur trouvée',
            definition_count: '[[TOK_1]] définition(s)',
            all_categories: 'Toutes les catégories',
            select_category: 'Sélectionnez une catégorie...',
            capabilities: 'Capacités',
            capabilities_hint: 'Capacités (séparées par des virgules)',
            capabilities_placeholder: 'par ex. lire, écrire, synchroniser',
            created: 'Définition du connecteur créée',
            updated: 'Définition du connecteur mise à jour',
            fetch_error: 'Échec de la récupération des définitions de connecteur. Veuillez réessayer.',
            create_error: 'Échec de la création de la définition du connecteur',
            update_error: 'Échec de la mise à jour de la définition du connecteur',
        },
        brds: {
            title: 'Capture BRD',
            page_title: 'Capture BRD',
            create_brd: 'Créer un BRD',
            brd_title: 'Titre du BRD',
            description: 'Descriptif',
            requirements: 'Exigences',
            status: 'Statut',
            stakeholders: 'Parties prenantes',
            connector_label: 'Connecteur',
            select_connector: 'Sélectionner un connecteur...',
            approval: 'Approbation',
            no_brds_found: 'Aucun BRD trouvé',
            decision_records: 'Registres de décisions',
            create_decision: 'Créer une décision',
            alternatives_considered: 'Alternatives envisagées',
            alternative_name: "Nom de l'alternative",
            reason_rejected: 'Motif de rejet',
            add_alternative: 'Ajouter une alternative',
            remove_alternative: "Supprimer l'alternative {name}",
            alternatives: 'Alternatives',
            rationale: 'Justification',
            selected_connector: 'Connecteur sélectionné',
            comma_separated_names: 'Noms séparés par des virgules',
            brd_created: 'BRD créé',
            decision_record_created: 'Enregistrement de décision créé',
            no_decision_records_found: 'Aucun enregistrement de décision trouvé',
            aria_brds_table: 'BRD',
            aria_decision_records_table: 'Enregistrements de décision',
            aria_approve: 'Approuver {name}',
            aria_archive: 'Archiver {name}',
            brd_title_help: 'Un nom court et lisible par l\'homme pour ce BRD - par ex. "Intégration de la billetterie Jira", "Déploiement Okta SSO".',
            brd_title_placeholder: 'par ex. Intégration de la billetterie Jira',
            description_help: 'Le problème commercial que ce connecteur résout. Quel résultat attendez-vous une fois qu’il sera en ligne ?',
            description_placeholder: "par ex. Automatisez la création de tickets d'incident à partir des alertes de surveillance afin que les appels soient signalés dans les 60 secondes.",
            connector_help: 'Facultatif. Choisissez un connecteur auquel ce BRD est destiné – laissez vide si le connecteur n’a pas encore été choisi.',
            requirements_help: 'Liste de fonctionnalités indispensables séparées par des virgules – par ex. "Connexion OAuth2, livraison de webhook, exportation d\'audit".',
            requirements_placeholder: "Connexion OAuth2, livraison de webhook, exportation d'audit",
            stakeholders_help: 'Noms ou adresses e-mail séparés par des virgules des personnes qui doivent se déconnecter.',
            selected_connector_help: "Choisissez le connecteur auquel cette décision s'applique.",
            rationale_help: 'Pourquoi ce connecteur a été choisi. Couvrez les facteurs décisifs afin qu’un futur lecteur comprenne l’appel.',
            rationale_placeholder: "par ex. Choisissez Jira car il contient déjà notre historique de tickets et l'équipe y est formée.",
            alternatives_considered_help: "Autres connecteurs évalués et raisons pour lesquelles ils n’ont pas été sélectionnés. Ajoute une capacité de défense pour l'audit.",
            alternative_name_placeholder: 'par ex. ServiceMaintenant',
            reason_rejected_placeholder: "par ex. Coût 3 fois plus élevé, aucun avantage pour notre cas d'utilisation",
        },
        security_reviews: {
            title: 'Revues de sécurité',
            page_title: 'Revues de sécurité',
            create_review: 'Créer une revue',
            connector_name: 'Nom du connecteur',
            connector_label: 'Connecteur',
            select_connector: 'Sélectionner un connecteur...',
            reviewer: 'Réviseur',
            select_reviewer: 'Sélectionner un réviseur...',
            findings: 'Constatations (une par ligne)',
            risk_level: 'Niveau de risque',
            risk_level_placeholder: 'p. ex. élevé, moyen, faible',
            notes: 'Remarques',
            review_status: 'Statut de la revue',
            checklist: 'Liste de contrôle',
            privacy_impact: 'Impact sur la vie privée',
            approval_gate: "Porte d'approbation",
            no_reviews_found: 'Aucune revue trouvée',
            review_created: 'Revue de sécurité créée',
            create_control_mapping: 'Créer un mappage de contrôle',
            control_mapping_created: 'Mappage de contrôle créé',
            connector_id_label: 'ID du connecteur',
            control_id_label: 'ID du contrôle',
            control_name_label: 'Nom du contrôle',
            aria_approve: 'Approuver {name}',
            aria_reject: 'Rejeter {name}',
            scan_imported: 'Scan importé avec succès',
            import_scan: 'Importer le scan',
            scan_format: 'Format du scan',
            scan_data: 'Données du scan',
            import_results: "Résultats d'importation",
            recommendations: 'Recommandations',
            auto_populated_from: 'Rempli automatiquement à partir de [[TOK_1]]',
            manual_entry: 'Saisie manuelle',
            automation_type: "Type d'automatisation",
            select_automation_type: "Sélectionnez le type d'automatisation...",
            automation_full: 'Complet : le connecteur automatise entièrement ce contrôle',
            automation_partial: 'Partiel : le connecteur apporte des preuves ; les humains agissent toujours',
            automation_monitoring: "Surveillance uniquement : le connecteur observe, n'applique pas",
            control_id_help: 'Utilisez le code de votre système de conformité (par exemple ISO-27001-A.12.1, SOC2-CC6.1 ou votre ID de contrôle interne).',
            control_name_help: 'Nom court lisible par l\'homme (par exemple "Restriction d\'accès au réseau").',
            description_label: 'Descriptif',
            load_sarif_example: "Charger l'exemple SARIF",
            load_json_example: 'Charger un exemple personnalisé de [[TOK_0]]',
            scan_format_help: "SARIF est le standard OASIS émis par la plupart des scanners (Snyk, CodeQL, Semgrep). Utilisez un [[TOK_0]] personnalisé pour les outils qui n'émettent pas de SARIF.",
            scan_data_help: "Collez le résultat de l'analyse complète, téléchargez un fichier .sarif/.json ou cliquez sur un bouton Charger un exemple pour voir la forme.",
            upload_file_label: 'Téléchargez le fichier .sarif ou .json',
            invalid_scan_json: "Impossible d'analyser les données d'analyse en tant que [[TOK_0]]. Recherchez les erreurs de syntaxe à proximité du caractère en surbrillance.",
            save_as_review: "Enregistrer en tant qu'examen de sécurité",
            discard_preview: "Supprimer l'aperçu",
            preview_hint: "Ceci est un aperçu — rien n'est encore enregistré. Cliquez sur « Enregistrer en tant qu'examen de sécurité » pour créer un examen en attente pré-rempli avec ces valeurs.",
            reviewer_required_for_save: "Choisissez un réviseur pour enregistrer cette analyse en tant qu'examen de sécurité.",
        },
        poc_scorecards: {
            title: 'Fiches POC',
            page_title: 'Fiches POC',
            create_scorecard: 'Créer une fiche',
            connector_label: 'Connecteur',
            select_connector: 'Sélectionner un connecteur...',
            vendor_name: 'Nom du fournisseur',
            recommendation: 'Recommandation',
            recommendation_placeholder: 'p. ex. Continuer, Ne pas continuer, Nécessite une évaluation approfondie',
            criteria: "Critères d'évaluation",
            criterion_name: 'Nom du critère',
            score: 'Score',
            max_score: 'Score maximum',
            notes: 'Remarques',
            add_criterion: 'Ajouter un critère',
            remove_criterion: 'Supprimer le critère {name}',
            total_score: 'Score total',
            api_quality: 'Qualité API',
            reliability: 'Fiabilité',
            support_quality: 'Qualité du support',
            cost_score: 'Score de coût',
            overall_score: 'Score global',
            evidence: 'Preuves',
            no_scorecards_found: 'Aucune fiche trouvée',
            scorecard_created: 'Fiche POC créée',
            connector_help: 'Choisissez le connecteur auquel cette évaluation POC est destinée.',
            vendor_name_help: 'Le fournisseur ou le produit évalué – par ex. "Okta", "Datadog", "Flocon de neige".',
            vendor_name_placeholder: 'par ex. Okta, Datadog, Flocon de neige',
            recommendation_help: "Votre dernier appel après l'évaluation. Soyez bref et décisif.",
            criteria_help: 'Notez le fournisseur sur chaque critère d’évaluation. Ajoutez une ligne par critère ([[TOK_0]] qualité, fiabilité, support, coût, etc.).',
            criterion_name_help: 'Ce que vous notez – par ex. "[[TOK_0]] Qualité", "Fiabilité", "Support", "Coût".',
            criterion_name_placeholder: 'par ex. [[TOK_0]] Qualité',
            score_help: 'Note attribuée pour ce critère. Ne doit pas dépasser le score maximum.',
            max_score_help: 'Meilleur score disponible pour ce critère. Utilisez la même échelle sur toutes les lignes afin que les totaux soient comparables.',
            notes_help: 'Facultatif. Ajoutez des preuves, des mises en garde ou des liens – tout ce qui explique le score.',
        },
        common_labels: {
            aria_filter_instances: 'Filtrer les instances de connecteurs',
            aria_filter_definitions: 'Filtrer les définitions de connecteurs',
            aria_filter_credentials: 'Filtrer les identifiants',
            aria_filter_events: 'Filtrer les événements',
            aria_filter_dlq: 'Filtrer la file des lettres mortes',
            aria_instance_summary: "Résumé de l'instance du connecteur",
            aria_active_connectors: 'Connecteurs actifs',
            aria_error_connectors: 'Connecteurs en erreur',
            aria_credential_health: "Résumé de l'état des identifiants",
            aria_items_per_page: 'Éléments par page',
            show_password: 'Afficher le mot de passe',
            hide_password: 'Masquer le mot de passe',
            payload_json_label: 'Charge utile (JSON)',
            payload_invalid_json: 'La charge utile doit être du JSON valide',
            placeholder_event_type: 'ex. incident.created',
            placeholder_source_module: 'ex. monitoring',
            placeholder_version: 'ex. 1.0',
        },
        statuses: {
            configuring: 'Configuration',
            testing: 'Tests',
            active: 'Actif',
            paused: 'En pause',
            error: 'Erreur',
            disabled: 'Désactivé',
            draft: 'Brouillon',
            approved: 'Approuvé',
            archived: 'Archivé',
            pending: 'En attente',
            rejected: 'Rejeté',
        },
        system_types: {
            application: 'Demande',
            database: 'Base de données',
            middleware: 'Intergiciel',
            infrastructure: 'Infrastructures',
            saas: 'SaaS',
            other: 'Autre',
        },
        hosting_types: {
            on_premise: 'Sur site',
            cloud: 'Nuage',
            hybrid: 'Hybride',
            managed: 'Géré',
        },
        system_statuses: {
            active: 'Actif',
            decommissioned: 'Décommissionné',
            planned: 'Planifié',
            under_review: 'En révision',
        },
        automation_statuses: {
            planning: 'Planification',
            in_progress: 'En cours',
            completed: 'Terminé',
            on_hold: 'En attente',
        },
        gap_types: {
            functional: 'Fonctionnel',
            technical: 'Technique',
            security: 'Sécurité',
            compliance: 'Conformité',
            process: 'Processus',
        },
        severity_labels: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
        },
        gap_statuses: {
            open: 'Ouvert',
            in_progress: 'En cours',
            mitigated: 'Atténué',
            closed: 'Fermé',
            accepted: 'Accepté',
        },
        verification_statuses: {
            not_started: 'Non commencé',
            in_progress: 'En cours',
            verified: 'Vérifié',
            failed: 'Échoué',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Interne',
            email: 'E-mail',
            queue: 'File',
        },
        credential_types: {
            password: 'Mot de passe',
            api_key: 'Clé API',
            oauth2_client: 'Client OAuth2',
            certificate: 'Certificat',
            token: 'Jeton',
            ssh_key: 'Clé SSH',
            imap_credentials: 'Identifiants IMAP',
        },
        categories: {
            hr: 'RH',
            crm: 'GRC',
            erp: 'ERP',
            cloud: 'Nuage',
            security: 'Sécurité',
            itsm: 'ITSM',
            custom: 'Personnalisé',
        },
        delivery_statuses: {
            pending: 'En attente',
            delivered: 'Livré',
            partial: 'Partiel',
            failed: 'Échoué',
        },
        automation_planning: {
            title: 'Planification automatisation',
            page_title: 'Planification automatisation',
            program_name: 'Nom du programme',
            program_status: 'Statut',
            description: 'Descriptif',
            linked_artifacts: 'Artefacts liés',
            create_program: 'Créer un programme',
            edit_program: 'Modifier le programme',
            no_programs_found: 'Aucun programme trouvé',
            program_created: 'Programme créé',
            program_updated: 'Programme mis à jour',
            target_date: 'Date cible',
            owner: 'Propriétaire',
            select_status: 'Sélectionner un statut...',
            aria_programs_table: "Programmes d'automatisation",
            aria_edit: 'Modifier {name}',
            export_programs: 'Exporter les programmes',
            title_label: 'Titre du programme',
            title_help: 'Un nom court et lisible pour le programme d\'automatisation - par ex. "Déploiement des incidents vers Jira au troisième trimestre", "[[TOK_0]] automatisation des demandes d\'accès".',
            title_placeholder: 'par ex. Déploiement des incidents vers Jira au troisième trimestre',
            description_help: "Ce que couvre ce programme et le résultat que vous attendez une fois qu'il sera en ligne. Facultatif mais recommandé.",
            description_placeholder: 'par ex. Transférez les alertes de surveillance dans Jira afin que les appels soient signalés dans les 60 secondes.',
            owner_label: 'Propriétaire du programme',
            owner_help: 'La personne responsable de ce programme. Ils recevront des notifications sur les progrès et les portes.',
            select_owner: 'Sélectionnez un propriétaire...',
            frameworks_in_scope: 'Cadres concernés',
            frameworks_in_scope_help: "Cadres de conformité pris en charge par ce programme. Aide la piste d'audit à montrer par quelles réglementations l'automatisation est régie.",
            select_frameworks: 'Sélectionnez les cadres...',
            status_draft: 'Brouillon',
            status_active: 'Actif',
            status_completed: 'Terminé',
            status_archived: 'Archivé',
            change_status: 'Changer le statut',
            status_updated: 'Statut mis à jour',
            aria_change_status: 'Modifier le statut de [[TOK_1]]',
        },
        system_inventory: {
            title: 'Inventaire des systèmes',
            page_title: 'Inventaire des systèmes',
            system_name: 'Nom du système',
            system_type: 'Type de système',
            hosting: 'Hébergement',
            status: 'Statut',
            description: 'Descriptif',
            create_system: 'Créer un système',
            edit_system: 'Modifier le système',
            no_systems_found: 'Aucun système trouvé',
            system_created: 'Système créé',
            system_updated: 'Système mis à jour',
            select_type: 'Sélectionner un type...',
            select_hosting: 'Sélectionner hébergement...',
            select_status: 'Sélectionner un statut...',
            owner: 'Propriétaire',
            department: 'Département',
            data_categories: 'Catégories de données',
            data_categories_placeholder: 'Séparées par des virgules, ex. PII, Financier, Santé',
            jurisdiction: 'Juridiction',
            jurisdiction_placeholder: 'ex. UE, US, Global',
            interfaces: 'Interfaces',
            interfaces_placeholder: 'Séparées par des virgules, ex. API REST, SFTP, JDBC',
            owner_placeholder: 'Sélectionner un propriétaire responsable...',
            department_placeholder: "Sélectionner l'unité organisationnelle responsable...",
            system_name_hint: "Utilisez le nom du système ou de l'application reconnu par l'entreprise.",
            system_type_hint: 'Classifiez le système afin que les rapports puissent regrouper des actifs similaires.',
            hosting_hint: "Identifiez où le système s'exécute pour la résidence, la sécurité et l'examen des fournisseurs.",
            status_hint: "Définissez l'état du cycle de vie utilisé par les révisions, les exportations et les preuves d'audit.",
            owner_hint: "Choisissez l'utilisateur actif responsable de la gouvernance du système et des tâches de suivi.",
            department_hint: "Utilisez l'unité organisationnelle responsable de l'exploitation ou de la gouvernance de ce système.",
            data_categories_hint: 'Listez les classes de données traitées par ce système, séparées par des virgules.',
            jurisdiction_hint: "Enregistrez la principale juridiction légale ou d'hébergement pour la cartographie de la conformité.",
            interfaces_hint: "Listez les chemins de connexion ou d'intégration utilisés pour échanger des données.",
            description_hint: 'Résumez ce que fait le système et pourquoi il est important pour la cartographie des données.',
            owner_department_required: 'Le propriétaire et le département sont obligatoires.',
            aria_systems_table: 'Inventaire des systèmes',
            aria_edit: 'Modifier {name}',
            export_systems: 'Exporter les systèmes',
        },
        traceability_matrix: {
            title: 'Matrice de traçabilité',
            page_title: 'Matrice de traçabilité',
            brd_selector: 'Sélectionner le BRD',
            requirement: 'Exigence',
            linked_artifact: 'Artefact lié',
            verification_status: 'Statut de vérification',
            verified_by: 'Vérifié par',
            create_entry: 'Créer une entrée',
            edit_entry: 'Modifier une entrée',
            no_entries_found: 'Aucune entrée trouvée',
            entry_created: 'Entrée créée',
            entry_updated: 'Entrée mise à jour',
            select_brd: 'Sélectionner un BRD...',
            select_status: 'Sélectionner un statut...',
            aria_matrix_table: 'Matrice de traçabilité',
            aria_edit: 'Modifier entrée pour {name}',
            export_matrix: 'Exporter la matrice',
        },
        gap_register: {
            title: 'Registre des écarts',
            page_title: 'Registre des écarts',
            gap_title: "Titre de l'écart",
            gap_type: "Type d'écart",
            severity: 'Gravité',
            status: 'Statut',
            description: 'Descriptif',
            remediation_plan: 'Plan de remédiation',
            assigned_to: 'Assigné à',
            due_date: "Date d'échéance",
            create_gap: 'Créer un écart',
            edit_gap: "Modifier l'écart",
            no_gaps_found: 'Aucun écart trouvé',
            gap_created: 'Écart créé',
            gap_updated: 'Écart mis à jour',
            select_type: 'Sélectionner un type...',
            select_severity: 'Sélectionner la gravité...',
            select_status: 'Sélectionner un statut...',
            aria_gaps_table: 'Registre des écarts',
            aria_edit: 'Modifier {name}',
            export_gaps: 'Exporter les écarts',
            gap_title_hint: 'Provide a concise name for the identified gap.',
            gap_type_hint: 'Select the nature of the gap (e.g., missing coverage or integration issue).',
            severity_hint: 'The impact of this gap on compliance and operations.',
            status_hint: 'Current stage of the gap resolution lifecycle.',
            owner_hint: 'The person responsible for tracking and remediating this gap.',
            description_hint: 'Detailed context regarding the gap, its root cause, and impact.',
            mitigation_plan_hint: 'Steps planned or taken to address and close the gap.',
            linked_requirement_ids_hint: 'Comma-separated requirement codes this gap affects.',
            linked_system_ids_hint: 'Comma-separated system IDs associated with this gap.',
            gap_types: {
                coverage: 'Coverage',
                capability: 'Capability',
                integration: 'Integration',
                compliance: 'Compliance',
            },
        },
        regulatory: {
            system_inventory_governance_info: 'System inventory aligns with Data Law enterprise governance. System types map to regulatory categories, hosting classification determines jurisdiction-specific controls. Use framework linkage to connect systems to applicable regulatory frameworks.',
            automation_planning_workflow_info: 'Automation programs align with compliance workflow obligations defined by applicable regulatory frameworks. Framework scope determines which requirements the program addresses.',
            traceability_regulatory_source_info: 'Each traceability entry connects a BRD requirement to its regulatory source. Verification status tracks whether implementation satisfies the regulatory obligation.',
            security_reviews_control_mapping_info: 'Security reviews evaluate framework-specific controls applicable to each connector. Risk level captures assessed exposure, findings document deviations from control requirements.',
            gap_register_framework_info: 'Gap Register captures compliance gaps per regulatory framework. Use framework filter to view gaps for a specific framework. Severity levels align with framework risk classification.',
            poc_scorecards_criteria_info: 'POC scorecards evaluate connectors against regulatory criteria. Criteria structure supports weighted scoring with evidence notes. Vendor linkage connects to vendor record.',
            evidence_trail_info: 'All connector module actions generate audit events for cross-module evidence trail integrity. CSV exports preserve referential integrity.',
        },
        system_inventory_extra: {
            framework_linkage: 'Liaison au cadre',
            framework_linkage_placeholder: 'ex. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Portée du cadre',
            framework_scope_placeholder: 'ex. GDPR, PCI-DSS',
            procedure_linkage: 'Liaison de procédure',
            procedure_linkage_placeholder: 'ex. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Source réglementaire',
            regulatory_source_placeholder: 'ex. GDPR Art. 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Cartographie des contrôles',
            control_mappings_section: 'Mappages de contrôle',
            no_control_mappings: 'Aucun mappage de contrôle pour l\'instant. Cliquez sur "Créer un mappage de contrôle" pour en ajouter un.',
            automation_type_col: 'Automatisation',
        },
        gap_register_extra: {
            framework_filter: 'Cadre',
            framework_id: 'ID du cadre',
            framework_id_placeholder: 'ex. GDPR, ISO 27001',
            all_frameworks: 'Tous les cadres',
        },
        poc_scorecards_extra: {
            criteria_count: 'Critères',
        },
        export_labels: {
            export_brds: 'Exporter les BRD',
            export_decision_records: 'Exporter les registres de décisions',
            export_security_reviews: 'Exporter les revues de sécurité',
            export_poc_scorecards: 'Exporter les fiches POC',
            export_instances: 'Exporter des instances',
            export_definitions: 'Exporter des définitions',
            export_credentials: "Exporter les informations d'identification",
            export_events: 'Exporter des événements',
            exporting: 'Exportation...',
            export_success: 'Exportation terminée',
            export_error: "Échec de l'exportation",
        },
    },
    vendor_risk: {
        risk_acceptance_reasoning: {
            draft_label: 'Projet de raisonnement',
            drafting: 'Rédaction du raisonnement…',
            results_heading: '[[TOK_2]]-raisonnement rédigé ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            narrative_label: 'Exposé des motifs',
            controls_heading: 'Contrôles compensatoires',
            no_controls: 'Aucun contrôle compensatoire suggéré.',
            citations_label: 'Citations',
            accept_label: 'Accepter le raisonnement',
            reject_label: 'Rejeter le brouillon',
            accept_hint: "Accepter enregistre le raisonnement sur le brouillon persistant pour la lignée IAT. Les contrôles narratif + ne mettent pas à jour automatiquement l'enregistrement d'acceptation : un collage par l'opérateur est requis.",
            resolve_summary: 'Résolution : [[TOK_1]]',
            error_generic: "Impossible de rédiger un raisonnement. Réessayez ou vérifiez l'état d'acceptation du risque.",
        },
        redline_assistant: {
            run_label: 'Redline avec bibliothèque',
            running: 'Exécution de la ligne rouge…',
            results_heading: 'Suggestions de ligne rouge ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            no_suggestions: 'Aucune lacune dans la clause standard n’a été détectée.',
            jurisdiction_label: 'Juridiction',
            col_kind: 'Genre',
            col_severity: 'Gravité',
            col_title: 'Suggestions',
            col_excerpt: 'Extrait correspondant',
            col_apply: 'Postuler',
            kind_missing: 'Norme manquante',
            kind_weaker: 'Plus faible que la norme',
            kind_jurisdiction: 'Superposition de juridiction',
            proposed_label: 'Texte proposé',
            citations_label: 'Citations',
            accept_label: 'Accepter la sélection',
            reject_label: 'Rejeter le rapport',
            partial_label: 'Appliquer la sélection',
            accept_hint: "Appliquer la sélection enregistre les suggestions choisies sur le brouillon pour la lignée IAT. Aucune modification automatique n'est appliquée au texte du contrat : l'opérateur détermine la ligne rouge.",
            resolve_summary: 'Résolution : [[TOK_2]] · [[TOK_3]] suggestion(s) appliquée(s)',
            error_generic: "Impossible de produire une ligne rouge. Réessayez ou vérifiez l'état du contrat.",
            clause_library_link: 'Gérer la bibliothèque de clauses',
        },
        clause_library: {
            page_title: 'Bibliothèque de clauses',
            add_label: 'Ajouter une clause',
            edit_label: 'Modifier',
            delete_label: 'Supprimer',
            slug_label: 'Limace',
            title_label: 'Titre',
            body_label: 'Corps',
            jurisdiction_label: 'Juridiction',
            tags_label: 'Balises (séparées par des virgules)',
            must_contain_label: 'Marqueurs obligatoires (séparés par des virgules)',
            severity_label: "Gravité en cas d'absence",
            no_clauses: "Aucune clause pour l'instant. Ajoutez-en un pour amorcer l'assistant Redline.",
            save_label: 'Enregistrer',
            cancel_label: 'Annuler',
            load_error: 'Impossible de charger la bibliothèque de clauses.',
            save_error: "Impossible d'enregistrer la clause.",
            delete_error: 'Impossible de supprimer la clause.',
            delete_confirm: 'Supprimer la clause "[[TOK_1]]" ? Cela ne peut pas être annulé.',
        },
        obligation_extraction: {
            extract_label: 'Extraire les obligations',
            extracting: 'Extraction…',
            results_heading: 'Obligations extraites ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            no_obligations: "Aucun modèle d'obligation détecté dans ce texte de contrat.",
            col_class: 'Classe',
            col_summary: 'Résumé (modifiable)',
            col_excerpt: 'Extrait de clause',
            col_due_date: "Date d'échéance (modifiable)",
            col_priority: 'Priorité',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Délai de préavis',
            class_audit: 'Droit de vérification',
            class_insurance: 'Assurance',
            class_sla: 'Réponse [[TOK_0]]',
            class_breach: 'Notification de violation',
            class_renewal: 'Fenêtre de renouvellement',
            citations_label: 'Citations',
            accept_hint: "Accepter créera une tâche par obligation (cap 8) avec la priorité + la date d'échéance affichée.",
            accept_label: 'Accepter les obligations',
            reject_label: 'Rejeter le rapport',
            resolve_summary: 'Résolution : [[TOK_2]] · [[TOK_3]] tâche(s) créée(s)',
            error_generic: "Impossible d'extraire les obligations. Réessayez ou vérifiez le texte du contrat.",
        },
        subprocessor_impact: {
            assess_label: "Évaluer l'impact",
            assessing: 'Évaluation de l’impact…',
            results_heading: 'Impact sur le sous-traitant secondaire ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            risk_delta_label: 'Delta du risque',
            notification_heading: 'Notification client',
            subject_label: 'Sujet',
            deadline_label: 'Date limite de notification',
            body_label: 'Corps de notification',
            required_fields_label: 'Champs obligatoires de l’article 28(4)',
            mitigation_heading: "Mesures d'atténuation",
            citations_label: 'Citations',
            accept_label: "Accepter l'évaluation",
            reject_label: "Rejeter l'évaluation",
            accept_hint: "Accepter créera une tâche de notification client avec la date limite [[TOK_0]] comme date d'échéance.",
            resolve_summary: 'Résolution : [[TOK_2]][[TOK_3]]',
            error_generic: "Impossible d'évaluer ce changement de sous-traitant. Réessayez ou vérifiez l'enregistrement des modifications.",
        },
        onboarding_evidence: {
            collect_label: 'Exécuter la collecte de preuves [[TOK_0]]',
            collecting: 'Recueillir des preuves…',
            results_heading: 'Collecte de preuves ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            findings_heading: 'Preuve existante',
            missing_heading: 'Objets manquants',
            no_findings: 'Aucune preuve existante détectée.',
            no_missing: 'Aucun artefact requis ne manque pour ce niveau de risque.',
            next_step_label: 'Étape suivante',
            class_dpa: 'Accord de traitement des données',
            class_soc2: 'Rapport SOC2',
            class_iso27001: 'Certificat ISO 27001',
            class_insurance: 'Politique de cyberassurance',
            class_incident_history: 'Incident antérieur',
            accept_hint: "Accepter créera des tâches pour chaque artefact manquant (limité à 5). Les conclusions restent provisoires jusqu'à ce que vous les joigniez comme preuve.",
            accept_label: 'Accepter le rapport',
            reject_label: 'Rejeter le rapport',
            resolve_summary: 'Résolution : [[TOK_2]] · [[TOK_3]] tâche(s) créée(s)',
            error_generic: "Impossible d'exécuter la collecte de preuves [[TOK_0]] Réessayez ou vérifiez l'état du dossier d'intégration.",
        },
        no_permission_title: 'Autorisations insuffisantes',
        no_permission_message: "Vous n'êtes pas autorisé à accéder à la gestion des risques liés aux fournisseurs.",
        unknown_vendor: 'Fournisseur inconnu',
        nav: {
            dashboard: 'Tableau de bord des risques',
            scoring: 'Notation des risques',
            questionnaires: "Formulaires d'enquête",
            contracts: 'Contrats',
            gates: "Points d'approbation",
            reviews: 'Évaluations fournisseurs',
            signals: 'Signaux de risque',
            reassessments: 'Réévaluations',
            portfolio: 'Portefeuille de risques',
            acceptances: 'Acceptation des risques',
            review_routing: 'Routage des examens',
            onboarding_cases: "Dossiers d'intégration",
            sub_processor_register: 'Registre des sous-traitants',
        },
        dashboard: {
            title: 'Tableau de bord risque fournisseur',
            page_title: 'Tableau de bord des risques liés aux fournisseurs',
            loading: 'Chargement de dashboard data...',
            risk_tier_header: 'Niveau de risque',
            count_header: 'Compter',
            percentage_header: 'Pourcentage',
            sections_nav: 'Sections sur les risques liés aux fournisseurs',
            urgent_expiry: 'Urgent : expire dans les 14 jours',
            no_previous_tier: 'Aucun niveau précédent',
            view_as_chart: 'Afficher sous forme de graphique',
            view_as_table: 'Afficher sous forme de tableau',
            showing_chart: 'Affichage de la vue graphique',
            showing_table: 'Affichage de la vue tableau',
            load_error: 'Échec de load vendor risk dashboard. Veuillez réessayer.',
            risk_distribution: 'Risque Distribution Aperçu',
            recent_tier_changes: 'Récent Niveau Changements',
            no_tier_changes: 'Non recent niveau changements.',
            review_kpis: 'KPI de révision',
            total_vendors_reviewed: 'Total Fournisseurs Reviewed',
            reviews_by_outcome: 'Révisions par résultat',
            contract_coverage: 'Couverture contractuelle',
            total_vendors: 'Total Fournisseurs',
            with_active_dpa: 'Avec Actif DPA',
            without_dpa: 'Sans DPA',
            dpa_coverage: 'Couverture DPA',
            active_contracts_by_type: 'Actif Contrats par Type',
            expiring_contracts: 'Contrats expirant (90 prochains jours)',
            no_expiring_contracts: 'Aucun contrat expirant dans les 90 prochains jours.',
            vendor: 'Fournisseur',
            previous_tier: 'Précédent Niveau',
            current_tier: 'Actuel Niveau',
            changed_at: 'Modifié le',
            expires_at: 'Expire À',
            days_remaining: 'Jours restants',
            days: 'jours',
            vendors_label: 'fournisseurs',
            no_data: 'Aucune donnée',
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Faible',
            expiring_acceptances_heading: 'Acceptations de risque arrivant à expiration',
            expiring_30d_label: 'Expire dans 30 jours',
            expiring_60d_label: 'Expire dans 60 jours',
            expiring_90d_label: 'Expire dans 90 jours',
        },
        scoring: {
            title: 'Notation des risques',
            page_title: 'Notation des risques liés aux fournisseurs',
            filter_scores: 'Filtrer les scores de risque',
            filter_by_tier: 'Filtrer par niveau de risque',
            scores_pagination: 'Pagination des scores de risque',
            config_dimensions: 'Configuration des dimensions de notation',
            scores_loaded: '[[TOK_1]] scores de risque chargés',
            weight_must_equal_100: 'Le poids total doit être égal à 100 (actuel : [[TOK_1]])',
            out_of_10: 'sur 10, noté [[TOK_1]]',
            dimension_name: 'Nom de la dimension [[TOK_1]]',
            dimension_weight: '[[TOK_1]] poids (pourcentage)',
            must_equal_100: 'doit être égal à 100',
            config_title: 'Configuration de notation',
            scores_title: 'Fournisseur Risque Scores',
            new_score_title: 'Score un Fournisseur',
            new: 'Nouveau Score',
            vendor_id: 'Fournisseur ID',
            risk_tier: 'Risque Niveau',
            score: 'Score',
            scored_at: 'Noté le',
            no_scores: 'Aucun risk scores trouvé',
            all_tiers: 'Tous les niveaux',
            load_config_error: 'Échec de charge risque scoring configuration. Veuillez réessayer.',
            update_config: 'Mettre à jour la configuration de notation',
            update_config_error: 'Échec de mise à jour risque scoring configuration. Veuillez réessayer.',
            load_scores_error: 'Échec de load vendor risk scores. Veuillez réessayer.',
            calculate_error: 'Échec de calculer vendor risque noter. Veuillez réessayer.',
            weight: 'poids',
            score_range: 'Note (1-5)',
            method: 'Méthode',
        },
        questionnaires: {
            title: 'Questionnaires',
            page_title: 'Questionnaires des fournisseurs',
            filter_questionnaires: 'Filtres de questionnaire',
            questionnaire_views: 'Vues du questionnaire',
            templates_list: 'Liste des modèles de questionnaire',
            instances_list: 'Liste des instances de questionnaire',
            filter_by_status: 'Filtrer par statut du questionnaire',
            templates_per_page: 'Modèles par page',
            instances_per_page: 'Instances par page',
            select_template: 'Sélectionnez un modèle de questionnaire',
            template_category: 'Catégorie de modèle',
            templates_tab: 'Modèles',
            instances_tab: 'Occurrences',
            new: 'Nouveau Questionnaire',
            new_template: 'Nouveau modèle',
            new_instance: 'Nouvelle occurrence',
            vendor_id: 'Fournisseur ID',
            template_id: 'Modèle ID',
            assigned_to: 'Assigné À',
            due_date: "Date d'échéance",
            responses: 'Réponses',
            risk_score: 'Achèvement',
            no_questionnaires: 'Aucun questionnaires trouvé',
            load_templates_error: 'Échec de load questionnaire templates. Veuillez réessayer.',
            load_instances_error: 'Échec de load questionnaires. Veuillez réessayer.',
            create_template_error: 'Échec de create questionnaire template. Veuillez réessayer.',
            initiate_error: 'Échec de initiate questionnaire. Veuillez réessayer.',
            submit_error: 'Échec de submit questionnaire. Veuillez réessayer.',
            review_error: 'Échec de review questionnaire. Veuillez réessayer.',
            resubmit: 'Resoumettre',
            approve_error: "Impossible d'approuver le questionnaire",
            reject_error: 'Impossible de rejeter le questionnaire',
            resubmit_error: 'Impossible de resoumettre le questionnaire',
            templates_loaded: '[[TOK_1]] modèles de questionnaire chargés',
            instances_loaded: '[[TOK_1]] instances de questionnaire chargées',
            fill_responses_cta: 'Remplir les réponses',
            fill_responses_title: 'Remplir les réponses du questionnaire',
            template_missing: 'Modèle introuvable.',
            responses_saved: 'Réponses enregistrées.',
            load_template_error: 'Échec du chargement du modèle.',
            version_history: 'Historique des versions',
            download_previous_version: 'Télécharger la version précédente',
            trigger: 'Déclencheur',
            template_label: 'Modèle',
            reviewer: 'Réviseur',
            reviewer_required: 'Un réviseur doit être désigné pour les questionnaires [[TOK_1]] (séparation des tâches).',
            select_option: 'Sélectionnez une option',
            multi_choice_hint: "Sélectionnez tout ce qui s'applique",
            category_initial_onboarding: 'Intégration initiale',
            category_annual_review: 'Bilan annuel',
            category_incident_triggered: 'Déclenché par un incident',
            category_contract_renewal: 'Renouvellement du contrat',
            template_editor: {
                page_title: 'Modifier le modèle de questionnaire',
                preview_page_title: 'Aperçu du modèle de questionnaire',
                edit_structure: 'Modifier la structure',
                preview: 'Aperçu',
                actions: 'Actions',
                back_to_list: 'Retour aux modèles',
                load_error: 'Échec du chargement du modèle',
                save_error: "Échec de l'enregistrement de la structure du modèle",
                saved: 'Structure du modèle enregistrée.',
                sections_heading: 'Sections',
                questions_heading: 'Questions',
                add_section: 'Ajouter une rubrique',
                edit_section: 'Modifier la rubrique',
                delete_section: 'Supprimer la rubrique',
                move_section_up: 'Déplacer la section vers le haut',
                move_section_down: 'Déplacer la section vers le bas',
                confirm_delete_section: 'Supprimer la section "[[TOK_1]]" ? Toutes ses questions seront supprimées.',
                section_title: 'Titre de la section',
                section_description: 'Description de la rubrique',
                section_id: 'Identifiant de la section',
                section_id_hint: 'Généré automatiquement, sauf si vous en définissez un explicitement.',
                no_sections: "Aucune section pour l'instant. Ajoutez une section pour commencer.",
                no_questions: "Aucune question dans cette section pour l'instant.",
                add_question: 'Ajouter une question',
                edit_question: 'Modifier la question',
                delete_question: 'Supprimer la question',
                move_question_up: 'Déplacer la question vers le haut',
                move_question_down: 'Déplacer la question vers le bas',
                confirm_delete_question: 'Supprimer la question "[[TOK_1]]" ?',
                question_text: 'Texte de la question',
                question_type: 'Type de question',
                question_id: 'Numéro de question',
                evidence_required: 'Preuve requise',
                risk_weight: 'Pondération de risque',
                scoring_map: 'Carte de notation',
                scoring_map_json_hint: '[[TOK_0]] objet mappant les valeurs de réponse aux scores numériques.',
                scoring_map_invalid_json: 'La carte de notation doit être valide [[TOK_0]].',
                options_heading: 'Options de réponse',
                add_option: 'Ajouter une option',
                remove_option: "Supprimer l'option",
                option_label: 'Étiquette',
                option_value: 'Valeur',
                option_risk_weight: 'Pondération de risque',
                min_options_error: 'Les questions à choix doivent avoir au moins 2 options.',
                option_label_required: 'Chaque option nécessite une étiquette.',
                option_value_required: 'Chaque option nécessite une valeur.',
                option_value_unique: 'Les valeurs des options doivent être uniques.',
                branching_rules_heading: 'Règles de branchement',
                branching_rules_hint: 'Affichez ou masquez cette question en fonction de la réponse à une question précédente.',
                add_branching_rule: 'Ajouter une règle de branchement',
                remove_branching_rule: 'Supprimer la règle de branchement',
                branching_condition_question: 'Si question',
                branching_condition_value: 'a de la valeur',
                branching_action: 'alors',
                branching_action_show: 'montre cette question',
                branching_action_hide: 'cacher cette question',
                branching_select_condition_question: 'Sélectionnez la question précédente',
                branching_select_condition_value: 'Sélectionner une valeur',
                save: 'Enregistrer la structure',
                saving: 'Sauvegarde...',
                cancel: 'Annuler',
                close: 'Fermer',
                question_text_required: 'Le texte de la question est requis.',
                section_title_required: 'Le titre de la section est requis.',
                type_single_choice: 'Choix unique',
                type_multi_choice: 'Choix multiple',
                type_free_text: 'Texte libre',
                type_numeric: 'Numérique',
                type_date: 'Date',
                type_file_upload: 'Téléchargement de fichiers',
                type_yes_no: 'Oui / Non',
                preview_heading: 'Aperçu du modèle',
                preview_subtitle: 'Aperçu en lecture seule de la façon dont le questionnaire apparaît à un fournisseur.',
                preview_no_content: 'Ce modèle ne comporte pas encore de sections ni de questions.',
                preview_branching_notice: "Les règles de branchement sont évaluées lors du remplissage ; l'aperçu montre chaque question.",
            },
            review_modal: {
                title: 'Examiner les réponses au questionnaire',
                open_cta: 'Examen',
                loading: 'Chargement du questionnaire...',
                template_missing: 'Modèle introuvable.',
                load_error: 'Échec du chargement du questionnaire pour examen.',
                annotation_heading: 'Annotations',
                annotation_placeholder: 'Ajoutez une annotation de réviseur pour cette question...',
                annotation_status_label: 'Statut des annotations',
                annotation_status_acceptable: 'Acceptable',
                annotation_status_concern: 'Préoccupation',
                annotation_status_requires_action: 'Nécessite une action',
                review_comments_label: "Commentaires de l'évaluation globale",
                review_comments_placeholder: 'Résumez les résultats de votre examen...',
                justification_label: 'Justification de la décision',
                justification_placeholder: 'Expliquez la justification de votre décision...',
                reject_requires_comments: "Le rejet d'un questionnaire nécessite la révision des commentaires.",
                decision_heading: 'Décision',
                decision: {
                    approved: 'Approuver',
                    rejected: 'Rejeter',
                    additional_info_requested: 'Demander des informations complémentaires',
                },
                submit: "Envoyer l'avis",
                submitting: "Envoi de l'avis...",
                cancel: 'Annuler',
                submit_success: 'Avis soumis.',
                submit_error: "Échec de l'envoi de l'avis.",
                separation_of_duties_error: 'Vous ne pouvez pas consulter un questionnaire qui vous a été demandé de remplir. La séparation des tâches nécessite un réviseur différent.',
                decision_required: 'Veuillez sélectionner une décision de révision.',
                announce_opened: 'Examen modal ouvert.',
                announce_submitted: 'Avis soumis.',
            },
            instance_detail: {
                submitted_at: 'Soumis',
                reviewed_at: 'Révisé',
                reviewer: 'Réviseur',
                review_decision: 'Décision',
                review_comments: 'Examiner les commentaires',
                decision_approved: 'Approuvé',
                decision_rejected: 'Rejeté',
                decision_additional_info_requested: "Plus d'informations demandées",
                decision_pending: "En attente d'examen",
                expand_comments: 'Afficher les commentaires complets',
                collapse_comments: 'Masquer les commentaires complets',
                no_reviewer: 'Aucun réviseur attribué',
            },
            export: {
                portfolio_label: "Portefeuille d'exportation",
                instance_label: 'Exporter',
                portfolio_success: "Prêt pour l'exportation du portefeuille.",
                instance_success: 'Exportation du questionnaire prête.',
                portfolio_error: "Échec de l'exportation du portefeuille de questionnaires.",
                instance_error: "Échec de l'exportation du questionnaire.",
            },
            branching: {
                hidden_notice: 'Certaines questions sont masquées par des règles de branchement.',
                cycle_warning: 'Un cycle a été détecté dans les règles de branchement. Les questions concernées sont visibles par défaut.',
            },
        },
        contracts: {
            title: 'Contrats',
            page_title: 'Contrats des fournisseurs',
            new: 'Nouveau contrat',
            vendor_id: 'Fournisseur ID',
            filter_contracts: 'Filtrer les contrats',
            filter_by_document_type: 'Filtrer par type de document',
            filter_by_status: 'Filtrer par statut de contrat',
            per_page: 'Contrats par page',
            expired_notice: 'Ce contrat est expiré',
            document_type: 'Type de document',
            expiry_date: "Date d'expiration",
            no_contracts: 'Aucun contracts trouvé',
            all_document_types: 'Tous Document Types',
            load_error: 'Échec de load contracts. Veuillez réessayer.',
            create_error: 'Échec de create contract. Veuillez réessayer.',
            delete_error: 'Échec de delete contract. Veuillez réessayer.',
            update_error: 'Échec de la mise à jour du statut. Veuillez réessayer.',
            confirm_delete: 'Supprimer le contrat « {title} » ?',
            renewal_date: 'Date de renouvellement',
            effective_date: "Date d'effet",
            parties: 'Intervenants',
            summary: 'Résumé',
            n_contracts: '{count} contrats',
            n_contract: '{count} contrat',
            contracts_loaded: '{count} contrats chargés',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Avenant de sécurité',
            doc_type_scc_annex: 'Annexe SCC',
            doc_type_sub_processor_list: 'Liste des sous-traitants',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Autre',
            status_draft: 'Brouillon',
            status_under_negotiation: 'En négociation',
            status_pending_signature: 'En attente de signature',
            status_active: 'Actif',
            status_expired: 'Expiré',
            status_terminated: 'Résilié',
            status_superseded: 'Remplacé',
        },
        gates: {
            title: "Points d'approbation",
            page_title: 'Évaluations des portes',
            new: 'Nouveau Gate Evaluation',
            vendor_id: 'Fournisseur ID',
            gate_name: 'Nom de porte',
            outcome: 'Résultat',
            evaluator: 'Évaluateur',
            no_gates: 'Aucun gate evaluations trouvé',
            load_error: 'Échec de load gate evaluations. Veuillez réessayer.',
            evaluate_error: 'Échec de evaluate vendor gate. Veuillez réessayer.',
            detail_error: 'Échec de fetch evaluation detail. Veuillez réessayer.',
            override_error: 'Échec de override gate evaluation. Veuillez réessayer.',
            criteria_results: 'Critères Résultats',
            evaluate_form: 'Évaluer le portail des fournisseurs',
            per_page: 'Évaluations par page',
            passed: 'Réussi',
            failed: 'Échoué',
            override: 'Remplacement',
            override_justification: 'Justification de remplacement',
            override_placeholder: 'Saisissez justification for overriding this gate evaluation',
            approval_id: 'Approbation ID',
            overall_passed: 'Réussi',
            overall_failed: 'Échoué',
            overall_overridden: 'Contourné',
            evaluations_loaded: '{count} évaluations de porte chargées',
            create_approval_cta: 'Créer une approbation',
        },
        reviews: {
            title: 'Évaluations fournisseurs',
            page_title: 'Avis des fournisseurs',
            new: 'Nouveau examiner',
            vendor_id: 'Fournisseur ID',
            filter_by_outcome: "Filtrer par résultat de l'avis",
            per_page: 'Avis par page',
            kpi_summary: 'Consulter le résumé du [[TOK_0]]',
            review_outcome_label: "Résultat de l'examen",
            edit_outcome: "Modifier le résultat de l'examen",
            reviews_loaded: '[[TOK_1]] avis du fournisseur chargés',
            reviewer: 'Réviseur',
            review_type: 'Examiner Type',
            outcome: 'Résultat',
            findings: 'Constatations',
            no_reviews: 'Aucun vendor reviews trouvé',
            load_kpis_error: 'Échec de fetch vendor review kpis. Veuillez réessayer.',
            load_error: 'Échec de fetch vendor reviews. Veuillez réessayer.',
            update_error: "Impossible de mettre à jour l'avis fournisseur",
            create_error: 'Échec de create vendor review. Veuillez réessayer.',
            total_reviewed: 'Total Fournisseurs Reviewed',
            total_reviews: 'Total de révisions',
            satisfactory: 'Satisfaisant',
            concerns_identified: 'Préoccupations identifiées',
            remediation_required: 'Remédiation Obligatoire',
            escalated: 'Escaladé',
            program_id: 'Programme ID',
            period_id: 'Période ID',
            task_id: 'Tâche ID',
            recommendations: 'Recommandations',
        },
        risk_signals: {
            title: 'Signaux de risque',
            page_title: 'Signaux de risque',
            new_signal: 'Nouveau signal de risque',
            signal_type: 'Type de signal',
            severity: 'Gravité',
            description: 'Descriptif',
            source: 'Origine',
            vendor_id: 'Identifiant du fournisseur',
            certification_expiry: 'Expiration de certification',
            breach_notification: 'Notification de violation',
            financial_instability: 'Instabilité financière',
            compliance_change: 'Changement de conformité',
            custom: 'Personnalisé',
            active: 'Actif',
            acknowledged: 'Accusé réception',
            resolved: 'Résolu',
            no_signals: 'Aucun signal de risque trouvé',
            source_external_feed: 'Flux externe',
            source_manual: 'Manuel',
            source_integration: 'Intégration',
            source_regulatory: 'Réglementaire',
            source_media: 'Médias',
            trigger_reassessment_prompt: 'Ce signal est de gravité élevée. Lancer une réévaluation du fournisseur maintenant ?',
            reassessment_triggered: 'Réévaluation déclenchée.',
            reassessment_trigger_error: 'Échec du déclenchement de la réévaluation.',
        },
        reassessments: {
            title: 'Tâches de réévaluation',
            page_title: 'Tâches de réévaluation',
            trigger: 'Déclencher une réévaluation',
            trigger_success: 'Réévaluation déclenchée avec succès',
            reason: 'Raison',
            deadline: 'Échéance',
            assigned_to: 'Assigné à',
            vendor_id: 'Identifiant du fournisseur',
            outcome: 'Résultat',
            new_risk_level: 'Nouveau niveau de risque',
            complete: 'Terminer la réévaluation',
            complete_success: 'Réévaluation terminée avec succès',
            pending: 'En attente',
            in_progress: 'En cours',
            completed: 'Terminé',
            cancelled: 'Annulé',
            no_tasks: 'Aucune tâche de réévaluation trouvée',
            risk_trend: 'Tendance du risque',
            notes: 'Remarques',
        },
        portfolio: {
            title: 'Portefeuille de risques',
            page_title: 'Portefeuille de risque',
            dashboard: 'Tableau de bord du portefeuille',
            vendor_id: 'Identifiant du fournisseur',
            total_vendors: 'Total des fournisseurs',
            average_score: 'Score de risque moyen',
            high_risk_count: 'Fournisseurs à haut risque',
            trend_direction: 'Direction de la tendance',
            improved: 'Amélioré',
            stable: 'Stable',
            degraded: 'Dégradé',
            vendor_trend: 'Tendance fournisseur',
            outstanding_questionnaires: 'Questionnaires en suspens',
            overdue_assessments: 'Évaluations en retard',
            no_outstanding: 'Aucun questionnaire en suspens',
            no_overdue: 'Aucune évaluation en retard',
            due_date: "Date d'échéance",
        },
        risk_acceptance: {
            title: "Registre d'acceptation des risques",
            page_title: "Registre d'acceptation des risques",
            new_acceptance: 'Nouvelle acceptation de risque',
            vendor_id: 'Identifiant du fournisseur',
            risk_level: 'Niveau de risque',
            conditions: 'Conditions',
            justification: 'Justification',
            expiry_date: "Date d'expiration",
            create_success: 'Acceptation de risque créée avec succès',
            review_condition: 'Examiner la condition',
            condition_met: 'Condition remplie',
            condition_not_met: 'Condition non remplie',
            review_success: 'Condition examinée avec succès',
            export_register: 'Exporter le registre',
            active: 'Actif',
            expired: 'Expiré',
            revoked: 'Révoqué',
            no_acceptances: 'Aucune acceptation de risque trouvée',
            met_count: '[[TOK_2]]/[[TOK_3]] rencontré',
        },
        review_routing: {
            title: 'Routage des examens',
            page_title: 'Réviser le routage',
            route_to_reviewers: 'Envoyer aux examinateurs',
            route_success: 'Envoyé aux examinateurs avec succès',
            vendor_id: 'Identifiant du fournisseur',
            reviewer_id: "Identifiant de l'examinateur",
            reviewer_role: "Rôle de l'examinateur",
            questionnaire_id: 'Identifiant du questionnaire',
            review_status: "Statut de l'examen",
            reviewers_label: 'Réviseurs (user_id, rôle par ligne)',
            pending: 'En attente',
            in_review: 'En examen',
            completed: 'Terminé',
            no_routing: "Aucun routage d'examen trouvé",
            primary_reviewer: 'Examinateur principal',
            secondary_reviewer: 'Examinateur secondaire',
            approver: 'Approbateur',
        },
        onboarding: {
            title: "Dossiers d'intégration fournisseurs",
            page_title: "Dossiers d'intégration fournisseurs",
            new_case: "Nouveau dossier d'intégration",
            case_detail: "Dossier d'intégration",
            open_mps_dossier_filing: 'Ouvrir un dépôt MPS',
            dossier_filing_description: "Crée un nouveau dépôt MPS pré-rempli à partir de ce cas d'onboarding. Le dépôt sera lié au cas.",
            dossier_filing_dpia_id: 'ID DPIA',
            dossier_filing_dpia_id_placeholder: 'ex. dpia_01TEST000000000000000001',
            dossier_filing_title: 'Titre du dépôt',
            dossier_filing_form_type: 'Type de formulaire',
            dossier_filing_submit: 'Créer le dépôt',
            dossier_filing_validation_error: 'ID DPIA et titre requis.',
            dossier_filing_created: 'Dépôt MPS créé',
            dossier_filing_error: 'Impossible de créer le dépôt MPS.',
            linked_questionnaire_due_date: 'Échéance',
            linked_questionnaire_assignee: 'Attribué à',
            linked_questionnaire_submitted_at: 'Soumis le',
            score_last_scored: 'Dernière notation',
            score_dimensions: 'Dimensions',
            linked_contract_document_type: 'Type de document',
            linked_contract_effective_date: "Date d'entrée en vigueur",
            linked_contract_expiry_date: "Date d'expiration",
            linked_sub_processor_countries: 'Pays de traitement',
            linked_sub_processor_last_assessment: 'Dernière évaluation',
            linked_sub_processor_next_assessment: 'Prochaine évaluation',
            case_id: 'ID du dossier',
            vendor: 'Fournisseur',
            case_type: 'Type de dossier',
            service_description: 'Description du service',
            data_categories: 'Catégories de données',
            systems_accessed: 'Systèmes accédés',
            jurisdiction: 'Juridiction',
            hosting_model: "Modèle d'hébergement",
            controller_role: 'Rôle responsable/sous-traitant',
            status_pipeline: 'Pipeline de statut',
            tabs_label: "Sections du dossier d'intégration",
            per_page: 'Dossiers par page',
            filter_cases: "Filtrer les dossiers d'intégration",
            cases_count: 'dossiers',
            cases_loaded: "dossiers d'intégration chargés",
            no_cases: "Aucun dossier d'intégration trouvé.",
            vendor_lookup_placeholder: 'Entrez ID du fournisseur',
            data_categories_placeholder: 'ex., données_personnelles, financières, santé',
            systems_placeholder: 'ex., CRM, ERP, Système RH',
            status_open: 'Ouvert',
            status_in_progress: 'En cours',
            status_awaiting_approval: "En attente d'approbation",
            status_approved: 'Approuvé',
            status_remediation_required: 'Remédiation requise',
            status_closed: 'Fermé',
            type_new_vendor: 'Nouveau fournisseur',
            type_service_change: 'Changement de service',
            type_renewal: 'Renouvellement',
            type_reassessment: 'Réévaluation',
            tab_overview: 'Aperçu',
            tab_due_diligence: 'Diligence raisonnable',
            tab_security_assessment: 'Évaluation de sécurité',
            tab_contractual_controls: 'Contrôles contractuels',
            tab_sub_processors: 'Sous-traitants',
            tab_approval_gates: "Portes d'approbation",
            tab_evidence: 'Preuves',
            tab_placeholder: "Le contenu de cette section sera complété lors du processus d'intégration.",
            completion_not_started: 'Non démarré',
            completion_in_progress: 'En cours',
            completion_completed: 'Terminé',
            completion_requiring_attention: 'Attention requise',
            gate_name: 'Nom de la porte',
            approver: 'Approbateur',
            decision: 'Décision',
            comments: 'Commentaires',
            decide: 'Prendre une décision',
            decision_approved: 'Approuvé',
            decision_rejected: 'Rejeté',
            decision_deferred: 'Différé',
            no_approvals: "Aucune porte d'approbation configurée pour ce dossier.",
            approval_success: "Décision d'approbation enregistrée avec succès",
            approval_error: "Impossible d'enregistrer la décision d'approbation",
            transition_status: 'Changer le statut',
            confirm_transition: 'Changer le dossier de "{from}" à "{to}" ?',
            transition_success: 'Statut du dossier changé avec succès',
            transition_error: 'Impossible de changer le statut du dossier',
            create_success: "Dossier d'intégration créé avec succès",
            create_error: "Impossible de créer le dossier d'intégration",
            load_error: "Impossible de charger les dossiers d'intégration",
            detail_error: 'Impossible de charger les détails du dossier',
            export: 'Exporter',
            export_error: "Impossible d'exporter le dossier d'intégration",
            evidence_tab_description: "Téléversez et exportez les preuves pour le cas d'onboarding.",
            upload_evidence_label: 'Téléverser une preuve',
            attached_evidence_heading: 'Preuves jointes',
            no_evidence_attached: 'Aucune preuve jointe pour le moment.',
            export_bundle_button: 'Exporter le dossier de preuves',
            load_attachments_error: 'Échec du chargement des preuves.',
            linked_questionnaires_heading: 'Questionnaires liés',
            no_linked_questionnaires: 'Aucun questionnaire lié.',
            linked_scores_heading: 'Scores liés',
            no_linked_scores: 'Aucun score lié.',
            latest_score_label: 'Dernier score',
            linked_contracts_heading: 'Contrats liés',
            no_linked_contracts: 'Aucun contrat lié.',
            linked_sub_processors_heading: 'Sous-traitants liés',
            no_linked_sub_processors: 'Aucun sous-traitant lié.',
        },
        sub_processors: {
            title: 'Registre des sous-traitants',
            page_title: 'Registre des sous-traitants',
            new_record: 'Nouveau sous-traitant',
            edit_record: 'Modifier le sous-traitant',
            onboarding_case: "Dossier d'intégration",
            services: 'Services fournis',
            data_categories: 'Catégories de données',
            processing_countries: 'Pays de traitement',
            dpa_chain_status: 'Statut de la chaîne DPA',
            certifications: 'Certifications',
            last_assessment: 'Dernière évaluation',
            next_assessment: 'Prochaine évaluation',
            change_history: 'Historique des modifications',
            history: 'Historique',
            changed_by: 'Modifié par',
            comma_separated: 'Valeurs séparées par des virgules',
            filter_records: 'Filtrer les enregistrements',
            filter_by_dpa: 'Filtrer par statut de chaîne DPA',
            all_dpa_statuses: 'Tous les statuts DPA',
            per_page: 'Enregistrements par page',
            records_count: 'sous-traitants',
            records_loaded: 'enregistrements chargés',
            no_records: 'Aucun sous-traitant trouvé.',
            no_history: 'Aucun historique de modifications disponible.',
            dpa_active: 'Actif',
            dpa_pending: 'En attente',
            dpa_expired: 'Expiré',
            dpa_not_required: 'Non requis',
            create_success: 'Sous-traitant créé avec succès',
            create_error: 'Impossible de créer le sous-traitant',
            update_success: 'Sous-traitant mis à jour avec succès',
            update_error: 'Impossible de mettre à jour le sous-traitant',
            load_error: 'Impossible de charger le registre',
            history_error: "Impossible de charger l'historique des modifications",
            export_csv: 'Exporter CSV',
            export_json: 'Exporter JSON',
            export_error: "Impossible d'exporter les données",
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: "Tableau de bord d'orchestration",
            runs: "Exécutions d'orchestration",
            tasks: "Tâches d'exécution",
            templates: 'Modèles de liste de contrôle',
            vendor_requests: 'Demandes fournisseurs',
            proof_chain: 'Chaîne de preuves',
            dsr_integration: 'Intégration DSR',
            vendor_verification: 'Vérification fournisseur',
            completeness: 'Tableau de complétude',
        },
        dashboard: {
            title: "Tableau de bord d'orchestration",
            loading: 'Chargement de dashboard data...',
            active_runs: 'Exécutions actives',
            completion_rate: "Taux d'achèvement",
            avg_completion_time: "Temps moyen d'achèvement",
            overdue_tasks: 'En retard Tâches',
            vendor_compliance: 'Fournisseur Conformité',
            recent_runs: 'Exécutions récentes',
            no_recent_runs: "Aucune exécution récente d'orchestration.",
            run_id: 'Exécuter ID',
            ticket_id: 'ID du ticket',
            progress: 'Progression',
            systems: 'Systèmes',
            vendors: 'Fournisseurs',
            load_error: "Échec du chargement du tableau de bord d'orchestration. Veuillez réessayer.",
            aria_table: "Exécutions d'orchestration récentes",
        },
        runs: {
            title: "Exécutions d'orchestration",
            new: 'Nouveau exécuter',
            run_id: 'Exécuter ID',
            ticket_id: 'ID du ticket',
            progress: 'Progression',
            systems: 'Systèmes',
            vendors: 'Fournisseurs',
            data_subject_ref: 'Données Sujet Ref',
            data_categories: 'Catégories de données',
            enable_proof_chain: 'Activer la chaîne de preuve',
            start: 'Démarrer',
            started: "L'exécution a commencé",
            mark_ready: 'Marquer prêt',
            marked_ready: 'Exécuter marqué comme prêt',
            complete: 'Terminé',
            complete_exceptions: 'Complet avec exceptions',
            pause: 'Pause',
            resume: 'CV',
            cancel: 'Annuler',
            no_runs: 'Aucun orchestration runs trouvé',
            load_error: "Échec du chargement des exécutions d'orchestration. Veuillez réessayer.",
            create_error: "Échec de la création de l'exécution d'orchestration",
            aria_filter_status: "Filtrer par statut d'exécution",
            aria_table: "Exécutions d'orchestration",
            placeholder_ticket_id: 'ex. TKT-000123',
            placeholder_data_subject_ref: 'ex. DS-REF-001',
            placeholder_data_categories: 'ex. personal_data, financial, health',
            title_label: 'Title',
            run_type: 'Run Type',
            run_type_labels: {
                data_subject_request: 'Data Subject Request',
                retention_expiry: 'Retention Expiry',
                manual: 'Manual',
                scheduled: 'Scheduled',
            },
            field_guidelines: {
                title: 'A descriptive name for this orchestration run.',
                run_type: 'The origin or trigger for the deletion process.',
                ticket_id: 'The associated ticket ID from your DSR or support system.',
                data_subject_ref: 'A unique identifier for the data subject (e.g., internal ID, email hash).',
                data_categories: 'Specific categories of personal data to be deleted (comma-separated).',
                proof_enabled: 'Maintains an immutable cryptographic chain of evidence for this run.',
            },
            actions: 'Actions',
            progress_guideline: 'Calculated based on completed system tasks and vendor requests.',
            placeholder_title: 'e.g., Q2 2026 Customer Deletion Batch',
        },
        tasks: {
            title: "Tâches d'exécution",
            task_id: 'Tâche ID',
            run_id: 'Exécuter ID',
            system_name: 'Système Nom',
            assigned_to: 'Assigné À',
            sla_deadline: 'SLA Échéance',
            progress: 'Progression',
            enter_run_id: 'Saisissez exécuter id à filtrer...',
            select_run: 'Sélectionnez une exécution pour afficher les tâches',
            unassigned: 'Non assigné',
            overdue: 'En retard',
            assign_task: 'Assigner Tâche',
            assignee_id: 'Assigné ID',
            update_status: 'Mettre à jour Statut',
            new_status: 'Nouveau statut',
            no_transitions: 'Cette tâche est dans un état final et ne peut pas changer de statut.',
            select_status_placeholder: 'Sélectionnez un nouveau statut',
            skip_justification: 'Justification de l’omission',
            failure_reason: 'Motif de l’échec',
            no_tasks: 'Aucun execution tasks trouvé',
            new_task: 'Nouvelle tâche',
            system_id: 'ID système',
            data_classification: 'Classification des données',
            load_error: "Échec du chargement des tâches d'exécution. Veuillez réessayer.",
            assign_error: "Échec de l'attribution de la tâche",
            status_error: 'Échec de la mise à jour du statut de la tâche',
            no_tasks_for_run: 'Cette exécution de suppression n’a pas encore de tâches d’exécution.',
            aria_filter_run_id: "Filtrer par ID d'exécution",
            aria_filter_status: 'Filtrer par statut de tâche',
            aria_table: "Tâches d'exécution",
            view_steps: 'Voir les étapes',
            steps_modal_title: 'Étapes d’exécution',
            step_title: 'Étape',
            step_status: 'Statut de l’étape',
            step_notes: 'Remarques',
            step_evidence: 'Fichiers de preuve',
            step_evidence_required: 'Une preuve est requise pour cette étape',
            step_evidence_missing: 'Aucune preuve téléversée',
            step_save: 'Enregistrer l’étape',
            step_saved: 'Étape mise à jour',
            step_save_error: 'Échec de la mise à jour de l’étape',
            create_success: 'Tâche d’exécution créée',
            create_error: 'Échec de la création de la tâche d’exécution',
            step_upload_label: 'Joindre une preuve',
        },
        templates: {
            title: 'Modèles de liste de contrôle',
            new: 'Nouveau modèle',
            template_id: 'Modèle ID',
            system_type: 'Système Type',
            est_duration: 'Durée est.',
            steps: 'Étapes',
            action_type: "Type d'action",
            instructions: 'Consignes',
            mandatory: 'Obligatoire',
            add_step: 'Ajouter étape',
            step_n: 'Étape',
            no_templates: 'Aucun checklist templates trouvé',
            all_system_types: 'Tous Système Types',
            load_error: 'Échec du chargement des modèles de liste de contrôle. Veuillez réessayer.',
            create_error: 'Échec de la création du modèle de liste de contrôle',
            aria_filter_system_type: 'Filtrer par type de système',
            aria_filter_status: 'Filtrer par statut du modèle',
            aria_table: 'Modèles de liste de contrôle',
            placeholder_name: 'ex. Liste de contrôle de suppression de base de données',
            guideline_name: 'Use a clear operating name, for example “Database Deletion Checklist”.',
            guideline_system_type: 'Choose the system category this checklist will usually run against.',
            guideline_status: 'Draft templates can be reviewed before activation; active templates can be reused in runs.',
            guideline_description: 'Summarise scope, retention context, and when teams should select this template.',
            update_success: 'Modèle mis à jour avec succès',
            create_success_msg: 'Modèle créé avec succès',
            update_error: 'Échec de la mise à jour du modèle',
            activate_success: 'Modèle activé avec succès',
            activate_error: 'Échec de l’activation du modèle',
            archive_success: 'Modèle archivé avec succès',
            archive_error: 'Échec de l’archivage du modèle',
            clone_success: 'Modèle cloné avec succès',
            clone_error: 'Échec du clonage du modèle',
        },
        vendor_requests: {
            title: 'Fournisseur Suppression Demandes',
            new: 'Nouveau demande',
            request_id: 'Demande ID',
            vendor_name: 'Fournisseur Nom',
            vendor_id: 'Fournisseur ID',
            data_subject_ref: 'Données Sujet Ref',
            data_categories: 'Catégories de données',
            legal_basis: 'Base juridique',
            sla_days: 'Jours SLA',
            requested_completion: 'Achèvement demandé',
            communications: 'Échanges',
            total_requests: 'Total Demandes',
            no_requests: 'Aucun vendor deletion requests trouvé',
            filter_vendor_id: 'Filtrer par Fournisseur ID...',
            change_status: 'Changer le Statut',
            new_status: 'Nouveau Statut',
            actions: 'Actions',
            load_error: 'Échec du chargement des demandes de suppression fournisseur. Veuillez réessayer.',
            create_error: 'Échec de la création de la demande de suppression fournisseur',
            dashboard_error: 'Échec du chargement du tableau de bord de suppression fournisseur. Veuillez réessayer.',
            aria_filter_status: 'Filtrer par statut de la demande',
            aria_filter_vendor_id: 'Filtrer par ID fournisseur',
            aria_table: 'Demandes de suppression fournisseur',
            placeholder_vendor_id: 'ex. VND-001',
            placeholder_vendor_name: 'ex. Acme Analytics',
            placeholder_data_subject_ref: 'ex. DS-REF-001',
            placeholder_data_categories: 'ex. personal_data, analytics',
            placeholder_legal_basis: 'ex. PDPL Article 19',
        },
        proof_chain: {
            title: 'Visualiseur de chaîne de preuve',
            enter_run_id: 'Saisissez exécuter id...',
            load_chain: 'Charger la chaîne',
            verify_chain: 'Vérifier la chaîne',
            verifying: 'Vérification...',
            chain_valid: 'La chaîne est valide',
            chain_invalid: 'La chaîne est cassée',
            chain_length: 'Longueur de chaîne',
            broken_at_index: "Cassé à l'index",
            no_proof_records: 'Aucun enregistrement de preuve trouvé pour cette exécution.',
            proof_id: 'ID de preuve',
            entity_type: "Type d'entité",
            entity_id: "ID de l'entité",
            event_hash: "Hash de l'événement",
            previous_hash: 'Hash précédent',
            attestation: "Déclaration sur l'honneur",
            attestation_actor: 'Réalisé par',
            attestation_signed_at: 'Signé le',
            attestation_signature: 'Signature',
            attestation_evidence_refs: 'Références de preuves',
            run_field_label: 'Exécution de suppression',
            select_run: 'Sélectionnez une exécution de suppression…',
            aria_select_run: 'Exécution de suppression pour la recherche de la chaîne de preuves',
            chain_broken_here: 'Chaîne cassée ici',
            load_error: 'Échec du chargement de la chaîne de preuves. Veuillez réessayer.',
            verify_error: 'Échec de la vérification de la chaîne de preuves. Veuillez réessayer.',
            aria_run_id: "ID d'exécution pour la recherche de chaîne de preuves",
        },
        dsr_integration: {
            change_status: 'Changer le statut',
            request_type: 'Type de demande',
            data_subject_hint: 'Identifiant de la personne concernée dont les données seront effacées (p. ex. e-mail ou ID client). Correspond généralement au demandeur du dossier DSR sélectionné.',
            title: 'Intégration de suppression DSR',
            create_run: 'Créer une exécution de suppression DSR',
            dsr_case_id: 'ID du dossier DSR',
            data_subject_id: 'ID de la personne concernée',
            systems: 'Systèmes cibles',
            route_to_department: 'Transmettre au département',
            confirm_deletion: 'Confirmer la suppression',
            no_runs: 'Aucune exécution de suppression DSR trouvée',
            status: 'Statut de suppression',
            deadline: 'Date limite',
        },
        vendor_verification: {
            title: 'Vérification de suppression fournisseur',
            create_followup: 'Créer un suivi',
            deadline: 'Date limite de confirmation',
            escalation_contact: "Contact d'escalade",
            record_confirmation: 'Enregistrer la confirmation',
            overdue: 'Suppressions en retard',
            escalate: 'Escalader',
            confirm_escalation: 'Êtes-vous sûr de vouloir escalader cette demande de suppression fournisseur ?',
            no_followups: 'Aucun suivi fournisseur trouvé',
            no_overdue: 'Aucune suppression fournisseur en retard',
            vendor_request: 'Demande fournisseur',
            vendor: 'Fournisseur',
            unknown_vendor: 'Fournisseur inconnu',
            overdue_badge: 'En retard',
            mark_confirmed: 'Marquer comme confirmé',
            mark_confirmed_for: 'Marquer la suppression comme confirmée pour {vendor}',
            confirm_confirmation: 'Marquer cette suppression fournisseur comme confirmée ?',
            confirmation_success: 'Suppression fournisseur confirmée',
            confirmation_failed: 'Échec de la confirmation de la suppression fournisseur',
            select_request: 'Sélectionner une demande fournisseur…',
            escalation_contact_placeholder: 'p. ex. dpo@vendor.example',
            create_success: 'Suivi fournisseur créé avec succès',
            create_failed: 'Échec de la création du suivi fournisseur',
            deadline_hint: 'Cette page n’affiche que les suivis dont l’échéance est déjà dépassée.',
            deadline_future_warning: 'Cette échéance est dans le futur, le suivi n’apparaîtra donc pas dans la liste des éléments en retard tant que la date n’est pas passée.',
            escalation_success: 'Suppression fournisseur escaladée avec succès',
            escalation_failed: 'Échec de l’escalade de la suppression fournisseur',
        },
        completeness: {
            title: 'Complétude de suppression',
            check_conflicts: 'Vérifier les conflits de conservation',
            no_conflicts: 'Aucun conflit de conservation trouvé',
            conflict_resolution: 'Résolution de conflit',
            extend_retention: 'Prolonger la conservation',
            proceed_deletion: 'Procéder à la suppression',
            escalate_conflict: 'Escalader',
            resolve: 'Résoudre le conflit',
            data_subject_id: 'ID de la personne concernée',
            placeholder_data_subject_id: "Saisir l'ID de la personne concernée",
            data_subject_hint: 'Identifiant de la personne dont vous vérifiez la suppression (p. ex. e-mail, ID client ou référence DSR). Choisissez un sujet connu ou saisissez-en un.',
            guidance: "Saisissez ou sélectionnez un ID de personne concernée, choisissez éventuellement des systèmes, puis lancez la vérification pour voir l'exhaustivité de la suppression et les conflits de conservation.",
            completion: 'Achèvement de la suppression',
            pending_items: 'Éléments en attente',
            system: 'Système',
            policy: 'Politique',
            retention_end: 'Fin de conservation',
            completed_items: 'Éléments Complétés',
            last_review_label: 'Dernier avis',
            days_ago: 'il y a quelques jours',
            review_overdue: 'Cycle de révision dépassé. Réexamen requis.',
        },
        run_status_labels: {
            pending: 'En attente',
            planning: 'Planification',
            ready: 'Prêt',
            in_progress: 'En Cours',
            paused: 'En Pause',
            completed: 'Terminé',
            completed_with_exceptions: 'Terminé avec Exceptions',
            cancelled: 'Annulé',
        },
        task_status_labels: {
            pending: 'En Attente',
            assigned: 'Assigné',
            in_progress: 'En Cours',
            awaiting_verification: 'En Attente de Vérification',
            verified: 'Vérifié',
            failed: 'Échoué',
            skipped: 'Ignoré',
        },
        system_type_labels: {
            database: 'Base de Données',
            saas_application: 'Application SaaS',
            file_storage: 'Stockage de Fichiers',
            email_system: 'Système de Messagerie',
            analytics_platform: 'Plateforme Analytique',
            backup_system: 'Système de Sauvegarde',
            vendor_managed: 'Géré par le Fournisseur',
            custom: 'Personnalisé',
        },
        template_status_labels: {
            draft: 'Brouillon',
            active: 'Actif',
        },
        action_type_labels: {
            manual_check: 'Vérification Manuelle',
            api_call: 'Appel API',
            sql_query: 'Requête SQL',
            script_execution: 'Exécution de Script',
            file_deletion: 'Suppression de Fichier',
            verification: 'Vérification',
            notification: 'Notification',
            approval: 'Approbation',
        },
        request_status_labels: {
            draft: 'Brouillon',
            sent: 'Envoyé',
            acknowledged: 'Accusé de réception',
            in_progress: 'En Cours',
            completed: 'Terminé',
            overdue: 'En Retard',
            escalated: 'Escaladé',
            disputed: 'Contesté',
        },
        event_type_labels: {
            initiation: 'Initiation',
            data_deletion: 'Suppression de Données',
            completion: 'Achèvement',
            verification: 'Vérification',
            rollback: 'Annulation',
        },
        count_labels: {
            one_template: '1 modèle',
            n_templates: '{n} modèles',
            one_run: '1 exécution',
            n_runs: '{n} exécutions',
            one_task: '1 tâche',
            n_tasks: '{n} tâches',
            one_request: '1 demande',
            n_requests: '{n} demandes',
        },
        aria: {
            completion_rate: 'Taux achèvement: {pct}%',
            vendor_compliance: 'Conformité fournisseur: {pct}%',
            run_progress: 'Progression: {pct}%',
            run_progress_systems: 'Progression: {completed} sur {total} systèmes traités',
            chain_broken: 'Chaîne rompue à cet enregistrement',
            chain_valid: 'Chaîne valide à cet enregistrement',
            chain_unknown: 'Statut de chaîne inconnu',
            escalate_vendor: 'Escalader {id}',
            resolve_conflict: 'Résoudre le conflit pour {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'L’intégralité de la suppression doit être vérifiée au moins tous les 365 jours. Les enregistrements dépassant ce seuil sont signalés pour un nouvel examen obligatoire afin de maintenir la conformité réglementaire.',
            runs_data_d1_lifecycle_info: "Les états d'exécution de l'orchestration correspondent au cycle de vie DATA-D1 : planification = catalogue, prêt = classer, in_progress = appliquer les règles, terminé = preuves générées, completed_with_exceptions = révision requise. Chaque transition est enregistrée dans la chaîne de preuve.",
            vendor_record_linkage_info: "Chaque demande de suppression de fournisseur est liée à son enregistrement de fournisseur via vendor_id. La confirmation d'achèvement nécessite une preuve cryptographique de la chaîne de preuve avant que la demande puisse être marquée comme terminée.",
            templates_internal_classification_info: 'Tous les modèles de liste de contrôle de suppression sont classés comme documents organisationnels internes. Ils ne portent pas d’identifiant de formulaire réglementaire officiel et ne doivent pas être soumis en tant que dépôts réglementaires.',
            proof_chain_evidence_info: "Chaque enregistrement de preuve capture la personne concernée/catégorie, l'horodatage, l'acteur, la base juridique et un hachage SHA-256. Ensemble, ces champs produisent des preuves de suppression cryptographique qui satisfont aux exigences d'audit réglementaire.",
            retention_data_law_info: "Les calendriers de conservation sur ce tableau de bord sont dérivés de la classification Loi sur les données attribuée à chaque catégorie de données. Lorsqu'une classification change, les règles de conservation liées sont mises à jour automatiquement pour garantir l'alignement réglementaire.",
            dsr_erasure_route_info: "Les exécutions d’effacement DSR sont liées au dossier de demande de droits d’origine. Le délai réglementaire (généralement 30 jours en vertu de l'[[TOK_0]] Art. 17) est suivi automatiquement. Les cas en retard sont signalés pour escalade.",
        },
    },
    discovery: {
        nav: {
            dashboard: 'Tableau de bord de découverte',
            scans: 'Scans de découverte',
            staging_area: 'Zone de transit',
            dedup_rules: 'Règles de déduplication',
            classification_rules: 'Règles de classification',
            suggestions: 'File de suggestions',
            analytics: 'Analytique des suggestions',
            import_templates: "Modèles d'importation",
            connectors: 'Gestion des connecteurs',
            discovery_cycles: 'Cycles de découverte',
            owner_review: 'Revue du propriétaire',
            classification_lineage: 'Historique de classification',
        },
        dashboard: {
            title: 'Tableau de bord de découverte',
            loading: 'Chargement de dashboard data...',
            total_scans: "Total d'analyses",
            active_scans: 'Analyses actives',
            completed_30d: 'Terminé (30d)',
            failed_30d: 'Échoué (30d)',
            systems_discovered: 'Systèmes découverts',
            pending_staged_records: 'En attente Staged Enregistrements',
            recent_scans: 'Analyses récentes',
            no_recent_scans: 'Aucune analyse récente.',
            scan_id: 'Scanner ID',
            discovered: 'Découvert',
            view_all_scans: 'Voir All Scans',
            staging_area: 'Zone de staging',
            suggestion_queue: 'File de suggestions',
            records_reviewed: 'Enregistrements examinés',
            records_approved: 'Enregistrements approuvés',
            exceptions_pending: 'Exceptions en attente',
            view_as_chart: 'Afficher en graphique',
            view_as_table: 'Afficher en tableau',
        },
        scans: {
            title: 'Scans de découverte',
            new: 'Nouveau scanner',
            scan_id: 'Scanner ID',
            scan_type: 'Scanner Type',
            progress: 'Progression',
            discovered: 'Découvert',
            no_scans: 'Aucun discovery scans trouvé',
            all_scan_types: 'Tous Scanner Types',
            source_config: 'Config. source (JSON)',
            invalid_json: 'JSON invalide dans la config. source',
            load_error: 'Échec de load discovery scans. Veuillez réessayer.',
            create_error: 'Échec de create discovery scan. Veuillez réessayer.',
            change_status: 'Changer le statut',
            new_status: 'Nouveau statut',
            actions: 'Actions',
            type_endpoint: 'Point de terminaison',
            type_spreadsheet_import: 'Importation de feuille de calcul',
            type_cmdb_sync: 'Synchronisation CMDB',
            type_cloud_sync: 'Synchronisation cloud',
            status_pending: 'En attente',
            status_running: 'En cours',
            status_completed: 'Terminé',
            status_failed: 'Échoué',
            status_cancelled: 'Annulé',
            source_config_placeholder: '{"hôte": "...", "port": 443}',
        },
        staging_area: {
            title: 'Zone de transit',
            record_id: 'Enregistrement ID',
            source_scan: 'Analyse source',
            entity_type: "Type d'entité",
            suggested_name: 'Nom suggéré',
            confidence: 'Confiance',
            no_records: 'Aucun staged records trouvé',
            promote: 'Promouvoir',
            discard: 'Rejeter',
            review: 'Examiner',
            merge: 'Fusionner',
            merge_title: "Fusionner l'enregistrement",
            merge_target_id: 'Fusionner Cible ID',
            reject_reason_placeholder: 'Reason pour rejet...',
            promotion_status: 'Statut de promotion',
            dedup_status: 'Statut de dédup.',
            all_source_types: 'Tous les types de source',
            all_promotion_statuses: 'Tous les statuts de promotion',
            all_dedup_statuses: 'Tous les statuts de dédup.',
            load_error: 'Échec de load staged records. Veuillez réessayer.',
            promote_error: 'Échec de promote record. Veuillez réessayer.',
            reject_error: 'Échec de rejeter enregistrer. Veuillez réessayer.',
            merge_error: 'Échec de merge record. Veuillez réessayer.',
            review_error: 'Échec de marquer enregistrer pour examen. Veuillez réessayer.',
            bulk_promote_error: 'Échec de bulk promote records. Veuillez réessayer.',
            bulk_reject_error: 'Échec de bulk reject records. Veuillez réessayer.',
            service_type_web_server: 'Serveur web',
            service_type_database: 'Base de données',
            service_type_api_gateway: 'Passerelle API',
            service_type_storage: 'Stockage',
            service_type_authentication: 'Authentification',
            service_type_analytics: 'Analytique',
            service_type_unknown: 'Inconnu',
            source_type_endpoint_scan: 'Scan de point de terminaison',
            source_type_spreadsheet: 'Feuille de calcul',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Inventaire cloud',
            promotion_status_new: 'Nouveau',
            promotion_status_under_review: 'En cours de révision',
            promotion_status_promoted: 'Promu',
            promotion_status_rejected: 'Rejeté',
            promotion_status_merged: 'Fusionné',
            dedup_status_unmatched: 'Sans correspondance',
            dedup_status_potential_match: 'Correspondance potentielle',
            dedup_status_exact_match: 'Correspondance exacte',
            dedup_status_resolved: 'Résolu',
            confirm_bulk_reject: 'Êtes-vous sûr de vouloir rejeter les enregistrements sélectionnés ?',
            scan_batch_id: 'ID de lot',
            promote_to_registry_title: 'Promouvoir au registre de données',
            promote_modal_instructions: "Crée un élément du registre de données avec collection_method : lien d'observation et de provenance vers cet enregistrement de découverte. L'élément commence au statut de brouillon pour révision.",
            promote_label_category: 'Catégorie',
            promote_label_name_override: 'Nom (remplacement facultatif)',
            placeholder_name_override: "La valeur par défaut est le nom/nom d'hôte de l'enregistrement de découverte",
            promote_label_sensitivity: 'Sensibilité proposée',
            inherit_from_category: 'Hériter de la catégorie',
        },
        dedup_rules: {
            title: 'Règles de déduplication',
            new: 'Nouveau Rule',
            rule_name: 'Nom de la règle',
            match_fields: 'Correspondance Champs',
            threshold: 'Seuil',
            no_rules: 'Aucun dedup rules trouvé',
            seed_defaults: 'Valeurs initiales par défaut',
            match_type: 'Correspondance Type',
            similarity_threshold: 'Seuil de similarité',
            field_name: 'Champ Nom',
            load_error: 'Échec de load dedup rules. Veuillez réessayer.',
            create_error: 'Échec de create dedup rule. Veuillez réessayer.',
            toggle_error: 'Échec de toggle dedup rule. Veuillez réessayer.',
            seed_error: 'Échec de seed defaults. Veuillez réessayer.',
            priority: 'Priorité',
            enabled_status: 'Activé',
            disabled_status: 'Désactivé',
            default_badge: 'Par défaut',
            enable: 'Activer',
            disable: 'Désactiver',
            match_type_exact: 'Exact',
            match_type_fuzzy: 'Approximatif',
            match_type_regex: 'Expression régulière',
            match_type_ip_range: 'Plage IP',
        },
        classification_rules: {
            title: 'Règles de classification',
            new: 'Nouveau Rule',
            rule_name: 'Nom de la règle',
            pattern: 'Modèle',
            classification: 'Classement',
            no_rules: 'Aucun classification rules trouvé',
            seed_defaults: 'Valeurs initiales par défaut',
            run_rules_now: 'Exécuter les règles maintenant',
            run_rules_success: 'Génération de [[TOK_1]] nouvelle(s) suggestion(s) de classification',
            run_rules_no_results: 'Aucune nouvelle suggestion générée : toutes les règles de correspondance ont déjà des suggestions en attente',
            run_rules_error: "Échec de l'exécution des règles de classification. Veuillez réessayer.",
            taxonomy_id: 'Taxonomie ID',
            level_id: 'Niveau ID',
            condition_logic: 'Logique de condition',
            weight: 'Poids',
            conditions: 'Prérequis',
            condition_field: 'Champ',
            condition_operator: 'Opérateur',
            condition_value: 'Valeur',
            effectiveness: 'Efficacité',
            match_count: 'Correspondances',
            approval_count: 'Approbations',
            rejection_count: 'Rejets',
            filter_taxonomy: 'Filtrer par Taxonomie ID...',
            load_error: 'Échec de charge classification rules. Veuillez réessayer.',
            create_error: 'Échec de create classification rule. Veuillez réessayer.',
            seed_error: 'Échec de seed defaults. Veuillez réessayer.',
            toggle_error: 'Échec de toggle rule. Veuillez réessayer.',
            priority: 'Priorité',
            enabled_status: 'Activé',
            disabled_status: 'Désactivé',
            enable: 'Activer',
            disable: 'Désactiver',
            logic_and: 'ET',
            logic_or: 'OU',
            operator_equals: 'Égal à',
            operator_contains: 'Contient',
            operator_matches_regex: 'Correspond au Regex',
            operator_in_list: 'Dans la liste',
            operator_not_equals: 'Différent de',
            operator_not_contains: 'Ne contient pas',
            enabled_label: 'Activé',
            disabled_label: 'Désactivé',
            taxonomy_label: 'Taxonomie',
            operator_label: 'Opérateur',
            value_label: 'Valeur',
        },
        suggestions: {
            title: 'File de suggestions',
            entity_type: "Type d'entité",
            suggested_name: 'Nom suggéré',
            source: 'Provenance',
            confidence: 'Confiance',
            accept: 'Accepter',
            reject: 'Rejeter',
            no_suggestions: "Aucune suggestion en file d'attente.",
            modify_approve: 'Modifier et approuver',
            delegate: 'Déléguer',
            delegate_user_id: 'Déléguer Utilisateur ID',
            new_level_id: 'Nouveau niveau id',
            reject_reason_placeholder: 'Reason pour rejet...',
            current_level: 'Actuel Niveau',
            suggested_level: 'Niveau suggéré',
            filter_taxonomy: 'Filtrer par Taxonomie ID...',
            all_confidence: 'Toutes les bandes de confiance',
            load_error: 'Échec de load suggestions. Veuillez réessayer.',
            approve_error: 'Échec de approve suggestion. Veuillez réessayer.',
            reject_error: 'Échec de reject suggestion. Veuillez réessayer.',
            modify_error: 'Échec de modify & approve suggestion. Veuillez réessayer.',
            delegate_error: 'Échec de delegate suggestion. Veuillez réessayer.',
            bulk_approve_error: 'Échec de bulk approve suggestions. Veuillez réessayer.',
            bulk_reject_error: 'Échec de bulk reject suggestions. Veuillez réessayer.',
            suggestion_type_new_label: 'Nouvelle étiquette',
            suggestion_type_validation: 'Validation',
            suggestion_type_reclassification: 'Reclassement',
            status_pending: 'En attente',
            status_approved: 'Approuvé',
            status_rejected: 'Rejeté',
            status_superseded: 'Remplacé',
            confidence_high: 'Élevée',
            confidence_medium: 'Moyenne',
            confidence_low: 'Faible',
            confirm_bulk_reject: 'Êtes-vous sûr de vouloir rejeter les suggestions sélectionnées ?',
        },
        analytics: {
            title: 'Analytique des suggestions',
            total_suggestions: 'Total de suggestions',
            accepted: 'Accepté',
            rejected: 'Rejeté',
            pending: 'En attente',
            acceptance_rate: "Taux d'acceptation",
            by_entity_type: "Par type d'entité",
            by_source: 'Par source',
            avg_decision_time: 'Avg Décision Heure',
            rule_effectiveness: 'Efficacité de la règle',
            by_status: 'Par Statut',
            by_confidence: 'Par bande de confiance',
            load_error: 'Échec de load suggestion analytics. Veuillez réessayer.',
            confidence_high: 'Élevée',
            confidence_medium: 'Moyenne',
            confidence_low: 'Faible',
            by_confidence_band: 'Par niveau de confiance',
            approval_rate: "Taux d'approbation",
            by_label_state: "Par état d'étiquette",
        },
        import_templates: {
            title: "Modèles d'importation",
            new: 'Nouveau modèle',
            template_name: 'Modèle Nom',
            file_format: 'Fichier Formater',
            column_mappings: 'Colonne Correspondances',
            no_templates: 'Aucun import templates trouvé',
            source_column: 'Colonne source',
            target_field: 'Cible Champ',
            transform: 'Transformer',
            source_column_label: 'Colonne source',
            target_field_label: 'Champ cible',
            transform_label: 'Transformer',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer this import template ?',
            load_error: 'Échec de load import templates. Veuillez réessayer.',
            save_error: 'Échec de save import template. Veuillez réessayer.',
            delete_error: 'Échec de delete import template. Veuillez réessayer.',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
        },
        connectors: {
            title: 'Gestion des connecteurs',
            new: 'Nouveau connecteur',
            connector_name: 'Connecteur Nom',
            connector_type: 'Catégorie',
            last_sync: 'Dernier Synchroniser',
            no_connectors: 'Aucun connectors trouvé',
            cmdb_syncs: 'Synchro. CMDB',
            cloud_syncs: 'Synchro. cloud',
            new_sync: 'Nouveau synchroniser',
            no_syncs: 'Aucun syncs trouvé',
            cmdb_error: 'Échec de load cmdb scans. Veuillez réessayer.',
            cloud_error: 'Échec de load cloud scans. Veuillez réessayer.',
            trigger_error: 'Échec de trigger sync. Veuillez réessayer.',
            trigger_sync_error: 'Échec de trigger {type}',
            cmdb_section_title: 'Synchronisations CMDB',
            cloud_section_title: 'Synchronisations cloud',
            column_connector: 'Connecteur',
            action_start: 'Démarrer',
            confirm_cancel_sync: 'Annuler cette synchronisation ?',
            start_error: 'Échec du démarrage de la synchronisation',
            cancel_error: 'Échec de l’annulation de la synchronisation',
            type_endpoint: 'Analyse de point de terminaison',
            type_spreadsheet_import: 'Import de feuille de calcul',
            type_cmdb_sync: 'Synchronisation CMDB',
            type_cloud_sync: 'Synchronisation cloud',
        },
        discovery_cycles: {
            title: 'Cycles de découverte',
            new_cycle: 'Nouveau cycle de découverte',
            cycle_name: 'Nom du cycle',
            scope_type: 'Type de portée',
            scope_ids: 'Identifiants de portée',
            cadence_days: 'Fréquence (jours)',
            status: 'Statut',
            no_cycles: 'Aucun cycle de découverte trouvé',
            compare: 'Comparer les cycles',
            delta_report: 'Rapport des modifications',
            new_records: 'Nouveaux enregistrements',
            changed_records: 'Enregistrements modifiés',
            removed_records: 'Enregistrements supprimés',
            schedule: 'Planifier une analyse',
            scope_organization: 'Organisation',
            scope_department: 'Département',
            scope_system: 'Système',
            scope_systems: 'Systèmes',
            bulk_actions: 'Actions en masse',
            selected: '{count} sélectionné(s)',
            bulk_create: 'Création en masse',
            bulk_assign_scope: 'Attribuer la portée en masse',
            bulk_advance: 'Avancer le statut en masse',
            confirm_bulk_action: "Confirmer l'action en masse",
            bulk_confirm_message: 'Êtes-vous sûr de vouloir effectuer cette action ?',
            cycles_affected: '{count} cycles seront affectés',
            select_all: 'Tout sélectionner',
            select_cycle: 'Sélectionner le cycle {name}',
            from_template: 'à partir du modèle',
            bulk_results: 'Résultats en masse',
            failed_label: 'échoué',
            template_id: 'ID du modèle',
            count: 'Nombre',
            advance_to: 'Statut cible',
            bulk_success: 'Opération en masse terminée',
        },
        owner_review: {
            title: 'Tâches de revue du propriétaire',
            assign_owner: 'Attribuer au propriétaire',
            owner_id: 'Propriétaire',
            decision: 'Décision',
            approve: 'Approuver',
            modify: 'Modifier',
            reject: 'Rejeter',
            escalate: 'Escalader',
            no_tasks: 'Aucune tâche de revue trouvée',
            bulk_resolve: 'Résolution en masse',
            exceptions: "Éléments d'exception",
            no_exceptions: "Aucun élément d'exception trouvé",
            record_id_label: "Identifiant de l'enregistrement",
            selected: 'sélectionné',
            notes: 'Remarques',
            select_all: 'Tout Sélectionner',
            select: 'Sélectionner',
            confirm_resolve: 'Confirmer',
        },
        classification_lineage: {
            title: 'Historique de classification',
            link_suggestion: "Lier à l'étiquette proposée",
            suggestion_id: 'Suggestions',
            proposed_label_id: 'Étiquette proposée',
            no_lineage: "Aucune donnée d'historique trouvée",
            full_lineage: 'Historique complet',
            record_id_label: "Identifiant de l'enregistrement",
            staged_record_label: 'Enregistrement mis en scène',
            enter_staged_record_id: "Saisissez l'ID de l'enregistrement intermédiaire",
            scan_id_label: "Numériser l'identifiant",
            select_record: 'Sélectionner un enregistrement',
            select_suggestion: 'Sélectionner une suggestion',
            select_label: 'Sélectionner une étiquette',
        },
        common_labels: {
            n_rules: '[[TOK_1]] règles',
            one_rule: '1 règle',
            n_scans: '[[TOK_1]] analyses',
            one_scan: '1 analyse',
            n_syncs: '[[TOK_1]] synchronisations',
            one_sync: '1 synchronisation',
            n_records: '[[TOK_1]] enregistrements',
            one_record: '1 enregistrement',
            n_templates: '[[TOK_1]] modèles',
            one_template: '1 modèle',
            n_suggestions: '[[TOK_1]] suggestions',
            one_suggestion: '1 suggestion',
            n_selected: '[[TOK_1]] sélectionné',
            dashboard_loaded: 'Tableau de bord de découverte chargé',
            n_scans_loaded: '[[TOK_1]] analyses chargées',
            n_staged_records_loaded: '[[TOK_1]] enregistrements intermédiaires chargés',
            confirm_delete_import_template: "Êtes-vous sûr de vouloir supprimer ce modèle d'importation ?",
            invalid_json_source_config: '[[TOK_0]] non valide dans source_config',
            scope_organization: 'Organisation',
            scope_department: 'Département',
            scope_system: 'Système',
            aria_filter_scans: 'Filtrer les analyses',
            aria_filter_staged_records: 'Filtrer les enregistrements intermédiaires',
            aria_filter_suggestions: 'Filtres',
            aria_filter_by_taxonomy_id: 'Filtrer par ID de taxonomie',
            aria_filter_by_enabled_status: 'Filtrer par statut activé',
            aria_filter_by_source_type: 'Filtrer par type de source',
            aria_filter_by_promotion_status: 'Filtrer par statut de promotion',
            aria_filter_by_dedup_status: 'Filtrer par statut de déduplication',
            aria_filter_by_scan_type: "Filtrer par type d'analyse",
            aria_filter_by_status: 'Filtrer par statut',
            aria_filter_by_confidence: 'Filtrer par bande de confiance',
            aria_select_all_records: 'Sélectionnez tous les enregistrements',
            aria_select_record: "Sélectionner l'enregistrement [[TOK_1]]",
            aria_select_all_suggestions: 'Sélectionnez toutes les suggestions',
            aria_select_suggestion: 'Sélectionnez une suggestion [[TOK_1]]',
            aria_promote_record: "Promouvoir l'enregistrement [[TOK_1]]",
            aria_discard_record: "Supprimer l'enregistrement [[TOK_1]]",
            aria_merge_record: "Fusionner l'enregistrement [[TOK_1]]",
            aria_review_record: "Vérifier l'enregistrement [[TOK_1]]",
            aria_accept_suggestion: 'Accepter la suggestion [[TOK_1]]',
            aria_reject_record: "Rejeter l'enregistrement",
            aria_merge_record_dialog: "Fusionner l'enregistrement",
            aria_create_new_scan: 'Créer une nouvelle analyse',
            aria_sync_progress: 'Progression de la synchronisation : [[TOK_2]] éléments traités sur [[TOK_3]]',
            aria_scan_progress: "Progression de l'analyse : [[TOK_2]] éléments traités sur [[TOK_3]]",
            aria_confidence: 'Confiance : [[TOK_1]] %',
            aria_effectiveness: 'Efficacité : [[TOK_1]]',
            aria_promote_n_records: 'Promouvoir [[TOK_1]] enregistrements sélectionnés',
            aria_discard_n_records: 'Supprimer [[TOK_1]] enregistrements sélectionnés',
            placeholder_pii_detection_rule: 'par exemple, règle de détection des informations personnelles',
            placeholder_tax_id: 'par exemple, TAX-001',
            placeholder_lvl_id: 'par exemple, LVL-001',
            placeholder_service_type: 'par exemple, service_type',
            placeholder_database: 'par exemple, base de données',
            placeholder_hostname_match: "par exemple, correspondance exacte du nom d'hôte",
            placeholder_hostname: "par exemple, le nom d'hôte",
            placeholder_hr_systems_csv: 'par exemple, systèmes RH [[TOK_0]] Importer',
            placeholder_server_name: 'par exemple, le nom du serveur',
            placeholder_hostname_field: "par exemple, le nom d'hôte",
            placeholder_lowercase: 'par exemple, minuscule',
            placeholder_source_config: '{"hôte": "...", "port": 443}',
            placeholder_stg_id: 'par exemple, STG-000123',
            placeholder_lvl_002: 'par exemple, LVL-002',
            placeholder_usr_id: 'par exemple, USR-000123',
            decision_for: 'Décision pour [[TOK_1]]',
        },
        exports: {
            title: 'Exporter',
            inventory: 'Inventaire des données',
            classification_register: 'Registre de classification',
            raci: 'Matrice RACI',
            exceptions: "Rapport d'exceptions",
            evidence_pack: 'Dossier de preuves',
            delta_report: 'Rapport des modifications',
            executive_summary: 'Résumé exécutif',
            export_button: 'Exporter',
            downloading: 'Téléchargement en cours...',
            download_complete: 'Téléchargement terminé.',
            download_error: 'Échec du téléchargement. Veuillez réessayer.',
        },
        flags: {
            title: 'Marqueurs en aval',
            pending: 'Marqueurs en attente',
            cross_border_review_needed: 'Examen transfrontalier requis',
            sharing_disclosure_needed: 'Divulgation de partage requise',
            dpia_review_needed: 'Examen AIPD requis',
            acknowledge: 'Accuser réception',
            resolve: 'Résoudre',
            no_flags: 'Aucun marqueur en aval.',
        },
        delta: {
            title: 'Résumé des modifications',
            new_count: '{n} nouveaux',
            removed_count: '{n} supprimés',
            changed_count: '{n} modifiés',
            re_review_triggered: 'Réexamen déclenché',
            create_re_review: 'Créer un réexamen',
            recent_alerts: 'Alertes de modifications récentes',
            no_alerts: 'Aucune alerte de modification récente.',
            threshold_exceeded: 'Seuil de modification dépassé (>10 %)',
        },
        regulatory: {
            dashboard_governance_info: "Ce tableau de bord affiche l'état de gouvernance au niveau du cycle : systèmes analysés, enregistrements mis en scène, enregistrements examinés, enregistrements approuvés et exceptions en attente. Cela correspond aux critères de réussite des responsables de gouvernance : « tableau de bord en direct indiquant qui a mis à jour son inventaire, sa classification et ses journaux de partage » (P-VN-05).",
            export_artifacts_info: "Les exportations de découverte incluent tous les types d'artefacts requis par UC-VN-10 et DATA-EVD-01 : inventaire des données approuvées, registre de classification, mappage de propriété/RACI, file d'attente d'exceptions, résumé, ensemble de preuves et rapport delta.",
            scan_inventory_pipeline_info: "Chaque analyse terminée produit des enregistrements compatibles avec le modèle vn_data_law_data_inventory_register (exigence 88dd9877). Les actifs de données découverts remplissent automatiquement le registre d'inventaire des données pour satisfaire à l'obligation de la loi sur les données de maintenir un inventaire des données numériques.",
            connector_linkage_info: "Chaque configuration de connecteur doit inclure : le type de système (par exemple, [[TOK_0]], plate-forme cloud), la référence du magasin de données (base de données, magasin de fichiers, SaaS) et la liaison des processus métier (UC-VN-10 enregistrements de support requis). Ces champs garantissent que les actifs découverts sont traçables jusqu'à leur système source et leur contexte commercial.",
            owner_routing_info: "Les tâches de révision sont acheminées vers le bon service ou propriétaire de l'application en fonction de la propriété du système/des données (UC-VN-10 étape 5). Le routage utilise le registre de propriété du système, et non une affectation ad hoc.",
            owner_actions_audit_info: "Les propriétaires peuvent approuver, modifier, rejeter ou faire remonter chaque classification (UC-VN-10 étape 6). Chaque action capture l'acteur, l'horodatage et la raison, produisant ainsi des événements de preuve d'audit de gouvernance conformément à l'exigence f12fc090 (attestation annuelle de gouvernance). La piste d'audit montre qui a examiné, ce qui a été modifié et quand.",
            escalation_timers_info: "Minuteries de remontée : le délai d'examen par le propriétaire est de 5 jours ouvrables ; l'escalade des exceptions est de 48 heures (minuteurs UC-VN-10). Les éléments non résolus sont automatiquement signalés à l'expiration du délai. Les minuteries sont configurables par politique organisationnelle.",
            original_suggestion_preserved_info: "La suggestion originale de classification de machine/système est conservée à côté de chaque remplacement par le propriétaire (exigence de preuve de UC-VN-10). La suggestion originale n'est jamais écrasée et reste visible à des fins d'audit.",
            dedup_lineage_info: "Les règles de déduplication empêchent les entrées d'inventaire en double lorsque la même ressource de données est découverte via plusieurs analyses ou connecteurs. Les métadonnées d'analyse les plus récentes sont conservées en tant qu'enregistrement principal tout en conservant les références de traçabilité à toutes les découvertes antérieures pour la traçabilité de l'audit.",
            label_states_info: "Analytics distingue 4 états d'étiquette pour l'examen de la gouvernance : suggéré par la machine (en attente), approuvé par le propriétaire, modifié par le propriétaire et rejeté. Ces états permettent aux auditeurs d'évaluer la précision de l'automatisation et l'engagement des propriétaires.",
            import_pipeline_info: "Les modèles d'importation doivent produire des enregistrements compatibles avec le pipeline de découverte. Les enregistrements importés entrent en préparation avec les mêmes exigences en matière de métadonnées que les enregistrements analysés : identification du système source, ID de lot et horodatage. Les mappages de colonnes doivent cibler les champs définis dans vn_data_law_data_inventory_register.",
            lineage_full_path_info: "La lignée de classification retrace le chemin complet : analyse/importation -> préparation -> examen du propriétaire -> étiquette approuvée -> entrée de registre (UC-VN-10 étapes 1 à 10). Chaque étape affiche l'ID de l'enregistrement, l'acteur, l'horodatage et la transition d'état pour une traçabilité complète de l'audit.",
            staging_workflow_info: "Les enregistrements intermédiaires se distinguent visuellement des entrées d'inventaire approuvées par leur badge de statut de promotion (UC-VN-10 étape 3). Chaque enregistrement conserve les métadonnées de provenance : système source, ID du lot d'analyse et horodatage de découverte pour une traçabilité complète de l'audit.",
            suggestion_data_d1_info: "Les suggestions s'alignent sur la procédure de classification de la loi sur les données DATA-D1 : (1) cataloguer les actifs de données, (2) classer par niveau de sensibilité, (3) définir des règles de traitement. Chaque suggestion comprend des dimensions de sensibilité et d'importance selon l'exigence 18e4bfd1.",
            downstream_flags_info: 'Les éléments marqués pour le partage, le transfert transfrontalier ou le traitement à haut risque déclenchent des flux de travail en aval liés : évaluation du transfert transfrontalier, évaluation des risques de partage et examen de [[TOK_0]] (UC-VN-10 étape 8).',
            delta_detection_info: "Les cycles de découverte prennent en charge la détection delta selon l'UC-VN-10 étape 11 : chaque cycle indique quels enregistrements sont nouveaux, modifiés ou supprimés depuis la dernière référence approuvée. Les modifications importantes (delta > 10 %) déclenchent automatiquement des workflows de réexamen.",
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Échec de charge. Veuillez réessayer.',
            save: 'Échec de save. Veuillez réessayer.',
            fetch_escalation_log_failed: 'Échec de fetch escalation log. Veuillez réessayer.',
            fetch_activations_failed: 'Échec de fetch activations. Veuillez réessayer.',
            deactivate_failed: 'Échec de désactiver. Veuillez réessayer.',
            complete_activation_failed: 'Échec de complete activation. Veuillez réessayer.',
            fetch_playbook_templates_failed: 'Échec de fetch playbook templates. Veuillez réessayer.',
            create_playbook_template_failed: 'Échec de create playbook template. Veuillez réessayer.',
            clone_template_failed: 'Échec de clone template. Veuillez réessayer.',
            update_status_failed: 'Échec de la mise à jour du statut. Veuillez réessayer.',
            deprecate_template_failed: 'Échec de deprecate template. Veuillez réessayer.',
            seed_defaults_failed: 'Échec de seed defaults. Veuillez réessayer.',
            fetch_regulator_exports_failed: 'Échec de fetch regulator exports. Veuillez réessayer.',
            create_regulator_export_failed: 'Échec de create regulator export. Veuillez réessayer.',
            update_submission_status_failed: 'Échec de update submission status. Veuillez réessayer.',
            fetch_response_metrics_failed: 'Échec de fetch réponse métriques. Veuillez réessayer.',
            fetch_sla_dashboard_failed: 'Échec de fetch sla dashboard. Veuillez réessayer.',
            fetch_sla_definitions_failed: 'Échec de fetch sla definitions. Veuillez réessayer.',
            create_sla_definition_failed: 'Échec de create sla definition. Veuillez réessayer.',
            seed_sla_defaults_failed: 'Échec de seed sla defaults. Veuillez réessayer.',
            fetch_vendor_coordination_failed: 'Échec de fetch vendor coordination. Veuillez réessayer.',
            fetch_vendor_detail_failed: 'Échec de fetch vendor detail. Veuillez réessayer.',
            create_vendor_coordination_failed: 'Échec de create vendor coordination. Veuillez réessayer.',
            add_communication_failed: 'Échec de add communication. Veuillez réessayer.',
            add_info_request_failed: 'Échec de add info request. Veuillez réessayer.',
            add_action_request_failed: 'Échec de add action request. Veuillez réessayer.',
        },
        nav: {
            playbooks: 'Modèles de guide opérationnel',
            sla_definitions: 'Définitions SLA',
            sla_dashboard: 'Tableau de bord SLA',
            escalation_log: "Journal d'escalade",
            regulator_exports: 'Exports réglementaires',
            deadlines: 'Notification Échéances',
            vendor_coordination: 'Coordination fournisseurs',
            metrics: 'Métriques de réponse',
            playbook_links: 'Liens Playbook',
            regulatory_sla: 'SLA réglementaire',
            coordination_dashboard: 'Coordination',
            evidence_chain: 'Chaîne de preuves',
            post_review: 'Revue post-incident',
        },
        playbooks: {
            page_title: 'Modèles de manuels de jeu',
            activations_page_title: 'Activations du manuel de jeu',
            title: 'Modèles de guide opérationnel',
            new: 'Nouveau modèle',
            seed_defaults: 'Valeurs initiales par défaut',
            scenario_type: 'Type de scénario',
            severity_applicability: 'Applicabilité de la gravité',
            all_scenario_types: 'Tous les types de scénario',
            new_playbook: 'Nouveau Playbook Template',
            clone: 'Cloner',
            clone_template: 'Cloner Modèle',
            template_name: 'Nom du modèle',
            deprecate: 'Rendre obsolète',
            confirm_deprecate: 'Rendre le modèle « {name} » obsolète ?',
            create_template: 'Ajouter modèle',
            update_status: 'Mettre à jour Statut',
            no_templates: 'Aucun playbook templates trouvé',
            deactivation_reason_placeholder: 'Motif de désactivation...',
            description_placeholder: 'Description du livre de procédures...',
            name_placeholder: 'Nom du livre de procédures...',
        },
        sla_definitions: {
            page_title: 'Définitions SLA',
            title: 'Définitions SLA',
            new: 'Nouveau SLA Definition',
            sla_name: 'SLA Nom',
            target_hours: 'Heures cibles',
            escalation_after: 'Escalade Après',
            applies_to: "S'applique à",
            no_definitions: 'Aucun sla definitions trouvé',
            target_value_placeholder: 'Cible valeur',
            name_placeholder: 'Nom du SLA...',
            threshold_hours_label: 'Heures seuil',
            severity_label: 'Gravité',
            all_types: 'Tous les types',
            all_severities: 'Toutes les gravités',
            default_label: 'Par défaut',
        },
        sla_dashboard: {
            compliant: 'Conforme',
            page_title: 'Tableau de bord SLA',
            title: 'Tableau de bord SLA',
            loading: 'Chargement de sla data...',
            compliance_rate: 'Conformité Taux',
            breached: 'Violé',
            at_risk: 'À Risque',
            on_track: 'Sur Suivre',
            by_severity: 'Par Gravité',
            total_records: 'Total des enregistrements',
            met: 'Respecté',
            sla_records: 'Enregistrements SLA',
            sla_reference: 'Référence SLA',
            record_id: "ID d'enregistrement",
            metric_type: 'Type de métrique',
            severity: 'Gravité',
            elapsed: 'Écoulé',
            clock_start: 'Début du chrono',
        },
        escalation_log: {
            page_title: "Journal d'escalade",
            title: "Journal d'escalade",
            incident_id: "ID d'incident",
            escalated_by: 'Escaladé Par',
            escalated_to: 'Escaladé À',
            reason: 'Motif',
            escalated_at: 'Escaladé À',
            no_escalations: 'Aucun escalations trouvé',
            filter_incident_id: 'Filtrer par Incident ID',
            escalation_id: "ID d'escalade",
            level: 'Niveau',
            level_range: 'Niveau (L1–L4)',
            create_escalation: 'Créer une escalade',
            incident_id_placeholder: 'ex. INC-001',
            target_role_placeholder: 'ex. dpo, incident_manager',
            select_placeholder: '— sélectionner —',
        },
        regulator_exports: {
            page_title: 'Exports réglementaires',
            title: 'Exports réglementaires',
            new: 'Nouveau exporter',
            incident_id: "ID d'incident",
            regulator: 'Régulateur',
            export_format: 'Formater',
            exported_at: 'Exporté À',
            no_exports: 'Aucun regulator exports trouvé',
            enter_incident_id: 'Saisissez Incident ID',
            export_id: "ID d'export",
            watermark: 'Filigrane',
            submission_status: 'Statut de soumission',
            all_jurisdictions: 'Toutes les juridictions',
            no_transitions: 'Aucune autre transition disponible à partir de',
            select_new_status: '— sélectionner un nouveau statut —',
            sections_included: 'Sections incluses',
            form_classification: 'Classement',
            submission_channel: 'Chaîne',
        },
        deadlines: {
            title: 'Notification Échéances',
            incident_id: "ID d'incident",
            deadline: 'Échéance',
            regulator: 'Régulateur',
            remaining: 'Restant',
            no_deadlines: 'Aucun notification deadlines trouvé',
        },
        vendor_coordination: {
            page_title: 'Coordination fournisseurs',
            title: 'Coordination fournisseurs',
            new: 'Nouveau Coordination',
            incident_id: "ID d'incident",
            vendor_name: 'Fournisseur Nom',
            contact: 'Personne-ressource',
            coordination_status: 'Statut de coordination',
            no_items: 'Aucun vendor coordination items trouvé',
            assessment_placeholder: 'Évaluation initiale du fournisseur...',
            coordination_id: 'ID de coordination',
            communications: 'Échanges',
            info_requests: "Demandes d'information",
            action_requests: "Demandes d'action",
            direction: 'Sens',
            channel_label: 'Canal',
            no_transitions: 'Aucune transition supplémentaire disponible.',
            vendor_ref_number: 'Numéro de référence',
            report_date: 'Date du rapport',
            contact_email: 'E-mail',
            contact_phone: 'Téléphone',
            channel_email: 'E-mail',
            channel_meeting: 'Réunion',
            channel_phone: 'Téléphone',
            channel_portal: 'Portail',
            incident_id_placeholder: 'Filtrer par Incident ID...',
            priority_critical: 'Critique',
            priority_high: 'Élevé',
            priority_low: 'Low',
            priority_medium: 'Moyen',
            vendor_id_placeholder: 'Filtrer par Fournisseur ID...',
            description_placeholder: 'Descriptif...',
            filter_vendor_id: 'Filtrer par Fournisseur ID',
            inbound: 'Entrant',
            outbound: 'Sortant',
            summary_placeholder: 'Résumé...',
            priority_label: 'Priorité',
            due_date_label: "Date d'échéance",
            info_request_desc: "Description de la demande d'informations",
            action_request_desc: "Description de la demande d'action",
            content_label: 'Contenu',
            select_incident: 'Sélectionner un incident',
            select_vendor: 'Sélectionner le prestataire',
            discovery_date: 'Date de découverte',
        },
        metrics: {
            page_title: 'Métriques de réponse',
            title: 'Métriques de réponse',
            loading: 'Chargement de metrics data...',
            avg_response_time: 'Avg Réponse Heure',
            avg_resolution_time: 'Avg Résolution Heure',
            total_incidents: "Total d'incidents",
            by_severity: 'Par Gravité',
            by_status: 'Par Statut',
            trend: 'Tendance',
            start_sla_clock: 'Démarrer le chrono SLA',
            sla_records: 'Enregistrements SLA',
            no_sla_records: "Aucun enregistrement SLA pour l'instant.",
            record_id: "ID d'enregistrement",
            severity: 'Gravité',
            progress: 'Progression',
            incident_id_required: "L'ID d'incident est obligatoire",
            sla_definition_required: 'La définition SLA est obligatoire',
            metric_type_required: 'Le type de métrique est obligatoire',
            threshold_required: 'Les heures seuil sont obligatoires',
            sla_clock_started: 'Chrono SLA démarré',
            sla_definition: 'Définition SLA',
            no_definitions: 'Aucune définition SLA trouvée.',
            select_definition: 'Sélectionner une définition SLA...',
            select_metric_type: 'Sélectionner le type de métrique...',
            select_severity: 'Sélectionner la gravité...',
            threshold_hours: 'Seuil (heures)',
            warning_threshold_pct: "Seuil d'avertissement (%)",
            start_clock: 'Démarrer le chrono',
            starting: 'Démarrage...',
            metric_label: 'Métrique',
            value_label: 'Valeur',
            incident_id: "ID d'incident",
            threshold_placeholder: 'ex. 24',
            metric_types: {
                triage_time: 'Temps de triage',
                containment_time: 'Temps de confinement',
                notification_time: 'Temps de notification',
                resolution_time: 'Temps de résolution',
            },
            severities: {
                critical: 'Critique',
                high: 'Élevé',
                medium: 'Moyen',
                low: 'Faible',
            },
        },
        playbook_links: {
            page_title: 'Liens Playbook',
            title: 'Liens Playbook-Notification',
            new_link: 'Lier un playbook à une notification',
            activation_id: "ID d'activation",
            notification_id: 'ID de notification',
            select_activation: 'Sélectionner une activation...',
            select_notification: 'Sélectionner une notification...',
            no_links: 'Aucun lien playbook trouvé',
            seed_pdpl: 'Initialiser les playbooks PDPL',
            created: 'Lien playbook créé',
            seeded: 'Playbooks PDPL initialisés',
            create_failed: 'Échec de la création du lien playbook',
            seed_failed: 'Échec de l’initialisation des playbooks PDPL',
        },
        regulatory_sla: {
            page_title: 'Correspondances SLA réglementaires',
            title: 'Correspondances SLA réglementaires',
            new_mapping: 'Nouvelle correspondance SLA',
            sla_definition: 'Définition SLA',
            select_sla_definition: 'Sélectionner une définition SLA...',
            framework_code: 'Code du cadre',
            deadline_type: "Type d'échéance",
            deadline_hours: 'Délai en heures',
            auto_escalate: 'Auto-escalade',
            seed_pdpl: 'Initialiser les valeurs PDPL par défaut',
            no_mappings: 'Aucune correspondance SLA réglementaire trouvée',
            dashboard: 'Tableau de bord SLA réglementaire',
            deadline_types: {
                initial_notification: 'Notification initiale',
                supplement_response: 'Réponse complémentaire',
                authority_response: "Réponse de l'autorité",
                remediation_report: 'Rapport de remédiation',
            },
            statutory_reference: 'Référence statutaire',
        },
        coordination_dashboard: {
            page_title: 'Tableau de bord de coordination',
            title: 'Tableau de bord de coordination',
            incident_id: "ID d'incident",
            select_incident: 'Sélectionner un incident...',
            team_role: "Rôle de l'équipe",
            members: 'Membres',
            tasks: 'Tâches',
            sla_status: 'Statut SLA',
            no_teams: 'Aucune équipe de coordination trouvée',
            new_team: 'Nouvelle équipe de coordination',
            enter_incident_id: "Saisissez un ID d'incident pour afficher les équipes de coordination.",
            member_ids_placeholder: 'utilisateur1, utilisateur2',
            edit_team: "Modifier l'équipe",
            task_count: 'Nombre de tâches',
            tasks_completed: 'Terminé',
            team_roles: {
                security: 'Sécurité',
                legal: 'Juridique',
                it: 'IT',
                management: 'Direction',
                department_owner: 'Responsable de département',
                external: 'Externe',
            },
        },
        evidence_chain: {
            page_title: 'Chaîne de preuves',
            title: 'Chaîne de garde des preuves',
            new_entry: 'Nouvelle entrée de preuve',
            select_incident: 'Sélectionner un incident...',
            actor: 'Acteur',
            select_actor: 'Sélectionner un acteur...',
            evidence_id: 'ID de preuve',
            action: 'Action',
            recipient: 'Destinataire',
            no_entries: 'Aucune entrée de chaîne de preuves trouvée',
            enter_incident_id: "Saisissez un ID d'incident pour afficher la chaîne de preuves.",
            evidence_id_placeholder: 'ex. EVD-2026-0001',
            evidence_id_help: 'Une référence unique pour l’élément de preuve : un fichier journal, une image disque ou une capture d’écran. Une suggestion est préremplie ; modifiez-la pour qu’elle corresponde à votre catalogue de preuves.',
            select_incident_first: 'Sélectionnez un incident ci-dessus avant d’ajouter une entrée de preuve.',
            for_incident: 'Pour l’incident',
            actions: {
                collected: 'Collecté',
                shared: 'Partagé',
                exported: 'Exporté',
                archived: 'Archivé',
            },
        },
        post_review: {
            page_title: 'Revue post-incident',
            title: 'Revue post-incident',
            new_review: 'Nouvelle revue',
            select_incident: 'Sélectionner un incident...',
            lessons_learned: 'Leçons apprises',
            recommendations: 'Recommandations',
            improvement_actions: "Actions d'amélioration",
            submit_for_review: 'Soumettre pour revue',
            aria_submit_review: 'Soumettre la revue {name} pour revue',
            aria_sign_off: 'Approuver la revue {name}',
            sign_off: 'Approbation',
            no_reviews: 'Aucune revue post-incident trouvée',
            enter_incident_id: "Saisissez un ID d'incident pour afficher la revue post-incident.",
            one_per_line: 'Un par ligne',
            statuses: {
                draft: 'Brouillon',
                in_review: 'En revue',
                signed_off: 'Approuvé',
                closed: 'Clôturé',
            },
        },
        activations: {
            title: 'Activations du manuel de jeu',
            activation_id: "Identifiant d'activation",
            phases: 'Étapes',
            activated_at: 'Activé à',
            activated_by: 'Activé par',
            deactivate: 'Désactiver',
            complete: 'Terminer',
            deactivation_reason: 'Raison de la désactivation',
            evidence_button: 'Preuve',
            evidence_modal_title: "Preuve d'activation",
            no_evidence: 'Aucune preuve attachée à cette activation.',
            upload_evidence_label: "Télécharger la preuve d'activation",
        },
    },
    program_governance: {
        maturity_walkthrough: {
            run_label: 'Guide-moi à travers les lacunes',
            running: 'Des écarts de marche…',
            results_heading: "Feuille de route d'amélioration ([[TOK_2]] écart[[TOK_3]])",
            tokens_label: '≈ [[TOK_1]] jetons',
            no_gaps: 'Aucune lacune détectée : tous les domaines atteignent ou dépassent la cible.',
            col_priority: 'Priorité',
            col_domain: 'Domaine',
            col_levels: 'Actuel → Cible',
            col_severity: 'Gravité',
            col_actions: 'Actions correctives',
            citations_label: 'Citations',
            accept_label: 'Accepter la feuille de route',
            reject_label: 'Rejeter le brouillon',
            export_label: 'Exporter [[TOK_0]]',
            exported_label: 'Feuille de route exportée',
            accept_hint: "Accepter enregistre la feuille de route sur le brouillon persistant. Utilisez Export [[TOK_0]] pour générer le livrable ; l'opérateur colle improvement_actions dans l'évaluation.",
            resolve_summary: 'Résolution : [[TOK_1]]',
            error_generic: "Impossible d'exécuter la procédure pas à pas. Réessayez ou vérifiez l'état de l'évaluation.",
        },
        policy_gap: {
            run_label: 'Détecter les lacunes politiques',
            running: 'Détecter les lacunes…',
            results_heading: 'Lacunes politiques ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            no_gaps: 'Aucune lacune de couverture détectée.',
            col_severity: 'Gravité',
            col_kind: 'Genre',
            col_clause: 'Clause/exigence',
            kind_missing: 'Clause manquante',
            kind_weak: 'Faible couverture',
            kind_stale: 'Obsolète (examen en retard)',
            remediation_label: 'Correction suggérée',
            citations_label: 'Citations',
            accept_label: "Accepter le rapport d'écart",
            reject_label: 'Rejeter le rapport',
            export_label: 'Exporter [[TOK_0]]',
            accept_hint: "Accepter enregistre le rapport d'écart sur le brouillon persistant. Utilisez Exporter [[TOK_0]] pour générer un rapport d'audit de stratégie ; c'est l'opérateur qui pilote la modification réelle de la politique.",
            resolve_summary: 'Résolution : [[TOK_1]]',
            error_generic: "Impossible de détecter les lacunes politiques. Réessayez ou vérifiez l'état du document.",
        },
        remediation_plan_generator: {
            run_label: 'Générer un plan à partir des lacunes',
            running: 'Plan de génération…',
            results_heading: 'Plan de remédiation ([[TOK_2]] phase[[TOK_3]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            phase_label: 'Phase [[TOK_1]]',
            window_label: 'Fenêtre',
            owner_label: 'Rôle de propriétaire',
            evidence_label: 'Types de preuves requis',
            tasks_label: 'Tâches',
            no_phases: "Aucune phase produite – l'ensemble d'intervalles d'entrée peut être vide.",
            citations_label: 'Citations',
            accept_label: 'Accepter le forfait',
            reject_label: 'Rejeter le plan',
            export_label: 'Exporter [[TOK_0]]',
            accept_hint: "Accepter crée des tâches de phase liées à l'enregistrement du plan. Utilisez Exporter [[TOK_0]] pour le livrable complet. Les espaces réservés pour le rôle de propriétaire nécessitent un suivi de l'opérateur.",
            resolve_summary: 'Résolution : [[TOK_2]] · [[TOK_3]] tâche(s) créée(s)',
            error_generic: "Impossible de générer un plan de correction. Réessayez ou vérifiez l'entrée définie par l'écart.",
            source_picker_label: 'Origine',
            source_all: 'Tout',
            source_consent: 'Analyse des écarts de consentement',
            source_policy: 'Détection des lacunes politiques',
            source_vendor: 'Intégration des fournisseurs',
            load_upstream_label: "Charger depuis l'amont",
            loading_upstream: 'Chargement…',
            upstream_count: '[[TOK_1]] espace(s) chargé(s)',
        },
        nav: {
            maturity_models: 'Modèles de maturité',
            maturity_assessments: 'Évaluations de maturité',
            trend_dashboard: 'Tableau de bord des tendances',
            reporting_periods: 'Périodes de rapport',
            executive_summaries: 'Résumés exécutifs',
            audit_readiness: "Préparation à l'audit",
            evidence_gaps: 'Lacunes de preuves',
            program_health: 'Santé du programme',
            obligation_mappings: 'Correspondances des obligations',
            governance_documents: 'Documents de gouvernance',
            remediation_plans: 'Plans de remédiation',
            governance_model: 'Modèle de gouvernance',
            document_drafting: 'Rédaction de documents',
            document_issuance: 'Émission de documents',
            acknowledgment_tracking: 'Suivi des accusés de réception',
            change_log: 'Journal des modifications',
            review_cadence: 'Cadence de révision',
        },
        maturity_models: {
            title: 'Modèles de maturité',
            new: 'Nouveau modéliser',
            seed_defaults: 'Valeurs initiales par défaut',
            domains: 'Domaines',
            activate: 'Activer',
            no_models: 'Aucun maturity models trouvé',
            new_maturity_model: 'Nouveau maturité modéliser',
            create_model: 'Ajouter modéliser',
            load_error: 'Impossible de charger les modèles de maturité. Veuillez réessayer.',
            create_error: 'Impossible de créer le modèle de maturité',
            status_error: 'Impossible de mettre à jour le statut du modèle',
            seed_error: 'Impossible de générer les valeurs par défaut',
            aria_seed_defaults: 'Générer les modèles de maturité par défaut',
            aria_create_new: 'Créer un nouveau modèle de maturité',
            loading_sr: 'Chargement des modèles de maturité',
            model_name_placeholder: 'p. ex., Modèle de maturité vie privée',
            status_changed: 'Statut du modèle changé en {status}',
        },
        maturity_assessments: {
            title: 'Évaluations de maturité',
            new: 'Nouveau évaluation',
            model: 'Modéliser',
            assessor: 'Évaluateur',
            overall_score: 'Score global',
            overall_score_help: 'Une note de maturité pondérée de 0 à 5, calculée automatiquement lorsqu’une évaluation est finalisée. Augmentez-la en attribuant une note plus élevée à chaque domaine lors de l’évaluation, puis en faisant passer l’évaluation par Soumettre pour révision → Finaliser.',
            assessed_at: 'Évalué le',
            no_assessments: 'Aucun maturité évaluations trouvé',
            load_error: 'Impossible de charger les évaluations. Veuillez réessayer.',
            create_error: "Impossible de créer l'évaluation",
            start_error: "Impossible de démarrer l'évaluation",
            archive_error: "Impossible d'archiver l'évaluation",
            eval_error: "Impossible de charger l'évaluation",
            eval_min_score: 'Veuillez noter au moins un domaine',
            eval_save_error: 'Impossible de sauvegarder les évaluations de domaine',
            review_error: 'Impossible de soumettre pour révision',
            finalize_error: "Impossible de finaliser l'évaluation",
            start: 'Démarrer',
            start_confirm_title: "Démarrer l'évaluation",
            start_confirm_message: 'Êtes-vous sûr de vouloir démarrer cette évaluation ?',
            archive_confirm_title: "Archiver l'évaluation",
            archive_confirm_message: 'Êtes-vous sûr de vouloir archiver cette évaluation ?',
            evaluate_domains: 'Évaluer',
            evaluate_domains_title: 'Évaluer les domaines',
            submit_for_review: 'Soumettre pour révision',
            finalize: 'Finaliser',
            archive: 'Archiver',
            all_reviewers: 'Tous les réviseurs doivent approuver',
            any_reviewer: "N'importe quel réviseur peut approuver",
            select_level: 'Sélectionner le niveau de maturité...',
            findings_placeholder: 'Conclusions, notes, références de preuves...',
            no_domains: 'Aucun domaine trouvé pour ce modèle.',
        },
        trend_dashboard: {
            title: 'Tableau de bord des tendances',
            loading: 'Chargement de trend data...',
            score_trend: 'Tendance du score',
            domain_comparison: 'Comparaison de domaines',
            period: 'Période',
            load_error: 'Impossible de charger le résumé des tendances. Veuillez réessayer.',
            metrics_load_error: 'Impossible de charger les métriques. Veuillez réessayer.',
            module: 'Module',
            metric: 'Métrique',
            value: 'Valeur',
            trend: 'Tendance',
            aria_filters: 'Filtres des métriques de tendance',
            showing_chart: 'Affichage de la vue graphique',
            showing_table: 'Affichage de la vue tableau',
        },
        reporting_periods: {
            title: 'Périodes de rapport',
            new: 'Nouveau période',
            period_name: 'Période Nom',
            start_date: 'Début Date',
            end_date: 'Fin Date',
            no_periods: 'Aucun reporting periods trouvé',
            load_error: 'Impossible de charger les périodes. Veuillez réessayer.',
            create_error: 'Impossible de créer la période',
            auto_generate_error: 'Impossible de générer automatiquement les périodes',
            status_error: 'Impossible de mettre à jour le statut de la période',
            start_collecting: 'Commencer la collecte',
            mark_as_draft: 'Marquer comme brouillon',
            submit_for_review: 'Soumettre pour révision',
            publish: 'Publier',
            auto_generate: 'Générer automatiquement les périodes',
            period_label_placeholder: 'p. ex., T1 2026',
            status_updated: 'Statut de la période mis à jour',
        },
        executive_summaries: {
            title: 'Résumés exécutifs',
            new: 'Nouveau résumé',
            period: 'Période',
            generated_at: 'Généré le',
            generated_by: 'Généré par',
            no_summaries: 'Aucun executive summaries trouvé',
            generate: 'Générer',
            load_error: 'Impossible de charger les résumés exécutifs. Veuillez réessayer.',
            generate_error: 'Impossible de générer le résumé exécutif',
            save_error: 'Impossible de sauvegarder le résumé exécutif',
        },
        audit_readiness: {
            title: "Préparation à l'audit",
            loading: 'Chargement de audit readiness data...',
            overall_readiness: 'Préparation globale',
            by_domain: 'Par Domaine',
            evidence_coverage: 'Couverture des preuves',
            gaps: 'Écarts',
            load_error: 'Impossible de charger la dernière préparation. Veuillez réessayer.',
            history_error: "Impossible de charger l'historique. Veuillez réessayer.",
            calculate_error: "Impossible de calculer la préparation à l'audit",
            aria_recalculate: 'Recalculer le score de préparation',
            aria_current_readiness: "Préparation actuelle à l'audit",
            aria_history: 'Historique des scores de préparation',
            recalculated: "Préparation à l'audit recalculée",
            loading_sr: 'Chargement des données de préparation',
        },
        evidence_gaps: {
            title: 'Lacunes de preuves',
            domain: 'Domaine',
            control: 'Contrôle',
            gap_type: "Type d'écart",
            severity: 'Gravité',
            no_gaps: 'Aucun evidence gaps trouvé',
            load_error: 'Impossible de charger les lacunes. Veuillez réessayer.',
            stats_error: 'Impossible de charger les statistiques. Veuillez réessayer.',
            create_error: 'Impossible de créer la lacune',
            update_error: 'Impossible de mettre à jour la lacune',
            status_error: 'Impossible de mettre à jour le statut',
            aria_create_new: 'Créer une nouvelle lacune',
            aria_statistics: 'Statistiques des lacunes',
            loading_sr: 'Chargement des lacunes',
            status_updated: 'Statut de la lacune mis à jour',
            entity_type_placeholder: 'p. ex., fournisseur, système',
            all_modules: 'Tous les domaines',
            all_severities: 'Toutes les gravités',
        },
        program_health: {
            title: 'Santé du programme',
            loading: 'Chargement de program health data...',
            overall_health: 'Santé globale',
            by_module: 'Par Module',
            risk_areas: 'Domaines de risque',
            recommendations: 'Recommandations',
            load_error: 'Impossible de charger les données. Veuillez réessayer.',
            aria_key_metrics: 'Métriques clés de santé du programme',
            aria_module_scorecard: 'Détail de la fiche de score par module',
            loading_sr: 'Chargement des données de santé du programme',
            trending_up: 'Tendance à la hausse',
            trending_down: 'Tendance à la baisse',
            trending_stable: 'Stable',
            data_loaded: 'Données de santé du programme chargées',
        },
        obligation_mappings: {
            title: 'Correspondances des obligations',
            create_mapping: 'Créer une correspondance des obligations',
            framework: 'Cadre réglementaire',
            select_framework: 'Sélectionner un cadre...',
            obligation: 'Obligation',
            obligation_ref: "Référence de l'obligation",
            obligation_description: "Description de l'obligation",
            role: 'Rôle',
            assigned_role: 'Rôle assigné',
            assigned_department: 'Département assigné',
            select_department: 'Sélectionner un département...',
            control_ids: 'ID de contrôle',
            raci_assignments: 'Attributions RACI',
            create_raci: 'Créer une attribution RACI',
            activity: 'Activité',
            activity_name: "Nom de l'activité",
            activity_description: "Description de l'activité",
            responsible: 'Responsable',
            select_users: 'Sélectionner des utilisateurs...',
            accountable: 'Redevable',
            select_user: 'Sélectionner un utilisateur...',
            consulted: 'Consulté',
            informed: 'Informé',
            review_frequency: 'Fréquence de révision',
            frequency_monthly: 'Mensuel',
            frequency_quarterly: 'Trimestriel',
            frequency_semi_annual: 'Semestriel',
            frequency_annual: 'Annuel',
            no_mappings_found: 'Aucune correspondance des obligations trouvée.',
            no_raci_found: 'Aucune attribution RACI trouvée.',
            mapping_created: "Mappage d'obligation créé",
            mapping_updated: "Correspondance d'obligation mise à jour",
            mapping_deleted: "Correspondance d'obligation supprimée",
            raci_created: 'Attribution RACI créée',
            raci_updated: 'Attribution RACI mise à jour',
            raci_deleted: 'Attribution RACI supprimée',
            aria_edit_mapping: 'Modifier la correspondance {name}',
            aria_delete_mapping: 'Supprimer la correspondance {name}',
            aria_edit_raci: 'Modifier RACI {name}',
            aria_delete_raci: 'Supprimer RACI {name}',
            confirm_delete_mapping: "Supprimer cette correspondance d'obligation ?",
            confirm_delete_raci: 'Supprimer cette attribution RACI ?',
            table_view: 'Vue tableau',
            matrix_view: 'Vue matricielle',
            print_export: 'Imprimer / Exporter',
            filter_framework: 'Filtrer par cadre',
            no_matrix_data: 'Aucune attribution RACI à afficher en vue matricielle.',
            aria_print_export: 'Imprimer ou exporter la matrice RACI',
        },
        governance_documents: {
            title: 'Documents de gouvernance',
            create_document: 'Créer un document de gouvernance',
            document_title: 'Titre du document',
            document_type: 'Type de document',
            content_url: 'URL du contenu',
            content_url_placeholder: 'https://...',
            framework_codes: 'Codes cadre',
            select_frameworks: 'Sélectionner des cadres...',
            effective_date: "Date d'entrée en vigueur",
            review_date: 'Date de révision',
            status: 'Statut',
            version: 'Version',
            acknowledgments: 'Accusés de réception',
            acknowledge: 'Accuser réception',
            acknowledged_by: 'Accusé de réception par',
            department: 'Département',
            no_documents_found: 'Aucun document de gouvernance trouvé.',
            draft: 'Brouillon',
            review: 'Révision',
            approved: 'Approuvé',
            issued: 'Émis',
            superseded: 'Remplacé',
            document_created: 'Document créé',
            document_acknowledged: 'Document accusé de réception',
            policy: 'Politique',
            procedure: 'Procédure',
            standard: 'Norme',
            guideline: 'Ligne directrice',
        },
        governance_model: {
            title: 'Modèle de gouvernance',
            create_model: 'Créer un modèle de gouvernance',
            edit_model: 'Modifier le modèle de gouvernance',
            model_name: 'Nom du modèle',
            description: 'Descriptif',
            governance_type: 'Type de gouvernance',
            type_centralized: 'Centralisé',
            type_federated: 'Fédéré',
            type_hybrid: 'Hybride',
            framework_codes: 'Codes de cadre',
            select_frameworks: 'Sélectionner les cadres...',
            review_frequency: 'Fréquence de révision',
            freq_monthly: 'Mensuelle',
            freq_quarterly: 'Trimestrielle',
            freq_semi_annual: 'Semestrielle',
            freq_annual: 'Annuelle',
            committees: 'Comités',
            committee_name: 'Nom du comité',
            committee_members: 'Membres (séparés par des virgules)',
            committee_mandate: 'Mandat',
            add_committee: 'Ajouter un comité',
            no_committees: 'Aucun comité défini.',
            delegation_rules: 'Règles de délégation',
            from_role: 'Du rôle',
            to_role: 'Au rôle',
            scope: 'Portée',
            add_delegation_rule: 'Ajouter une règle de délégation',
            control_owner_summary: 'Résumé des propriétaires de contrôle',
            no_raci_data: 'Aucune donnée RACI liée à ce modèle.',
            activity: 'Activité',
            responsible: 'Responsable',
            accountable: 'Redevable',
            consulted: 'Consulté',
            informed: 'Informé',
            no_models_found: 'Aucun modèle de gouvernance trouvé.',
            model_created: 'Modèle de gouvernance créé',
            model_updated: 'Modèle de gouvernance mis à jour',
            model_deleted: 'Modèle de gouvernance supprimé',
            confirm_delete: 'Supprimer ce modèle de gouvernance ?',
            expand: 'Développer',
            collapse: 'Réduire',
            aria_expand: 'Développer les détails de {name}',
            aria_edit: 'Modifier le modèle {name}',
            aria_delete: 'Supprimer le modèle {name}',
            aria_export_csv: 'Exporter {name} en CSV',
            aria_export_json: 'Exporter {name} en JSON',
            framework_read_permission_warning: "Vous avez besoin de l'autorisation regulatory_framework:read pour sélectionner les frameworks. Demandez à un administrateur de l'accorder.",
            select_members: 'Sélectionner les membres du comité',
            select_from_role: 'Sélectionnez le rôle de délégation',
            select_to_role: 'Sélectionnez le rôle de réception',
            mandate_markdown_hint: 'Markdown pris en charge : **gras**, listes, liens.',
            scope_tab_obligation: 'Obligation',
            scope_tab_framework: 'Cadre',
            scope_tab_free_text: 'Texte libre',
            select_obligation: 'Sélectionnez une obligation',
            select_framework: 'Sélectionnez un cadre',
            aria_remove_committee: 'Supprimer le comité {n}',
            aria_remove_delegation_rule: 'Supprimer la règle de délégation {n}',
            no_frameworks_available: "Aucun cadre disponible. Ajoutez d'abord des cadres réglementaires.",
        },
        document_drafting: {
            title: 'Rédaction et approbation',
            document_title: 'Titre du document',
            document_type: 'Type de document',
            status: 'Statut',
            drafter: 'Rédacteur',
            deadline: 'Date limite',
            assign_drafter: 'Assigner un rédacteur',
            select_drafter: 'Sélectionner un rédacteur...',
            assign: 'Assigner',
            submit_for_review: 'Soumettre pour révision',
            legal_review: 'Révision juridique',
            reviewer: 'Réviseur',
            select_reviewer: 'Sélectionner un réviseur...',
            comments: 'Commentaires',
            review_action: 'Action de révision',
            approve: 'Approuver',
            request_changes: 'Demander des modifications',
            submit_review: 'Soumettre la révision',
            executive_approval: 'Approbation de la direction',
            no_drafts_found: 'Aucun document en rédaction, révision ou approbation.',
            drafter_assigned: 'Rédacteur assigné',
            status_updated: 'Statut du document mis à jour',
            review_approved: 'Révision approuvée',
            changes_requested: 'Modifications demandées',
            document_approved: 'Document approuvé',
            aria_assign: 'Assigner un rédacteur à {name}',
            aria_submit_review: 'Soumettre {name} pour révision',
            aria_review: 'Réviser {name}',
            aria_approve: 'Approuver {name}',
        },
        document_issuance: {
            title: 'Émission et distribution',
            document_title: 'Titre du document',
            document_type: 'Type de document',
            status: 'Statut',
            version: 'Version',
            effective_date: "Date d'entrée en vigueur",
            distribution_scope: 'Portée de distribution',
            distribution_placeholder: 'Ex. : Tous les départements',
            issuance_number: "Numéro d'émission",
            issuance_number_placeholder: 'Ex. : ISS-2026-001',
            supersedes: 'Remplace le document',
            none: 'Aucun',
            issue_document: 'Émettre le document',
            ready_for_issuance: 'Prêt pour émission',
            issued_documents: 'Documents émis',
            no_issued_documents: 'Aucun document émis trouvé.',
            view_lineage: 'Voir la lignée',
            supersession_lineage: 'Lignée de remplacement',
            document_issued: 'Document émis',
            document_superseded: 'Document remplacé',
            aria_issue: 'Émettre {name}',
            aria_view_lineage: 'Voir la lignée de {name}',
        },
        acknowledgment_tracking: {
            title: 'Suivi des accusés de réception',
            document_title: 'Documenter',
            acknowledged_count: 'Reçus',
            pending_count: 'En attente',
            percentage: 'Achèvement',
            details: 'Détails',
            send_reminder: 'Envoyer un rappel',
            acknowledgment_details: 'Détails des accusés',
            user: 'Utilisateur',
            department: 'Département',
            acknowledged_at: 'Reçu le',
            status: 'Statut',
            acknowledged: 'Reçu',
            no_issued_documents: 'Aucun document émis à suivre.',
            no_acknowledgments: 'Aucun accusé enregistré.',
            reminder_sent: 'Rappel envoyé',
            aria_expand: 'Détails des accusés pour {name}',
            aria_send_reminder: 'Envoyer un rappel pour {name}',
        },
        change_log: {
            title: 'Journal des modifications',
            date: 'Date',
            document: 'Documenter',
            change_type: 'Type de modification',
            actor: 'Acteur',
            summary: 'Résumé',
            export_csv: 'Exporter CSV',
            filters: 'Filtres du journal',
            filter_document: 'Filtrer par document',
            all_documents: 'Tous les documents',
            filter_change_type: 'Filtrer par type',
            all_types: 'Tous les types',
            date_from: 'Date début',
            date_to: 'Date fin',
            version_history: 'Historique des versions',
            version_archive: 'Archive des versions',
            no_entries: 'Aucune entrée trouvée.',
            no_history: 'Aucun historique disponible.',
            exported: 'Journal exporté',
            aria_export: 'Exporter le journal en CSV',
            aria_view_history: "Voir l'historique de {name}",
        },
        review_cadence: {
            title: 'Cadence de révision',
            configure_cadence: 'Configurer la cadence',
            edit_cadence: 'Modifier la cadence',
            document: 'Documenter',
            select_document: 'Sélectionner un document...',
            review_frequency: 'Fréquence de révision',
            freq_30: '30 jours',
            freq_60: '60 jours',
            freq_90: '90 jours',
            freq_180: '180 jours',
            freq_365: '365 jours',
            last_reviewed: 'Dernière révision',
            next_review: 'Prochaine révision',
            status: 'Statut',
            overdue: 'En retard',
            on_track: 'À jour',
            days: 'jours',
            horizon: 'Horizon de révision',
            overdue_warning: 'Révisions en retard',
            overdue_count: '{count} document(s) en retard.',
            no_cadences: 'Aucune cadence configurée.',
            cadence_created: 'Cadence créée',
            cadence_updated: 'Cadence mise à jour',
            aria_edit: 'Modifier la cadence de {name}',
        },
        remediation_plans: {
            title: 'Plans de remédiation',
            create_plan: 'Créer un plan de remédiation',
            gap_id: 'Référence de lacune',
            select_gap: 'Sélectionner une lacune...',
            plan_title: 'Titre',
            description: 'Descriptif',
            priority: 'Priorité',
            priority_critical: 'Critique',
            priority_high: 'Élevée',
            priority_medium: 'Moyenne',
            priority_low: 'Faible',
            assigned_to: 'Assigné à',
            select_user: 'Sélectionner un utilisateur...',
            target_date: 'Date cible',
            framework_code: 'Cadre',
            select_framework: 'Sélectionner un cadre...',
            gap_finding: 'Constat de lacune',
            action_items: "Éléments d'action",
            owner: 'Propriétaire',
            deadline: 'Échéance',
            planned: 'Planifié',
            in_progress: 'En cours',
            completed: 'Terminé',
            verified: 'Vérifié',
            no_plans_found: 'Aucun plan de remédiation trouvé.',
            evidence: 'Preuve',
            plan_created: 'Plan de remédiation créé',
            action_items_hint: "Éléments d'action (un par ligne)",
        },
        statuses: {
            identified: 'Identifié',
            assigned: 'Attribué',
            in_remediation: 'En réhabilitation',
            resolved: 'Résolu',
            accepted_risk: 'Risque accepté',
            planned: 'Prévu',
            in_progress: 'En cours',
            under_review: 'En cours de révision',
            finalized: 'Finalisé',
            archived: 'Archivé',
            draft: 'Brouillon',
            active: 'Actif',
            upcoming: 'À venir',
            collecting: 'Collecte',
            published: 'Publié',
            review: 'Examen',
            approved: 'Approuvé',
            issued: 'Publié',
            superseded: 'Remplacé',
            completed: 'Terminé',
            verified: 'Vérifié',
        },
        severities: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Low',
        },
        priorities: {
            critical: 'Critique',
            high: 'Élevé',
            medium: 'Moyen',
            low: 'Low',
        },
        gap_types: {
            missing: 'Manquant',
            expired: 'Expiré',
            insufficient: 'Insuffisant',
        },
        document_types: {
            policy: 'Politique',
            procedure: 'Procédure',
            standard: 'Norme',
            guideline: 'Ligne directrice',
            template: 'Modèle (interne)',
        },
        maturity_levels: {
            level_1: 'Niveau 1 — Initiale',
            level_2: 'Niveau 2 — Développement',
            level_3: 'Niveau 3 — Défini',
            level_4: 'Niveau 4 — Géré',
            level_5: 'Niveau 5 — Optimisation',
        },
        grades: {
            excellent: 'Excellent',
            good: 'Bon',
            fair: 'Foire',
            poor: 'Pauvre',
            critical: 'Critique',
            needs_improvement: "Besoin d'amélioration",
            not_assessed: 'Non évalué',
        },
        modules: {
            data_mapping: 'Cartographie des données',
            consent: 'Consentement',
            governance: 'Gouvernance',
            incidents: 'Incidents',
            monitoring: 'Surveillance',
            classification: 'Classement',
            vendor_risk: 'Risque fournisseurs',
            discovery: 'Découverte',
            deletion: 'Suppression',
        },
        cadences: {
            monthly: 'Mensuel',
            quarterly: 'Trimestriel',
            semi_annual: 'Semestriel',
            annual: 'Annuel',
        },
        section_labels: {
            opening: 'Ouverture',
            key_metrics: 'Indicateurs clés',
            highlights: 'Points forts',
            concerns: 'Préoccupations',
            recommendations: 'Recommandations',
            outlook: 'Perspectives',
        },
        out_of_100: '/100',
        count_gaps: '[[TOK_1]] écart',
        count_gaps_plural: '[[TOK_1]] lacunes',
        count_summaries: '[[TOK_1]] résumé',
        count_summaries_plural: '[[TOK_1]] résumés',
        count_assessments: '[[TOK_1]] évaluation',
        count_assessments_plural: '[[TOK_1]] évaluations',
        count_models: 'Modèle [[TOK_1]]',
        count_models_plural: '[[TOK_1]] modèles',
        count_periods: '[[TOK_1]] période',
        count_periods_plural: '[[TOK_1]] périodes',
        count_metrics: '[[TOK_1]] métrique',
        count_metrics_plural: '[[TOK_1]] métriques',
        unknown_user: 'Utilisateur inconnu',
        unknown_gap: 'Écart inconnu',
        no_permission_title: 'Autorisations insuffisantes',
        no_permission_message: "Vous n'avez pas la permission d'accéder à cette page.",
        ac_vn_frameworks_title: 'Couverture du cadre VN',
        ac_vn_frameworks_body: "Les évaluations de maturité couvrent les 6 cadres réglementaires vietnamiens : [[TOK_0]], loi sur les données, loi sur les télécommunications, loi sur la cybersécurité, loi [[TOK_1]] et loi sur le commerce électronique, chacun avec des critères d'évaluation spécifiques au cadre.",
        ac_controller_processor_title: 'Contrôleur vs processeur',
        ac_controller_processor_body: "Les mappages d’obligations font la distinction entre les responsabilités du responsable du traitement et celles du sous-traitant. Attribuez des rôles à l'aide de la matrice RACI pour garantir que chaque obligation a un propriétaire clair, que l'organisation agisse en tant que contrôleur ou sous-traitant.",
        ac_versioned_evidence_title: 'Piste de preuves versionnées',
        ac_versioned_evidence_body: 'Chaque transition de statut (Brouillon, Révision, Approuvé, Publié) crée un enregistrement horodaté et versionné qui sert de preuve vérifiable. Le journal des modifications capture l’historique complet du cycle de vie du document.',
        ac_remediation_gap_link_title: 'Lié aux lacunes d’évaluation',
        ac_remediation_gap_link_body: 'Chaque plan de remédiation est directement lié à une lacune d’évaluation identifiée. Attribuez un propriétaire et fixez un délai cible pour suivre les progrès de la résolution, de l’écart à la fermeture.',
        ac_annual_attestation_title: "Cycle d'attestation annuel",
        ac_annual_attestation_body: "Les périodes de déclaration sont conformes aux exigences d'attestation annuelle de la loi vietnamienne sur les données. Utilisez la cadence « Annuelle » (cycle de 365 jours) pour générer automatiquement des périodes alignées sur l'attestation.",
        ac_evidence_per_obligation_title: 'Preuve par obligation-cadre',
        ac_evidence_per_obligation_body: 'Les lacunes en matière de preuves identifient les preuves manquantes, expirées ou insuffisantes pour chaque obligation-cadre. Filtrez par domaine pour voir quelles exigences réglementaires manquent de preuves à l’appui.',
        ac_cross_framework_title: 'Complétude multi-framework',
        ac_cross_framework_body: 'La préparation à l’audit fournit une vue d’exhaustivité inter-framework. Les scores des composants reflètent la couverture de tous les cadres cartographiés, mettant en évidence les domaines qui nécessitent une attention avant un audit.',
        ac_cadence_default_title: 'Cadence de révision par défaut',
        ac_cadence_default_body: 'La cadence de révision par défaut est de 180 jours. Les avis en retard sont automatiquement signalés. Ajustez la fréquence par document selon vos besoins – les options vont de 30 à 365 jours.',
        ac_templates_internal_title: 'Classification des modèles',
        ac_templates_internal_body: 'Les modèles sont classés comme documents internes. Utilisez le type de document « Modèle » pour marquer les artefacts de gouvernance réutilisables avec une portée de distribution interne uniquement.',
    },
    mcp_pending: {
        title: 'MCP — Écritures en attente',
        subtitle: 'Les clients Claude externes proposent ici des écritures. Approuvez ou refusez chaque entrée — Forseti n’exécute qu’après validation par un administrateur.',
        no_pending: 'Aucune écriture en attente.',
        col_tool: 'Outil',
        col_preview: 'Aperçu',
        col_key: 'Touche [[TOK_0]]',
        col_requested: 'Demandé',
        col_expires: 'Expire',
        col_status: 'Statut',
        status_pending: 'En attente',
        status_approved: 'Approuvé',
        status_declined: 'Refusé',
        status_expired: 'Expiré',
        status_executed: 'Exécuté',
        approve_label: 'Approuver',
        decline_label: 'Refuser',
        refresh_label: 'Actualiser',
        error_generic: 'Impossible de charger les écritures en attente.',
        confirm_approve: 'L’approbation exécutera l’outil sur votre organisation avec les permissions du détenteur de l’API key. Continuer ?',
        confirm_decline: 'Refuser cette écriture en attente ? Cette action est irréversible.',
        advisory_banner: 'Les écritures en attente expirent 24 heures après leur création. Le balayage GC horaire refuse automatiquement les entrées expirées.',
    },
    audit_walkthrough: {
        title: 'Forseti — Générateur de visite d’audit',
        subtitle: 'Générez une visite structurée pour le lancement d’un audit : question d’ouverture par contrôle, preuves attendues, questions complémentaires, lacunes potentielles.',
        audit_picker_label: 'Vérification',
        audit_picker_hint: 'Choisissez un audit planifié pour générer une visite.',
        run_label: 'Générer la visite',
        running: 'Génération…',
        results_heading: 'Visite — {count} contrôle(s)',
        tokens_label: '≈ {count} jetons',
        no_controls: 'Aucun contrôle dans le périmètre. Ajoutez des contrôles à la fiche d’audit.',
        col_control: 'Contrôle',
        col_question: 'Question d’ouverture',
        col_evidence: 'Preuve',
        col_gaps: 'Lacunes potentielles',
        expected_evidence_label: 'Preuves attendues',
        followup_probes_label: 'Questions complémentaires',
        accept_label: 'Accepter la visite',
        reject_label: 'Rejeter',
        export_label: 'Exporter en DOCX',
        resolve_summary: 'Résolution : {status}',
        error_generic: 'Impossible de générer la visite. Réessayez ou vérifiez le statut de l’audit.',
    },
    privilege_creep: {
        title: 'Forseti — Détection de dérive de privilèges',
        subtitle: 'Analyse périodique des affectations de rôles. Les conclusions sont consultatives — Forseti ne révoque jamais automatiquement.',
        run_label: 'Analyser maintenant',
        running: 'Analyse…',
        findings_heading: '{count} conclusion(s)',
        no_findings: 'Aucune dérive de privilèges détectée.',
        col_user: 'Utilisateur',
        col_job_function: 'Fonction',
        col_severity: 'Gravité',
        col_unexpected: 'Permissions inattendues',
        col_remediation: 'Remédiation suggérée',
        col_status: 'Statut',
        severity_critical: 'Critique',
        severity_high: 'Élevée',
        severity_medium: 'Moyenne',
        severity_low: 'Faible',
        status_open: 'Ouverte',
        status_dismissed: 'Rejetée',
        status_remediated: 'Corrigée',
        dismiss_label: 'Rejeter',
        remediate_label: 'Marquer corrigée',
        note_label: 'Note (facultatif)',
        error_generic: 'Impossible d’analyser la dérive de privilèges. Réessayez plus tard.',
        advisory_banner: 'Ces conclusions sont consultatives. Forseti ne révoque jamais automatiquement les permissions — examinez avec le propriétaire du rôle avant d’agir.',
    },
    compliance_rules: {
        rule_mapping: {
            title: 'Mappage automatique des règles de conformité',
            subtitle: 'Forseti parcourt un pack réglementaire installé et suggère des règles de conformité nouvelles ou actualisées fondées sur les articles sources.',
            pack_picker_label: 'Dossier réglementaire',
            pack_picker_hint: 'Sélectionnez un pack installé à mapper.',
            run_label: 'Carte du pack',
            running: 'Cartographie…',
            results_heading: '[[TOK_1]] suggestion(s)',
            tokens_label: '≈ [[TOK_1]] jetons de votre bucket mensuel',
            no_suggestions: 'Aucune suggestion : le contenu du pack est peut-être déjà entièrement couvert par les règles existantes.',
            kind_new: 'Nouvelle règle',
            kind_refresh: "Actualiser l'existant",
            kind_no_change: 'Aucun changement requis',
            col_kind: 'Genre',
            col_title: 'Titre proposé',
            col_existing: 'Règle existante',
            col_source: 'Origine',
            proposed_body_label: 'Corps proposé',
            source_quote_label: 'Citation source',
            accept_selected: 'Accepter la sélection',
            reject_all: 'Rejeter tout',
            accept_all: 'Acceptez tout',
            resolve_summary: 'Résolution : [[TOK_2]] · [[TOK_3]] règle(s) créée(s)',
            error_generic: "Impossible d'exécuter le mappage de règles. Réessayez ou vérifiez le code du pack.",
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Tableau de bord de session',
            access_log: "Journal d'accès",
            justification_review: 'Examen des justifications',
            investigations: 'Enquêtes',
            pattern_analysis: 'Analyse de modèles',
            anchoring_status: "Statut d'ancrage",
            configuration: 'Paramétrage',
            access_policies: "Politiques d'accès",
            review_campaigns: 'Campagnes de révision',
            evidence_packages: 'Paquets de preuves',
        },
        session_dashboard: {
            title: 'Tableau de bord de session',
            loading: 'Chargement de dashboard data...',
            total_sessions: 'Total de sessions',
            active_sessions: 'Sessions actives',
            avg_duration: 'Durée moyenne',
            concurrent_peak: 'Pic simultané',
            auth_method_breakdown: "Répartition méthodes d'auth.",
            geo_country_breakdown: 'Répartition par pays',
            recent_session_events: 'Récent Session Événements',
            user_id: 'Utilisateur ID',
            session_id: 'ID de session',
            ip_address: 'IP Adresse',
            auth_method: "Méthode d'auth.",
            started_at: 'Démarré À',
            event_type: 'Événement Type',
            all_event_types: 'Tous Événement Types',
            filter_by_user: 'Filtrer par Utilisateur ID...',
            no_active_sessions: 'Aucune session active',
            no_session_events: 'Aucun session events trouvé',
            revoke: 'Révoquer',
            revoke_session: 'Révoquer Session',
            revoke_reason: 'Motif',
            revoke_placeholder: 'Fournissez un motif de révocation de cette session...',
            session_label: 'Session :',
            load_failed: 'Échec de load session dashboard. Veuillez réessayer.',
            events_load_failed: 'Échec de load session events. Veuillez réessayer.',
            revoke_failed: 'Échec de revoke session. Veuillez réessayer.',
            session_events_loaded: '{n} session events chargés',
            event_types: {
                session_created: 'Session créée',
                session_refreshed: 'Session actualisée',
                session_expired: 'Session expirée',
                session_revoked: 'Session révoquée',
                session_terminated: 'Session terminée',
                login_success: 'Connexion réussie',
                login_failure: 'Échec de connexion',
                logout: 'Déconnexion',
                token_refresh: 'Actualisation des jetons',
                mfa_challenge: 'Défi MFA',
            },
        },
        access_log: {
            title: "Journal d'accès",
            user_id: 'Utilisateur ID',
            resource: 'Ressource',
            action: 'Mesure',
            ip_address: 'IP Adresse',
            timestamp: 'Horodatage',
            no_logs: 'Aucun access log entries trouvé',
            filter_by_user: 'Filtrer par Utilisateur ID...',
            load_failed: 'Échec de charge access journaliser. Veuillez réessayer.',
            export_success: 'Exporter initiated avec succès',
            export_failed: 'Échec de export access log. Veuillez réessayer.',
            record_count: 'enregistrer',
            record_count_plural: 'enregistrements',
            unclassified: 'Non classifié',
            classification_missing: 'Classification manquante',
            response_code: 'Code de reponse',
            classification_levels: {
                public: 'Publique',
                internal: 'Interne',
                confidential: 'Confidentiel',
                restricted: 'Restreint',
                unclassified: 'Non classifie',
            },
        },
        justification_review: {
            title: 'Examen des justifications',
            user_id: 'Utilisateur ID',
            resource: 'Ressource',
            justification: 'Motif',
            submitted_at: 'Soumis le',
            reviewer: 'Réviseur',
            no_reviews: 'Aucun justification reviews trouvé',
            load_failed: 'Échec de load justifications. Veuillez réessayer.',
            review_failed: 'Échec de review justification. Veuillez réessayer.',
            decline_failed: 'Échec de decline access. Veuillez réessayer.',
            justification_count: 'motif',
            justification_count_plural: 'motifs',
            reviewed: 'Révisé',
            concerning: 'Préoccupant',
            escalated: 'Escaladé',
            link_investigation_placeholder: 'Lier à un enquête (optional)',
            review_queue: "Examiner File d'attente",
            access_id_label: "ID d'accès",
            access_id_placeholder: "ID d'entrée du journal d'accès",
            select_user_placeholder: 'Sélectionner un utilisateur (optionnel)',
            resource_type_label: 'Type de ressource',
            resource_type_placeholder: 'ex. document, database',
            resource_id_label: 'ID de la ressource',
            resource_id_placeholder: 'Identifiant de la ressource',
            reason_placeholder: "Raison d'accès à cette ressource...",
            create_failed: 'Échec de create justification',
            unclassified: 'Non classifié',
            review_statuses: {
                pending: 'En attente',
                reviewed: 'Révisé',
                concerning: 'Concernant',
                escalated: 'Escaladé',
            },
            reason_codes: {
                business_need: "Besoin de l'entreprise",
                legal_obligation: 'Obligation légale',
                data_subject_request: 'Demande de personne concernée',
                audit_requirement: 'Exigence de vérification',
                incident_response: 'Réponse aux incidents',
                research: 'Recherche',
                administrative: 'Administratif',
                other: 'Autre',
            },
        },
        investigations: {
            title: "Espace d'enquête",
            new: 'Nouveau enquête',
            subject: 'Sujet',
            investigator: 'Enquêteur',
            opened_at: 'Ouvert À',
            findings: 'Constatations',
            no_investigations: 'Aucun enquêtes trouvé',
            load_failed: 'Échec de charge enquêtes. Veuillez réessayer.',
            create_failed: 'Échec de create investigation. Veuillez réessayer.',
            timeline_add_failed: 'Échec de add timeline entry. Veuillez réessayer.',
            link_access_failed: 'Échec de link access ids. Veuillez réessayer.',
            link_justification_failed: 'Échec de link justification ids. Veuillez réessayer.',
            close_failed: 'Échec de fermer enquête. Veuillez réessayer.',
            export_success: 'Exporter initiated avec succès',
            export_failed: 'Échec de export investigation. Veuillez réessayer.',
            refresh_failed: 'Échec de refresh investigation detail. Veuillez réessayer.',
            update_failed: "Échec de la mise à jour de l'enquête",
            investigation_count: 'enquête',
            investigation_count_plural: 'enquêtes',
            title_placeholder: 'Enquête titre',
            description_placeholder: 'Détaillé description de le enquête...',
            assignee_placeholder: "ID utilisateur de l'assigné (facultatif)",
            timeline_action_placeholder: "p.ex., Journaux d'accès révisés",
            timeline_note_placeholder: 'Facultatif note',
            access_ids_placeholder: "identifiant d'accès-1, identifiant d'accès-2",
            justification_ids_placeholder: 'justification-id-1, justification-id-2',
            findings_placeholder: 'Résumer le enquête constatations...',
            by_actor: 'by',
            close_investigation: 'Fermer Enquête',
            add_timeline_failed: 'Échec de add timeline entry. Veuillez réessayer.',
            fetch_failed: 'Échec de fetch investigations. Veuillez réessayer.',
            change_status: "Changer le statut de l'enquête",
            details: "Détails de l'enquête",
            link_evidence: 'Lier une preuve',
            link_justifications: 'Lier des justifications',
            access_ids_label: "IDs d'accès",
            justification_ids_label: 'IDs de justification',
            access_ids_link_placeholder: "identifiant d'accès-1, identifiant d'accès-2",
            justification_ids_link_placeholder: 'justification-id-1, justification-id-2',
            investigations_loaded: '{n} investigations chargés',
            status_changed_to: 'Statut changé en {status}',
            add_timeline_entry: 'Ajouter une entrée chronologique',
            add_access_ids: "Ajouter des IDs d'accès",
            add_justification_ids: 'Ajouter des IDs de justification',
            investigation_types: {
                anomaly_review: 'Examen des anomalies',
                complaint_driven: 'Suite à une plainte',
                scheduled_review: 'Examen programmé',
                whistleblower_report: 'Rapport de dénonciation',
            },
            severity_labels: {
                low: 'Faible',
                medium: 'Moyen',
                high: 'Élevé',
                critical: 'Critique',
            },
            status_labels: {
                open: 'Ouvert',
                in_progress: 'En cours',
                pending_review: "En attente d'examen",
                closed_substantiated: 'Clôturé (justifié)',
                closed_unsubstantiated: 'Clôturé (non fondé)',
                closed_inconclusive: 'Fermé (non concluant)',
            },
            disposition_labels: {
                substantiated: 'Justifié',
                unsubstantiated: 'Non fondé',
                inconclusive: 'Non concluant',
            },
        },
        pattern_analysis: {
            title: 'Analyse de modèles',
            loading: 'Chargement de pattern data...',
            anomalies_detected: 'Anomalies détectées',
            patterns: 'Modèles',
            by_user: 'Par Utilisateur',
            by_resource: 'Par ressource',
            time_range: 'Plage horaire',
            load_failed: 'Échec de analyze patterns. Veuillez réessayer.',
            top_resources: 'Top 10',
            access_by_hour: 'Accès par heure du jour',
            access_by_day: 'Accès par Day de Semaine',
            fetch_failed: 'Échec de fetch pattern analysis. Veuillez réessayer.',
            analysis_loaded: 'Analyse de motifs chargée pour {user}, {n} sessions trouvées',
            date_format_placeholder: 'JJ/MM/AAAA',
            access_by_hour_heading: 'Accès par heure de la journée',
            access_by_day_heading: 'Accès par jour de la semaine',
            by_classification: 'Par niveau de classification',
            top_accessed_resources: 'Ressources les plus consultées',
            user_access_summary: "Résumé d'accès utilisateur",
            days: {
                sunday: 'Dimanche',
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
            },
            linked_access_logs: "Journaux d'accès liés",
            linked_access_logs_desc: 'Accédez aux entrées du journal associées aux modèles détectés pour cet utilisateur.',
        },
        anchoring_status: {
            title: "Statut d'ancrage",
            loading: 'Chargement de anchoring data...',
            anchored: 'Ancré',
            pending: 'En attente',
            failed: 'Échoué',
            last_anchor: 'Dernier ancrage',
            no_records: 'Aucun anchoring records trouvé',
            status_load_failed: 'Échec de load anchoring status. Veuillez réessayer.',
            proofs_load_failed: 'Échec de load access proofs. Veuillez réessayer.',
            verify_failed: 'Échec de verify proof chain. Veuillez réessayer.',
            anchor_failed: 'Échec de anchor access proof. Veuillez réessayer.',
            batch_anchor_failed: 'Échec de batch anchor access proofs. Veuillez réessayer.',
            proof_count: 'preuve',
            proof_count_plural: 'preuves',
            anchor_single: 'Ancrage individuel',
            anchor_batch: 'Ancrage par lot',
            access_id_placeholder: 'Saisissez access ID to anchor',
            batch_ids_placeholder: "identifiant d'accès-1, identifiant d'accès-2, identifiant d'accès-3",
            verify_chain: 'Vérifier la chaîne',
            chain_breaks: 'Ruptures de chaîne',
            total_checked: 'Total vérifié',
            anchor_placeholder: 'Saisissez access ID to anchor',
            fetch_failed: 'Échec de fetch anchoring status. Veuillez réessayer.',
            fetch_proofs_failed: 'Échec de fetch proofs. Veuillez réessayer.',
            access_id: "ID d'accès",
            chain_sequence: 'Séq. chaîne',
            proof_hash_label: 'Hash de preuve',
            batch_id: 'ID de lot',
            proofs_loaded: '{n} access proofs chargés',
            anchor_statuses: {
                pending: 'En attente',
                submitted: 'Soumis',
                confirmed: 'Confirmé',
                failed: 'Échec',
            },
            anchor_types: {
                sha256_chain: 'SHA-256 Chaîne',
                blockchain_anchor: 'Ancre Blockchain',
                zkp_stub: 'Talon ZKP',
            },
        },
        configuration: {
            title: 'Configuration',
            session_settings: 'Session Paramètres',
            log_retention: 'Journal Conservation (days)',
            anomaly_threshold: "Seuil d'anomalie",
            anchoring_enabled: 'Ancrage activé',
            save_config: 'Enregistrer Configuration',
            load_failed: 'Échec de charge configuration. Veuillez réessayer.',
            save_success: 'Configuration enregistré avec succès',
            save_failed: 'Échec de save configuration. Veuillez réessayer.',
            justification_rules: 'Règles de justification',
            reason_codes: 'Codes de motif',
            anchoring_settings: "Paramètres d'ancrage",
            anchoring_method: "Méthode d'ancrage",
            anchoring_frequency: "Fréquence d'ancrage",
            batch_interval: 'Lot Intervalle (minutes)',
            eligibility_criteria: "Critères d'éligibilité",
            add_criterion_placeholder: 'Ajouter eligibility criterion...',
            retention_settings: 'Conservation Paramètres',
            standard_retention: 'Norme Conservation (days)',
            sensitive_retention: 'Sensible Conservation (days)',
            working_hours: 'Heures de travail',
            work_start: 'Début Heure',
            work_end: 'Fin Heure',
            timezone: 'Fuseau horaire',
            timezone_placeholder: 'p.ex. Asia/Ho_Chi_Minh',
            working_days: 'Jours ouvrés',
            concurrent_sessions: 'Limites de sessions simultanées',
            concurrent_threshold: 'Concurrent Session Seuil',
            classification_level: 'Classification Niveau',
            prompt_mode: "Mode d'invite",
            grace_period: 'Période de grâce (s)',
            code_placeholder: 'identifiant',
            is_custom: 'Personnalisé',
            label_placeholder: 'Libellé',
            description_placeholder: 'Descriptif',
            custom: 'Personnalisé',
            fetch_failed: 'Échec de fetch configuration. Veuillez réessayer.',
            classification_levels: {
                public: 'Publique',
                internal: 'Interne',
                confidential: 'Confidentiel',
                restricted: 'Restreint',
                unclassified: 'Non classé',
            },
            prompt_modes: {
                reason_only: 'Raison seulement',
                reason_text: 'Motif + Texte',
                reason_text_supervisor: 'Raison + Texte + Superviseur',
            },
            anchoring_methods: {
                sha256_chain: 'SHA-256 Chaîne',
                blockchain_anchor: 'Ancre Blockchain',
                zkp_stub: 'Talon ZKP',
            },
            anchoring_frequencies: {
                realtime: 'En temps réel',
                batched: 'Par lots',
                on_demand: 'Sur demande',
            },
        },
        access_policies: {
            title: "Politiques d'accès",
            create_policy: "Créer une politique d'accès",
            policy_name: 'Nom de la stratégie',
            framework_code: 'Cadre réglementaire',
            select_framework: 'Sélectionner un cadre réglementaire...',
            review_frequency: 'Fréquence de révision',
            scope: 'Périmètre',
            no_policies_found: "Aucune politique d'accès trouvée.",
            policy_created: "Politique d'accès créée",
            frequency_labels: {
                monthly: 'Mensuel',
                quarterly: 'Trimestriel',
                semi_annual: 'Semestriel',
                annual: 'Annuel',
            },
        },
        review_campaigns: {
            title: "Campagnes de révision d'accès",
            create_campaign: 'Créer une campagne de révision',
            reviewer: 'Réviseur',
            due_date: "Date d'échéance",
            certify: 'Certifier',
            no_campaigns_found: "Aucune campagne de révision d'accès trouvée.",
            status_open: 'Ouvert',
            status_in_review: 'En révision',
            status_completed: 'Terminé',
            campaign_created: 'Campagne de revue créée',
            review_certified: "Revue d'accès certifiée",
            certify_campaign: 'Certifier la campagne {id}',
            policy_id: 'ID de la politique',
            select_policy: 'Sélectionner une politique...',
            reviewer_ids_label: 'Réviseurs',
            select_reviewers: 'Sélectionner des réviseurs...',
            status_labels: {
                open: 'Ouvert',
                in_review: 'En cours de revue',
                completed: 'Terminé',
            },
            evidence_package_id: 'ID du dossier de preuves',
        },
        evidence_packages: {
            title: 'Paquets de preuves',
            generate_package: 'Générer un paquet de preuves',
            export_type: "Type d'exportation",
            package_type: 'Type de paquet',
            framework_scope: 'Périmètre du cadre',
            period: 'Période',
            generated_by: 'Généré par',
            generated_at: 'Généré le',
            no_packages_found: 'Aucun paquet de preuves trouvé.',
            package_generated: 'Pack de preuves généré',
            export_type_full: 'Exportation complète',
            export_type_summary: 'Résumé',
            export_type_certification_only: 'Certification uniquement',
            package_type_access_review: "Revue d'accès",
            package_type_investigation: 'Enquête',
            package_type_certification: 'Attestation',
            package_type_authority_request: "Demande d'autorité",
            period_start: 'Début de la période',
            period_end: 'Fin de la période',
            select_frameworks: 'Sélectionner les cadres...',
            completeness_col: 'Complétude',
            status_col: 'Statut',
            generated_by_col: 'Généré par',
        },
        evidence_package_detail: {
            title: 'Détail du pack de preuves',
            not_found: 'Pack de preuves introuvable.',
            package_metadata: 'Métadonnées du pack',
            status: 'Statut',
            item_count: "Nombre d'éléments",
            disposition: 'Disposition',
            closed_at: 'Fermé le',
            completeness_dashboard: 'Tableau de complétude',
            no_completeness_data: 'Aucune donnée de complétude disponible.',
            controls_covered: 'contrôles couverts',
            missing: 'Manquants',
            sign_off_tracker: 'Suivi des approbations',
            stage_framework_owner: 'Propriétaire du cadre',
            stage_legal_compliance: 'Juridique et Conformité',
            stage_internal_audit: 'Audit interne',
            approved: 'Approuvé',
            returned: 'Retourné',
            pending: 'En attente',
            approve: 'Approuver',
            return_btn: 'Retourner',
            sign_off_submitted: 'Approbation soumise',
            artifacts: 'Artefacts',
            no_artifacts: 'Aucun artefact trouvé.',
            template_id: 'ID de modèle',
            description: 'Descriptif',
            classification: 'Classement',
            evidence_type: 'Type de preuve',
            framework_section: 'Section du cadre',
            history: "Historique d'approbation",
            expand: 'Développer',
            collapse: 'Réduire',
            action: 'Action',
            actor: 'Acteur',
            timestamp: 'Horodatage',
            comment: 'Commentaire',
            close_case: 'Fermer le dossier',
            confirm_close: 'Confirmer la fermeture',
            closure_notes: 'Notes de fermeture',
            disposition_compliant: 'Conforme',
            disposition_non_compliant: 'Non conforme',
            disposition_partial: 'Partiel',
            case_closed: 'Pack de preuves fermé',
            export_package: 'Exporter le pack',
            export_complete: 'Pack de preuves exporté',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Tableau de bord',
            properties: 'Propriétés',
            groups: 'Groupes',
            bindings: 'Liaisons',
            change_requests: 'Demandes de modification',
            comparison: 'Comparaison',
            inconsistencies: 'Incohérences',
            snapshot_schedules: "Planifications d'instantanés",
            golden_templates: 'Modèles de référence',
            evidence_packs: 'Paquets de preuves',
            audit: 'Vérification',
        },
        select_property: 'Sélectionner la propriété…',
        select_policy: 'Sélectionner la politique…',
        select_properties: 'Sélectionner les propriétés…',
        select_target_properties: 'Sélectionner les propriétés cibles…',
        select_owner: 'Sélectionner le propriétaire…',
        select_technical_contact: 'Sélectionner le contact technique…',
        property_statuses: {
            active: 'Actif',
            inactive: 'Inactif',
            pending: 'En attente',
            decommissioned: 'Déclassé',
        },
        dashboard: {
            title: 'Tableau de bord inter-propriétés',
            loading: 'Chargement de dashboard data...',
            total_properties: 'Total Propriétés',
            active_properties: 'Actif Propriétés',
            snapshot_coverage: 'Couverture des instantanés',
            properties_covered: 'propriétés couvertes',
            total_bindings: 'Total des liaisons',
            deployed_bindings: 'Déployé',
            pending_bindings: 'Déploiement en attente',
            deployment_progress: 'Progression du déploiement',
            on_target: "Sur l'objectif",
            below_target: "Sous l'objectif",
            target_label: 'Objectif',
            total_groups: 'Total Groupes',
            pending_changes: 'En attente Changements',
            inconsistencies: 'Incohérences',
            recent_activity: 'Récent Activité',
            no_recent_activity: 'Aucune activité récente.',
            fetch_error: 'Échec de load dashboard. Veuillez réessayer.',
        },
        properties: {
            title: 'Registre de propriétés',
            new: 'Nouveau propriété',
            edit: 'Modifier Propriété',
            property_name: 'Nom',
            property_type: 'Tapez',
            identifier: 'Identifiant',
            environment: 'Environnement',
            owner_id: 'Propriétaire ID',
            technical_contact_id: 'ID du contact technique',
            decommission: 'Décommissionner',
            confirm_decommission: 'Êtes-vous sûr de vouloir décommissionner cette propriété ?',
            no_properties: 'Aucun propriétés trouvé',
            all_environments: 'Tous les environnements',
            all_types: 'Tous les types',
            cmp_instance_id: "[[TOK_0]] ID d'instance",
            deployment_date: 'Date de déploiement',
            identifier_placeholder: 'par exemple, www.example.com ou com.example.app',
            owner_name: 'Propriétaire',
            technical_contact_name: 'Contact technique',
            sensitive_data_categories: 'Catégories de données sensibles',
            sensitive_data_categories_placeholder: 'Sélectionnez les catégories de données sensibles',
            requires_enhanced_review: 'Nécessite un examen approfondi',
            sensitive_review_status: 'Examen des données sensibles',
            sensitive_review_pending: "En attente d'examen",
            sensitive_review_approved: 'Approuvé',
            sensitive_review_rejected: 'Rejeté',
            sensitive_review_submit: "Soumettre l'avis",
            sensitive_review_approve: 'Approuver',
            sensitive_review_reject: 'Rejeter',
            sensitive_review_notes: 'Notes de révision',
            sensitive_review_notes_placeholder: 'Saisir des notes de révision...',
            record_withdrawal: 'Retrait du dossier',
            withdrawal_subject_id: 'ID du sujet',
            withdrawal_consent_id: 'Identifiant de consentement',
            withdrawal_reason: 'Raison',
            withdrawal_downstream_systems: 'Systèmes en aval',
            withdrawal_downstream_placeholder: 'système-1, système-2',
            withdrawal_success: 'Le retrait s’est propagé avec succès.',
            withdrawal_error: 'Échec de la propagation du retrait.',
            withdrawal_data_subject_id: 'ID de la personne concernée',
            withdrawal_consent_record_id: "ID de l'enregistrement de consentement",
            withdrawal_data_subject_id_placeholder: 'ex. usr_abc123',
            withdrawal_consent_record_id_placeholder: 'ex. consent_xyz789',
            withdrawal_purposes: 'Objectifs retirés',
            withdrawal_purposes_placeholder: 'Sélectionnez les raisons pour lesquelles le consentement est retiré pour...',
            withdrawal_withdrawn_at: 'Date de retrait',
            withdrawal_tasks_created: 'Tâches créées',
            withdrawal_affected_bindings: 'Liaisons concernées',
            withdrawal_affected_activities: 'Activités de traitement concernées',
            withdrawal_history: 'Historique des retraits',
        },
        groups: {
            title: 'Groupes de propriétés',
            new: 'Nouveau groupe',
            group_name: 'Groupe Nom',
            member_count: 'Membres',
            no_groups: 'Aucun property groups trouvé',
            policies: 'Politiques',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
        },
        bindings: {
            title: 'Matrice de liaisons',
            property: 'Propriété',
            purpose: 'Finalité',
            legal_basis: 'Base juridique',
            bound: 'Lié',
            no_bindings: 'Aucun bindings trouvé',
            bind_policy: 'Lier la stratégie',
            bulk_bind: 'Liaison en masse',
            bind_policy_to_property: 'Lier la stratégie à la propriété',
            bulk_bind_policy: 'Politique de liaison groupée',
            unbound: 'Non lié',
            policy_id: 'ID de la politique',
            version_placeholder: 'par exemple, 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Liaison',
            property_name: 'Nom de propriété',
            policy_name: 'Nom de politique',
            bindings_list: 'Liste des liaisons',
            binding_actions: {
                start_deploy: 'Démarrer le déploiement',
                mark_deployed: 'Marquer comme déployé',
                rollback: 'Annuler',
            },
        },
        change_requests: {
            title: 'Pipeline de demandes de modification',
            new: 'Nouveau changement demande',
            requester: 'Demandeur',
            change_type: 'Changement Type',
            property: 'Propriété',
            submitted_at: 'Soumis le',
            no_requests: 'Aucun change requests trouvé',
            fetch_pipeline_error: 'Échec de fetch pipeline. Veuillez réessayer.',
            fetch_list_error: 'Échec de fetch change requests. Veuillez réessayer.',
            create_error: 'Échec de create change request. Veuillez réessayer.',
            action_error: 'Échec de perform action. Veuillez réessayer.',
            approver_name: 'Approbateur',
            placeholder_target_props: 'identifiant-prop-1, identifiant-prop-2',
            view_all: 'Tout',
            view_my_properties: 'Mes Propriétés',
            stage_requests: 'Demandes {stage}',
        },
        comparison: {
            title: 'Espace de comparaison',
            select_properties: 'Sélectionnez propriétés à comparer',
            compare: 'Comparer',
            no_comparison: 'Sélectionnez à le moins two propriétés à comparer.',
            fetch_error: 'Échec de fetch comparison reports. Veuillez réessayer.',
            run_error: 'Échec de run comparison. Veuillez réessayer.',
            save_notes_error: 'Échec de save notes. Veuillez réessayer.',
            scan_complete: 'Inconsistency scan terminé avec succès',
            scan_error: 'Échec de run inconsistency scan. Veuillez réessayer.',
            min_two_properties: 'Veuillez fournir au moins 2 ID de propriétés pour la comparaison.',
            view_inconsistencies: 'Voir les incohérences',
            click_to_select: 'Cliquez pour sélectionner deux propriétés ou plus',
            no_properties_available: 'Aucune propriété disponible',
            no_matching_properties: 'Aucune propriété correspondante',
            select_at_least_two_props: 'Sélectionnez au moins deux propriétés dans le menu déroulant.',
            no_differences_found: 'Aucune différence trouvée entre les propriétés sélectionnées.',
            found_inconsistencies: '{count} incohérences trouvées dans {properties} propriétés et {bindings} liaisons.',
        },
        inconsistencies: {
            title: "Liste d'incohérences",
            property: 'Propriété',
            field: 'Champ',
            expected: 'Attendu',
            actual: 'Réel',
            severity: 'Gravité',
            no_inconsistencies: 'Aucun inconsistencies trouvé',
            trend: "Tendance d'incohérence",
            trend_chart_label: 'Graphique de tendance des incohérences montrant les décomptes au fil du temps',
            acknowledge: 'Accuser réception',
            resolve: 'Résoudre',
            suppress: 'Supprimer',
            cr_id_placeholder: 'ID CR',
            view_all: 'Tout',
            view_my_properties: 'Mes Proprietes',
            view_dpo_review: "[[TOK_0]] File d'attente de révision",
            change_request_id_required: 'L’ID de demande de modification est requis pour résoudre cette incohérence.',
        },
        snapshot_schedules: {
            title: "Planifications d'instantanés",
            new: 'Nouveau planification',
            schedule_name: 'Planification Nom',
            frequency: 'Fréquence',
            next_run: 'Suivant Exécuter',
            last_run: 'Dernier Exécuter',
            no_schedules: 'Aucun snapshot schedules trouvé',
            target_type: 'Type de cible',
            target_id: 'ID cible',
            custom_frequency_days: 'Fréquence personnalisée (jours)',
            time_of_day: 'Heure de la journée',
            time: 'Temps',
            retention_days: 'Rétention (jours)',
            execute_now: 'Exécuter maintenant',
            placeholder_days: 'par exemple, 10',
            target_name: 'Nom de la cible',
        },
        golden_templates: {
            title: 'Modèles de référence',
            new: 'Nouveau modèle',
            template_name: 'Modèle Nom',
            property_type: 'Propriété Type',
            no_templates: 'Aucun golden templates trouvé',
            applicable_group_ids: 'ID de groupe applicables (séparés par des virgules)',
            applicable_groups: 'Groupes applicables',
            purposes: 'Objectifs',
            legal_bases: 'Bases juridiques',
            banner_config: 'Configuration de la bannière',
            consent_settings: 'Paramètres de consentement',
            group_ids_placeholder: 'identifiant-groupe-1, identifiant-groupe-2',
            apply_to_property: 'Appliquer à la Propriété',
            apply_to_group: 'Appliquer au Groupe',
            apply_success: 'Modèle appliqué avec succès.',
            applications: 'Historique des applications',
            no_applications: 'Aucune application de modèle pour le moment.',
            no_configuration_details: "Le modèle n'a pas de détails de configuration. Modifiez le modèle pour ajouter des finalités, des bases légales, des paramètres de bannière ou des paramètres de consentement.",
        },
        rollouts: {
            title: 'Déploiements de modèles',
            rollout_status: 'Statut du déploiement',
            confirmed: 'Confirmé',
            pending: 'En attente',
            failed: 'Échoué',
            confirm: 'Confirmer la Propriété',
            confirm_success: 'Propriété confirmée dans le déploiement.',
            can_close: 'Toutes les propriétés confirmées — déploiement terminé',
            cannot_close: 'En attente des confirmations de propriétés',
            no_rollouts: 'Aucun déploiement trouvé.',
            in_progress: 'En cours',
            completed: 'Terminé',
            cancelled: 'Annulé',
            reject: 'Rejeter la Propriété',
            reject_success: 'Propriété rejetée du déploiement.',
            confirm_all: 'Tout Confirmer',
            reject_all: 'Tout Rejeter',
            confirm_label: 'Confirmer le déploiement pour',
            reject_label: 'Rejeter le déploiement pour',
            confirm_all_label: 'Confirmer Tous les Déploiements en Attente',
            reject_all_label: 'Rejeter Tous les Déploiements en Attente',
            no_properties_in_rollout: "Ce déploiement n'a aucune propriété.",
        },
        analytics: {
            title: 'Analyse des propriétés',
            opt_in_rate: "Taux d'adhésion",
            opt_out_rate: 'Taux de refus',
            withdrawal_rate: 'Taux de retrait',
            total_consents: 'Total des consentements',
            total_withdrawals: 'Total des retraits',
            compliance_score: 'Score de conformité',
            non_compliant: 'Propriétés non conformes',
            no_non_compliant: 'Toutes les propriétés sont conformes.',
            threshold: 'Seuil de conformité',
            property_id: 'ID de propriété',
            compliant: 'Conforme',
            non_compliant_status: 'Non conforme',
            compliance_help_summary: 'Comment le score de conformité est-il calculé et comment y remédier ?',
            compliance_help_intro: 'Une propriété est signalée comme non conforme lorsque son score est inférieur à 80 %. Le score est calculé comme suit :',
            compliance_help_with_template_label: 'Si un Golden Template est appliqué :',
            compliance_help_with_template_text: '% de clés de configuration (objectifs, legal_bases, banner_config, consent_settings) qui correspondent exactement au modèle.',
            compliance_help_no_template_label: 'Si aucun Golden Template n’est appliqué :',
            compliance_help_no_template_text: '% de liaisons (types de consentement attribués à la propriété) avec deployment_status = déployé. Une propriété sans liaison est définie par défaut sur 100 %.',
            compliance_help_fix_intro: "Pour supprimer une propriété de cette liste, effectuez l'une des opérations suivantes :",
            compliance_help_fix_deploy_label: 'Déployer ses liaisons',
            compliance_help_fix_deploy_text: "ouvrez la page Binding Matrix et définissez l'état de déploiement de chaque liaison sur déployé.",
            compliance_help_fix_template_label: 'Appliquer un modèle doré',
            compliance_help_fix_template_text: 'utilisez Appliquer au groupe sur le modèle, puis confirmez le déploiement de cette propriété. Assurez-vous que la configuration de la propriété correspond au modèle.',
            compliance_help_fix_decommission_label: 'Mettre la propriété hors service',
            compliance_help_fix_decommission_text: "utilisez le bouton Mettre hors service dans le modal de détail de la propriété s'il n'est plus utilisé.",
            compliance_help_fix_no_bindings_label: 'Supprimer toutes les liaisons',
            compliance_help_fix_no_bindings_text: "si une propriété n'a ni modèle ni liaisons, elle obtient un score de 100 % par défaut.",
        },
        evidence_packs: {
            title: 'Paquets de preuves',
            new: 'Nouveau Pack',
            pack_name: 'Nom du pack',
            properties: 'Propriétés',
            generated_at: 'Généré le',
            no_packs: 'Aucun evidence packs trouvé',
            generate: 'Générer',
            content_type_consent_records: 'Consentement Enregistrements',
            content_type_policy_versions: 'Versions de la politique',
            content_type_binding_history: 'Historique de liaison',
            content_type_change_requests: 'Changement Demandes',
            content_type_inconsistency_reports: "Rapports d'incohérence",
            content_type_snapshot_data: "Données d'instantané",
            content_type_audit_trail: "Piste d'audit",
        },
        audit: {
            title: 'Audit des propriétés de consentement',
            event_type: 'Événement Type',
            entity_type: "Type d'entité",
            entity_id: "ID de l'entité",
            actor: 'Acteur',
            timestamp: 'Horodatage',
            no_events: 'Aucun audit events trouvé',
            entity_type_property: 'Propriété',
            entity_type_group: 'Groupe',
            entity_type_binding: 'Liaison',
            entity_type_change_request: 'Demande de modification',
            entity_type_golden_template: 'Modèle de référence',
            entity_type_snapshot_schedule: 'Planification instantané',
            entity_type_inconsistency: 'Incohérence',
            entity_type_evidence_pack: 'Dossier de preuves',
            action_created: 'Créé',
            action_updated: 'Mis à jour',
            action_deleted: 'Supprimé',
            action_decommissioned: 'Mis hors service',
            action_status_changed: 'Statut modifié',
            action_submitted: 'Soumis',
            action_approved: 'Approuvé',
            action_rejected: 'Rejeté',
            action_deployed: 'Déployé',
            action_rolled_back: 'Annulé',
            action_paused: 'En pause',
            action_resumed: 'Repris',
            action_cancelled: 'Annulé',
            action_acknowledged: 'Acquitté',
            action_resolved: 'Résolu',
            action_suppressed: 'Supprimé',
            action_executed: 'Exécuté',
        },
        property_types: {
            website: 'Site web',
            mobile_app: 'Application mobile',
            ott: 'OTT',
            iot_device: 'Appareil IoT',
            kiosk: 'Kiosque',
            api_service: 'Service API',
            sdk: 'SDK',
        },
        environments: {
            production: 'Fabrication',
            staging: 'Préproduction',
            development: 'Développement',
            testing: 'Test',
        },
        group_types: {
            brand: 'Marque',
            region: 'Région',
            product_line: 'Ligne de produits',
            business_unit: 'Unité commerciale',
            custom: 'Personnalisé',
        },
        target_types: {
            property: 'Propriété',
            group: 'Groupe',
            all: 'Tous',
        },
        frequencies: {
            hourly: 'Toutes les heures',
            daily: 'Quotidien',
            weekly: 'Hebdomadaire',
            monthly: 'Mensuel',
            custom: 'Personnalisé',
        },
        binding_statuses: {
            current: 'Actuel',
            outdated: 'Obsolète',
            pending: 'En attente',
            deploying: 'En déploiement',
            rolled_back: 'Annulé',
        },
        sensitive_categories: {
            health: 'Données de santé',
            biometric: 'Données biométriques',
            genetic: 'Données génétiques',
            racial_ethnic: 'Origine raciale/ethnique',
            political_opinions: 'Opinions politiques',
            religious_beliefs: 'Croyances religieuses',
            trade_union: 'Adhésion syndicale',
            sexual_orientation: 'Orientation sexuelle',
            criminal_records: 'Casier judiciaire',
            financial: 'Données financières',
            children: 'Données sur les enfants',
            geolocation: 'Géolocalisation précise',
        },
        export_csv: 'Exporter CSV',
        exporting: 'Exportation...',
        page_x_of_y: 'Page {page} sur {total}',
        regulatory: {
            capture_method_guidance: "[[TOK_0]] nécessite une preuve de consentement pour correspondre au canal de collecte. Les types de propriétés correspondent aux méthodes de capture du consentement : site Web/OTT = consentement basé sur une bannière, application mobile/SDK = flux de consentement dans l'application, kiosque = capture du consentement physique/à l'écran, service [[TOK_1]] = consentement programmatique, appareil IoT = mécanisme de consentement au niveau de l'appareil.",
            dashboard_metrics_info: "Ce tableau de bord fournit au [[TOK_0]] une vue unique de l'état de consentement sur toutes les propriétés numériques. Les mesures clés incluent : le pourcentage de couverture de liaison (liaisons déployées par rapport au total), l'adhésion au modèle via le widget d'incohérences, les demandes de modification en attente nécessitant un examen et la répartition de l'état des propriétés montrant les propriétés avec des états actifs, inactifs ou mis hors service. Les propriétés comportant des catégories de données sensibles sont suivies via le registre immobilier.",
            change_request_impact_info: "Les demandes de modification affectant les propriétés du consentement doivent documenter l'impact réglementaire : quelles exigences [[TOK_0]] sont concernées, si la modification affecte le traitement des données sensibles (Art. 2.4) et si la modification nécessite un nouveau consentement des personnes concernées. Le résumé d'impact dans chaque demande de modification détaille les références réglementaires [[TOK_1]] pour les éléments probants.",
            outdated_binding_warning: "Les liaisons avec le statut « obsolète » indiquent qu'une propriété exécute une version de stratégie qui n'est pas à jour. Ces propriétés peuvent ne pas refléter les dernières exigences [[TOK_0]] ou les mises à jour des règles de l'organisation. Examinez et mettez à jour rapidement les liaisons obsolètes pour maintenir la conformité [[TOK_1]] dans toutes les propriétés de consentement.",
            template_pdpl_alignment: "Conformément à l'[[TOK_0]] Art. 11, les modèles dorés doivent relier les objectifs aux bases juridiques. Les configurations de bannières doivent appliquer l'opt-in (et non l'opt-out) conformément à l'art. 11.3 consentement explicite. Les modèles doivent spécifier un mécanisme de retrait conformément à l'art. 12. Pour les données sensibles (Art. 2.4), les modèles doivent imposer un consentement écrit explicite ou équivalent – ​​l'acceptation par clic est insuffisante.",
        },
    },
    localization: {
        nav: {
            dashboard: 'Tableau de bord',
            market_packs: 'Packs de marché',
            language_packs: 'Packs linguistiques',
            frameworks: 'Cadres réglementaires',
            mappings: 'Correspondances de modules',
            submissions: 'Soumissions de packs',
            translations: 'Aperçu de la traduction',
            audit: "Piste d'audit",
        },
        dashboard: {
            title: 'Tableau de bord de localisation',
            loading: 'Chargement de dashboard data...',
            active_market_packs: 'Actif Marché Packs',
            published_packs_available: 'Packs marché publiés disponibles',
            language_packs: 'Packs linguistiques',
            total_language_packs: 'Total de packs linguistiques enregistrés',
            active_regulatory_frameworks: 'Actif Regulatory Cadres',
            frameworks_active: 'Cadres avec statut actif',
            pending_pack_submissions: 'Soumissions de packs en attente',
            submissions_awaiting_review: 'Soumissions en attente de révision',
            recent_audit_events: 'Récent Audit Événements',
            no_recent_audit: "Aucun événement d'audit récent.",
            event_type: 'Événement Type',
            entity_type: "Type d'entité",
            entity_id: "ID de l'entité",
            actor: 'Acteur',
            timestamp: 'Horodatage',
        },
        market_packs: {
            title: 'Catalogue de packs de marché',
            new: 'Nouveau Market Pack',
            pack_name: 'Nom du pack',
            market: 'Marché',
            locale: 'Langue',
            no_packs: 'Aucun market packs trouvé',
        },
        language_packs: {
            title: 'Packs linguistiques',
            new: 'Nouveau Language Pack',
            language: 'Langue',
            locale_code: 'Code de langue',
            completeness: 'Complétude',
            completeness_detail: "Détail de l'exhaustivité",
            overall_completeness: 'exhaustivité globale',
            total_keys: 'Clés totales',
            translated_keys: 'Clés traduites',
            missing_keys: 'Clés manquantes',
            namespace_breakdown: "Répartition de l'espace de noms",
            namespace: 'Espace de noms',
            translated: 'Traduit',
            no_packs: 'Aucun language packs trouvé',
            install_language_pack: 'Installer le pack de langue',
            available_packs: 'Packs de langue disponibles',
            install: 'Installer',
            all_installed: 'Tous les packs de langue sont déjà installés.',
            install_success: 'Pack de langue installé avec succès.',
            market: 'Marché',
            featured: 'En vedette',
        },
        frameworks: {
            title: 'Cadres réglementaires',
            new: 'Nouveau cadre',
            framework_name: 'Cadre Nom',
            jurisdiction: 'Juridiction',
            effective_date: "Date d'effet",
            no_frameworks: 'Aucun regulatory frameworks trouvé',
            view_requirements: 'Voir les exigences',
            hide_requirements: 'Masquer les exigences',
            show_legacy: 'Afficher les cadres réglementaires anciens',
            effective_until: "En vigueur jusqu'au",
            effective_on: 'En vigueur à partir du',
            replaced_by: 'Remplacé par',
            replaces_label: 'Remplace',
            status_legacy: 'Ancien',
            status_upcoming: 'À venir',
            watchlist: 'Liste de surveillance',
            watchlist_empty: 'Aucun projet ou cadre à venir',
            watchlist_empty_desc: 'Les frameworks avec le statut « projet » ou « à venir » apparaîtront ici pour être surveillés.',
            expected_effective: 'Efficacité attendue',
            effective_date_tbd: "Date d'entrée en vigueur : à déterminer",
            activate: 'Activer',
            ai_law_title: 'Loi vietnamienne [[TOK_0]]',
            ai_risk_classification: '[[TOK_0]] Classification des risques',
            ai_system_dossier: '[[TOK_0]] Dossier système',
            ai_labeling_checklist: '[[TOK_0]] Étiquetage et divulgation',
            ai_incident_report: "[[TOK_0]] Rapport d'incident",
            ai_impact_assessment: "[[TOK_0]] Évaluation d'impact",
            ai_sandbox_application: 'Application bac à sable',
            ai_sandbox_monitoring: 'Surveillance du bac à sable',
            ai_sandbox_completion: 'Achèvement du bac à sable',
            ai_submission_tracker: 'Suivi des soumissions',
            ai_evidence_capture: 'Capture de preuves',
            risk_level_minimal: 'Risque minimal',
            risk_level_limited: 'Risque limité',
            risk_level_high: 'Risque élevé',
            risk_level_unacceptable: 'Risque inacceptable',
            submission_status_draft: 'Brouillon',
            submission_status_submitted: 'Soumis',
            submission_status_returned: 'Renvoyé pour modification',
            submission_status_accepted: 'Accepté',
            submission_status_rejected: 'Rejeté',
            submission_status_closed: 'Fermé',
            ecommerce_law_title: 'Loi vietnamienne sur le commerce électronique',
            ecommerce_platform_classification: 'Classification des plateformes',
            ecommerce_seller_register: 'Registre des vendeurs',
            ecommerce_complaint_register: 'Registre des plaintes',
            ecommerce_takedown_register: 'Registre de retrait',
            ecommerce_submission_tracking: 'Suivi des soumissions',
            ecommerce_dossier_checklist: 'Liste de contrôle des dossiers',
            ecommerce_cross_border: 'Conformité transfrontalière',
            ecommerce_trustmark: 'Programme de marque de confiance',
            ecommerce_notification: 'Notification',
            ecommerce_registration: 'Inscription',
            ecommerce_termination: 'Résiliation',
            ecommerce_reporting_readiness: 'Préparation aux rapports',
            ecommerce_evidence_capture: 'Capture de preuves',
            submission_status_approved: 'Approuvé',
            cybersec_law_2025_title: 'Loi vietnamienne sur la cybersécurité (2025)',
            cybersec_system_classification: 'Classification du système',
            cybersec_risk_assessment: 'Évaluation des risques',
            cybersec_incident_report: "Rapport d'incident",
            cybersec_authority_cooperation: 'Coopération entre autorités',
            cybersec_data_localization: 'Localisation des données',
            cybersec_vendor_security: 'Sécurité des fournisseurs',
            cybersec_submission_tracker: 'Suivi des soumissions',
            cybersec_evidence_capture: 'Capture de preuves',
            cybersec_dossier_checklist: 'Liste de contrôle des dossiers',
            cybersec_classification_general: 'Général',
            cybersec_classification_important: 'Important',
            cybersec_classification_critical: 'Critique',
            data_law_title: 'Loi vietnamienne sur les données',
            data_inventory: 'Inventaire des données',
            data_classification: 'Classification des données',
            data_sharing: 'Partage de données',
            data_governance: 'Gouvernance des données',
            data_submission_tracker: 'Suivi des soumissions',
            data_evidence_capture: 'Capture de preuves',
            data_dossier_checklist: 'Liste de contrôle des dossiers',
            telecom_law_title: 'Loi vietnamienne sur les télécommunications',
            telecom_authority_request: "Demande d'autorisation",
            telecom_disclosure: 'Divulgation',
            telecom_confidentiality: 'Confidentialité',
            telecom_submission_tracker: 'Suivi des soumissions',
            telecom_evidence_capture: 'Capture de preuves',
            telecom_dossier_checklist: 'Liste de contrôle des dossiers',
            pdpl_law_title: 'Loi vietnamienne sur la protection des données personnelles',
            pdpl_breach_notification: 'Notification de violation',
            pdpl_dpo_notification: '[[TOK_0]] Notification de rendez-vous',
            pdpl_data_subject_notification: 'Notification de la personne concernée',
            pdpl_submission_tracker: 'Suivi des soumissions',
            pdpl_evidence_capture: 'Capture de preuves',
            pdpl_dossier_checklist: 'Liste de contrôle des dossiers',
            pdpl_authority_filing: "Dépôt d'autorité",
            pdpl_mops_filing: 'Dépôt MoPS',
        },
        mappings: {
            title: 'Correspondances de modules',
            new: 'Nouveau correspondance',
            module: 'Composant',
            market_pack: 'Pack marché',
            mapping_status: 'Correspondance Statut',
            no_mappings: 'Aucun module correspondances trouvé',
            incomplete_entries_warning: "{count} correspondance(s) masquée(s) en raison d'un ID de cadre, d'un ID d'exigence ou d'un module manquant.",
        },
        submissions: {
            title: 'Soumissions de packs',
            new: 'Nouveau Submission',
            submitter: 'Soumetteur',
            pack: 'Lot',
            submitted_at: 'Soumis le',
            no_submissions: 'Aucun pack submissions trouvé',
            installed_sector_overlays_title: 'Sector Overlays ({count}) [FR]',
            installed_sector_overlays_aria: 'Installed Sector Overlays [FR]',
            installed_col_name: 'Name [FR]',
            installed_col_code: 'Code [FR]',
            installed_col_sector: 'Sector [FR]',
            installed_col_mode: 'Mode [FR]',
            installed_col_status: 'Status [FR]',
            installed_refresh: 'Refresh [FR]',
        },
        translations: {
            title: 'Aperçu de la traduction',
            select_locale: 'Sélectionnez Locale',
            select_module: 'Sélectionnez Module',
            key: 'Key',
            value: 'Valeur',
            no_translations: 'Aucun translations trouvé',
        },
        audit: {
            title: "Piste d'audit de localisation",
            event_type: 'Événement Type',
            entity_type: "Type d'entité",
            entity_id: "ID de l'entité",
            entity_name: "Nom de l'entité",
            actor: 'Acteur',
            timestamp: 'Horodatage',
            payload: 'Charge utile',
            collapse_payload: 'Réduire les détails de la charge',
            expand_payload: 'Développer les détails de la charge',
            collapse: 'Réduire',
            expand: 'Développer',
            all_entity_types: "Tous les types d'entité",
            no_events: 'Aucun audit events trouvé',
        },
        market_packs_detail: {
            installed_at: 'Installé le',
            pack_details_label: 'Détails du pack',
            market_code: 'Code marché',
            supported_locales: 'Langues prises en charge',
            min_platform_version: 'Version minimale de la plateforme',
            pack_information: 'Information du pack',
            pack_contents: 'Contenu du pack',
            included_frameworks: 'Cadres inclus',
            pack_artifacts: 'Artefacts du pack',
            no_artifacts: 'Aucun artefact trouvé pour ce pack',
            pack_not_found: 'Pack introuvable',
        },
        mappings_form: {
            framework_id: 'ID du cadre',
            requirement_id: "ID de l'exigence",
            module_label: 'Module',
            mapping_type: 'Type de mappage',
            configuration_json: 'Configuration ([[TOK_0]])',
            conflict_resolution: 'Résolution de conflit',
            is_override: 'Est une surcharge',
            all_modules: 'Tous les modules',
            all_mapping_types: 'Tous les types de mappage',
        },
        submissions_detail: {
            submission_id: 'ID de soumission',
            validation: 'Validation',
            reviewers: 'Réviseurs',
            start_review: 'Démarrer la revue',
            hide_comments: 'Masquer les commentaires',
            review_comments: 'Commentaires de revue',
            loading_comments: 'Chargement des commentaires...',
            no_comments: 'Pas encore de commentaires.',
            add_comment: 'Ajouter un commentaire',
            reject_submission: 'Rejeter la soumission',
            reason_for_rejection: 'Motif du rejet',
            reviewer_ids: 'IDs des réviseurs (séparés par des virgules)',
            submit_new_pack: 'Soumettre un nouveau pack',
            pack_type: 'Type de pack',
            market_code: 'Code marché',
            target_locales: 'Langues cibles',
            pack_file: 'Fichier du pack',
            pack_format_info: "Format du pack : les packs de marché doivent inclure des fichiers [[TOK_0]] spécifiques aux paramètres régionaux avec des traductions d'espace de noms/clés. Les modules linguistiques doivent fournir des traductions pour les paramètres régionaux cibles spécifiés. Voir la documentation pour le schéma détaillé.",
            accepted_formats: 'Formats acceptés : .json ou .zip. Les fichiers [[TOK_0]] doivent contenir un objet plat ou avec un espace de noms de paires clé-valeur de traduction. Les fichiers ZIP doivent contenir un ou plusieurs fichiers de paramètres régionaux [[TOK_1]].',
            comma_separated_locales: 'Codes de langue séparés par des virgules pour ce pack linguistique',
            confirm_approval: "Confirmer l'approbation",
            approve_message: 'Approuver cette soumission de pack ?',
            submission_label: 'Soumission',
            all_pack_types: 'Tous les types de pack',
            passed: 'réussi',
            failed_label: 'échoué',
            market_code_required: 'Le code marché est requis',
            version_required: 'La version est requise',
            pack_type_regulatory: 'Réglementaire',
            framework_code: 'Code du cadre',
            jurisdiction_code: 'Code de juridiction',
            pack_source: 'Origine',
            pack_source_manual: 'Manuel',
            pack_version: 'Version du paquet',
            install_regulatory_pack: 'Installer le paquet réglementaire',
            regulatory_pack_desc: 'Téléverser un paquet de cadre réglementaire (.zip)',
            framework_required: 'Le code du cadre réglementaire est requis',
            jurisdiction_required: 'Le code de juridiction est requis',
        },
        catalog_detail: {
            packs_installed_of: 'sur {total} packs installés',
            install_all: 'Tout installer',
            installing: 'Installation en cours...',
            removing: 'Suppression...',
            requires: 'Nécessite',
            tab_catalog: 'Catalogue',
            tab_installed: 'Installé',
            details: 'Détails',
        },
        translations_detail: {
            source_locale: 'Langue source',
            target_locale: 'Langue cible',
            locales_must_differ: 'Les langues source et cible doivent être différentes.',
            all_keys_translated: 'Toutes les clés traduites',
            keys_missing: '[[TOK_1]] clé(s) manquante(s)',
            show_missing_only: 'Afficher uniquement les manquants',
            namespace: 'Espace de noms',
            source: 'Origine',
            target: 'Cible',
        },
        frameworks_detail: {
            tab_frameworks: 'Cadres',
            tab_watchlist: 'Liste de surveillance',
            authority: 'Autorité',
            requirements_count: 'Exigences',
            all_types: 'Tous les types',
            collapse_all: 'Tout réduire',
            expand_all: 'Tout développer',
            filtered_to: 'Filtré à',
            clear_filter: 'Effacer le filtre',
            no_requirements: 'Aucune exigence trouvée pour ce cadre.',
            requirements_label: 'Exigences',
            status_updated: 'Statut mis à jour avec succès',
            overview_tab: 'Aperçu',
            forms_tab: 'Formulaires',
            procedures_tab: 'Procédures',
            fines_risks_tab: 'Amendes et risques',
            deadlines_tab: 'Délais',
            guidance_tab: 'Conseils',
            guidance_empty: "Aucun contenu d'orientation pour ce cadre.",
            guidance_loading: 'Guide de chargement…',
            guidance_section: "Section d'orientation",
            guidance_view: 'Afficher les conseils',
            guidance_map_to_workflow: 'Mapper au flux de travail',
            guidance_link_evidence: 'Lien vers les preuves',
            guidance_filter_type: 'Tapez',
            guidance_filter_category: 'Catégorie',
            guidance_filter_module: 'Module',
            guidance_filter_status: 'Statut',
            guidance_filter_search: 'Guide de recherche',
            guidance_filter_all: 'Tout',
            guidance_table_reference: 'Référence',
            guidance_table_name: 'Nom du guide',
            guidance_table_type: 'Tapez',
            guidance_table_category: 'Catégorie',
            guidance_table_effective_date: "Date d'entrée en vigueur",
            guidance_table_modules: 'Modules associés',
            guidance_table_actions: 'Actions',
            guidance_reference_only_banner: "Référence uniquement : s'applique au secteur {[[TOK_1]]} mais pas à votre organisation.",
            guidance_related_link: 'Conseils connexes',
            deadlines_empty: 'Aucun délai réglementaire trouvé pour ce cadre.',
            deadlines_sla_type: 'Type de SLA',
            deadlines_value: 'Délai',
            deadlines_unit: 'Unité',
            deadlines_extension: 'Rallonge',
            deadlines_reference: 'Référence juridique',
            framework_stack: 'Structure du cadre',
            layer_parent_law: 'Loi principale',
            layer_implementing_decree: "Décret d'application",
            layer_enforcement_decree: 'Décret de sanctions',
            layer_admin_procedures: 'Procédures administratives',
            status_active: 'Actif',
            status_draft: 'Projet',
            draft_enforcement_badge: 'Projet — pas encore promulgué',
            effective_date: "Date d'entrée en vigueur",
            forms_table_id: 'ID formulaire',
            forms_table_name: 'Nom',
            forms_table_source: 'Source',
            forms_table_category: 'Catégorie',
            forms_table_type: 'Tapez',
            fill_form: 'Remplir le formulaire',
            view_reference: 'Voir la référence',
            forms_official: 'Officiel',
            forms_internal: 'Interne',
            forms_empty: 'Aucun formulaire trouvé pour ce cadre.',
            forms_loading: 'Chargement des formulaires...',
            filter_by_source_layer: 'Filtrer par couche source',
            all_layers: 'Tous les calques',
            procedures_id: 'ID procédure',
            procedures_name: 'Procédure',
            procedures_trigger: 'Déclencheur',
            procedures_steps: 'Étapes',
            procedures_outputs: 'Résultats',
            procedures_related_forms: 'Formulaires associés',
            procedures_submission_channels: 'Canaux de soumission',
            procedures_empty: 'Aucune procédure trouvée pour ce cadre.',
            fines_area: "Zone d'infraction",
            fines_articles: 'Articles projet',
            fines_individual: 'Amende (individuel)',
            fines_organization: 'Amende (organisation)',
            fines_revenue: "Escalade sur le chiffre d'affaires",
            fines_deadlines: 'Délais',
            fines_remediation: 'Mesures correctives',
            fines_related: 'Procédures associées',
            fines_empty: 'Aucune donnée de sanctions disponible pour ce cadre.',
            fines_enforcement_pending: "Cadre de sanctions non encore publié. Les données de sanctions seront ajoutées lors de la promulgation de l'instrument d'application.",
            view_details: 'Voir les détails',
            back_to_list: 'Retour à la liste',
            description: 'Descriptif',
            jurisdiction: 'Juridiction',
            lineage: 'Filiation',
            replaces: 'Remplace',
            replaced_by: 'Remplacé par',
            requirements: 'Exigences',
            tab_navigation: 'Onglets de détail du cadre',
            forms_table_actions: 'Actions',
            create_form: 'Créer un formulaire',
            mark_promulgated: 'Marquer comme promulgué',
            status_promulgated: 'Promulgué',
            promulgated_success: 'Statut de la couche mis à jour en promulgué',
            transition_review: 'Revue de transition',
            transition_review_desc: "Ce cadre a une revue de transition en attente pour l'adoption de la loi successeur.",
            transition_review_by: 'Date limite de revue',
            transition_review_status: 'Statut de la revue',
            transition_review_notes: 'Remarques',
            transition_review_pending: 'En attente',
            transition_review_in_progress: 'En cours',
            transition_review_completed: 'Terminée',
            transition_review_successor: 'Cadre successeur',
            transition_review_lead_time: 'Délai de préparation',
            transition_review_lead_time_days: "{days} jours avant la date d'entrée en vigueur",
            transition_review_forms_heading: 'Revues de transition des formulaires',
            transition_review_forms_desc: 'Vérifiez la pertinence de chaque modèle opérationnel dans le cadre successeur.',
            transition_review_outcome: 'Résultat',
            transition_review_outcome_carry_forward: 'Conserver',
            transition_review_outcome_carry_forward_revised: 'Conserver (révisé)',
            transition_review_outcome_retire: 'Retirer',
            transition_review_outcome_split: 'Scinder',
            transition_review_outcome_awaiting_decree: 'En attente de décret',
            transition_review_no_forms: 'Aucune revue de transition de formulaire configurée.',
            transition_review_update_success: 'Revue de transition mise à jour avec succès',
            transition_review_operational_note: "Ce sont des modèles opérationnels de soutien aux processus, pas des décomptes de formulaires réglementaires. L'attribution juridique reste au cadre ancien jusqu'à l'entrée en vigueur de la loi successeur.",
            rights_tab: 'Droits',
            rights_empty: 'Aucun droit des personnes concernées défini pour ce cadre.',
            rights_code: 'Coder',
            rights_name: 'Droit',
            rights_legal_basis: 'Base juridique',
            rights_elaborating_articles: 'Articles détaillés',
            rights_description: 'Descriptif',
            requirements_reference: 'Référence',
            requirements_mandatory: 'Obligatoire',
            requirements_yes: 'Yes',
            requirements_no: 'No',
            requirements_source: 'Origine',
            category_legal_basis: 'Base juridique',
            category_data_subject_rights: 'Droits des personnes concernées',
            category_notification: 'Notification',
            category_assessment: 'Évaluation',
            category_governance: 'Gouvernance',
            category_record_keeping: 'Tenue de registres',
            category_cross_border: 'Transfrontalier',
            category_technical_measures: 'Mesures techniques',
            category_incident_reporting: "Rapport d'incident",
            category_risk_management: 'Gestion des risques',
            category_supply_chain: "Chaîne d'approvisionnement",
            category_certification: 'Attestation',
            child_frameworks: '[[TOK_1]] framework enfant',
            child_frameworks_plural: '[[TOK_1]] frameworks enfants',
            replaces_prefix: 'Remplace :',
            replaced_by_prefix: 'Remplacé par :',
            responsible_prefix: 'Responsable :',
            watchlist_empty_hint: 'Les frameworks avec le statut « projet » ou « à venir » apparaîtront ici pour être surveillés.',
            framework_count: 'Cadre [[TOK_1]]',
            framework_count_plural: '[[TOK_1]] cadres',
            hiding_legacy: "(cachant l'héritage de [[TOK_1]])",
            label_VN_PDPL: '[[TOK_0]] (Décret 13/2023)',
            label_VN_PDPD_DECREE_13: 'Décret PDPD 13/2023',
            label_VN_PDPL_LAW_2025: '[[TOK_0]] Loi 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Décret [[TOK_0]]',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: "[[TOK_0]] Projet d'application 2026",
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'NQ22 Temporary Overlay 2026',
            label_VN_DATA_LAW: 'Loi sur les données',
            label_VN_DATA_LAW_DECREE_165_2025: 'Décret-loi sur les données 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Bourses de données Draft 2026',
            label_VN_TELECOM_LAW_2023: 'Loi sur les télécommunications 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Décret Télécom 163/2024',
            label_VN_CYBERSEC_LAW: 'Loi Cybersécurité (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Décret Cybersec 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Loi sur la cybersécurité 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'Loi sur le commerce électronique 122/2025',
            label_VN_AI_LAW_2026: '[[TOK_0]] Loi 2026',
            label_VN_AI_DECREE_142_2026: '[[TOK_0]] Decree 142/2026/NĐ-CP',
            issuer_company: 'Entreprise',
            issuer_authority_a05_mps: 'MPS/A05',
            issuer_authority_mic: 'MIC',
            issuer_authority_mps_ndc: 'MPS/NDC',
            issuer_other_authority: 'Autorité',
            sla_type_rights_request_ack: 'Accusé de réception de la demande de droits',
            'sla_type_Access control review': "Révision du contrôle d'accès",
            'sla_type_Annual governance attestation': 'Attestation annuelle de gouvernance',
            'sla_type_Audit review cycle': "Cycle d'examen des audits",
            'sla_type_Authority request response': "Réponse à la demande d'autorité",
            'sla_type_Change notification processing': 'Traitement des notifications de modification',
            'sla_type_Complaint acknowledgment': 'Accusé de réception de la plainte',
            'sla_type_Complaint resolution': 'Résolution des plaintes',
            'sla_type_Confidentiality policy review': 'Examen de la politique de confidentialité',
            'sla_type_Cybersecurity incident full report': 'Rapport complet sur les incidents de cybersécurité',
            'sla_type_Cybersecurity incident initial report': "Rapport initial d'incident de cybersécurité",
            'sla_type_Data inventory review': "Examen de l'inventaire des données",
            'sla_type_Disclosure log review cycle': 'Cycle d’examen du journal de divulgation',
            'sla_type_Incident classification decision': "Décision de classification de l'incident",
            'sla_type_Information system classification review': "Revue de la classification des systèmes d'information",
            'sla_type_Notification processing (sales website/app)': 'Traitement des notifications (site/application de vente)',
            'sla_type_Pen test cycle': 'Cycle de test du stylet',
            'sla_type_Registration processing (service platform)': 'Traitement des inscriptions (plateforme de services)',
            'sla_type_Risk assessment cycle': "Cycle d'évaluation des risques",
            'sla_type_Takedown decision (after review)': 'Décision de retrait (après examen)',
            'sla_type_Termination notice (public)': 'Avis de résiliation (public)',
            sla_type_ai_impact_assessment_completion: "[[TOK_0]] achèvement de l'évaluation d'impact",
            sla_type_ai_sandbox_application_review: "[[TOK_0]] examen de l'application sandbox",
            sla_type_ai_serious_incident_report: "[[TOK_0]] rapport d'incident grave",
            sla_type_ai_system_registration: 'Enregistrement du système [[TOK_0]]',
            sla_type_authority_request_response: "Réponse à la demande d'autorité",
            sla_type_certificate_issuance_review: 'Examen de la délivrance du certificat',
            sla_type_complaint_handling_approach_notice: 'Avis d’approche de traitement des plaintes',
            sla_type_complaint_incomplete_info_request: "Réclamation demande d'informations incomplète",
            sla_type_data_governance_attestation: 'Attestation de gouvernance des données',
            sla_type_dsr_acknowledgment: 'Accusé de réception DSR',
            sla_type_dsr_cl2_withdraw_restrict_object: 'DSR (Cl.2) — Retirer/restreindre/objecter',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'DSR (Cl.2) — Tiers',
            sla_type_dsr_cl3_access_correct_provide: 'DSR (Cl.3) — Accéder / corriger / fournir',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'DSR (Cl.3) — Tiers',
            sla_type_dsr_cl4_deletion: 'DSR (Cl.4) — Suppression',
            sla_type_dsr_cl4_deletion_third_party: 'DSR (Cl.4) — Suppression, tiers',
            sla_type_dsr_cl5_protective_measures: 'DSR (Cl.5) — Mesures de protection',
            sla_type_telecom_authority_request_response: "Réponse à la demande de l'autorité des télécommunications",
            sla_type_rights_request_completion: 'Finalisation de la demande de droits',
            sla_type_incident_authority_notification: "Notification à l'autorité d'incident",
            sla_type_incident_subject_notification: "Notification du sujet de l'incident",
            sla_type_dpia_completion: '[[TOK_0]] achèvement',
            sla_type_data_retention_review: 'Examen de la conservation des données',
            sla_type_authority_filing_review: "Examen du dépôt d'autorisation",
            sla_type_authority_supplement_response: 'Réponse au supplément d’autorité',
            sla_type_authority_resubmission: "Nouvelle soumission à l'autorité",
            sla_type_authority_filing_supplement_response: "Réponse supplémentaire au dépôt d'autorité",
            sla_type_authority_filing_resubmission: "Nouvelle soumission de la demande d'autorisation",
            unit_working_days: 'jours ouvrables',
            unit_calendar_days: 'jours calendaires',
            unit_hours: 'heures',
            form_category_dpa: 'DPA',
            form_category_dsr: 'DSR',
            form_category_consent: 'Consentement',
            form_category_privacy: 'Confidentialité',
            form_category_breach: 'Violation',
            form_category_dpia: '[[TOK_0]]',
            form_category_register: "S'inscrire",
            form_category_monitoring: 'Surveillance',
            form_category_vendor: 'Vendeur',
            form_category_org: 'Organisationnel',
            form_category_sector: 'Secteur',
            form_category_data_mapping: 'Cartographie des données',
            form_category_governance: 'Gouvernance',
            form_category_incident: 'Incident',
            form_category_authority_submission: "Soumission à l'autorité",
            form_category_notice: 'Avis',
            form_category_assessment_report: "Rapport d'évaluation",
            form_category_request: 'Demande',
            form_category_dossier: 'Dossier',
            form_category_filing: 'Dépôt',
            module_consent: 'Consentement',
            module_rights_request: 'Demande de droits',
            module_classification: 'Classement',
            module_dpia: '[[TOK_0]]',
            module_governance: 'Gouvernance',
            module_monitoring: 'Surveillance',
            module_register: "S'inscrire",
            module_risk: 'Risque',
            module_data_mapping: 'Cartographie des données',
            module_incident: 'Incident',
            module_assessment: 'Évaluation',
            module_vendor: 'Vendeur',
            module_policy: 'Politique',
            module_audit: 'Vérification',
            module_training: 'Formation',
            module_discovery: 'Découverte',
            enum_guidance_type_calculation_guidance: 'Guide de calcul',
            enum_guidance_type_implementation_guidance: 'Conseils de mise en œuvre',
            enum_guidance_type_interpretive_note: 'Note interprétative',
            enum_guidance_type_legal_guidance: 'Conseils juridiques',
            enum_guidance_type_procedural_guidance: 'Conseils procéduraux',
            enum_guidance_type_sector_guidance: 'Orientation sectorielle',
            enum_guidance_type_technical_methodology: 'Méthodologie technique',
            enum_guidance_category_annual_reporting: 'Rapport annuel',
            enum_guidance_category_authority_cooperation: 'Coopération entre autorités',
            enum_guidance_category_authority_coordination: 'Coordination des autorités',
            enum_guidance_category_business_continuity: 'Continuité des activités',
            enum_guidance_category_capital_adequacy: 'Adéquation du capital',
            enum_guidance_category_complaint_handling: 'Traitement des plaintes',
            enum_guidance_category_consent: 'Consentement',
            enum_guidance_category_consent_management: 'Gestion du consentement',
            enum_guidance_category_consumer_protection: 'Protection des consommateurs',
            enum_guidance_category_control_environment: 'Environnement de contrôle',
            enum_guidance_category_cross_border: 'Transfrontalier',
            enum_guidance_category_cross_border_transfers: 'Virements transfrontaliers',
            enum_guidance_category_data_classification: 'Classification des données',
            enum_guidance_category_data_localization: 'Localisation des données',
            enum_guidance_category_data_protection_impact_assessment: "Analyse d'impact sur la protection des données",
            enum_guidance_category_direct_marketing: 'Marketing direct',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Gouvernance',
            enum_guidance_category_ict_risk_management: 'Gestion des risques TIC',
            enum_guidance_category_incident_management: 'Gestion des incidents',
            enum_guidance_category_internal_audit: 'Audit interne',
            enum_guidance_category_isms_documentation: 'Documentation SMSI',
            enum_guidance_category_lawful_basis: 'Base légale',
            enum_guidance_category_licensing: 'Licence',
            enum_guidance_category_local_presence: 'Présence locale',
            enum_guidance_category_logging_and_retention: 'Journalisation et conservation',
            enum_guidance_category_logical_and_physical_access: 'Accès logique et physique',
            enum_guidance_category_operational_resilience_testing: 'Tests de résilience opérationnelle',
            enum_guidance_category_outsourcing: 'Externalisation',
            enum_guidance_category_platform_registration: 'Inscription à la plateforme',
            enum_guidance_category_quality_of_service: 'Qualité de service',
            enum_guidance_category_risk_classification: 'Classification des risques',
            enum_guidance_category_risk_management: 'Gestion des risques',
            enum_guidance_category_scope_definition: 'Définition de la portée',
            enum_guidance_category_sectoral_localisation: 'Localisation sectorielle',
            enum_guidance_category_subscriber_protection: 'Protection des abonnés',
            enum_guidance_category_supply_chain: "Chaîne d'approvisionnement",
            enum_guidance_category_system_classification: 'Classification du système',
            enum_guidance_category_system_operations: 'Opérations du système',
            enum_guidance_category_telecommunications_data: 'Données de télécommunications',
            enum_guidance_category_third_party_risk: 'Risque de tiers',
            enum_guidance_category_transitional_provisions: 'Dispositions transitoires',
            enum_guidance_category_vulnerability_management: 'Gestion des vulnérabilités',
            enum_guidance_status_active: 'Actif',
            enum_guidance_status_draft: 'Brouillon',
            enum_module_access_management: 'Gestion des accès',
            enum_module_ai_governance: '[[TOK_0]] Gouvernance',
            enum_module_asset_management: 'Gestion des actifs',
            enum_module_audit_trail: "Piste d'audit",
            enum_module_breach_notification: 'Notification de violation',
            enum_module_capital_adequacy: 'Adéquation du capital',
            enum_module_classification: 'Classement',
            enum_module_consent: 'Consentement',
            enum_module_consent_management: 'Gestion du consentement',
            enum_module_cross_border_transfers: 'Virements transfrontaliers',
            enum_module_data_localization: 'Localisation des données',
            enum_module_data_mapping: 'Cartographie des données',
            enum_module_data_protection: 'Protection des données',
            enum_module_data_subject_rights: 'Droits des personnes concernées',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Cryptage',
            enum_module_governance: 'Gouvernance',
            enum_module_incident: 'Incident',
            enum_module_incident_management: 'Gestion des incidents',
            enum_module_internal_audit: 'Audit interne',
            enum_module_isms_documentation: 'Documentation SMSI',
            enum_module_isms_governance: 'Gouvernance du SMSI',
            enum_module_logging_and_monitoring: 'Journalisation et surveillance',
            enum_module_monitoring: 'Surveillance',
            enum_module_policy_management: 'Gestion des politiques',
            enum_module_risk: 'Risque',
            enum_module_risk_management: 'Gestion des risques',
            enum_module_training: 'Formation',
            enum_module_vendor: 'Vendeur',
            enum_module_vendor_management: 'Gestion des fournisseurs',
            enum_module_vendor_risk: 'Risque du fournisseur',
            enum_module_vulnerability_management: 'Gestion des vulnérabilités',
            category_access: 'Accès',
            category_availability: 'Disponibilité',
            category_change_management: 'Gestion du changement',
            category_classification: 'Classement',
            category_communication_and_information: 'Communication et informations',
            category_compliance: 'Conformité',
            category_confidentiality: 'Confidentialité',
            category_control_activities: 'Activités de contrôle',
            category_control_environment: 'Environnement de contrôle',
            category_incident: 'Incident',
            category_internal_audit: 'Audit interne',
            category_internal_control: 'Contrôle interne',
            category_logical_and_physical_access: 'Accès logique et physique',
            category_mis_data: 'Données du système d’information de gestion',
            category_monitoring: 'Surveillance',
            category_monitoring_activities: 'Activités de surveillance',
            category_outsourcing: 'Externalisation',
            category_privacy: 'Confidentialité',
            category_processing_integrity: 'Intégrité du traitement',
            category_reporting: 'Rapports',
            category_risk_assessment: 'Évaluation des risques',
            category_risk_mitigation: 'Atténuation des risques',
            category_sector_applicability: 'Applicabilité sectorielle',
            category_system_operations: 'Opérations du système',
            category_training: 'Formation',
            category_vendor: 'Vendeur',
            guidance_related_forms_advisory: 'Certains formulaires comportent des conseils connexes – voir dans le',
            guidance_related_procedures_advisory: "Certaines procédures sont accompagnées d'instructions connexes — voir dans le",
            guidance_related_requirements_advisory: "Certaines exigences sont accompagnées d'orientations associées – voir dans le",
        },
        channels: {
            title: 'Canaux de soumission et échéances',
            channels: 'Canaux de soumission',
            add_channel: 'Ajouter un canal',
            channel_type: 'Tapez',
            name: 'Nom',
            instructions: 'Instructions',
            active: 'Actif',
            no_channels: 'Aucun canal de soumission configuré',
            portal: 'Portail',
            in_person: 'En personne',
            postal: 'Poste',
            email: 'E-mail',
            add: 'Ajouter',
            deadlines: 'Échéances réglementaires',
            add_deadline: 'Ajouter une échéance',
            label: 'Libellé',
            days: 'Jours',
            day_type: 'Type de jour',
            calendar_days: 'Jours calendaires',
            working_days: 'Jours ouvrables',
            no_deadlines: 'Aucune échéance configurée',
            description: 'Descriptif',
            failed_load: 'Échec de load channel data',
            channel_added: 'Canal ajouté',
            channel_added_announce: 'Canal de soumission ajouté',
            failed_add_channel: 'Échec de add channel',
            deadline_added: 'Échéance ajoutée',
            deadline_added_announce: 'Échéance réglementaire ajoutée',
            failed_add_deadline: 'Échec de add deadline',
        },
        module_links: {
            title: 'Liaison du cadre',
            modules: 'Modules liés',
            add_module: 'Ajouter un module',
            module_code: 'Code du module',
            required: 'Requis',
            link: 'Lier',
            no_modules: 'Aucun module lié',
            notes: 'Remarques',
            personas: 'Personas liés',
            add_persona: 'Ajouter un persona',
            persona_id: 'ID du persona',
            role_description: 'Description du rôle',
            no_personas: 'Aucun persona lié',
            failed_load: 'Échec de load framework links',
            module_linked: 'Module lié',
            module_linked_announce: 'Module lié avec succès',
            failed_link_module: 'Échec de link module',
            persona_linked: 'Persona lié',
            persona_linked_announce: 'Persona lié avec succès',
            failed_link_persona: 'Échec de link persona',
        },
        regulatory_updates: {
            statuses: {
                pending: 'En attente',
                assessed: 'Évalué',
                applied: 'Appliqué',
                dismissed: 'Rejeté',
            },
            title: 'Mises à jour réglementaires et tableau de bord du cadre',
            page_description: 'Coverage at a glance for every installed regulatory framework, plus the in-product change log of regulatory updates: amendments, effective dates, and impact assessments. [FR]',
            coverage_dashboard: 'Tableau de bord de couverture du cadre',
            no_frameworks: 'Aucun cadre trouvé',
            framework: 'Cadre',
            modules: 'Modules',
            templates: 'Modèles',
            forms: 'Formulaires',
            channels: 'Canaux',
            deadlines: 'Échéances',
            pending: 'Mises à jour en attente',
            updates: 'Mises à jour réglementaires',
            create_update: 'Créer une mise à jour',
            framework_id: 'ID du cadre',
            update_title: 'Titre',
            description: 'Descriptif',
            effective_date: "Date d'entrée en vigueur",
            amendment_ref: 'Référence de modification',
            create: 'Créer',
            no_updates: 'Aucune mise à jour réglementaire',
            status: 'Statut',
            impact: 'Impact',
            change_summary: 'Résumé des modifications',
            assess: 'Évaluer',
            failed_load: 'Échec de load data',
            update_created: 'Mise à jour créée',
            update_created_announce: 'Mise à jour réglementaire créée',
            failed_create: 'Échec de create update',
            update_assessed: 'Mise à jour évaluée',
            failed_assess: 'Échec de assess update',
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Banking [FR]',
                insurance: 'Insurance [FR]',
                healthcare: 'Healthcare [FR]',
                ict_critical: 'Critical ICT [FR]',
                telecom: 'Telecommunications [FR]',
                energy: 'Energy [FR]',
                transport: 'Transport [FR]',
                digital_services: 'Digital services [FR]',
                digital_technology_industry: 'Industrie des technologies numériques',
                public_administration: 'Public administration [FR]',
                payments: 'Payments [FR]',
                other: 'Other [FR]',
            },
            sector_label: 'Sector [FR]',
            direct_scope_label: 'Direct legal scope [FR]',
            chip_direct: 'Directly applicable [FR]',
            chip_reference: 'Reference only [FR]',
            banner_direct_copy: 'Directly applicable to your organization. Sector reports and deadlines are active. [FR]',
            banner_reference_copy: 'Reference only — your organization is not classified in this sector. [FR]',
            edit_mode_button: 'Edit mode [FR]',
            edit_form_title: 'Change install mode [FR]',
            mode_direct_label: 'Direct — legally applicable [FR]',
            mode_direct_help: 'Schedules sector deadlines and dashboard widgets. [FR]',
            mode_reference_label: 'Reference only [FR]',
            mode_reference_help: 'Browseable but no deadlines or widgets. [FR]',
            reason_note_label: 'Reason (optional) [FR]',
            reason_note_placeholder: 'e.g. Bank subsidiary acquired [FR]',
            cancel: 'Cancel [FR]',
            confirm: 'Confirm [FR]',
            confirming: 'Saving… [FR]',
            save: 'Save [FR]',
            saving: 'Saving… [FR]',
            toast_mode_changed: 'Sector overlay mode updated. [FR]',
            toast_installed: 'Sector overlay installed. [FR]',
            toast_sectors_saved: 'Sector self-identification saved. [FR]',
            install_modal_title: 'Install sector overlay [FR]',
            install_modal_intro: 'Sector overlays are opt-in regulatory packs scoped to a single industry. [FR]',
            install_modal_footer: 'You can change install mode later from the framework detail page. [FR]',
            install_button: 'Install [FR]',
            installed_label: 'Installed [FR]',
            uninstall_button: 'Désinstaller',
            uninstall_confirm: 'Confirmer la désinstallation',
            uninstall_cancel: 'Annuler',
            suggested_label: 'Suggested [FR]',
            catalog_page_title: 'Sector overlays [FR]',
            catalog_page_intro: 'Optional regulatory packs scoped to a single industry sector. [FR]',
            catalog_empty_title: 'No sector overlays available [FR]',
            catalog_empty_description: 'Sector overlay packs published in your platform will appear here. [FR]',
            authority_label: 'Authority [FR]',
            org_sectors_title: 'Industry sectors [FR]',
            org_sectors_intro: 'Select the industry sectors your organization operates in. [FR]',
            widget_title: 'Sector overlay reports due [FR]',
            widget_aria_label: 'Sector overlay reports due [FR]',
            widget_empty: 'No upcoming sector overlay deadlines. [FR]',
            audit_event_mode_changed: 'Sector overlay install mode changed [FR]',
            audit_event_installed: 'Sector overlay installed [FR]',
            view_details_button: 'View details → [FR]',
            banner_aria_label: 'Sector overlay status [FR]',
            toast_load_failed: 'Failed to load sector overlays [FR]',
            toast_install_failed: 'Failed to install sector overlay [FR]',
            toast_uninstall_confirm_required: 'Type "{packCode}" to confirm uninstall. [FR]',
            toast_uninstalled: 'Uninstalled {packCode}. [FR]',
            toast_uninstall_failed: 'Failed to uninstall sector overlay [FR]',
            uninstall_warning_destructive_label: 'Destructive action. [FR]',
            uninstall_warning_body: 'Uninstalling will delete the framework record and any persisted regulatory deadlines tied to {frameworkCode} from this organisation. [FR]',
            uninstall_warning_type_to_confirm: 'Type {packCode} to confirm. [FR]',
            uninstall_in_progress: 'Uninstalling… [FR]',
            widget_view_all: 'View all sector overlays → [FR]',
            widget_due_in_days: 'Due in {days}d [FR]',
            widget_overdue_days: 'Overdue by {days}d [FR]',
            widget_due_today: 'Due today [FR]',
            widget_due_unknown: '— [FR]',
        },
        phased_obligations: {
            panel_title: 'Phased obligations [FR]',
            panel_aria_label: 'Phased obligations [FR]',
            panel_intro: 'Some clauses in this framework activate later than the framework itself. [FR]',
            phased_effective_date_label: 'Phased effective: [FR]',
            status_pending: 'Pending [FR]',
            status_active: 'Active [FR]',
            status_early: 'Active (early-implemented) [FR]',
            notice_window_label: 'Authority notice window: [FR]',
            days_label: 'days [FR]',
            recipient_label: 'Recipient: [FR]',
            early_implement_button: 'Mark early-implemented [FR]',
            early_implement_modal_title: 'Mark phased obligation as early-implemented [FR]',
            early_implement_modal_intro: 'Recording an early implementation activates the obligation now and schedules the regulator notice timer. [FR]',
            effective_at_label: 'Effective from [FR]',
            reason_label: 'Reason (optional) [FR]',
            reason_placeholder: 'e.g. Board approved early adoption 2026-09-01 [FR]',
            confirm: 'Confirm [FR]',
            toast_early_implemented: 'Early implementation recorded. [FR]',
            audit_event_early_implemented: 'Phased obligation marked early-implemented [FR]',
            widget_rolling_window_label: 'Phased activations within 90 days [FR]',
        },
    },
    partner_marketplace: {
        nav: {
            dashboard: 'Tableau de bord',
            partner_orgs: 'Organisations partenaires',
            service_tiers: 'Niveaux de service',
            deliverable_templates: 'Modèles de livrables',
            deliverables: 'Livrables',
            brand_profiles: 'Profils de marque',
            support_tickets: 'Tickets de support',
            workflow_templates: 'Modèles de flux de travail',
            workflows: 'Flux de travail',
            escalation: 'Escalade',
            reports: 'Rapports',
            audit: "Piste d'audit",
        },
        dashboard: {
            title: 'Tableau de bord partenaire',
            loading: 'Chargement de dashboard data...',
            total_managed_tenants: 'Total de locataires gérés',
            avg_health_score: 'Avg Santé Score',
            open_tickets: 'Tickets ouverts',
            upcoming_deliverables: 'Livrables à venir',
            escalated_tickets: 'Tickets escaladés',
            managed_tenants: 'Locataires gérés',
            partner_tier: 'Partenaire Niveau',
            managed_tenants_count: 'Nombre de locataires gérés',
            onboarding_date: "Date d'intégration",
            view_details: 'Voir détails',
            no_partner_orgs: 'Aucun partner organizations trouvé',
        },
        partner_orgs: {
            title: 'Organisations partenaires',
            new: 'Nouveau Partner Org',
            contact_name: 'Contact Nom',
            contact_email: 'Contact E-mail',
            partner_tier: 'Partenaire Niveau',
            managed_orgs: 'Organisations gérées',
            onboarding_date: "Date d'intégration",
            no_orgs: 'Aucun partner organizations trouvé',
            contact_phone: 'Contact Téléphone',
            metadata_json: 'Métadonnées (JSON)',
            change_status: 'Changement Statut',
            new_status: 'Nouveau statut',
            invalid_json_metadata: 'JSON invalide dans le champ métadonnées',
            suspended: 'Suspendu',
            offboarded: 'Désintégré',
            all_tiers: 'Tous les niveaux',
            silver: 'Argent',
            gold: 'Or',
            platinum: 'Platine',
            status_offboarded: 'Désintégré',
            status_suspended: 'Suspendu',
            tier_gold: 'Or',
            tier_platinum: 'Platine',
            tier_silver: 'Argent',
        },
        service_tiers: {
            title: 'Niveaux de service',
            new: 'Nouveau niveau',
            tier_name: 'Niveau Nom',
            monthly_fee: 'Mensuel Frais',
            features: 'Fonctionnalités',
            no_tiers: 'Aucun service tiers trouvé',
            tier_code: 'Code de niveau',
            user_seats: 'Places utilisateur',
            user_seat_limit: 'Utilisateur Seat Limite',
            storage_gb: 'Stockage (GB)',
            storage_limit_gb: 'Stockage Limite (GB)',
            response_time_hrs: 'Réponse Heure (hrs)',
            resolution_time_hrs: 'Résolution Heure (hrs)',
            review_frequency: 'Examiner Fréquence',
            sla_response_time: 'SLA Réponse Heure (hours)',
            sla_resolution_time: 'SLA Résolution Heure (hours)',
            module_profile_json: 'Module Profil (JSON)',
            comparing: 'Comparaison...',
            compare: 'Comparer',
            comparison: 'Service Niveau Comparison',
            attribute: 'Attribut',
            deprecate: 'Rendre obsolète',
            deprecated: 'Obsolète',
            invalid_json_module: 'Invalide JSON dans module profile champ',
            select_compare: 'Sélectionnez à le moins 2 tiers à comparer',
            comparison_title: 'Service Niveau Comparison',
            status_deprecated: 'Obsolète',
            activate: 'Activer',
            invalid_json_module_profile: 'JSON invalide dans le profil du module',
            resolution_time: 'Résolution Heure',
            response_time: 'Réponse Heure',
            select_at_least_two: 'Sélectionnez at least 2 tiers',
        },
        deliverable_templates: {
            title: 'Modèles de livrables',
            new: 'Nouveau modèle',
            template_name: 'Modèle Nom',
            deliverable_type: 'Type de livrable',
            no_templates: 'Aucun deliverable templates trouvé',
            frequency: 'Fréquence',
            est_effort_hrs: 'Effort est. (h)',
            estimated_effort: 'Effort estimé (heures)',
            associated_module: 'Module associé',
            linked_tiers_count: 'Nombre de niveaux liés',
            evidence_requirements: 'Preuve Exigences (comma-separated)',
            tier_ids: 'IDs de niveaux (séparés par des virgules)',
            frequency_one_time: 'Ponctuel',
            frequency_monthly: 'Mensuel',
            frequency_quarterly: 'Trimestriel',
            frequency_annually: 'Annuellement',
            type_report: 'Rapport',
            type_review: 'Examiner',
            type_assessment: 'Évaluation',
            type_meeting: 'Réunion',
            type_configuration: 'Paramétrage',
            freq_one_time: 'Ponctuel',
            freq_monthly: 'Mensuel',
            freq_quarterly: 'Trimestriel',
            freq_annually: 'Annuellement',
            status_deprecated: 'Obsolète',
        },
        deliverables: {
            title: 'Livrables',
            new: 'Nouveau Deliverable',
            partner: 'Partenaire',
            deliverable_type: 'Type de livrable',
            due_date: "Date d'échéance",
            no_deliverables: 'Aucun deliverables trouvé',
            assigned_to: 'Assigné À',
            completion_date: "Date d'achèvement",
            update_status: 'Mettre à jour Statut',
            hide_details: 'Masquer Détails',
            view_details: 'Voir détails',
            evidence_ids: 'IDs de preuves',
            client_approval: 'Client Approbation',
            bulk_update: 'Mise à jour en masse',
            bulk_update_status: 'Bulk Mettre à jour Statut',
            generate_schedule: 'Générer Planification',
            generate_deliverable_schedule: 'Générer Deliverable Planification',
            organization_id: 'Organisation ID',
            service_tier_id: 'Service Niveau ID',
            filter_assigned_to: 'Filtrer par Assigné À',
            select_status: 'Sélectionnez status...',
            new_status: 'Nouveau statut',
            upcoming: 'À venir',
            overdue: 'En retard',
            status_deferred: 'Reporté',
            status_overdue: 'En retard',
            status_upcoming: 'À venir',
        },
        brand_profiles: {
            title: 'Profils de marque',
            new: 'Nouveau Brand Profile',
            partner: 'Partenaire',
            brand_name: 'Nom de marque',
            primary_color: 'Principal Couleur',
            logo_url: 'URL du logo',
            no_profiles: 'Aucun brand profiles trouvé',
            secondary_color: 'Secondaire Couleur',
            header_text: 'En-tête Texte',
            footer_text: 'Pied de page Texte',
            contact_email: 'Contact E-mail',
            contact_phone: 'Contact Téléphone',
            contact_website: 'Site web de contact',
            contact_address: 'Contact Adresse',
            is_default: 'Est Par défaut',
            set_default: 'Définir par défaut',
            preview: 'Aperçu',
            report_header_preview: 'Rapport En-tête Preview',
            report_footer_preview: 'Rapport Pied de page Preview',
            preview_description: 'Ce est un preview de le signaler en-tête avec le selected brand colors.',
            contact_website_short: 'Site web',
            logo_preview: 'Aperçu du logo',
        },
        support_tickets: {
            title: 'Tickets de support',
            new: 'Nouveau Ticket',
            partner: 'Partenaire',
            subject: 'Sujet',
            assigned_to: 'Assigné À',
            no_tickets: 'Aucun support tickets trouvé',
            category: 'Catégorie',
            priority: 'Priorité',
            escalation_tier: 'Escalade Niveau',
            sla_status: 'SLA Statut',
            update_status: 'Mettre à jour Statut',
            escalate: 'Escalader',
            add_note: 'Ajouter Note',
            escalate_ticket: 'Escalader le ticket',
            escalate_to_tier: 'Escalader À Niveau',
            notes_timeline: 'Notes Chronologie',
            no_notes: 'Non notes encore.',
            attachments: 'Pièces jointes',
            no_attachments: 'Aucune pièce jointe.',
            client_org_id: 'ID Org. client',
            content: 'Contenu',
            note_type: 'Catégorie',
            view_detail: 'Voir Detail',
            hide: 'Masquer',
            new_status: 'Nouveau statut',
            all_categories: 'Toutes les catégories',
            all_priorities: 'Toutes les priorités',
            all_tiers: 'Tous les niveaux',
            ticket_not_found: 'Ticket non trouvé',
            ticket_id: 'ID du ticket',
            client_org: 'Org. client',
            deescalate: 'Désescalader',
            deescalate_ticket: 'Désescalader le ticket',
            deescalate_to_tier: 'De-escalate À Niveau',
            add_attachment: 'Ajouter pièce jointe',
            file: 'Fichier',
            linked_entity: 'Entité liée',
            sla_target: 'Cible',
            breached: 'Violé',
            remaining_hours: 'restants',
            na: 'N/A',
            tickets_found: 'tickets trouvés',
            reason: 'Motif',
            target: 'Cible',
            upload: 'Téléverser',
        },
        workflow_templates: {
            title: 'Modèles de flux de travail',
            new: 'Nouveau modèle',
            template_name: 'Modèle Nom',
            steps: 'Étapes',
            no_templates: 'Aucun workflow templates trouvé',
            category: 'Catégorie',
            view_steps: 'Voir étapes',
            hide_steps: 'Masquer Étapes',
            step: 'Étape',
            step_title: 'Titre',
            step_description: 'Descriptif',
            assignee_role: 'Assigné Rôle',
            sla_hours: 'Heures SLA',
            evidence_required: 'Preuve Obligatoire',
            guidance_notes: "Notes d'orientation",
            add_step: 'Ajouter étape',
            no_steps: 'Aucune étape définie.',
            no_steps_defined: 'Aucune étape définie.',
            templates_found: 'modèles trouvés',
            all_categories: 'Toutes les catégories',
        },
        workflows: {
            title: 'Instances de flux de travail',
            new: 'Nouveau flux de travail',
            template: 'Modèle',
            partner: 'Partenaire',
            current_step: 'Actuel Étape',
            progress: 'Progression',
            no_workflows: 'Aucun workflow instances trouvé',
            instances_found: 'instances trouvées',
        },
        escalation: {
            title: 'Escalade Tableau de bord',
            ticket: 'Demande',
            partner: 'Partenaire',
            escalated_at: 'Escaladé À',
            reason: 'Motif',
            no_escalations: 'Aucun escalations trouvé',
            time_in_tier: 'Heure dans Niveau',
            auto_evaluate: 'Évaluation auto.',
            priority_critical: 'Critique',
            priority_high: 'Élevé',
            priority_medium: 'Moyen',
            priority_low: 'Low',
            deescalated_from_dashboard: 'Désescaladé depuis le tableau de bord',
            sla_breached: 'SLA violé',
            sla_remaining: 'SLA restant',
        },
        reports: {
            title: 'Rapports',
            partner: 'Partenaire',
            report_type: 'Rapport Type',
            generated_at: 'Généré le',
            no_reports: 'Aucun reports trouvé',
            generate: 'Générer Rapport',
        },
        audit: {
            title: 'Partenaire Audit Trail',
            event_type: 'Événement Type',
            entity_type: "Type d'entité",
            entity_id: "ID de l'entité",
            actor: 'Acteur',
            timestamp: 'Horodatage',
            no_events: 'Aucun audit events trouvé',
            events_found: 'événements trouvés',
            event_type_created: 'Créé',
            event_type_updated: 'Mis à jour',
            event_type_deleted: 'Supprimé',
            event_type_status_change: 'Changement de statut',
            event_type_escalation: 'Escalade',
            event_type_assignment: 'Affectation',
            entity_type_partner_org: 'Organisation partenaire',
            entity_type_service_tier: 'Niveau de service',
            entity_type_deliverable_template: 'Modèle de livrable',
            entity_type_deliverable_instance: 'Instance livrable',
            entity_type_brand_profile: 'Profil de marque',
            entity_type_support_ticket: "Billet d'assistance",
            entity_type_workflow_template: 'Modèle de flux de travail',
            entity_type_workflow_instance: 'Instance de flux de travail',
            entity_type_generated_report: 'Rapport généré',
            entity_type_escalation_rule: "Règle d'escalade",
        },
        no_permission_title: 'Autorisations insuffisantes',
        no_permission_message: "Vous n'êtes pas autorisé à accéder à l'espace de travail partenaire.",
        status_active: 'Actif',
        status_suspended: 'Suspendu',
        status_offboarded: 'Hors-bord',
        status_completed: 'Terminé',
        status_cancelled: 'Annulé',
        status_deprecated: 'Obsolète',
        status_new: 'Nouveau',
        status_triaged: 'Trié',
        status_in_progress: 'En cours',
        status_waiting_on_client: 'En attente du client',
        status_waiting_on_vendor: 'En attente du vendeur',
        status_escalated: 'Escaladé',
        status_resolved: 'Résolu',
        status_closed: 'Fermé',
        status_pending: 'En attente',
        status_skipped: 'Sauté',
        category_onboarding: 'Intégration',
        category_incident_escalation: 'Escalade des incidents',
        category_config_change: 'Changement de configuration',
        category_periodic_review: 'Examen périodique',
        category_offboarding: 'Débarquement',
        category_custom: 'Personnalisé',
        category_configuration: 'Configuration',
        category_incident: 'Incident',
        category_compliance_question: 'Question de conformité',
        category_feature_request: 'Demande de fonctionnalité',
        category_bug_report: 'Rapport de bug',
        priority_critical: 'Critique',
        priority_high: 'Élevé',
        priority_medium: 'Moyen',
        priority_low: 'Faible',
        tier_silver: 'Argent',
        tier_gold: 'Or',
        tier_platinum: 'Platine',
        report_type_compliance_summary: 'Résumé de conformité',
        report_type_risk_overview: 'Aperçu des risques',
        report_type_incident_report: "Rapport d'incident",
        report_type_consent_status: 'Statut de consentement',
        report_type_program_maturity: 'Maturité du programme',
        report_type_executive_pack: 'Pack Exécutif',
        note_type_internal: 'Interne',
        note_type_client_visible: 'Client visible',
        status_updated: 'Statut mis à jour avec succès',
        deliverable_status_updated: 'Statut du livrable mis à jour avec succès',
        ticket_status_updated: 'Statut du ticket mis à jour avec succès',
        ticket_escalated: 'Le ticket a été transféré avec succès',
        note_added: 'Note ajoutée avec succès',
        attachment_uploaded: 'Pièce jointe téléchargée avec succès',
        ticket_deescalated: 'Le ticket a été résolu avec succès',
        auto_evaluation_completed: 'Auto-évaluation terminée',
        template_created: 'Modèle de workflow créé avec succès',
        template_updated: 'Modèle de workflow mis à jour avec succès',
        brand_set_default: 'Profil de marque défini par défaut avec succès',
        brand_created: 'Profil de marque créé avec succès',
        brand_updated: 'Profil de marque mis à jour avec succès',
        tier_created: 'Le niveau de service a été créé avec succès',
        tier_updated: 'Le niveau de service a été mis à jour avec succès',
        tier_deprecated: 'Le niveau de service a été obsolète avec succès',
        tier_activated: 'Le niveau de service a été activé avec succès',
        period: 'Période',
        format: 'Formater',
        period_start: 'Début de la période',
        period_end: 'Fin de période',
        reports_count: '[[TOK_1]] rapports',
        reports_count_one: 'Rapport [[TOK_1]]',
        metric: 'Métrique',
        value: 'Valeur',
        showing_chart_view: 'Affichage de la vue graphique',
        showing_table_view: 'Affichage de la vue du tableau de données',
        evidence_ids_placeholder: 'par ex. ev-001, ev-002',
        confirm_cancel_workflow: 'Êtes-vous sûr de vouloir annuler ce flux de travail ? Cette action ne peut pas être annulée.',
        export_csv: 'Exporter [[TOK_0]]',
        compliance_qualifications_title: 'Qualifications du service de conformité',
        compliance_qualifications_desc: 'Le niveau partenaire (Argent/Or/Platine) détermine la portée du service de conformité. Les partenaires Gold et Platinum sont qualifiés pour les engagements du secteur réglementé. Utilisez le champ Métadonnées pour enregistrer les certifications (ISO 27001, SOC 2), les spécialisations et les qualifications juridictionnelles de chaque partenaire.',
        regulatory_output_title: 'Alignement des résultats réglementaires',
        regulatory_output_desc: "Chaque type de modèle correspond à une catégorie de sortie réglementaire : les rapports produisent une documentation de conformité, les examens valident l'efficacité du contrôle, les évaluations couvrent les évaluations des risques ([[TOK_0]], analyse des écarts), les réunions documentent les sessions de gouvernance. Les exigences en matière de preuves définissent les artefacts que chaque livrable doit référencer pour être prêt à l'audit.",
        sla_compliance_title: '[[TOK_0]] Suivi pour la livraison conforme',
        sla_compliance_desc: "Les SLA sur les délais de réponse et de résolution sont contractuellement contraignants pour la fourniture de services de conformité. La fréquence de révision détermine la fréquence à laquelle les livrables de conformité des partenaires sont évalués. Les [[TOK_0]] violations sur les tickets critiques en matière de conformité déclenchent une escalade automatique et sont enregistrées dans la piste d'audit des partenaires à des fins de preuve réglementaire.",
        regulatory_engagement_title: 'Modèles d’engagement réglementaire',
        regulatory_engagement_desc: "Les catégories de flux de travail correspondent aux types d'engagement réglementaire : l'intégration couvre la configuration initiale de la conformité et l'analyse des écarts, l'examen périodique gère les évaluations de conformité récurrentes, l'escalade des incidents gère la réponse aux violations réglementaires, l'offboarding garantit le respect des obligations de conservation des données. Chaque étape peut nécessiter la collecte de preuves pour garantir l’exhaustivité de la piste d’audit.",
        compliance_escalation_title: "Procédures d'escalade critiques en matière de conformité",
        compliance_escalation_desc: "L1 gère les problèmes opérationnels standard. L2 couvre les défaillances ayant un impact sur la conformité (non-respect des délais réglementaires, lacunes en matière de contrôle). L3 est réservé aux scénarios de violation de la réglementation nécessitant une attention immédiate de la direction. La violation de [[TOK_0]] sur les tickets L2/L3 génère automatiquement des entrées de piste d'audit. Toutes les actions d’escalade et de désescalade sont enregistrées en permanence.",
        audit_regulatory_title: 'Sentier des preuves réglementaires',
        audit_regulatory_desc: "Cette piste d'audit fournit des enregistrements inviolables pour la conformité réglementaire. Chaque action du partenaire (création, mise à jour, suppression, escalade, changement de statut) est enregistrée avec l'identité de l'acteur, l'horodatage et la différence complète de charge utile. Utilisez les filtres de type d'entité pour isoler les preuves par domaine de conformité. Exportez les résultats filtrés pour produire une documentation prête à être auditée pour les inspections réglementaires.",
        evidence_trail_title: 'Parcours de preuves inter-modules',
        evidence_trail_desc: "Chaque étape du flux de travail peut collecter des ID de preuves liés aux livrables, aux événements d'audit et aux artefacts de conformité dans les modules. Avancer d'une étape avec les identifiants de preuves crée une chaîne vérifiable reliant les flux de travail des partenaires à la documentation réglementaire. Les flux de travail terminés avec des chaînes de preuves complètes servent de preuve de la réalisation de l'engagement de conformité.",
        evidence_ids_label: 'ID de preuve',
    },
    org_groups: {
        title: "Groupes d'organisations",
        new: 'Ajouter groupe',
        group_name: 'Groupe Nom',
        member_count: 'Nombre de membres',
        root_org: 'Organisation racine',
        no_groups: 'Aucun org groups trouvé',
        add_organization: 'Ajouter une Organisation',
        select_organization: 'Sélectionnez une organisation...',
        no_available_orgs: 'Aucune organisation disponible à ajouter.',
        no_members: 'Aucune organisation membre dans ce groupe.',
        member_added: 'Organisation ajoutée au groupe.',
        member_removed: 'Organisation retirée du groupe.',
        already_in_group: 'Cette organisation appartient déjà à un groupe.',
        org_not_found: 'Organisation introuvable.',
        add_member_error: "Impossible d'ajouter l'organisation au groupe.",
        remove_member_error: "Impossible de retirer l'organisation du groupe.",
        confirm_remove_member: 'Êtes-vous sûr de vouloir retirer "{name}" de ce groupe ?',
        load_error: "Impossible de charger les détails du groupe d'organisations.",
        page_title_list: 'Groupes organisationnels',
        page_title_detail: 'Détails du groupe organisationnel',
        page_title_create: 'Créer un groupe organisationnel',
        page_title_settings: 'Paramètres du groupe organisationnel',
        page_title_users: "Groupe d'utilisateurs",
        page_title_reports: 'Rapports de groupe',
        page_title_dashboard: 'Tableau de bord du groupe',
        page_title_audit: 'Vérification du groupe',
        page_title_org_audit: 'Audit de groupe organisationnel',
        page_title_shared_vendors: 'Fournisseurs partagés',
        page_title_shared_frameworks: 'Cadres partagés',
        page_title_shared_forms: 'Modèles de formulaires partagés',
        page_title_merged_vendors: 'Fournisseurs fusionnés',
        page_title_settings_inheritance: 'Héritage des paramètres',
        announce_loaded_groups: '[[TOK_1]] groupes organisationnels chargés',
        announce_loaded_group: 'Groupe chargé [[TOK_1]]',
        announce_loaded_users: 'Utilisateurs du groupe [[TOK_1]] chargés',
        announce_loaded_reports: 'Rapports [[TOK_1]] chargés',
        announce_loaded_vendors: 'Fournisseurs partagés [[TOK_1]] chargés',
        announce_loaded_frameworks: 'Chargé des frameworks partagés [[TOK_1]]',
        announce_loaded_templates: '[[TOK_1]] modèles de formulaires partagés chargés',
        announce_loaded_audit: "Événements d'audit [[TOK_1]] chargés",
        announce_loaded_merged: 'Fournisseurs [[TOK_2]] partagés et [[TOK_3]] locaux chargés',
        announce_dashboard_loaded: 'Tableau de bord chargé.',
        announce_dashboard_refreshed: 'Tableau de bord rafraîchi.',
        announce_dashboard_refresh_failed: "Échec de l'actualisation du tableau de bord.",
        announce_refreshing: 'Tableau de bord actualisé...',
        announce_settings_loaded: 'Héritage des paramètres chargé.',
        announce_settings_saved: 'Paramètres enregistrés avec succès.',
        announce_saving_settings: 'Enregistrement des paramètres...',
        announce_error_saving: "Erreur lors de l'enregistrement des paramètres.",
        announce_group_dissolved: 'Groupe dissous.',
        announce_creating_group: "Création d'un groupe organisationnel...",
        announce_group_created: 'Groupe organisationnel créé avec succès.',
        announce_error_creating: 'Erreur lors de la création du groupe organisationnel.',
        announce_vendor_published: 'Fournisseur publié avec succès.',
        announce_vendor_retired: 'Vendeur à la retraite.',
        announce_framework_published: 'Cadre publié avec succès.',
        announce_framework_retired: 'Cadre retiré.',
        announce_template_published: 'Modèle de formulaire publié avec succès.',
        announce_template_retired: 'Modèle de formulaire retiré.',
        announce_role_assigned: 'Rôle attribué avec succès.',
        announce_error_assign_role: "Erreur lors de l'attribution du rôle.",
        announce_role_revoked: 'Rôle révoqué avec succès.',
        announce_report_generating: 'Génération du rapport...',
        announce_report_requested: 'Génération de rapport demandée.',
        announce_error_report: 'Erreur lors de la demande de rapport.',
        announce_report_deleted: 'Rapport supprimé.',
        announce_search_applied: 'Recherche appliquée.',
        announce_search_cleared: 'Recherche effacée.',
        announce_tab_selected: 'Onglet [[TOK_1]] sélectionné',
        announce_error_add_member: "Erreur lors de l'ajout d'un membre au groupe.",
        announce_category_reverted: '[[TOK_1]] est redevenu hérité du parent.',
        announce_category_overridden: '[[TOK_1]] défini sur remplacement local.',
        announce_override_saved: 'Remplacement [[TOK_1]] enregistré.',
        announce_export_started: "Exportation de l'audit en tant que [[TOK_1]]...",
        announce_export_completed: 'Exportation en tant que [[TOK_1]] terminée.',
        announce_export_failed: "L'exportation a échoué.",
        announce_filter_org: 'Filtré par organisation [[TOK_1]]',
        announce_filter_org_cleared: "Filtre d'organisation effacé",
        announce_filter_event: "Filtré par type d'événement [[TOK_1]]",
        announce_filter_cleared: 'Filtre effacé',
        announce_download: 'Téléchargement de [[TOK_2]] en tant que [[TOK_3]]',
        error_load_groups: 'Échec du chargement des groupes organisationnels. Veuillez réessayer.',
        error_load_users: 'Échec du chargement des utilisateurs du groupe.',
        error_load_reports: 'Échec du chargement des rapports de groupe.',
        error_load_dashboard: 'Échec du chargement du tableau de bord du groupe.',
        error_load_settings: 'Échec du chargement des paramètres du groupe.',
        error_load_vendors: 'Échec du chargement des fournisseurs fusionnés.',
        error_save_settings: "Échec de l'enregistrement des paramètres.",
        error_dissolve_group: 'Échec de la dissolution du groupe.',
        error_assign_role: "Échec de l'attribution du rôle.",
        error_create_group: 'Échec de la création du groupe organisationnel. Veuillez réessayer.',
        error_request_report: 'Échec de la demande de rapport.',
        error_group_name_required: 'Le nom du groupe est requis.',
        success_settings_saved: 'Paramètres enregistrés avec succès.',
        confirm_retire_vendor: 'Êtes-vous sûr de vouloir retirer le fournisseur « [[TOK_1]] » ?',
        confirm_retire_framework: 'Êtes-vous sûr de vouloir retirer le framework « [[TOK_1]] » ?',
        confirm_retire_template: 'Êtes-vous sûr de vouloir supprimer le modèle de formulaire « [[TOK_1]] » ?',
        confirm_dissolve_group: 'Êtes-vous sûr de vouloir dissoudre « [[TOK_1]] » ? Cette action ne peut pas être annulée.',
        confirm_revoke_role: 'Êtes-vous sûr de vouloir révoquer le rôle « [[TOK_2]] » de « [[TOK_3]] » ?',
        confirm_delete_report: 'Êtes-vous sûr de vouloir supprimer le rapport « [[TOK_1]] » ?',
        dissolve_group: 'Dissoudre le groupe',
        dissolve_warning: 'Cela dissoudra définitivement le groupe d’organisation. Toutes les organisations membres seront supprimées.',
        count_groups: 'Groupe [[TOK_1]]',
        count_groups_plural: '[[TOK_1]] groupes',
        count_users: '[[TOK_1]] utilisateur',
        count_users_plural: '[[TOK_1]] utilisateurs avec des rôles de groupe',
        count_events: 'Événement [[TOK_1]]',
        count_events_plural: '[[TOK_1]] événements',
        count_reports: 'Rapport [[TOK_1]]',
        count_reports_plural: '[[TOK_1]] rapports',
        count_vendors: '[[TOK_1]] fournisseur partagé au sein du groupe',
        count_vendors_plural: '[[TOK_1]] fournisseurs partagés au sein du groupe',
        count_frameworks: 'Cadre [[TOK_1]] partagé au sein du groupe',
        count_frameworks_plural: '[[TOK_1]] frameworks partagés au sein du groupe',
        count_templates: 'Modèle [[TOK_1]] partagé au sein du groupe',
        count_templates_plural: '[[TOK_1]] modèles partagés au sein du groupe',
        count_shared_vendors: '[[TOK_1]] fournisseurs partagés',
        count_local_vendors: '[[TOK_1]] fournisseurs locaux',
        merged_combined_view: 'Vue combinée des [[TOK_2]] fournisseurs partagés et des [[TOK_3]] fournisseurs locaux',
        dashboard: {
            title: 'Tableau de bord du groupe',
            loading: 'Chargement de dashboard data...',
            total_groups: 'Total Groupes',
            total_members: 'Total de membres',
            active_groups: 'Actif Groupes',
            overall_compliance_score: 'Score de conformité global',
            group_risk_level: 'Niveau de risque du groupe',
            sla_compliance: '[[TOK_0]] Conformité',
            compliance_posture: 'Posture de conformité',
            risk_heatmap: 'Carte thermique des risques',
            sla_performance: '[[TOK_0]] Performances',
            recent_incidents: 'Incidents récents',
            recent_activity: 'Activité récente',
            refresh_label: 'Actualiser les données du tableau de bord',
            score_good: 'Bon',
            score_needs_attention: "A besoin d'attention",
            score_critical: 'Critique',
            trend_up: 'Tendance à la hausse',
            trend_down: 'Tendance à la baisse',
            trend_stable: 'Stable',
            risk_low: 'Low',
            risk_medium: 'Moyen',
            risk_high: 'Élevé',
            risk_critical: 'Critique',
            risk_unknown: 'Inconnu',
            col_organization: 'Organisation',
            col_score: 'Score',
            col_trend: 'Tendance',
            col_open_issues: 'Problèmes ouverts',
            col_critical_issues: 'Problèmes critiques',
            col_health: 'Santé',
            col_vendor_risk: 'Risque du fournisseur',
            col_data_risk: 'Risque lié aux données',
            col_compliance_risk: 'Risque de conformité',
            col_total_cases: 'Total des cas',
            col_on_time: "À l'heure",
            col_breached: 'Violé',
            col_sla_percent: '[[TOK_0]] %',
            col_avg_days: 'Jours moyens',
            sr_vendor_risk: 'Score de risque du fournisseur : [[TOK_1]]',
            sr_data_risk: 'Score de risque lié aux données : [[TOK_1]]',
            sr_compliance_risk: 'Score de risque de non-conformité : [[TOK_1]]',
            sr_sla_breaches: 'Avertissement : [[TOK_1]] [[TOK_2]] violations',
            sr_severity: 'Gravité : [[TOK_1]]',
        },
        detail: {
            title: 'Détails du groupe',
            members: 'Membres',
            settings: 'Paramètres',
            audit: 'Vérification',
            sr_loading: 'Chargement des détails du groupe organisationnel',
            sr_loading_hierarchy: 'Chargement de la hiérarchie',
            member_org: 'organisation membre',
            root_org_label: 'organisation racine',
        },
        users: {
            title: 'Utilisateurs du groupe',
            add_user: 'Ajouter utilisateur',
            no_users: 'Aucun utilisateur dans ce groupe.',
            role_group_admin: 'Administrateur de groupe',
            role_group_reader: 'Lecteur de groupe',
            sr_loading: 'Chargement des utilisateurs du groupe',
        },
        reports: {
            title: 'Rapports du groupe',
            no_reports: 'Aucun reports trouvé',
            generate_report: 'Générer un nouveau rapport',
            report_type_compliance: 'Résumé de conformité',
            report_type_risk: 'Aperçu des risques',
            report_type_sla: '[[TOK_0]] Performances',
            report_type_incident: "Rapport d'incident",
            report_type_executive: 'Note de synthèse',
            report_type_board: "Rapport du conseil d'administration",
            status_queued: "En file d'attente",
            status_generating: 'Génération',
            status_completed: 'Terminé',
            status_failed: 'Échec',
            period_start: 'Début de la période',
            period_end: 'Fin de période',
            sr_loading: 'Chargement des rapports de groupe',
        },
        shared_vendors: {
            title: 'Fournisseurs partagés',
            no_vendors: 'Aucun shared vendors trouvé',
            merged_vendors: 'Fournisseurs fusionnés',
            publish_form_label: 'Publier un fournisseur partagé',
            sr_loading: 'Chargement des fournisseurs partagés',
            sr_loading_merged: 'Chargement des fournisseurs fusionnés',
            local_vendors: 'Fournisseurs locaux',
            source_shared: 'Partagé du groupe',
            source_local: 'Vendeur local',
            category_technology: 'Technologie',
            category_consulting: 'Conseil',
            category_outsourcing: 'Externalisation',
            category_cloud: 'Nuage',
            category_data_processing: 'Traitement des données',
            category_other: 'Autre',
            risk_tier_low: 'Low',
            risk_tier_medium: 'Moyen',
            risk_tier_high: 'Élevé',
            risk_tier_critical: 'Critique',
            compliance_compliant: 'Conforme',
            compliance_non_compliant: 'Non conforme',
            compliance_pending: 'En attente',
            compliance_under_review: 'En cours de révision',
            status_active: 'Actif',
            status_retired: 'Retraité',
        },
        shared_frameworks: {
            title: 'Cadres partagés',
            no_frameworks: 'Aucun shared frameworks trouvé',
            publish_form_label: 'Publier un cadre partagé',
            sr_loading: 'Chargement de frameworks partagés',
            status_active: 'Actif',
            status_retired: 'Retraité',
        },
        shared_forms: {
            title: 'Modèles de formulaires partagés',
            no_forms: 'Aucun shared form templates trouvé',
            publish_form_label: 'Publier un modèle de formulaire partagé',
            sr_loading: 'Chargement de modèles de formulaires partagés',
            status_active: 'Actif',
            status_retired: 'Retraité',
        },
        audit: {
            title: 'Audit du groupe',
            consolidated_title: "Piste d'audit consolidée",
            consolidated_subtitle: 'Cross-organization auditer events pour ce group',
            audit_log_title: 'Groupe Audit Journal',
            event_type: 'Événement Type',
            actor: 'Acteur',
            timestamp: 'Horodatage',
            source_org: 'Org. source',
            org: 'Org',
            summary: 'Résumé',
            details: 'Détails',
            no_events: 'Aucun audit events trouvé',
            all_events: 'Tous Événements',
            all_orgs: 'Toutes les org.',
            organization: 'Organisation',
            from: 'De',
            to: 'To',
            search_events: 'Rechercher des événements...',
            clear: 'Effacer',
            events_24h: 'Événements (24h)',
            events_7d: 'Événements (7d)',
            active_orgs: 'Org. actives',
            exporting: 'Exportation...',
            export_csv: 'Exporter CSV',
            export_json: 'Exporter JSON',
            back_to_group: 'Retour à Groupe',
            back_to_detail: 'Retour au détail',
            sr_loading: "Chargement des événements d'audit",
            sr_loading_summary: "Chargement du résumé de l'audit",
        },
        settings: {
            title: 'Groupe Paramètres',
            inheritance: 'Héritage des paramètres',
            inheritance_subtitle: 'Configurer les catégories de paramètres qui héritent du groupe ou utiliser des remplacements locaux',
            sla_settings: 'SLA Paramètres',
            calendar_settings: 'Calendrier Paramètres',
            notification_settings: 'Notification Paramètres',
            intake_settings: "Paramètres d'entrée",
            cmp_integration: 'Intégration CMP',
            overridden: 'Remplacé',
            inheriting: 'Héritage',
            hide_defaults: 'Masquer les valeurs par défaut',
            show_group_defaults: 'Afficher Groupe Defaults',
            group_defaults: 'Valeurs par défaut du groupe',
            inherit_from_group: 'Inherit de Groupe',
            use_local_override: 'Utiliser le remplacement local',
            local_override_json: 'Remplacement local (JSON)',
            save_override: 'Enregistrer le remplacement',
            saving: 'Enregistrement...',
            sr_loading: "Chargement de l'héritage des paramètres",
            sr_loading_settings: 'Chargement des paramètres du groupe',
            sr_enabled: 'Activé',
            sr_disabled: 'Désactivé',
            sr_override_active: 'Remplacement local actif',
            sr_inherited: 'Hérité du parent',
            danger_zone: 'Zone dangereuse',
            sharing_options: 'Options de partage',
            advanced_options: 'Options avancées',
        },
        status_active: 'Actif',
        status_dissolved: 'Dissous',
        status_pending: 'En attente',
        status_suspended: 'Suspendu',
    },
    integrations: {
        nav: {
            webhooks: 'Points de rappel',
            domains: 'Domaines',
            export_schedules: 'Planification des exports',
            email_log: 'Journal des e-mails',
        },
    },
    platform: {
        nav: {
            users: 'Utilisateurs',
            roles: 'Rôles',
            profile: 'Mon profil',
        },
        security: {
            mfa: 'Paramètres MFA',
            sso: 'Configuration SSO',
            api_keys: 'Clés API',
            service_accounts: 'Comptes de service',
            ip_allowlist: "Liste blanche d'adresses IP",
            delegations: 'Délégations',
            break_glass: "Accès d'urgence",
            session_settings: 'Paramètres de session',
            active_sessions: 'Sessions actives',
            access_reviews: "Revues d'accès",
            my_reviews: 'Mes revues',
            role_analytics: 'Analytique des rôles',
            attestation_schedules: 'Planification des attestations',
            sod_rules: 'Règles SoD',
            sod_violations: 'Violations SoD',
        },
        module_config: {
            title: 'Configuration des modules',
            subtitle: 'Activez ou désactivez les modules fonctionnels de votre organisation. Les modules désactivés sont masqués dans la navigation.',
            enabled: 'Activé',
            disabled: 'Désactivé',
            save: 'Enregistrer la configuration',
            saving: 'Enregistrement...',
            saved: 'Configuration enregistrée avec succès',
            nav_label: 'Configuration des modules',
            settings: 'Paramètres',
            webhooks: 'Points de rappel',
            domains: 'Domaines',
            export_schedules: 'Planification des exports',
            email_log: 'Journal des e-mails',
        },
        files_nav: {
            section: 'Fichiers',
            configuration: 'Configuration',
            browser: 'Navigateur de fichiers',
            dashboard: 'Tableau de bord des fichiers',
        },
        immutable_audit_trails: {
            nav_group_label: 'Audit et preuve',
            nav_settings: 'Paramètres',
            nav_status: 'Statut de preuve',
            nav_integrity_center: "Centre d'intégrité",
            nav_usage: 'Utilisation et crédits',
            settings_title: "Pistes d'audit immuables - Paramètres",
            settings_subtitle: 'Paramètres par organisation pour le module complémentaire Immutable Audit Trails.',
            settings_banner: "Le module complémentaire Immutable Audit Trails n’est pas activé pour votre organisation. Activez-le ici pour commencer à ancrer la preuve pour les événements d'audit de niveau A et B.",
            status_title: "Pistes d'audit immuables - Statut de preuve",
            status_subtitle: 'Relations de preuve par événement entre les modules.',
            status_banner: 'Le module complémentaire Immutable Audit Trails n’est pas activé pour votre organisation. Visitez Paramètres pour l’activer.',
            integrity_center_title: "Pistes d'audit immuables — Centre d'intégrité",
            integrity_center_subtitle: 'Vérifiez les preuves et exportez les packs d’intégrité.',
            integrity_center_banner: 'Le module complémentaire Immutable Audit Trails n’est pas activé pour votre organisation. Visitez Paramètres pour l’activer avant d’exécuter la vérification ou d’exporter des packs d’intégrité.',
            usage_title: "Pistes d'audit immuables - Utilisation et crédits",
            usage_subtitle: 'Solde créditeur, achats de forfaits et historique d’utilisation.',
            usage_banner: "Activez les pistes d'audit immuables dans les paramètres pour commencer à consommer des crédits de preuve.",
            module_tips_placeholder: "Des conseils et des conseils pour cette surface sont disponibles dans le centre d'aide.",
            column_label: 'Preuve',
            no_proof_aria: 'Aucune preuve enregistrée',
            proof_status_receipt_label: 'reçu {id}',
            in_progress_hint: 'En cours – mises à jour automatiquement',
            status_pills: {
                pending: 'En attente',
                submitted: 'Soumis',
                anchored: 'Ancré',
                confirmed: 'Confirmé',
                retrying: 'Réessayer',
                paused_cap: 'En pause (limite)',
                failed: 'Échec',
                failed_auth: "Échec de l'authentification",
            },
            status_tooltips: {
                pending: "En attente : en file d'attente pour le service de preuve. Passera sous peu à Soumis ; aucune action n'est nécessaire.",
                submitted: "Soumis : votre événement a été envoyé au service d'épreuves. Pour le mode batch, il attend d’être scellé et ancré sur la chaîne. Mises à jour automatiquement ; aucune action n'est nécessaire.",
                anchored: "Ancré — le lot a été écrit en chaîne et attend la confirmation finale. Mises à jour automatiquement ; aucune action n'est nécessaire.",
                confirmed: 'Confirmé — la preuve est ancrée sur la chaîne et vérifiable.',
                retrying: "Nouvelle tentative : une erreur passagère s'est produite. Le réconciliateur réessaye automatiquement ; aucune action n'est nécessaire.",
                paused_cap: 'En pause : votre plafond mensuel de crédits de preuve a été atteint. Échangez plus de crédits ou attendez le mois de facturation suivant.',
                failed: "Échec : l'ancrage n'a pas réussi. Le réconciliateur réessayera automatiquement ; contactez le support si le problème persiste.",
                failed_auth: "L'authentification a échoué : le service de preuve a rejeté nos informations d'identification. Consultez la page Paramètres des pistes d'audit immuables.",
            },
            mode_pills: {
                direct: 'Direct',
                batch: 'Lot',
            },
            drawer: {
                title: 'Détails de la preuve',
                close: 'Fermer',
                section_proof: 'Preuve',
                section_batch: 'Adhésion par lots',
                status: 'Statut',
                proof_reference: 'Référence de preuve',
                receipt_id: 'ID du reçu',
                taxonomy_class: 'Cours de taxonomie',
                units_consumed: 'Unités consommées',
                created_at: 'Créé',
                verification_ref: 'Référence de vérification de chaîne',
                chain: 'Chaîne',
                tx_hash: "Hachage d'émission",
                block_ref: 'Réf bloc',
                batch_reference: 'Référence du lot',
                leaf_index: 'Index feuille',
                local_event_hash: "Hachage d'événement local",
                show_inclusion: "Afficher le chemin d'inclusion",
                hide_inclusion: "Masquer le chemin d'inclusion",
                privacy_note: "La charge utile est hachée ; Aucune donnée personnelle n'a été laissée à ComplianceOne pour cet événement.",
                verify_now: 'Vérifiez maintenant',
                verify_pending: 'Vérification en cours…',
                verify_verified: 'Vérifié – les contrôles locaux + côté chaîne ont été réussis.',
                verify_issue_prefix: 'Problème de vérification :',
                verify_failed: "L'appel de vérification a échoué.",
                verify_result_prefix: 'Verdict de vérification : ',
                verify_pending_note: "Vérification en attente : cette preuve est toujours en attente d'ancrage en chaîne. Réessayez une fois le lot scellé.",
                awaiting_anchor_note: "Cette épreuve fait partie d'un lot ouvert. La vérification devient disponible une fois que le lot est scellé et ancré dans la chaîne, généralement dans la fenêtre de lot configurée par l'organisation. Le badge de statut sera mis à jour automatiquement.",
                terminal_error_note: "Cette preuve n’a pas réussi à s’ancrer. Le réconciliateur de statut de preuve réessayera automatiquement ; la vérification manuelle n'a encore rien à vérifier.",
            },
            integrity_center: {
                section_run: 'Exécuter la vérification',
                section_progress: 'Exécuter la progression',
                section_issues: 'Problèmes',
                period_start: 'Début des règles',
                period_end: 'Fin de période',
                module_filter: 'Modules (séparés par des virgules, facultatif)',
                modules_placeholder: 'rights_requests, incidents',
                run_button: 'Exécuter la vérification',
                export_button: "Pack d'intégrité à l'exportation",
                export_success: "Pack d'intégrité exporté.",
                export_failed: "L'exportation a échoué.",
                empty_disabled: "Activez les pistes d'audit immuables dans les paramètres pour exécuter des passes de vérification.",
                error_period_required: 'Choisissez une date de début et de fin.',
                error_start_run: "Échec du démarrage de l'exécution.",
                processed: 'Traité : [[TOK_2]] sur [[TOK_3]]',
                col_verdict: 'Verdict',
                col_count: 'Compter',
                col_proof_link: 'Lien de preuve',
                col_module: 'Module',
                col_event_type: "Type d'événement",
                col_expected: 'Hachage attendu',
                col_recomputed: 'Hachage recalculé',
                col_raised_at: 'Élevé à',
                any_verdict: 'Tout verdict',
                no_issues: 'Aucun problème trouvé.',
            },
            settings_page: {
                load_error: 'Échec du chargement des paramètres.',
                save: 'Enregistrer',
                save_success: 'Paramètres enregistrés.',
                save_error: "L'enregistrement a échoué.",
                discard: 'Ignorer les modifications',
                read_only_banner: "Vous disposez d'un accès en lecture seule. Contactez un administrateur de plateforme pour apporter des modifications.",
                section_status: 'Statut et activation',
                enabled_label: 'Module complémentaire activé',
                enabled_help: "Lorsqu'il est activé, chaque événement d'audit de niveau A et B est haché et ancré.",
                section_scope: 'Portée',
                scope_self: 'Soi seulement',
                scope_self_and_children: 'Organisations autonomes et enfants',
                scope_children_only: 'Enfants uniquement (le parent ne prouve pas ses propres événements)',
                section_mode: 'Mode de preuve par défaut',
                mode_direct: 'Direct (un présentateur par événement)',
                mode_batch: 'Lot (ancre Merkle-root par groupe)',
                mode_hybrid: 'Hybride (registre par classe par défaut)',
                batch_window_label: 'Fenêtre de lot (minutes, 1 à 60)',
                section_taxonomy: 'Taxonomie des événements protégés',
                taxonomy_help: 'Remplacements de classe par événement. Niveau A → mode direct, Niveau B → mode batch, Désactivé → non vérifié.',
                taxonomy_search: 'Remplacements de recherche',
                taxonomy_reset: 'Réinitialiser aux valeurs par défaut',
                taxonomy_event_class: "Classe d'événement",
                taxonomy_override: 'Remplacer',
                taxonomy_actions: 'Actions',
                taxonomy_clear: 'Effacer',
                taxonomy_no_overrides: 'Aucun remplacement : utilisation des valeurs par défaut du registre.',
                taxonomy_add_class: 'event_class.code',
                taxonomy_add: 'Ajouter un remplacement',
                section_privacy: 'Contrôles de confidentialité',
                privacy_log_actor_ip: "Enregistrer l'adresse IP de l'acteur",
                privacy_log_user_agent: 'Agent utilisateur du journal',
                privacy_privileged_access_proofing: 'Preuve de lectures à accès privilégié (niveau A)',
                privacy_note: 'Les modifications s’appliquent uniquement de manière prospective.',
                section_caps: 'Plafonds et limites',
                cap_label: 'Plafond mensuel (unités ; vide = illimité)',
                warn_label: "Seuil d'avertissement (unités ; doit être inférieur au plafond)",
                auto_pause_label: 'Mettre automatiquement en pause les nouvelles épreuves une fois le plafond atteint',
                section_export: "Accès à l'exportation",
                export_help: "ID de rôle autorisés à exporter des packs d’intégrité. Séparés par des virgules ; vide = utiliser l'autorisation par défaut IMMUTABLE_AUDIT_TRAILS_EXPORT.",
                section_group: 'Participation de groupe',
                group_view_intro: 'Vous êtes configuré en tant que parent du groupe. Chaque organisation enfant contrôle sa propre activation/désactivation ; leurs décisions sont répercutées sur votre facturation conformément aux règles de facturation de groupe.',
                group_view_rule_enabled: "Un enfant avec activé=false est affiché comme « Ne participe pas ». Vous voyez l'absence; l'enfant contrôle la bascule.",
                group_view_rule_billing: "La consommation des enfants s'étend à votre plafond mensuel. Regardez la page Utilisation pour surveiller le taux de combustion combiné.",
                group_view_rule_edit: 'Vous ne pouvez pas modifier les paramètres d’un enfant à partir de cette page. Ouvrez directement l’organisation enfant pour la modifier.',
                group_view_open_groups: 'Groupes organisationnels ouverts',
                section_credentials: "Informations d'identification",
                credential_id: "Identifiant d'identification",
                credential_rotated_at: 'Dernière rotation',
                rotate_button: "Rotation des informations d'identification",
                rotate_success: "Les informations d'identification ont fait l'objet d'une rotation. Ancien identifiant valide pour [[TOK_1]] minutes supplémentaires.",
                rotate_failed: "La rotation des informations d'identification a échoué.",
                rotate_modal_title: "Changer l'identifiant [[TOK_0]] ?",
                rotate_modal_body: "La rotation délivre un nouveau titre. L'ancien identifiant reste accepté par [[TOK_0]] pendant une période de grâce de 60 minutes afin que les travailleurs en vol puissent terminer leur travail actuel. Après 60 minutes, l'ancien identifiant est révoqué.",
                rotate_modal_confirm: 'Faites pivoter maintenant',
                tier_a_off_modal_title: "Désactiver la vérification linguistique pour une classe d'événement ?",
                tier_a_off_modal_body: "La définition d'une classe d'événements sur « Désactivé » empêche le test d'ancrer ces événements. L'architecture §6 explique l'implication réglementaire : les événements de niveau A sont pertinents pour le régulateur ; les désactiver peut briser la défendabilité de votre piste d'audit.",
                tier_a_off_modal_confirm: 'Je comprends - appliquer le remplacement',
                error_warn_lt_cap: "Le seuil d'avertissement doit être inférieur au plafond mensuel.",
                error_window_range: 'La fenêtre de lot doit être comprise entre 1 et 60 minutes.',
                error_run_in_progress: 'Une vérification est en cours ; Je ne peux pas désactiver le module complémentaire pour le moment.',
            },
            status_page: {
                filter_status: 'Statut',
                filter_mode: 'Mode preuve',
                filter_module: 'Module',
                filter_source_collection: 'Collection de sources',
                filter_from_date: 'De',
                filter_to_date: 'À',
                filter_search: 'Rechercher',
                any_status: "N'importe quel statut",
                any_mode: "N'importe quel mode",
                col_module: 'Module',
                col_event_type: "Type d'événement",
                col_proof_status: 'Statut',
                col_proof_mode: 'Mode',
                col_created_at: 'Créé',
                col_units: 'Unités',
                empty_disabled: 'Le module complémentaire Immutable Audit Trails n’est pas activé pour votre organisation. Visitez Paramètres pour l’activer.',
                empty_enabled_no_rows: 'Aucun lien de preuve ne correspond aux filtres actuels.',
                export_csv: 'Exporter [[TOK_0]]',
                export_xlsx: 'Exporter [[TOK_0]]',
                export_success: 'Exportation terminée',
                export_failed: "Échec de l'exportation",
            },
            usage_page: {
                section_alerts: 'Alertes',
                alert_dismiss: 'Rejeter',
                alert_dismiss_aria: "Ignorer l'alerte [[TOK_1]]",
                alert_dismissed: 'Alerte rejetée',
                alert_dismiss_failed: "Échec de la suppression de l'alerte",
                section_balance: 'Solde créditeur',
                balance_label: 'Crédits disponibles',
                balance_hint: "Unités restantes (1 unité = 1 preuve d'événement protégé).",
                section_current_month: 'Mois en cours',
                consumed_label: 'Consommé',
                granted_label: 'Accordé',
                refunded_label: 'Remboursé',
                net_label: 'Filet',
                section_history: "Historique d'utilisation",
                history_kind: 'Genre',
                history_units: 'Unités',
                history_balance_after: 'Solde après',
                history_notes: 'Remarques',
                history_at: 'Quand',
                cap_warning_banner: "Vous avez dépassé votre seuil d'avertissement pour ce mois de facturation. Pensez à utiliser des crédits supplémentaires.",
                cap_paused_banner: 'Plafond mensuel atteint. Les soumissions de preuves sont suspendues jusqu’au mois prochain ou jusqu’à ce que le plafond soit augmenté.',
                section_redeem: 'Échanger un forfait de crédits',
                redeem_purchase_id: 'Numéro de facture',
                redeem_package: 'Forfait',
                redeem_button: 'Échanger',
                redeem_pending: 'Rachat…',
                redeem_success: 'Crédits échangés',
                redeem_failed: "Échec de l'échange",
                redeem_option_template: '[[TOK_4]] — [[TOK_5]] [[TOK_6]] — [[TOK_7]]',
                redeem_option_units: 'unités',
                alert_dismissing: 'Rejeter…',
                alert_kind: {
                    cap_reached: 'Plafond mensuel atteint',
                    low_balance: 'Solde faible',
                    auth_failure: "Échec d'authentification",
                    merkle_mismatch: 'Inadéquation de Merkle',
                    batch_terminal_failure: 'Panne du terminal batch',
                    direct_terminal_failure: 'Échec du terminal de soumission directe',
                },
                usage_kind: {
                    consume: 'Consommer',
                    refund: 'Remboursement',
                    grant: 'Subvention',
                    adjustment: 'Ajustement',
                    reservation: 'Réservation',
                },
                package_starter: 'Démarreur',
                package_growth: 'Croissance',
                package_enterprise: 'Entreprise',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Acheter plus de crédits',
                    purchase_title: 'Acheter plus de crédits',
                    purchase_subtitle: 'Choisissez un forfait. Vous serez redirigé vers le paiement sécurisé Stripe, et votre facture vous parviendra par e-mail.',
                    checkout_button: 'Continuer vers le paiement',
                    checkout_pending: 'Ouverture du paiement…',
                    cancel_button: 'Annuler',
                    purchase_error: 'Impossible de démarrer le paiement. Veuillez réessayer dans un instant.',
                    redeem_subtitle: "Déjà payé ? Sélectionnez le forfait que vous avez acheté et saisissez l'identifiant de facture reçu par e-mail pour ajouter les crédits.",
                    error_not_found: "Aucune facture n'a été trouvée avec ce numéro. Vérifiez le numéro de facture et réessayez.",
                    error_not_paid: "Cette facture n'est pas encore marquée comme payée.",
                    error_org_mismatch: "Cette facture n'a pas été émise à votre organisation.",
                    error_package_mismatch: 'Cette facture ne correspond pas au forfait sélectionné.',
                    error_billing_unavailable: 'Impossible de joindre le service de facturation. Veuillez réessayer dans un instant.',
                },
            },
        },
        files_config: {
            title: 'Configuration des fichiers',
            subtitle: 'Configurez les limites de téléchargement de fichiers, les politiques de rétention et les remplacements par type de propriétaire pour la surface des pièces jointes de la plateforme.',
            section_global: 'Valeurs par défaut globales',
            section_global_help: "Ces limites s'appliquent à chaque fichier téléchargé par les utilisateurs de votre organisation, à moins qu'un remplacement par type de propriétaire ci-dessous ne les modifie.",
            section_overrides: 'Remplacements par type de propriétaire',
            section_overrides_help: "Remplacez les limites globales pour un type de propriétaire spécifique. Les valeurs de type par propriétaire l'emportent toujours sur le paramètre global.",
            max_file_size_label: 'Taille maximale du fichier',
            max_file_size_hint: 'Par téléchargement individuel (MiB)',
            max_total_attachments_label: 'Nombre total maximum de pièces jointes',
            max_total_attachments_hint: 'Dans toute l’organisation',
            max_total_size_label: 'Stockage total maximum',
            max_total_size_hint: 'Dans l’ensemble de l’organisation (MiB)',
            allowed_mime_types_label: 'Types de fichiers autorisés',
            allowed_mime_types_placeholder: 'Sélectionnez les types MIME',
            retention_days_label: 'Période de conservation (jours)',
            retention_days_hint: 'Combien de temps les fichiers doivent être conservés avant de pouvoir être supprimés. Laissez vide pour aucune politique de rétention.',
            legal_hold_label: 'Mise en attente légale',
            legal_hold_hint: "Lorsqu'elle est activée, la suppression définitive d'un fichier de ce type de propriétaire nécessite l'autorisation légale de remplacement et l'adhésion explicite de l'opérateur.",
            save: 'Enregistrer les modifications',
            saving: 'Sauvegarde…',
            reset: 'Réinitialiser',
            save_success: 'Paramètres enregistrés',
            save_version_conflict: 'Un autre opérateur a mis à jour ces paramètres pendant que vous étiez en train de modifier. Rechargez pour voir les dernières valeurs.',
            empty_state_title: 'Utilisation des paramètres par défaut de la plateforme',
            empty_state_body: "Votre organisation s'exécute actuellement sur la stratégie de fichiers par défaut de la plateforme. Modifiez n'importe quelle valeur ci-dessous pour créer un remplacement au niveau de l'organisation.",
            read_only_banner: "Vous disposez d'un accès en lecture seule à la configuration des fichiers. Contactez un administrateur de plateforme pour apporter des modifications.",
            owner_type_default_badge: 'Par défaut',
            owner_type_overridden_badge: 'Remplacé',
            owner_type_label: 'Type de propriétaire',
            owner_type_collapse: 'Réduire',
            owner_type_expand: 'Développer',
            override_save: 'Enregistrer le remplacement',
            override_remove: 'Supprimer le remplacement',
            mime_labels: {
                'application/pdf': '[[TOK_0]] document',
                'image/png': 'Image PNG',
                'image/jpeg': 'Image JPEG',
                'image/jpg': 'Image JPG',
                'application/msword': 'Document Word (ancien)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Document Word',
                'application/vnd.ms-excel': 'Feuille de calcul Excel (ancienne version)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Feuille de calcul Excel',
                'text/csv': 'Fichier [[TOK_0]]',
                'text/plain': 'Texte brut',
                'message/rfc822': 'Message électronique',
            },
        },
        files_browser: {
            title: 'Navigateur de fichiers',
            subtitle: "Recherchez, filtrez et gérez chaque pièce jointe téléchargée dans l'ensemble de l'organisation.",
            filter_owner_type: 'Type de propriétaire',
            filter_uploader: 'Téléchargé par',
            filter_from: 'Téléchargé après',
            filter_to: 'Téléversé avant',
            filter_size_min: 'Taille minimale (Mio)',
            filter_size_max: 'Taille maximale (Mio)',
            filter_mime: 'Type de fichier',
            filter_deleted_state: 'État de suppression',
            filter_deleted_any: 'Tous les fichiers',
            filter_deleted_only: 'Seulement supprimé',
            filter_deleted_exclude: 'Exclure supprimé',
            filter_orphaned: 'Orphelin seulement',
            filter_search_placeholder: 'Rechercher le nom du fichier…',
            filter_apply: 'Appliquer des filtres',
            filter_clear: 'Effacer les filtres',
            col_filename: 'Nom du fichier',
            col_owner_type: 'Type de propriétaire',
            col_owner_entity: 'Propriétaire',
            col_uploader: 'Téléchargé par',
            col_uploaded_at: 'Téléchargé',
            col_size: 'Taille',
            col_mime: 'Tapez',
            col_state: 'État',
            col_actions: 'Actions',
            state_active: 'Actif',
            state_deleted: 'Supprimé',
            state_orphaned: 'Orphelin',
            action_view_detail: 'Afficher les détails',
            action_download: 'Télécharger',
            action_ai_edits: '[[TOK_0]] Modifications',
            action_soft_delete: 'Suppression logicielle',
            action_restore: 'Restaurer',
            action_hard_delete: 'Suppression définitive',
            bulk_soft_delete: 'Suppression logicielle sélectionnée',
            bulk_export_csv: 'Exporter [[TOK_0]]',
            bulk_select_all: 'Tout sélectionner',
            reason_label: 'Raison',
            reason_min_10_chars: 'Le motif est requis (au moins 10 caractères)',
            reason_min_20_chars: 'Le motif est requis (au moins 20 caractères)',
            legal_hold_override_label: 'Remplacer la conservation légale',
            legal_hold_override_warning: "Ce fichier est sous conservation légale. La suppression définitive sera enregistrée dans la piste d'audit avec votre motif et votre indicateur de remplacement.",
            empty_state_title: 'Aucun fichier ne correspond à vos filtres',
            empty_state_body: 'Ajustez vos filtres pour voir les résultats ou effacez-les pour afficher tous les fichiers.',
            pagination_prev: 'Précédent',
            pagination_next: 'Suivant',
            pagination_page: 'Page [[TOK_2]] sur [[TOK_3]]',
            pagination_size_label: 'Par page',
            pagination_total: 'Total : [[TOK_1]]',
            toast_soft_deleted: 'Fichier supprimé de manière logicielle',
            toast_restored: 'Fichier restauré',
            toast_hard_deleted: 'Fichier définitivement supprimé',
            toast_bulk_deleted: '[[TOK_1]] fichier(s) supprimé(s)',
            toast_error: "L'opération a échoué",
            confirm_soft_delete_title: 'Fichier de suppression logicielle',
            confirm_restore_title: 'Restaurer le fichier',
            confirm_hard_delete_title: 'Supprimer définitivement le fichier',
            confirm_bulk_soft_delete_title: 'Supprimer les fichiers sélectionnés',
            confirm_submit: 'Confirmer',
            confirm_cancel: 'Annuler',
        },
        files_detail: {
            modal_title: 'Détails du fichier',
            close: 'Fermer',
            meta_filename: 'Nom du fichier',
            meta_size: 'Taille',
            meta_mime: 'Tapez',
            meta_owner_type: 'Type de propriétaire',
            meta_owner_entity: 'Entité propriétaire',
            meta_uploader: 'Téléchargé par',
            meta_uploaded_at: 'Téléchargé',
            meta_storage_path: 'Chemin de stockage',
            meta_deleted_state: 'État de suppression',
            audit_section_title: "Piste d'audit",
            audit_load_more: "Charger plus d'événements",
            audit_empty: "Aucun événement d'audit enregistré pour ce fichier.",
            audit_config_changed: 'Configuration modifiée',
            audit_soft_deleted: 'Suppression logicielle',
            audit_restored: 'Restauré',
            audit_hard_deleted: 'Supprimé définitivement',
            audit_downloaded: 'Téléchargé',
            audit_quota_breached: 'Tentative de violation du quota',
            action_download: 'Télécharger',
            action_soft_delete: 'Suppression logicielle',
            action_restore: 'Restaurer',
            action_hard_delete: 'Suppression définitive',
            effective_settings_title: 'Politique efficace',
            effective_max_file_size: 'Taille maximale du fichier',
            effective_retention_days: 'Rétention',
            effective_legal_hold: 'Mise en attente légale',
            effective_legal_hold_yes: 'Actif',
            effective_legal_hold_no: 'Aucun',
        },
        files_dashboard: {
            title: 'Tableau de bord des fichiers',
            subtitle: 'Utilisation du stockage, croissance et fichiers orphelins dans toute l’organisation.',
            kpi_total_files: 'Total des fichiers',
            kpi_total_size: 'Stockage total',
            kpi_near_quota: 'Utilisation des quotas',
            kpi_orphaned: 'Fichiers orphelins',
            chart_by_owner_type: 'Fichiers par type de propriétaire',
            chart_growth_30d: 'Croissance sur 30 jours',
            toggle_count: 'Par comptage',
            toggle_size: 'Par taille',
            orphaned_panel_title: 'Fichiers orphelins (top 20)',
            orphaned_view_all: 'Afficher tous les fichiers orphelins',
            orphaned_empty: 'Aucun fichier orphelin trouvé.',
            growth_empty: 'Aucune activité de téléchargement au cours des 30 derniers jours.',
            retention_n_days: '[[TOK_1]] jour(s)',
            retention_none: 'Aucune politique',
        },
    },
    category_labels: {
        'user-guide': "Guide de l'utilisateur",
        'admin-guide': "Guide d'administration",
        'getting-started': 'Commencer',
        faq: 'FAQ',
    },
    tag_labels: {
        faq: 'FAQ',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': '[[TOK_0]] Clés',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        admin: 'Administrateur',
        aesirx: 'AesirX',
        purposes: 'Objectifs',
        preferences: 'Préférences',
        onboarding: 'Intégration',
        'first-steps': 'Premiers pas',
        login: 'Connexion',
        navigation: 'Navigation',
        users: 'Utilisateurs',
        user: 'Utilisateur',
        roles: 'Rôles',
        role: 'Rôle',
        'access-control': "Contrôle d'accès",
        'access-management': 'Gestion des accès',
        permissions: 'Autorisations',
        permission: 'Autorisation',
        consent: 'Consentement',
        'consent-management': 'Gestion du consentement',
        privacy: 'Confidentialité',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Vérification',
        auditing: 'Audit',
        breach: 'Violation',
        incident: 'Incident',
        incidents: 'Incidents',
        notification: 'Notification',
        notifications: 'Notifications',
        reporting: 'Rapports',
        risk: 'Risque',
        vendor: 'Vendeur',
        vendors: 'Vendeurs',
        'vendor-risk': 'Risque du fournisseur',
        assessment: 'Évaluation',
        assessments: 'Évaluations',
        dpia: 'DPIA',
        'cross-border': 'Transfrontalier',
        transfer: 'Transfert',
        transfers: 'Transferts',
        deletion: 'Suppression',
        retention: 'Rétention',
        'data-mapping': 'Cartographie des données',
        discovery: 'Découverte',
        classification: 'Classement',
        workflow: 'Flux de travail',
        workflows: 'Flux de travail',
        template: 'Modèle',
        templates: 'Modèles',
        catalog: 'Catalogue',
        monitoring: 'Surveillance',
        tasks: 'Tâches',
        task: 'Tâche',
        'task-management': 'Gestion des tâches',
        organizations: 'Organisations',
        org: 'Organisation',
        governance: 'Gouvernance',
        compliance: 'Conformité',
        forms: 'Formulaires',
        form: 'Formulaire',
        connectors: 'Connecteurs',
        connector: 'Connecteur',
        integration: 'Intégration',
        integrations: 'Intégrations',
        security: 'Sécurité',
        encryption: 'Cryptage',
        backup: 'Sauvegarde',
        recovery: 'Récupération',
        maintenance: 'Entretien',
        settings: 'Paramètres',
        configuration: 'Configuration',
        sla: 'SLA',
        escalation: 'Escalade',
        remediation: 'Assainissement',
        evidence: 'Preuve',
        'case-management': 'Gestion de cas',
        profile: 'Profil',
        delegation: 'Délégation',
        'service-accounts': 'Comptes de services',
        license: 'Licence',
        'license-management': 'Gestion des licences',
        plan: 'Planifier',
        plans: 'Forfaits',
        dashboard: 'Tableau de bord',
        'web-consent': 'Consentement Web',
        'partner-marketplace': 'Marché des partenaires',
        partner: 'Partenaire',
        partners: 'Partenaires',
        deliverables: 'Livrables',
        'service-tiers': 'Niveaux de service',
        'support-tickets': "Billets d'assistance",
        'audit-trail': "Piste d'audit",
        'first-time-setup': 'Configuration initiale',
        setup: 'Configuration',
        quickstart: 'Démarrage rapide',
        tour: 'Visite',
        tours: 'Visites',
        'sample-data': 'Exemples de données',
        'data-subject': 'Personne concernée',
        'data-subjects': 'Personnes concernées',
        pseudonymous: 'Pseudonyme',
        identified: 'Identifié',
        'help-center': "Centre d'aide",
        article: 'Article',
        articles: 'Articles',
        search: 'Rechercher',
        'platform-settings': 'Paramètres de la plateforme',
        'platform-config': 'Configuration de la plateforme',
        'module-config': 'Configuration des modules',
        'module-configuration': 'Configuration des modules',
        'rights-requests': 'Demandes de droits',
        'access-accountability': 'Responsabilité d’accès',
        'data-discovery': 'Découverte de données',
        'incident-ops': 'Opérations sur les incidents',
        'deletion-orchestration': 'Orchestration de la suppression',
        'compliance-forms': 'Formulaires de conformité',
        'program-governance': 'Gouvernance du programme',
        localization: 'Localisation',
        'privacy-scanner': 'Scanner de confidentialité',
        'consent-properties': 'Propriétés du consentement',
        acceptances: 'Acceptations',
        access: 'Accès',
        'access-review': "Examen de l'accès",
        'access-reviews': 'Accès aux avis',
        accountability: 'Responsabilité',
        acknowledgment: 'Remerciement',
        'action-plans': "Plans d'action",
        activation: 'Activation',
        activations: 'Activations',
        'active-response': 'Réponse active',
        activity: 'Activité',
        adequacy: 'Adéquation',
        'admin-guide': "Guide d'administration",
        aggregation: 'Agrégation',
        agreements: 'Accords',
        ai: 'AI',
        alerts: 'Alertes',
        analytics: 'Analyse',
        anchoring: 'Ancrage',
        approval: 'Approbation',
        approvals: 'Approbations',
        apps: 'Applications',
        assets: 'Actifs',
        assignments: 'Missions',
        attestation: 'Attestation',
        'audit-log': "Journal d'audit",
        'audit-pack': "Pack d'audit",
        authentication: 'Authentification',
        authority: 'Autorité',
        'auto-play': 'Lecture automatique',
        automated: 'Automatisé',
        automation: 'Automatisation',
        baseline: 'Référence',
        batches: 'Lots',
        bidirectional: 'Bidirectionnel',
        bilingual: 'Bilingue',
        bindings: 'Reliures',
        blockchain: 'Chaîne de blocs',
        board: 'Conseil',
        brand: 'Marque',
        brds: 'BRD',
        'break-glass': 'Briser la vitre',
        builder: 'Constructeur',
        bulk: 'En vrac',
        'bulk-sync': 'Synchronisation groupée',
        bundles: 'Forfaits',
        calendar: 'Calendrier',
        campaigns: 'Campagnes',
        cases: 'Cas',
        categories: 'Catégories',
        category: 'Catégorie',
        certification: 'Attestation',
        chain: 'Chaîne',
        change: 'Changement',
        'change-awareness': 'Sensibilisation au changement',
        'change-log': 'Journal des modifications',
        'change-management': 'Gestion du changement',
        'change-requests': 'Demandes de changement',
        'cmp-validation': '[[TOK_0]] Validation',
        collection: 'Collecte',
        comparison: 'Comparaison',
        completeness: 'exhaustivité',
        completion: 'Achèvement',
        'compliance-posture': 'Posture de conformité',
        'compliance-proof': 'Preuve de conformité',
        'compliance-reviews': 'Examens de conformité',
        config: 'Configuration',
        confirmation: 'Confirmation',
        conflicts: 'Conflits',
        consolidation: 'Consolidation',
        continuous: 'Continu',
        contracts: 'Contrats',
        controls: 'Contrôles',
        cookies: 'Biscuits',
        cooperation: 'Coopération',
        coordination: 'Coordination',
        'corporate-governance': "Gouvernance d'entreprise",
        'corrective-actions': 'Actions correctives',
        coverage: 'Couverture',
        'credential-vault': "Coffre-fort d'informations d'identification",
        credentials: "Informations d'identification",
        cycles: 'Cycles',
        dashboards: 'Tableaux de bord',
        'data-assets': 'Actifs de données',
        'data-flows': 'Flux de données',
        'data-sensitivity': 'Sensibilité des données',
        'data-steward': 'Gestionnaire de données',
        deadlines: 'Délais',
        'decree-356': 'Décret 356',
        dedup: 'Déduplication',
        definitions: 'Définitions',
        deliverable: 'Livrable',
        departments: 'Départements',
        'dependency-order': 'Ordre de dépendance',
        deployment: 'Déploiement',
        detection: 'Détection',
        diff: 'Différence',
        'digital-properties': 'Propriétés numériques',
        dimensions: 'Dimensions',
        disable: 'Désactiver',
        'disaster-recovery': 'Reprise après sinistre',
        disclosure: 'Divulgation',
        documentation: 'Documentation',
        documents: 'Documents',
        domains: 'Domaines',
        dossier: 'Dossier',
        dpa: 'DPA',
        drift: 'Dérive',
        'drift-detection': 'Détection de dérive',
        'due-diligence': 'Diligence raisonnable',
        email: 'Email',
        emergency: 'Urgence',
        enable: 'Activer',
        'enterprise-map': "Carte d'entreprise",
        erasure: 'Effacement',
        evaluation: 'Évaluation',
        'event-bus': 'Bus événementiel',
        exceptions: 'Exceptions',
        execution: 'Exécution',
        executive: 'Exécutif',
        exercises: 'Exercices',
        export: 'Exporter',
        exports: 'Exportations',
        filing: 'Dépôt',
        filter: 'Filtrer',
        filtering: 'Filtrage',
        findings: 'Résultats',
        flows: 'Flux',
        'follow-up': 'Suivi',
        forensic: 'Forensique',
        forensics: 'Médecine légale',
        'form-filler': 'Remplisseur de formulaire',
        framework: 'Cadre',
        frameworks: 'Cadres',
        'gap-analysis': 'Analyse des écarts',
        'gap-report': "Rapport d'écart",
        gaps: 'Lacunes',
        gates: 'Portes',
        'getting-started': 'Commencer',
        'golden-templates': 'Modèles dorés',
        grc: 'GRC',
        'group-management': 'Gestion de groupe',
        groups: 'Groupes',
        'guided-tours': 'Visites guidées',
        guides: 'Guides',
        handling: 'Manipulation',
        'hands-on': 'Pratique',
        health: 'Santé',
        help: 'Aide',
        hierarchy: 'Hiérarchie',
        history: 'Histoire',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': "Fournisseur d'identité",
        implementation: 'Mise en œuvre',
        import: 'Importer',
        improvement: 'Amélioration',
        'incident-response': 'Réponse aux incidents',
        inconsistencies: 'Incohérences',
        instances: 'Instances',
        intake: 'Admission',
        'intake-key': "Clé d'admission",
        interactive: 'Interactif',
        international: 'Internationale',
        inventory: 'Inventaire',
        investigation: 'Enquête',
        investigations: 'Enquêtes',
        'ip-allowlist': "Liste d'adresses IP autorisées",
        issues: 'Problèmes',
        justification: 'Justification',
        justifications: 'Justifications',
        kanban: 'Kanban',
        keyboard: 'Clavier',
        keys: 'Clés',
        'knowledge-base': 'Base de connaissances',
        koncernstyring: "Gouvernance d'entreprise",
        kpi: 'KPI',
        labeling: 'Étiquetage',
        language: 'Langue',
        'language-packs': 'Packs de langue',
        languages: 'Langues',
        lawfulness: 'Légalité',
        layout: 'Disposition',
        'legal-basis': 'Base juridique',
        'lessons-learned': 'Leçons apprises',
        levels: 'Niveaux',
        library: 'Bibliothèque',
        lifecycle: 'Cycle de vie',
        lineage: 'Lignée',
        links: 'Liens',
        listings: 'Annonces',
        live: 'En direct',
        locale: 'Paramètres régionaux',
        log: 'Log',
        logging: 'Journalisation',
        'managed-service': 'Service géré',
        mapping: 'Cartographie',
        mappings: 'Mappages',
        'market-packs': 'Packs de marché',
        marketplace: 'Marché',
        maturity: 'Maturité',
        metrics: 'Métriques',
        models: 'Modèles',
        module: 'Module',
        modules: 'Modules',
        mps: 'MPS',
        'multi-factor': 'Multi-Facteur',
        'multi-market': 'Multi-marchés',
        'multi-org': 'Multi-organisation',
        'multi-property': 'Multi-propriété',
        'my-tasks': 'Mes tâches',
        obligations: 'Obligations',
        offboarding: 'Débarquement',
        oidc: 'OIDC',
        orchestration: 'Orchestration',
        'org-groups': 'Groupes organisationnels',
        organization: 'Organisation',
        overdue: 'En retard',
        overview: 'Aperçu',
        'owner-review': 'Examen du propriétaire',
        package: 'Forfait',
        packages: 'Forfaits',
        packs: 'Packs',
        pagination: 'Pagination',
        'parent-child': 'Parent-Enfant',
        patterns: 'Modèles',
        performance: 'Performances',
        periodic: 'Périodique',
        periods: 'Périodes',
        personal: 'Personnel',
        'personal-data': 'Données personnelles',
        personas: 'Personnages',
        planning: 'Planification',
        platform: 'Plateforme',
        playbooks: 'Manuels de jeu',
        poc: 'PoC',
        'point-in-time': 'Point dans le temps',
        policies: 'Politiques',
        portfolio: 'Portefeuille',
        'post-incident': "Après l'incident",
        'power-user': 'Utilisateur expérimenté',
        practice: 'Pratique',
        pricing: 'Tarifs',
        'privacy-impact': 'Impact sur la confidentialité',
        procedures: 'Procédures',
        processes: 'Processus',
        processing: 'Traitement',
        'processing-activities': 'Activités de traitement',
        procurement: 'Approvisionnement',
        productivity: 'Productivité',
        profiles: 'Profils',
        programs: 'Programmes',
        progress: 'Progrès',
        proof: 'Preuve',
        propagation: 'Propagation',
        properties: 'Propriétés',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Formulaire public',
        quality: 'Qualité',
        questionnaires: 'Questionnaires',
        'quick-links': 'Liens rapides',
        'quick-start': 'Démarrage rapide',
        'quick-starts': 'Démarrages rapides',
        raci: 'RACI',
        readiness: 'Préparation',
        'real-time': 'En temps réel',
        reassessments: 'Réévaluations',
        reconciliation: 'Réconciliation',
        record: 'Enregistrer',
        records: 'Enregistrements',
        recurring: 'Récurrent',
        register: "S'inscrire",
        registry: 'Registre',
        regulations: 'Règlements',
        regulator: 'Régulateur',
        regulatory: 'Réglementaire',
        'regulatory-frameworks': 'Cadres réglementaires',
        remap: 'Remapper',
        reminders: 'Rappels',
        reports: 'Rapports',
        requests: 'Demandes',
        requirements: 'Exigences',
        response: 'Réponse',
        'response-plans': 'Plans de réponse',
        'response-team': "Équipe d'intervention",
        'response-templates': 'Modèles de réponse',
        'response-time': 'Temps de réponse',
        responses: 'Réponses',
        responsibility: 'Responsabilité',
        results: 'Résultats',
        review: 'Examen',
        reviews: 'Avis',
        'right-to-delete': 'Droit de suppression',
        rights: 'Droits',
        'risk-tiers': 'Niveaux de risque',
        rollouts: 'Déploiements',
        rollup: 'Cumul',
        ropa: 'ROPA',
        routing: 'Routage',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Règles',
        runs: 'Fonctionne',
        saml: 'SAML',
        scan: 'Numériser',
        scanning: 'Numérisation',
        scc: 'SCC',
        schedule: 'Calendrier',
        scheduled: 'Programmé',
        schedules: 'Horaires',
        scheduling: 'Planification',
        scores: 'Partitions',
        scoring: 'Notation',
        scripts: 'Scripts',
        'security-reviews': 'Examens de sécurité',
        'sensitive-data': 'Données sensibles',
        sensitivity: 'Sensibilité',
        'separation-of-duties': 'Séparation des tâches',
        service: 'Service',
        sessions: 'Séances',
        'setup-wizard': 'Assistant de configuration',
        severity: 'Gravité',
        'shared-governance': 'Gouvernance partagée',
        'shared-settings': 'Paramètres partagés',
        shortcuts: 'Raccourcis',
        sidebar: 'Barre latérale',
        signals: 'Signaux',
        'single-sign-on': 'Authentification unique',
        snapshots: 'Instantanés',
        sod: 'SoD',
        sorting: 'Tri',
        sources: 'Sources',
        staging: 'Mise en scène',
        standards: 'Normes',
        status: 'Statut',
        structure: 'Structure',
        'sub-processor': 'Sous-traitant',
        'sub-processors': 'Sous-traitants',
        submissions: 'Soumissions',
        subprocessors: 'Sous-traitants',
        subscription: 'Abonnement',
        suggestions: 'Suggestions',
        summaries: 'Résumés',
        supplements: 'Suppléments',
        support: 'Assistance',
        sync: 'Synchroniser',
        system: 'Système',
        systems: 'Systèmes',
        tables: 'Tableaux',
        tagging: 'Marquage',
        'tamper-proof': 'Inviolable',
        taxonomies: 'Taxonomies',
        taxonomy: 'Taxonomie',
        tenants: 'Locataires',
        termination: 'Résiliation',
        'third-party': 'Tiers',
        'ticket-sync': 'Synchronisation des billets',
        tickets: 'Billets',
        tiers: 'Niveaux',
        tokens: 'Jetons',
        totp: 'TOTP',
        traceability: 'Traçabilité',
        tracking: 'Suivi',
        trail: 'Sentier',
        training: 'Formation',
        translation: 'Traduction',
        translations: 'Traductions',
        transparency: 'Transparence',
        trends: 'Tendances',
        unified: 'Unifié',
        updates: 'Mises à jour',
        validation: 'Validation',
        vault: 'Coffre-fort',
        'vendor-requests': 'Demandes des fournisseurs',
        verification: 'Vérification',
        versioning: 'Gestion des versions',
        versions: 'Versions',
        vietnam: 'Viêt Nam',
        violations: 'Violations',
        visualization: 'Visualisation',
        waivers: 'Renonciations',
        'web-records': 'Enregistrements Web',
        website: 'Site Web',
        websites: 'Sites Web',
        weights: 'Poids',
        'white-label': 'Marque blanche',
        withdrawal: 'Retrait',
    },
    module_labels: {
        rights_requests: "Demandes d'exercice des droits",
        data_mapping: 'Cartographie des données',
        governance: 'Gouvernance des prestataires',
        consent: 'Gouvernance du consentement',
        consent_properties: 'Propriétés du consentement',
        assessments: 'AIPD et évaluations',
        classification: 'Classification des données',
        monitoring: 'Programmes de surveillance',
        program: 'Programme de surveillance',
        incidents: 'Réponse aux incidents',
        connectors: 'Connecteurs',
        vendor_risk: 'Risque du fournisseur',
        deletion_orchestration: 'Orchestration de suppression',
        discovery: 'Découverte de données',
        incident_ops: "Opérations d'incidents",
        program_governance: 'Gouvernance de programme',
        access_accountability: 'Responsabilité des accès',
        localization: 'Localisation',
        partner_workspace: 'Espace de travail partenaire',
        privacy_scanner: 'Scanner de confidentialité',
        onboarding: 'Intégration',
        compliance_forms: 'Formulaires de Conformité',
        audit_trail: "Piste d'Audit",
        data_subjects: 'Personnes concernées',
        organizations: 'Organisations',
        task_management: 'Gestion des tâches',
        deletion_orch: 'Orchestration de suppression',
        forms: 'Formulaires de conformité',
        partner_marketplace: 'Place de marché partenaires',
        dashboard: 'Tableau de bord',
        platform_settings: 'Paramètres de la plateforme',
        help_center: "Centre d'aide",
    },
    module_descriptions: {
        rights_requests: "Gérez les demandes d'exercice des droits des personnes concernées, y compris l'accès, la suppression et la portabilité. Suivez le cycle de vie des demandes, attribuez des responsables et respectez les délais réglementaires.",
        data_mapping: 'Cartographiez les flux de données dans votre organisation. Suivez les activités de traitement, les catégories de données, les finalités, les politiques de conservation et les intégrations système.',
        governance: 'Gérez la conformité et la gouvernance des prestataires. Suivez les évaluations des prestataires, les contrats, la performance des SLA et les obligations réglementaires.',
        consent: "Gérez la collecte, le stockage et le retrait du consentement. Suivez les enregistrements de consentement, les finalités et l'intégration avec les plateformes de gestion du consentement.",
        consent_properties: 'Configurez les propriétés de consentement, les groupes et les modèles de référence. Définissez des configurations de consentement réutilisables pour un déploiement cohérent.',
        assessments: "Réalisez des Analyses d'Impact relatives à la Protection des Données (AIPD) et des évaluations des risques de confidentialité. Évaluez les activités de traitement pour identifier les risques de conformité.",
        classification: 'Classifiez les actifs de données par niveau de sensibilité. Appliquez des étiquettes taxonomiques, suivez les enregistrements du cycle de vie et identifiez les lacunes de classification.',
        monitoring: "Mettez en place des programmes de surveillance pour suivre les indicateurs de conformité, les indicateurs clés de risque et l'efficacité des contrôles dans le temps.",
        incidents: "Signalez et gérez les incidents de confidentialité et les violations de données. Suivez les processus d'enquête, de notification et de remédiation.",
        connectors: 'Configurez les connecteurs de sources de données et les intégrations. Connectez des systèmes externes pour la découverte automatisée des données et la surveillance.',
        vendor_risk: "Évaluez et surveillez les risques des prestataires tiers. Notez les prestataires, suivez l'atténuation des risques et gérez les configurations de risque des prestataires.",
        deletion_orchestration: 'Orchestrez la suppression des données dans tous les systèmes. Suivez les demandes de suppression, vérifiez les chaînes de preuves et assurez la suppression complète des données.',
        discovery: 'Découvrez les données personnelles dans les systèmes connectés. Analysez les sources de données pour constituer un inventaire complet des données.',
        incident_ops: "Gestion opérationnelle des incidents avec des manuels de procédures, des processus d'escalade et un suivi des SLA pour la résolution des incidents.",
        program_governance: "Suivez la maturité globale du programme de confidentialité, les scores de conformité, les lacunes en matière de preuves et les rapports à la direction dans l'ensemble de votre organisation.",
        access_accountability: "Enquêtez et auditez les modèles d'accès des utilisateurs. Suivez les configurations d'accès, surveillez les activités suspectes et appliquez la responsabilisation.",
        localization: 'Installez et gérez les packs de localisation de marché. Ajoutez des cadres réglementaires, des packs linguistiques et du contenu de conformité spécifique à chaque région.',
        partner_workspace: 'Collaborez avec des partenaires externes. Partagez des données de conformité, suivez les obligations des partenaires et gérez les relations partenaires.',
        privacy_scanner: "Analysez les sites web pour détecter les problèmes de conformité en matière de confidentialité. Surveillez l'utilisation des cookies, les scripts de suivi et la présence de politiques de confidentialité en temps réel.",
        onboarding: "Guidez les nouvelles organisations dans la configuration de la plateforme. Assistant d'intégration étape par étape pour la configuration initiale et l'importation des données.",
        compliance_forms: "Créez et gérez des formulaires de conformité à partir d'un catalogue de modèles. Remplissez des formulaires réglementaires, suivez les soumissions et générez des rapports.",
        audit_trail: "Consultez une piste d'audit complète de toutes les actions du système. Suivez qui a fait quoi, quand et où dans tous les modules.",
        organizations: "Gérez les organisations et les paramètres multi-locataires. Configurez les profils d'organisation, les hiérarchies et les relations inter-organisations.",
    },
    privacy_scanner: {
        anomaly_explain: {
            explain_label: 'Expliquer les anomalies',
            explaining: 'Expliquer…',
            results_heading: 'Explications des anomalies ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            items_label: '[[TOK_1]] éléments',
            remediation_label: 'Étapes de remédiation',
            items_detail_label: 'Articles concernés',
            accept_label: "Accepter l'explication",
            reject_label: "Rejeter l'explication",
            error_generic: "Impossible d'expliquer les anomalies. Réessayez ou vérifiez que l'analyse s'est terminée avec succès.",
        },
        cookie_insight: {
            insight_label: 'Informations sur les cookies et le tracker [[TOK_0]]',
            producing: 'Produire des insights…',
            results_heading: 'Informations sur les cookies et les trackers ([[TOK_1]])',
            tokens_label: '≈ [[TOK_1]] jetons',
            items_label: '[[TOK_1]] éléments',
            classification_label: 'Classement',
            severity_label: 'Gravité',
            banner_copy_label: 'Copie de bannière suggérée',
            retention_label: 'Conseils de rétention',
            citations_label: 'Citations',
            kind_cookie: 'Biscuit',
            kind_tracker: 'Traqueur',
            class_necessary: 'Nécessaire',
            class_analytics: 'Analyse',
            class_marketing: 'Commercialisation',
            class_social: 'Social',
            accept_label: 'Accepter les informations',
            reject_label: 'Rejeter les insights',
            no_items: "Aucun cookie ou traceur n'a été détecté lors de cette analyse.",
            error_generic: "Impossible de produire les informations sur les cookies. Réessayez ou vérifiez que l'analyse s'est terminée avec succès.",
        },
        monitoring: {
            title: 'Confidentialité Surveillance',
            new_scan: 'Nouveau scanner',
            scan_url: 'URL à Scanner',
            scan_frequency: 'Scanner Fréquence',
            last_scan: 'Dernier Scanner',
            score: 'Confidentialité Score',
            issues: 'Problèmes Trouvé',
            history: 'Scanner Historique',
            settings: 'Surveillance Paramètres',
        },
        real_time: {
            title: 'Analyseur en temps réel',
            scan_now: 'Scanner Maintenant',
            scanning: 'Analyse...',
            results: 'Scanner Résultats',
            no_results: "Aucun résultat d'analyse.",
            cookies: 'Témoins de connexion',
            trackers: 'Traceurs',
            consent_banners: 'Bannières de consentement',
            third_party: 'Scripts tiers',
            archive: 'Résultats Archiver',
            settings: 'Paramètres du scanneur',
        },
        dashboard: {
            page_title: 'Tableau de bord de surveillance de la confidentialité',
            privacy_monitoring: 'Surveillance de la confidentialité',
            plan_label: '[[TOK_1]] forfait',
            expires_label: 'expire le [[TOK_1]]',
            settings: 'Paramètres',
            refresh: 'Actualiser',
            refreshing_dashboard: 'Actualisation du tableau de bord de surveillance',
            refresh_aria: 'Actualiser le tableau de bord de surveillance',
            not_configured_title: 'Surveillance de la confidentialité non configurée',
            not_configured_desc: 'Connectez votre [[TOK_0]] service de surveillance de la confidentialité pour commencer à suivre la conformité du site Web.',
            configure_monitoring: 'Configurer la surveillance',
            license_expired_title: 'Licence expirée',
            license_expired_desc: 'Votre licence [[TOK_0]] Privacy Monitoring a expiré. Veuillez le renouveler pour éviter une interruption du service.',
            compliance_score: 'Score de conformité',
            cookies_detected: 'Cookies détectés',
            trackers_label: 'Traqueurs',
            open_issues: 'Problèmes ouverts',
            score_good: 'Bon',
            score_needs_improvement: "Besoin d'amélioration",
            score_critical: 'Critique',
            action_required: 'Action requise',
            cookies_sr: 'cookies détectés',
            trackers_sr: 'trackers trouvés',
            open_issues_sr: 'problèmes ouverts',
            action_required_sr: 'action requise',
            metric_label: 'Métrique',
            value_label: 'Valeur',
            status_label: 'Statut',
            aria_metrics: 'Mesures de surveillance de la confidentialité',
            plan_limit_warning: 'Numérisation de [[TOK_4]] : [[TOK_2]]/[[TOK_3]] — vous avez atteint la limite de votre forfait.',
            manage_domains: 'Gérez les domaines ou mettez à niveau votre forfait.',
            monitored_domains: 'Domaines surveillés',
            domain_added: 'Domaine [[TOK_1]] ajouté',
            domain_removed: 'Domaine [[TOK_1]] supprimé',
            failed_add_domain: "Échec de l'ajout du domaine",
            failed_remove_domain: 'Échec de la suppression du domaine',
            failed_load: 'Échec du chargement du tableau de bord de surveillance',
            new_domain_aria: 'Nouveau domaine [[TOK_0]]',
            add_domain: 'Ajouter un domaine',
            adding_domain: 'Ajout…',
            no_domains: "Aucun domaine surveillé n'est encore configuré.",
            aria_domains_table: 'Domaines surveillés',
            col_domain: 'Domaine',
            col_compliance_score: 'Score de conformité',
            col_status: 'Statut',
            col_cookies: 'Biscuits',
            col_trackers: 'Traqueurs',
            col_issues: 'Problèmes',
            col_last_scan: 'Dernière analyse',
            col_action: 'Action',
            compliance_status_sr: 'état de conformité',
            showing_chart: 'Affichage de la vue graphique',
            showing_table: 'Affichage de la vue du tableau de données',
            loading_sr: 'Tableau de bord de surveillance du chargement',
            col_framework_tags: 'Balises du cadre',
            col_last_monitored: 'Dernière surveillance',
            framework_tags_sr: 'cadres réglementaires applicables',
            last_monitored_sr: 'horodatage de surveillance continue',
            audit_trail_heading: "Piste d'audit",
            audit_trail_info: "Chaque analyse de surveillance est horodatée et enregistrée. Les modifications de conformité au niveau du domaine produisent un enregistrement d'audit immuable qui peut être exporté pour examen réglementaire.",
            cybersecurity_law_info_heading: 'Détection des lois sur la cybersécurité',
            cybersecurity_law_info: 'Les domaines surveillés sont automatiquement vérifiés par rapport aux exigences de la loi sur la cybersécurité (par exemple, la loi vietnamienne sur la cybersécurité, la directive [[TOK_0]]). Les balises framework indiquent quelles réglementations s’appliquent. Les problèmes sont classés par cadre réglementaire pour des mesures correctives ciblées.',
        },
        scan: {
            page_title: 'Analyse en temps réel',
            title: 'Scanner de confidentialité en temps réel',
            settings: 'Paramètres',
            results_archive: 'Archives des résultats',
            launch_scan: "Lancer l'analyse",
            target_url: 'Cible [[TOK_0]]',
            protocol_aria: 'Protocole',
            url_required: '[[TOK_0]] est requis',
            url_whitespace: 'Veuillez supprimer les espaces du [[TOK_0]]',
            url_invalid: 'Veuillez saisir un domaine valide (par exemple, exemple.com)',
            add_subpages: 'Ajouter des sous-pages',
            add_subpages_aria: 'Ajouter des sous-pages, [[TOK_1]] ajouté',
            start_scan: "Démarrer l'analyse",
            launching: 'Lancement…',
            scan_launched: "L'analyse a été lancée avec succès",
            scan_failed: "Échec du lancement de l'analyse",
            scan_progress: "Progression de l'analyse",
            scanning_in_progress: 'Numérisation en cours…',
            scan_id: "Numériser l'identifiant",
            status_label: 'Statut',
            status_unknown: 'unknown',
            progress_label: 'Progrès',
            pages_label: 'Pages',
            refresh_status: 'Actualiser le statut',
            new_scan: 'Nouvelle analyse',
            scan_completed: 'Scan terminé, résultats disponibles',
            failed_check_status: "Échec de la vérification de l'état de l'analyse",
            scan_results: "Résultats de l'analyse",
            main_page: 'Page principale',
            page_n: 'Page [[TOK_1]]',
            result_pages_nav: 'Pages de résultats',
            page_url: 'Page [[TOK_0]]',
            risk_score: 'Score de risque',
            risk_score_sr: 'score de risque',
            cookies_label: 'Biscuits',
            cookies_sr: 'cookies détectés',
            scripts_label: 'Scripts',
            scripts_sr: 'scripts détectés',
            issues_label: 'Problèmes',
            issues_sr: 'problèmes trouvés',
            issues_found: 'Problèmes trouvés',
            aria_issues_table: "Problèmes détectés lors de l'analyse",
            col_severity: 'Gravité',
            col_category: 'Catégorie',
            col_title: 'Titre',
            col_remediation: 'Assainissement',
            severity_sr: 'severity',
            scan_result_metrics: "Métriques des résultats de l'analyse",
            view_full_detail: 'Voir tous les détails',
            col_consent_category: 'Catégorie de consentement',
            consent_category_sr: 'catégorisation du consentement',
            compliance_evidence_heading: 'Preuve de conformité',
            compliance_evidence_info: 'Les résultats de l’analyse sont automatiquement liés aux cas de conformité. Chaque problème peut être attribué à une catégorie de consentement (essentiel, fonctionnel, analytique, marketing) et produit des preuves prêtes à être auditées pour un examen réglementaire.',
            rule_config_heading: 'Configuration des règles',
            rule_config_info: "Les règles d'analyse sont configurables selon le cadre réglementaire. Les vérifications des cookies, la détection des scripts et l'analyse des fournisseurs peuvent être activées ou désactivées via les paramètres. Des règles personnalisées peuvent être définies pour répondre aux exigences de conformité de votre organisation.",
            case_linkage_heading: 'Lien avec les dossiers de conformité',
            case_linkage_info: "Les problèmes détectés lors des analyses en temps réel peuvent être liés à des cas de conformité à des fins de suivi et de correction. Accédez à la page Détails des résultats de l'analyse pour afficher les associations de cas.",
            subpages_modal_title: 'Ajouter des sous-pages',
            subpages_modal_desc: "Ajoutez jusqu'à 5 URL de sous-pages à analyser à côté du domaine principal.",
            subpage_n: 'Sous-page [[TOK_1]]',
        },
        result_detail: {
            page_title: "Détails des résultats de l'analyse",
            title: "Résultat de l'analyse",
            back_to_archive: 'Retour aux archives',
            failed_load: "Échec du chargement du résultat de l'analyse",
            loading_sr: "Chargement du résultat de l'analyse…",
            scan_id: "Numériser l'identifiant",
            target_url: 'Cible [[TOK_0]]',
            status_label: 'Statut',
            status_sr: 'status',
            started: 'Commencé',
            completed: 'Terminé',
            pages_scanned: 'Pages numérisées',
            https_label: 'HTTPS',
            highest_risk_score: 'Score de risque le plus élevé',
            most_cookies: 'La plupart des cookies',
            most_vendors: 'La plupart des fournisseurs tiers',
            most_issues: 'La plupart des problèmes',
            across_pages: 'à travers les pages',
            highest_values_aria: 'Valeurs les plus élevées sur toutes les pages',
            scanned_pages_nav: 'Pages numérisées',
            main_page: 'Page principale',
            page_n: 'Page [[TOK_1]]',
            page_url: 'Page [[TOK_0]]',
            risk_score: 'Score de risque',
            overall_risk_sr: 'score de risque global',
            cookies_label: 'Biscuits',
            cookies_sr: 'cookies détectés',
            vendors_label: 'Fournisseurs tiers',
            vendors_sr: 'fournisseurs tiers détectés',
            issues_label: 'Problèmes',
            issues_sr: 'problèmes trouvés',
            risk_breakdown_aria: 'Répartition du score de risque',
            issues_found: 'Problèmes trouvés',
            aria_issues_table: "Problèmes détectés lors de l'analyse",
            col_severity: 'Gravité',
            col_category: 'Catégorie',
            col_title: 'Titre',
            col_remediation: 'Assainissement',
            severity_sr: 'severity',
            cookies_heading: 'Cookies ([[TOK_1]])',
            aria_cookies_table: 'Cookies détectés',
            col_name: 'Nom',
            col_domain: 'Domaine',
            col_path: 'Chemin',
            col_secure: 'Sécurisé',
            col_httponly: 'Http uniquement',
            col_samesite: 'Même site',
            vendors_heading: 'Fournisseurs tiers ([[TOK_1]])',
            aria_vendors_table: 'Fournisseurs tiers détectés',
            col_hostname: "Nom d'hôte",
            scripts_heading: 'Scripts / Balises ([[TOK_1]])',
            aria_scripts_table: 'Scripts et balises détectés',
            col_url: 'URL',
            col_type: 'Tapez',
            links_heading: 'Liens',
            first_party: 'Première partie',
            third_party: 'Tiers',
            col_risk_category: 'Catégorie de risque',
            col_regulatory_framework: 'Cadre réglementaire',
            col_actionable_detail: 'Détails exploitables',
            risk_category_sr: 'catégorie de risque réglementaire',
            risk_category_mapping_heading: 'Cartographie des catégories de risques',
            risk_category_mapping_info: "Chaque résultat d'analyse est mappé à une catégorie de risque réglementaire (collecte de données, transfert transfrontalier, gestion du consentement, conservation des données, contrôles de sécurité). Cette cartographie permet des remédiations ciblées priorisées par l’impact réglementaire.",
            compliance_case_heading: 'Association de cas de conformité',
            compliance_case_info: "Les résultats de l'analyse sont liés aux cas de conformité pour un suivi de bout en bout. Les problèmes peuvent être transmis directement des résultats de l’analyse au flux de travail des dossiers de conformité.",
        },
        results_archive: {
            page_title: "Archives des résultats de l'analyse",
            title: "Archives des résultats de l'analyse",
            back_to_scanner: 'Retour au scanner',
            failed_load: "Échec du chargement des résultats de l'analyse",
            results_loaded: "Résultats de l'analyse chargés, enregistrements [[TOK_1]]",
            total_label: 'Total : [[TOK_1]]',
            aria_table: "Archives des résultats de l'analyse",
            col_scan_date: 'Date de numérisation',
            col_target_url: 'Cible [[TOK_0]]',
            col_duration: 'Durée',
            col_issues_found: 'Problèmes trouvés',
            col_risk_score: 'Score de risque',
            col_status: 'Statut',
            col_actions: 'Actions',
            scan_status_sr: "état de l'analyse",
            view_result: 'Voir',
            no_results: "Aucun résultat d'analyse trouvé.",
            loading_sr: "Chargement des résultats de l'analyse",
            pagination_aria: "Pagination des résultats de l'analyse",
            col_risk_category: 'Catégorie de risque',
            risk_category_sr: 'catégorie de risque réglementaire',
            archive_retention_heading: 'Conservation des archives',
            archive_retention_info: "Les résultats de l'analyse sont conservés pendant la durée spécifiée dans la politique de conservation des données de votre organisation. Les résultats archivés incluent le contexte d'analyse complet (balises de framework, catégories de risque, conseils de remédiation) et peuvent être exportés au format [[TOK_0]] pour les preuves réglementaires.",
            export_context_info: 'Les fichiers [[TOK_0]] exportés incluent le contexte réglementaire : catégorie de risque, cadres applicables et détails de mesures correctives exploitables pour chaque résultat.',
        },
        scanner_settings: {
            page_title: 'Paramètres du scanner',
            title: 'Paramètres du scanner',
            back_to_scanner: 'Retour au scanner',
            failed_load: 'Échec du chargement de la configuration du scanner',
            endpoint_url: 'Point de terminaison [[TOK_0]]',
            save_success: 'La configuration du scanner a été enregistrée avec succès.',
            save_failed: "Échec de l'enregistrement de la configuration du scanner",
            test_connection: 'Tester la connexion',
            testing: 'Test...',
            save_configuration: 'Enregistrer la configuration',
            saving: 'Sauvegarde...',
            loading_sr: 'Chargement des paramètres du scanner',
        },
        monitoring_settings: {
            page_title: 'Paramètres de surveillance de la confidentialité',
            title: 'Paramètres de surveillance',
            back_to_dashboard: 'Retour au tableau de bord',
            failed_load: 'Échec du chargement de la configuration de surveillance',
            credentials_heading: '[[TOK_0]] Identifiants',
            connected_as: 'Connecté en tant que [[TOK_1]]',
            credentials_desc: 'Saisissez les identifiants de votre compte [[TOK_0]] pour connecter Privacy Monitoring. Recherchez votre identifiant de membre sur la page de profil de votre compte [[TOK_1]].',
            client_id: 'Identifiant client',
            client_secret: 'Secret client',
            username: "[[TOK_0]] Nom d'utilisateur (e-mail)",
            password: '[[TOK_0]] Mot de passe',
            placeholder_keep: "(laisser vide pour conserver l'existant)",
            credential_form_aria: "[[TOK_0]] formulaire d'identification",
            test_connection: 'Tester la connexion',
            testing: 'Test…',
            test_aria: 'Tester la connexion [[TOK_0]]',
            testing_aria: 'Test de connexion',
            save_configuration: 'Enregistrer la configuration',
            saving: 'Sauvegarde…',
            save_aria: "Enregistrer les informations d'identification",
            saving_aria: "Enregistrer les informations d'identification",
            credentials_saved: '[[TOK_0]] identifiants enregistrés avec succès.',
            credentials_saving: '[[TOK_0]] identifiants enregistrés. Rechargement de la configuration…',
            credentials_save_failed: "Échec de l'enregistrement des informations d'identification",
            client_id_required: 'L’ID client et le nom d’utilisateur sont requis.',
            all_fields_required: 'Tous les champs d’informations d’identification sont obligatoires.',
            email_heading: 'Notifications par courrier électronique',
            receive_emails: "Recevoir des e-mails de rapport d'analyse",
            email_toggle_aria: "Toggle les e-mails de rapport d'analyse",
            only_on_change: "Envoyez un e-mail uniquement lorsque l'état du risque change",
            only_on_change_aria: "Activer l'envoi d'e-mails uniquement en cas de changement de statut de risque",
            emails_enabled: "E-mails de rapport d'analyse activés",
            emails_disabled: "E-mails de rapport d'analyse désactivés",
            only_change_on: 'Envoi par e-mail uniquement sur le changement de risque',
            only_change_off: 'Envoi par e-mail à chaque analyse',
            email_failed: 'Échec de la mise à jour des paramètres de messagerie',
            email_settings_aria: 'Paramètres de notification par e-mail',
            loading_sr: 'Chargement des paramètres de surveillance',
        },
        entity_types: {
            user: 'Utilisateur',
            case: 'Cas',
            incident: 'Incident',
            assessment: 'Évaluation',
            vendor: 'Vendeur',
            consent: 'Consentement',
            policy: 'Politique',
            data_map: 'Carte des données',
        },
        actions: {
            create: 'Créer',
            update: 'Mise à jour',
            delete: 'Supprimer',
            view: 'Voir',
            export: 'Exporter',
            status_change: 'Changement de statut',
        },
    },
    forms: {
        dashboard: {
            title: 'Tableau de bord des formulaires',
            total_templates: 'Total Modèles',
            installed: 'Installé',
            available: 'Disponible',
            by_market: 'Par Marché',
            back_dashboard: 'Retour à Tableau de bord',
            browse_templates: 'Parcourir les modèles',
            catalog_coverage: 'Couverture du catalogue',
            quick_start: 'Démarrage rapide',
            recent_instances: 'Instances récentes',
            total_instances: "Total d'instances",
            fetch_failed: 'Échec de fetch dashboard data. Veuillez réessayer.',
            no_instances: 'Aucun instances trouvé',
            form_metrics: 'Aperçu des métriques de formulaires',
            templates_total: 'modèles au total',
            instances_total: 'instances au total',
            installed_of_available: '[[TOK_2]] sur [[TOK_3]] installés',
            templates_in_category: 'modèles dans {category}',
        },
        templates: {
            title: 'Modèles de formulaires',
            new: 'Nouveau modèle',
            edit: 'Modifier Modèle',
            name: 'Modèle Nom',
            form_type: 'Formulaire Type',
            market: 'Marché',
            language: 'Langue',
            schema: 'Schéma du formulaire',
            preview: 'Aperçu',
            duplicate: 'Dupliquer Modèle',
            grid_view: 'Grille Voir',
            list_view: 'Liste Voir',
            fetch_failed: 'Échec de fetch templates. Veuillez réessayer.',
            filter_templates: 'Filtrer les modèles',
            version_history: 'Historique des versions',
            no_version_history: 'Aucun historique de versions — ceci est la version initiale.',
            form_id: 'ID du formulaire',
            source_instrument: 'Instrument source',
            issuer: 'Émetteur',
            all_frameworks: 'Tous les cadres',
            view_mode: "Mode d'affichage",
        },
        catalog: {
            title: 'Catalogue de formulaires',
            install: 'Installer',
            uninstall: 'Désinstaller',
            install_all: 'Installer Tous',
            installed_tab: 'Installé',
            catalog_tab: 'Catalogue',
            search_placeholder: 'Rechercher des modèles...',
            no_templates: 'Aucun templates trouvé',
            template_count: '{count} modèles',
            all_markets: 'Tous les marchés',
            sections: 'Rubriques',
            all_categories: 'Toutes les catégories',
            category: 'Catégorie',
            category_install_failed: 'Échec de install category templates. Veuillez réessayer.',
            category_install_success: 'Modèles de catégorie installés.',
            fetch_failed: 'Échec de fetch templates. Veuillez réessayer.',
            fetch_installed_failed: 'Échec de fetch installed templates. Veuillez réessayer.',
            fields: 'Champs',
            install_failed: 'Échec de install template. Veuillez réessayer.',
            install_success: 'Modèle installed avec succès.',
            installing: 'Installation...',
            removing: 'Suppression...',
            uninstall_confirm: 'Êtes-vous sûr de vouloir désinstaller ce modèle ?',
            uninstall_failed: 'Échec de uninstall template. Veuillez réessayer.',
            uninstall_success: 'Modèle uninstalled avec succès.',
            installation_summary: "Résumé de l'installation",
            filter_catalog: 'Filtrer le catalogue',
            all_frameworks: 'Tous les cadres',
            templates_installed_count: '[[TOK_1]] modèle(s) installés avec succès',
            all_already_installed: 'Tous les modèles de cette catégorie sont déjà installés',
            form_id: 'ID du formulaire',
            issuer: 'Émetteur',
            catalog_tabs: 'Onglets du catalogue de formulaires',
        },
        filler: {
            back_templates: 'Retour à Modèles',
            no_sections: 'Aucun sections trouvé',
            draft_created: 'Brouillon créé.',
            draft_saved: 'Brouillon enregistré.',
            fetch_template_failed: 'Échec de fetch template. Veuillez réessayer.',
            save_draft: 'Enregistrer Brouillon',
            save_draft_failed: 'Échec de save draft. Veuillez réessayer.',
            saving: 'Enregistrement...',
            select_option: 'Sélectionnez option',
            submit: 'Soumettre',
            submit_failed: 'Échec de submit. Veuillez réessayer.',
            submitting: 'Soumission...',
            title: 'Assistant de formulaire',
            form_id_label: 'ID du formulaire',
            schema_label: 'Schéma',
            framework_label: 'Cadre',
            issuer_label: 'Émetteur',
            source_label: 'Origine',
            market_label: 'Marché',
            section_of: 'Section {current} sur {total}',
            form_navigation: 'Navigation du formulaire',
            form_progress: 'Progression du formulaire : Section {current} sur {total}',
            removed_item: 'Élément {index} supprimé de {field}',
            added_item: 'Nouvel élément ajouté à {field}',
            go_to_previous: 'Aller à la section précédente, section {current} sur {total}',
            go_to_next: 'Aller à la section suivante, section {current} sur {total}',
            risk_matrix_placeholder: '1 à 5',
        },
        filing: {
            title: 'Statut de dépôt',
            advance: 'Mettre à jour le statut de dépôt...',
            not_started: 'Non commencé',
            drafting: 'Rédaction',
            internal_review: 'Revue interne',
            approved_for_submission: 'Approuvé pour soumission',
            submitted_to_authority: "Soumis à l'autorité",
            supplement_requested: 'Complément demandé',
            supplement_in_progress: 'Complément en cours',
            resubmitted: 'Resoumis',
            accepted: 'Accepté',
            rejected: 'Rejeté',
            closed: 'Clôturé',
        },
        instances: {
            approved_by: 'Approuvé Par',
            form_answers: 'Réponses du formulaire',
            no_answers: 'Aucun answers trouvé',
            view_outputs: 'Voir Outputs',
            approve: 'Approuver',
            approve_failed: 'Échec de approuver. Veuillez réessayer.',
            approving: 'Approbation...',
            detail_title: "Détail de l'instance",
            fetch_failed: 'Échec de fetch instances. Veuillez réessayer.',
            generate_failed: 'Échec de generate output. Veuillez réessayer.',
            generate_output: 'Générer Sortie',
            generating: 'Génération...',
            submitted_at: 'Soumis le',
            instance_metadata: "Métadonnées de l'instance du formulaire",
            filing_status_steps: 'Étapes du statut de classement',
            current_status: 'statut actuel',
            filing_status_update_failed: 'Échec de la mise à jour du statut du dépôt',
        },
        outputs: {
            back_instance: 'Retour à Instance',
            no_outputs_msg: 'Non outputs avoir été generated encore.',
            no_outputs_title: 'Aucun résultat',
            output_name: 'Sortie Nom',
            download: 'Télécharger',
            download_failed: 'Échec de télécharger. Veuillez réessayer.',
            fetch_failed: 'Échec de fetch outputs. Veuillez réessayer.',
            format: 'Formater',
            generated_at: 'Généré le',
            generated_by: 'Généré par',
            size: 'Taille',
            title: 'Résultats du formulaire',
            print: 'Imprimer',
            print_outputs: 'Imprimer les sorties du formulaire',
            printing: 'Impression des sorties du formulaire',
            pdf_preview: 'Aperçu PDF',
            downloading: 'Téléchargement de {name}',
            preview_in_new_window: 'Aperçu de {name} ({format}) dans une nouvelle fenêtre',
        },
        cybersec_domains: {
            scope: 'Portée et applicabilité',
            risk: 'Évaluation des risques et cartographie des contrôles',
            policy: 'Politiques de sécurité organisationnelle',
            localization: 'Localisation des données et présence locale',
            vendor: "Tiers et chaîne d'approvisionnement",
            authority: 'Traitement des demandes des autorités',
            incident: 'Réponse aux incidents et preuves',
            training: 'Formation et préparation',
        },
        market_finalization_domains: {
            data_law: 'Loi sur les Données — Gouvernance et Contrôles Opérationnels',
            pdpl_2025: 'PDPL 2025 — Gouvernance de la Vie Privée et Droits des Personnes Concernées',
            decree_356: 'Décret 356/2025 — Contrôles des Fournisseurs et Transfrontaliers',
            telecom: 'Loi Télécommunications — Confidentialité et Demandes des Autorités',
        },
        nav: {
            filing_case_links: 'Liens de dossier de dépôt',
            section_routing: 'Routage de section',
            submission_packages: 'Paquets de soumission',
        },
        filing_case_links: {
            title: 'Liens de dossier de dépôt',
            link_form: 'Lier le formulaire au dossier de dépôt',
            filing_case_type: 'Type de dossier de dépôt',
            form_instance: 'Instance de formulaire',
            select_form_instance: 'Sélectionner une instance de formulaire...',
            select_filing_case: 'Sélectionner un dossier de dépôt...',
            no_links_found: 'Aucun lien de dossier de dépôt trouvé.',
            linked: 'Lié',
            filing_case_id: 'ID du dossier de classement',
            link_created: 'Lien de dossier de classement créé',
            link_deleted: 'Lien de dossier de dépôt supprimé',
            aria_delete_link: 'Supprimer le lien {name}',
            case_type_dpia_dossier: 'Dossier AIPD',
            case_type_cross_border_filing: 'Dépôt transfrontalier',
            case_type_breach_notification: 'Notification de violation',
            no_instances_guidance: "Pas encore d'instances de formulaire. Créez-en une depuis les Modèles de formulaire.",
            no_filings_guidance: 'Pas encore de dossiers de dépôt. Créez-en un depuis les Évaluations.',
        },
        section_routing: {
            title: 'Routage de section',
            assign_section: 'Attribuer une section',
            department: 'Département',
            select_department: 'Sélectionner un département...',
            assignee: 'Assigné à',
            select_assignee: 'Sélectionner un assigné...',
            section: 'Section',
            select_section: 'Sélectionner une section...',
            select_form_instance: 'Sélectionner une instance de formulaire...',
            no_assignments_found: 'Aucune attribution de section trouvée.',
            select_instance_prompt: 'Sélectionnez une instance de formulaire pour voir les attributions de section.',
            complete_section: 'Terminer la section',
            status_pending: 'En attente',
            status_in_progress: 'En cours',
            status_completed: 'Terminé',
            status_reviewed: 'Révisé',
            form_instance_id: "ID d'instance du formulaire",
            assignment_created: 'Attribution de section créée',
            assignment_deleted: 'Attribution de section supprimée',
            status_updated: 'Statut de la section mis à jour',
            aria_delete_assignment: "Supprimer l'attribution {name}",
            deadline: 'Date limite',
            deadline_help: 'Facultatif. Les attributions dépassant cette date sont affichées comme en retard.',
            overdue: 'En retard',
            days_remaining: 'jours restants',
            approval_requested: 'Soumis pour examen',
            form_approved: 'Formulaire approuvé',
            form_rejected: 'Formulaire rejeté',
            no_departments_guidance: "Aucun département configuré. Configurez-les dans les Paramètres de l'organisation.",
            no_sections_guidance: 'Aucune section définie dans le modèle. Assurez-vous que le modèle de formulaire comporte des sections.',
            select_instance_first: "Sélectionnez d'abord une instance de formulaire pour charger les sections disponibles.",
        },
        submission_packages: {
            title: 'Paquets de soumission',
            assemble_package: 'Assembler le paquet de soumission',
            dossier: 'Dossier',
            select_dossier: 'Sélectionner un dossier...',
            package_label: 'Étiquette du paquet',
            cover_letter: 'Lettre de couverture',
            checklist: 'Liste de contrôle',
            evidence_index: 'Index des preuves',
            completeness: 'Complétude',
            incomplete_warning: 'Assemblage impossible : le formulaire comporte des sections incomplètes.',
            no_packages_found: 'Aucun paquet de soumission trouvé.',
            version: 'Version',
            package_assembled: 'Paquet de soumission assemblé',
            package_deleted: 'Paquet de soumission supprimé',
            aria_delete_package: 'Supprimer le paquet {name}',
            status_draft: 'Brouillon',
            status_complete: 'Terminé',
            status_submitted: 'Soumis',
            status_accepted: 'Accepté',
            status_rejected: 'Rejeté',
            package_updated: 'Paquet de soumission mis à jour',
            document_generated: 'Document généré',
            documents: 'Documents',
            generate: 'Générer',
            preview: 'Aperçu',
            download: 'Télécharger',
            download_all: 'Tout télécharger',
            no_dossiers_guidance: 'Pas encore de dossiers. Créez-en un depuis les Évaluations.',
            package_plan_help: 'Inclure dans le plan du paquet (génération automatique de documents disponible) :',
            cover_letter_help: "Lettre d'accompagnement officielle adressée à l'autorité destinataire",
            checklist_help: 'Liste de vérification de conformité vérifiant que toutes les exigences de soumission sont remplies',
            evidence_index_help: 'Index des documents justificatifs référencés dans la soumission',
            completeness_skipped: 'Vérification de complétude ignorée — aucune instance de formulaire liée à ce dossier.',
            completeness_unavailable: 'Vérification de complétude indisponible — assemblage du paquet en cours.',
            duplicate_package_error: 'Un paquet de soumission existe déjà pour ce dossier.',
            doc_cover_letter: 'Lettre de couverture',
            doc_checklist: 'Liste de vérification',
            doc_evidence_index: 'Index des preuves',
            export_csv: 'Exporter CSV',
            export_success: 'Liens des dossiers de dépôt exportés avec succès',
            no_assignments_guidance: "Aucune attribution de section pour le moment. Attribuez des sections aux départements et aux membres de l'équipe pour commencer le routage.",
        },
        template_picker: {
            title: 'Sélectionner un modèle',
            hint: 'Choisissez un modèle de formulaire réglementaire ou commencez avec un formulaire vierge.',
            market_filter: 'Filtrer par marché',
            framework_filter: 'Filtrer par cadre',
            all_markets: 'Tous les marchés',
            all_frameworks: 'Tous les cadres',
            search_placeholder: 'Rechercher des modèles...',
            blank_form: 'Formulaire vierge / générique',
            blank_form_desc: 'Créer sans modèle — remplir les champs manuellement.',
            no_templates: 'Aucun modèle trouvé pour ce filtre.',
            select: 'Sélectionner',
            link_error: 'Échec de la liaison du modèle — vous pouvez lier un modèle ultérieurement depuis la vue Édition.',
            internal_badge: 'Modèle interne',
            legacy_badge: 'Obsolète',
            draft_badge: 'Brouillon',
            upcoming_badge: 'À venir',
            hidden_badge: 'Masqué',
            show_hidden_toggle: 'Afficher les modèles masqués / obsolètes',
            show_hidden_toggle_hint: 'Vue administrateur : inclut les modèles marqués internal_only, hidden, legacy ou draft.',
        },
        cover_letter_modal: {
            title: "Lettre d'accompagnement : aperçu et édition",
            iframe_title: "Aperçu de la lettre d'accompagnement",
            stage_label: 'Étape',
            stage_initial: 'Soumission initiale',
            stage_supplement: 'Réponse complémentaire',
            stage_resubmission: 'Nouvelle soumission',
            subject_label: 'Objet',
            body_label: 'Paragraphe principal',
            notes_label: 'Notes supplémentaires',
            refresh_preview: "Actualiser l'aperçu",
            confirm: 'Confirmer et enregistrer',
            regenerate: 'Régénérer',
            snapshot_saved: "Lettre d'accompagnement enregistrée",
        },
        related_panel: {
            title: 'Formulaires réglementaires associés',
            open_form: 'Remplir le formulaire',
            no_forms: 'Aucun formulaire associé trouvé.',
            hint_vn: "Formulaires réglementaires spécifiques au VN disponibles — sélectionnez un formulaire pour ouvrir l'assistant de conformité.",
            internal_badge: 'Interne',
            official_badge: 'Officiel',
            loading: 'Chargement des formulaires associés...',
            error: 'Impossible de charger les formulaires associés.',
            form_id: 'ID du formulaire',
            form_name: 'Nom du formulaire',
            framework: 'Cadre réglementaire',
        },
        view_form: 'Voir le formulaire',
        edit_form: 'Modifier le formulaire',
        save_draft: 'Enregistrer le brouillon',
        module_settings: 'Paramètres du module',
        validation_errors: 'Veuillez corriger les erreurs de validation',
        custom_name_help: 'Optionnel — par défaut, le nom du modèle si laissé vide',
        select_placeholder: 'Sélectionner...',
        previous_section: 'Précédent',
        next_section: 'Suivant',
        loading: 'Chargement...',
        array_add: 'Ajouter',
        array_remove: 'Supprimer',
        array_item_label: 'Élément {index} de {label}',
        array_add_item: 'Ajouter un élément à {label}',
        array_remove_item: 'Supprimer l’élément {index} de {label}',
        legacy_banner: 'Cet enregistrement a été créé avant les formulaires unifiés. Certaines données peuvent différer entre l’entité et l’instance de formulaire.',
        field_required: '{label} est requis',
        section_announcement: 'Section [[TOK_3]] de [[TOK_4]] : [[TOK_5]]',
        sections_nav_label: 'Sections du formulaire',
        no_sections: 'Aucune section de modèle disponible.',
        section_label_tpl: 'Section [[TOK_2]] : [[TOK_3]]',
        module_settings_auto_applied: 'Les paramètres spécifiques au module sont appliqués automatiquement.',
        operation_failed: "L'opération a échoué",
        failed_to_load_form: 'Impossible de charger le formulaire',
        failed_to_save_form: "Impossible d'enregistrer le formulaire",
        failed_to_submit_form: "Impossible d'envoyer le formulaire",
        failed_to_load_template: 'Impossible de charger le modèle',
        failed_to_save_draft: "Impossible d'enregistrer le brouillon",
        failed_to_create: 'Impossible de créer',
    },
    pack_catalog: {
        title: 'Catalogue de packs',
        install: 'Installer le pack',
        uninstall: 'Désinstaller le pack',
        install_batch: 'Installer Cluster',
        installed_tab: 'Installé',
        catalog_tab: 'Catalogue',
        pack_details: 'Détails du pack',
        frameworks: 'Cadres',
        requirements: 'Exigences',
        artifacts: 'Artefacts',
        language_pack: 'Pack linguistique',
        dependencies: 'Dépendances',
        no_packs: 'Aucun packs trouvé',
    },
    platform_pages: {
        users: {
            title: 'Utilisateurs',
            new: 'Nouveau utilisateur',
            invite: 'Inviter Utilisateur',
            edit: 'Modifier Utilisateur',
            name: 'Nom',
            email: 'E-mail',
            role: 'Rôle',
            status: 'Statut',
            identity_type: 'Identité Type',
            last_login: 'Dernière connexion',
            deactivate: 'Désactiver',
            reactivate: 'Réactiver',
            unlock: 'Déverrouiller',
            reset_password: 'Réinitialiser Mot de passe',
            remove: 'Supprimer',
            remove_confirm: "Supprimer \"{name}\" ? Cette action est définitive et l'utilisateur perdra tout accès. L'enregistrement est conservé à des fins d'audit.",
        },
        roles: {
            title: 'Rôles',
            new: 'Nouveau rôle',
            edit: 'Modifier Rôle',
            name: 'Rôle Nom',
            description: 'Descriptif',
            permissions: 'Autorisations',
            users_count: 'Utilisateurs',
            detail: 'Détail du rôle',
            all_tiers: 'Tous les niveaux',
            role_name_placeholder: 'ex. Responsable conformité régional',
        },
        profile: {
            title: 'Mon Profil',
            name: 'Nom',
            display_name: "Nom d'affichage",
            email: 'E-mail',
            phone: 'Téléphone',
            department: 'Département',
            job_title: 'Intitulé du poste',
            language: 'Langue',
            role: 'Rôle',
            persona: 'Persona détectée',
            last_login: 'Dernière connexion',
            save: 'Enregistrer les modifications',
            save_success: 'Profil mis à jour avec succès',
            module_tips_section: 'Conseils de module',
            tips_toggle: 'Afficher les conseils réglementaires dans les modules',
            dismissed_tips: 'Conseils ignorés',
            reset_dismissed: 'Réinitialiser tous les conseils ignorés',
            notification_prefs: 'Préférences de notification',
            notification_prefs_link: 'Gérer les préférences de notification →',
            change_password: 'Changement Mot de passe',
            current_password: 'Actuel Mot de passe',
            new_password: 'Nouveau mot de passe',
            confirm_password: 'Confirmer Mot de passe',
            accessibility: 'Accessibilite',
            high_contrast: 'Mode contraste eleve',
            high_contrast_desc: 'Augmenter le contraste pour une meilleure lisibilite. Conforme WCAG 2.1 AAA.',
            passwords_no_match: 'Les mots de passe ne correspondent pas',
            password_changed_logout: 'Mot de passe modifié. Vous serez déconnecté.',
            failed_update: 'Échec de la mise à jour du profil',
            failed_change_password: 'Échec du changement de mot de passe',
            none: 'Aucun',
            never: 'Jamais',
            password_requirements: 'Min. 12 car., majuscule, minuscule, chiffre, caractère spécial',
        },
        security: {
            mfa_title: 'Paramètres MFA',
            mfa_enable: 'Activer la MFA',
            mfa_disable: 'Désactiver la MFA',
            mfa_setup: "Scannez ce code QR avec votre appli d'authentification",
            sso_title: 'Configuration SSO',
            sso_provider: 'Fournisseur',
            sso_client_id: 'ID client',
            sso_redirect: 'URI de redirection',
            api_keys_title: 'API Clés',
            api_keys_new: 'Nouveau api clé',
            api_keys_name: 'Clé Nom',
            api_keys_last_used: 'Dernière utilisation',
            api_keys_expires: 'Expirer',
            api_keys_revoke: 'Révoquer',
            service_accounts_title: 'Comptes de service',
            ip_allowlist_title: "Liste blanche d'IP",
            ip_add: 'Ajouter ip adresse',
            ip_address: 'IP Adresse',
            ip_description: 'Descriptif',
            delegations_title: 'Délégations',
            delegations_new: 'Nouveau Delegation',
            delegations_from: 'De Utilisateur',
            delegations_to: 'À Utilisateur',
            delegations_expires: 'Expirer',
            break_glass_title: 'Break-Glass Accès',
            break_glass_request: 'Demande Accès',
            break_glass_reason: 'Reason pour Accès',
            break_glass_duration: 'Durée',
            session_settings_title: 'Session Paramètres',
            session_timeout: "Session Délai d'attente (minutes)",
            session_max_concurrent: 'Sessions simultanées max.',
            active_sessions_title: 'Sessions actives',
            active_sessions_device: 'Appareil',
            active_sessions_ip: 'IP Adresse',
            active_sessions_started: 'Démarré',
            active_sessions_revoke: 'Révoquer Session',
            active_sessions_confirm_terminate: 'Êtes-vous sûr de vouloir mettre fin à cette session ?',
            active_sessions_confirm_terminate_current: 'Ceci est votre session en cours. En y mettant fin, vous vous déconnecterez immédiatement. Continuer?',
            active_sessions_confirm_terminate_all: 'Êtes-vous sûr de vouloir mettre fin à toutes les autres sessions ? Seule votre session en cours restera active.',
            active_sessions_terminated: "La session s'est terminée avec succès.",
            active_sessions_all_terminated: 'Toutes les autres sessions ont été interrompues.',
            active_sessions_terminate_all: 'Terminer toutes les autres sessions',
            active_sessions_last_activity: 'Dernière activité',
            active_sessions_current: 'Session en cours',
            active_sessions_revoke_selected: 'Révoquer la sélection',
            active_sessions_confirm_terminate_selected: 'Êtes-vous sûr de vouloir terminer les sessions sélectionnées ?',
            active_sessions_selected_terminated: 'Sessions sélectionnées terminées avec succès.',
            ip_allowlist_desc: "Gérez les adresses IP autorisées pour l'accès [[TOK_0]].",
            ip_no_entries: 'Aucune adresse IP configurée.',
            session_settings_desc: "Configurez le délai d'expiration de la session et les limites des sessions simultanées.",
            session_settings_save_policy: 'Enregistrer la politique de session',
            session_settings_saved: 'Paramètres de session mis à jour avec succès.',
            session_settings_idle_timeout: "Délai d'inactivité (minutes)",
            session_settings_absolute_timeout: "Délai d'attente absolu (minutes)",
            session_settings_help_idle: "La session expirera après cette période d'inactivité.",
            session_settings_help_absolute: "La session expirera après cette durée totale, quelle que soit l'activité.",
            session_settings_help_max: 'Nombre maximum de sessions simultanées par utilisateur.',
            sso_note: 'Les modifications apportées à la configuration SSO peuvent nécessiter une nouvelle authentification des utilisateurs.',
            service_accounts_warning: "Cette clé [[TOK_0]] ne sera affichée qu'une seule fois. Copiez-le maintenant et conservez-le en toute sécurité.",
            service_accounts_new: 'Nouveau compte de service',
            service_accounts_name: 'Nom du compte',
            service_accounts_role: 'Rôle',
            service_accounts_created: 'Créé',
            service_accounts_desc: 'Gérez les comptes de service machine à machine pour les intégrations [[TOK_0]].',
            break_glass_warning: "L’accès aux bris de glace est audité et enregistré. À utiliser uniquement en cas d'urgence réelle.",
            break_glass_min_chars: '[[TOK_2]] / [[TOK_3]] caractères minimum',
            break_glass_permission_count: '[[TOK_1]] autorisation(s) sélectionnée(s)',
            break_glass_submitted: "Demande de bris de glace soumise. En attente d'approbation.",
            break_glass_approved: 'Demande de bris de glace approuvée.',
            break_glass_denied: 'Demande de bris de vitre refusée.',
            break_glass_confirm_activate: 'Approuver cette demande de bris de glace ? Cela accordera immédiatement un accès d’urgence.',
            break_glass_confirm_title: "Confirmer l'activation",
            break_glass_pending: 'Demandes en attente',
            break_glass_active_sessions: 'Séances actives de bris de glace',
            break_glass_time_remaining: 'Temps restant',
            break_glass_expired: 'Expiré',
            break_glass_approved_denied_by: 'Approuvé/Refusé par',
            delegations_desc: "Gérez les délégations d'autorisations temporaires entre les utilisateurs.",
            delegations_my: 'Mes délégations',
            delegations_to_me: "M'a délégué",
            delegations_scope_all: 'Toutes les autorisations',
            delegations_scope_specific: 'Autorisations spécifiques',
            delegations_created: 'Délégation créée avec succès.',
            delegations_revoked: 'Délégation révoquée.',
            delegations_confirm_revoke: 'Etes-vous sûr de vouloir révoquer cette délégation ?',
            delegations_confirm_revoke_title: 'Confirmer la révocation',
            delegations_permission_count: '[[TOK_1]] autorisation(s)',
            api_keys_status: 'Statut',
            api_keys_prefix: 'Préfixe de clé',
            api_keys_permissions_count: 'Autorisations',
            api_keys_ip_count: 'Restrictions IP',
            api_keys_created: 'Créé',
            api_keys_confirm_revoke_title: 'Confirmer la révocation',
            api_keys_confirm_revoke_message: 'Êtes-vous sûr de vouloir révoquer la clé [[TOK_2]] "[[TOK_1]]" ? Cette action ne peut pas être annulée.',
            api_keys_confirm_rotate_title: 'Confirmer la rotation',
            api_keys_confirm_rotate_message: 'Êtes-vous sûr de vouloir faire pivoter la clé [[TOK_2]] "[[TOK_1]]" ? La clé actuelle cessera de fonctionner immédiatement.',
            api_keys_created_success: 'Clé [[TOK_0]] créée avec succès.',
            api_keys_revoked_success: 'La clé [[TOK_2]] "[[TOK_1]]" a été révoquée.',
            api_keys_rotated_success: 'La clé [[TOK_2]] "[[TOK_1]]" a été pivotée. Copiez la nouvelle clé ci-dessous.',
            api_keys_load_error: 'Échec du chargement des clés [[TOK_0]].',
            api_keys_create_error: 'Échec de la création de la clé [[TOK_0]].',
            api_keys_revoke_error: 'Échec de la révocation de la clé [[TOK_0]].',
            api_keys_rotate_error: 'Échec de la rotation de la clé [[TOK_0]].',
            break_glass_duration_15: '15 minutes',
            break_glass_duration_30: '30 minutes',
            break_glass_duration_60: '60 minutes (1h)',
            break_glass_duration_120: '120 minutes (2h)',
            break_glass_duration_240: '240 minutes (4h)',
            sod_rules_title: 'Règles de séparation des tâches',
            sod_violations_report: "Rapport d'infractions",
            sod_create_rule: 'Créer une règle',
            sod_col_name: 'Nom',
            sod_col_description: 'Descriptif',
            sod_col_conflict_count: 'Nombre de conflits',
            sod_col_severity: 'Gravité',
            sod_col_status: 'Statut',
            sod_col_actions: 'Actions',
            sod_no_rules: 'Aucune règle SoD trouvée',
            sod_severity_warning: 'Avertissement',
            sod_severity_blocking: 'Blocage',
            sod_active: 'Actif',
            sod_inactive: 'Inactif',
            sod_edit: 'Modifier',
            sod_exceptions: 'Exceptions',
            sod_deactivate: 'Désactiver',
            sod_confirm_deactivate_title: 'Confirmer la désactivation',
            sod_confirm_deactivate_message: 'Désactiver la règle "[[TOK_1]]" ? Il ne signalera plus les violations.',
            sod_deactivate_error: 'Échec de la désactivation de la règle',
            sod_rule_count: '{count} rules',
        },
        access_reviews: {
            title: "Revues d'accès",
            campaigns: 'Campagnes de révision',
            new_campaign: 'Nouveau Campaign',
            campaign_name: 'Nom de campagne',
            scope: 'Portée',
            reviewers: 'Réviseurs',
            due_date: "Date d'échéance",
            progress: 'Progression',
            my_reviews: 'Mes révisions',
            approve: 'Approuver',
            revoke: 'Révoquer',
            analytics: 'Rôle Analyses',
            analytics_title: 'Rôle Analyses',
            permission_usage: 'Permission Utilisation',
            role_coverage: 'Couverture des rôles',
            campaign_detail: 'Détails de la campagne',
            campaign_description: 'Descriptif',
            campaign_status: 'Statut',
            campaign_deadline: 'Date limite',
            campaign_scope_type: 'Type de portée',
            campaign_completion: 'Achèvement',
            campaign_total_items: 'Total des articles',
            campaign_pending_items: 'En attente',
            campaign_confirmed_items: 'Confirmé',
            campaign_revoked_items: 'Révoqué',
            campaign_escalated_items: 'Escaladé',
            campaign_launch: 'Campagne de lancement',
            campaign_cancel: 'Annuler la campagne',
            campaign_confirm_launch: 'Êtes-vous sûr de vouloir lancer cette campagne ?',
            campaign_confirm_cancel: 'Êtes-vous sûr de vouloir annuler cette campagne ?',
            campaign_launched: 'Campagne lancée avec succès.',
            campaign_cancelled: 'Campagne annulée.',
            review_items: 'Réviser les éléments',
            review_item_user: 'Utilisateur',
            review_item_role: 'Rôle',
            review_item_reviewer: 'Réviseur',
            review_item_decision: 'Décision',
            review_item_justify: 'Justification',
            review_item_confirm: 'Confirmer',
            review_item_revoke: 'Révoquer',
            review_item_escalate: 'Escalader',
            all_decisions: 'Toutes les décisions',
            bulk_action: 'Action groupée',
            bulk_confirm: 'Confirmation groupée',
            bulk_revoke: 'Révocation groupée',
            selected_count: '[[TOK_1]] sélectionné',
            justify_required: 'Une justification est requise',
            scope_all_users: 'Tous les utilisateurs',
            scope_role_owner: 'Propriétaire du rôle',
            scope_department: 'Département',
            back_to_campaigns: 'Retour aux campagnes',
            recommendations: 'Recommandations',
            refreshing: 'Rafraîchissant...',
            decide: 'Décider',
            decision_by: 'Décision par',
            loading_items: 'Chargement des éléments...',
            loading_review_items: 'Chargement des éléments de révision...',
            campaign_not_found: 'Campagne introuvable',
            loading_campaign: 'Chargement des détails de la campagne...',
            campaign_completed: 'Campagne terminée avec succès.',
            confirm_cancel_title: 'Confirmer Annuler',
            justify_bulk_confirm: 'Justification de la confirmation groupée :',
            justify_bulk_revoke: 'Justification de la révocation groupée :',
            items_selected: '[[TOK_1]] élément(s) sélectionné(s)',
            justify_bulk_required: 'Une justification est requise pour les actions groupées',
            create_campaign_title: 'Créer une campagne de révision des accès',
            name_required: 'Le nom est requis',
            scope_type_required: 'Le type de portée est requis',
            reviewer_strategy_required: 'Une stratégie de réviseur est requise',
            deadline_required: 'Un délai est requis',
            reviewer_id_required: 'L’ID du réviseur est requis pour une stratégie utilisateur spécifique',
            invalid_json: '[[TOK_0]] non valide',
            scope_filter_label: 'Filtre de portée ([[TOK_0]])',
            reviewer_strategy_label: 'Stratégie des évaluateurs',
            reviewer_id_label: 'ID du réviseur',
            deadline_label: 'Date limite',
            create_campaign_btn: 'Créer une campagne',
            scope_type_label: 'Type de portée',
            scope_by_role: 'Par rôle',
            scope_by_department: 'Par département',
            scope_custom: 'Personnalisé',
            reviewer_manager: 'Gestionnaire',
            reviewer_specific_user: 'Utilisateur spécifique',
            enter_json_filter: 'Entrez le filtre [[TOK_0]]',
            hint_label: 'Indice :',
            role_usage: 'Utilisation des rôles',
            over_privileged_users: 'Utilisateurs trop privilégiés',
            role_name_col: 'Nom du rôle',
            assigned_users: 'Utilisateurs attribués',
            active_users_30d: 'Utilisateurs actifs (30j)',
            total_perms: 'Autorisations totales',
            used_perms: 'Perms utilisées',
            unused_perms: 'Permissions inutilisées',
            no_data_available: 'Aucune donnée disponible',
            roles_col: 'Rôles',
            total_col: 'Total',
            used_col: 'Utilisé',
            unused_pct: '% inutilisé',
            current_count: 'Nombre actuel',
            recommended_count: 'Nombre recommandé',
            rationale: 'Justification',
            loading_analytics: 'Chargement des analyses...',
            loading_role_analytics: "Chargement des données d'analyse des rôles...",
            computed_at: 'Calculé à :',
            form_errors: 'Le formulaire contient des [[TOK_1]] erreur(s). Merci de les corriger.',
            scope_filter_invalid_json: 'Le filtre de portée contient des [[TOK_0]] non valides.',
            scope_hint_all_users: "Aucun filtre n'est nécessaire : tous les utilisateurs seront inclus.",
            review_type_label: 'Type de révision',
            review_type_required: 'Le type de révision est requis',
            reviewer_ids_label: 'IDs des réviseurs',
            reviewer_ids_hint: "Saisissez des IDs d'utilisateur séparés par des virgules",
            reviewer_ids_required: 'Au moins un ID de réviseur est requis',
            start_date_label: 'Date de début',
            start_date_required: 'La date de début est requise',
            end_date_label: 'Date de fin',
            end_date_required: 'La date de fin est requise',
            review_type_user_access: 'Accès utilisateur',
            review_type_role_permissions: 'Permissions de rôle',
            review_type_service_accounts: 'Comptes de service',
            review_type_privileged_access: 'Accès privilégié',
            review_type_application_access: 'Accès application',
            auto_revoke_label: 'Révocation automatique en cas de refus',
            campaigns_title: "Campagnes d'examen d'accès",
            create_campaign_label: '+ Créer une campagne',
            no_campaigns_found: 'Aucune campagne trouvée',
            loading_campaigns: 'Chargement des campagnes...',
            no_reviews_assigned: 'Aucun avis ne vous a été attribué',
            loading_reviews: 'Chargement des avis...',
            review_decision_title: 'Décision de révision',
            justification_label: 'Justification',
            announce_loaded_review_items: "Éléments d'évaluation [[TOK_1]] chargés",
            announce_loaded_campaigns: '[[TOK_1]] campagnes chargées',
            announce_decision_submitted: 'Décision "[[TOK_1]]" soumise pour examen',
            announce_decision_submitted_for: 'Décision "[[TOK_2]]" soumise pour [[TOK_3]]',
            announce_bulk_decision: '[[TOK_2]] en bloc appliqué aux éléments [[TOK_3]]',
        },
        attestation: {
            title: "Calendrier d'attestation",
            new: 'Nouveau planification',
            edit: 'Modifier Planification',
            create_title: "Créer un calendrier d'attestation",
            edit_title: "Modifier le calendrier d'attestation",
            schedule_history: 'Historique du calendrier',
            next_run_date: 'Date de la prochaine exécution',
            schedule_name: 'Planification Nom',
            frequency: 'Fréquence',
            next_run: 'Suivant Exécuter',
            last_run: 'Dernier Exécuter',
            history: "Historique d'attestation",
            description: 'Descriptif',
            scope: 'Portée',
            status: 'Statut',
            created_at: 'Créé',
            updated_at: 'Mis à jour',
            trigger_now: 'Déclenchez maintenant',
            back_to_schedules: 'Retour aux horaires',
            confirm_trigger: 'Trigger this schedule now?',
            confirm_delete: 'Delete this schedule?',
            triggered: 'Planification déclenchée avec succès.',
            deleted: 'Calendrier supprimé.',
            saved: 'Planification enregistrée avec succès.',
            campaigns_generated: 'Campagnes générées',
            run_date: "Date d'exécution",
            run_status: "Statut d'exécution",
            create_schedule: 'Créer un calendrier',
            view_history: "Afficher l'historique",
            deactivate: 'Désactiver',
            overdue: 'OVERDUE',
            overdue_sr: 'Le calendrier est en retard',
            confirm_trigger_title: "Confirmer l'action",
            confirm_trigger_message: 'Are you sure you want to trigger this schedule now?',
            confirm_deactivate_title: 'Confirmer la désactivation',
            confirm_deactivate_message: 'Etes-vous sûr de vouloir désactiver ce planning ?',
            triggered_success: 'Planification déclenchée avec succès.',
            deactivated_success: 'Calendrier désactivé.',
            name_label: 'Nom *',
            frequency_label: 'Fréquence *',
            scope_type_label: 'Type de portée *',
            scope_filter_label: 'Filtre de portée ([[TOK_0]])',
            reviewer_strategy_label: 'Stratégie des évaluateurs *',
            reviewer_id_label: 'ID du réviseur *',
            frequency_quarterly: 'Trimestriel',
            frequency_semi_annual: 'Semestriel',
            frequency_annual: 'Annuel',
            scope_all_users: 'Tous les utilisateurs',
            scope_by_role: 'Par rôle',
            scope_by_department: 'Par département',
            scope_framework: 'Cadre',
            scope_custom: 'Personnalisé',
            reviewer_manager: 'Gestionnaire',
            reviewer_role_owner: 'Propriétaire du rôle',
            reviewer_specific_user: 'Utilisateur spécifique',
            computed_next_run_date: 'Date de prochaine exécution calculée',
            current_scheduled_date: 'Date prévue actuelle',
            recomputed_frequency_changed: '(recalculé -- fréquence modifiée)',
            estimated_days_hint: "Estimation basée sur [[TOK_1]] jours à partir d'aujourd'hui",
            validation_name_required: 'Le nom est requis',
            validation_frequency_required: 'La fréquence est requise',
            validation_scope_type_required: 'Le type de portée est requis',
            validation_reviewer_strategy_required: 'Une stratégie de réviseur est requise',
            validation_reviewer_id_required: 'L’ID du réviseur est requis pour une stratégie utilisateur spécifique',
            validation_invalid_json: '[[TOK_0]] non valide',
            validation_scope_filter_invalid_json: 'Le filtre de portée contient des [[TOK_0]] non valides.',
            form_errors: 'Le formulaire contient des [[TOK_1]] erreur(s). Merci de les corriger.',
            create_schedule_btn: 'Créer un calendrier',
            schedule_history_title: 'Historique des programmes',
            campaign_name_col: 'Nom de la campagne',
            items_col: 'Articles',
            no_campaigns_yet: "Aucune campagne générée pour l'instant",
            loading_history: "Chargement de l'historique...",
            loading_schedule: 'Calendrier de chargement...',
            total_campaigns: 'Nombre total de campagnes : [[TOK_1]]',
            results_per_page: 'Résultats par page',
            page_size_option: '[[TOK_1]] / page',
        },
        sod: {
            title: 'Règles de séparation des tâches',
            new: 'Nouveau Rule',
            edit: 'Modifier la règle',
            create_title: 'Créer une règle SoD',
            edit_title: 'Modifier la règle SoD',
            rule_name: 'Nom de la règle',
            conflicting_permissions: 'Permissions en conflit',
            permission_a: 'Permission Un',
            permission_b: 'Autorisation B',
            violations: 'Violations SoD',
            violation_user: 'Utilisateur',
            violation_rule: 'Règle violée',
            violation_date: 'Détecté le',
            exceptions: 'Exceptions SoD',
            exception_reason: "Motif d'exception",
            exception_approver: 'Approuvé Par',
            exception_status: "Statut d'exception",
            has_exception: 'A une exception',
            no_exception: 'Aucune exception',
            grant_exception: 'Accorder une exception',
            granting: 'Accorder...',
            grant_new_exception: 'Accorder une nouvelle exception',
            exceptions_for: 'Exceptions pour : [[TOK_1]]',
            back_to_rules: 'Retour aux règles',
            no_violations: 'Aucune violation trouvée',
            no_exceptions_found: 'Aucune exception trouvée pour cette règle',
            all_exception_statuses: "Tous les statuts d'exception",
            user_id_label: 'Identifiant utilisateur',
            justification_label: 'Justification',
            compensating_controls_label: 'Contrôles compensatoires',
            expires_at_label: 'Expire à',
            granting_exception_for: 'Accorder une exception pour la règle : [[TOK_1]]',
            severity: 'Gravité',
            severity_warning: 'Avertissement',
            severity_blocking: 'Blocage',
            violation_count: '[[TOK_1]] violation(s)',
            exception_count: '[[TOK_1]] exception(s)',
            rule_description: 'Descriptif',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer cette règle ?',
            deleted: 'Règle supprimée.',
            framework_code: 'Cadre reglementaire',
            name_label: 'Nom *',
            severity_label: 'Gravité *',
            conflict_pairs_legend: "Paires d'autorisations en conflit",
            conflict_pairs_hint: 'Chaque paire définit deux autorisations qui ne doivent pas être détenues par le même utilisateur.',
            placeholder_permission_a: '-- Autorisation A --',
            placeholder_permission_b: '-- Autorisation B --',
            permission_a_for_pair: 'Autorisation A pour la paire [[TOK_1]]',
            permission_b_for_pair: 'Autorisation B pour la paire [[TOK_1]]',
            conflict_pair_label: 'Paire de conflits [[TOK_1]]',
            remove_conflict_pair: 'Supprimer la paire en conflit [[TOK_1]]',
            add_pair: '+ Ajouter une paire',
            placeholder_name: "par ex. Séparation de l'approbation du paiement",
            create_rule: 'Créer une règle',
            loading_rule: 'Chargement de la règle SoD...',
            failed_load_rule: 'Échec du chargement de la règle.',
            failed_create_rule: 'Échec de la création de la règle SoD.',
            failed_update_rule: 'Échec de la mise à jour de la règle SoD.',
            validation_name_required: 'Le nom est requis.',
            validation_pair_required: "Au moins une paire d'autorisations de conflit est requise.",
            validation_pair_both_required: 'Paire [[TOK_1]] : les deux autorisations doivent être sélectionnées.',
            validation_pair_must_differ: "Paire [[TOK_1]] : l'autorisation A et l'autorisation B doivent être différentes.",
            added_conflict_pair: "Ajout d'une paire de conflits [[TOK_1]]",
            removed_conflict_pair: 'Paire de conflits supprimée [[TOK_1]]',
            announce_loaded_violations: 'Violations de [[TOK_1]] chargées',
            announce_loaded_exceptions: '[[TOK_1]] exceptions chargées',
            announce_loaded_rules: '[[TOK_1]] règles SoD chargées',
            announce_loading_exceptions: 'Chargement des exceptions…',
            regulatory_info: {
                sod_context: 'Les regles SoD imposent la separation reglementaire des roles exigee par la PDPL. Les violations liees a un framework_code peuvent etre incluses dans les paquets de preuves (UC-VN-09).',
                violation_export_context: 'Les exports de violations SoD incluent framework_code, roles en conflit, severite, createur et date de detection pour les paquets de preuves (P-VN-10).',
                exception_context: 'Les exceptions SoD produisent des preuves: approbateur, justification, controles compensatoires et date d\\u0027expiration. Les exceptions expirees restent visibles (UC-VN-09 Etape 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Attestation schedules support the annual governance attestation cycle required by Data Law (DATA-D4). When scope_type is set to "framework", schedules can be linked to specific regulatory frameworks.',
            api_keys_context: 'API key telemetry constitutes account evidence per VN_CYBERSEC_LAW_2025 Section B.5. Each key record includes last_used_at, ip_allowlist, permissions, status, and expires_at.',
            session_context: 'Session management enforces access controls per Telecom Law confidentiality requirements (Section B.4). Session events produce audit trail entries.',
            break_glass_context: 'Break-glass procedures produce regulatory justification evidence: requestor identity, justification, permissions, duration, approver identity, and approval/denial timestamps.',
            license_context: 'License settings gate modules by tier using PACKAGE_DEFINITIONS. Framework-specific modules require appropriate license tiers. Tier changes produce audit trail entries.',
            module_config_context: 'Module configuration supports framework-driven enablement. Disabling a module required by an active regulatory framework may break evidence completeness.',
            notification_context: 'Compliance-critical notifications (breach deadlines, attestation due dates) are marked with a compliance_critical flag and cannot be fully suppressed.',
            delegation_context: 'Delegation governance produces audit-grade evidence: delegator_id, delegate_id, permission scope, start/end dates, and status. Expired delegations remain visible.',
            access_control_context: 'Access control configuration meets Cybersecurity Law requirements (VN_CYBERSEC_LAW_2025): IP allowlist, MFA, service accounts, and SSO changes are audit-trailed.',
        },
    },
    cmp: {
        integration: {
            title: 'Intégration CMP',
            status: 'Connexion Statut',
            endpoint: 'Point de terminaison CMP',
            last_sync: 'Dernier Synchroniser',
            configure: 'Configurer',
        },
        purpose_mapping: {
            title: 'Finalité Correspondance',
            cmp_purpose: 'Finalité CMP',
            grc_purpose: 'Finalité GRC',
            mapping_status: 'Correspondance Statut',
            auto_map: 'Correspondance auto.',
            new_mapping: 'Nouveau correspondance',
        },
        webhook: {
            title: 'Configuration du webhook',
            webhook_url: 'URL du webhook',
            secret: 'Secret du webhook',
            events: "Types d'événements",
            test_webhook: 'Tester Webhook',
        },
        bulk_sync: {
            title: 'Synchro. en masse',
            sync_now: 'Synchroniser Maintenant',
            last_run: 'Dernier Exécuter',
            records_synced: 'Enregistrements Synchronisé',
            sync_history: 'Synchroniser Historique',
            syncing: 'Synchronisation...',
        },
        sync_settings: {
            sync_failures: 'Échecs de synchronisation',
            sync_secret_warning: 'Synchroniser Secret (save ce maintenant — il va non être shown again):',
            push_description: 'Configurez GRC Suite pour envoyer les mises à jour de statut des dossiers à AesirX CMP.',
            technical_description: "Cette configuration contrôle la manière dont GRC Suite transmet les mises à jour de l'état des dossiers à [[TOK_1]] [[TOK_0]].",
            direction_label: 'Sens',
            direction_value: 'GRC Suite → AesirX CMP (sortant)',
            auth_label: 'Authentification',
            auth_value: "Signature HMAC-SHA256 dans l'en-tête X-GRC-Signature",
            retry_label: 'Nouvelle tentative Politique',
            retry_value: '3 tentatives avec recul exponentiel (30s, 2min, 10min)',
            inbound_label: 'Config. entrante',
            inbound_value: 'Le webhook entrant (CMP → GRC) est configuré dans',
            cmp_webhook_settings: 'CMP Webhook Paramètres',
            page_title: 'Paramètres de Synchronisation CMP',
            outbound_sync_configured: 'Synchronisation sortante configurée.',
            configure_sync_failed: 'Échec de la configuration de la synchronisation',
            configuration_updated: 'Configuration mise à jour.',
            update_configuration_failed: 'Échec de la mise à jour de la configuration',
            connection_test_failed: 'Échec du test de connexion',
            test_result_message: 'Test envoyé à {endpoint}. Statut : {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Nouveau → sous examiner (assigned)',
                under_review_to_identity_verification: 'Sous Examiner → Identité Vérification',
                under_review_to_in_progress: 'Sous Examiner → En cours',
                in_progress_to_completed: 'En cours → Terminé',
                in_progress_to_denied: 'En cours → Refusé',
                any_to_closed: 'Tout → Fermé',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhooks',
            new: 'Nouveau Webhook',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Événements',
            secret: 'Clé secrète',
            active: 'Actif',
            test: 'Tester',
            create_failed: 'Échec de create webhook. Veuillez réessayer.',
            create_success: 'Webhook créé avec succès',
            deactivate_failed: 'Échec de deactivate webhook. Veuillez réessayer.',
            deactivate_success: 'Webhook désactivé.',
            fetch_failed: 'Échec de fetch webhooks. Veuillez réessayer.',
            send_test_failed: 'Échec de send test. Veuillez réessayer.',
            test_failed: 'Webhook test échoué.',
            test_success: 'Test du webhook réussi.',
            edit_title: 'Modifier le webhook',
            announce_loaded: 'Webhooks chargés',
            update_success: 'Webhook mis à jour avec succès.',
            update_failed: 'Échec de la mise à jour du webhook.',
            activate_success: 'Webhook activé.',
            activate_failed: "Échec de l'activation du webhook.",
        },
        domains: {
            title: 'Domaines',
            new: 'Nouveau domaine',
            domain_name: 'Domaine Nom',
            verified: 'Vérifié',
            verify: 'Vérifier',
            add_failed: 'Échec de add domain. Veuillez réessayer.',
            add_success: 'Domaine added avec succès',
            domain_placeholder: 'p.ex. grc.example.com',
            fetch_failed: 'Échec de fetch domains. Veuillez réessayer.',
            remove_failed: 'Échec de remove domain. Veuillez réessayer.',
            remove_success: 'Domaine removed avec succès',
            txt_record: 'Enregistrement TXT',
            verify_dns_failed: 'La vérification DNS a échoué.',
            verify_failed: 'Échec de verify domain. Veuillez réessayer.',
            verify_success: 'Domaine vérifié avec succès',
        },
        export_schedules: {
            title: "Planifications d'export",
            new: 'Nouveau planification',
            schedule_name: 'Nom',
            frequency: 'Fréquence',
            format: 'Formater',
            last_run: 'Dernier Exécuter',
            next_run: 'Suivant Exécuter',
            create_failed: 'Échec de create schedule. Veuillez réessayer.',
            create_success: 'Planification créé avec succès',
            day_of_month: 'Jour du mois',
            day_of_week: 'Jour de la semaine',
            deactivate_failed: 'Échec de désactiver planifier. Veuillez réessayer.',
            deactivate_success: 'Planification désactivée.',
            fetch_failed: 'Échec de fetch schedules. Veuillez réessayer.',
            freq_daily: 'Quotidien',
            freq_monthly: 'Mensuel',
            freq_weekly: 'Hebdomadaire',
            recipients: 'Destinataires',
            time_utc: 'Heure (UTC)',
            trigger_failed: 'Échec de trigger export. Veuillez réessayer.',
            trigger_success: 'Exporter triggered avec succès.',
            type_audit_trail: "Piste d'audit",
            type_compliance_report: 'Conformité Rapport',
            type_custom: 'Personnalisé',
            type_incident_report: 'Incident Rapport',
            type_ropa: 'ROPA',
        },
        email_log: {
            title: "Journal d'e-mails",
            recipient: 'Destinataire',
            subject: 'Sujet',
            sent_at: 'Envoyé À',
            status: 'Statut',
            resend: 'Renvoyer',
            fetch_failed: 'Échec de fetch email logs. Veuillez réessayer.',
        },
    },
    organizations: {
        title: 'Organisations',
        create: 'Ajouter organisation',
        edit: 'Modifier Organisation',
        name: 'Nom',
        slug: 'Identifiant URL',
        timezone: 'Fuseau horaire',
        locale: 'Par défaut Locale',
        parent: 'Organisation parente',
        group: 'Groupe',
        org_group: "Groupe d'Organisations",
        no_group: "(Aucun - n'appartient à aucun groupe)",
        created: 'Créé',
        no_parent: '(Aucun - autonome)',
        no_orgs: 'Aucun organizations trouvé',
        load_error: 'Échec de load organizations. Veuillez réessayer.',
        save_error: 'Échec de save organization. Veuillez réessayer.',
        created_msg: 'Organisation créé',
        updated: 'Organisation mis à jour',
        deactivate: 'Désactiver',
        deactivated: 'Organisation désactivée',
        confirm_deactivate: 'Êtes-vous sûr de vouloir désactiver cette organisation ?',
        loaded_results: 'Organizations chargés, {count} résultats',
        form_loaded: 'Formulaire Organization chargé',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        locale_en_us: 'Anglais (en-US)',
    },
    intake_configs: {
        title: "Configs d'entrée publiques",
        create: 'Ajouter Config',
        edit: "Modifier la config. d'entrée",
        label_col: 'Libellé',
        key: "Clé d'entrée",
        key_hint: 'Public URL va être: /rights-request?key=',
        mapped_org: 'Cible Organisation',
        status: 'Statut',
        enabled: 'Activé',
        disabled: 'Désactivé',
        request_types: 'Activé Demande Types',
        language: 'Par défaut Langue',
        public_url: 'URL publique',
        no_configs: "Aucune config. d'entrée trouvée. Créez-en une pour activer les formulaires de demande de droits.",
        load_error: 'Échec de load intake configs. Veuillez réessayer.',
        save_error: 'Échec de save. Veuillez réessayer.',
        delete_error: 'Échec de supprimer. Veuillez réessayer.',
        created_msg: 'Configuration créée',
        updated: 'Configuration mise à jour',
        deleted: "Config. d'entrée supprimée",
        confirm_delete: "Supprimer cette configuration d'entrée ?",
        select_types: 'Sélectionnez at least one request type',
        select_org: 'Sélectionnez target organization',
        routing_mode: 'Mode de Routage',
        single_org: 'Organisation Unique',
        org_group_mode: "Groupe d'Organisations",
        org_group: "Groupe d'Organisations",
        select_group: "Sélectionnez un groupe d'organisations...",
        group_root_hint: "Défini automatiquement sur l'organisation racine du groupe lorsque le groupe est sélectionné.",
        loaded_results: 'Intake configurations chargés, {count} résultats',
        form_loaded: 'Formulaire Intake configuration chargé',
    },
    frequency: {
        weekly: 'Hebdomadaire',
        monthly: 'Mensuel',
        quarterly: 'Trimestriel',
        semi_annually: 'Semestriel',
        annually: 'Annuel',
        custom: 'Personnalisé',
    },
    task_management: {
        nav: {
            calendar: 'Calendrier',
            all_tasks: 'Toutes les tâches',
            my_tasks: 'Mes tâches',
            overdue: 'En retard',
            board: 'Tableau',
            workflows: 'Flux de travail',
        },
        list: {
            title: 'Toutes les tâches',
            my_title: 'Mes tâches',
            overdue_title: 'Tâches en retard',
            new_task: 'Créer une tâche',
            no_tasks: 'Aucune tâche trouvée.',
            empty_state: 'Aucune tâche trouvée. Les tâches sont générées à partir des flux de travail des modules comme les évaluations, les incidents et les campagnes de révision.',
            total: 'Total des tâches',
            search_placeholder: 'Rechercher des tâches...',
            bulk_actions: 'Actions groupées',
            change_status: 'Changer le statut',
            change_priority: 'Changer la priorité',
            assign: 'Assigner',
            sr_my_tasks_count: '{count} tâches assignées à vous',
            sr_days_overdue: '{count} jours de retard',
            sla_label: 'SLA',
        },
        detail: {
            title: 'Détail de la tâche',
            description: 'Descriptif',
            workflow_progress: 'Progression du flux de travail',
            checklist: 'Liste de contrôle',
            dependencies: 'Dépendances',
            comments: 'Commentaires',
            activity_timeline: "Chronologie d'activité",
            assignees: 'Assignés',
            add_assignee: 'Ajouter un assigné',
            remove_assignee: 'Retirer un assigné',
            due_date: "Date d'échéance",
            start_date: 'Date de début',
            sla_status: 'Statut SLA',
            sla_on_track: 'Dans les délais',
            sla_at_risk: 'À risque',
            sla_breached: 'Dépassé',
            tags: 'Balises',
            source_entity: 'Entité source',
            view_source: 'Voir la source',
            add_dependency: 'Ajouter une dépendance',
            remove_dependency: 'Retirer une dépendance',
            write_comment: 'Écrire un commentaire...',
            post_comment: 'Publier',
            edit_comment: 'Modifier',
            delete_comment: 'Supprimer',
            add_checklist_item: 'Ajouter un élément',
            no_dependencies: 'Aucune dépendance',
            no_comments: 'Aucun commentaire',
            blocks: 'Bloque',
            blocked_by: 'Bloqué par',
            related: 'Lié',
            working_days_remain: 'jours ouvrés restants',
            created_by: 'Créé par',
            completed_at: 'Terminé le',
            no_assignees: 'Aucun assigné',
            add_assignee_placeholder: "Saisir l'ID utilisateur...",
            edited: 'modifié',
            timeline: "Chronologie d'activité",
            no_timeline: 'Aucune activité',
            no_workflow: 'Aucun flux de travail assigné',
            add_dependency_placeholder: "Saisir l'ID de tâche...",
            sr_status_updated: 'Statut mis à jour : [[TOK_1]]',
            sr_priority_updated: 'Priorité mise à jour sur [[TOK_1]]',
            convert_to_workflow: 'Exécuter en tant que workflow',
            convert_modal_title: 'Convertir une tâche en exécution de flux de travail',
            convert_workflow_label: 'Flux de travail',
            convert_workflow_placeholder: 'Choisissez un flux de travail…',
            convert_attachments_label: 'Pièces jointes',
            convert_attachments_empty: 'Aucune pièce jointe sur cette tâche.',
            convert_persona_label: 'Remplacement de la personnalité (facultatif)',
            convert_submit: "Démarrer l'exécution du flux de travail",
            convert_starting: "Démarrage de l'exécution du flux de travail…",
            convert_started: 'L’exécution du workflow a démarré – ouverture de l’exécution…',
            convert_disabled_in_flight: 'Un workflow exécuté à partir de cette tâche est déjà en cours.',
            linked_workflow_chip: 'De [[TOK_1]]',
            linked_chat_chip: 'Depuis le chat [[TOK_0]]',
            linked_more: '+[[TOK_1]] plus',
        },
        calendar: {
            title: 'Calendrier des tâches',
            page_title: 'Calendrier',
            create_task: 'Créer une tâche',
            month: 'Mois',
            week: 'Semaine',
            day: 'Jour',
            today: "Aujourd'hui",
            more_tasks: '+[[TOK_1]] plus',
            no_tasks_day: 'Aucune tâche ce jour',
            all_day: 'Toute la journée',
            quick_create_tooltip: 'Créer une tâche pour ce jour',
            view_changed: 'Vue du calendrier changée en {view}',
            tasks_in_view: '{count} tâches dans la vue',
            task_in_view: '[[TOK_1]] tâche en vue',
        },
        filters: {
            assignee: 'Assigné',
            me: 'Moi',
            role: 'Rôle',
            status: 'Statut',
            priority: 'Priorité',
            task_type: 'Type de tâche',
            source_module: 'Module source',
            organization: 'Organisation',
            sla_breached_only: 'Afficher uniquement SLA dépassé',
            clear_filters: 'Effacer les filtres',
            apply_filters: 'Appliquer',
            source_label: 'Origine',
            source_manual: 'Manuel',
            source_module_kind: 'Généré par le module',
            source_chat: 'Depuis le chat [[TOK_0]]',
            source_workflow_run: 'À partir de [[TOK_0]] Exécution du workflow',
        },
        status: {
            pending: 'En attente',
            in_progress: 'En cours',
            blocked: 'Bloqué',
            completed: 'Terminé',
            overdue: 'En retard',
            escalated: 'Escaladé',
            cancelled: 'Annulé',
        },
        priority: {
            critical: 'Critique',
            high: 'Élevée',
            medium: 'Moyenne',
            low: 'Basse',
        },
        task_types: {
            manual_task: 'Tâche manuelle',
            dsr_case: 'Cas DSR',
            dsr_review: 'Revue DSR',
            dsr_escalation: 'Escalade DSR',
            dpia_review: 'Revue AIPD',
            dpia_approval: 'Approbation AIPD',
            transfer_review: 'Revue de transfert',
            incident_task: "Tâche d'incident",
            incident_notification: "Notification d'incident",
            playbook_step: 'Étape du guide',
            regulator_deadline: 'Échéance réglementaire',
            monitoring_task: 'Tâche de surveillance',
            kpi_alert: 'Alerte KPI',
            vendor_review: 'Revue fournisseur',
            vendor_questionnaire: 'Questionnaire fournisseur',
            governance_review: 'Revue de gouvernance',
            drift_alert: 'Alerte de dérive',
            governance_approval: 'Approbation de gouvernance',
            deletion_task: 'Tâche de suppression',
            deletion_verification: 'Vérification de suppression',
            access_review: 'Revue des accès',
            sod_alert: 'Alerte SoD',
            consent_workflow: 'Flux de consentement',
            consent_alert: 'Alerte de consentement',
            property_review: 'Revue de propriété',
            inconsistency_alert: "Alerte d'incohérence",
            form_review: 'Revue de formulaire',
            dossier_deadline: 'Échéance de dossier',
            submission_task: 'Tâche de soumission',
            translation_review: 'Revue de traduction',
            governance_task: 'Tâche de gouvernance',
            reporting_deadline: 'Échéance de rapport',
            scanner_alert: 'Alerte du scanner',
            classification_review: 'Revue de classification',
            lifecycle_task: 'Tâche de cycle de vie',
            discovery_review: 'Revue de découverte',
        },
        task_type_groups: {
            manual: 'Manuel',
            dsr: 'DSR / Demandes de droits',
            assessments: 'Évaluations',
            incidents: 'Incidents',
            incident_ops: "Opérations d'incidents",
            monitoring: 'Surveillance',
            vendor_risk: 'Risque fournisseurs',
            governance: 'Gouvernance',
            deletion: 'Suppression',
            access_review: 'Revue des accès',
            consent: 'Consentement',
            consent_properties: 'Propriétés du consentement',
            forms: 'Formulaires',
            localization: 'Localisation',
            program_governance: 'Gouvernance de programme',
            privacy_scanner: 'Scanner de confidentialité',
            classification: 'Classement',
            discovery: 'Découverte',
        },
        create: {
            title: 'Créer une tâche',
            task_title: 'Titre',
            task_description: 'Descriptif',
            task_type: 'Type de tâche',
            task_type_label: 'Type de tâche',
            task_type_placeholder: 'Sélectionner un type de tâche',
            priority: 'Priorité',
            assignees: 'Assignés',
            assignee_search_placeholder: 'Rechercher des utilisateurs...',
            due_date: "Date d'échéance",
            start_date: 'Date de début',
            checklist: 'Liste de contrôle',
            tags: 'Balises',
            add_checklist_item: 'Ajouter un élément de liste',
            validation: {
                title_required: 'Le titre est obligatoire',
                title_max_length: 'Le titre doit comporter 500 caractères ou moins',
                description_max_length: 'La description doit comporter 5000 caractères ou moins',
                due_date_before_start: "La date d'échéance doit être postérieure à la date de début",
                max_reminders: 'Maximum 5 rappels par tâche',
            },
            reminders: {
                title: 'Rappels',
                add: 'Ajouter un rappel',
                at_due_date: "À la date d'échéance",
                minutes_before: '[[TOK_1]] minutes avant',
                hours_before: '[[TOK_1]] heures avant',
                days_before: '[[TOK_1]] jours avant',
                weeks_before: '[[TOK_1]] semaines avant',
                custom: 'Personnalisé',
                channel_platform: 'Plateforme',
                channel_email: 'E-mail',
                channel_both: 'Les deux',
            },
            workflow: {
                label: 'Flux de travail',
                none: 'Aucun (gestion manuelle des statuts)',
                steps_count: '[[TOK_1]] étapes',
                preview_label: 'Étapes du flux',
            },
        },
        errors: {
            fetch_failed: 'Échec du chargement des tâches.',
            save_failed: "Échec de l'enregistrement de la tâche.",
            delete_failed: 'Échec de la suppression de la tâche.',
            status_change_failed: 'Échec du changement de statut.',
            assign_failed: "Échec de l'assignation.",
            comment_failed: "Échec de l'enregistrement du commentaire.",
            checklist_failed: 'Échec de la mise à jour de la liste de contrôle.',
            dependency_failed: 'Échec de la mise à jour de la dépendance.',
            workflow_failed: "Échec de l'enregistrement du flux.",
            workflow_activate_failed: "Échec de l'activation du flux.",
            workflow_delete_failed: 'Échec de la suppression du flux.',
            template_install_failed: "Échec de l'installation du modèle.",
            search_failed: 'Échec de la recherche.',
            convert_failed: "Impossible de démarrer l'exécution du flux de travail.",
            convert_quota_exhausted: "Le seau de jetons est bas. Faites l'appoint avant de réexécuter.",
        },
        dependency_types: {
            blocks: 'Bloque',
            blocked_by: 'Bloqué par',
            related: 'Lié',
        },
        workflow: {
            current_step: 'Étape actuelle',
            transition: 'Transition',
            history: 'Historique des étapes',
            no_workflow: 'Aucun flux de travail assigné',
            detail_title: 'Détails du workflow',
            list_title: 'Définitions des flux de travail',
            create_workflow: 'Créer un flux de travail',
            browse_templates: 'Parcourir les modèles',
            template_catalog_title: 'Catalogue de modèles',
            name: 'Nom',
            description: 'Descriptif',
            task_types: 'Types de tâche',
            steps: 'Étapes',
            version: 'Version',
            created: 'Créé',
            actions: 'Actions',
            status_draft: 'Brouillon',
            status_active: 'Actif',
            status_archived: 'Archivé',
            activate: 'Activer',
            archive: 'Archiver',
            save: 'Enregistrer',
            edit: 'Modifier',
            delete: 'Supprimer',
            clone: 'Cloner',
            install: 'Installer',
            installed: 'Installé',
            system: 'Système',
            general_settings: 'Paramètres généraux',
            default_assignment: 'Assignation par défaut',
            default_sla: 'SLA par défaut',
            workflow_steps: 'Étapes du flux de travail',
            add_step: 'Ajouter une étape',
            step_name: "Nom de l'étape",
            step_status: 'Valeur du statut',
            assignment_strategy: "Stratégie d'assignation",
            assignment_role: "Rôle d'assignation",
            sla_hours: 'Heures SLA',
            sla_calendar_type: 'Type de calendrier',
            working_days: 'Jours ouvrés',
            calendar_days: 'Jours calendaires',
            is_terminal: 'Étape terminale',
            required_fields: 'Champs obligatoires',
            checklist_template: 'Modèle de liste de contrôle',
            transitions: 'Transitions',
            add_transition: 'Ajouter une transition',
            from_step: 'De',
            to_step: 'Vers',
            permission: 'Autorisation',
            sla_action: 'Action SLA',
            notify: 'Notifier',
            escalation_rules: "Règles d'escalade",
            add_rule: 'Ajouter une règle',
            trigger: 'Déclencheur',
            threshold: 'Seuil',
            action: 'Action',
            target_role: 'Rôle cible',
            trigger_sla_threshold: 'Seuil SLA',
            trigger_sla_breach: 'Violation SLA',
            trigger_blocked_duration: 'Durée bloquée',
            trigger_manual: 'Manuel',
            action_notify: 'Notifier',
            action_escalate: 'Escalader le niveau',
            action_reassign: 'Réassigner',
            sla_start: 'Démarrer',
            sla_pause: 'Pause',
            sla_resume: 'Reprendre',
            sla_stop: 'Arrêter',
            strategy_manual: 'Manuel',
            strategy_role_based: 'Basé sur le rôle',
            strategy_round_robin: 'Tournoi à la ronde',
            strategy_least_loaded: 'Moins chargé',
            strategy_creator: 'Créateur',
            confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce flux de travail ?',
            confirm_archive: 'Êtes-vous sûr de vouloir archiver ce flux de travail ?',
            cannot_delete_active: "Les flux actifs ne peuvent pas être supprimés. Archivez d'abord.",
            validation_errors: 'Erreurs de validation du flux',
            step_count: '[[TOK_1]] étapes',
            no_workflows: 'Aucun flux trouvé.',
            no_templates: 'Aucun modèle disponible.',
            sr_templates_count: '[[TOK_1]] modèles disponibles',
            template_installed: 'Modèle installé avec succès.',
            activate_success: 'Flux de travail activé avec succès.',
            archive_success: 'Flux de travail archivé avec succès.',
            save_success: 'Flux de travail enregistré avec succès.',
            delete_success: 'Flux de travail supprimé avec succès.',
        },
        columns: {
            priority: 'Priorité',
            title: 'Titre',
            status: 'Statut',
            type: 'Tapez',
            assignees: 'Assigné(s)',
            due_date: "Date d'échéance",
            source: 'Origine',
            actions: 'Actions',
        },
        groups: {
            overdue: 'En retard',
            due_today: "Échéance aujourd'hui",
            due_this_week: 'Échéance cette semaine',
            due_later: 'Échéance ultérieure',
            no_due_date: "Sans date d'échéance",
        },
        board: {
            title: 'Tableau des tâches',
            drag_hint: 'Glissez les tâches entre les colonnes pour changer le statut',
            empty_column: 'Aucune tâche',
            keyboard_hint: 'Clavier : flèches pour naviguer, espace pour saisir une tâche, gauche/droite pour sélectionner la colonne, Entrée pour déposer, Échap pour annuler.',
            sr_moving: 'Déplacement de {title}. Au-dessus de {column}. Appuyez sur Entrée pour déposer, Échap pour annuler.',
            sr_tasks_shown: '{count} tâches affichées',
            sr_picked_up: '{title} saisi',
            sr_returned: '[[TOK_2]] est revenu à [[TOK_3]]',
            sr_dropped: '{title} déposé dans {column}, position {position} sur {total}',
            sr_move_cancelled: 'Déplacement annulé',
            sr_over_column: 'Au-dessus de {column}',
            sr_moved_to: '{title} deplace vers {column}',
            invalid_transition: 'Impossible de deplacer la tache de {from} vers {to}.',
            terminal_status: 'Cette tache a un statut terminal et ne peut pas etre deplacee.',
            invalid_drop_target: 'Cible de depot invalide',
        },
        team: {
            title: "Charge de travail de l'équipe",
            assignee: 'Assigné',
            active: 'Actif',
            overdue: 'En retard',
            blocked: 'Bloqué',
            completed_7d: 'Terminé (7j)',
            load: 'Charge',
            load_high: 'Élevée',
            load_medium: 'Moyenne',
            load_normal: 'Normale',
        },
        graph: {
            title: 'Graphique de dépendance',
            list_view: 'Vue en liste',
            graph_view: 'Vue graphique',
            zoom_in: 'Zoomer',
            zoom_out: 'Zoom arrière',
            reset_zoom: 'Réinitialiser',
            blocks_label: 'blocks',
            related_label: 'related',
            no_dependencies: 'Aucune dépendance à visualiser.',
        },
        add_dependency_modal: {
            title: 'Ajouter une dépendance',
            search_placeholder: 'Rechercher des tâches par titre ou ID...',
            no_results: 'Aucune tâche trouvée.',
            this_blocks: 'Cette tâche bloque les blocs sélectionnés',
            this_blocked_by: 'Cette tâche est bloquée par les sélectionnés',
            related: 'Lié',
            max_dependencies: 'Maximum 10 dépendances par tâche.',
            circular_error: "Impossible d'ajouter : cela créerait une dépendance circulaire.",
        },
        conflict_detection: {
            title: 'Détection de conflits',
            unresolved: 'non résolu',
            no_conflicts: 'Aucun conflit détecté',
            section: 'Section',
            field: 'Champ',
            dept_a: 'Département A',
            value_a: 'Valeur A',
            dept_b: 'Département B',
            value_b: 'Valeur B',
            severity: 'Gravité',
            status: 'Statut',
            resolved: 'Résolu',
            open: 'Ouvert',
            resolve: 'Résoudre',
            load_failed: 'Échec de load conflicts',
            resolve_success: 'Conflit résolu avec succès',
            resolve_failed: 'Échec de resolve conflict',
            severity_critical: 'Critique',
            severity_warning: 'Avertissement',
            severity_info: 'Informations',
        },
        consolidation: {
            title: 'Progrès de consolidation',
            add_child: 'Ajouter une sous-tâche',
            child_task_id: 'ID de la sous-tâche',
            department_id: 'ID du département',
            link: 'Lier',
            overall_completion: 'Achèvement global',
            departments_complete: 'Départements terminés',
            overdue: 'En retard',
            ready: 'Prêt',
            not_ready: 'Pas prêt',
            master_status: 'Statut principal',
            department_breakdown: 'Répartition par département',
            department: 'Département',
            status: 'Statut',
            completion: 'Achèvement',
            due_date: "Date d'échéance",
            overdue_flag: 'En retard',
            child_tasks: 'Sous-tâches',
            task: 'Tâche',
            load_failed: 'Échec de load consolidation data',
            child_linked: 'Sous-tâche liée avec succès',
            link_failed: 'Échec de link child task',
            confirm_unlink: 'Voulez-vous vraiment dissocier cette sous-tâche ?',
            child_unlinked: 'Sous-tâche dissociée',
            unlink_failed: 'Échec de la dissociation de la sous-tâche',
            unlink: 'Dissocier',
            status_completed: 'Terminé',
            status_in_progress: 'En cours',
            status_pending: 'En attente',
            select_child_task: 'Sélectionner la sous-tâche',
            select_department: 'Sélectionner le département',
        },
        section_assignments: {
            title: 'Attributions de section',
            assign_section: 'Attribuer une section',
            section_ref: 'Réf. de section',
            section_label: 'Libellé de section',
            department_id: 'ID du département',
            department: 'Département',
            assignee_id: "ID de l'assigné",
            assignee: 'Cessionnaire',
            mandatory: 'Obligatoire',
            assign: 'Attribuer',
            no_assignments: 'Aucune attribution de section',
            status: 'Statut',
            completion: 'Achèvement',
            mark_complete: 'Terminer',
            load_failed: 'Échec de load section assignments',
            assign_success: 'Section attribuée avec succès',
            assign_failed: 'Échec de assign section',
            status_updated: 'Statut mis à jour',
            status_update_failed: 'Échec de la mise à jour du statut',
            section_ref_placeholder: 'par ex. 3.2',
            status_completed: 'Terminé',
            status_in_progress: 'En cours',
            status_pending: 'En attente',
            select_department: 'Sélectionnez le département',
            select_assignee: 'Sélectionnez le destinataire',
        },
        overdue_columns: {
            days_overdue: 'Jours de retard',
        },
        regulatory_info: {
            deadline_context: 'Lors de la creation de taches DPIA, les dates d echeance doivent correspondre aux delais de depot PDPL : contribution departementale = 10 jours ouvrables. Les delais de cybersecurite et de telecommunications s appliquent egalement.',
            overdue_deadline_context: 'Delais reglementaires des donnees de pack : contribution departementale PDPL = 10 jours ouvrables, reponse supplementaire = 15 jours ouvrables, resoumission = 10 jours ouvrables. Les taches en violation de SLA sont distinguees visuellement.',
            section_assignment_context: 'Processus DPIA multi-departements (PDPL-P1) : le DPO attribue les sections du dossier aux departements. Delai de contribution departementale : 10 jours ouvrables.',
            template_catalog_context: 'Les modeles systeme couvrent les processus specifiques aux cadres : DPIA PDPL, attestation de la loi sur les donnees, reponse aux incidents de cybersecurite, demandes d autorite telecom et enregistrement de systeme IA. Les modeles systeme ne sont pas modifiables.',
            workflow_instantiation_context: 'Les modeles installes peuvent etre instancies en flux de travail actifs. Les taches sont creees automatiquement avec des dates d echeance calculees.',
        },
    },
    notifications: {
        bell: {
            title: 'Notifications',
            unread_count: 'unread',
        },
        drawer: {
            title: 'Notifications',
            mark_all_read: 'Marquer tout comme lu',
            no_notifications: 'Aucune notification',
            filter: {
                all: 'All',
                unread: 'Non lu',
                tasks: 'Tâches',
                approvals: 'Approbations',
                alerts: 'Alertes',
            },
        },
        preferences: {
            title: 'Préférences de notifications',
            description: 'Configurer la façon dont vous recevez les notifications',
            category: {
                label: 'Catégorie',
                task_assigned: 'Tâche assignée',
                task_sla_approaching: '[[TOK_0]] Approche',
                task_overdue: 'Tâche en retard',
                task_completed: 'Tâche terminée',
                task_escalated: 'Tâche escaladée',
                workflow_transition: 'Transition du flux de travail',
                approval_requested: 'Approbation demandée',
                comment_added: 'Commentaire ajouté',
                weekly_digest: 'Résumé hebdomadaire',
                sla_breach_report: '[[TOK_0]] Rapport de violation',
                system_alert: 'Alerte système',
            },
            channel: {
                platform: 'Plateforme',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Heures calmes',
                start: 'Démarrer',
                end: 'End',
                timezone: 'Fuseau horaire',
            },
            digest: {
                title: 'Fréquence de résumé',
                daily: 'Quotidiennement',
                weekly: 'Hebdomadaire',
                none: 'Aucun',
            },
            watched: {
                title: 'Entités surveillées',
                empty: 'Aucune entité surveillée',
            },
            save: 'Enregistrer les préférences',
            saving: 'Sauvegarde...',
            saved_success: 'Préférences enregistrées avec succès',
            load_error: 'Impossible de charger les préférences enregistrées. Affichage des valeurs par défaut : les modifications seront enregistrées lorsque vous cliquerez sur Enregistrer.',
            enabled: 'Activé',
            disabled: 'Désactivé',
            unwatch: 'Ne plus regarder',
        },
        admin_queue: {
            title: "File d'administration des notifications",
            description: "Surveiller l'état de livraison des e-mails et réessayer les messages échoués",
            load_error: "Impossible de charger les données de la file d'attente des e-mails",
            retry_error: "Impossible de réessayer l'e-mail",
            filter_status: 'Filtrer par statut',
            all_statuses: 'Tous',
            refresh: 'Actualiser',
            status_queued: "En file d'attente",
            status_sent: 'Envoyé',
            status_failed: 'Échoué',
            status_bounced: 'Rejeté',
            col_recipient: 'Destinataire',
            col_category: 'Catégorie',
            col_template: 'Modèle',
            col_status: 'Statut',
            col_retries: 'Tentatives',
            col_created: 'Créé',
            col_sent: 'Envoyé le',
            col_actions: 'Actions',
            no_items: "Aucun élément dans la file d'attente des e-mails",
            retry: 'Réessayer',
            retrying: 'Nouvelle tentative...',
            prev: 'Précédent',
            next: 'Suivant',
            access_denied_title: 'Accès administrateur requis',
            access_denied: "Cette page est réservée aux administrateurs. Veuillez contacter votre administrateur si vous avez besoin d'un accès.",
            announce_queue_loaded: "File d'attente de courrier électronique chargée, [[TOK_1]] éléments",
            announce_processed: '[[TOK_1]] e-mail(s) traité(s)',
            process_now: 'Traiter maintenant',
            processing_ellipsis: 'Traitement…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'Assistance UI',
            activate: 'Activer',
            deactivate: 'Désactiver',
            connected: 'Connecté',
            disconnected: 'Déconnecté',
            disconnected_hint: 'Déconnecté - exécutez `npm run relay` pour vous connecter à Claude CLI',
            open_panel: 'Ouvrir le panneau UI Assist',
            history: 'Histoire',
            settings: 'Paramètres',
        },
        prompt: {
            placeholder: 'Décrivez le changement que vous souhaitez apporter…',
            send: 'Envoyer',
            cancel: 'Annuler',
            char_count: '[[TOK_2]] / [[TOK_3]]',
        },
        session: {
            streaming: 'Traitement…',
            complete: 'Terminé',
            error: 'Erreur',
            abort: 'Abandonner',
            abort_confirm: 'Êtes-vous sûr de vouloir abandonner ?',
            aborted_hint: "La session a été interrompue — vous pouvez continuer d'ici.",
            undo: 'Annuler',
            redo: 'Refaire',
            retry: 'Réessayer',
            dismiss: 'Rejeter',
        },
        label: {
            component: 'Composant',
            element: 'Élément',
            file: 'Fichier',
        },
        response: {
            you: 'You',
            claude: 'Claude',
            empty: "Aucun message pour l'instant. Sélectionnez des éléments et envoyez une invite pour commencer.",
        },
        panel: {
            tab_conversation: 'Discuter',
            tab_tasks: 'Tâches',
            tab_sprint: 'Sprint',
            tab_sessions: 'Séances',
            tab_lobby: "Hall d'entrée",
            follow_up: 'Suivi',
            followup_placeholder: 'Posez une question complémentaire…',
            interrupt_placeholder: 'Tapez pour interrompre et rediriger…',
            send_interrupt: 'Envoyer & Interrompre',
            will_interrupt: 'Interrompt la réponse en cours et envoie ceci à la place',
            expand: 'Agrandir en plein écran',
            collapse: 'Réduire au panneau latéral',
            no_sessions: 'Aucune session précédente. Sélectionnez des éléments et envoyez une instruction.',
            session_active: 'Actif',
            session_ended: 'Terminée',
            session_messages: '[[TOK_1]] messages',
            switch_session: 'Basculer vers cette session',
            load_session: "Charger l'historique des sessions",
            session_restored: "Session restaurée à partir de l'historique",
            archive_session: "Séance d'archivage",
            archive_confirm: 'Archiver cette session ? Le fichier de session sera supprimé.',
            new_session: 'Nouvelle séance',
            new_session_desc: "Utilisez Activer pour sélectionner un élément de l'interface utilisateur et démarrer une nouvelle session",
            start_new_session: 'Démarrer une nouvelle session',
            no_active_session_chat: "Démarrez une nouvelle session ou utilisez Activer pour sélectionner un élément d'interface utilisateur sur la page pour commencer.",
            no_active_session_tasks: 'Démarrez une nouvelle session ou sélectionnez une session existante pour créer des tâches.',
            no_active_session_sprint: 'Démarrez une nouvelle session ou sélectionnez une session existante pour planifier un sprint.',
            previous_sessions: 'Séances précédentes',
        },
        tasks: {
            none_found: 'Aucune tâche trouvée dans la réponse. Demandez à Claude de suggérer des tâches.',
            selected: 'selected',
            create_selected: 'Créer des tâches',
            execute_tasks: 'Exécuter les tâches',
            creating: 'Création…',
            created: 'tâches créées',
            create_error: 'Échec de la création de la tâche',
            plan_sprint: 'Planifier le sprint',
            priority_critical_desc: 'Bloquant — corriger immédiatement',
            priority_high_desc: 'Important — traiter ce sprint',
            priority_medium_desc: 'Normal — planifier pour le prochain sprint',
            priority_low_desc: 'Souhaitable — candidat pour le backlog',
            add_custom: 'Ajouter une tâche',
            add_title_placeholder: 'Titre de la tâche…',
            add_desc_placeholder: 'Description (facultatif)',
            add_save: 'Ajouter',
            add_cancel: 'Annuler',
        },
        sprint: {
            title: 'Planificateur de sprints',
            assigned: 'assigned',
            new_placeholder: 'Nom du sprint (par exemple, Sprint 18.1.0)',
            add: 'Add',
            backlog: 'Carnet de commandes',
            move_to: 'Déplacer vers…',
            empty: 'Créez un groupe de sprint et attribuez-lui des tâches.',
            create_all: 'Créer toutes les tâches',
            remove: 'Supprimer',
            drop_here: 'Attribuez des tâches à partir du backlog ci-dessous',
            add_task: 'Ajouter une tâche du backlog…',
        },
        feature_disabled: "UI Assist n'est pas activé",
        permission_denied: "Vous n'êtes pas autorisé à utiliser UI Assist",
    },
    license: {
        title: 'Licence et forfait',
        current_license: 'Licence actuelle',
        license_key: 'Clé de licence',
        activate: 'Activer la licence',
        deactivate: 'Désactiver la licence',
        validate_now: 'Valider maintenant',
        status: 'Statut de la licence',
        active: 'Actif',
        expired: 'Expiré',
        suspended: 'Suspendu',
        invalid: 'Invalide',
        pending: 'En attente',
        no_license: 'Pas de licence',
        expires_at: 'Expire',
        last_validated: 'Dernière validation',
        domain: 'Domaine sous licence',
        activation_success: 'Licence activée avec succès.',
        activation_failed: "L'activation de la licence a échoué.",
        domain_mismatch: 'Le domaine de licence ne correspond pas au domaine actuel.',
        deactivation_success: 'Licence désactivée.',
        validation_success: 'Licence validée avec succès.',
        validation_failed: 'La validation de la licence a échoué.',
        enter_key: 'Entrez votre clé de licence',
        confirm_deactivate: "Êtes-vous sûr de vouloir désactiver cette licence ? Les restrictions de module s'appliqueront en fonction du niveau par défaut.",
    },
    package_mgmt: {
        title: 'Forfait',
        module_column: 'Module',
        current_tier: 'Forfait actuel',
        light: 'Lumière',
        standard: 'Norme',
        enterprise_unlimited: 'Entreprise illimitée',
        change_package: 'Changer de forfait',
        upgrade: 'Mise à niveau',
        downgrade: 'Rétrograder',
        target_tier: 'Forfait cible',
        new_license_key: 'Clé de licence pour le package cible',
        confirm_change: 'Confirmer le changement de package',
        change_success: 'Le package a été modifié avec succès.',
        change_failed: 'La modification du package a échoué.',
        modules_included: 'Modules inclus',
        modules_restricted: 'Non disponible dans le forfait actuel',
        upgrade_to_enable: 'Mettez à niveau pour activer ce module.',
        module_availability: 'Disponibilité des modules',
        comparison: 'Comparaison des forfaits',
        power_users: 'Utilisateurs expérimentés',
        unlimited: 'Illimité',
        impact_warning: 'La rétrogradation désactivera les modules suivants :',
        invalid_license: "La clé de licence fournie n'est pas valide pour ce package.",
        tier_mismatch: 'La clé de licence concerne un niveau de package différent.',
    },
    board_report: {
        title: 'Rapport de Conformité au Conseil',
        subtitle: "Synthèse de la conformité sur l'ensemble des modules",
        date_from: 'Date de début',
        date_to: 'Date de fin',
        language: 'Langue du rapport',
        generate: 'Générer le rapport',
        generating: 'Génération du rapport...',
        download_pdf: 'Télécharger le PDF',
        close: 'Fermer le rapport',
        open_board_report: "Générer le rapport d'administration",
        close_board_report: "Fermer le rapport d'administration",
        report_period: 'Période du rapport',
        generated_at: 'Généré le',
        generated_by: 'Généré par',
        organization: 'Organisation',
        section_rights_requests: 'Demandes de droits',
        section_vendors: 'Fournisseurs',
        section_dpias: 'AIPD',
        section_consent: 'Politiques de consentement',
        section_data_mapping: 'Cartographie des données',
        section_incidents: 'Incidents',
        section_classification: 'Classification des données',
        section_governance: 'Gouvernance',
        open: 'Ouvert',
        closed: 'Fermé',
        sla_compliance: 'Conformité SLA',
        total: 'Total',
        expired_dpa: 'DPA expiré',
        high_risk: 'Risque élevé',
        completed: 'Terminé',
        overdue: 'En retard',
        policies_active: 'Politiques actives',
        coverage: 'Couverture',
        systems: 'Systèmes',
        completeness: 'Complétude',
        avg_resolution_days: 'Durée moy. de résolution (jours)',
        labeled: 'Étiqueté',
        unlabeled_systems: 'Systèmes non étiquetés',
        compliance_score: 'Score de conformité',
        drift_events_open: 'Écarts ouverts',
        no_data: 'Aucune donnée disponible pour la période sélectionnée.',
        error_date_range: 'Veuillez sélectionner une date de début et de fin.',
        table_category: 'Catégorie',
        table_metric: 'Métrique',
        table_value: 'Valeur',
        showing_chart_view: 'Affichage de la vue graphique',
        showing_table_view: 'Affichage de la vue tableau de données',
        error_generate: "Le rapport d'administration n'a pas pu être généré.",
        playbook_evidence_title: "Preuves d'exécution des playbooks",
        playbook_evidence_description: "Activité d'exécution par playbook et fichiers de preuve joints pour la période du rapport.",
        playbook_name: 'Manuel de jeu',
        playbook_execution_count: 'Exécutions',
        playbook_steps_total: 'Étapes',
        playbook_steps_required: 'Preuve requise',
        playbook_steps_attached: 'Preuve jointe',
        playbook_coverage_pct: 'Couverture',
        playbook_evidence_files: 'Fichiers de preuve',
        playbook_no_evidence: 'Aucune exécution de playbook sur cette période.',
        playbook_download_file: 'Télécharger le fichier',
    },
    framework_module_links: {
        title: 'Liaison de cadre réglementaire',
        modules: 'Modules liés',
        add_module: 'Ajouter un module',
        module_code: 'Code de module',
        required: 'Obligatoire',
        notes: 'Remarques',
        link: 'Lier',
        no_modules: 'Aucun module lié',
        personas: 'Personas liés',
        add_persona: 'Ajouter un persona',
        persona_id: 'ID de persona',
        role_description: 'Description du rôle',
        no_personas: 'Aucun persona lié',
    },
    framework_channels: {
        title: 'Canaux de soumission & Délais',
        channels: 'Canaux de soumission',
        add_channel: 'Ajouter un canal',
        channel_type: 'Tapez',
        name: 'Nom',
        instructions: 'Instructions',
        active: 'Actif',
        no_channels: 'Aucun canal de soumission configuré',
        portal: 'Portail',
        in_person: 'En personne',
        postal: 'Poste',
        email: 'E-mail',
        add: 'Ajouter',
        deadlines: 'Délais réglementaires',
        add_deadline: 'Ajouter un délai',
        label: 'Libellé',
        days: 'Jours',
        day_type: 'Type de jour',
        calendar_days: 'Jours calendaires',
        working_days: 'Jours ouvrables',
        description: 'Descriptif',
        no_deadlines: 'Aucun délai configuré',
    },
    regulatory_updates: {
        title: 'Mises à jour réglementaires & Tableau de bord des cadres',
        coverage_dashboard: 'Tableau de bord de couverture des cadres',
        no_frameworks: 'Aucun cadre trouvé',
        framework: 'Cadre réglementaire',
        status: 'Statut',
        modules: 'Modules',
        templates: 'Modèles',
        forms: 'Formulaires',
        channels: 'Canaux',
        deadlines: 'Délais',
        pending: 'Mises à jour en attente',
        updates: 'Mises à jour réglementaires',
        create_update: 'Créer une mise à jour',
        framework_id: 'ID du cadre',
        update_title: 'Titre',
        description: 'Descriptif',
        effective_date: "Date d'entrée en vigueur",
        create: 'Créer',
        no_updates: 'Aucune mise à jour réglementaire',
        impact: 'Impact',
        assess: 'Évaluer',
    },
    module_tips: frModuleTips,
    framework_rights: {
        be_informed: "Droit d'être informé",
        consent: 'Droit au consentement',
        refuse_consent: 'Droit de refuser le consentement',
        withdraw_consent: 'Droit de retirer le consentement',
        access: "Droit d'accès",
        rectification: 'Droit de rectification',
        data_provision: 'Droit à la fourniture des données',
        deletion: 'Droit à la suppression',
        restriction_of_processing: 'Droit à la limitation du traitement',
        object_to_processing: "Droit d'opposition au traitement",
        complaint: 'Droit de déposer une plainte',
        denunciation: 'Droit de dénonciation',
        lawsuit: 'Droit de poursuivre en justice',
        claim_damages: 'Droit à réparation du préjudice',
        request_protection_measures: 'Droit de demander des mesures de protection',
    },
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Directive 2002/58/CE (directive ePrivacy)',
            description: 'Directive parentale pour les transpositions nationales ePrivacy. Couvre les cookies, la confidentialité des communications électroniques et le marketing direct. Chaque État membre doit transposer dans son droit national.',
        },
        EU_GDPR: {
            display_name: 'Règlement général sur la protection des données (UE) 2016/679',
            description: "Le règlement général sur la protection des données ([[TOK_0]]) est un règlement de l'UE sur la protection des données et la confidentialité. Elle s’applique directement dans tous les États membres de l’UE/EEE.",
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Directive (UE) 2022/2555 ([[TOK_0]])',
            description: "Directive parent pour les transpositions nationales [[TOK_0]] Couvre la gestion des risques de cybersécurité, le reporting des incidents et la sécurité de la chaîne d'approvisionnement pour les entités essentielles et importantes.",
        },
        VN_AI_LAW_2026: {
            display_name: 'Loi vietnamienne [[TOK_0]] ([[TOK_1]]) — En vigueur le 1er mars 2026',
            description: "Vietnam [[TOK_0]] Loi (Luật Trí tuệ nhân tạo [[TOK_2]]) régissant le développement, le déploiement et l'utilisation de systèmes d'intelligence artificielle. Établit la classification des risques, les obligations de transparence et d'étiquetage, les exigences de déclaration d'incidents, les obligations d'évaluation d'impact et un mécanisme de test contrôlé (bac à sable) pour les activités [[TOK_1]] au Vietnam.",
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Decree 142/2026/NĐ-CP — [[TOK_0]] Law Implementation',
            description: 'Decree 142/2026/NĐ-CP (Nghị định số 142/2026/NĐ-CP) detailing certain articles and implementing measures of the Vietnam [[TOK_0]] Law (Law 134/2025/QH15). Issued 2026-04-30, effective 2026-05-01. Lead authority: Ministry of Science and Technology. Operationalises [[TOK_0]] risk classification, classification dossier, reclassification review, high-risk conformity assessment, high-risk risk-management system, transparency / explanation / technical marking / visible labeling, serious [[TOK_0]] incident reporting (72h / 5wd / 15d), state-agency [[TOK_0]] impact assessment (Mẫu AI02), and the controlled testing / [[TOK_0]] sandbox lifecycle (Mẫu AI03a-AI09b). Submission via the [[TOK_0]] one-stop e-portal or MoST transitional channel. No statutory fines.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Loi vietnamienne sur la cybersécurité (ère 24/2018)',
            description: "Loi vietnamienne sur la cybersécurité (loi n° [[TOK_0]]) établissant des exigences en matière de cybersécurité, de localisation des données et de signalement des incidents. Actif jusqu'à son remplacement par la loi [[TOK_1]] en vigueur le 01/07/2026.",
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Décret 53 — Mise en œuvre de la loi sur la cybersécurité',
            description: "Décret [[TOK_0]] mettant en œuvre la loi sur la cybersécurité, couvrant la détermination du champ d'application, les déclencheurs de localisation des données, les exigences de présence locale et les flux de travail de coopération des autorités.",
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Loi sur la cybersécurité ([[TOK_0]])',
            description: 'Loi consolidée du Vietnam sur la cybersécurité (loi [[TOK_0]]), remplaçant la loi [[TOK_1]], entrée en vigueur le 1er juillet 2026. Consolide la portée du décret [[TOK_2]]Đ-CP (voir VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Loi vietnamienne sur les données',
            description: "Loi vietnamienne sur les données (loi [[TOK_0]]) établissant des exigences complètes en matière de gouvernance des données, notamment l'inventaire des données, la classification, la gouvernance du partage et la gouvernance des transferts de données transfrontaliers. Chevauche avec VN_PDPL_LAW_2025 (aspects des données personnelles) et VN_CYBERSEC_LAW_2025 (localisation/classification des données).",
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Décret [[TOK_0]]Đ-CP (Mise en œuvre de la loi sur les données)',
            description: 'Décret [[TOK_0]]Đ-CP mettant en œuvre la loi vietnamienne sur les données (loi [[TOK_1]]). Fournit des formulaires officiels pour l’évaluation de l’impact du transfert de données transfrontalier, le rapport annuel d’évaluation des risques et l’accès à la base de données nationale. Définit 11 formulaires officiels Mẫu số.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Projet de décret sur les opérations des bourses de données 2026',
            description: "Projet de décret relatif au fonctionnement des plateformes d'échange de données (Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu). Régule la classification des plateformes, l'éligibilité des participants, les contrôles de liste de produits et de services de données, les tests sandbox, le flux de travail des transactions, les contrats électroniques, les certificats de droits de propriété sur les données et le traitement des plaintes/litiges. Actuellement en consultation publique; pas encore promulgué. Cite la loi sur les données [[TOK_0]], la loi sur la protection des données personnelles [[TOK_1]], la loi sur la cybersécurité [[TOK_2]] et la loi sur les transactions électroniques [[TOK_3]].",
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Loi sur le commerce électronique ([[TOK_0]])',
            description: "Loi vietnamienne sur le commerce électronique (Luật Thương mại điện tử [[TOK_0]]) établissant un régime national unifié pour le commerce électronique, couvrant les opérations de plateforme nationales et transfrontalières, la gouvernance et la responsabilité de la plateforme, la protection des consommateurs, les contrôles des vendeurs et des affiliés, le traitement des plaintes, la modération et l'application du retrait du contenu, ainsi que la préparation aux procédures administratives pour le système national de gestion du commerce électronique.",
        },
        VN_PDPL: {
            display_name: 'Vietnam [[TOK_0]] (Décret 13/2023)',
            description: 'Décret vietnamien sur la protection des données personnelles (Décret [[TOK_0]]) établissant des exigences complètes en matière de protection des données. Cadre existant – remplacé par la loi [[TOK_1]] et le décret [[TOK_2]] en vigueur le 01/01/2026.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Décret 13 — [[TOK_0]] Base opérationnelle',
            description: "Décret [[TOK_1]], l'instrument opérationnel pour les tâches [[TOK_0]], y compris le dépôt de dossiers, les artefacts de gouvernance, les mécanismes transfrontaliers et les procédures administratives MoPS. Remplacé par le décret [[TOK_2]] en vigueur le 01/01/2026.",
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Loi sur la protection des données personnelles ([[TOK_0]])',
            description: "La loi vietnamienne sur la protection des données personnelles (loi [[TOK_2]]) établissant un cadre complet de protection des données personnelles, en vigueur le 1er janvier 2026. Couvre les thèmes de conformité A à J : bases de traitement licites, consentement aux données sensibles, droits des personnes concernées (accès/rectification/effacement/restriction/objection/portabilité), notification des violations aux autorités et aux personnes concernées, [[TOK_0]] pour les traitements à haut risque, gouvernance des transferts transfrontaliers, Désignation [[TOK_1]], enregistrements des activités de traitement, obligations contractuelles du sous-traitant. Obligations de dépôt d'autorité via MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Renvois croisés : VN_PDPL_DECREE_356_2025 (décret d'application), VN_CYBERSEC_LAW_2025 (recoupements en matière de cybersécurité), VN_DATA_LAW (gouvernance des données).",
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Décret [[TOK_1]] ([[TOK_0]] Mise en œuvre)',
            description: "Décret [[TOK_0]] portant application de la loi sur la protection des données personnelles, remplaçant le décret [[TOK_1]]. Couvre le dépôt de dossiers, les artefacts de gouvernance, les mécanismes transfrontaliers et la certification des prestataires de services. Inventaire du formulaire annexe : Phụ lục I–VIII (analyse d'impact, transfert transfrontalier, certification). Procédures administratives MoPS via VN_PDPL_ADMIN_PROCEDURES_778_2026 (Décision 778/QĐ-BCA-A05). Workflow de certification : demande → délivrance → demande de modification → réémission → révocation. Renvois croisés : VN_PDPL_LAW_2025 (loi mère), VN_CYBERSEC_LAW_2025 (localisation des données), VN_DATA_LAW (chevauchements de gouvernance des données).",
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: '[[TOK_0]] A05 Procédures administratives (Décision 778/QĐ-BCA-A05)',
            description: "Décision 778/QĐ-BCA-A05 (février 2026) — Procédures administratives pour la protection des données personnelles en vertu de l'A05 ([[TOK_0]]). Définit les procédures de soumission, de traitement et d'émission des résultats des dossiers, y compris les formulaires DLCN-HC et les formulaires statutaires Mẫu số.",
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: "Projet de décret d'application 2026",
            description: "Projet de décret d'application et de sanctions en cas de violation de la loi sur la protection des données personnelles (loi [[TOK_0]]). Définit les fourchettes de pénalités, les facteurs aggravants/atténuants et les procédures d’application. Actuellement à l’état de projet en attente de promulgation.",
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Government Resolution NQ22/2026 — MoPS Administrative Simplification (Temporary Overlay)',
            description: 'Temporary procedural overlay (effective 2026-04-29, expiring 2027-03-01) introducing three official channels (National Public Service Portal, direct submission to MoPS, postal submission to MoPS) for [[TOK_0]] Decree 356/2025 and Decision 778/2026 dossier submissions. Email is NOT a NQ22 official channel — a separate unofficial email-ZIP submission guidance ([[TOK_0]]_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) is shipped with requires_legal_review: true. Procedural overlay only — does NOT alter substantive obligations, fine ranges, or the binding force of underlying frameworks. Review task scheduled 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Loi vietnamienne sur les télécommunications 2023',
            description: "Loi vietnamienne sur les télécommunications de 2023 (Luật Viễn thông), une superposition sectorielle pour les sociétés de télécommunications/FAI/plateformes avec des obligations de confidentialité, de contrôle de la divulgation et de traitement des demandes d'autorité. Renvois : VN_CYBERSEC_LAW_2025 (sécurité des systèmes d'information), VN_PDPL_LAW_2025 (traitement des données utilisateurs), VN_DATA_LAW (gouvernance des données).",
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Décret [[TOK_0]]Đ-CP (Mise en œuvre de la loi sur les télécommunications)',
            description: "Décret [[TOK_0]]Đ-CP mettant en œuvre la loi sur les télécommunications (loi [[TOK_1]]). Fournit des formulaires officiels pour la notification des services de télécommunications, les licences, l'enregistrement et les plans de développement des centres de données. Définit 7 formulaires officiels Mẫu số.",
        },
    },
    framework_requirements: {
        d163_r4: {
            title: 'Dépôt du plan de développement du data center',
            description: "Les plans de développement des centres de données doivent être déposés auprès de l'autorité compétente conformément au décret [[TOK_0]]Đ-CP.",
        },
        d163_r3: {
            title: 'Inscription au service de télécommunication',
            description: "L'enregistrement des services de télécommunications doit être déposé auprès de l'autorité compétente en utilisant le formulaire prescrit.",
        },
        d163_r2: {
            title: 'Demande de licence télécom',
            description: 'Les demandes de licences de télécommunications doivent être déposées au moyen du formulaire prescrit conformément au décret [[TOK_0]]Đ-CP.',
        },
        d163_r1: {
            title: 'Notification de fourniture de services de télécommunication',
            description: "Les fournisseurs de services de télécommunications doivent informer l'autorité compétente de la fourniture du service en utilisant le formulaire prescrit avant de commencer le service.",
        },
        vn_dp_draft_f: {
            title: 'Plaintes, litiges et gestion des risques',
            description: "Les opérateurs de plate-forme doivent assurer le traitement des plaintes, le flux de travail de traitement des litiges avec la préservation des preuves, l'identification des risques et les contrôles d'alerte précoce, ainsi que l'examen périodique des risques en matière de confidentialité, de cybersécurité et de gestion des accès.",
        },
        vn_dp_draft_e: {
            title: 'Workflow de transaction et certificat de droits de propriété sur les données',
            description: "Les transactions nécessitent l'enregistrement d'un compte, l'approbation de l'inscription, un contrat électronique, une confirmation de paiement, un relevé de livraison et la délivrance d'un certificat de droits de propriété sur les données, le cas échéant. L'historique et la traçabilité des transactions doivent être conservés dans un registre des transactions.",
        },
        vn_dp_draft_d: {
            title: "Contrôles du bac à sable et de l'environnement de test",
            description: "Les environnements de test doivent être isolés, à accès restreint, surveillés par la sécurité et examinés avant qu'une sortie ne soit extraite. Aucune donnée source ne peut être extraite de l'environnement de test et la fermeture/nettoyage des sessions de test doit être enregistrée.",
        },
        vn_dp_draft_c: {
            title: 'Contrôles de liste de produits et services de données',
            description: "Les annonces doivent être étayées par des preuves de source licite et de propriété/droit d'utilisation, des dossiers de validation technique, des informations sur la qualité et des dossiers d'examen et d'approbation des inscriptions côté plateforme. Les données interdites doivent être filtrées avant d'être répertoriées.",
        },
        vn_dp_draft_b: {
            title: 'Éligibilité et intégration des participants',
            description: 'Les opérateurs de plateforme doivent vérifier le statut juridique, la capacité juridique et les exigences commerciales conditionnelles pour les vendeurs et les acheteurs, enregistrer les comptes de transaction et de paiement et tenir un registre des participants.',
        },
        vn_dp_draft_a: {
            title: 'Classification de la plateforme de données et modèle opérationnel',
            description: "Les opérateurs de plateforme doivent établir une classification du type de plateforme (plateforme de données nationale par rapport à d'autres plateformes de données), définir l'éligibilité et les responsabilités des opérateurs, et documenter les prix, les frais, les règles de fonctionnement et la gouvernance technique.",
        },
        d165_r5: {
            title: 'Accès aux informations des bases de données nationales',
            description: "Les demandes d'extraction/d'utilisation d'informations de la base de données nationale de données numériques utilisent les formulaires prescrits (Mẫu số 07a/07b).",
        },
        d165_r4: {
            title: 'Rapport annuel d’évaluation des risques',
            description: "Les rapports annuels d'évaluation des risques doivent être déposés en utilisant les formulaires prescrits (Mẫu số 05a/05b, 06).",
        },
        d165_r3: {
            title: 'Avis de résiliation de transfert transfrontalier',
            description: 'La résiliation du transfert transfrontalier doit être notifiée au moyen des formulaires prescrits (Mẫu số 04a/04b).',
        },
        d165_r2: {
            title: 'Notification du résultat de l’évaluation',
            description: "L'autorité émet des avis de résultats d'évaluation en utilisant le formulaire prescrit (Mẫu số 03).",
        },
        d165_r1: {
            title: 'Dépôt d’évaluation d’impact sur le transfert transfrontalier de données',
            description: 'Les organisations doivent déposer des dossiers d’évaluation d’impact sur les transferts/traitements de données transfrontaliers en utilisant les formulaires prescrits (Mẫu số 01a/01b, 02).',
        },
        a964190d_8d1d_4284_bc7d_4023e2866751: {
            title: 'Consentement pour les cookies et technologies similaires',
            description: "Le stockage ou l'accès à des informations sur un équipement terminal n'est autorisé qu'avec un consentement préalable et éclairé, à l'exception du stockage techniquement nécessaire.",
        },
        '8437d96d_cf01_4f87_89f6_4faaf8eefdf6': {
            title: 'Confidentialité des communications',
            description: "Les États membres garantissent la confidentialité des communications et des données de trafic associées au moyen d'un réseau de communications public et de services de communications électroniques accessibles au public.",
        },
        c5420073_50c6_4981_816a_398460e5f546: {
            title: 'Consentement pour le marketing direct (opt-in)',
            description: "L'utilisation de systèmes de communications électroniques à des fins de marketing direct nécessite le consentement préalable de l'abonné.",
        },
        c8bf67d2_874b_4647_92d7_39aaa3230819: {
            title: 'Opt-in doux pour les clients existants',
            description: 'Le marketing direct auprès des clients existants pour des produits/services similaires est autorisé sans consentement si une désinscription est fournie.',
        },
        b546df40_9217_4204_b71c_5af5022a0ff9: {
            title: 'Notification de violation pour les fournisseurs de télécommunications',
            description: "Les fournisseurs de services de communications électroniques accessibles au public informent l'autorité nationale compétente des violations de données à caractère personnel.",
        },
        '5bd66ae4_dee3_4611_9104_71742df55484': {
            title: "Droit de s'opposer au marketing direct",
            description: "Les abonnés ont la possibilité de s'opposer à tout moment et gratuitement à la réception de messages de marketing direct.",
        },
        a10af31f_ba28_494e_ab50_f8679e86a0b0: {
            title: 'Conservation et effacement des données de trafic',
            description: "Les données de trafic relatives aux abonnés et aux utilisateurs doivent être effacées ou anonymisées lorsqu'elles ne sont plus nécessaires à leur transmission, sauf pour la facturation ou les paiements d'interconnexion.",
        },
        '8577e60f_66a8_4651_8336_d561db9929ad': {
            title: 'Conditions de traitement des données de localisation',
            description: "Les données de localisation autres que les données de trafic ne peuvent être traitées que de manière anonyme ou avec le consentement de l'utilisateur, dans la mesure et pour la durée nécessaires.",
        },
        '7f3abb41_8713_4276_93b5_6902f419a016': {
            title: 'Licéité du traitement — consentement',
            description: "Le traitement n'est licite que si la personne concernée a donné son consentement au traitement de ses données personnelles pour une ou plusieurs finalités spécifiques.",
        },
        '1c2a945a_8eac_428d_8105_e80e95288ea4': {
            title: 'Licéité du traitement — contrat',
            description: "Le traitement est nécessaire à l'exécution d'un contrat auquel la personne concernée est partie.",
        },
        '2b50c0fb_ee96_412e_a092_c3c1f3f817e8': {
            title: 'Licéité du traitement – obligation légale',
            description: "Le traitement est nécessaire au respect d'une obligation légale à laquelle le responsable du traitement est soumis.",
        },
        '702ea760_9e5c_4c32_babc_0b5094ca9735': {
            title: 'Licéité du traitement — intérêts vitaux',
            description: "Le traitement est nécessaire à la protection des intérêts vitaux de la personne concernée ou d'une autre personne physique.",
        },
        '8b55ce88_2d5e_467b_a55c_8c5b0efab67e': {
            title: 'Licéité du traitement — intérêt public',
            description: "Le traitement est nécessaire à l'exécution d'une mission d'intérêt public ou relevant de l'exercice de l'autorité publique.",
        },
        '8a72dd16_ee3c_4947_b5cd_9484719adad8': {
            title: 'Licéité du traitement — intérêts légitimes',
            description: 'Le traitement est nécessaire aux fins des intérêts légitimes poursuivis par le responsable du traitement ou un tiers.',
        },
        afefc965_8f83_4d75_a9fc_92d4d4f549d6: {
            title: 'Traitement de catégories particulières (données sensibles)',
            description: "Le traitement de catégories particulières de données personnelles (origine raciale, opinions politiques, santé, etc.) est interdit, sauf conditions spécifiques de l'art. 9(2) sont respectés.",
        },
        '10a2d63f_744d_4222_91f6_86a5a4cdaefd': {
            title: 'Conditions de consentement',
            description: 'Le responsable du traitement doit démontrer que le consentement a été donné. Le consentement doit être libre, spécifique, éclairé et sans ambiguïté. Le retrait doit être aussi simple que de donner son consentement.',
        },
        '27697f99_efef_49e6_b8e7_c2dc550d1791': {
            title: "Consentement de l'enfant — services numériques",
            description: "Le traitement des données personnelles d'un enfant de moins de 16 ans (ou d'un âge inférieur fixé par l'État membre, pas inférieur à 13 ans) nécessite le consentement parental pour les services de la société de l'information.",
        },
        '53883480_508e_4f8e_984f_9354c18de285': {
            title: 'Information et communication transparentes',
            description: 'Le responsable du traitement doit fournir les informations relatives au traitement sous une forme concise, transparente, intelligible et facilement accessible.',
        },
        b5eb22b7_78f2_4c55_b342_827d5f8ac90c: {
            title: 'Informations pour la collecte directe',
            description: 'Lorsque des données personnelles sont collectées auprès de la personne concernée, le responsable du traitement fournit des informations spécifiées au moment de la collecte.',
        },
        e55f7dbf_cd2a_4713_887e_8c64744e2d95: {
            title: 'Informations pour la collecte indirecte',
            description: "Lorsque des données personnelles n'ont pas été obtenues auprès de la personne concernée, le responsable du traitement fournit les informations spécifiées dans un délai raisonnable.",
        },
        '6bc5ec07_0589_4593_882a_13f41c31e1f6': {
            title: "Droit d'accès",
            description: "La personne concernée a le droit d'obtenir la confirmation du traitement et d'accéder aux données personnelles et aux informations supplémentaires.",
        },
        '0e011e25_dcea_4a1e_ae55_583e683cea44': {
            title: 'Droit de rectification',
            description: "La personne concernée a le droit d'obtenir la rectification des données personnelles inexactes sans délai injustifié.",
        },
        e8ec5a55_f657_4a99_9b92_3e9861067d28: {
            title: "Droit à l'effacement (droit à l'oubli)",
            description: "La personne concernée a le droit d'obtenir l'effacement de ses données personnelles sans retard injustifié lorsque des motifs spécifiés s'appliquent.",
        },
        '5b0c92fd_cd08_47be_bfd2_0540ad73f84f': {
            title: 'Droit à la limitation du traitement',
            description: "La personne concernée a le droit d'obtenir la limitation du traitement lorsque des conditions spécifiées s'appliquent.",
        },
        '3b829862_39f4_41be_8f2b_d469469a801b': {
            title: 'Obligation de notification — rectification/effacement/restriction',
            description: 'Le responsable du traitement communiquera toute rectification, effacement ou restriction à chaque destinataire auquel les données ont été divulguées.',
        },
        '9cf34be6_121b_4fdf_ad7c_c4773696522e': {
            title: 'Droit à la portabilité des données',
            description: 'La personne concernée a le droit de recevoir ses données personnelles dans un format structuré, couramment utilisé et lisible par machine.',
        },
        becae433_90b9_4cc0_bd33_df50976c1561: {
            title: "Droit d'opposition",
            description: "La personne concernée a le droit de s'opposer au traitement fondé sur l'intérêt public ou des intérêts légitimes, y compris le profilage.",
        },
        '4ef387f1_439c_4579_82a3_01565e6dc05d': {
            title: 'Prise de décision individuelle automatisée, y compris le profilage',
            description: "La personne concernée a le droit de ne pas faire l'objet d'une décision fondée uniquement sur un traitement automatisé produisant des effets juridiques ou d'une importance similaire.",
        },
        '667ae5eb_a39a_4809_a032_923cc804eaed': {
            title: "Notification du manquement à l'autorité de contrôle (72h)",
            description: "En cas de violation de données personnelles, le responsable du traitement doit en informer l'autorité de contrôle dans les 72 heures suivant sa prise de conscience, à moins qu'il soit peu probable qu'elle entraîne un risque.",
        },
        '40e4c2ad_bc85_436c_814f_265f02c8c3b1': {
            title: 'Notification de violation aux personnes concernées (risque élevé)',
            description: "Lorsqu'une violation est susceptible d'entraîner un risque élevé pour les droits et libertés, le responsable du traitement communique la violation à la personne concernée dans les meilleurs délais.",
        },
        '9dbb47bd_172f_4335_b7f3_4558476c4192': {
            title: 'Réponse aux demandes des personnes concernées (30 jours)',
            description: "Le responsable du traitement répond aux demandes des personnes concernées dans les plus brefs délais et dans un délai d'un mois à compter de leur réception, extensible de deux mois supplémentaires pour les demandes complexes.",
        },
        '175d16b7_a0fc_44ff_bb9e_5ccb5d3de5a9': {
            title: "Analyse d'impact sur la protection des données",
            description: "Lorsque le traitement est susceptible d'entraîner un risque élevé pour les droits et libertés, le responsable du traitement procède à une [[TOK_0]] préalablement au traitement.",
        },
        e54a7b09_33dd_4cda_8e21_d10a51e5e925: {
            title: "Consultation préalable de l'autorité de contrôle",
            description: "Le responsable du traitement doit consulter l'autorité de contrôle lorsqu'un [[TOK_0]] indique que le traitement entraînerait un risque élevé sans mesures d'atténuation.",
        },
        '047b7838_bae5_4861_9c38_c99fedec9c96': {
            title: '[[TOK_0]] liste de traitement obligatoire',
            description: "[[TOK_0]] est requis pour l'évaluation/le profilage systématique, le traitement à grande échelle de catégories spéciales et la surveillance systématique des espaces publics.",
        },
        aa08dc83_7c1a_441d_a8e7_960f65c8de87: {
            title: 'Registres des activités de traitement (contrôleur)',
            description: 'Chaque responsable du traitement doit tenir un registre des activités de traitement sous sa responsabilité, y compris les finalités, les catégories, les destinataires, les transferts et la conservation.',
        },
        b7eb6296_5962_449c_b267_d322d7919122: {
            title: 'Enregistrements des activités de traitement (sous-traitant)',
            description: "Chaque sous-traitant doit conserver un enregistrement de toutes les catégories d'activités de traitement effectuées pour le compte d'un responsable du traitement.",
        },
        '0d57e6d5_bbf5_4ea6_9a89_0f57bed61b5b': {
            title: 'Sécurité du traitement',
            description: 'Le responsable du traitement et le sous-traitant doivent mettre en œuvre des mesures techniques et organisationnelles appropriées pour assurer une sécurité adaptée au risque.',
        },
        ad85edfc_3c92_4ce4_a414_3ba6186cae98: {
            title: 'Protection des données dès la conception et par défaut',
            description: 'Le responsable du traitement met en œuvre des mesures appropriées pour garantir que seules les données personnelles nécessaires à chaque finalité spécifique sont traitées (minimisation des données).',
        },
        '933b438d_53b8_4b6a_b1db_8e7f1b429ede': {
            title: 'Désignation du délégué à la protection des données',
            description: 'Le responsable du traitement et le sous-traitant doivent désigner un [[TOK_0]] lorsque le traitement est effectué par une autorité publique, implique un contrôle régulier et systématique ou un traitement à grande échelle de catégories particulières.',
        },
        '28810a5d_d818_411a_9e8c_792d1b2c9b2f': {
            title: 'Principe général des virements',
            description: "Tout transfert de données personnelles vers un pays tiers n'aura lieu que si les conditions du chapitre V sont respectées.",
        },
        '60add64b_bb0c_44e7_baaf_666af65b2d0f': {
            title: 'Transferts basés sur une décision d’adéquation',
            description: 'Un transfert peut avoir lieu lorsque la Commission a décidé que le pays tiers assure un niveau de protection adéquat.',
        },
        cde8c7cd_3727_40ce_a321_e6b72b335179: {
            title: 'Transferts soumis à des garanties appropriées',
            description: 'En l’absence de décision d’adéquation, les transferts peuvent avoir lieu lorsque des garanties appropriées sont prévues, notamment des SCC ou des BCR.',
        },
        '0e8edaa1_2156_44d9_95f2_1b284f581658': {
            title: 'Clauses contractuelles types',
            description: 'Les clauses contractuelles types adoptées par la Commission ou par une autorité de contrôle offrent des garanties appropriées pour les transferts internationaux.',
        },
        '608a8de7_6c75_4f88_bd4c_1cc308780ab9': {
            title: 'Des règles d’entreprise contraignantes',
            description: "Des règles d'entreprise contraignantes approuvées par une autorité de contrôle compétente fournissent des garanties appropriées pour les transferts internationaux intra-groupe.",
        },
        '420ced80_0d3b_4a28_adad_14ba54df3e40': {
            title: 'Dérogations pour des situations spécifiques',
            description: "En l'absence d'adéquation ou de garanties, les transferts peuvent avoir lieu sur la base d'un consentement explicite, d'une nécessité contractuelle, d'un intérêt public, de réclamations légales, d'intérêts vitaux ou d'un registre public.",
        },
        c86fbc0d_7188_486c_8ea5_96b3fe957c6f: {
            title: 'Responsabilité et formation de l’organe de direction',
            description: 'Les organes de direction des entités essentielles et importantes doivent approuver les mesures de gestion des risques de cybersécurité et suivre des formations régulières.',
        },
        ffb95a09_993c_4db0_a4bb_c48000e43b33: {
            title: 'Mesures de gestion des risques de cybersécurité',
            description: 'Les entités essentielles et importantes prennent des mesures techniques, opérationnelles et organisationnelles appropriées et proportionnées pour gérer les risques de cybersécurité.',
        },
        '6a7c8c8f_4b81_4b47_adb7_c6abd12acd4b': {
            title: 'Politiques et procédures de gestion des incidents',
            description: "Les entités doivent mettre en œuvre des politiques de gestion des incidents, y compris des procédures de détection, d'analyse, de confinement et de réponse.",
        },
        de019eab_9992_4361_be7c_3e592f209d76: {
            title: 'Continuité des activités et gestion de crise',
            description: 'Les entités doivent mettre en œuvre des mesures de continuité des activités, notamment la gestion des sauvegardes, la reprise après sinistre et la gestion des crises.',
        },
        '6b5f482f_301c_4f69_bd91_f9ae1b21de6c': {
            title: "Sécurité de la chaîne d'approvisionnement",
            description: "Les entités doivent aborder les aspects liés à la sécurité des relations avec les fournisseurs directs et les prestataires de services, y compris les évaluations des risques liés à la chaîne d'approvisionnement.",
        },
        c8e7738b_358c_4c79_9fc2_a564f15a6e37: {
            title: "Sécurité des réseaux et des systèmes d'information",
            description: 'Les entités doivent mettre en œuvre la sécurité dans l’acquisition, le développement et la maintenance des réseaux et des systèmes d’information, y compris la gestion des vulnérabilités.',
        },
        '72520ed1_51ff_4983_a785_9be1f72cf7dd': {
            title: 'Gestion et divulgation des vulnérabilités',
            description: 'Les entités doivent mettre en œuvre des politiques et des procédures pour une divulgation et un traitement coordonnés des vulnérabilités.',
        },
        f009e65d_d55e_4c98_9532_63c150694698: {
            title: 'Efficacité de l’évaluation des risques liés à la cybersécurité',
            description: 'Les entités doivent mettre en œuvre des politiques et des procédures pour évaluer l’efficacité des mesures de gestion des risques de cybersécurité.',
        },
        '00e88824_675d_4b37_960c_757b3176c079': {
            title: 'Politiques de cryptographie et de chiffrement',
            description: "Les entités doivent mettre en œuvre des politiques et des procédures concernant l'utilisation de la cryptographie et, le cas échéant, du chiffrement.",
        },
        de29d287_81f1_46b1_b327_9cbf06ddad3d: {
            title: "Sécurité RH, contrôle d'accès, gestion des actifs",
            description: "Les entités doivent mettre en œuvre la sécurité des ressources humaines, les politiques de contrôle d'accès et la gestion des actifs.",
        },
        '750f4459_9ba4_415e_bc47_5b0ec27d35a2': {
            title: 'Authentification multifacteur',
            description: 'Les entités doivent utiliser des solutions d’authentification multifacteur ou d’authentification continue, des communications voix/vidéo/texte sécurisées et des systèmes de communication d’urgence sécurisés.',
        },
        '359474f9_1820_4e3e_9031_a593b66ccde4': {
            title: 'Alerte précoce au CSIRT (24h)',
            description: "Les entités soumettent une alerte précoce au CSIRT compétent dans les 24 heures suivant la prise de connaissance d'un incident significatif.",
        },
        '66acd92c_3091_4148_b935_68b0d24308e7': {
            title: "Notification d'incident au CSIRT (72h)",
            description: "Les entités soumettent une notification d'incident au CSIRT compétent dans les 72 heures suivant la prise de connaissance d'un incident significatif.",
        },
        '68269688_06b2_43ea_8e3e_a84532086557': {
            title: 'Rapport final au CSIRT (1 mois)',
            description: "Les entités soumettent un rapport final au CSIRT compétent au plus tard un mois après la notification de l'incident.",
        },
        c8512bde_b064_4926_b333_06b9c95cecd7: {
            title: "Détermination de l'applicabilité pour les activités [[TOK_0]]",
            description: "Déterminez si l'organisation mène des activités [[TOK_0]] soumises à la loi vietnamienne [[TOK_1]] et documentez la décision d'applicabilité.",
        },
        '3a87ad63_179a_45ba_8743_98d865df80ab': {
            title: '[[TOK_0]] classification des risques système par niveau de risque',
            description: "Classez chaque système [[TOK_0]] par niveau de risque (minimal, limité, élevé, inacceptable) à l'aide de la méthodologie de classification guidée.",
        },
        '0f4475d3_77a6_4b41_bfe2_d4b299b1bd45': {
            title: '[[TOK_0]] Maintenance des entrées du registre système',
            description: "Tenir à jour un registre des systèmes [[TOK_0]] avec le nom du système, le propriétaire, l'objectif, le contexte de déploiement, le niveau de risque et l'implication du fournisseur.",
        },
        '2a73ce94_906a_4c95_8a45_a5bdf2a8118c': {
            title: '[[TOK_0]] Dossier système avec liste de contrôle des artefacts et preuves',
            description: "Créez et maintenez un dossier système avec la liste de contrôle des artefacts requis, la bibliothèque de preuves et l'historique des versions.",
        },
        e92cfb42_d91b_444f_adbc_c03903844eac: {
            title: 'Obligations de transparence pour les gestionnaires de réseau [[TOK_0]]',
            description: "Mettre en œuvre des mesures de transparence pour les systèmes [[TOK_0]], notamment la notification des utilisateurs, la divulgation de l'implication de [[TOK_1]] et la documentation du système.",
        },
        '45eb43d7_9b63_4166_aa0d_fa6aeeaa70ba': {
            title: '[[TOK_0]] étiquetage de sortie, filigrane et signature de métadonnées',
            description: "Implémentez l'étiquetage et le filigrane pour le contenu généré par [[TOK_0]], y compris la signature des métadonnées, le cas échéant.",
        },
        '9566c94d_0dd3_419c_869f_6707d2a972f9': {
            title: 'Exigences de divulgation pour le contenu généré par [[TOK_0]]',
            description: "Divulguer aux utilisateurs lorsque le contenu est généré par [[TOK_0]] et fournir des mécanismes permettant aux utilisateurs d'identifier l'implication de [[TOK_1]]",
        },
        '21d39ea5_df78_45c6_8710_b203db229e25': {
            title: 'Obligations d’explicabilité et de transparence envers l’utilisateur',
            description: 'Fournir des résultats explicables pour les décisions [[TOK_0]] affectant les individus et maintenir une documentation de transparence destinée aux utilisateurs.',
        },
        f523fbc2_156d_466d_ad50_6a0c51b3ac9d: {
            title: 'Obligations de surveillance humaine pour les systèmes [[TOK_0]] à haut risque',
            description: "Veiller à ce que des mécanismes de surveillance humaine soient en place pour les systèmes [[TOK_0]] à haut risque, y compris des capacités d'escalade et de remplacement.",
        },
        bd180a89_4976_4790_9e50_f1c5c97dc576: {
            title: '[[TOK_0]] surveillance et détection des incidents',
            description: 'Mettre en œuvre des capacités de surveillance pour détecter les [[TOK_0]] incidents, dysfonctionnements et résultats indésirables du système.',
        },
        e7c1c60b_856c_4d3d_b6c9_092cde9b56bd: {
            title: '[[TOK_0]] incident grave signalé aux autorités',
            description: "Signaler les incidents [[TOK_0]] graves à l'autorité compétente dans le délai prescrit (72 heures).",
        },
        '97f15adc_558a_49f2_bb06_86597cb9579b': {
            title: "[[TOK_0]] conformité du délai de notification d'incident",
            description: 'Respectez les délais de notification pour les incidents [[TOK_0]], y compris la notification initiale, les mises à jour et les rapports de clôture.',
        },
        '96c33d7e_fe52_4730_adac_70c8c477c88e': {
            title: "[[TOK_0]] évaluation d'impact pour les systèmes à haut risque",
            description: "Réaliser des évaluations d'impact pour les systèmes [[TOK_0]] à haut risque couvrant les risques, les atténuations, la surveillance humaine et les plans de surveillance.",
        },
        '0f3b72c0_1030_44ff_ba53_596f45601cd7': {
            title: 'Tests contrôlés/détermination de l’éligibilité au bac à sable',
            description: 'Déterminez l’éligibilité à la participation aux tests contrôlés (bac à sable) et documentez l’évaluation de l’éligibilité.',
        },
        '4a6aed20_f655_4182_a760_aef1f329d5df': {
            title: 'Soumission des candidatures et suivi des approbations dans le bac à sable',
            description: 'Soumettez les demandes sandbox à l’autorité compétente et suivez le statut d’approbation tout au long du cycle de vie de la soumission.',
        },
        '8376988d_cd32_491e_a5b8_3340d3973358': {
            title: 'Points de contrôle de surveillance du bac à sable et achèvement/sortie',
            description: "Effectuer des points de contrôle de surveillance périodiques pendant la participation au bac à sable et préparer des rapports d'achèvement/de sortie.",
        },
        '7cb2b544_0512_4702_a092_9f1c10872376': {
            title: 'Documentation d’exemption/exception d’étiquetage avec justification',
            description: 'Documentez toute exemption ou exception en matière d’étiquetage avec justification et preuves à l’appui.',
        },
        dccd7fbf_872a_4716_87a4_b9c5ce8e2387: {
            title: 'Localisation des données pour les utilisateurs vietnamiens',
            description: 'Les données des utilisateurs vietnamiens sur les services fournis au Vietnam doivent être stockées sur le territoire du Vietnam.',
        },
        '9eb86a03_e165_4963_8813_2272b638d529': {
            title: "Rapport d'incident de cybersécurité",
            description: 'Les incidents de cybersécurité doivent être signalés aux autorités compétentes en temps utile.',
        },
        '736ac7de_7a6a_4bfd_b2be_c594e290038a': {
            title: "Classement du système d'information",
            description: 'Les systèmes d’information doivent être classés par niveau d’importance et des mesures de sécurité appropriées appliquées.',
        },
        ffb807cf_f121_4b52_8e50_e091c33180c9: {
            title: 'Évaluation des risques liés à la cybersécurité',
            description: 'Des évaluations régulières des risques de cybersécurité doivent être réalisées pour les systèmes d’information.',
        },
        a4de518b_a5f1_481f_9b08_f8d2bc9db7e5: {
            title: "Détermination du champ d'application (arbre de décision)",
            description: 'Les organisations doivent déterminer si elles relèvent du champ d’application du décret 53 à l’aide de l’arbre de décision prescrit.',
        },
        '01f99e9a_5e30_4d14_aae5_a2ce322a700b': {
            title: 'Évaluation et préparation à la localisation des données',
            description: 'Les organisations doivent évaluer les exigences en matière de localisation des données et démontrer qu’elles sont prêtes.',
        },
        cf24f011_dc23_4d84_aef5_994dde440571: {
            title: 'Liste de contrôle de préparation au stockage et à la rétention',
            description: 'Une liste de contrôle de préparation au stockage et à la conservation doit être complétée pour la conformité de la localisation des données.',
        },
        b3884cb8_c785_4258_9517_9e393be4f4e1: {
            title: 'Évaluation des exigences de présence locale',
            description: 'Les organisations doivent évaluer si les exigences de présence locale s’appliquent et planifier en conséquence.',
        },
        c1dc645b_cb1a_42a6_8ca5_9b15cfa84156: {
            title: 'Réception et vérification de la demande d’autorisation',
            description: "Les demandes d'autorisation doivent être reçues, vérifiées et traitées conformément aux procédures prescrites.",
        },
        d4571651_f39d_4c51_8f2d_7248c37f7b14: {
            title: 'Réponse à la demande d’autorité dans les délais',
            description: 'Les réponses aux demandes d’autorité doivent être fournies dans les délais prescrits.',
        },
        '66c1df70_3456_40e9_b645_6c6bd3be702e': {
            title: "Journal de traitement des demandes d'autorité",
            description: 'Un journal de toutes les activités de traitement des demandes d’autorisation doit être tenu.',
        },
        '04bbba2a_9804_4199_a517_054b6f4689fb': {
            title: 'Applicabilité et détermination du champ d’application (consolidé)',
            description: "Les organisations doivent déterminer si elles relèvent du champ d'application de la loi consolidée sur la cybersécurité, qui couvre à la fois le champ d'application de l'ancienne loi 24/2018 et du décret 53/2022.",
        },
        '89a21eaf_cf09_4fec_bbb4_a1dadd652f6e': {
            title: "Classification du système d'information par niveau d'importance",
            description: "Les systèmes d'information doivent être classés par niveau d'importance (général, important, critique) avec les obligations de sécurité correspondantes.",
        },
        '83ad981e_23ff_4a92_bebd_cd24487e912f': {
            title: 'Structure de gouvernance de la cybersécurité et personnel responsable',
            description: 'Les organisations doivent établir des structures de gouvernance de la cybersécurité et désigner du personnel responsable.',
        },
        '98d9a523_fefb_400b_bb7f_ebaf609a6ed4': {
            title: 'Évaluation périodique des risques de cybersécurité',
            description: 'Des évaluations régulières des risques de cybersécurité doivent être effectuées pour tous les systèmes d’information classifiés.',
        },
        '5236539f_4c1a_4eff_b2eb_fc11eb4eab23': {
            title: "Mesures de sécurité par classification du système d'information",
            description: 'Des mesures techniques de sécurité doivent être appliquées de manière appropriée à chaque niveau de classification du système d’information.',
        },
        b69a8be2_ae0c_408c_b8f1_73b573eca876: {
            title: "Contrôle d'accès et gestion des identités",
            description: 'Des mesures de contrôle d’accès et de gestion des identités doivent être mises en œuvre pour les systèmes d’information.',
        },
        ac774c26_feb7_4123_b799_c54f77bd87b5: {
            title: "Journalisation, surveillance et piste d'audit",
            description: 'Les systèmes d’information doivent maintenir des capacités de journalisation, de surveillance et de piste d’audit.',
        },
        a86cb01d_239b_44e2_9e09_e6973bcf9658: {
            title: 'Gestion des vulnérabilités et correctifs',
            description: 'Les processus de gestion des vulnérabilités et de correctifs doivent être établis et maintenus.',
        },
        '826a789f_0c03_4918_81a1_6aa1cc2c205c': {
            title: 'Localisation des données des utilisateurs vietnamiens',
            description: 'Les données des utilisateurs vietnamiens sur les services fournis au Vietnam doivent être stockées sur le territoire du Vietnam.',
        },
        '8bee2b51_ace8_4118_89c8_010b96640016': {
            title: 'Exigences de présence locale pour les prestataires de services étrangers',
            description: 'Les prestataires de services étrangers opérant au Vietnam doivent maintenir une présence locale comme prescrit.',
        },
        '74d89250_b45f_41b6_bfe3_f915071580de': {
            title: 'Architecture de stockage local et documentation des flux transfrontaliers',
            description: "L'architecture de stockage local doit être documentée et les flux de données transfrontaliers doivent être cartographiés et contrôlés.",
        },
        '04dec6f8_3280_494c_8506_292804b16d4d': {
            title: 'Détection et réponse aux incidents de cybersécurité',
            description: 'Les organisations doivent disposer de capacités pour détecter et répondre aux incidents de cybersécurité.',
        },
        faeda71b_5050_497d_b08b_e3f3f5313ad4: {
            title: "Déclaration obligatoire des incidents à l'autorité compétente",
            description: 'Les incidents de cybersécurité éligibles doivent être signalés à [[TOK_1]]/[[TOK_0]] dans les délais prescrits.',
        },
        d732b5a2_2b2c_48a0_955d_97a39daf132d: {
            title: 'Conformité du délai de notification des incidents',
            description: 'Les notifications d’incidents doivent respecter les délais prescrits (rapport initial sous 24h, rapport complet sous 72h).',
        },
        '8e2dffb0_3481_44f0_baf2_130ddd8cfe12': {
            title: 'Traitement des demandes d’autorité et coopération',
            description: 'Les demandes d’autorisation doivent être traitées rapidement et la coopération doit être assurée conformément aux procédures prescrites.',
        },
        e4c5b870_1d61_48fe_a6c2_1b9f5a458ea3: {
            title: "Registre des dossiers de demande d'autorité et journal de divulgation",
            description: "Toutes les demandes d'autorité et les divulgations doivent être consignées dans un registre de cas avec une piste d'audit complète.",
        },
        '8eff8b17_65bc_4f94_8ece_c509a9fd9abb': {
            title: 'Évaluation de la sécurité des fournisseurs et des tiers',
            description: 'Les fournisseurs tiers ayant accès aux systèmes d’information doivent se soumettre à une évaluation de sécurité.',
        },
        '69891e1b_97f6_464c_9cce_b1276794fe4a': {
            title: 'Contrôles d’accès aux données des fournisseurs et de notification d’incidents',
            description: "L'accès aux données des fournisseurs doit être documenté et les obligations contractuelles de notification des incidents doivent être établies.",
        },
        d89b6bc0_7a9e_4816_b31e_7c0abc02e90c: {
            title: 'Formations et exercices de sensibilisation à la sécurité',
            description: 'Des formations régulières de sensibilisation à la cybersécurité et des exercices sur table doivent être organisés.',
        },
        f9c5d3cc_5bb2_4b30_a5fb_ada34e407981: {
            title: "Test d'intrusion et audit de sécurité périodiques",
            description: "Des tests d'intrusion et des audits de sécurité périodiques doivent être effectués sur les systèmes d'information classifiés.",
        },
        '88dd9877_d2e2_4e41_a248_ae39b1ff478f': {
            title: "Maintenir l'inventaire des données numériques",
            description: 'Les organisations doivent maintenir un inventaire complet des données numériques cataloguant tous les actifs de données.',
        },
        '18e4bfd1_42cf_4d87_870f_5a34242962ef': {
            title: 'Classification des données par sensibilité et importance',
            description: 'Les données doivent être classées selon des niveaux de sensibilité et d’importance tels que définis par la Loi Informatique.',
        },
        b89981ac_7559_46f9_a74c_a143976dde4e: {
            title: 'Définir les règles de traitement par niveau de classification',
            description: 'Des règles de traitement doivent être établies pour chaque niveau de classification des données.',
        },
        '3bf8019d_b72c_41d7_82cf_fc367efd9526': {
            title: 'Suivez le partage et la divulgation des données avec les approbations',
            description: 'Toutes les activités de partage et de divulgation de données doivent être suivies avec les approbations appropriées.',
        },
        '8623eca2_4cf9_41bd_bfbd_2300c06ca1f3': {
            title: 'Gouvernance des transferts de données transfrontaliers',
            description: 'Les transferts de données transfrontaliers doivent être conformes aux exigences de gouvernance en vertu de la loi sur les données.',
        },
        '006b8aa6_9379_4eff_b8ab_935f9a087601': {
            title: 'Maintenir les politiques et les responsabilités de gouvernance',
            description: 'Les organisations doivent maintenir des politiques de gouvernance des données et attribuer des responsabilités de gouvernance.',
        },
        f12fc090_5c3e_4fa8_9813_74bea0359c5c: {
            title: 'Attestation annuelle de gouvernance',
            description: 'Une attestation annuelle de gouvernance doit être remplie pour confirmer la conformité continue.',
        },
        f6c3060a_5e52_4f97_b1af_c6a5f00bfaee: {
            title: 'Évaluation des risques liés aux données',
            description: 'Une évaluation des risques liés aux données doit être menée pour identifier et atténuer les risques liés à la gouvernance des données.',
        },
        '6f228998_1c61_49cf_a585_3d3e9baff55a': {
            title: 'Responsabilité et obligations de gouvernance des opérateurs de plateforme',
            description: 'Établir des structures de responsabilisation des opérateurs de plateforme, y compris des politiques de gouvernance, des responsabilités de surveillance et des obligations d’application.',
        },
        eee1d423_3783_4530_bc64_eef6fd9d02dc: {
            title: 'Règlement de la plateforme publication et transparence des informations',
            description: 'Publiez les règles de la plateforme, les conditions de négociation et les informations opérationnelles de manière transparente et accessible.',
        },
        '50b57433_7a51_4e92_9c84_c748d6865b70': {
            title: 'Notification du site/application de vente en ligne au MOIT',
            description: 'Soumettez une notification au MOIT pour les sites Web et les applications de vente en ligne via Online.gov.vn ou les canaux désignés.',
        },
        '92854abe_6654_4155_8495_f3419a8a8da0': {
            title: 'Plateforme de services de commerce électronique/inscription sur le marché auprès du MOIT',
            description: 'Enregistrez les plateformes de services et les places de marché de commerce électronique auprès du MOIT, y compris la soumission des dossiers et le suivi des approbations.',
        },
        b8bff437_805e_4a4a_a62e_89cb90b89d3f: {
            title: 'Tenue du registre des vendeurs (nationaux et étrangers)',
            description: 'Tenez un registre de tous les vendeurs sur la plateforme, y compris les vendeurs nationaux et étrangers, avec intégration, vérification et suivi du cycle de vie.',
        },
        '75778639_5235_4d13_a728_fa772c27fc0c': {
            title: 'Registre des vendeurs Livestream et contrôles de conformité',
            description: "Tenez à jour un registre des vendeurs de diffusion en direct avec vérification d'identité, suivi des activités et contrôles de conformité.",
        },
        '405f2932_742a_4bcb_9784_1a3d81f2e714': {
            title: 'Registre des affiliés et des partenaires marketing',
            description: 'Tenez à jour un registre des spécialistes du marketing affilié et des partenaires de référence avec le statut du contrat, les directives de contenu et les reconnaissances de conformité.',
        },
        cce5a4eb_a576_459c_95b5_bdd0e8ed30a8: {
            title: 'Liste des produits et application des marchandises interdites/conditionnelles',
            description: "Mettre en œuvre des contrôles sur les listes de produits, y compris des mesures de contrôle, de surveillance et d'application des marchandises interdites et conditionnelles.",
        },
        '9fc01e19_18dd_4d60_b95a_c1f4bcdbb6ae': {
            title: "Registre des plaintes des consommateurs avec réception, actions et piste d'audit",
            description: "Tenir un registre des plaintes avec les dossiers d'admission, les actions d'enquête, les résultats de résolution et une piste d'audit complète.",
        },
        '8a21764e_e5f4_4934_9913_c235f4c462ca': {
            title: 'Procédure de traitement des réclamations et délais de résolution',
            description: 'Établissez des procédures de traitement des plaintes avec des délais définis d’accusé de réception, d’enquête et de résolution.',
        },
        '8406373c_ec31_4bf8_810f_72d9d73b3de8': {
            title: 'Modération, surveillance et application du retrait du contenu',
            description: 'Mettez en œuvre des procédures de modération, de surveillance et de retrait du contenu pour les contenus illégaux, interdits ou en violation.',
        },
        '6f32c315_323b_4ce6_a4bb_3262a5b56afe': {
            title: "Les mesures de retrait et d'exécution sont enregistrées avec préservation des preuves",
            description: "Tenez un registre des mesures de retrait et d'application avec des enregistrements de décisions, la préservation des preuves et les notifications des vendeurs.",
        },
        c0bbbfbf_29bd_4813_89f1_956eab9f1a23: {
            title: 'Politique de la plateforme et registre de divulgation (versions, dates de publication, acceptation)',
            description: "Tenir à jour un registre des politiques et des divulgations de la plateforme avec l'historique des versions, les dates de publication et les preuves d'acceptation.",
        },
        c9fcbe90_622d_43ca_9ec6_db26c0eda490: {
            title: "Obligations d'information des consommateurs - informations précises sur les produits et lutte contre la tromperie",
            description: 'Garantir des informations précises et claires sur les produits et services et mettre en œuvre des mesures pour empêcher les pratiques trompeuses sur la plateforme.',
        },
        '8f49603b_454c_4470_ab07_2f845a447595': {
            title: 'Conditions d’exploitation des plateformes étrangères et enregistrement/notification',
            description: "Respecter les conditions d'exploitation des plateformes étrangères au service des utilisateurs vietnamiens, y compris les exigences d'enregistrement ou de notification.",
        },
        e0dc85cc_5d2a_4142_b1a6_cc2fde891f7b: {
            title: 'Représentation locale ou autorisation pour les plateformes étrangères',
            description: "Désignez un représentant local ou une entité autorisée au Vietnam pour les plateformes étrangères, comme l'exige la loi.",
        },
        '5719f47c_f298_429e_90c3_df6ceed856e1': {
            title: 'Coordination du vendeur transfrontalier et du traitement des réclamations',
            description: "Coordonner le traitement des vendeurs transfrontaliers et la résolution des plaintes, y compris l'escalade et la gestion des preuves.",
        },
        c0b3db29_9161_4cef_a889_94e3b85d78fe: {
            title: 'Interaction du système de gestion du commerce électronique de l’État et préparation aux rapports',
            description: "Préparez-vous à l'interaction avec le système de gestion du commerce électronique de l'État, y compris la cartographie des champs de données et la capacité de reporting.",
        },
        '145a7016_720a_4a06_badd_00145842821e': {
            title: 'Notification de changement important après approbation',
            description: "Envoyez des notifications pour les modifications importantes apportées aux détails, aux politiques ou aux opérations de la plateforme après l'approbation initiale.",
        },
        '4bc0ee2a_610d_490d_8122_d6d1afadaa22': {
            title: 'Notification de résiliation et de désactivation',
            description: 'Soumettez des notifications de résiliation ou de désactivation lors de la cessation des opérations de commerce électronique, y compris un avis public et la gestion de la protection des consommateurs.',
        },
        be95bc85_2b25_4de7_a3e7_154b780289e4: {
            title: 'Éligibilité et maintien du programme de marque de confiance et de notation de crédibilité',
            description: 'Évaluez l’éligibilité aux programmes de marque de confiance et d’évaluation de la crédibilité et conservez les preuves de conformité pour une participation continue.',
        },
        f639afe2_18f2_4c0a_82d9_626308994267: {
            title: 'Consentement au traitement des données personnelles',
            description: 'Le traitement des données personnelles nécessite le consentement de la personne concernée, sauf exception.',
        },
        '5dd8e1b9_ac2d_48af_8c62_538937f0a4f7': {
            title: 'Consentement au traitement de données sensibles',
            description: 'Le traitement des données personnelles sensibles nécessite un consentement explicite avec une notification distincte et claire à la personne concernée.',
        },
        '5a958c76_6943_4449_a15c_ddb503ce526f': {
            title: "Droit d'accès",
            description: "Les personnes concernées ont le droit d'accéder à leurs données personnelles détenues par le responsable du traitement.",
        },
        '1ae0a58b_65a5_4a32_9b2c_0baed7799a32': {
            title: 'Droit de rectification',
            description: 'Les personnes concernées ont le droit de demander la rectification de données personnelles inexactes.',
        },
        '25c61e57_273f_48cb_a318_d6315ad744f1': {
            title: "Droit à l'effacement",
            description: "Les personnes concernées ont le droit de demander l'effacement de leurs données personnelles.",
        },
        '0eafe047_ed8b_4a9a_bda9_b4ef2ae353c2': {
            title: 'Droit de restreindre le traitement',
            description: 'Les personnes concernées ont le droit de demander la limitation du traitement de leurs données personnelles.',
        },
        '77f9677a_f436_43ec_a947_3bdc44fc192a': {
            title: "Droit d'opposition",
            description: "Les personnes concernées ont le droit de s'opposer au traitement de leurs données personnelles.",
        },
        c8b19e70_782c_49c9_8a71_14bef4147d6b: {
            title: 'Droit de retirer son consentement',
            description: 'Les personnes concernées ont le droit de retirer à tout moment leur consentement préalablement donné.',
        },
        '7f472a1c_b37f_498d_adc7_df8d8eafbae9': {
            title: "Notification du manquement à l'autorité (72h)",
            description: "Le responsable du traitement doit informer le ministère de la Sécurité publique dans les 72 heures suivant la découverte d'une violation de données personnelles.",
        },
        '98bed7ab_e814_43f5_8e70_e95c413266a1': {
            title: 'Notification de violation aux personnes concernées',
            description: 'Le responsable du traitement doit informer sans délai les personnes concernées d’une violation de données personnelles.',
        },
        '404a3576_dd84_4bac_acf4_29719615c45e': {
            title: '[[TOK_0]] pour les traitements à haut risque',
            description: 'Une analyse d’impact sur la protection des données doit être réalisée pour les activités de traitement susceptibles d’entraîner un risque élevé.',
        },
        '29d9ed94_9360_457c_9aca_37aefac66969': {
            title: 'Évaluation des transferts transfrontaliers',
            description: 'Une analyse d’impact doit être réalisée avant de transférer des données personnelles hors du Vietnam.',
        },
        '9620ff08_b83c_4e1f_9350_eba835b145fe': {
            title: 'Registre des activités de traitement',
            description: 'Les responsables du traitement des données doivent tenir un registre des activités de traitement (RoPA) documentant toutes les activités de traitement.',
        },
        '96ee0ff3_3ead_431e_aa57_08ccff4821fc': {
            title: 'Enregistrements des accords de traitement des données',
            description: 'Les enregistrements des accords de traitement de données avec les sous-traitants et sous-traitants doivent être conservés.',
        },
        '434dc319_1922_49e4_b757_37622135c4b2': {
            title: 'Garanties relatives aux transferts transfrontaliers',
            description: 'Les transferts de données personnelles en dehors du Vietnam nécessitent des garanties appropriées et des évaluations documentées.',
        },
        '3372c651_d5a8_4cae_ae57_2fc684ad0768': {
            title: 'Accusé de réception sous 2 jours ouvrés',
            description: 'Les demandes des personnes concernées doivent être accusées de réception dans les 2 jours ouvrables suivant leur réception.',
        },
        b15fa62d_3f52_4e42_8442_f4969e08883a: {
            title: 'Réalisation sous 15 jours ouvrés',
            description: 'Les demandes des personnes concernées doivent être traitées dans un délai de 15 jours ouvrables, avec une possibilité de prolongation de 5 jours ouvrables.',
        },
        '5d81233c_f671_4827_b874_827762edfc20': {
            title: 'Dépôt du dossier d’évaluation d’impact MoPS',
            description: "Les organismes procédant à des traitements à haut risque doivent déposer un dossier d'analyse d'impact auprès du ministère de la Sécurité publique selon la procédure administrative prescrite.",
        },
        '83bf5bf8_edbd_4f0a_9f8e_5f47db01324d': {
            title: 'Dépôt du dossier de transfert transfrontalier MoPS',
            description: 'Les organisations transférant des données personnelles en dehors du Vietnam doivent déposer un dossier d’évaluation de l’impact du transfert transfrontalier auprès du ministère de la Sécurité publique.',
        },
        '9454e465_e618_4b6f_80b3_d79fdd9cc5cb': {
            title: 'Certification du prestataire de services de traitement',
            description: 'Les organismes fournissant un traitement de données personnelles en tant que service doivent obtenir un certificat de traitement de services auprès du ministère de la Sécurité publique.',
        },
        b88aec34_046a_4e0a_9c77_ddad27ea4bc4: {
            title: "Traitement du dossier d'évaluation d'impact lorsque les déclencheurs sont remplis",
            description: 'Un dossier d’évaluation de l’impact du traitement doit être déposé lorsque les éléments déclencheurs prescrits sont remplis.',
        },
        '9d34a206_b85e_4649_a23b_e2c6f1398402': {
            title: 'Dossier d’impact des transferts transfrontaliers',
            description: 'Un dossier d’impact des transferts transfrontaliers doit être préparé et déposé pour les transferts internationaux de données.',
        },
        '210d3ec3_e6f2_424b_ae25_cad76bc13320': {
            title: 'Désignation du délégué à la protection des données',
            description: 'Un délégué à la protection des données doit être désigné conformément au décret 13.',
        },
        '776183b2_2797_40e8_8d81_c4f512c566d2': {
            title: 'Artefacts de gouvernance (politiques, rôles, procédures)',
            description: 'Les artefacts de gouvernance, notamment les politiques, les rôles et les procédures, doivent être conservés.',
        },
        '4f1385f1_6dfc_4368_b4af_1040cd3f77b7': {
            title: 'Complétude du dossier de preuves et piste d’audit immuable',
            description: 'Les dossiers de preuves doivent être complets et une piste d’audit immuable doit être conservée.',
        },
        f6826e26_8991_4a0f_9117_481490230bdd: {
            title: 'Prise en charge du flux de travail de dépôt de dossiers',
            description: 'Les flux de travail de dépôt des dossiers doivent être pris en charge pour les analyses d’impact et les dossiers transfrontaliers.',
        },
        '8a28ee33_305a_491f_a93f_90e59f8da91b': {
            title: 'Exigences contractuelles du processeur',
            description: 'Les exigences contractuelles pour les sous-traitants doivent être établies et surveillées.',
        },
        '4fd36e83_8286_40e0_b9b2_a4bc5e8377b3': {
            title: 'Examen annuel de conformité',
            description: 'Un examen de conformité annuel doit être effectué pour vérifier le respect continu.',
        },
        '8b6b6c13_0d32_4439_819f_4bd8cff02217': {
            title: 'Autorité déposant les dossiers de soumission',
            description: 'Les enregistrements de toutes les soumissions de dépôt d’autorité doivent être conservés.',
        },
        e7ce6c23_03dc_42dd_bccd_fa571c3afee3: {
            title: 'Bases légales du traitement des données personnelles',
            description: 'Le traitement des données personnelles doit être fondé sur des bases licites telles que définies par le [[TOK_0]].',
        },
        c919c66c_6a74_4403_bb97_04b773d270bf: {
            title: 'Exigences de consentement pour les données sensibles',
            description: 'Le traitement des données personnelles sensibles nécessite un consentement explicite avec des exigences spécifiques.',
        },
        '419cc7c3_a257_4293_a054_304dc2fcb8df': {
            title: 'Droits des personnes concernées (accès, rectification, effacement, restriction, opposition, portabilité)',
            description: "Les personnes concernées disposent de droits complets, notamment d'accès, de rectification, d'effacement, de restriction, d'opposition et de portabilité.",
        },
        '638e6e25_3a74_4864_8bff_8e21ab82860b': {
            title: "Notification de violation à l'autorité",
            description: "Les responsables du traitement doivent informer l'autorité compétente des violations de données personnelles dans le délai prescrit.",
        },
        '6e75c111_66b1_4726_8c27_6537846edb30': {
            title: 'Notification de violation aux personnes concernées',
            description: 'Les responsables du traitement des données doivent informer les personnes concernées des violations de données personnelles.',
        },
        f686123d_3bdd_4a61_a53c_efe5b52d9058: {
            title: "Analyse d'impact sur la protection des données",
            description: 'Une analyse d’impact sur la protection des données doit être réalisée pour les activités de traitement à haut risque.',
        },
        '554ea5b6_092d_4295_a57a_1bd9b2eef291': {
            title: 'Gouvernance des transferts transfrontaliers',
            description: 'Les transferts transfrontaliers de données personnelles doivent être conformes aux exigences de gouvernance.',
        },
        cf9a5b29_46fd_4072_b877_13b8a69df82c: {
            title: 'Désignation du délégué à la protection des données',
            description: 'Les organisations doivent désigner un délégué à la protection des données si nécessaire.',
        },
        f5a4965d_eb0c_47df_9933_f185ae46463b: {
            title: 'Registres des activités de traitement',
            description: 'Les organisations doivent conserver des enregistrements de toutes les activités de traitement.',
        },
        ce8986ff_684d_41ec_8147_b3f2a1c5206c: {
            title: 'Obligations contractuelles du sous-traitant',
            description: 'Des obligations contractuelles doivent être établies avec les sous-traitants.',
        },
        '7a3d7554_7b6f_49d7_8864_4a5cd71fd6bd': {
            title: 'Dépôt du dossier d’analyse d’impact',
            description: "Les dossiers d'analyse d'impact doivent être déposés auprès de l'autorité compétente comme prescrit.",
        },
        '65dba62f_0788_44c1_89e3_09d802e28eb9': {
            title: 'Dossier d’impact des transferts transfrontaliers',
            description: 'Un dossier d’impact des transferts transfrontaliers doit être préparé et déposé pour les transferts internationaux de données.',
        },
        '0eccb520_b1fa_4fa3_a3ab_2d30823dd00e': {
            title: '[[TOK_0]] rendez-vous et notification',
            description: "Un délégué à la protection des données doit être nommé et l'autorité informée.",
        },
        '43ead19e_982a_4615_bafd_e6a3a4e80b3a': {
            title: 'Politiques et procédures de gouvernance',
            description: 'Des politiques et procédures de gouvernance doivent être établies et maintenues.',
        },
        '9ebc7a42_e1f1_49c4_ac90_22a691fd2219': {
            title: 'Pack de preuves et piste d’audit immuable',
            description: 'Les dossiers de preuves doivent être complets et une piste d’audit immuable doit être conservée.',
        },
        '5b0ba1c0_7b86_4c80_b9f9_26e4ff9652c2': {
            title: 'Cycle de vie du dossier de dépôt',
            description: 'Les cycles de vie des dossiers de dépôt doivent être gérés selon des étapes prescrites.',
        },
        '83f2f346_47bb_4377_a711_3cef26742f39': {
            title: 'Exigences contractuelles du processeur',
            description: 'Les exigences contractuelles pour les sous-traitants doivent être établies et surveillées.',
        },
        cb972e06_f773_492e_8ad5_f65d1e999b79: {
            title: 'Certification de prestataire de traitement de services',
            description: 'Les organisations fournissant des services de traitement de données doivent obtenir une certification.',
        },
        '4ba36ab5_39f0_4d79_927e_c39587bed226': {
            title: 'Autorité déposant les dossiers de soumission',
            description: 'Les enregistrements de toutes les soumissions de dépôt d’autorité doivent être conservés.',
        },
        f7a62c88_3cda_4031_bc52_1598661a5128: {
            title: 'Examen annuel de conformité',
            description: 'Un examen de conformité annuel doit être effectué pour vérifier le respect continu.',
        },
        '3e97f4d4_60ad_46a8_ad2b_615d4ca04aee': {
            title: 'Mesures techniques de sécurité des données',
            description: 'Des mesures techniques pour la sécurité des données doivent être mises en œuvre et maintenues.',
        },
        '45f4e745_a923_4879_94ce_5a2b41b7e886': {
            title: 'Décret 356 Exigences officielles du formulaire Mẫu số',
            description: 'Les 13 formulaires officiels de procédure administrative Mẫu số (Mẫu số 01a–10) prescrits par le décret [[TOK_0]]Đ-CP doivent être utilisés pour les dépôts correspondants auprès du ministère de la Sécurité publique. Les éléments Phụ lục I à VIII sont des mappages internes de structure de données, et non des formulaires réglementaires officiels.',
        },
        ff452604_7461_4c12_aeab_cb7dd1fb5ba3: {
            title: '[[TOK_0]] soumission du dossier à A05',
            description: 'Les organisations doivent soumettre des dossiers [[TOK_0]] à A05/[[TOK_1]] pour des activités de traitement impliquant des données personnelles sensibles ou un traitement à grande échelle.',
        },
        '003600ae_7a0f_4034_b206_72f59409b8f3': {
            title: 'Soumission du dossier de transfert transfrontalier',
            description: 'Les organisations doivent soumettre les dossiers de transfert de données transfrontaliers pour examen et approbation A05/[[TOK_0]].',
        },
        '4632b20c_293a_4c7e_968e_4ce178c3b7d8': {
            title: 'Demande de certificat de service de traitement',
            description: 'Les prestataires de services de traitement de données doivent demander des certificats auprès de A05/[[TOK_0]].',
        },
        be96add4_ebdb_4b6c_9426_4dc87b7cd2ce: {
            title: 'Notification de traitement de données personnelles',
            description: 'Les responsables du traitement doivent informer A05/[[TOK_0]] des activités de traitement de données personnelles en utilisant les formulaires prescrits (Mẫu số 01a/01b).',
        },
        '39f50471_27cc_46bd_acff_9aa2211d43ab': {
            title: 'Rapport de situation annuel',
            description: 'Les responsables du traitement doivent soumettre des rapports annuels sur la situation du traitement des données personnelles (Mẫu số 09).',
        },
        '3b45c6fa_d66a_448a_9ff1_597caa055e09': {
            title: 'Confidentialité des informations utilisateur par défaut',
            description: 'Les informations utilisateur doivent être traitées de manière confidentielle par défaut.',
        },
        '2994510e_b1f8_4cdd_947c_d9542746433b': {
            title: 'Contrôles minimaux de protection organisationnelle et technique',
            description: 'Des contrôles minimum de protection organisationnels et techniques doivent être mis en œuvre.',
        },
        '8643160f_9a10_4d93_baf5_082c6a7c768a': {
            title: 'Divulgation uniquement sur des bases appropriées',
            description: "La divulgation des informations sur les utilisateurs n'est autorisée que sur une base légale appropriée.",
        },
        c1fb7d85_fdc0_402e_ab0c_ff134bd72dfa: {
            title: 'Journalisation des divulgations obligatoires et auditabilité',
            description: 'Toutes les divulgations doivent être enregistrées et vérifiables.',
        },
        efa36bc0_abae_417a_b676_9509af37f89d: {
            title: "Flux de travail d'approbation interne pour les divulgations",
            description: 'Un flux de travail d’approbation interne doit être établi pour toutes les divulgations.',
        },
        d086fdcd_9a23_4500_893c_db8ac62bd787: {
            title: 'Traitement des réponses aux demandes d’autorité',
            description: 'Les demandes d’autorisation doivent être traitées et répondues conformément aux procédures prescrites.',
        },
    },
    framework_rights_descriptions: {
        be_informed: "La personne concernée a le droit d'être informée des activités de traitement des données personnelles.",
        consent: 'La personne concernée a le droit de consentir au traitement de ses données personnelles.',
        refuse_consent: 'La personne concernée a le droit de ne pas consentir au traitement de ses données personnelles.',
        withdraw_consent: 'La personne concernée a le droit de demander le retrait du consentement précédemment donné.',
        access: "La personne concernée a le droit de consulter et d'accéder à ses données personnelles détenues par le responsable du traitement.",
        rectification: 'La personne concernée a le droit de corriger ou de demander la rectification de données personnelles inexactes.',
        data_provision: 'La personne concernée a le droit de demander la fourniture de ses données personnelles (yêu cầu cung cấp dữ liệu cá nhân).',
        deletion: 'La personne concernée a le droit de demander la suppression ou la destruction de ses données personnelles, sous réserve des exceptions prévues par la loi.',
        restriction_of_processing: 'La personne concernée a le droit de demander la limitation du traitement de ses données personnelles.',
        object_to_processing: "La personne concernée a le droit d'adresser une demande d'opposition au traitement de ses données personnelles.",
        complaint: 'La personne concernée a le droit de déposer une plainte (khiếu nại) concernant le traitement des données personnelles.',
        denunciation: 'La personne concernée a le droit de déposer une dénonciation (tố cáo) concernant les violations de la protection des données personnelles.',
        lawsuit: "La personne concernée a le droit d'intenter une action en justice (khởi kiện) en cas de violation de ses droits en matière de protection des données.",
        claim_damages: 'La personne concernée a le droit de réclamer une indemnisation pour les dommages causés par des violations de la protection des données personnelles.',
        request_protection_measures: 'La personne concernée a le droit de demander aux autorités compétentes ou aux organisations/individus concernés de mettre en œuvre des mesures pour protéger ses données personnelles.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Gestion et surveillance des risques (projet)',
            steps: {
                '1': 'Identifier les catégories de risques',
                '2': 'Maintenir des contrôles d’alerte précoce',
                '3': 'Examiner les risques liés à la collecte, au stockage, au traitement, au partage et aux transactions',
                '4': 'Enregistrer les risques liés à la confidentialité, à la cybersécurité et à la gestion des accès',
                '5': 'Déclencher des actions correctives',
                '6': "Conserver l'historique des avis",
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Plaintes et litiges (projet)',
            steps: {
                '1': 'Recevoir les plaintes / litiges',
                '2': "Vérifier l'exhaustivité des informations requises ; demander un supplément sous 24 heures si incomplet",
                '3': "Dans les 3 jours ouvrables suivant la réception d'une demande complète, informez les parties de l'approche de traitement et du calendrier prévu.",
                '4': 'Demander des réponses et des pièces justificatives',
                '5': 'Évaluer les faits du litige et la responsabilité de la plateforme',
                '6': 'Enregistrer le résultat de la résolution',
                '7': 'Préserver les preuves et clôturer le dossier',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Remise et certificat de propriété des données (projet)',
            steps: {
                '1': 'Livrer le produit/service selon la méthode contractuelle',
                '2': "Enregistrer l'événement et l'heure de livraison",
                '3': 'Générer un certificat de droits de propriété sur les données',
                '4': 'Enregistrer la fin de la transaction',
                '5': 'Activer la recherche/vérification ultérieure si nécessaire',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Initiation et passation de transactions (projet)',
            steps: {
                '1': "Examiner la liste et le résultat de l'évaluation",
                '2': "Lancer un workflow d'achat, de négociation ou d'enchères",
                '3': 'Générer un contrat électronique',
                '4': 'Assurez l’acceptation des deux parties',
                '5': "Enregistrer l'achèvement du paiement",
                '6': 'Autoriser la livraison',
            },
        },
        VN_DP_DRAFT_P3: {
            name: "Accès au bac à sable/à l'environnement de test (projet)",
            steps: {
                '1': 'Soumettre une demande de bac à sable',
                '2': 'Définir la portée, les données autorisées, la période et les autorisations de traitement',
                '3': "Mise à disposition d'un environnement technique isolé",
                '4': 'Surveiller la sécurité et l’accès pendant les tests',
                '5': "Vérifier la sortie avant l'extraction",
                '6': 'Approuver l’extraction uniquement lorsque cela est autorisé',
                '7': "Fermer la session de test et nettoyer l'environnement",
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Liste des produits/services de données (ébauche)',
            steps: {
                '1': "Créer une demande d'inscription",
                '2': "Capturer la source et les preuves de propriété/droit d'utilisation",
                '3': 'Enregistrer les caractéristiques techniques, le format, les [[TOK_0]] détails et les restrictions',
                '4': 'Enregistrer les informations sur la qualité',
                '5': "Soumettre le dossier d'inscription à l'examen de la plateforme",
                '6': "La plateforme effectue des contrôles d'exhaustivité, de légalité et techniques",
                '7': 'Approuver ou rejeter la liste',
                '8': "Si approuvé, publier la liste avec le résultat de l'évaluation en pièce jointe",
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Intégration des participants (ébauche)',
            steps: {
                '1': 'Déterminer le type de participant : vendeur ou acheteur',
                '2': 'Vérifier le statut juridique et la capacité juridique',
                '3': "Vérifier les conditions supplémentaires si des secteurs d'activité conditionnels s'appliquent",
                '4': 'Enregistrer un compte de transaction',
                '5': 'Associer un compte de paiement',
                '6': 'Approuver la participation à la plateforme',
                '7': "Stocker le dossier des participants et la piste d'audit",
            },
        },
        AI_A1: {
            name: '[[TOK_0]] Enregistrement/Notification du système',
            steps: {
                '1': "Vérification de l'applicabilité et classification du système [[TOK_0]]",
                '2': "Construire le dossier d'enregistrement/notification",
                '3': 'Approbation interne',
                '4': 'Soumettre via le canal',
                '5': "Boucle d'amendement - si renvoyé, mettez à jour et soumettez à nouveau",
                '6': 'Fermer et confirmer le stockage',
            },
        },
        AI_A2: {
            name: '[[TOK_0]] Flux de travail de classification des risques',
            steps: {
                '1': 'Créer une entrée de registre système [[TOK_0]]',
                '2': "Exécuter l'assistant de classification",
                '3': 'Joindre des preuves',
                '4': 'Approuver le classement',
                '5': 'Lier les sorties au dossier système',
            },
        },
        AI_A3: {
            name: 'Conformité à l’étiquetage et à la divulgation',
            steps: {
                '1': "Identifier les obligations d'étiquetage par système et cas d'utilisation",
                '2': "Mettre en œuvre des avis d'étiquetage",
                '3': "Capturer des preuves : captures d'écran, copie de l'interface utilisateur, métadonnées techniques",
                '4': 'Gérer les exemptions et enregistrer la justification',
                '5': 'Approuver et version',
            },
        },
        AI_A4: {
            name: "Rapport d'incident grave",
            steps: {
                '1': "Créer un [[TOK_0]] enregistrement d'incident",
                '2': 'Classer la gravité',
                '3': 'Exécuter des actions de confinement et capturer des preuves',
                '4': "Générer un export de modèle de rapport d'incident grave",
                '5': "Soumettre à l'autorité via le canal",
                '6': 'Suivre les réponses des autorités et la clôture',
            },
        },
        AI_A5: {
            name: "[[TOK_0]] Évaluation d'impact",
            steps: {
                '1': "Créer un dossier d'évaluation",
                '2': 'Remplir les sections requises',
                '3': 'Joindre des preuves : flux de données, documentation du modèle, contrôles',
                '4': 'Approbation interne',
                '5': 'Exporter le rapport et le stocker dans un dossier',
            },
        },
        AI_A6: {
            name: 'Tests contrôlés / Participation au bac à sable',
            steps: {
                '1': 'Dossier complet d’éligibilité et de préparation',
                '2': "Préparer l'application et l'export",
                '3': 'Soumettre via le canal',
                '4': "Suivre l'approbation",
                '5': 'Exécuter des points de contrôle et des journaux de surveillance',
                '6': 'Rapport d’achèvement complet et dossier de clôture',
            },
        },
        CYBERSEC_C1: {
            name: 'Évaluation de la sécurité des systèmes d’information critiques',
            steps: {
                '1': "Classer les systèmes d'information selon les exigences nationales en matière de cybersécurité",
                '2': 'Effectuer une évaluation de la sécurité et une évaluation des risques pour les systèmes classifiés',
                '3': 'Mettre en œuvre les mesures de sécurité requises et les contrôles de base',
                '4': 'Documenter les preuves de conformité et planifier des examens périodiques',
            },
        },
        CYBERSEC_C2: {
            name: "Notification d'incident de cybersécurité",
            steps: {
                '1': 'Détecter, classer et évaluer l’incident de cybersécurité',
                '2': 'Exécuter des actions de réponse immédiate et préserver les preuves',
                '3': 'Faire rapport aux autorités et participer à la coordination nationale de la réponse aux incidents',
                '4': 'Effectuer un examen post-incident et documenter les leçons apprises',
            },
        },
        CYBERSEC_C3: {
            name: 'Vérification de la conformité de la localisation des données',
            steps: {
                '1': "Évaluer si les déclencheurs de localisation des données s'appliquent en fonction du type de service et des catégories de données",
                '2': "Vérifier que l'architecture de stockage locale et les contrôles de flux transfrontaliers sont en place",
                '3': 'Évaluer les exigences de présence locale (succursale/bureau de représentation), le cas échéant',
                '4': "Documenter les preuves de conformité et les conserver pour examen par l'autorité",
            },
        },
        CYBERSEC_C4: {
            name: 'Réponse à la demande de coopération des autorités',
            steps: {
                '1': "Recevoir et vérifier la légitimité et la portée de la demande d'autorité",
                '2': 'Recueillir et préparer les informations demandées ou exécuter les actions requises',
                '3': "Soumettre la réponse à l'autorité dans les délais requis",
                '4': 'Enregistrez la divulgation et fermez le dossier',
            },
        },
        CYBERSEC_C5: {
            name: 'Vérification des qualifications du personnel en cybersécurité',
            steps: {
                '1': "Évaluer la posture de sécurité des fournisseurs à l'aide du cadre d'évaluation de la cybersécurité",
                '2': "Vérifier la portée de l'accès aux données du fournisseur et s'inscrire dans le journal d'accès aux données du fournisseur",
                '3': "Examiner la clause de notification d'incident du fournisseur et les exigences contractuelles en matière de cybersécurité",
                '4': 'Planifiez des examens périodiques de la sécurité des fournisseurs et surveillez la conformité',
            },
        },
        DATA_D1: {
            name: "Configuration de l'inventaire et de la classification des données",
            steps: {
                '1': "Cataloguer tous les actifs de données avec types et sources dans le registre d'inventaire des données",
                '2': 'Classer chaque actif par niveau de sensibilité',
                '3': 'Définir des règles de traitement par niveau de classification',
                '4': "Capturer des preuves : captures d'écran, diagrammes d'architecture, contrôles d'accès",
                '5': 'Planifier des examens périodiques',
            },
        },
        DATA_D2: {
            name: 'Gouvernance du partage de données',
            steps: {
                '1': 'Évaluer les nouveaux accords de partage via une évaluation des risques liés au partage de données',
                '2': 'Workflow d’approbation interne complet',
                '3': "Enregistrer l'événement de partage dans le journal de partage/divulgation de données",
                '4': "Capturer des preuves : dossiers d'approbation, documents contractuels",
                '5': 'Examen périodique des accords de partage',
            },
        },
        DATA_D3: {
            name: 'Évaluation du transfert de données transfrontalier',
            steps: {
                '1': "Identifier les transferts transfrontaliers dans l'inventaire des données",
                '2': 'Effectuer une évaluation des risques de transfert',
                '3': 'Appliquer des mesures de sauvegarde et de gouvernance',
                '4': "Document dans la section transfrontalière de l'attestation de gouvernance",
                '5': "Dossier d'évaluation des exportations pour audit",
            },
        },
        DATA_D4: {
            name: 'Attestation annuelle de gouvernance',
            steps: {
                '1': 'Examiner la matrice RACI de gouvernance',
                '2': "Vérifier l'état de la politique (gouvernance, classification, partage, rétention)",
                '3': "Dossier d'attestation complet",
                '4': "Obtenir l'approbation interne",
                '5': "Attestation d'exportation et d'archivage",
            },
        },
        DATA_D5: {
            name: 'Gestion des incidents de données',
            steps: {
                '1': "Classer l'incident à l'aide du dossier de décision",
                '2': 'Exécuter la réponse aux incidents selon le playbook',
                '3': "Capturer des preuves : journaux, captures d'écran, communications",
                '4': 'Effectuer un examen post-incident',
                '5': 'Si une notification aux autorités est requise : créez un dossier de soumission et soumettez-le à [[TOK_0]]',
                '6': 'Fermer et archiver',
            },
        },
        ECOM_P1: {
            name: 'Notification (site Web/application de vente)',
            steps: {
                '1': 'Déterminer la classification : site/application de vente vs place de marché/plateforme de services',
                '2': "Créez un dossier de dossier interne avec l'identité de l'entreprise, les informations sur le site Web/l'application et les divulgations requises",
                '3': "Générer un pack de preuves : captures d'écran des divulgations, URL des politiques, historique des versions",
                '4': "Soumettre via Online.gov.vn - télécharger des documents, enregistrer l'horodatage et la confirmation",
                '5': 'Suivre le traitement – en cas de retour pour modification, saisir les raisons et soumettre à nouveau',
                '6': "Fermer : stocker la confirmation, lier les preuves et la piste d'audit",
            },
        },
        ECOM_P2: {
            name: 'Inscription (Plateformes de services / Marketplaces)',
            steps: {
                '1': 'Déterminer le modèle et les obligations de la plateforme : marché, commerce mixte et commerce social',
                '2': "Créer un dossier d'enregistrement - formulaire de candidature, programme de prestation de services, conditions générales, règles de la plateforme",
                '3': 'Approbations internes : attribuer un propriétaire juridique/de conformité, approuver la soumission',
                '4': "Soumettre via Online.gov.vn - télécharger le dossier, enregistrer l'horodatage",
                '5': 'Boucle de traitement – si renvoyé pour modification, mettre à jour et soumettre à nouveau',
                '6': 'Approbation et opérationnalisation – stocker la confirmation, maintenir des registres de conformité continus',
            },
        },
        ECOM_P3: {
            name: 'Notification de mise à jour/modification',
            steps: {
                '1': 'Identifier le déclencheur de changement — changement important apporté aux pièces de dossier',
                '2': 'Générer un package de modifications : résumé des modifications, documents mis à jour, mises à jour des preuves',
                '3': 'Soumettre la mise à jour et enregistrer le statut de soumission',
                '4': 'Suivre le traitement et clôturer',
            },
        },
        ECOM_P4: {
            name: 'Résiliation / Désactivation',
            steps: {
                '1': "Préparer le dossier de résiliation - date de cessation, motif, plan de gestion de la protection des consommateurs, preuve d'avis public",
                '2': "Soumettre la résiliation - enregistrer l'horodatage et la confirmation",
                '3': 'Fermer – stocker le statut final et les preuves',
            },
        },
        ECOM_P5: {
            name: 'Programme de marque de confiance/de notation de crédibilité',
            steps: {
                '1': 'Examen d’éligibilité et de préparation',
                '2': 'Préparer le dossier en utilisant le formulaire officiel',
                '3': 'Soumettre et suivre',
                '4': 'Maintenir des preuves de conformité continues',
            },
        },
        PDPL_P1: {
            name: '[[TOK_0]] Dépôt de la soumission à [[TOK_1]]',
            steps: {
                '1': 'Complétez [[TOK_0]] en utilisant le cheminement du formulaire du décret 356 (Mẫu số 02a/02b)',
                '2': 'Rassembler les documents de couverture et les preuves à l’appui',
                '3': 'Soumettre un dossier original au ministère de la Sécurité publique ([[TOK_0]])',
                '4': 'Surveiller les demandes de supplément de [[TOK_0]] et répondre dans les délais',
                '5': "Conserver le dossier et les preuves de soumission pour la piste d'audit",
            },
        },
        PDPL_P2: {
            name: 'Demande de transfert transfrontalier',
            steps: {
                '1': "Remplir le dossier de transfert transfrontalier à l'aide des formulaires du décret 356 (Mẫu số 01a/01b, Mẫu số 09)",
                '2': 'Soumettez un dossier original à [[TOK_0]] dans les 60 jours suivant le début du traitement.',
                '3': 'Notifier [[TOK_0]] après le transfert réussi avec les coordonnées du destinataire',
                '4': 'Répondre aux demandes de complément / correction / inspection de [[TOK_0]] dans les délais',
            },
        },
        PDPL_P3: {
            name: 'Demande de certificat de service de traitement de données',
            steps: {
                '1': 'Préparer le dossier de demande de certification conformément aux exigences du décret 356',
                '2': 'Soumettre la candidature à [[TOK_0]] avec les pièces justificatives requises',
                '3': 'Répondre aux commentaires de révision et aux demandes de supplément [[TOK_0]]',
                '4': 'Maintenir le calendrier de certificat et de renouvellement',
            },
        },
        PDPL_P4: {
            name: 'Traitement des demandes de droits des personnes concernées',
            steps: {
                '1': "Recevoir et enregistrer la demande ; vérifier l'identité de la personne concernée dans les 2 jours ouvrables",
                '2': 'Évaluer le type de demande et déterminer le délai applicable (10/15/20 jours par type)',
                '3': "Exécuter des actions d'exécution dans les systèmes et départements concernés",
                '4': 'Préparer et envoyer la réponse à la personne concernée avec le résultat et la justification',
                '5': "Clôturer le dossier et conserver les preuves pour l'audit ; documenter toute justification du refus",
            },
        },
        PDPL_P5: {
            name: 'Notification de violation à [[TOK_0]]',
            steps: {
                '1': "Détecter et évaluer la violation ; déterminer l'obligation de notification dans les 2 jours ouvrables",
                '2': 'Préparer le package de notification conformément aux exigences de [[TOK_0]]',
                '3': 'Envoyez une notification à [[TOK_0]] dans les deux jours ouvrés suivant la découverte.',
                '4': 'Répondre aux [[TOK_0]] demandes de suivi ; soumettre des suppléments et des preuves de coordination',
            },
        },
        TELECOM_T1: {
            name: "Traitement des demandes d'autorité",
            steps: {
                '1': "Recevoir et enregistrer la demande d'autorisation via le dossier d'admission",
                '2': "Vérifier l'identité de l'autorité, la base juridique et la portée de la demande",
                '3': 'Effectuer un examen juridique interne et obtenir l’approbation de la direction',
                '4': 'Préparer le dossier de réponse avec les preuves rassemblées',
                '5': 'Rédiger et approuver la lettre de réponse',
                '6': 'Créer un dossier de soumission et soumettre la réponse via le canal',
                '7': "Enregistrer la divulgation et suivre la reconnaissance de l'autorité",
                '8': "Clôturer le dossier et conserver les preuves pour la piste d'audit",
            },
        },
        TELECOM_T2: {
            name: 'Gestion de la divulgation',
            steps: {
                '1': "Recevoir une demande de divulgation (consentement de l'utilisateur, obligation légale ou demande d'autorité)",
                '2': 'Flux de travail complet d’approbation de la divulgation',
                '3': 'Exécuter la divulgation et enregistrer dans le registre des journaux',
                '4': "Capturer des preuves - dossiers d'approbation, dossiers de communication",
                '5': 'Examen périodique du journal de divulgation',
            },
        },
        TELECOM_T3: {
            name: "Politique de confidentialité et configuration du contrôle d'accès",
            steps: {
                '1': 'Rédiger et approuver la politique de confidentialité',
                '2': 'Rédiger et approuver la politique de contrôle d’accès et de journalisation',
                '3': 'Activités de traitement de documents dans le registre de traitement des informations sur les utilisateurs',
                '4': 'Capturer des preuves – documents politiques, preuves de mise en œuvre',
                '5': 'Planifier des examens périodiques',
            },
        },
        TELECOM_T4: {
            name: 'Évaluation des incidents de télécommunications',
            steps: {
                '1': "Classer et évaluer l'incident",
                '2': 'Déterminer les exigences de notification',
                '3': 'Si une notification aux autorités est requise : créer un dossier de soumission',
                '4': 'Capturer et conserver les preuves',
                '5': 'Résolution et clôture',
            },
        },
        TELECOM_T5: {
            name: 'Gestion de la conservation et de la suppression',
            steps: {
                '1': 'Définir le calendrier de conservation et de suppression par catégorie de données',
                '2': 'Mettre en œuvre les procédures de suppression',
                '3': 'Capturer des preuves – supprimer des enregistrements',
                '4': 'Révision périodique des plannings',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-A': 'Échecs de la gestion des incidents et du signalement',
            'CYBERSEC-FINE-B': 'Surveillance de la sécurité du système et échecs du contrôle de base',
            'CYBERSEC-FINE-C': 'Échecs de coopération dans les demandes d’autorité',
            'CYBERSEC-FINE-D': 'Localisation des données et violations de présence locale',
            'CYBERSEC-FINE-E': 'Défaillances de prévention des logiciels malveillants et de protection du système',
            'CYBERSEC-FINE-F': 'Échecs de réponse de la plate-forme/du fournisseur de services',
            'CYBERSEC-FINE-G': 'Défaillances de sécurité des fournisseurs/tiers',
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Inscription / Notification / Préparation administrative',
            'ECOM-FINE-B': 'Plaintes et protection des consommateurs',
            'ECOM-FINE-C': 'Surveillance et application du retrait',
            'ECOM-FINE-D': 'Opérations transfrontalières',
            'ECOM-FINE-E': 'Règles de la plateforme et transparence',
        },
        VN_PDPL: {
            'PDPL-FINE-A': 'Défaut de conduite [[TOK_0]]',
            'PDPL-FINE-B': 'Transfert transfrontalier non autorisé',
            'PDPL-FINE-C': 'Traitement sans base légale',
            'PDPL-FINE-D': 'Défaut de réponse au DSR',
            'PDPL-FINE-E': "Défaut de notification d'une violation de données",
            'PDPL-FINE-F': 'Accord de traitement non conforme',
            'PDPL-FINE-G': 'Violations du traitement des données sensibles',
            'PDPL-FINE-H': 'Violations du traitement des données des enfants',
            'PDPL-FINE-I': 'Violations de la prise de décision automatisée',
            'PDPL-FINE-J': "Non-respect des ordonnances d'autorisation",
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Échecs de traitement des demandes d’autorité',
            'TELECOM-FINE-B': 'Confidentialité et divulgation non autorisée',
            'TELECOM-FINE-C': 'Échecs du contrôle d’accès et de la journalisation',
            'TELECOM-FINE-D': 'Violations de conservation et de suppression',
            'TELECOM-FINE-E': 'Échecs de l’évaluation des incidents de télécommunications',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Immédiatement après la détection',
            },
            'TELECOM-FINE-D': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue',
            },
            'TELECOM-FINE-C': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue',
            },
            'TELECOM-FINE-B': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue',
            },
            'TELECOM-FINE-A': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: "Comme spécifié dans la demande d'autorisation",
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: "Jusqu'à 80 millions de VND",
                fine_org: "Jusqu'à 160 millions de VND",
                deadlines: 'Obligation continue',
            },
            'ECOM-FINE-D': {
                fine_individual: "Jusqu'à 80 millions de VND",
                fine_org: "Jusqu'à 160 millions de VND",
                deadlines: 'Obligation continue',
            },
            'ECOM-FINE-C': {
                fine_individual: "Jusqu'à 80 millions de VND",
                fine_org: "Jusqu'à 160 millions de VND",
                deadlines: 'Obligation continue',
            },
            'ECOM-FINE-B': {
                fine_individual: "Jusqu'à 80 millions de VND",
                fine_org: "Jusqu'à 160 millions de VND",
                deadlines: 'Comme spécifié par les obligations de traitement des réclamations',
            },
            'ECOM-FINE-A': {
                fine_individual: "Jusqu'à 80 millions de VND",
                fine_org: "Jusqu'à 160 millions de VND",
                deadlines: 'Avant de commencer les opérations de commerce électronique',
            },
        },
        VN_CYBERSEC_LAW: {
            'CYBERSEC-FINE-G': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue',
            },
            'CYBERSEC-FINE-F': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: "Comme spécifié dans la demande d'autorisation",
            },
            'CYBERSEC-FINE-E': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue',
            },
            'CYBERSEC-FINE-D': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: "Comme spécifié dans la décision de l'autorité ; obligation continue là où elle est déclenchée",
            },
            'CYBERSEC-FINE-C': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: "Comme spécifié dans la demande d'autorisation",
            },
            'CYBERSEC-FINE-B': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Obligation continue ; les contrôles doivent être en place avant le fonctionnement du système',
            },
            'CYBERSEC-FINE-A': {
                fine_individual: "Jusqu'à 100 millions de VND",
                fine_org: "Jusqu'à 200 millions de VND",
                deadlines: 'Réponse immédiate requise ; rapport dans les délais prescrits',
            },
        },
        VN_PDPL: {
            'PDPL-FINE-A': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: '60 jours à compter du début du traitement pour soumettre le dossier à [[TOK_0]]',
            },
            'PDPL-FINE-B': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                revenue: "3 à 5 % des revenus du Vietnam de l'année précédente dans les cas graves",
                deadlines: '60 jours à compter du début du traitement pour soumettre le dossier à [[TOK_0]] ; notification post-transfert requise',
            },
            'PDPL-FINE-C': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: 'Obligation continue ; le consentement doit être obtenu avant le traitement',
            },
            'PDPL-FINE-D': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: "Réponse procédurale sous 2 jours ouvrables ; 10 jours d'accès/correction ; 15 jours de retrait/restriction/objection ; Suppression de 20 jours",
            },
            'PDPL-FINE-E': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: '2 jours ouvrables pour informer [[TOK_0]] après avoir découvert une infraction',
            },
            'PDPL-FINE-F': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: 'Obligation continue',
            },
            'PDPL-FINE-G': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: 'Obligation continue ; des contrôles doivent être en place avant de traiter des données sensibles',
            },
            'PDPL-FINE-H': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: 'Obligation continue ; consentement parental requis avant le traitement',
            },
            'PDPL-FINE-I': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                deadlines: 'Obligation continue',
            },
            'PDPL-FINE-J': {
                fine_individual: "Jusqu'à 1,5 milliard de VND",
                fine_org: "Jusqu'à 3 milliards de VND",
                revenue: "Jusqu'à 5 % des revenus vietnamiens de l'année précédente en cas de violations répétées",
                deadlines: "Comme spécifié dans l'ordonnance de l'autorité",
            },
        },
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Fonctionnement continu de la plateforme',
            responsible: {
                '1': 'Opérateur de plateforme / Risque',
                '2': 'Opérateur de plateforme / Sécurité',
                '3': 'Opérateur de plateforme / Risque',
                '4': 'Opérateur de plateforme / Sécurité',
                '5': 'Opérateur de plateforme',
                '6': 'Conformité',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Un participant dépose une réclamation ou une demande de contestation',
            responsible: {
                '1': 'Opérateur de plateforme',
                '2': 'Opérateur de plateforme',
                '3': 'Opérateur de plateforme',
                '4': 'Opérateur de plateforme',
                '5': 'Opérateur de plateforme / Juridique',
                '6': 'Opérateur de plateforme',
                '7': 'Conformité',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P5: {
            trigger: 'La livraison est terminée une fois le contrat et les conditions de paiement remplies',
            responsible: {
                '1': 'Vendeur / Opérateur de plateforme',
                '2': 'Opérateur de plateforme',
                '3': 'Opérateur de plateforme',
                '4': 'Opérateur de plateforme',
                '5': 'Opérateur de plateforme',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Un acheteur initie une transaction pour des données, un produit ou un service',
            responsible: {
                '1': 'Acheteur',
                '2': 'Acheteur / Opérateur de plateforme',
                '3': 'Opérateur de plateforme',
                '4': 'Acheteur / Vendeur',
                '5': 'Opérateur de plateforme / Paiement',
                '6': 'Opérateur de plateforme',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Un participant souhaite évaluer des produits/services de données dans un environnement isolé',
            responsible: {
                '1': 'Participant',
                '2': 'Opérateur de plateforme / Participant',
                '3': 'Opérateur de plateforme / informatique',
                '4': 'Opérateur de plateforme / Sécurité',
                '5': 'Opérateur de plateforme',
                '6': 'Opérateur de plateforme',
                '7': 'Opérateur de plateforme / informatique',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Un vendeur cherche à répertorier des données, des produits ou des services de données à des fins de trading.',
            responsible: {
                '1': 'Vendeur',
                '2': 'Vendeur / Mentions légales',
                '3': 'Vendeur / informatique',
                '4': 'Vendeur',
                '5': 'Vendeur',
                '6': 'Opérateur de plateforme',
                '7': 'Opérateur de plateforme',
                '8': 'Opérateur de plateforme',
            },
            step_outputs: {},
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Un vendeur ou un acheteur rejoint la plateforme de données',
            responsible: {
                '1': 'Opérateur de plateforme',
                '2': 'Opérateur de plateforme / Juridique',
                '3': 'Opérateur de plateforme / Juridique',
                '4': 'Opérateur de plateforme',
                '5': 'Opérateur de plateforme',
                '6': 'Opérateur de plateforme',
                '7': 'Conformité',
            },
            step_outputs: {},
        },
        PDPL_P1: {
            trigger: 'Début d’un traitement de données personnelles nécessitant une analyse d’impact',
            responsible: {
                '1': '[[TOK_0]] / Équipe de confidentialité',
                '2': 'Équipe de confidentialité',
                '3': 'Juridique / Conformité',
                '4': '[[TOK_0]] / Équipe de confidentialité',
                '5': 'Équipe de conformité',
            },
            step_outputs: {},
        },
        PDPL_P2: {
            trigger: 'Intention de transférer des données personnelles en dehors du Vietnam',
            responsible: {
                '1': '[[TOK_0]] / Équipe de confidentialité',
                '2': 'Juridique / Conformité',
                '3': 'Juridique / Conformité',
                '4': '[[TOK_0]] / Équipe de confidentialité',
            },
            step_outputs: {},
        },
        PDPL_P3: {
            trigger: 'Organisme fournissant des services de traitement de données nécessitant une certification',
            responsible: {
                '1': 'Juridique / Conformité',
                '2': 'Juridique / Conformité',
                '3': '[[TOK_0]] / Équipe de confidentialité',
                '4': 'Équipe de conformité',
            },
            step_outputs: {},
        },
        PDPL_P4: {
            trigger: "Réception d'une demande de droits de la personne concernée",
            responsible: {
                '1': 'Équipe de confidentialité / Service client',
                '2': '[[TOK_0]] / Équipe de confidentialité',
                '3': 'Chefs de département / TI',
                '4': '[[TOK_0]] / Équipe de confidentialité',
                '5': 'Équipe de conformité',
            },
            step_outputs: {},
        },
        PDPL_P5: {
            trigger: 'Découverte d’une violation ou d’un manquement à la protection des données personnelles',
            responsible: {
                '1': 'Équipe de réponse aux incidents / [[TOK_0]]',
                '2': '[[TOK_0]] / Équipe de confidentialité',
                '3': 'Juridique / Conformité',
                '4': '[[TOK_0]] / Équipe de réponse aux incidents',
            },
            step_outputs: {},
        },
    },
    framework_deadline_references: {
        'PDPL Art. 9': '[[TOK_0]] Art. 9',
        'PDPL Art. 17': '[[TOK_0]] Art. 17',
        'PDPL Art. 23': '[[TOK_0]] Art. 23',
        'Decree 13 Art. 24': 'Décret 13 Art. 24',
        'MoPS Admin Procedures': "Procédures d'administration MoPS",
        'Annual cycle': 'Cycle annuel',
        'Decree 13/2023/NĐ-CP Art. 24': 'Décret [[TOK_0]]Đ-CP Art. 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Décret [[TOK_0]]Đ-CP Art. 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Décret [[TOK_0]]Đ-CP Art. 5 cl. 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Décret [[TOK_0]]Đ-CP Art. 5 cl. 2 à 5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Décret [[TOK_0]]Đ-CP Art. 5 cl. 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Décret [[TOK_0]]Đ-CP Art. 5 cl. 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Décret [[TOK_0]]Đ-CP Art. 5 cl. 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Décret [[TOK_0]]Đ-CP Art. 8(3)',
        'Draft Decree on Data Platforms 2026': 'Projet de décret sur les plateformes de données 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Loi [[TOK_0]] Ch. III ; NĐ 98/2020 ; 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Loi [[TOK_0]] Ch. IV (Protection des consommateurs)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Loi [[TOK_0]] — Procédure opérationnelle Online.gov.vn',
        'Law 134/2025/QH15 Article 12': 'Loi [[TOK_0]] Article 12',
        'Law 134/2025/QH15 Article 21': 'Loi [[TOK_0]] Article 21',
        'Law 134/2025/QH15 Article 27': 'Loi [[TOK_0]] Article 27',
        'Law 134/2025/QH15 Articles 9–10': 'Loi [[TOK_0]] Articles 9 à 10',
        'Law 24/2023/QH15 — article mapping pending': "Loi [[TOK_0]] — mappage d'article en attente",
        'Law 60/2024/QH15 (internal control target)': 'Loi [[TOK_0]] (cible du contrôle interne)',
        'Law 91/2025/QH15 Art. 21': 'Loi [[TOK_0]] Art. 21',
        'Law 91/2025/QH15 Art. 23': 'Loi [[TOK_0]] Art. 23',
        'Policy-defined': 'Défini par la stratégie',
        Quarterly: 'Trimestriel',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'Procédure administrative QĐ 778/QĐ-BCA-A05',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': "objectif de contrôle interne (Loi [[TOK_0]] Art. 24(2)(b), 41(5) — calendrier exact en attendant l'instrument de mise en œuvre)",
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': "objectif du contrôle interne (Loi [[TOK_0]] Art. 41(3) — calendrier exact en attendant l'instrument de mise en œuvre)",
        'source verification pending': 'vérification de la source en attente',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C) [FR]',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A) [FR]",
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A) [FR]',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A) [FR]',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D) [FR]',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D) [FR]',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D) [FR]',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B) [FR]',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A) [FR]',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Circular 83/2025/TT-NHNN — Internal Audit Governance [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D) [FR]',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Circular 83/2025/TT-NHNN — Management Information System (Layer 4) [FR]',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3) [FR]',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Circular 83/2025/TT-NHNN — Outsourcing Controls [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G) [FR]',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01 [FR]',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5) [FR]',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1) [FR]',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C) [FR]',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A) [FR]',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E) [FR]',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01 [FR]',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A) [FR]',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F) [FR]',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B) [FR]',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2) [FR]',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D) [FR]',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội (Assemblée nationale)',
        'Ministry of Public Security / A05 Department': 'Ministère de la Sécurité Publique / Département A05',
        'Ministry of Public Security': 'Ministère de la Sécurité Publique',
        'Ministry of Information and Communications': "Ministère de l'Information et des Communications",
        'Government of Vietnam': 'Gouvernement du Vietnam',
        'European Data Protection Board (EDPB)': 'Comité européen de la protection des données (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / CSIRT nationaux',
        'State Bank of Vietnam': "Banque d'État du Vietnam",
    },
    tour_titles: {
        access_accountability: 'Visite guidée de la responsabilité d’accès',
        assessments: 'Visite des évaluations',
        audit_trail: "Visite de la piste d'audit",
        classification: 'Tournée de classement',
        compliance_forms: 'Visite guidée des formulaires de conformité',
        connectors: 'Visite des connecteurs',
        consent_properties: 'Visite guidée des propriétés du consentement',
        consent: 'Visite guidée du consentement',
        dashboard: 'Visite du tableau de bord',
        data_mapping: 'Visite de cartographie des données',
        data_subjects: 'Visite des personnes concernées',
        deletion_orchestration: "Visite guidée de l'orchestration des suppressions",
        discovery: 'Circuit découverte',
        governance: 'Visite de la gouvernance',
        help_center: "Visite guidée du centre d'aide",
        incident_ops: "Visite des opérations en cas d'incident",
        incidents: 'Visite des incidents',
        localization: 'Visite de localisation',
        monitoring: 'Visite de surveillance',
        onboarding: "Visite d'intégration",
        organizations: 'Visite des organisations',
        partner_workspace: "Visite de l'espace de travail des partenaires",
        platform_settings: 'Visite guidée des paramètres de la plateforme',
        privacy_scanner: 'Visite guidée du scanner de confidentialité',
        program_governance: 'Visite de la gouvernance du programme',
        rights_requests: 'Visite des demandes de droits',
        task_management: 'Visite guidée de la gestion des tâches',
        vendor_risk: 'Visite guidée des risques liés aux fournisseurs',
    },
    tour_descriptions: {
        access_accountability: "En tant que responsable de l'audit interne (P-VN-10), examiner les preuves d'accès, auditer l'utilisation des autorisations et enquêter sur les modèles anormaux pour démontrer l'intégrité et la confidentialité de l'[[TOK_0]] Article 5(1)(f).",
        assessments: "En tant qu'entreprise [[TOK_1]] (P-VN-01), mener des DPIA conformément au décret 356 Mau so 02a, identifier les lacunes en matière de conformité et évaluer les risques de transfert transfrontalier en vertu de [[TOK_0]].",
        audit_trail: "En tant que responsable de l'audit interne (P-VN-10), interrogez les preuves inter-modules, assemblez des packs d'audit et exportez des journaux inviolables pour les soumissions réglementaires.",
        classification: 'En tant que Data Steward (P-VN-05), définissez les taxonomies de classification des données, attribuez des étiquettes de sensibilité, appliquez les politiques de conservation et résolvez les écarts de couverture requis pour la conformité de [[TOK_0]].',
        compliance_forms: "En tant qu'Entreprise [[TOK_0]] (P-VN-01), parcourez, complétez et soumettez les formulaires réglementaires vietnamiens officiels, notamment les modèles Phu luc I, Phu luc II et Mau so pour les dépôts auprès du Comité PDP.",
        connectors: "En tant que responsable des systèmes informatiques (P-VN-05), capturez les exigences commerciales pour les intégrations, mappez les connecteurs aux flux de données de conformité et vérifiez l'état de préparation du POC avant la mise en ligne.",
        consent_properties: "En tant qu'entreprise [[TOK_1]] (P-VN-01), configurez le déploiement de [[TOK_2]] : enregistrement de la propriété numérique, modèles dorés pour des bannières de consentement [[TOK_0]] cohérentes et matrices de liaison qui lient les propriétés aux activités de traitement.",
        consent: "En tant qu'entreprise [[TOK_1]] (P-VN-01), gérez le cycle de vie de la politique de consentement : définissez les objectifs de collecte, appliquez les droits de retrait de [[TOK_0]] et intégrez-les à votre plateforme de gestion du consentement.",
        dashboard: "En tant qu'entreprise [[TOK_1]] (P-VN-01), orientez-vous autour du centre de commande de posture de conformité qui fait apparaître les délais [[TOK_0]], les violations des SLA et les KPI de préparation à l'audit.",
        data_mapping: 'En tant que Data Steward (P-VN-05), construisez votre inventaire ROPA, cartographiez les flux de données transfrontaliers et maintenez le registre des activités de traitement requis par [[TOK_0]].',
        data_subjects: "En tant que responsable de la conformité de l'entreprise DPO ou de l'éducation, gérez les profils unifiés des personnes concernées qui relient les enregistrements de consentement, les demandes de droits et l'activité chronologique sur l'ensemble de la plateforme.",
        deletion_orchestration: "En tant que [[TOK_1]] (P-VN-01), vérifiez la suppression des données de bout en bout dans les systèmes internes et les fournisseurs tiers, avec des chaînes de preuve cryptographiques pour la conformité à l'article 17 du droit à l'effacement de [[TOK_0]].",
        discovery: "En tant que Data Steward (P-VN-05), exécutez des analyses automatisées pour découvrir des données personnelles sur les systèmes connectés, examinez les résultats par étapes et alimentez les résultats dans le module de classification pour l'étiquetage [[TOK_0]].",
        governance: 'En tant que gestionnaire des risques des fournisseurs (P-VN-08), maintenir le registre des fournisseurs, suivre les chaînes de sous-traitants, évaluer les risques de transfert transfrontalier et appliquer les manuels de gouvernance sous [[TOK_0]].',
        help_center: 'Pour tous les acteurs (DPD, auditeurs, responsables informatiques et responsables de la conformité), trouvez des réponses, des guides pratiques et une documentation spécifique aux modules pour prendre en charge vos flux de travail de conformité quotidiens.',
        incident_ops: "En tant que commandant de l'incident (P-VN-09), activez les playbooks de réponse, suivez la conformité de [[TOK_1]] par rapport à la fenêtre de notification de 72 heures [[TOK_0]], gérez les escalades et coordonnez la réponse des fournisseurs.",
        incidents: "En tant que commandant des incidents (P-VN-09), détecter et signaler les violations de données avec des obligations de notification [[TOK_0]] dans les 72 heures au comité PDP, trier par gravité et constituer des dossiers d'incidents de niveau audit.",
        localization: "En tant qu'entreprise [[TOK_1]] (P-VN-01), gérer le cycle de vie du cadre réglementaire : installer les packs du marché vietnamien, activer les cadres [[TOK_0]] et le décret 13, mapper les exigences aux modules de la plateforme et gérer les traductions.",
        monitoring: "En tant qu'entreprise [[TOK_1]] (P-VN-01), établissez des programmes continus de surveillance de la conformité, suivez les modifications réglementaires, mesurez les KPI et gérez les cas d'interaction réglementaire sous [[TOK_0]].",
        onboarding: "En tant que formateur en conformité (P-VN-02), dispensez une formation via des visites guidées, chargez des exemples de données réalistes pour des exercices pratiques et exécutez l'assistant de configuration pour des scénarios de démarrage rapide.",
        organizations: "En tant que [[TOK_0]] (P-VN-01), configurez des structures de conformité multi-organisations, établissez des hiérarchies de services et acheminez les demandes des personnes concernées au sein de votre groupe d'entreprise.",
        partner_workspace: 'En tant que responsable de compte partenaire, intégrez les organisations partenaires, configurez les niveaux de service, suivez les livrables de conformité et gérez le marché des partenaires.',
        platform_settings: "En tant qu'administrateur de plateforme, gérez toute la configuration opérationnelle : identité, sécurité, intégrations et accès aux modules qui sous-tendent votre programme de conformité.",
        privacy_scanner: "En tant qu'analyste de la confidentialité (P-VN-06), exécutez des analyses de surveillance continue pour détecter les violations du consentement aux cookies, les trackers non autorisés et les lacunes des politiques, générant ainsi des preuves de la conformité de l'ePrivacy et de [[TOK_0]].",
        program_governance: 'Naviguez entre les modèles de maturité, les évaluations, les lacunes en matière de données probantes, les résumés exécutifs, et bien plus encore. Chaque sous-module contribue à une vue holistique de la santé interne de votre programme.',
        rights_requests: "En tant qu'entreprise [[TOK_1]] (P-VN-01), gérez les demandes de droits des personnes concernées sous [[TOK_0]] avec des délais légaux de 15 jours, une vérification d'identité et des pistes de résolution de niveau audit.",
        task_management: 'Acheminez les tâches de conformité entre les personnages, suivez les délais [[TOK_0]] et automatisez les flux de travail qui responsabilisent votre équipe.',
        vendor_risk: 'En tant que gestionnaire des risques des fournisseurs (P-VN-08), évaluez les risques liés aux tiers, appliquez les examens de contrôle et déclenchez des réévaluations - distincts de la gouvernance du programme, qui suit votre maturité interne.',
    },
    consolidation: {
        title: 'Dossiers de consolidation',
        new_case: 'Créer un dossier de consolidation',
        case_count: 'case',
        created: 'Dossier de consolidation créé',
        create: 'Créer un cas',
        creating: 'Création...',
        cancel: 'Annuler',
        no_cases: 'Aucun cas de consolidation trouvé.',
        all_statuses: 'Tous les statuts',
        all_purposes: 'Tous usages',
        filter_status: 'Filtrer par statut',
        filter_purpose: 'Filtrer par objectif',
        col_title: 'Titre',
        col_purpose: 'Objectif',
        col_status: 'Statut',
        col_progress: 'Progrès',
        col_deadline: 'Date limite',
        col_department: 'Département',
        col_version: 'Version',
        col_evidence: 'Preuve',
        sections_accepted: 'accepted',
        prev: 'Précédent',
        next: 'Suivant',
        page: 'Pages',
        prev_page: 'Page précédente',
        next_page: 'Page suivante',
        field_title: 'Titre',
        field_purpose: 'Objectif',
        field_framework: 'Code-cadre',
        field_deadline: 'Date limite',
        field_reviewer: 'ID utilisateur du réviseur',
        title_placeholder: 'Entrez le titre du cas',
        framework_placeholder: 'par exemple, PDPD-2023',
        reviewer_placeholder: "Saisir l'ID utilisateur du réviseur",
        purposes: {
            dpia_filing: '[[TOK_0]] Dépôt',
            cross_border_filing: 'Dépôt transfrontalier',
            annual_governance_attestation: 'Attestation annuelle de gouvernance',
            breach_package: 'Forfait infraction',
            audit_inspection_pack: "Pack d'inspection d'audit",
        },
        statuses: {
            draft: 'Brouillon',
            collecting: 'Collecte',
            consolidating: 'Consolidation',
            review: 'Examen',
            corrections: 'Corrections',
            pending_approval: "En attente d'approbation",
            approved: 'Approuvé',
            completed: 'Terminé',
            closed: 'Fermé',
            rejected: 'Rejeté',
        },
        section_statuses: {
            pending: 'En attente',
            in_progress: 'En cours',
            submitted: 'Soumis',
            accepted: 'Accepté',
            needs_correction: "Besoin d'une correction",
            corrected: 'Corrigé',
        },
        flag_types: {
            missing_section: 'Section manquante',
            conflicting_entry: 'Entrée conflictuelle',
            stale_entry: 'Entrée périmée',
            missing_evidence: 'Preuve manquante',
            incomplete_data: 'Données incomplètes',
            duplicate_entry: 'Entrée en double',
        },
        flag_severities: {
            critical: 'Critique',
            warning: 'Avertissement',
            info: 'Informations',
        },
        sections_title: 'Sections',
        no_sections: "Aucune section attribuée pour l'instant.",
        flags_title: 'Drapeaux',
        no_flags: 'Aucun indicateur détecté.',
        open: 'open',
        approval_chain: "Chaîne d'approbation",
        pending: 'En attente',
        audit_trail: "Piste d'audit",
        no_audit: "Aucun événement d'audit.",
        auto_assign: 'Attribution automatique des sections',
        start_collection: 'Commencer la collecte',
        review_case: 'Cas de révision',
        generate_export: 'Générer une exportation',
        review_title: 'Revue de consolidation',
        advance_approval: "Avancer jusqu'à l'approbation",
        back_to_case: 'Retour au cas',
        accept: 'Accepter',
        return_section: 'Retour',
        return_comment: 'Retourner le commentaire...',
        resolve: 'Résoudre',
        dismiss: 'Rejeter',
        resolution_notes: 'Notes de résolution...',
        notes: 'Remarques',
        section_accepted: 'Section acceptée',
        section_returned: 'Section renvoyée pour correction',
        advanced_to_approval: "Dossier avancé en attente d'approbation",
        section_data: 'Données de section',
        save_progress: 'Enregistrer la progression',
        submit_section: 'Soumettre la section',
        submitting: 'Envoi...',
        resubmit: 'Soumettre à nouveau',
        progress_saved: 'Progrès enregistré',
        section_submitted: 'Section soumise',
        correction_required: 'Correction requise',
        evidence_title: 'Preuve',
        no_evidence: 'Aucune preuve jointe.',
        add_evidence: 'Ajouter des preuves',
        evidence_added: 'Preuve ajoutée',
        evidence_files: 'dossiers de preuves',
        uploaded_by: 'téléchargé par',
        comments_title: 'Commentaires',
        no_comments: 'Pas encore de commentaires.',
        comment_placeholder: 'Ajouter un commentaire...',
        add_comment: 'Ajouter un commentaire',
        comment_added: 'Commentaire ajouté',
        view_data: 'Afficher les données soumises',
        export_title: 'Exportation de dossiers',
        export_generated: "Package d'exportation généré",
        regenerate: 'Régénérer',
        regenerating: 'Régénérant...',
        generated_at: 'Généré à',
        artifacts_title: 'Exporter des artefacts',
        artifact_type: 'Artefact',
        file_name: 'Nom du fichier',
        file_size: 'Taille',
        generated: 'Généré',
        download: 'Télécharger',
        artifacts: {
            master_report: 'Rapport principal',
            evidence_bundle: 'Ensemble de preuves (ZIP)',
            contributor_lineage: 'Lignée des contributeurs',
            conflict_resolution: 'Résolution des conflits',
            approval_history: 'Historique des approbations',
        },
        official_forms: 'Formulaires officiels',
        forms_description: 'Les formulaires officiels suivants peuvent être générés à partir des données consolidées. Les formulaires officiels sont distincts des documents de travail internes.',
        announce_loaded_cases: 'Cas de consolidation [[TOK_1]] chargés',
        announce_case_detail_loaded: 'Détails du dossier chargés',
        announce_case_transitioned: 'Requête transférée vers [[TOK_1]]',
        announce_flag_resolved: 'Indicateur résolu',
        announce_flag_dismissed: 'Drapeau rejeté',
        case_detail_loaded: 'Détails du dossier chargés',
        sections_auto_assigned: 'Sections attribuées automatiquement à partir de la hiérarchie des départements',
        errors: {
            load_failed: 'Échec du chargement des données. Veuillez réessayer.',
            create_failed: 'Échec de la création du dossier. Veuillez réessayer.',
            required_fields: 'Veuillez remplir tous les champs obligatoires.',
            not_found: 'Pas trouvé.',
            comment_required: 'Un commentaire est requis lors du retour d’une section.',
            notes_required: 'Des notes sont requises lors de la résolution ou du rejet d’un signalement.',
        },
    },
    rights_requests: {
        import: {
            title: 'Importer des dossiers',
            nav_title: 'Import en masse',
            description: 'Téléversez un fichier CSV pour importer en masse les dossiers de demande de droits.',
            select_file: 'Sélectionner le fichier CSV',
            file_help: 'CSV avec des en-têtes correspondant aux champs de dossier.',
            file_too_large: 'Fichier trop volumineux. La taille maximale est de 2 Mo.',
            preview: 'Aperçu',
            columns_detected: 'Colonnes détectées : {count}',
            column_mapping: 'Correspondance des colonnes',
            import_button: 'Importer',
            import_complete: 'Import terminé',
            import_error: "L'import a échoué",
            result: "Résultat de l'import",
            total: 'Total',
            imported: 'Importé',
            skipped: 'Ignoré',
            failed: 'Échoué',
            errors: 'Erreurs',
            error_row: 'Ligne',
            error_field: 'Champ',
            error_message: 'Message',
            history: "Historique d'import",
            no_history: "Aucun historique d'import.",
            history_file: 'Nom de fichier',
            history_date: 'Date',
        },
        batch: {
            nav_title: 'Processus par lots',
            page_title: 'Processus par lots DSR',
            page_subtitle: "Téléchargez un [[TOK_1]] de DSR en attente. Forseti rédige une réponse d'accusé de réception par demande et met en file d'attente une tâche de vérification par ligne. Le [[TOK_0]] examine + accepte chacun avant l'envoi.",
            upload_heading: 'Télécharger',
            csv_hint: 'Colonnes obligatoires : request_id, requester_email, request_type. Facultatif : date limite (ISO-8601), notes.',
            rows_heading: '[[TOK_1]] lignes analysées',
            submit_label: 'Exécuter un lot',
            submitting: 'Rédaction…',
            col_request_id: 'Identifiant de la demande',
            col_email: 'E-mail du demandeur',
            col_type: 'Tapez',
            col_status: 'Statut',
            col_actions: 'Actions',
            status_queued: "En file d'attente",
            status_drafted: 'Rédigé',
            status_failed: 'Échec',
            status_accepted: 'Accepté',
            status_rejected: 'Rejeté',
            'status_parsing-error': "Erreur d'analyse",
            accept: 'Accepter',
            reject: 'Rejeter',
            permission_denied: "Vous n'êtes pas autorisé à exécuter les workflows Forseti.",
        },
    },
    assessment_triggers: {
        title: 'Déclencheurs d’évaluation',
        subtitle: "Configurez la création automatisée d'évaluations et les notifications [[TOK_0]] pour les workflows de confidentialité.",
        auto_create_dpia_label: "Créer automatiquement [[TOK_0]] lors du traitement d'une activité marquée comme [[TOK_1]] requise",
        auto_notify_new_purpose_label: "Notifier automatiquement [[TOK_0]] lorsqu'un nouvel objectif est créé avec des catégories de données sensibles",
        auto_notify_cross_border_label: "Notifier automatiquement [[TOK_0]] lorsqu'un transfert transfrontalier est ajouté à l'activité de traitement",
        default_dpo_label: 'Par défaut [[TOK_0]]',
        default_dpo_placeholder: 'Sélectionnez [[TOK_0]] par défaut...',
        notification_channels_label: 'Canaux de notification',
        channel_in_app: "Dans l'application",
        channel_email: 'Email',
        save_success: 'Paramètres de déclenchement d’évaluation enregistrés.',
        save_error: "Échec de l'enregistrement des paramètres du déclencheur d'évaluation.",
        fetch_error: "Échec du chargement des paramètres du déclencheur d'évaluation.",
        fetch_users_error: 'Échec du chargement des utilisateurs.',
        announce_loaded: "Paramètres de déclenchement d'évaluation chargés",
        dpia_status: '[[TOK_0]] Statut',
        dpia_linked: '[[TOK_0]] Lié',
        dpia_required_no_dpia: '[[TOK_0]] Obligatoire — Non créé',
        create_dpia: 'Créer [[TOK_0]]',
        create_dpia_success: "[[TOK_0]] créé et lié à l'activité.",
        create_dpia_error: "Échec de la création de [[TOK_0]] pour l'activité.",
        view_dpia: 'Afficher [[TOK_0]]',
    },
    data_subjects: {
        title: 'Profils des personnes concernées',
        nav_title: 'Personnes concernées',
        nav: {
            profiles: 'Profils',
        },
        create: 'Créer un profil',
        edit: 'Modifier le profil',
        delete: 'Supprimer le profil',
        delete_confirm: 'Êtes-vous sûr de vouloir supprimer ce profil de personne concernée ?',
        display_name: "Nom d'affichage",
        email: 'Email',
        phone: 'Téléphone',
        employee_id: "ID d'employé",
        student_id: "Carte d'étudiant",
        notes: 'Remarques',
        external_refs: 'Références externes',
        cases_count: 'Cas',
        workflows_count: 'Dossiers de consentement',
        last_activity: 'Dernière activité',
        timeline: 'Chronologie',
        link_case: 'Link Case',
        link_workflow: 'Link Workflow',
        no_profiles: 'Aucun profil de personne concernée trouvé.',
        search_placeholder: 'Recherchez par nom, email, téléphone ou identifiant...',
        create_success: 'Profil de la personne concernée créé.',
        create_error: 'Échec de la création du profil de la personne concernée.',
        update_success: 'Profil de la personne concernée mis à jour.',
        update_error: 'Échec de la mise à jour du profil de la personne concernée.',
        delete_success: 'Profil de la personne concernée supprimé.',
        delete_error: 'Échec de la suppression du profil de la personne concernée.',
        link_case_success: 'Cas lié au profil.',
        link_case_error: 'Échec de la liaison du dossier au profil.',
        link_workflow_success: 'Workflow lié au profil.',
        link_workflow_error: 'Échec de la liaison du flux de travail au profil.',
        load_error: 'Échec du chargement des profils des personnes concernées.',
        detail_load_error: 'Échec du chargement du profil de la personne concernée.',
        timeline_load_error: 'Échec du chargement de la chronologie.',
        tab_cases: 'Cas DSR',
        tab_consent: 'Dossiers de consentement',
        tab_timeline: 'Chronologie',
        tab_consent_workflows: 'Flux de travail de consentement',
        tab_web_consent: '[[TOK_0]] Consentement',
        web_consent_empty: 'Aucun enregistrement de consentement [[TOK_0]] trouvé pour ce sujet.',
        web_consent_load_error: 'Échec du chargement de [[TOK_0]] enregistrements de consentement.',
        col_policy_version: 'Version de la politique',
        col_versions: 'Versions',
        col_consent_version: 'Consentement',
        col_cookie_declaration_version: 'Déclaration relative aux cookies',
        col_purposes: 'Objectifs',
        purpose_granted: 'Accordé',
        purpose_denied: 'Refusé',
        granted_domains: 'Accordé',
        denied_domains: 'Refusé',
        col_action: 'Action',
        col_timestamp: 'Horodatage',
        col_domain: 'Domaine',
        no_cases: 'Aucun cas lié.',
        no_workflows: 'Aucun workflow de consentement lié.',
        no_timeline: 'Aucun événement chronologique.',
        case_id: 'Numéro de cas',
        case_status: 'Statut',
        case_type: 'Type de demande',
        case_created: 'Créé',
        workflow_id: 'ID de flux de travail',
        workflow_type: 'Tapez',
        workflow_status: 'Statut',
        workflow_created: 'Créé',
        timeline_date: 'Date',
        timeline_event: 'Événement',
        timeline_details: 'Détails',
        timeline_time: 'Temps',
        timeline_type: 'Tapez',
        timeline_summary: 'Résumé',
        type_case: 'Cas DSR',
        type_consent_workflow: 'Flux de travail de consentement',
        profile_info: 'Informations sur le profil',
        announce_loaded: 'Profils de personnes concernées chargés',
        announce_detail_loaded: 'Profil de la personne concernée chargé',
        select_case: '— Sélectionner un dossier —',
        select_workflow: '— Sélectionner un flux de travail —',
        no_cases_hint: 'Liez des cas pour les voir ici.',
        no_workflows_hint: 'Liez des flux de consentement pour les voir ici.',
    },
    flows: {
        map: {
            description_prefix: '{systems} systèmes · {flows} flux · {crossBorder} transferts hors UE · {highRisk} risque élevé/critique',
            switch_to_list: 'Passer à la vue liste',
            switch_to_list_aria: 'Passer à la vue tableau',
            svg_aria: 'Carte des flux de données : {systems} systèmes, {flows} flux, {crossBorder} transferts hors UE',
            selected_system: 'Système sélectionné',
            drill_hint: 'Ouvrez l’onglet « Liste » pour modifier les flux, AIPD et affectations de fournisseurs liés à ce système.',
        },
    },
    packages: {
        light: {
            name: 'Lumière',
            description: 'Outils essentiels de conformité à la confidentialité pour les petites équipes',
        },
        standard: {
            name: 'Norme',
            description: 'Plateforme de conformité complète pour les organisations en croissance',
        },
        enterprise_unlimited: {
            name: 'Entreprise illimitée',
            description: 'Conformité de niveau entreprise avec prise en charge multi-organisations et services dédiés',
        },
    },
    forseti: {
        providerSettings: {
            title: 'Forseti [[TOK_0]] Paramètres du fournisseur',
            subtitle: 'Configurez le fournisseur Claude pour le conseiller juridique Forseti [[TOK_0]].',
            healthHeading: 'Santé du prestataire',
            statusLabel: 'Statut',
            statusOk: "D'accord",
            statusFailed: 'Indisponible',
            providerLabel: 'Fournisseur',
            providerClaudeApi: 'Claude [[TOK_0]]',
            providerCliRelay: 'Relais Claude CLI',
            providerAesirManaged: 'Jetons gérés par Aesir',
            lastCheckedLabel: 'Dernière vérification',
            reasonLabel: 'Raison',
            refreshButton: 'Actualiser',
            apiKeyHeading: 'Claude [[TOK_0]] clé',
            apiKeyHint: "La définition d'une touche [[TOK_0]] active le mode Claude [[TOK_1]]. Laissez non défini pour utiliser le relais CLI local (mode développeur/auto-hébergé).",
            apiKeyLabel: 'Touche [[TOK_0]]',
            apiKeyMinLength: 'Minimum 32 caractères. Chiffré au repos ; jamais montré à nouveau.',
            apiKeyTooShort: 'La clé [[TOK_0]] doit comporter au moins 32 caractères.',
            apiKeySaved: 'Clé [[TOK_0]] enregistrée. Une santé rafraîchissante…',
            apiKeyCleared: 'Touche [[TOK_0]] effacée. Forseti utilise désormais le relais CLI local.',
            setKeyButton: 'Enregistrer la clé [[TOK_0]]',
            clearKeyButton: 'Effacer la touche [[TOK_0]] (utiliser le relais CLI)',
        },
        usage: {
            title: 'Utilisation',
            subtitle: 'Consommation de jetons et état du compartiment pour cette organisation.',
            bucketHeading: 'Bucket de jetons mensuel',
            remainingLabel: 'Restant',
            consumedLabel: 'Consommé',
            totalLabel: 'Total',
            unitsLabel: 'unités facturables',
            lastReconciledLabel: 'Dernier rapprochement',
            recentHeading: 'Activité récente',
            historyHeading: '12 dernières périodes',
            noActivity: "Aucune activité pour l'instant cette période.",
            featureLabel: 'Caractéristique',
            whenLabel: 'Quand',
            periodLabel: 'Période',
            topUpButton: 'Demander un forfait de recharge',
            topUpHint: 'Contactez votre responsable de compte pour demander un forfait de recharge.',
            buyMore: {
                buyButton: "Acheter plus d'unités",
                purchaseTitle: "Acheter plus d'unités de facturation",
                purchaseSubtitle: 'Choisissez un forfait. Vous serez redirigé vers le paiement sécurisé Stripe, et votre facture vous parviendra par e-mail.',
                packageLabel: 'Forfait',
                optionTemplate: '{name} — {units} {units_label} — {price}',
                packageSmall: 'Petit',
                packageMedium: 'Moyen',
                packageLarge: 'Grand',
                checkoutButton: 'Continuer vers le paiement',
                checkoutPending: 'Ouverture du paiement…',
                cancelButton: 'Annuler',
                purchaseError: 'Impossible de démarrer le paiement. Veuillez réessayer sous peu.',
                redeemTitle: 'Utiliser une facture',
                redeemSubtitle: 'Déjà payé ? Sélectionnez le forfait que vous avez acheté et saisissez le numéro de facture indiqué dans votre e-mail pour ajouter les unités.',
                invoiceLabel: 'Numéro de facture',
                invoicePlaceholder: 'JJVExxxX-0001',
                redeemButton: 'Utiliser',
                redeemPending: 'Utilisation en cours…',
                redeemSuccess: 'Unités ajoutées à votre compartiment.',
                redeemAlready: 'Cette facture a déjà été utilisée.',
                errorNotFound: "Aucune facture n'a été trouvée avec ce numéro. Vérifiez le numéro de facture et réessayez.",
                errorNotPaid: "Cette facture n'est pas encore marquée comme payée.",
                errorOrgMismatch: "Cette facture n'a pas été émise pour votre organisation.",
                errorPackageMismatch: 'Cette facture ne correspond pas au forfait sélectionné.',
                errorInvalidInvoice: 'Saisissez un numéro de facture valide.',
                errorGeneric: "L'utilisation a échoué. Veuillez réessayer sous peu.",
            },
            byFeatureHeading: 'Ce mois-ci par fonctionnalité',
            byFeatureEmpty: "Aucune activité de fonctionnalité pour l'instant cette période.",
            featureColumn: 'Caractéristique',
            featureUnitsColumn: 'Unités',
            featureRunsColumn: 'Fonctionne',
            byUserHeading: 'Ce mois-ci par utilisateur (vue administrateur)',
            byUserEmpty: "Aucune activité par utilisateur pour l'instant cette période.",
            userColumn: 'Utilisateur',
            reconciliationLinkLabel: 'Afficher le rapport de dérive de rapprochement',
            reconciliationLinkHint: 'Administrateur interne à Aesir uniquement.',
            featureLabels: {
                chat: 'Discuter',
                workflow: 'Exécution du flux de travail',
                tabular: 'Extraction tabulaire',
                redline: 'Examen de la ligne rouge',
                title: 'Titre de la conversation',
                unknown: 'Autre',
            },
        },
        reconciliation: {
            title: 'Rapprochement des quotas Forseti',
            subtitle: "Dérivez entre le cache rapide du compteur de quotas et le grand livre de facturation faisant autorité. Le réconciliateur s'exécute toutes les 5 minutes ; cette page présente la dernière exécution et l'historique. Administrateur interne à Aesir uniquement.",
            backLink: "Retour à l'utilisation de Forseti",
            stubHeading: "L'histoire de la réconciliation sera bientôt disponible",
            stubBody: "Les journaux du réconciliateur dérivent via le canal de journalisation structuré. Un point de terminaison de lecture back-end qui expose les 30 dernières exécutions de réconciliation est en cours de portée (différé du Sprint 47.5.9.6 — voir fichier de travail). Une fois le point final atterri, cette page affichera le tableau de l'historique d'exécution + la bannière de dérive P0.",
            stubBackendOwner: 'Différé du backend : persister les exécutions de réconciliation dans une nouvelle collection + ajouter la route `GET /llm-relay/quota/reconciliation`.',
            permissionDenied: "Cette page est réservée aux administrateurs internes d'Aesir. Si vous pensez que vous devriez avoir accès, contactez votre représentant [[TOK_0]].",
        },
        projects: {
            title: 'Projets',
            subtitle: 'Espaces de travail pour les documents, les conversations, les flux de travail et les révisions.',
            modeLabel: 'Voir',
            tabMine: 'Mes projets',
            tabShared: 'Partagé avec moi',
            searchLabel: 'Rechercher des projets',
            searchPlaceholder: 'Rechercher…',
            newButton: 'Nouveau projet',
            colName: 'Nom',
            colVisibility: 'Visibilité',
            colDocs: 'Documents',
            colMembers: 'Membres',
            colUpdated: 'Mis à jour',
            visibilityOwn: 'Posséder uniquement',
            visibilityShared: 'Partagé',
            emptyMine: "Aucun projet pour l'instant. Créez-en un pour commencer.",
            emptyShared: "Aucun projet n'a été partagé avec vous.",
            pageHint: 'Affichage de [[TOK_2]] sur [[TOK_3]].',
            createTitle: 'Nouveau projet',
            createSubmit: 'Créer un projet',
            fieldName: 'Nom',
            fieldDescription: 'Description (facultatif)',
            fieldCmNumber: 'Numéro de dossier/affaire (facultatif)',
            fieldVisibility: 'Visibilité',
            errorNameRequired: 'Le nom est requis.',
            errorSelectorRequired: 'Sélectionnez un utilisateur ou un groupe organisationnel à ajouter.',
            renameButton: 'Renommer',
            renamePrompt: 'Renommer le projet',
            deleteButton: 'Supprimer',
            deleteConfirm: 'Supprimer ce projet ? Il sera conservé pendant 30 jours avant sa suppression définitive.',
            deleteFolderConfirm: "Supprimer ce dossier ? Les documents à l'intérieur resteront dans le projet, mais non classés.",
            removeMemberConfirm: 'Supprimer ce membre ?',
            foldersHeading: 'Dossiers',
            foldersEmpty: "Aucun dossier pour l'instant.",
            addFolderButton: 'Nouveau dossier',
            addFolderTitle: 'Nouveau dossier',
            documentsHeading: 'Documents',
            documentsEmpty: "Aucun document joint pour l'instant.",
            colFilename: 'Nom du fichier',
            colAdded: 'Ajouté',
            unattachButton: 'Détacher',
            membersHeading: 'Membres',
            membersEmpty: 'Propriétaire uniquement.',
            addMemberButton: 'Ajouter un membre',
            addMemberTitle: 'Ajouter un membre',
            addMemberSubmit: 'Ajouter un membre',
            colMember: 'Membre',
            colRole: 'Rôle',
            selectorTypeLabel: 'Ajouter par',
            selectorUser: 'Identifiant utilisateur',
            selectorGroup: 'ID du groupe organisationnel',
            fieldUserId: 'Utilisateur',
            fieldGroupId: 'Groupe organisationnel',
            fieldRole: 'Rôle',
            roleAdmin: 'Administrateur',
            roleEditor: 'Éditeur',
            roleViewer: 'Visionneuse',
            notFound: 'Projet introuvable.',
            selectUserPlaceholder: 'Sélectionnez un utilisateur…',
            selectGroupPlaceholder: 'Sélectionnez un groupe organisationnel…',
            noUsersAvailable: 'Aucun utilisateur disponible.',
            noGroupsAvailable: 'Aucun groupe organisationnel disponible.',
            loadFailed: 'Échec du chargement des options.',
            deleteProjectTitle: 'Supprimer le projet ?',
            deleteFolderTitle: 'Supprimer le dossier ?',
            removeMemberTitle: 'Supprimer un membre ?',
            removeMemberConfirmGeneric: 'Supprimer ce membre du projet ?',
            addDocumentButton: 'Ajouter un document',
            addDocumentTitle: 'Ajouter un document au projet',
            fieldDocument: 'Sélectionner un document',
            selectDocPlaceholder: 'Rechercher un document...',
            ownerLabel: 'Propriétaire du système',
        },
        chat: {
            sidebarLabel: 'Discussions',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Votre [[TOK_0]] Conseiller juridique et conformité — fondé sur vos données de locataire et vos packs réglementaires installés.',
            personaSelectorLabel: 'Personnalité',
            personaHeading: 'Choisissez un personnage',
            startChatButton: 'Démarrer une nouvelle discussion',
            startingChat: 'Démarrage du chat…',
            recentHeading: 'Discussions récentes',
            recentEmpty: 'Pas encore de chat – démarrez-en un ci-dessus.',
            untitledChat: 'Nouvelle discussion',
            messageListLabel: 'Conversation',
            detailSubtitle: 'Personnage : [[TOK_1]]',
            composeHeading: 'Envoyer un message',
            composeLabel: 'Message Forseti',
            composeDisabledPlaceholder: "La composition du message arrive dans le prochain sprint (47.5.4b — Streaming SSE + boucle d'appel d'outil).",
            composeDisabledHint: 'Aperçu en lecture seule livré dans la version 47.5.4a. Les appels d’outils Streaming + atterrissent en 47.5.4b.',
            switchPersonaHeading: 'Personnalité',
            presetPersona: 'Personnalité prédéfinie',
            changePersona: 'Changer de personnalité',
            hidePersonaOptions: 'Masquer les options de personnalité',
            starterHeading: 'Commencez par l’une de ces actions',
            renameButton: 'Renommer',
            renamePrompt: 'Renommer la discussion',
            deleteButton: 'Supprimer',
            deleteConfirm: 'Supprimer cette discussion ? Il sera conservé pendant 30 jours avant sa suppression définitive.',
            notFound: 'Chat introuvable.',
            emptyChat: "Aucun message pour l'instant : dites bonjour pour démarrer une conversation.",
            roleUser: 'Vous',
            roleAssistant: 'Forseti',
            roleSystem: 'Système',
            thinkingLabel: 'Penser',
            toolCallPlaceholder: "Appel d'outil : ",
            toolResultPlaceholder: "Résultat de l'outil masqué : l'interface utilisateur complète arrive dans 47.5.4b.",
            docEditPlaceholder: 'Modifications du document proposées (V[[TOK_1]]).',
            disclaimer: 'Forseti soutient votre jugement – il ne remplace pas un avocat agréé.',
            sendButton: 'Envoyer',
            sending: 'Envoi…',
            composePlaceholder: 'Demandez à Forseti…',
            composingPlaceholder: 'Forseti répond…',
            streamingPlaceholder: 'Forseti tape…',
            promptInjectionTitle: 'Forseti a laissé tomber quelques jetons de contrôle.',
            promptInjectionBody: 'Motifs dépouillés : [[TOK_1]]. Forseti ne verra que le texte de votre message.',
            promptInjectionInline: 'Forseti a supprimé les jetons de contrôle ([[TOK_1]]) de votre message.',
            rateLimitTitle: 'Vous envoyez des messages trop vite.',
            rateLimitRetryAfter: 'Réessayez dans [[TOK_1]]s.',
            counselReviewTitle: 'Forseti est incertain ici.',
            counselReviewBody: 'Confirmez auprès d’un avocat agréé avant de donner suite à cette réponse.',
            legalConclusionRefused: "Forseti a refusé de formuler une conclusion juridique sans fondement. Essayez d'abord search_regulatory ou contactez un conseiller.",
            toolCallDone: 'Terminé.',
            toolCallArgsLabel: 'Arguments',
            toolCallResultLabel: 'Résultat',
            toolResultLogged: "Résultat de l'outil capturé dans le journal d'audit.",
            toolResultAria: "résultat de l'outil",
            documentEditAria: 'modification de documents',
            createTaskFromMessage: 'Créer une tâche à partir de ceci',
            createTaskHeading: 'Créer une tâche à partir de ce message',
            createTaskTitleLabel: 'Titre',
            createTaskTitleRequired: 'Le titre est requis.',
            createTaskDescriptionLabel: 'Descriptif',
            createTaskAssigneeLabel: 'Cessionnaire',
            createTaskAssigneePlaceholder: 'Sélectionnez le destinataire…',
            createTaskAssigneeNone: '- non attribué -',
            createTaskDueDateLabel: "Date d'échéance",
            createTaskWorkflowLabel: 'Workflow lié (facultatif)',
            createTaskWorkflowPlaceholder: 'Sélectionnez un flux de travail…',
            createTaskWorkflowNone: '— aucun —',
            renameModalSubmit: 'Renommer',
            renameModalSaving: 'Sauvegarde…',
            deleteConfirmTitle: 'Supprimer le chat ?',
            createTaskSubmit: 'Créer une tâche',
            createTaskSubmitting: 'Création…',
            cancelButton: 'Annuler',
            autoRouteHintMessage: 'Cette question est davantage dans la timonerie de [[TOK_1]].',
            autoRouteSwitchButton: 'Passer à [[TOK_1]]',
            autoRouteSwitching: 'Commutation…',
            handoffSuggestionMessage: 'Ou ouvrez une nouvelle discussion avec [[TOK_1]] pour faire avancer cette question.',
            handoffSuggestionButton: 'Démarrez une nouvelle conversation avec [[TOK_1]]',
            handoffSuggestionWorking: 'Ouverture…',
            handoffSuggestionDismiss: 'Pas maintenant',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Spécialiste de la conformité',
                'forseti-legal': 'Conseiller juridique',
                'forseti-dpo': 'Conseiller DPO',
                'forseti-risk': 'Analyste des risques',
                'forseti-auditor': "Œil de l'auditeur",
            },
            exportButton: 'Exporter en PDF',
            exportRunning: 'Exportation…',
            exportSuccess: 'Exporté : {filename} (ouvrir le navigateur de fichiers).',
            citation: {
                verifyBadge: '[VÉRIFIER]',
                verifyAria: "la citation n'a pas pu être vérifiée – examiner avant de s'appuyer",
                popoverAria: 'Source pour [[TOK_1]]',
                openSource: 'Page open source',
            },
        },
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: "Événement généré par [[TOK_0]] à partir de la piste d'audit Forseti.",
        },
        rowAction: {
            ask: 'Demandez à Forseti',
            tooltipOpen: 'Demandez à Forseti à ce sujet [[TOK_1]]',
            tooltipLocked: 'Ce [[TOK_1]] est verrouillé — Forseti peut répondre aux questions mais ne peut pas apporter de modifications.',
        },
        advisorRunPanel: {
            title: 'Forseti — à propos de ce disque',
            heading: 'Forseti — [[TOK_1]]',
            summaryLabel: 'Résumé',
            suggestedPersona: 'Personnalité suggérée',
            askForseti: 'Demandez à Forseti',
            runWorkflow: 'Exécuter un flux de travail',
            viewLineage: "Afficher le lignage d'audit",
            createPdplEvidencePack: 'Créer un dossier de preuves PDPL',
            prepareBreachDraft: 'Préparer le projet de notification',
            primaryActions: {
                projectSummary: 'Résumer le document de projet',
                supplementSummary: 'Résumer la demande de complément',
                authoritySummary: "Résumer la demande de l'autorité",
                rightsRequestResponse: 'Rédiger une réponse DSR',
                dpiaQuickReview: 'Lancer la revue rapide DPIA',
                taskControlWalkthrough: 'Parcourir les preuves de contrôle',
                vendorRiskNarrative: 'Générer le narratif de risque fournisseur',
                incidentLetter: 'Rédiger la lettre de violation PDPL',
                ropaSufficiency: 'Lancer le contrôle de suffisance RoPA',
                vendorDpaReview: 'Lancer la revue DPA fournisseur',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'RoPA Sufficiency Check',
                    notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
                },
                vendorDpaReview: {
                    title: 'Vendor DPA Review',
                    notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                vendorRiskNarrative: {
                    title: 'Vendor Risk Narrative',
                    notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
                },
                incidentLetter: {
                    title: 'PDPL Breach Notification Letter',
                    notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
                },
                projectSummary: {
                    title: 'Project Document Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
                },
                supplementSummary: {
                    title: 'Supplement Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
                },
                authoritySummary: {
                    title: 'Authority Request Summary',
                    notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
                },
                rightsRequestResponse: {
                    title: 'DSR Response Draft',
                    notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
                },
                dpiaQuickReview: {
                    title: 'DPIA Quick Review',
                    notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
                },
                taskControlWalkthrough: {
                    title: 'Control Evidence Walkthrough',
                    notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
                },
            },
            breachDraftNotice: 'Forseti prépare uniquement le contenu du projet pour le Mẫu số 08 lié. Il ne décide pas si une notification est requise et ne dépose ni envoie le formulaire.',
            breachDraftReady: 'Projet Mẫu số 08 prêt à être examiné',
            breachDraftReviewBeforeSelecting: 'Examiner avant de sélectionner',
            workflowHeading: 'Flux de travail pertinents',
            workflowLoading: 'Chargement des flux de travail pertinents…',
            workflowEmpty: "Aucun flux de travail pertinent n'est disponible pour cet enregistrement.",
            workflowError: 'Impossible de charger les flux de travail pertinents.',
            selectWorkflow: 'Sélectionner {title}',
            workflowSelected: "Flux de travail sélectionné. L'exécuteur intégré s'ouvre à l'étape suivante.",
            workflowRunSelected: 'Exécuter le flux de travail sélectionné',
            workflowStarting: 'Démarrage du flux de travail…',
            workflowRunError: 'Impossible de démarrer ce flux de travail.',
            workflowQuotaExhausted: 'Votre quota d’utilisation de Forseti est insuffisant pour démarrer ce flux de travail.',
            workflowTopUp: 'Consulter l’utilisation et demander une recharge',
            workflowCreateGuided: 'Créer un flux de travail guidé pour cet enregistrement',
            lineageHeading: 'Traçabilité d’audit de cet enregistrement',
            lineageLoading: 'Chargement de la traçabilité d’audit…',
            lineageEmpty: "Aucun événement de traçabilité Forseti n'est enregistré pour cet enregistrement.",
            lineageError: "Impossible de charger la traçabilité d'audit.",
            retry: 'Réessayer',
            chatContextLoading: 'Chargement du contexte de l’enregistrement…',
            chatGuidance: {
                general: 'Forseti peut résumer cet enregistrement, repérer les informations manquantes et suggérer des étapes de vérification.',
                privacy: 'Forseti peut examiner les faits relatifs à la vie privée, vérifier les obligations des référentiels installés et aider à préparer un projet soumis à une validation humaine.',
                compliance: 'Forseti peut repérer les lacunes de conformité, étayer les exigences par les sources installées et suggérer des prochaines étapes attribuables.',
                legal: 'Forseti peut résumer l’enregistrement, trouver des sources étayées et aider à préparer un projet à soumettre au conseil juridique.',
                risk: 'Forseti peut évaluer les risques consignés, signaler les faits manquants et suggérer des étapes de vérification proportionnées.',
                audit: 'Forseti peut examiner les lacunes de preuve, relier l’enregistrement aux contrôles installés et suggérer un suivi prêt pour l’audit.',
            },
            starterPrompts: {
                identifyGaps: 'Quelles informations ou preuves manquent dans cet enregistrement ?',
                reviewFrameworks: 'Quelles obligations de nos référentiels installés dois-je examiner pour cet enregistrement ?',
                prepareDraft: 'Aidez-moi à préparer un projet fondé uniquement sur cet enregistrement et sur des sources installées dûment étayées.',
                nextSteps: 'Quelles étapes de vérification dois-je entreprendre ensuite ?',
                summarizeRecord: 'Résumez cet enregistrement et signalez les points qui nécessitent une validation humaine.',
                assessRisk: 'Évaluez les risques consignés, repérez les faits manquants et suggérez des étapes de vérification.',
            },
            disclaimer: 'Forseti soutient votre jugement – il ne remplace pas un avocat agréé.',
            recordType: {
                project: 'Projet',
                dpia: '[[TOK_0]]',
                dossier_filing: 'Dépôt de dossiers',
                transfer_assessment: 'Transfert transfrontalier',
                vendor: 'Vendeur',
                vendor_contract: 'Contrat du fournisseur',
                vendor_acceptance: 'Acceptation des risques du fournisseur',
                incident: 'Incident',
                incident_op: 'Opération sur incident',
                breach_notification: 'Notification de violation',
                authority_request: "Demande d'autorisation",
                supplement_request: 'Demande de supplément',
                rights_request: 'Demande de droits',
                contract: 'Contrat',
                task: 'Tâche',
                data_mapping_activity: 'Activité RoPA',
                compliance_rule: 'Règle de conformité',
                program: 'Programme',
                governance_document: 'Document de gouvernance',
                remediation_plan: 'Plan de remédiation',
                cross_border_filing: 'Dépôt transfrontalier',
            },
        },
        autocomplete: {
            button_label: 'Demandez à Forseti de rédiger ceci',
            drafting: 'Rédaction…',
            hint_pick_activity: 'Choisissez une activité de traitement liée pour activer la rédaction Forseti.',
            draft_origin_label: 'Projet Forseti — examen par champ',
            tokens_label: '≈ [[TOK_1]] jetons de votre bucket mensuel',
            accept_selected: 'Accepter la sélection',
            reject_all: 'Rejeter le brouillon',
            field_checkbox_label: 'Appliquer le brouillon Forseti pour [[TOK_1]]',
            field_labels: {
                description: 'Descriptif',
                purpose: 'Objectif',
                data_subjects: 'Personnes concernées',
                data_types: 'Types de données',
                necessity_justification: 'Nécessité et proportionnalité',
                consultation_notes: 'Notes de consultation',
                dpo_opinion: '[[TOK_0]] avis',
                system_ids: 'Systèmes liés',
                vendor_ids: 'Fournisseurs liés',
            },
            error_generic: "Forseti n'a pas pu rédiger ce [[TOK_0]]. Réessayez ou affinez l'enregistrement d'activité.",
            variant_legend: 'Cadre cadre',
            variant_label_gdpr: '[[TOK_0]]',
            variant_label_pdpl: '[[TOK_0]]',
            variant_label_nis2: '[[TOK_0]]',
            variant_label_iso27001: 'OIN 27001',
            variant_label_soc2: 'SOC2',
            conflict_banner: "Attention : des [[TOK_1]] conflits entre frameworks s'appliquent à cette variante. Révisez avant d’accepter.",
        },
        tia: {
            button_label: 'Demandez à Forseti de rédiger ce TIA',
            drafting: 'Rédaction de TIA…',
            hint_pick_destination: 'Définissez le pays de destination sur le dossier de transfert avant que Forseti puisse rédiger.',
            draft_origin_label: 'Projet Forseti TIA — examen par domaine',
            tokens_label: '≈ [[TOK_1]] jetons de votre bucket mensuel',
            accept_selected: 'Accepter la sélection',
            reject_all: 'Rejeter le brouillon',
            field_checkbox_label: 'Appliquer le brouillon Forseti pour [[TOK_1]]',
            error_generic: "Forseti n'a pas pu rédiger ce TIA. Réessayez ou affinez l'enregistrement du transfert.",
            usage_details: "Détails d'utilisation de l'IA",
            applied_status: 'Brouillon accepté. Vérifiez les champs renseignés, puis sélectionnez Mettre à jour.',
            recommended_updates_title: "Mises à jour d'enregistrement recommandées",
            mechanism_recommendation: 'Mécanisme de transfert : {value}',
            dpo_signoff_recommendation: 'Exiger la validation du DPO pour ce transfert sensible.',
            review_date_warning: 'Définissez une échéance de revue avant de mettre à jour ce transfert sensible.',
            processing_activity_warning: 'Associez au moins une activité de traitement / un enregistrement ROPA avant de finaliser la TIA.',
            go_to_field: 'Aller au champ',
            adequacy_label: 'Régime de destination',
            adequacy_status_adequacy_decision: "Décision d'adéquation",
            adequacy_status_non_adequacy_with_sccs: 'Inadéquation – CCS requis',
            adequacy_status_derogation: "Dérogation à l'article 49",
            adequacy_status_transitional: 'Raccourci transitionnel/EEE',
            adequacy_status_unknown: 'Inconnu — définir la destination',
            conflict_banner: "Attention : [[TOK_1]] des conflits entre frameworks s'appliquent à ce régime de transfert. Révisez avant d’accepter.",
        },
        // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
        guardrails: {
            missing_facts_title: 'Faits requis manquants',
            missing_facts_hint: 'Forseti a signalé des faits absents de l’enregistrement. Les champs qui en dépendent ne sont pas présélectionnés — fournissez les faits ou acceptez le champ délibérément.',
            risk_label: 'Risque calibré',
            risk_low: 'Faible',
            risk_medium: 'Moyen',
            risk_high: 'Élevé',
            jurisdiction_label: 'Déclencheurs de juridiction',
            jurisdiction_gdpr: 'RGPD',
            jurisdiction_vn_pdpl: 'PDPL (Vietnam)',
            trigger_applicable: 'S’applique',
            trigger_not_applicable: 'Non déclenché',
            trigger_unknown: 'Inconnu — fait manquant',
            recipient_role_label: 'Rôle du destinataire',
            recipient_role_controller: 'Responsable du traitement',
            recipient_role_processor: 'Sous-traitant',
            recipient_role_joint_controller: 'Responsable conjoint',
            recipient_role_unknown: 'Inconnu — non précisé',
            opt_in_hint: 'Conclusion juridique — ne l’activez que si vous l’acceptez avec les faits disponibles.',
        },
        mcp: {
            pageTitle: 'Clés du connecteur MCP',
            pageSubtitle: "Émettez des clés [[TOK_0]] pour que les clients Claude externes puissent appeler les outils Forseti en lecture seule (recherche réglementaire, lecture de documents, recherche de modules). Phase 1 — lecture seule. Les outils d'écriture arrivent dans la version 48.3.0.",
            issueButton: 'Émettre une nouvelle clé',
            issueModalTitle: 'Émettre la clé MCP [[TOK_0]]',
            labelField: 'Étiquette',
            labelHint: 'Une brève description (par exemple, "[[TOK_0]] laboratoire de capacités – recherche réglementaire »).',
            permittedToolsField: 'Outils autorisés',
            expiresAtField: 'Expire (facultatif)',
            expiresAtHint: "Laissez vide pour n'expire jamais.",
            submit: 'Clé du problème',
            cancel: 'Annuler',
            keyDisplayedOnce: 'Copiez cette clé maintenant – vous ne pourrez plus la revoir. Stockez-le dans votre gestionnaire de secrets (1Password, AWS Secrets Manager, Vault, etc.).',
            keyDisplayedOnceClose: "Je l'ai copié — fermer",
            colLabel: 'Étiquette',
            colPrefix: 'Préfixe',
            colStatus: 'Statut',
            colTools: 'Outils',
            colCreatedAt: 'Créé',
            colLastUsed: 'Dernière utilisation',
            colCalls: 'Appels',
            colActions: 'Actions',
            statusActive: 'Actif',
            statusRevoked: 'Révoqué',
            statusExpired: 'Expiré',
            revokeAction: 'Révoquer',
            rotateAction: 'Rotation',
            confirmRevokeTitle: 'Révoquer cette clé MCP ?',
            confirmRevokeBody: 'Les clients Claude externes utilisant cette clé perdront immédiatement leur accès. Cela ne peut pas être annulé.',
            confirmRevoke: 'Révoquer la clé',
            rotatedTitle: 'Clé tournée',
            rotatedBody: "La nouvelle clé en texte brut se trouve ci-dessous. L'ancienne clé continue de fonctionner pendant 5 minutes afin que tous les appels en vol soient terminés.",
            emptyState: 'Aucune clé MCP émise pour le moment.',
            errorIssue: "Impossible d'émettre la clé MCP.",
            errorList: 'Impossible de charger les clés MCP.',
            errorRevoke: 'Impossible de révoquer la clé.',
            errorRotate: 'Impossible de faire tourner la clé.',
            neverUsed: '—',
            neverExpires: 'Jamais',
        },
        memory: {
            pageTitle: 'Mémoire Forseti',
            pageSubtitle: 'Parcourez et organisez le contexte spécifique à l’organisation que Forseti a accumulé au fil des conversations et des décisions. Les entrées organisées se verrouillent contre la rétention nocturne et restent disponibles pour chaque personne.',
            filterCategory: 'Catégorie',
            filterAllCategories: 'Toutes les catégories',
            totalCount: '[[TOK_1]] entrées',
            colAnchor: 'Ancre',
            colCategory: 'Catégorie',
            colSource: 'Origine',
            colContent: 'Contenu',
            colCreatedAt: 'Créé',
            colActions: 'Actions',
            editButton: 'Modifier',
            deleteButton: 'Supprimer',
            promoteButton: 'Promouvoir comme organisé',
            emptyState: "Pas de souvenirs pour l'instant : Forseti accumulera du contexte au fur et à mesure que vous discuterez.",
            categories: {
                framework_interpretation: 'Interprétation du cadre',
                process_preference: 'Préférence de processus',
                escalation_threshold: "Seuil d'escalade",
                decision_context: 'Contexte décisionnel',
                glossary_term: 'Terme du glossaire',
                auto_inferred: 'Auto-déduit',
            },
            sources: {
                admin_curated: 'Organisé',
                user_explicit: 'Explicite',
                auto: 'Inféré',
            },
            deleteConfirmTitle: 'Supprimer cette mémoire ?',
            deleteConfirmBody: 'La suppression supprimera cette ancre de chaque futur démarrage de chat Forseti. Ancre : [[TOK_1]]',
            deleteConfirmLabel: 'Supprimer',
            deleteCancelLabel: 'Annuler',
            editModalTitle: 'Modifier la mémoire',
            editAnchorLabel: 'Ancre',
            editCategoryLabel: 'Catégorie',
            editContentLabel: 'Contenu',
            editContentCount: '[[TOK_2]]/[[TOK_3]] caractères',
            editEmptyError: 'Le contenu ne peut pas être vide.',
            editTooLongError: 'Le contenu doit contenir ≤ 1 000 caractères.',
            editAutoPromoteHint: 'L’enregistrement de cette mémoire auto-déduite la marquera comme confirmée par l’utilisateur et la supprimera du balayage de rétention.',
            editCancelButton: 'Annuler',
            editSaveButton: 'Enregistrer',
            editSaving: 'Sauvegarde…',
        },
        auditLineage: {
            title: "Lignée d'audit",
            subtitle: "Tracez chaque artefact généré par [[TOK_0]] attaché à un enregistrement. Discussions, appels d'outils, tâches, brouillons de preuves et versions de documents.",
            filterForm: 'Filtres',
            recordType: "Type d'enregistrement",
            recordId: "Identifiant de l'enregistrement",
            dateStart: 'De',
            dateEnd: 'À',
            search: 'Rechercher',
            loading: 'Chargement…',
            exportPdf: 'Exporter [[TOK_0]]',
            exportCsv: 'Exporter [[TOK_0]]',
            nodesHeading: 'Nœuds de lignée',
            colType: 'Tapez',
            colLabel: 'Étiquette',
            colOccurredAt: 'Survenu à',
            colActor: 'Acteur',
            colId: "pièce d'identité",
            noResults: 'Aucune activité de conseiller pour ce dossier.',
            draftBadge: 'Brouillon généré par [[TOK_0]]',
            prev: 'Précédent',
            next: 'Suivant',
            viewToggleTable: 'Afficher sous forme de tableau',
            viewToggleGraph: 'Afficher sous forme de graphique',
            graphAriaLabel: 'Graphique de lignée (visuel). Utilisez la vue tableau pour la technologie d’assistance.',
            graphLegendDraft: 'Projet de preuve [[TOK_0]]',
            graphEmpty: 'Aucun nœud à représenter graphiquement.',
            paginationAriaLabel: 'Pagination',
            exportSuccessTemplate: '[[TOK_2]] : [[TOK_3]]',
            exportErrorTemplate: "Échec de l'exportation : [[TOK_1]]",
            recordTypes: {
                project: 'Projet',
                dpia: '[[TOK_0]]',
                vendor: 'Vendeur',
                incident: 'Incident',
                incident_op: 'Opération sur incident',
                rights_request: 'Demande de droits',
                contract: 'Contrat',
                task: 'Tâche',
                data_mapping_activity: 'Activité de cartographie des données',
                compliance_rule: 'Règle de conformité',
                program: 'Programme',
            },
            nodeTypes: {
                chat: 'Discuter',
                tool_call: "Appel d'outil",
                workflow_run: 'Exécution du flux de travail',
                task: 'Tâche',
                evidence: 'Preuve',
                document_version: 'Version du document',
            },
        },
        integrityCenter: {
            verdicts: {
                ok: "D'accord",
                drifted: 'Dérivé',
                hash_mismatch: 'Incompatibilité de hachage',
                merkle_mismatch: 'Inadéquation de Merkle',
                source_missing: 'Source manquante',
                not_found: 'Pas trouvé',
                chain_unreachable: 'Chaîne inaccessible',
                service_unreachable: 'Service inaccessible',
                pending: 'Ancrage en attente',
            },
        },
        evidenceDraft: {
            draftBadge: 'DRAFT généré par [[TOK_0]]',
            pendingReviewBadge: "En attente d'examen",
            approvedBadge: 'Approuvé',
            rejectedBadge: 'Rejeté',
            moveToReviewButton: 'Marquer comme prêt à être examiné',
            approveButton: 'Approuver',
            rejectButton: 'Rejeter',
            rejectReasonLabel: 'Motif du refus',
            humanSignoffBanner: "Forseti soutient votre jugement – il ne remplace pas un avocat agréé. Les preuves générées par [[TOK_0]] nécessitent l'approbation humaine avant d'être considérées comme des preuves formelles.",
            pageTitle: '[[TOK_0]] brouillons de preuves',
            pageSubtitle: 'Examinez, approuvez ou rejetez les preuves générées par [[TOK_0]]. Les brouillons doivent être approuvés par un humain avant de pouvoir être considérés comme des preuves formelles.',
            filterAll: 'Tout est exploitable',
            filterDrafts: 'Brouillons uniquement',
            filterPending: "En attente d'examen",
            filterApproved: 'Récemment approuvé',
            filterRejected: 'Récemment rejeté',
            colId: 'Identifiant des preuves',
            colStatus: 'Statut',
            colSource: 'Origine',
            colCreatedAt: 'Créé',
            colActions: 'Actions',
            empty: 'Aucun brouillon de preuve [[TOK_0]] dans cet état.',
            confirmApprove: 'Approuver cette preuve générée par [[TOK_0]] comme formelle ?',
            confirmReject: 'Rejetez cette ébauche de preuves. Cela ne peut pas être annulé.',
            reasonRequired: 'Un motif de refus est requis.',
            rejectModalTitle: 'Rejeter le projet de preuve',
            approveModalTitle: 'Approuver le projet de preuve',
            operationFailed: "L'opération a échoué. Veuillez réessayer.",
            moveToReviewSuccess: 'Marqué prêt pour examen.',
            approveSuccess: 'Approuvé.',
            rejectSuccess: 'Rejeté.',
            sourceLabelWorkflowRunTitle: 'Flux de travail : [[TOK_1]]',
            sourceLabelWorkflowRunId: 'Exécution du workflow [[TOK_1]]',
            sourceLabelChatTitle: 'Chat : [[TOK_1]]',
            sourceLabelChatId: 'Chat Forseti [[TOK_1]]',
            sourceLabelEmpty: '—',
            filtersAriaLabel: 'Statut du filtre',
        },
        workflows: {
            pageTitle: 'Flux de travail IA',
            pageSubtitle: 'Modèles de prompts IA enregistrés produisant des tâches et des brouillons de preuves.',
            newWorkflow: 'Nouveau flux de travail',
            newWorkflowHeading: 'Nouveau flux de travail IA',
            tabAll: 'Tous',
            tabBuiltin: 'Pack intégré',
            tabMine: 'Mes flux de travail',
            tabDetail: 'Détails',
            tabLinkedTasks: 'Tâches liées',
            builtinBadge: 'Intégré',
            builtinSubtitle: 'Flux de travail intégré.',
            userSubtitle: 'Flux de travail personnalisé.',
            emptyHint: 'Aucun flux de travail pour le moment.',
            loadTimeoutError: "Impossible de charger les flux de travail après 10 secondes. Réessayez ou vérifiez l'onglet Réseau du navigateur pour une requête bloquée.",
            loadError: 'Échec du chargement des flux de travail.',
            hideError: 'Échec du masquage.',
            unhideError: "Échec de l'affichage.",
            retry: 'Réessayer',
            producesTasks: 'Produit des tâches',
            producesEvidence: 'Produit des brouillons de preuves',
            hideButton: 'Masquer de ma liste',
            unhideButton: 'Afficher',
            runButton: 'Exécuter',
            editButton: 'Modifier',
            shareButton: 'Partager',
            backToList: 'Retour à la liste',
            requireTitleAndPrompt: 'Le titre et le prompt sont requis.',
            fieldTitle: 'Titre',
            fieldDescription: 'Descriptif',
            fieldType: 'Tapez',
            fieldPersona: 'Affinité de persona',
            fieldPractice: 'Pratique',
            fieldPrompt: 'Invite (markdown)',
            fieldProducesTasks: 'Produit des tâches',
            fieldProducesEvidence: 'Produit des brouillons de preuves',
            fieldProjectId: 'Projet (facultatif)',
            fieldAttachmentIds: 'Pièces jointes',
            fieldParentRecord: 'Enregistrement parent (facultatif)',
            fieldPersonaOverride: 'Substitution de persona (facultatif)',
            typeAssistant: 'Assistante',
            typeTabular: 'Tabulaire',
            personaNone: '— aucun —',
            parentNone: '— aucun —',
            parentIdPlaceholder: "ID de l'enregistrement parent",
            selectProjectPlaceholder: 'Sélectionner un projet…',
            selectProjectFirst: 'Sélectionnez un projet pour choisir les pièces jointes.',
            selectAttachmentsPlaceholder: 'Sélectionner des documents…',
            noAttachmentsInProject: 'Ce projet ne comporte aucun document joint.',
            selectParentRecordPlaceholder: 'Sélectionner un enregistrement…',
            selectParentRecordFirst: "Sélectionnez d'abord un type d'enregistrement.",
            noRecordsForType: 'Aucun enregistrement de ce type disponible.',
            shareUserSelectorLabel: 'Destinataires (utilisateurs)',
            shareGroupSelectorLabel: "Destinataires (groupes d'organisation)",
            selectUsersPlaceholder: 'Sélectionner des utilisateurs…',
            selectOrgGroupsPlaceholder: "Sélectionner des groupes d'organisation…",
            loadingOptions: 'Chargement…',
            loadFailed: 'Échec du chargement des options.',
            parentRecordTypes: {
                dpia: 'AIPD',
                vendor: 'Fournisseur',
                incident: 'Incident',
                rights_request: 'Demande de droits',
                contract: 'Contrat',
                data_mapping_activity: 'Activité RoPA',
                compliance_rule: 'Règle de conformité',
                program: 'Programme',
            },
            cancelButton: 'Annuler',
            closeButton: 'Fermer',
            createButton: 'Créer',
            creating: 'Création…',
            saveButton: 'Enregistrer',
            saving: 'Enregistrement…',
            shareWorkflowHeading: 'Partager le flux de travail',
            shareIntro: 'Partage : {title}',
            shareUserIds: "ID d'utilisateur (séparés par espace ou virgule)",
            shareGroupIds: "ID de groupe d'organisation (séparés par espace ou virgule)",
            shareAllowEdit: 'Autoriser les destinataires à modifier',
            shareRequireRecipient: "Fournissez au moins un id d'utilisateur ou de groupe.",
            shareSuccess: 'Partagé.',
            sharing: 'Partage…',
            runWorkflowHeading: 'Exécuter : {title}',
            runStarting: 'Démarrage…',
            runStatusLabel: 'Statut : {status}',
            runProducedCounts: 'Tâches : {tasks} · Brouillons de preuves : {evidence}',
            runPanelHeading: 'Exécution du flux de travail',
            runPanelHeadingWithTitle: 'Exécution du flux de travail : {title}',
            runViewTasks: 'Afficher les tâches générées',
            runLoadFailed: 'Impossible de charger l’exécution du flux de travail.',
            runStreamFailed: 'La connexion au suivi du flux de travail a échoué.',
            runStatusValues: {
                pending: 'En attente',
                running: 'En cours',
                completed: 'Terminé',
                succeeded: 'Réussi',
                failed: 'Échoué',
                cancelled: 'Annulé',
            },
            runProgressStatus: 'Statut : {status}',
            runProgressTaskCreated: 'Tâche créée.',
            runProgressEvidenceDrafted: 'Brouillon de preuve créé.',
            runProgressAttachmentGenerated: 'Pièce jointe générée.',
            guidedWorkflowTitle: 'Flux de travail guidé pour {recordType}',
            guidedWorkflowDescription: 'Créé pour les enregistrements de type {recordType}. Vérifiez et personnalisez ce flux de travail avant de l’enregistrer.',
            guidedWorkflowPrompt: 'Examinez l’enregistrement de type {recordType} fourni, repérez les faits manquants et proposez des prochaines étapes étayées pour validation humaine.',
            costHint: "La vérification de quota préalable se déclenche à l'envoi ; les exécutions hors quota retournent 402 avec un CTA de recharge.",
            quotaExhausted: 'Quota de jetons faible. Rechargez avant de réexécuter.',
            promptHeading: 'Invite',
            editWorkflowHeading: 'Modifier le flux de travail',
            linkedTasksHint: 'Les tâches créées par ce flux de travail apparaissent dans la liste des tâches filtrée par cet id de flux. Le lien croisé arrive en 47.5.8.',
            notFound: 'Flux de travail introuvable.',
            schedules: {
                tabTitle: 'Plannings',
                sectionHeading: 'Exécutions planifiées',
                empty: 'Aucun planning pour le moment. Créez-en un pour exécuter ce flux de travail automatiquement.',
                addButton: 'Ajouter un planning',
                addHeading: 'Planifier le flux de travail',
                editHeading: 'Modifier le planning',
                fieldFrequency: 'Fréquence',
                fieldDayOfWeek: 'Jour de la semaine',
                fieldDayOfMonth: 'Jour du mois',
                fieldTime: 'Heure (UTC)',
                fieldTimezone: 'Fuseau horaire',
                fieldProject: 'Projet (facultatif)',
                fieldAttachments: 'Pièces jointes par défaut',
                fieldPersonaOverride: 'Substitution de persona (facultatif)',
                frequencyDaily: 'Quotidien',
                frequencyWeekly: 'Hebdomadaire',
                frequencyMonthly: 'Mensuel',
                weekdaySun: 'Dimanche',
                weekdayMon: 'Lundi',
                weekdayTue: 'Mardi',
                weekdayWed: 'Mercredi',
                weekdayThu: 'Jeudi',
                weekdayFri: 'Vendredi',
                weekdaySat: 'Samedi',
                statusActive: 'Actif',
                statusPaused: 'En pause',
                nextRunLabel: 'Prochaine exécution',
                lastRunLabel: 'Dernière exécution',
                pauseButton: 'Pause',
                resumeButton: 'Reprendre',
                deleteButton: 'Supprimer',
                triggerButton: 'Exécuter maintenant',
                savingButton: 'Enregistrement…',
                saveButton: 'Enregistrer',
                triggered: "Exécution démarrée — vérifiez l'historique des exécutions.",
            },
            branching: {
                helpHeading: 'Syntaxe de prompt conditionnelle',
                helpBody: 'Utilisez {% if attachment.framework_code == "vn-pdpl" %}…{% endif %} pour faire varier le prompt selon le contexte. Variables autorisées : attachment.framework_code, attachment.locale, project.name, project.tier, persona.slug, org.country, org.locale. Les blocs {% if %} imbriqués ne sont pas pris en charge.',
            },
        },
        crossFrameworkConflicts: {
            pageTitle: 'Conflits entre frameworks',
            pageSubtitle: 'Catalogue organisé des endroits où vos packs réglementaires installés interagissent de manière conflictuelle. Surfaces Forseti; les humains décident.',
            noInstalledPacks: "Aucun pack réglementaire n'est installé pour cette organisation : installez au moins deux packs pour détecter les conflits entre frameworks.",
            noConflicts: 'Aucun conflit ne correspond aux filtres actuels.',
            allAcknowledged: 'Chaque conflit visible a été reconnu. Beau travail.',
            columnSeverity: 'Gravité',
            columnTitle: 'Titre',
            columnFrameworks: 'Cadres',
            columnTopic: 'Sujet',
            columnStatus: 'Statut',
            filterFrameworkPlaceholder: 'Tous les cadres',
            filterTopicPlaceholder: 'Tous les sujets',
            filterSeverityPlaceholder: 'Toutes les sévérités',
            filterStatusPlaceholder: 'Tous les statuts',
            filterStatusAcknowledged: 'Reconnu',
            filterStatusUnacknowledged: 'Non reconnu',
            severityCritical: 'Critique',
            severityHigh: 'Élevé',
            severityMedium: 'Moyen',
            severityLow: 'Faible',
            statusAcknowledged: 'Reconnu',
            statusInReview: 'En revue',
            statusResolved: 'Résolu',
            statusWontFix: 'Ne résoudra pas',
            statusUnacknowledged: 'Non reconnu',
            drawerSummaryHeading: 'Résumé',
            drawerSideAHeading: 'Face A',
            drawerSideBHeading: 'Face B',
            drawerRequirementsLabel: 'Exigences citées',
            drawerSuggestedResolutionHeading: 'Résolution suggérée',
            drawerLegalCounselBadge: 'Examen par un conseiller juridique requis',
            drawerAckHeading: 'Remerciement',
            drawerAckStatusLabel: 'Statut',
            drawerAckAssigneeLabel: 'Attribué à',
            drawerAckDueDateLabel: "Date d'échéance",
            drawerAckNotesLabel: 'Remarques',
            drawerAckButtonAcknowledge: 'Reconnaître',
            drawerAckButtonUpdate: 'Mise à jour',
            drawerAckButtonUnacknowledge: 'Annuler la réception',
            searchPlaceholder: 'Rechercher un titre ou un résumé…',
            searchButton: 'Rechercher',
            searchButtonAriaLabel: 'Exécuter une recherche de conflit',
            exportSuccessTemplate: '[[TOK_2]] : [[TOK_1]]',
            exportSuccessTemplateXlsx: '[[TOK_2]] : [[TOK_1]]',
            exportErrorTemplate: "Échec de l'exportation : [[TOK_1]]",
            exportAriaLabel: "Conflits d'exportation",
        },
        tabularReviews: {
            pageTitle: 'Revues tabulaires',
            pageSubtitle: 'Comparez N documents sur M attributs avec des citations fondées.',
            newReview: 'Nouvelle revue',
            newReviewHeading: 'Nouvelle revue tabulaire',
            emptyHint: 'Aucune revue tabulaire pour le moment.',
            docsLabel: '{n} documents',
            colsLabel: '{n} colonnes',
            detailSubtitle: '{docs} documents · {cols} colonnes',
            addColumn: 'Ajouter une colonne',
            addColumnHeading: 'Ajouter une colonne',
            columnInfo: 'Voir l’invite et le format',
            columnInfoAria: 'Afficher l’invite et le format de la colonne {name}',
            columnInfoPrompt: 'Invite',
            columnInfoFormat: 'Format de retour',
            columnInfoPresets: 'Valeurs autorisées',
            columnInfoCitations: 'Citations',
            columnInfoCitationsRequired: 'Obligatoire',
            removeColumn: 'Supprimer la colonne',
            removeColumnAria: 'Supprimer la colonne {name}',
            removeColumnConfirm: 'Supprimer la colonne « {name} » ? Ses cellules extraites seront supprimées.',
            deleteReview: 'Supprimer',
            deleteReviewAria: 'Supprimer la revue {title}',
            deleteReviewConfirm: 'Supprimer la revue « {title} » ? Cela supprime définitivement ses colonnes, cellules et discussions.',
            runAll: 'Tout exécuter',
            running: 'Exécution…',
            cancel: 'Annuler',
            exportXlsx: 'Exporter Excel',
            exportCsv: 'Exporter CSV',
            exporting: 'Exportation…',
            backToList: 'Retour à la liste',
            notFound: 'Revue tabulaire introuvable.',
            noDocuments: 'Joignez des documents pour démarrer la revue.',
            noColumns: 'Ajoutez des colonnes pour définir ce qui doit être extrait.',
            tableAriaLabel: "Grille d'extraction",
            threadsCountAria: '{n} message(s) de discussion',
            startDiscussionAria: 'Démarrer la discussion',
            docColumn: 'Documenter',
            statusPending: 'En attente',
            statusRunning: 'Exécution…',
            statusFailed: 'Échec : {msg}',
            statusCancelled: 'Annulé',
            citationsCount: '[[TOK_1]] citation(s)',
            citationsView: 'Voir les passages sources',
            citationPage: 'Page {n}',
            titleRequired: 'Le titre est requis.',
            fieldTitle: 'Titre',
            fieldProjectId: 'Projet (facultatif)',
            fieldAttachmentIds: 'Pièces jointes',
            fieldColumnName: 'Nom de la colonne',
            fieldColumnNameHelp: "Une étiquette courte et descriptive pour cette colonne dans la grille d'extraction.",
            columnNamePlaceholder: 'p. ex. Date de début du contrat',
            fieldExtractionPrompt: "Prompt d'extraction",
            fieldExtractionPromptHelp: 'Décrivez les informations que vous souhaitez extraire. Soyez précis pour obtenir de meilleurs résultats.',
            columnPromptPlaceholder: 'Que doit rechercher Forseti dans les documents ?',
            fieldReturnFormat: 'Format de retour',
            fieldReturnFormatHelp: "Contrôle la manière dont l'IA formate sa réponse (par exemple sous forme de date ou de nombre).",
            fieldPresets: 'Valeurs autorisées (une par ligne)',
            fieldPresetsPlaceholder: 'oui\nnon\npartiel',
            fieldCitationsRequired: 'Citation requise',
            formatShortText: 'Texte court',
            formatLongText: 'Texte long',
            formatEnum: 'Énumération',
            formatNumber: 'Nombre',
            formatDate: 'Date',
            formatList: 'Liste',
            columnRequireFields: 'Le nom et le prompt sont requis.',
            addColumnError: "Échec de l'ajout de la colonne.",
            cancelButton: 'Annuler',
            createButton: 'Créer',
            creating: 'Création…',
            addButton: 'Ajouter',
            adding: 'Ajout…',
            runConfirmHeading: "Exécuter l'extraction",
            estimateBody: '~{units} unités facturables estimées (confiance {confidence}).',
            costHint: 'La vérification de quota préalable se déclenche à la confirmation ; les exécutions hors quota retournent 402 avec un CTA de recharge.',
            quotaExhausted: 'Quota de jetons faible. Rechargez avant de réexécuter.',
            starting: 'Démarrage…',
            confirmRun: "Confirmer l'exécution",
            charts: {
                title: 'Graphiques de colonnes',
                tabsAria: 'Colonnes des graphiques',
                enumAria: 'Distribution des valeurs enum',
                numberAria: 'Histogramme de distribution numérique',
                dateAria: 'Chronologie des dates',
                enumEmpty: 'Aucune cellule complétée.',
                numberEmpty: 'Aucune valeur numérique.',
                numberExcluded: '{n} cellule(s) exclues (vides / non numériques / non complétées).',
                dateEmpty: 'Aucune valeur de date.',
                dateExcluded: '{n} cellule(s) exclues.',
                unsupportedFormat: 'Format de colonne non pris en charge.',
            },
            threads: {
                drawerTitle: 'Discussion',
                loading: 'Chargement…',
                empty: 'Aucun message pour le moment. Lancez la conversation.',
                composerLabel: 'Nouveau commentaire',
                composerPlaceholder: 'Ajouter un commentaire…',
                post: 'Publier',
                posting: 'Publication…',
                edit: 'Modifier',
                editLabel: 'Modifier le message',
                delete: 'Supprimer',
                save: 'Enregistrer',
                cancel: 'Annuler',
                close: 'Fermer',
                editedBadge: 'modifié',
                loadError: 'Échec du chargement du fil',
                postError: 'Échec de la publication',
                editError: 'Échec de la modification',
                deleteError: 'Échec de la suppression',
            },
            compare: {
                pageTitle: 'Comparer les revues',
                leftReviewLabel: 'Revue de gauche',
                rightReviewLabel: 'Revue de droite',
                pickReview: 'Choisissez une revue à comparer',
                noSharedDocuments: 'Ces revues ne partagent aucun document — la comparaison nécessite au moins une pièce jointe commune.',
                sharedDocumentsHeading: 'Documents partagés',
                leftOnlyHeading: 'Colonnes uniquement dans la revue de gauche',
                rightOnlyHeading: 'Colonnes uniquement dans la revue de droite',
                differs: 'Diffère',
                identical: 'Identique',
                emptyValue: '—',
                compareButton: 'Comparer avec…',
                documentHeading: 'Documenter',
                errorMissingIds: 'Les ids des revues de gauche et de droite sont requis.',
                errorComparisonFailed: 'La comparaison a échoué.',
                errorLoadFailed: 'Échec du chargement des revues.',
                pickerLoading: 'Chargement…',
                pickerNoOtherReviews: 'Aucune autre revue disponible pour la comparaison.',
                pickerCancel: 'Annuler',
            },
        },
        documentReview: {
            pageTitle: 'Examen des documents',
            pageSubtitle: 'Acceptez ou rejetez les modifications suggérées par [[TOK_0]] pour ce document.',
            sidePanelLabel: '[[TOK_0]] lignes rouges',
            sidePanelHeading: '[[TOK_0]] lignes rouges',
            noPendingEdits: 'Aucune modification en attente.',
            pendingCount: '[[TOK_1]] en attente',
            acceptAllButton: 'Acceptez tout',
            rejectAllButton: 'Rejeter tout',
            acceptAllTitle: 'Accepter toutes les modifications en attente ?',
            acceptAllConfirm: 'Cela acceptera les [[TOK_1]] modifications en attente et créera une ou plusieurs nouvelles versions. Continuer?',
            editsHeading: 'Modifications',
            editsEmpty: 'Aucune modification à examiner.',
            versionsHeading: 'Historique des versions',
            versionsEmpty: "Aucune version pour l'instant.",
            editLabel: 'Modifier',
            editLabelWithId: 'Modifier #{id}',
            acceptButton: 'Accepter',
            rejectButton: 'Rejeter',
            accepting: 'Accepter…',
            rejecting: 'Rejeter…',
            diffDeletedAria: 'Supprimé',
            diffInsertedAria: 'Inséré',
            statusPending: 'En attente',
            statusAccepted: 'Accepté',
            statusRejected: 'Rejeté',
            versionLabel: 'Version',
            versionAriaLabel: 'Version [[TOK_1]]',
            versionAriaLabelCurrent: 'Version [[TOK_2]] ([[TOK_3]])',
            versionCurrentTag: 'courant',
            versionSourceLabel: 'Origine',
            versionCreatedLabel: 'Créé',
            versionModelLabel: 'Modèle',
            sourceUpload: 'Télécharger',
            sourceUserUpload: "Téléchargement par l'utilisateur",
            sourceAssistantEdit: 'Assistant de modification',
            sourceUserAccept: "Modification acceptée par l'utilisateur",
            sourceUserReject: "L'utilisateur a refusé la modification",
            sourceGenerated: 'Généré',
        },
        documentReviewIndex: {
            sidebarLabel: 'Revue de documents',
            pageTitle: 'Revue de documents',
            pageSubtitle: 'Documents de votre organisation comportant des modifications suggérées par IA en attente de revue ou des versions issues de Forseti.',
            colDocument: 'Documenter',
            colLinkedRecord: 'Enregistrement lié',
            colPendingEdits: 'Modifications en attente',
            colLastActivity: 'Dernière activité',
            colOpen: 'Ouvrir',
            open: 'Ouvrir',
            empty: "Aucun document en revue Forseti pour le moment. Les documents entrent dans cette file lorsque Forseti suggère une modification dans un chat, lorsqu'un flux IA produit un redline, ou lorsque vous envoyez un document en revue via le bouton ci-dessus.",
            loading: 'Chargement…',
            loadError: 'Échec du chargement des documents en revue.',
            retryButton: 'Réessayer',
            noLinkedRecord: '—',
            pendingZero: 'Aucune',
            sendForReviewButton: 'Envoyer un document en revue',
            sendForReviewTitle: 'Envoyer un document en revue',
            sendForReviewSubtitle: 'Choisissez une pièce jointe existante de cette organisation, ou téléversez un nouveau fichier. Le document est ajouté à la file de revue et Forseti effectuera une passe redline dessus.',
            sendForReviewTabPick: 'Choisir existant',
            sendForReviewTabUpload: 'Téléverser nouveau',
            sendForReviewPickerLabel: 'Rechercher des pièces jointes',
            sendForReviewPickerPlaceholder: 'Tapez pour rechercher…',
            sendForReviewPickerEmpty: 'Aucune pièce jointe correspondante. Essayez une autre recherche.',
            sendForReviewSubmit: 'Envoyer en revue',
            sendForReviewCancel: 'Annuler',
            sendForReviewSubmitting: 'Envoi…',
            sendForReviewError: "Impossible d'envoyer le document en revue. Veuillez réessayer.",
            sendForReviewSuccess: 'Document envoyé en revue.',
            sendForReviewAcceptedExt: 'Acceptés : {ext}.',
            sendForReviewMaxSize: 'Taille max. {mb} Mo.',
        },
        chats: {
            exportError: "Échec de l'exportation.",
        },
    },
    pdplEvidencePacks: {
        title: 'Dossiers de preuves PDPL',
        subtitle: 'Soumission contrôlée par le client à MoPS A05',
        nav: { emailProviders: 'Fournisseurs de messagerie' },
        providers: {
            pageTitle: 'Fournisseurs de messagerie',
            pageSubtitle: 'Configurez le fournisseur de messagerie sortante de votre organisation pour soumettre les dossiers de preuves PDPL à MoPS A05.',
            architectureRuleHeading: "Règle d'architecture (verrouillée)",
            architectureRuleBody: "AesirX n'est pas l'expéditeur des courriels de preuve. Chaque envoi utilise un fournisseur que vous possédez et contrôlez. AesirX n'envoie jamais en votre nom.",
            empty: 'Aucun fournisseur configuré pour le moment.',
            createCta: 'Créer un fournisseur',
            statusPendingConsent: 'En attente de consentement',
            statusPendingConnectionCheck: 'Test de connexion en attente',
            statusActive: 'Actif',
            statusConnectionCheckFailed: 'Échec du test de connexion',
            statusDisabled: 'Désactivé',
            acceptConsentCta: 'Accepter le consentement',
            runConnectionCheckCta: 'Lancer le test de connexion',
            disableCta: 'Désactiver',
            disableConfirm: "Désactiver ce fournisseur interrompt les envois directs jusqu'à la configuration d'un nouveau fournisseur et la reconfirmation du consentement. Continuer ?",
            columnDisplayName: 'Nom',
            columnFromAddress: 'Adresse expéditrice',
            columnStatus: 'Statut',
            columnLastCheck: 'Dernier test',
            columnActions: 'Actions',
            createModalTitle: 'Nouveau fournisseur SMTP',
            createDisplayNameLabel: 'Nom affiché',
            createFromAddressLabel: 'Adresse expéditrice',
            createReplyToLabel: 'Adresse de réponse (facultatif)',
            createSmtpHostLabel: 'Serveur SMTP',
            createSmtpPortLabel: 'Port SMTP',
            createSmtpUsernameLabel: 'Identifiant SMTP',
            createSmtpPasswordLabel: 'Mot de passe SMTP',
            createSmtpEncryptionLabel: 'Chiffrement',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (implicite)',
            createSmtpEncryptionNone: 'Aucun',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Bientôt disponible',
            createOauthDisabledHint: "Les fournisseurs OAuth ne sont pas encore activés. Utilisez SMTP pour l'instant.",
            createSubmitCta: 'Créer le fournisseur',
            createCancelCta: 'Annuler',
            createErrorInvalidFromAddress: "L'adresse expéditrice doit être une boîte e-mail valide.",
            createErrorDuplicateFromAddress: 'Un autre fournisseur est déjà configuré pour cette adresse expéditrice.',
            createErrorGeneric: 'Impossible de créer le fournisseur. Vérifiez le formulaire et réessayez.',
            consentModalTitle: "Confirmer la règle d'architecture",
            consentLocaleToggleEn: 'Anglais',
            consentLocaleToggleVi: 'Vietnamien',
            consentAcknowledgeCta: 'Je confirme — accepter le consentement',
            consentCancelCta: 'Annuler',
            consentErrorMismatch: 'Le texte de consentement a été modifié et ne correspond plus à la clause canonique. Rouvrez la boîte de dialogue et soumettez à nouveau.',
            testModalTitle: 'Test de connexion',
            testRunningCta: 'Test de connexion en cours…',
            testRunCta: 'Lancer le test de connexion',
            testRetryCta: 'Réessayer le test',
            testSuccessHeading: 'Connexion réussie',
            testSuccessBody: 'Authentifié auprès de {host}:{port} en {latencyMs} ms. Le fournisseur est prêt pour les envois directs.',
            testFailureHeading: 'Échec de la connexion',
            testFailureBody: "Le test n'a pas pu aboutir. Examinez la cause ci-dessous et réessayez après correction.",
            testFailureReasonLabel: "Cause de l'échec",
            testCloseCta: 'Fermer',
            detailDrawerTitle: 'Détails du fournisseur',
            detailDrawerHistoryHeading: 'Historique des tests de connexion',
            detailDrawerConsentHeading: 'Confirmation du consentement',
            detailDrawerNoHistory: 'Aucun test de connexion enregistré pour le moment.',
            detailDrawerNoConsent: "Le consentement n'a pas encore été confirmé.",
            outcomeSuccess: 'Succès',
            outcomeFailure: 'Échec',
        },
        builder: {
            pageTitle: 'Assembler le dossier de preuves',
            pageSubtitle: 'Téléversez les 6 fichiers, choisissez le type de paquet et assemblez le ZIP déterministe en 8 parties pour la soumission.',
            packTypeLabel: 'Type de paquet',
            packTypeDpia: 'DPIA (Mẫu số 02a)',
            packTypeOtia: 'OTIA (Mẫu số 02b)',
            part01CoverLetter: 'Partie 01 — Lettre de présentation (PDF)',
            part02AuthorityForm: "Partie 02 — Formulaire de l'autorité (PDF)",
            part03Supporting: 'Partie 03 — Preuves justificatives (≥1)',
            part04Safeguards: 'Partie 04 — Garanties',
            part04SafeguardsRequiredOtia: '(requis pour OTIA)',
            part05PriorCorrespondence: 'Partie 05 — Correspondance antérieure (facultatif)',
            part06Signature: 'Partie 06 — Preuves de signature et cachet (≥1)',
            uploadPickFile: 'Choisir un fichier',
            uploadPickFiles: 'Choisir des fichiers',
            uploadRemoveFile: 'Retirer',
            requiredMissing: 'Partie requise manquante',
            assembleCta: 'Assembler le paquet',
            assembling: 'Assemblage…',
            assembleSuccessHeading: 'Paquet assemblé',
            assembleSuccessSummary: '{fileCount} fichiers · {bytes} octets · SHA-256 {shaPrefix}…',
            composeNextCta: "Rédiger un brouillon d'e-mail",
            warningsHeading: 'Avertissements de validation',
            assembleError: "Impossible d'assembler le paquet. Vérifiez les données et réessayez.",
            forsetiAssistHeading: 'Assistance IA Forseti (optionnelle)',
            forsetiAssistHint: "Exécutez le PDPL Evidence Pack Assembly Advisor pour mettre en évidence les éléments manquants, rédiger le texte de la lettre d'accompagnement et signaler les lacunes en matière de protection. AesirX n'est pas l'expéditeur — l'IA ne fait que conseiller ; vous approuvez chaque artefact.",
            forsetiAssistCta: 'Ouvrir la bibliothèque de workflows Forseti',
            forsetiAiRunIdLabel: "ID d'exécution IA Forseti liée (coller pour enregistrer l'assistance IA)",
        },
        draft: {
            pageTitle: "Brouillon d'e-mail",
            pageSubtitle: "Rédigez et modifiez le brouillon d'e-mail. L'envoi direct arrive dans une version ultérieure.",
            composeCta: 'Rédiger le brouillon',
            composing: 'Rédaction…',
            noDraftYet: 'Aucun brouillon. Rédigez-en un pour commencer.',
            localeToggleLabel: 'Langue',
            localeEn: 'Anglais',
            localeVi: 'Vietnamien',
            subjectLabel: 'Sujet',
            bodyLabel: 'Corps',
            saveCta: 'Enregistrer les modifications',
            saving: 'Enregistrement…',
            saveError: "Impossible d'enregistrer le brouillon. Veuillez réessayer.",
            manifestSummaryLabel: 'Récapitulatif du manifeste',
            coverLetterLabel: 'Lettre de présentation (PDF)',
            coverLetterDownloadCta: 'Télécharger le PDF',
            editHistoryHeading: "Historique d'édition",
            editHistoryEmpty: 'Aucune modification pour le moment.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'NQ22 avis de canal non officiel',
            uploadSentProofCta: "Téléverser une preuve d'envoi manuel",
            versionLabel: 'Version',
            statusDraft: 'Brouillon',
            statusEdited: 'Modifié',
            statusFinalized: 'Finalisé',
        },
        sentProof: {
            modalTitle: "Téléverser une preuve d'envoi manuel",
            architectureLockNote: "AesirX n'est pas l'expéditeur. Cette preuve capture l'envoi manuel que vous avez effectué via votre propre client de messagerie.",
            fileLabel: 'Fichier de preuve (.eml, .png, .jpg)',
            envelopeFromLabel: 'De',
            envelopeToLabel: 'À',
            envelopeSubjectLabel: "Sujet (à l'envoi)",
            envelopeSentAtLabel: 'Envoyé à',
            envelopeAttachmentShaLabel: "SHA-256 de la pièce jointe (à l'envoi)",
            uploadCta: 'Téléverser la preuve',
            uploading: 'Téléversement…',
            uploadSuccess: "Preuve d'envoi téléversée.",
            uploadErrorInvalidMime: 'Type de fichier non autorisé. Utilisez .eml, .png, .jpg ou .jpeg.',
            uploadErrorGeneric: 'Impossible de téléverser la preuve. Veuillez réessayer.',
            existingProofsHeading: "Preuves d'envoi enregistrées",
            existingProofsEmpty: "Aucune preuve d'envoi enregistrée pour le moment.",
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Dossier de preuves',
            notFoundMessage: 'Dossier de preuves introuvable : il a peut-être été supprimé ou le lien est incorrect.',
            manifestHeading: 'Manifeste',
            dossierLabel: 'Dossier',
            packShaLabel: 'SHA-256 du paquet',
            fileCountLabel: 'Fichiers',
            bytesLabel: 'Taille',
            composeDraftCta: 'Rédiger le brouillon',
            sendComingSoonCta: 'Envoi direct : bientôt disponible',
            sendComingSoonHint: "L'envoi direct est en cours de développement. Utilisez « Téléverser une preuve d'envoi manuel » sur la page du brouillon en attendant.",
            sendCta: 'Envoyer via le fournisseur configuré',
            sendDisabledNoProviderHint: "Configurez d'abord un fournisseur de messagerie maîtrisé par le client. AesirX n'envoie jamais en votre nom.",
            timelineHeading: 'Historique des envois',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Envoyer le dossier de preuves',
            providerPickerLabel: 'Fournisseur de messagerie configuré',
            providerPickerHint: "AesirX n'envoie jamais en votre nom. Sélectionnez ci-dessous l'un de vos fournisseurs configurés.",
            providerPickerEmpty: "Aucun fournisseur actif n'est configuré. Configurez-en un sur la page Fournisseurs de messagerie avant l'envoi.",
            providerPickerEmptyCta: 'Ouvrir les fournisseurs de messagerie',
            draftPickerLabel: 'Brouillon de courriel',
            draftPickerOption: '{locale} · v{version}',
            draftPickerEmpty: "Aucun brouillon n'a encore été rédigé pour ce dossier. Rédigez-en un sur la page du brouillon au préalable.",
            recipientToLabel: 'Destinataire',
            recipientToHint: 'Une ou plusieurs adresses e-mail, séparées par des virgules.',
            recipientCcLabel: 'Cc (séparés par des virgules)',
            recipientCcHint: 'Facultatif. Liste d’adresses e-mail séparée par des virgules.',
            recipientBccLabel: 'Cci (séparés par des virgules)',
            recipientBccHint: 'Facultatif. Liste d’adresses e-mail séparée par des virgules.',
            consentReaffirmHeading: 'Réaffirmer le consentement du fournisseur',
            submitCta: 'Envoyer maintenant',
            sending: 'Envoi en cours…',
            cancelCta: 'Annuler',
            sendSuccess: 'Envoi enregistré. Le dossier a été transmis via votre fournisseur configuré.',
            sendErrorGeneric: "Impossible d'envoyer le dossier. Veuillez consulter l'erreur ci-dessous et réessayer.",
            sendErrorAlreadyFinalized: 'Ce brouillon a déjà été utilisé pour un envoi réussi. Rédigez un nouveau brouillon avant de renvoyer.',
            sendErrorInvalidRecipients: 'Une ou plusieurs adresses destinataires ne sont pas des boîtes de messagerie valides.',
            // Timeline
            timelineEmpty: "Aucun envoi enregistré pour l'instant. Utilisez « Envoyer via le fournisseur configuré » ci-dessus pour transmettre via votre fournisseur SMTP / Microsoft 365 / Google Workspace maîtrisé par le client.",
            timelineProviderLabel: 'Envoyé via votre fournisseur configuré',
            timelineSentAtLabel: 'Envoyé',
            timelineRecipientLabel: 'Destinataire',
            timelineOutcomeSent: 'Envoyé',
            timelineOutcomeFailed: 'Échec',
            timelineViewDetailsCta: 'Voir les détails',
            // Authority-response chips
            authorityChipNone: 'En attente de réponse',
            authorityChipAcknowledgement: 'Accusé de réception',
            authorityChipAcceptance: 'Acceptation',
            authorityChipRejection: 'Rejet',
            authorityChipSupplementRequest: 'Demande de complément',
            authorityChipNoResponse: 'Aucune réponse',
            // Hard-copy chips
            hardCopyChipNone: 'Aucun suivi papier',
            hardCopyChipPending: 'Posté — livraison en attente',
            hardCopyChipDelivered: 'Livré',
            // Drawer
            drawerTitle: "Enregistrement d'envoi",
            drawerEnvelopeHeading: 'Enveloppe',
            drawerEnvelopeFromLabel: 'De',
            drawerEnvelopeToLabel: 'À',
            drawerEnvelopeCcLabel: 'Cc',
            drawerEnvelopeBccLabel: 'Cci',
            drawerEnvelopeSubjectLabel: 'Objet',
            drawerEnvelopeMessageIdLabel: 'Message-ID',
            drawerOutcomeHeading: 'Résultat',
            drawerSnapshotHeading: 'Instantané de la chaîne de conservation',
            drawerSnapshotPackShaLabel: "SHA-256 du paquet à l'envoi",
            drawerSnapshotDraftVersionLabel: "Version du brouillon à l'envoi",
            drawerSnapshotAttachmentLabel: 'ZIP transmis',
            drawerSnapshotAttachmentDownloadCta: 'Télécharger le ZIP',
            drawerAuthorityResponseHeading: "Réponse de l'autorité",
            drawerHardCopyHeading: 'Suivi papier',
            drawerSentByLabel: 'Envoyé par',
            drawerSendIdLabel: "Identifiant de l'enregistrement d'envoi",
            drawerSmtpResponseLabel: 'Réponse SMTP',
            drawerFailureReasonLabel: "Motif de l'échec",
            drawerLatencyLabel: 'Latence',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Accepté',
            drawerRejectedLabel: 'Rejeté',
            drawerCloseCta: 'Fermer',
            // Authority-response panel
            authorityRecordCta: 'Enregistrer la réponse',
            authorityReclassifyCta: 'Reclasser',
            authorityClassificationLabel: 'Classification',
            authorityReceivedAtLabel: 'Reçu le',
            authorityFreeTextLabel: 'Notes (facultatif)',
            authorityEvidenceLabel: 'Fichier de preuve (.eml / .pdf / .png / .jpg — facultatif)',
            authorityReasonLabel: 'Motif de la reclassification',
            authorityHistoryHeading: 'Historique des reclassifications',
            authorityHistoryEmpty: 'Aucune reclassification enregistrée.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Enregistrer la réponse',
            authoritySubmitting: 'Enregistrement…',
            authorityErrorInvalidMime: 'Type de fichier de preuve non autorisé. Utilisez .eml, .pdf, .png ou .jpg.',
            authorityErrorGeneric: "Impossible d'enregistrer la réponse. Veuillez réessayer.",
            authorityRecordedAtLabel: 'Enregistré le',
            authorityRecordedByLabel: 'Enregistré par',
            authorityEvidenceFilenameLabel: 'Preuve',
            authorityEvidenceDownloadCta: 'Télécharger la preuve',
            // Hard-copy panel
            hardCopyRecordCta: 'Consigner le suivi papier',
            hardCopyConfirmCta: 'Confirmer la livraison',
            hardCopyEditNotesCta: 'Modifier les notes de livraison',
            hardCopyPostedAtLabel: 'Posté le',
            hardCopyCourierLabel: 'Coursier',
            hardCopyTrackingLabel: 'Numéro de suivi',
            hardCopyRecipientLabel: "Destinataire sur l'étiquette",
            hardCopyReceiptLabel: 'Preuve de réception (.pdf / .png / .jpg — facultatif)',
            hardCopyReceiptDownloadCta: 'Télécharger le reçu',
            hardCopyDeliveredAtLabel: 'Livré le',
            hardCopyDeliveryNotesLabel: 'Notes de livraison (facultatif)',
            hardCopySubmitCta: 'Enregistrer le suivi',
            hardCopySubmitting: 'Enregistrement…',
            hardCopyErrorInvalidMime: 'Type de fichier de reçu non autorisé. Utilisez .pdf, .png ou .jpg.',
            hardCopyErrorGeneric: "Impossible d'enregistrer le suivi. Veuillez réessayer.",
        },
    },
};
//# sourceMappingURL=fr.js.map